(function(scope){
'use strict';

function F(arity, fun, wrapper) {
  wrapper.a = arity;
  wrapper.f = fun;
  return wrapper;
}

function F2(fun) {
  return F(2, fun, function(a) { return function(b) { return fun(a,b); }; })
}
function F3(fun) {
  return F(3, fun, function(a) {
    return function(b) { return function(c) { return fun(a, b, c); }; };
  });
}
function F4(fun) {
  return F(4, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return fun(a, b, c, d); }; }; };
  });
}
function F5(fun) {
  return F(5, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return fun(a, b, c, d, e); }; }; }; };
  });
}
function F6(fun) {
  return F(6, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return fun(a, b, c, d, e, f); }; }; }; }; };
  });
}
function F7(fun) {
  return F(7, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return fun(a, b, c, d, e, f, g); }; }; }; }; }; };
  });
}
function F8(fun) {
  return F(8, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) {
    return fun(a, b, c, d, e, f, g, h); }; }; }; }; }; }; };
  });
}
function F9(fun) {
  return F(9, fun, function(a) { return function(b) { return function(c) {
    return function(d) { return function(e) { return function(f) {
    return function(g) { return function(h) { return function(i) {
    return fun(a, b, c, d, e, f, g, h, i); }; }; }; }; }; }; }; };
  });
}

function A2(fun, a, b) {
  return fun.a === 2 ? fun.f(a, b) : fun(a)(b);
}
function A3(fun, a, b, c) {
  return fun.a === 3 ? fun.f(a, b, c) : fun(a)(b)(c);
}
function A4(fun, a, b, c, d) {
  return fun.a === 4 ? fun.f(a, b, c, d) : fun(a)(b)(c)(d);
}
function A5(fun, a, b, c, d, e) {
  return fun.a === 5 ? fun.f(a, b, c, d, e) : fun(a)(b)(c)(d)(e);
}
function A6(fun, a, b, c, d, e, f) {
  return fun.a === 6 ? fun.f(a, b, c, d, e, f) : fun(a)(b)(c)(d)(e)(f);
}
function A7(fun, a, b, c, d, e, f, g) {
  return fun.a === 7 ? fun.f(a, b, c, d, e, f, g) : fun(a)(b)(c)(d)(e)(f)(g);
}
function A8(fun, a, b, c, d, e, f, g, h) {
  return fun.a === 8 ? fun.f(a, b, c, d, e, f, g, h) : fun(a)(b)(c)(d)(e)(f)(g)(h);
}
function A9(fun, a, b, c, d, e, f, g, h, i) {
  return fun.a === 9 ? fun.f(a, b, c, d, e, f, g, h, i) : fun(a)(b)(c)(d)(e)(f)(g)(h)(i);
}




// EQUALITY

function _Utils_eq(x, y)
{
	for (
		var pair, stack = [], isEqual = _Utils_eqHelp(x, y, 0, stack);
		isEqual && (pair = stack.pop());
		isEqual = _Utils_eqHelp(pair.a, pair.b, 0, stack)
		)
	{}

	return isEqual;
}

function _Utils_eqHelp(x, y, depth, stack)
{
	if (x === y)
	{
		return true;
	}

	if (typeof x !== 'object' || x === null || y === null)
	{
		typeof x === 'function' && _Debug_crash(5);
		return false;
	}

	if (depth > 100)
	{
		stack.push(_Utils_Tuple2(x,y));
		return true;
	}

	/**_UNUSED/
	if (x.$ === 'Set_elm_builtin')
	{
		x = $elm$core$Set$toList(x);
		y = $elm$core$Set$toList(y);
	}
	if (x.$ === 'RBNode_elm_builtin' || x.$ === 'RBEmpty_elm_builtin')
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	/**/
	if (x.$ < 0)
	{
		x = $elm$core$Dict$toList(x);
		y = $elm$core$Dict$toList(y);
	}
	//*/

	for (var key in x)
	{
		if (!_Utils_eqHelp(x[key], y[key], depth + 1, stack))
		{
			return false;
		}
	}
	return true;
}

var _Utils_equal = F2(_Utils_eq);
var _Utils_notEqual = F2(function(a, b) { return !_Utils_eq(a,b); });



// COMPARISONS

// Code in Generate/JavaScript.hs, Basics.js, and List.js depends on
// the particular integer values assigned to LT, EQ, and GT.

function _Utils_cmp(x, y, ord)
{
	if (typeof x !== 'object')
	{
		return x === y ? /*EQ*/ 0 : x < y ? /*LT*/ -1 : /*GT*/ 1;
	}

	/**_UNUSED/
	if (x instanceof String)
	{
		var a = x.valueOf();
		var b = y.valueOf();
		return a === b ? 0 : a < b ? -1 : 1;
	}
	//*/

	/**/
	if (typeof x.$ === 'undefined')
	//*/
	/**_UNUSED/
	if (x.$[0] === '#')
	//*/
	{
		return (ord = _Utils_cmp(x.a, y.a))
			? ord
			: (ord = _Utils_cmp(x.b, y.b))
				? ord
				: _Utils_cmp(x.c, y.c);
	}

	// traverse conses until end of a list or a mismatch
	for (; x.b && y.b && !(ord = _Utils_cmp(x.a, y.a)); x = x.b, y = y.b) {} // WHILE_CONSES
	return ord || (x.b ? /*GT*/ 1 : y.b ? /*LT*/ -1 : /*EQ*/ 0);
}

var _Utils_lt = F2(function(a, b) { return _Utils_cmp(a, b) < 0; });
var _Utils_le = F2(function(a, b) { return _Utils_cmp(a, b) < 1; });
var _Utils_gt = F2(function(a, b) { return _Utils_cmp(a, b) > 0; });
var _Utils_ge = F2(function(a, b) { return _Utils_cmp(a, b) >= 0; });

var _Utils_compare = F2(function(x, y)
{
	var n = _Utils_cmp(x, y);
	return n < 0 ? $elm$core$Basics$LT : n ? $elm$core$Basics$GT : $elm$core$Basics$EQ;
});


// COMMON VALUES

var _Utils_Tuple0 = 0;
var _Utils_Tuple0_UNUSED = { $: '#0' };

function _Utils_Tuple2(a, b) { return { a: a, b: b }; }
function _Utils_Tuple2_UNUSED(a, b) { return { $: '#2', a: a, b: b }; }

function _Utils_Tuple3(a, b, c) { return { a: a, b: b, c: c }; }
function _Utils_Tuple3_UNUSED(a, b, c) { return { $: '#3', a: a, b: b, c: c }; }

function _Utils_chr(c) { return c; }
function _Utils_chr_UNUSED(c) { return new String(c); }


// RECORDS

function _Utils_update(oldRecord, updatedFields)
{
	var newRecord = {};

	for (var key in oldRecord)
	{
		newRecord[key] = oldRecord[key];
	}

	for (var key in updatedFields)
	{
		newRecord[key] = updatedFields[key];
	}

	return newRecord;
}


// APPEND

var _Utils_append = F2(_Utils_ap);

function _Utils_ap(xs, ys)
{
	// append Strings
	if (typeof xs === 'string')
	{
		return xs + ys;
	}

	// append Lists
	if (!xs.b)
	{
		return ys;
	}
	var root = _List_Cons(xs.a, ys);
	xs = xs.b
	for (var curr = root; xs.b; xs = xs.b) // WHILE_CONS
	{
		curr = curr.b = _List_Cons(xs.a, ys);
	}
	return root;
}



var _List_Nil = { $: 0 };
var _List_Nil_UNUSED = { $: '[]' };

function _List_Cons(hd, tl) { return { $: 1, a: hd, b: tl }; }
function _List_Cons_UNUSED(hd, tl) { return { $: '::', a: hd, b: tl }; }


var _List_cons = F2(_List_Cons);

function _List_fromArray(arr)
{
	var out = _List_Nil;
	for (var i = arr.length; i--; )
	{
		out = _List_Cons(arr[i], out);
	}
	return out;
}

function _List_toArray(xs)
{
	for (var out = []; xs.b; xs = xs.b) // WHILE_CONS
	{
		out.push(xs.a);
	}
	return out;
}

var _List_map2 = F3(function(f, xs, ys)
{
	for (var arr = []; xs.b && ys.b; xs = xs.b, ys = ys.b) // WHILE_CONSES
	{
		arr.push(A2(f, xs.a, ys.a));
	}
	return _List_fromArray(arr);
});

var _List_map3 = F4(function(f, xs, ys, zs)
{
	for (var arr = []; xs.b && ys.b && zs.b; xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A3(f, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map4 = F5(function(f, ws, xs, ys, zs)
{
	for (var arr = []; ws.b && xs.b && ys.b && zs.b; ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A4(f, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_map5 = F6(function(f, vs, ws, xs, ys, zs)
{
	for (var arr = []; vs.b && ws.b && xs.b && ys.b && zs.b; vs = vs.b, ws = ws.b, xs = xs.b, ys = ys.b, zs = zs.b) // WHILE_CONSES
	{
		arr.push(A5(f, vs.a, ws.a, xs.a, ys.a, zs.a));
	}
	return _List_fromArray(arr);
});

var _List_sortBy = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		return _Utils_cmp(f(a), f(b));
	}));
});

var _List_sortWith = F2(function(f, xs)
{
	return _List_fromArray(_List_toArray(xs).sort(function(a, b) {
		var ord = A2(f, a, b);
		return ord === $elm$core$Basics$EQ ? 0 : ord === $elm$core$Basics$LT ? -1 : 1;
	}));
});



var _JsArray_empty = [];

function _JsArray_singleton(value)
{
    return [value];
}

function _JsArray_length(array)
{
    return array.length;
}

var _JsArray_initialize = F3(function(size, offset, func)
{
    var result = new Array(size);

    for (var i = 0; i < size; i++)
    {
        result[i] = func(offset + i);
    }

    return result;
});

var _JsArray_initializeFromList = F2(function (max, ls)
{
    var result = new Array(max);

    for (var i = 0; i < max && ls.b; i++)
    {
        result[i] = ls.a;
        ls = ls.b;
    }

    result.length = i;
    return _Utils_Tuple2(result, ls);
});

var _JsArray_unsafeGet = F2(function(index, array)
{
    return array[index];
});

var _JsArray_unsafeSet = F3(function(index, value, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[index] = value;
    return result;
});

var _JsArray_push = F2(function(value, array)
{
    var length = array.length;
    var result = new Array(length + 1);

    for (var i = 0; i < length; i++)
    {
        result[i] = array[i];
    }

    result[length] = value;
    return result;
});

var _JsArray_foldl = F3(function(func, acc, array)
{
    var length = array.length;

    for (var i = 0; i < length; i++)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_foldr = F3(function(func, acc, array)
{
    for (var i = array.length - 1; i >= 0; i--)
    {
        acc = A2(func, array[i], acc);
    }

    return acc;
});

var _JsArray_map = F2(function(func, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = func(array[i]);
    }

    return result;
});

var _JsArray_indexedMap = F3(function(func, offset, array)
{
    var length = array.length;
    var result = new Array(length);

    for (var i = 0; i < length; i++)
    {
        result[i] = A2(func, offset + i, array[i]);
    }

    return result;
});

var _JsArray_slice = F3(function(from, to, array)
{
    return array.slice(from, to);
});

var _JsArray_appendN = F3(function(n, dest, source)
{
    var destLen = dest.length;
    var itemsToCopy = n - destLen;

    if (itemsToCopy > source.length)
    {
        itemsToCopy = source.length;
    }

    var size = destLen + itemsToCopy;
    var result = new Array(size);

    for (var i = 0; i < destLen; i++)
    {
        result[i] = dest[i];
    }

    for (var i = 0; i < itemsToCopy; i++)
    {
        result[i + destLen] = source[i];
    }

    return result;
});



// LOG

var _Debug_log = F2(function(tag, value)
{
	return value;
});

var _Debug_log_UNUSED = F2(function(tag, value)
{
	console.log(tag + ': ' + _Debug_toString(value));
	return value;
});


// TODOS

function _Debug_todo(moduleName, region)
{
	return function(message) {
		_Debug_crash(8, moduleName, region, message);
	};
}

function _Debug_todoCase(moduleName, region, value)
{
	return function(message) {
		_Debug_crash(9, moduleName, region, value, message);
	};
}


// TO STRING

function _Debug_toString(value)
{
	return '<internals>';
}

function _Debug_toString_UNUSED(value)
{
	return _Debug_toAnsiString(false, value);
}

function _Debug_toAnsiString(ansi, value)
{
	if (typeof value === 'function')
	{
		return _Debug_internalColor(ansi, '<function>');
	}

	if (typeof value === 'boolean')
	{
		return _Debug_ctorColor(ansi, value ? 'True' : 'False');
	}

	if (typeof value === 'number')
	{
		return _Debug_numberColor(ansi, value + '');
	}

	if (value instanceof String)
	{
		return _Debug_charColor(ansi, "'" + _Debug_addSlashes(value, true) + "'");
	}

	if (typeof value === 'string')
	{
		return _Debug_stringColor(ansi, '"' + _Debug_addSlashes(value, false) + '"');
	}

	if (typeof value === 'object' && '$' in value)
	{
		var tag = value.$;

		if (typeof tag === 'number')
		{
			return _Debug_internalColor(ansi, '<internals>');
		}

		if (tag[0] === '#')
		{
			var output = [];
			for (var k in value)
			{
				if (k === '$') continue;
				output.push(_Debug_toAnsiString(ansi, value[k]));
			}
			return '(' + output.join(',') + ')';
		}

		if (tag === 'Set_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Set')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Set$toList(value));
		}

		if (tag === 'RBNode_elm_builtin' || tag === 'RBEmpty_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Dict')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Dict$toList(value));
		}

		if (tag === 'Array_elm_builtin')
		{
			return _Debug_ctorColor(ansi, 'Array')
				+ _Debug_fadeColor(ansi, '.fromList') + ' '
				+ _Debug_toAnsiString(ansi, $elm$core$Array$toList(value));
		}

		if (tag === '::' || tag === '[]')
		{
			var output = '[';

			value.b && (output += _Debug_toAnsiString(ansi, value.a), value = value.b)

			for (; value.b; value = value.b) // WHILE_CONS
			{
				output += ',' + _Debug_toAnsiString(ansi, value.a);
			}
			return output + ']';
		}

		var output = '';
		for (var i in value)
		{
			if (i === '$') continue;
			var str = _Debug_toAnsiString(ansi, value[i]);
			var c0 = str[0];
			var parenless = c0 === '{' || c0 === '(' || c0 === '[' || c0 === '<' || c0 === '"' || str.indexOf(' ') < 0;
			output += ' ' + (parenless ? str : '(' + str + ')');
		}
		return _Debug_ctorColor(ansi, tag) + output;
	}

	if (typeof DataView === 'function' && value instanceof DataView)
	{
		return _Debug_stringColor(ansi, '<' + value.byteLength + ' bytes>');
	}

	if (typeof File !== 'undefined' && value instanceof File)
	{
		return _Debug_internalColor(ansi, '<' + value.name + '>');
	}

	if (typeof value === 'object')
	{
		var output = [];
		for (var key in value)
		{
			var field = key[0] === '_' ? key.slice(1) : key;
			output.push(_Debug_fadeColor(ansi, field) + ' = ' + _Debug_toAnsiString(ansi, value[key]));
		}
		if (output.length === 0)
		{
			return '{}';
		}
		return '{ ' + output.join(', ') + ' }';
	}

	return _Debug_internalColor(ansi, '<internals>');
}

function _Debug_addSlashes(str, isChar)
{
	var s = str
		.replace(/\\/g, '\\\\')
		.replace(/\n/g, '\\n')
		.replace(/\t/g, '\\t')
		.replace(/\r/g, '\\r')
		.replace(/\v/g, '\\v')
		.replace(/\0/g, '\\0');

	if (isChar)
	{
		return s.replace(/\'/g, '\\\'');
	}
	else
	{
		return s.replace(/\"/g, '\\"');
	}
}

function _Debug_ctorColor(ansi, string)
{
	return ansi ? '\x1b[96m' + string + '\x1b[0m' : string;
}

function _Debug_numberColor(ansi, string)
{
	return ansi ? '\x1b[95m' + string + '\x1b[0m' : string;
}

function _Debug_stringColor(ansi, string)
{
	return ansi ? '\x1b[93m' + string + '\x1b[0m' : string;
}

function _Debug_charColor(ansi, string)
{
	return ansi ? '\x1b[92m' + string + '\x1b[0m' : string;
}

function _Debug_fadeColor(ansi, string)
{
	return ansi ? '\x1b[37m' + string + '\x1b[0m' : string;
}

function _Debug_internalColor(ansi, string)
{
	return ansi ? '\x1b[36m' + string + '\x1b[0m' : string;
}

function _Debug_toHexDigit(n)
{
	return String.fromCharCode(n < 10 ? 48 + n : 55 + n);
}


// CRASH


function _Debug_crash(identifier)
{
	throw new Error('https://github.com/elm/core/blob/1.0.0/hints/' + identifier + '.md');
}


function _Debug_crash_UNUSED(identifier, fact1, fact2, fact3, fact4)
{
	switch(identifier)
	{
		case 0:
			throw new Error('What node should I take over? In JavaScript I need something like:\n\n    Elm.Main.init({\n        node: document.getElementById("elm-node")\n    })\n\nYou need to do this with any Browser.sandbox or Browser.element program.');

		case 1:
			throw new Error('Browser.application programs cannot handle URLs like this:\n\n    ' + document.location.href + '\n\nWhat is the root? The root of your file system? Try looking at this program with `elm reactor` or some other server.');

		case 2:
			var jsonErrorString = fact1;
			throw new Error('Problem with the flags given to your Elm program on initialization.\n\n' + jsonErrorString);

		case 3:
			var portName = fact1;
			throw new Error('There can only be one port named `' + portName + '`, but your program has multiple.');

		case 4:
			var portName = fact1;
			var problem = fact2;
			throw new Error('Trying to send an unexpected type of value through port `' + portName + '`:\n' + problem);

		case 5:
			throw new Error('Trying to use `(==)` on functions.\nThere is no way to know if functions are "the same" in the Elm sense.\nRead more about this at https://package.elm-lang.org/packages/elm/core/latest/Basics#== which describes why it is this way and what the better version will look like.');

		case 6:
			var moduleName = fact1;
			throw new Error('Your page is loading multiple Elm scripts with a module named ' + moduleName + '. Maybe a duplicate script is getting loaded accidentally? If not, rename one of them so I know which is which!');

		case 8:
			var moduleName = fact1;
			var region = fact2;
			var message = fact3;
			throw new Error('TODO in module `' + moduleName + '` ' + _Debug_regionToString(region) + '\n\n' + message);

		case 9:
			var moduleName = fact1;
			var region = fact2;
			var value = fact3;
			var message = fact4;
			throw new Error(
				'TODO in module `' + moduleName + '` from the `case` expression '
				+ _Debug_regionToString(region) + '\n\nIt received the following value:\n\n    '
				+ _Debug_toString(value).replace('\n', '\n    ')
				+ '\n\nBut the branch that handles it says:\n\n    ' + message.replace('\n', '\n    ')
			);

		case 10:
			throw new Error('Bug in https://github.com/elm/virtual-dom/issues');

		case 11:
			throw new Error('Cannot perform mod 0. Division by zero error.');
	}
}

function _Debug_regionToString(region)
{
	if (region.l.a7 === region.j.a7)
	{
		return 'on line ' + region.l.a7;
	}
	return 'on lines ' + region.l.a7 + ' through ' + region.j.a7;
}



// MATH

var _Basics_add = F2(function(a, b) { return a + b; });
var _Basics_sub = F2(function(a, b) { return a - b; });
var _Basics_mul = F2(function(a, b) { return a * b; });
var _Basics_fdiv = F2(function(a, b) { return a / b; });
var _Basics_idiv = F2(function(a, b) { return (a / b) | 0; });
var _Basics_pow = F2(Math.pow);

var _Basics_remainderBy = F2(function(b, a) { return a % b; });

// https://www.microsoft.com/en-us/research/wp-content/uploads/2016/02/divmodnote-letter.pdf
var _Basics_modBy = F2(function(modulus, x)
{
	var answer = x % modulus;
	return modulus === 0
		? _Debug_crash(11)
		:
	((answer > 0 && modulus < 0) || (answer < 0 && modulus > 0))
		? answer + modulus
		: answer;
});


// TRIGONOMETRY

var _Basics_pi = Math.PI;
var _Basics_e = Math.E;
var _Basics_cos = Math.cos;
var _Basics_sin = Math.sin;
var _Basics_tan = Math.tan;
var _Basics_acos = Math.acos;
var _Basics_asin = Math.asin;
var _Basics_atan = Math.atan;
var _Basics_atan2 = F2(Math.atan2);


// MORE MATH

function _Basics_toFloat(x) { return x; }
function _Basics_truncate(n) { return n | 0; }
function _Basics_isInfinite(n) { return n === Infinity || n === -Infinity; }

var _Basics_ceiling = Math.ceil;
var _Basics_floor = Math.floor;
var _Basics_round = Math.round;
var _Basics_sqrt = Math.sqrt;
var _Basics_log = Math.log;
var _Basics_isNaN = isNaN;


// BOOLEANS

function _Basics_not(bool) { return !bool; }
var _Basics_and = F2(function(a, b) { return a && b; });
var _Basics_or  = F2(function(a, b) { return a || b; });
var _Basics_xor = F2(function(a, b) { return a !== b; });



var _String_cons = F2(function(chr, str)
{
	return chr + str;
});

function _String_uncons(string)
{
	var word = string.charCodeAt(0);
	return !isNaN(word)
		? $elm$core$Maybe$Just(
			0xD800 <= word && word <= 0xDBFF
				? _Utils_Tuple2(_Utils_chr(string[0] + string[1]), string.slice(2))
				: _Utils_Tuple2(_Utils_chr(string[0]), string.slice(1))
		)
		: $elm$core$Maybe$Nothing;
}

var _String_append = F2(function(a, b)
{
	return a + b;
});

function _String_length(str)
{
	return str.length;
}

var _String_map = F2(function(func, string)
{
	var len = string.length;
	var array = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = string.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			array[i] = func(_Utils_chr(string[i] + string[i+1]));
			i += 2;
			continue;
		}
		array[i] = func(_Utils_chr(string[i]));
		i++;
	}
	return array.join('');
});

var _String_filter = F2(function(isGood, str)
{
	var arr = [];
	var len = str.length;
	var i = 0;
	while (i < len)
	{
		var char = str[i];
		var word = str.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += str[i];
			i++;
		}

		if (isGood(_Utils_chr(char)))
		{
			arr.push(char);
		}
	}
	return arr.join('');
});

function _String_reverse(str)
{
	var len = str.length;
	var arr = new Array(len);
	var i = 0;
	while (i < len)
	{
		var word = str.charCodeAt(i);
		if (0xD800 <= word && word <= 0xDBFF)
		{
			arr[len - i] = str[i + 1];
			i++;
			arr[len - i] = str[i - 1];
			i++;
		}
		else
		{
			arr[len - i] = str[i];
			i++;
		}
	}
	return arr.join('');
}

var _String_foldl = F3(function(func, state, string)
{
	var len = string.length;
	var i = 0;
	while (i < len)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		i++;
		if (0xD800 <= word && word <= 0xDBFF)
		{
			char += string[i];
			i++;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_foldr = F3(function(func, state, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		state = A2(func, _Utils_chr(char), state);
	}
	return state;
});

var _String_split = F2(function(sep, str)
{
	return str.split(sep);
});

var _String_join = F2(function(sep, strs)
{
	return strs.join(sep);
});

var _String_slice = F3(function(start, end, str) {
	return str.slice(start, end);
});

function _String_trim(str)
{
	return str.trim();
}

function _String_trimLeft(str)
{
	return str.replace(/^\s+/, '');
}

function _String_trimRight(str)
{
	return str.replace(/\s+$/, '');
}

function _String_words(str)
{
	return _List_fromArray(str.trim().split(/\s+/g));
}

function _String_lines(str)
{
	return _List_fromArray(str.split(/\r\n|\r|\n/g));
}

function _String_toUpper(str)
{
	return str.toUpperCase();
}

function _String_toLower(str)
{
	return str.toLowerCase();
}

var _String_any = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (isGood(_Utils_chr(char)))
		{
			return true;
		}
	}
	return false;
});

var _String_all = F2(function(isGood, string)
{
	var i = string.length;
	while (i--)
	{
		var char = string[i];
		var word = string.charCodeAt(i);
		if (0xDC00 <= word && word <= 0xDFFF)
		{
			i--;
			char = string[i] + char;
		}
		if (!isGood(_Utils_chr(char)))
		{
			return false;
		}
	}
	return true;
});

var _String_contains = F2(function(sub, str)
{
	return str.indexOf(sub) > -1;
});

var _String_startsWith = F2(function(sub, str)
{
	return str.indexOf(sub) === 0;
});

var _String_endsWith = F2(function(sub, str)
{
	return str.length >= sub.length &&
		str.lastIndexOf(sub) === str.length - sub.length;
});

var _String_indexes = F2(function(sub, str)
{
	var subLen = sub.length;

	if (subLen < 1)
	{
		return _List_Nil;
	}

	var i = 0;
	var is = [];

	while ((i = str.indexOf(sub, i)) > -1)
	{
		is.push(i);
		i = i + subLen;
	}

	return _List_fromArray(is);
});


// TO STRING

function _String_fromNumber(number)
{
	return number + '';
}


// INT CONVERSIONS

function _String_toInt(str)
{
	var total = 0;
	var code0 = str.charCodeAt(0);
	var start = code0 == 0x2B /* + */ || code0 == 0x2D /* - */ ? 1 : 0;

	for (var i = start; i < str.length; ++i)
	{
		var code = str.charCodeAt(i);
		if (code < 0x30 || 0x39 < code)
		{
			return $elm$core$Maybe$Nothing;
		}
		total = 10 * total + code - 0x30;
	}

	return i == start
		? $elm$core$Maybe$Nothing
		: $elm$core$Maybe$Just(code0 == 0x2D ? -total : total);
}


// FLOAT CONVERSIONS

function _String_toFloat(s)
{
	// check if it is a hex, octal, or binary number
	if (s.length === 0 || /[\sxbo]/.test(s))
	{
		return $elm$core$Maybe$Nothing;
	}
	var n = +s;
	// faster isNaN check
	return n === n ? $elm$core$Maybe$Just(n) : $elm$core$Maybe$Nothing;
}

function _String_fromList(chars)
{
	return _List_toArray(chars).join('');
}




function _Char_toCode(char)
{
	var code = char.charCodeAt(0);
	if (0xD800 <= code && code <= 0xDBFF)
	{
		return (code - 0xD800) * 0x400 + char.charCodeAt(1) - 0xDC00 + 0x10000
	}
	return code;
}

function _Char_fromCode(code)
{
	return _Utils_chr(
		(code < 0 || 0x10FFFF < code)
			? '\uFFFD'
			:
		(code <= 0xFFFF)
			? String.fromCharCode(code)
			:
		(code -= 0x10000,
			String.fromCharCode(Math.floor(code / 0x400) + 0xD800, code % 0x400 + 0xDC00)
		)
	);
}

function _Char_toUpper(char)
{
	return _Utils_chr(char.toUpperCase());
}

function _Char_toLower(char)
{
	return _Utils_chr(char.toLowerCase());
}

function _Char_toLocaleUpper(char)
{
	return _Utils_chr(char.toLocaleUpperCase());
}

function _Char_toLocaleLower(char)
{
	return _Utils_chr(char.toLocaleLowerCase());
}



/**_UNUSED/
function _Json_errorToString(error)
{
	return $elm$json$Json$Decode$errorToString(error);
}
//*/


// CORE DECODERS

function _Json_succeed(msg)
{
	return {
		$: 0,
		a: msg
	};
}

function _Json_fail(msg)
{
	return {
		$: 1,
		a: msg
	};
}

function _Json_decodePrim(decoder)
{
	return { $: 2, b: decoder };
}

var _Json_decodeInt = _Json_decodePrim(function(value) {
	return (typeof value !== 'number')
		? _Json_expecting('an INT', value)
		:
	(-2147483647 < value && value < 2147483647 && (value | 0) === value)
		? $elm$core$Result$Ok(value)
		:
	(isFinite(value) && !(value % 1))
		? $elm$core$Result$Ok(value)
		: _Json_expecting('an INT', value);
});

var _Json_decodeBool = _Json_decodePrim(function(value) {
	return (typeof value === 'boolean')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a BOOL', value);
});

var _Json_decodeFloat = _Json_decodePrim(function(value) {
	return (typeof value === 'number')
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FLOAT', value);
});

var _Json_decodeValue = _Json_decodePrim(function(value) {
	return $elm$core$Result$Ok(_Json_wrap(value));
});

var _Json_decodeString = _Json_decodePrim(function(value) {
	return (typeof value === 'string')
		? $elm$core$Result$Ok(value)
		: (value instanceof String)
			? $elm$core$Result$Ok(value + '')
			: _Json_expecting('a STRING', value);
});

function _Json_decodeList(decoder) { return { $: 3, b: decoder }; }
function _Json_decodeArray(decoder) { return { $: 4, b: decoder }; }

function _Json_decodeNull(value) { return { $: 5, c: value }; }

var _Json_decodeField = F2(function(field, decoder)
{
	return {
		$: 6,
		d: field,
		b: decoder
	};
});

var _Json_decodeIndex = F2(function(index, decoder)
{
	return {
		$: 7,
		e: index,
		b: decoder
	};
});

function _Json_decodeKeyValuePairs(decoder)
{
	return {
		$: 8,
		b: decoder
	};
}

function _Json_mapMany(f, decoders)
{
	return {
		$: 9,
		f: f,
		g: decoders
	};
}

var _Json_andThen = F2(function(callback, decoder)
{
	return {
		$: 10,
		b: decoder,
		h: callback
	};
});

function _Json_oneOf(decoders)
{
	return {
		$: 11,
		g: decoders
	};
}


// DECODING OBJECTS

var _Json_map1 = F2(function(f, d1)
{
	return _Json_mapMany(f, [d1]);
});

var _Json_map2 = F3(function(f, d1, d2)
{
	return _Json_mapMany(f, [d1, d2]);
});

var _Json_map3 = F4(function(f, d1, d2, d3)
{
	return _Json_mapMany(f, [d1, d2, d3]);
});

var _Json_map4 = F5(function(f, d1, d2, d3, d4)
{
	return _Json_mapMany(f, [d1, d2, d3, d4]);
});

var _Json_map5 = F6(function(f, d1, d2, d3, d4, d5)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5]);
});

var _Json_map6 = F7(function(f, d1, d2, d3, d4, d5, d6)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6]);
});

var _Json_map7 = F8(function(f, d1, d2, d3, d4, d5, d6, d7)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7]);
});

var _Json_map8 = F9(function(f, d1, d2, d3, d4, d5, d6, d7, d8)
{
	return _Json_mapMany(f, [d1, d2, d3, d4, d5, d6, d7, d8]);
});


// DECODE

var _Json_runOnString = F2(function(decoder, string)
{
	try
	{
		var value = JSON.parse(string);
		return _Json_runHelp(decoder, value);
	}
	catch (e)
	{
		return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'This is not valid JSON! ' + e.message, _Json_wrap(string)));
	}
});

var _Json_run = F2(function(decoder, value)
{
	return _Json_runHelp(decoder, _Json_unwrap(value));
});

function _Json_runHelp(decoder, value)
{
	switch (decoder.$)
	{
		case 2:
			return decoder.b(value);

		case 5:
			return (value === null)
				? $elm$core$Result$Ok(decoder.c)
				: _Json_expecting('null', value);

		case 3:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('a LIST', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _List_fromArray);

		case 4:
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			return _Json_runArrayDecoder(decoder.b, value, _Json_toElmArray);

		case 6:
			var field = decoder.d;
			if (typeof value !== 'object' || value === null || !(field in value))
			{
				return _Json_expecting('an OBJECT with a field named `' + field + '`', value);
			}
			var result = _Json_runHelp(decoder.b, value[field]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, field, result.a));

		case 7:
			var index = decoder.e;
			if (!_Json_isArray(value))
			{
				return _Json_expecting('an ARRAY', value);
			}
			if (index >= value.length)
			{
				return _Json_expecting('a LONGER array. Need index ' + index + ' but only see ' + value.length + ' entries', value);
			}
			var result = _Json_runHelp(decoder.b, value[index]);
			return ($elm$core$Result$isOk(result)) ? result : $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, index, result.a));

		case 8:
			if (typeof value !== 'object' || value === null || _Json_isArray(value))
			{
				return _Json_expecting('an OBJECT', value);
			}

			var keyValuePairs = _List_Nil;
			// TODO test perf of Object.keys and switch when support is good enough
			for (var key in value)
			{
				if (value.hasOwnProperty(key))
				{
					var result = _Json_runHelp(decoder.b, value[key]);
					if (!$elm$core$Result$isOk(result))
					{
						return $elm$core$Result$Err(A2($elm$json$Json$Decode$Field, key, result.a));
					}
					keyValuePairs = _List_Cons(_Utils_Tuple2(key, result.a), keyValuePairs);
				}
			}
			return $elm$core$Result$Ok($elm$core$List$reverse(keyValuePairs));

		case 9:
			var answer = decoder.f;
			var decoders = decoder.g;
			for (var i = 0; i < decoders.length; i++)
			{
				var result = _Json_runHelp(decoders[i], value);
				if (!$elm$core$Result$isOk(result))
				{
					return result;
				}
				answer = answer(result.a);
			}
			return $elm$core$Result$Ok(answer);

		case 10:
			var result = _Json_runHelp(decoder.b, value);
			return (!$elm$core$Result$isOk(result))
				? result
				: _Json_runHelp(decoder.h(result.a), value);

		case 11:
			var errors = _List_Nil;
			for (var temp = decoder.g; temp.b; temp = temp.b) // WHILE_CONS
			{
				var result = _Json_runHelp(temp.a, value);
				if ($elm$core$Result$isOk(result))
				{
					return result;
				}
				errors = _List_Cons(result.a, errors);
			}
			return $elm$core$Result$Err($elm$json$Json$Decode$OneOf($elm$core$List$reverse(errors)));

		case 1:
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, decoder.a, _Json_wrap(value)));

		case 0:
			return $elm$core$Result$Ok(decoder.a);
	}
}

function _Json_runArrayDecoder(decoder, value, toElmValue)
{
	var len = value.length;
	var array = new Array(len);
	for (var i = 0; i < len; i++)
	{
		var result = _Json_runHelp(decoder, value[i]);
		if (!$elm$core$Result$isOk(result))
		{
			return $elm$core$Result$Err(A2($elm$json$Json$Decode$Index, i, result.a));
		}
		array[i] = result.a;
	}
	return $elm$core$Result$Ok(toElmValue(array));
}

function _Json_isArray(value)
{
	return Array.isArray(value) || (typeof FileList !== 'undefined' && value instanceof FileList);
}

function _Json_toElmArray(array)
{
	return A2($elm$core$Array$initialize, array.length, function(i) { return array[i]; });
}

function _Json_expecting(type, value)
{
	return $elm$core$Result$Err(A2($elm$json$Json$Decode$Failure, 'Expecting ' + type, _Json_wrap(value)));
}


// EQUALITY

function _Json_equality(x, y)
{
	if (x === y)
	{
		return true;
	}

	if (x.$ !== y.$)
	{
		return false;
	}

	switch (x.$)
	{
		case 0:
		case 1:
			return x.a === y.a;

		case 2:
			return x.b === y.b;

		case 5:
			return x.c === y.c;

		case 3:
		case 4:
		case 8:
			return _Json_equality(x.b, y.b);

		case 6:
			return x.d === y.d && _Json_equality(x.b, y.b);

		case 7:
			return x.e === y.e && _Json_equality(x.b, y.b);

		case 9:
			return x.f === y.f && _Json_listEquality(x.g, y.g);

		case 10:
			return x.h === y.h && _Json_equality(x.b, y.b);

		case 11:
			return _Json_listEquality(x.g, y.g);
	}
}

function _Json_listEquality(aDecoders, bDecoders)
{
	var len = aDecoders.length;
	if (len !== bDecoders.length)
	{
		return false;
	}
	for (var i = 0; i < len; i++)
	{
		if (!_Json_equality(aDecoders[i], bDecoders[i]))
		{
			return false;
		}
	}
	return true;
}


// ENCODE

var _Json_encode = F2(function(indentLevel, value)
{
	return JSON.stringify(_Json_unwrap(value), null, indentLevel) + '';
});

function _Json_wrap_UNUSED(value) { return { $: 0, a: value }; }
function _Json_unwrap_UNUSED(value) { return value.a; }

function _Json_wrap(value) { return value; }
function _Json_unwrap(value) { return value; }

function _Json_emptyArray() { return []; }
function _Json_emptyObject() { return {}; }

var _Json_addField = F3(function(key, value, object)
{
	object[key] = _Json_unwrap(value);
	return object;
});

function _Json_addEntry(func)
{
	return F2(function(entry, array)
	{
		array.push(_Json_unwrap(func(entry)));
		return array;
	});
}

var _Json_encodeNull = _Json_wrap(null);



// TASKS

function _Scheduler_succeed(value)
{
	return {
		$: 0,
		a: value
	};
}

function _Scheduler_fail(error)
{
	return {
		$: 1,
		a: error
	};
}

function _Scheduler_binding(callback)
{
	return {
		$: 2,
		b: callback,
		c: null
	};
}

var _Scheduler_andThen = F2(function(callback, task)
{
	return {
		$: 3,
		b: callback,
		d: task
	};
});

var _Scheduler_onError = F2(function(callback, task)
{
	return {
		$: 4,
		b: callback,
		d: task
	};
});

function _Scheduler_receive(callback)
{
	return {
		$: 5,
		b: callback
	};
}


// PROCESSES

var _Scheduler_guid = 0;

function _Scheduler_rawSpawn(task)
{
	var proc = {
		$: 0,
		e: _Scheduler_guid++,
		f: task,
		g: null,
		h: []
	};

	_Scheduler_enqueue(proc);

	return proc;
}

function _Scheduler_spawn(task)
{
	return _Scheduler_binding(function(callback) {
		callback(_Scheduler_succeed(_Scheduler_rawSpawn(task)));
	});
}

function _Scheduler_rawSend(proc, msg)
{
	proc.h.push(msg);
	_Scheduler_enqueue(proc);
}

var _Scheduler_send = F2(function(proc, msg)
{
	return _Scheduler_binding(function(callback) {
		_Scheduler_rawSend(proc, msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});

function _Scheduler_kill(proc)
{
	return _Scheduler_binding(function(callback) {
		var task = proc.f;
		if (task.$ === 2 && task.c)
		{
			task.c();
		}

		proc.f = null;

		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
}


/* STEP PROCESSES

type alias Process =
  { $ : tag
  , id : unique_id
  , root : Task
  , stack : null | { $: SUCCEED | FAIL, a: callback, b: stack }
  , mailbox : [msg]
  }

*/


var _Scheduler_working = false;
var _Scheduler_queue = [];


function _Scheduler_enqueue(proc)
{
	_Scheduler_queue.push(proc);
	if (_Scheduler_working)
	{
		return;
	}
	_Scheduler_working = true;
	while (proc = _Scheduler_queue.shift())
	{
		_Scheduler_step(proc);
	}
	_Scheduler_working = false;
}


function _Scheduler_step(proc)
{
	while (proc.f)
	{
		var rootTag = proc.f.$;
		if (rootTag === 0 || rootTag === 1)
		{
			while (proc.g && proc.g.$ !== rootTag)
			{
				proc.g = proc.g.i;
			}
			if (!proc.g)
			{
				return;
			}
			proc.f = proc.g.b(proc.f.a);
			proc.g = proc.g.i;
		}
		else if (rootTag === 2)
		{
			proc.f.c = proc.f.b(function(newRoot) {
				proc.f = newRoot;
				_Scheduler_enqueue(proc);
			});
			return;
		}
		else if (rootTag === 5)
		{
			if (proc.h.length === 0)
			{
				return;
			}
			proc.f = proc.f.b(proc.h.shift());
		}
		else // if (rootTag === 3 || rootTag === 4)
		{
			proc.g = {
				$: rootTag === 3 ? 0 : 1,
				b: proc.f.b,
				i: proc.g
			};
			proc.f = proc.f.d;
		}
	}
}



function _Process_sleep(time)
{
	return _Scheduler_binding(function(callback) {
		var id = setTimeout(function() {
			callback(_Scheduler_succeed(_Utils_Tuple0));
		}, time);

		return function() { clearTimeout(id); };
	});
}




// PROGRAMS


var _Platform_worker = F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.fG,
		impl.ha,
		impl.gY,
		function() { return function() {} }
	);
});



// INITIALIZE A PROGRAM


function _Platform_initialize(flagDecoder, args, init, update, subscriptions, stepperBuilder)
{
	var result = A2(_Json_run, flagDecoder, _Json_wrap(args ? args['flags'] : undefined));
	$elm$core$Result$isOk(result) || _Debug_crash(2 /**_UNUSED/, _Json_errorToString(result.a) /**/);
	var managers = {};
	var initPair = init(result.a);
	var model = initPair.a;
	var stepper = stepperBuilder(sendToApp, model);
	var ports = _Platform_setupEffects(managers, sendToApp);

	function sendToApp(msg, viewMetadata)
	{
		var pair = A2(update, msg, model);
		stepper(model = pair.a, viewMetadata);
		_Platform_enqueueEffects(managers, pair.b, subscriptions(model));
	}

	_Platform_enqueueEffects(managers, initPair.b, subscriptions(model));

	return ports ? { ports: ports } : {};
}



// TRACK PRELOADS
//
// This is used by code in elm/browser and elm/http
// to register any HTTP requests that are triggered by init.
//


var _Platform_preload;


function _Platform_registerPreload(url)
{
	_Platform_preload.add(url);
}



// EFFECT MANAGERS


var _Platform_effectManagers = {};


function _Platform_setupEffects(managers, sendToApp)
{
	var ports;

	// setup all necessary effect managers
	for (var key in _Platform_effectManagers)
	{
		var manager = _Platform_effectManagers[key];

		if (manager.a)
		{
			ports = ports || {};
			ports[key] = manager.a(key, sendToApp);
		}

		managers[key] = _Platform_instantiateManager(manager, sendToApp);
	}

	return ports;
}


function _Platform_createManager(init, onEffects, onSelfMsg, cmdMap, subMap)
{
	return {
		b: init,
		c: onEffects,
		d: onSelfMsg,
		e: cmdMap,
		f: subMap
	};
}


function _Platform_instantiateManager(info, sendToApp)
{
	var router = {
		g: sendToApp,
		h: undefined
	};

	var onEffects = info.c;
	var onSelfMsg = info.d;
	var cmdMap = info.e;
	var subMap = info.f;

	function loop(state)
	{
		return A2(_Scheduler_andThen, loop, _Scheduler_receive(function(msg)
		{
			var value = msg.a;

			if (msg.$ === 0)
			{
				return A3(onSelfMsg, router, value, state);
			}

			return cmdMap && subMap
				? A4(onEffects, router, value.i, value.j, state)
				: A3(onEffects, router, cmdMap ? value.i : value.j, state);
		}));
	}

	return router.h = _Scheduler_rawSpawn(A2(_Scheduler_andThen, loop, info.b));
}



// ROUTING


var _Platform_sendToApp = F2(function(router, msg)
{
	return _Scheduler_binding(function(callback)
	{
		router.g(msg);
		callback(_Scheduler_succeed(_Utils_Tuple0));
	});
});


var _Platform_sendToSelf = F2(function(router, msg)
{
	return A2(_Scheduler_send, router.h, {
		$: 0,
		a: msg
	});
});



// BAGS


function _Platform_leaf(home)
{
	return function(value)
	{
		return {
			$: 1,
			k: home,
			l: value
		};
	};
}


function _Platform_batch(list)
{
	return {
		$: 2,
		m: list
	};
}


var _Platform_map = F2(function(tagger, bag)
{
	return {
		$: 3,
		n: tagger,
		o: bag
	}
});



// PIPE BAGS INTO EFFECT MANAGERS
//
// Effects must be queued!
//
// Say your init contains a synchronous command, like Time.now or Time.here
//
//   - This will produce a batch of effects (FX_1)
//   - The synchronous task triggers the subsequent `update` call
//   - This will produce a batch of effects (FX_2)
//
// If we just start dispatching FX_2, subscriptions from FX_2 can be processed
// before subscriptions from FX_1. No good! Earlier versions of this code had
// this problem, leading to these reports:
//
//   https://github.com/elm/core/issues/980
//   https://github.com/elm/core/pull/981
//   https://github.com/elm/compiler/issues/1776
//
// The queue is necessary to avoid ordering issues for synchronous commands.


// Why use true/false here? Why not just check the length of the queue?
// The goal is to detect "are we currently dispatching effects?" If we
// are, we need to bail and let the ongoing while loop handle things.
//
// Now say the queue has 1 element. When we dequeue the final element,
// the queue will be empty, but we are still actively dispatching effects.
// So you could get queue jumping in a really tricky category of cases.
//
var _Platform_effectsQueue = [];
var _Platform_effectsActive = false;


function _Platform_enqueueEffects(managers, cmdBag, subBag)
{
	_Platform_effectsQueue.push({ p: managers, q: cmdBag, r: subBag });

	if (_Platform_effectsActive) return;

	_Platform_effectsActive = true;
	for (var fx; fx = _Platform_effectsQueue.shift(); )
	{
		_Platform_dispatchEffects(fx.p, fx.q, fx.r);
	}
	_Platform_effectsActive = false;
}


function _Platform_dispatchEffects(managers, cmdBag, subBag)
{
	var effectsDict = {};
	_Platform_gatherEffects(true, cmdBag, effectsDict, null);
	_Platform_gatherEffects(false, subBag, effectsDict, null);

	for (var home in managers)
	{
		_Scheduler_rawSend(managers[home], {
			$: 'fx',
			a: effectsDict[home] || { i: _List_Nil, j: _List_Nil }
		});
	}
}


function _Platform_gatherEffects(isCmd, bag, effectsDict, taggers)
{
	switch (bag.$)
	{
		case 1:
			var home = bag.k;
			var effect = _Platform_toEffect(isCmd, home, taggers, bag.l);
			effectsDict[home] = _Platform_insert(isCmd, effect, effectsDict[home]);
			return;

		case 2:
			for (var list = bag.m; list.b; list = list.b) // WHILE_CONS
			{
				_Platform_gatherEffects(isCmd, list.a, effectsDict, taggers);
			}
			return;

		case 3:
			_Platform_gatherEffects(isCmd, bag.o, effectsDict, {
				s: bag.n,
				t: taggers
			});
			return;
	}
}


function _Platform_toEffect(isCmd, home, taggers, value)
{
	function applyTaggers(x)
	{
		for (var temp = taggers; temp; temp = temp.t)
		{
			x = temp.s(x);
		}
		return x;
	}

	var map = isCmd
		? _Platform_effectManagers[home].e
		: _Platform_effectManagers[home].f;

	return A2(map, applyTaggers, value)
}


function _Platform_insert(isCmd, newEffect, effects)
{
	effects = effects || { i: _List_Nil, j: _List_Nil };

	isCmd
		? (effects.i = _List_Cons(newEffect, effects.i))
		: (effects.j = _List_Cons(newEffect, effects.j));

	return effects;
}



// PORTS


function _Platform_checkPortName(name)
{
	if (_Platform_effectManagers[name])
	{
		_Debug_crash(3, name)
	}
}



// OUTGOING PORTS


function _Platform_outgoingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		e: _Platform_outgoingPortMap,
		u: converter,
		a: _Platform_setupOutgoingPort
	};
	return _Platform_leaf(name);
}


var _Platform_outgoingPortMap = F2(function(tagger, value) { return value; });


function _Platform_setupOutgoingPort(name)
{
	var subs = [];
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Process_sleep(0);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, cmdList, state)
	{
		for ( ; cmdList.b; cmdList = cmdList.b) // WHILE_CONS
		{
			// grab a separate reference to subs in case unsubscribe is called
			var currentSubs = subs;
			var value = _Json_unwrap(converter(cmdList.a));
			for (var i = 0; i < currentSubs.length; i++)
			{
				currentSubs[i](value);
			}
		}
		return init;
	});

	// PUBLIC API

	function subscribe(callback)
	{
		subs.push(callback);
	}

	function unsubscribe(callback)
	{
		// copy subs into a new array in case unsubscribe is called within a
		// subscribed callback
		subs = subs.slice();
		var index = subs.indexOf(callback);
		if (index >= 0)
		{
			subs.splice(index, 1);
		}
	}

	return {
		subscribe: subscribe,
		unsubscribe: unsubscribe
	};
}



// INCOMING PORTS


function _Platform_incomingPort(name, converter)
{
	_Platform_checkPortName(name);
	_Platform_effectManagers[name] = {
		f: _Platform_incomingPortMap,
		u: converter,
		a: _Platform_setupIncomingPort
	};
	return _Platform_leaf(name);
}


var _Platform_incomingPortMap = F2(function(tagger, finalTagger)
{
	return function(value)
	{
		return tagger(finalTagger(value));
	};
});


function _Platform_setupIncomingPort(name, sendToApp)
{
	var subs = _List_Nil;
	var converter = _Platform_effectManagers[name].u;

	// CREATE MANAGER

	var init = _Scheduler_succeed(null);

	_Platform_effectManagers[name].b = init;
	_Platform_effectManagers[name].c = F3(function(router, subList, state)
	{
		subs = subList;
		return init;
	});

	// PUBLIC API

	function send(incomingValue)
	{
		var result = A2(_Json_run, converter, _Json_wrap(incomingValue));

		$elm$core$Result$isOk(result) || _Debug_crash(4, name, result.a);

		var value = result.a;
		for (var temp = subs; temp.b; temp = temp.b) // WHILE_CONS
		{
			sendToApp(temp.a(value));
		}
	}

	return { send: send };
}



// EXPORT ELM MODULES
//
// Have DEBUG and PROD versions so that we can (1) give nicer errors in
// debug mode and (2) not pay for the bits needed for that in prod mode.
//


function _Platform_export(exports)
{
	scope['Elm']
		? _Platform_mergeExportsProd(scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsProd(obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6)
				: _Platform_mergeExportsProd(obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}


function _Platform_export_UNUSED(exports)
{
	scope['Elm']
		? _Platform_mergeExportsDebug('Elm', scope['Elm'], exports)
		: scope['Elm'] = exports;
}


function _Platform_mergeExportsDebug(moduleName, obj, exports)
{
	for (var name in exports)
	{
		(name in obj)
			? (name == 'init')
				? _Debug_crash(6, moduleName)
				: _Platform_mergeExportsDebug(moduleName + '.' + name, obj[name], exports[name])
			: (obj[name] = exports[name]);
	}
}




// HELPERS


var _VirtualDom_divertHrefToApp;

var _VirtualDom_doc = typeof document !== 'undefined' ? document : {};


function _VirtualDom_appendChild(parent, child)
{
	parent.appendChild(child);
}

var _VirtualDom_init = F4(function(virtualNode, flagDecoder, debugMetadata, args)
{
	// NOTE: this function needs _Platform_export available to work

	/**/
	var node = args['node'];
	//*/
	/**_UNUSED/
	var node = args && args['node'] ? args['node'] : _Debug_crash(0);
	//*/

	node.parentNode.replaceChild(
		_VirtualDom_render(virtualNode, function() {}),
		node
	);

	return {};
});



// TEXT


function _VirtualDom_text(string)
{
	return {
		$: 0,
		a: string
	};
}



// NODE


var _VirtualDom_nodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 1,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_node = _VirtualDom_nodeNS(undefined);



// KEYED NODE


var _VirtualDom_keyedNodeNS = F2(function(namespace, tag)
{
	return F2(function(factList, kidList)
	{
		for (var kids = [], descendantsCount = 0; kidList.b; kidList = kidList.b) // WHILE_CONS
		{
			var kid = kidList.a;
			descendantsCount += (kid.b.b || 0);
			kids.push(kid);
		}
		descendantsCount += kids.length;

		return {
			$: 2,
			c: tag,
			d: _VirtualDom_organizeFacts(factList),
			e: kids,
			f: namespace,
			b: descendantsCount
		};
	});
});


var _VirtualDom_keyedNode = _VirtualDom_keyedNodeNS(undefined);



// CUSTOM


function _VirtualDom_custom(factList, model, render, diff)
{
	return {
		$: 3,
		d: _VirtualDom_organizeFacts(factList),
		g: model,
		h: render,
		i: diff
	};
}



// MAP


var _VirtualDom_map = F2(function(tagger, node)
{
	return {
		$: 4,
		j: tagger,
		k: node,
		b: 1 + (node.b || 0)
	};
});



// LAZY


function _VirtualDom_thunk(refs, thunk)
{
	return {
		$: 5,
		l: refs,
		m: thunk,
		k: undefined
	};
}

var _VirtualDom_lazy = F2(function(func, a)
{
	return _VirtualDom_thunk([func, a], function() {
		return func(a);
	});
});

var _VirtualDom_lazy2 = F3(function(func, a, b)
{
	return _VirtualDom_thunk([func, a, b], function() {
		return A2(func, a, b);
	});
});

var _VirtualDom_lazy3 = F4(function(func, a, b, c)
{
	return _VirtualDom_thunk([func, a, b, c], function() {
		return A3(func, a, b, c);
	});
});

var _VirtualDom_lazy4 = F5(function(func, a, b, c, d)
{
	return _VirtualDom_thunk([func, a, b, c, d], function() {
		return A4(func, a, b, c, d);
	});
});

var _VirtualDom_lazy5 = F6(function(func, a, b, c, d, e)
{
	return _VirtualDom_thunk([func, a, b, c, d, e], function() {
		return A5(func, a, b, c, d, e);
	});
});

var _VirtualDom_lazy6 = F7(function(func, a, b, c, d, e, f)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f], function() {
		return A6(func, a, b, c, d, e, f);
	});
});

var _VirtualDom_lazy7 = F8(function(func, a, b, c, d, e, f, g)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g], function() {
		return A7(func, a, b, c, d, e, f, g);
	});
});

var _VirtualDom_lazy8 = F9(function(func, a, b, c, d, e, f, g, h)
{
	return _VirtualDom_thunk([func, a, b, c, d, e, f, g, h], function() {
		return A8(func, a, b, c, d, e, f, g, h);
	});
});



// FACTS


var _VirtualDom_on = F2(function(key, handler)
{
	return {
		$: 'a0',
		n: key,
		o: handler
	};
});
var _VirtualDom_style = F2(function(key, value)
{
	return {
		$: 'a1',
		n: key,
		o: value
	};
});
var _VirtualDom_property = F2(function(key, value)
{
	return {
		$: 'a2',
		n: key,
		o: value
	};
});
var _VirtualDom_attribute = F2(function(key, value)
{
	return {
		$: 'a3',
		n: key,
		o: value
	};
});
var _VirtualDom_attributeNS = F3(function(namespace, key, value)
{
	return {
		$: 'a4',
		n: key,
		o: { f: namespace, o: value }
	};
});



// XSS ATTACK VECTOR CHECKS


function _VirtualDom_noScript(tag)
{
	return tag == 'script' ? 'p' : tag;
}

function _VirtualDom_noOnOrFormAction(key)
{
	return /^(on|formAction$)/i.test(key) ? 'data-' + key : key;
}

function _VirtualDom_noInnerHtmlOrFormAction(key)
{
	return key == 'innerHTML' || key == 'formAction' ? 'data-' + key : key;
}

function _VirtualDom_noJavaScriptUri(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,'')) ? '' : value;
}

function _VirtualDom_noJavaScriptUri_UNUSED(value)
{
	return /^javascript:/i.test(value.replace(/\s/g,''))
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}

function _VirtualDom_noJavaScriptOrHtmlUri(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value) ? '' : value;
}

function _VirtualDom_noJavaScriptOrHtmlUri_UNUSED(value)
{
	return /^\s*(javascript:|data:text\/html)/i.test(value)
		? 'javascript:alert("This is an XSS vector. Please use ports or web components instead.")'
		: value;
}



// MAP FACTS


var _VirtualDom_mapAttribute = F2(function(func, attr)
{
	return (attr.$ === 'a0')
		? A2(_VirtualDom_on, attr.n, _VirtualDom_mapHandler(func, attr.o))
		: attr;
});

function _VirtualDom_mapHandler(func, handler)
{
	var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

	// 0 = Normal
	// 1 = MayStopPropagation
	// 2 = MayPreventDefault
	// 3 = Custom

	return {
		$: handler.$,
		a:
			!tag
				? A2($elm$json$Json$Decode$map, func, handler.a)
				:
			A3($elm$json$Json$Decode$map2,
				tag < 3
					? _VirtualDom_mapEventTuple
					: _VirtualDom_mapEventRecord,
				$elm$json$Json$Decode$succeed(func),
				handler.a
			)
	};
}

var _VirtualDom_mapEventTuple = F2(function(func, tuple)
{
	return _Utils_Tuple2(func(tuple.a), tuple.b);
});

var _VirtualDom_mapEventRecord = F2(function(func, record)
{
	return {
		dM: func(record.dM),
		eG: record.eG,
		dZ: record.dZ
	}
});



// ORGANIZE FACTS


function _VirtualDom_organizeFacts(factList)
{
	for (var facts = {}; factList.b; factList = factList.b) // WHILE_CONS
	{
		var entry = factList.a;

		var tag = entry.$;
		var key = entry.n;
		var value = entry.o;

		if (tag === 'a2')
		{
			(key === 'className')
				? _VirtualDom_addClass(facts, key, _Json_unwrap(value))
				: facts[key] = _Json_unwrap(value);

			continue;
		}

		var subFacts = facts[tag] || (facts[tag] = {});
		(tag === 'a3' && key === 'class')
			? _VirtualDom_addClass(subFacts, key, value)
			: subFacts[key] = value;
	}

	return facts;
}

function _VirtualDom_addClass(object, key, newClass)
{
	var classes = object[key];
	object[key] = classes ? classes + ' ' + newClass : newClass;
}



// RENDER


function _VirtualDom_render(vNode, eventNode)
{
	var tag = vNode.$;

	if (tag === 5)
	{
		return _VirtualDom_render(vNode.k || (vNode.k = vNode.m()), eventNode);
	}

	if (tag === 0)
	{
		return _VirtualDom_doc.createTextNode(vNode.a);
	}

	if (tag === 4)
	{
		var subNode = vNode.k;
		var tagger = vNode.j;

		while (subNode.$ === 4)
		{
			typeof tagger !== 'object'
				? tagger = [tagger, subNode.j]
				: tagger.push(subNode.j);

			subNode = subNode.k;
		}

		var subEventRoot = { j: tagger, p: eventNode };
		var domNode = _VirtualDom_render(subNode, subEventRoot);
		domNode.elm_event_node_ref = subEventRoot;
		return domNode;
	}

	if (tag === 3)
	{
		var domNode = vNode.h(vNode.g);
		_VirtualDom_applyFacts(domNode, eventNode, vNode.d);
		return domNode;
	}

	// at this point `tag` must be 1 or 2

	var domNode = vNode.f
		? _VirtualDom_doc.createElementNS(vNode.f, vNode.c)
		: _VirtualDom_doc.createElement(vNode.c);

	if (_VirtualDom_divertHrefToApp && vNode.c == 'a')
	{
		domNode.addEventListener('click', _VirtualDom_divertHrefToApp(domNode));
	}

	_VirtualDom_applyFacts(domNode, eventNode, vNode.d);

	for (var kids = vNode.e, i = 0; i < kids.length; i++)
	{
		_VirtualDom_appendChild(domNode, _VirtualDom_render(tag === 1 ? kids[i] : kids[i].b, eventNode));
	}

	return domNode;
}



// APPLY FACTS


function _VirtualDom_applyFacts(domNode, eventNode, facts)
{
	for (var key in facts)
	{
		var value = facts[key];

		key === 'a1'
			? _VirtualDom_applyStyles(domNode, value)
			:
		key === 'a0'
			? _VirtualDom_applyEvents(domNode, eventNode, value)
			:
		key === 'a3'
			? _VirtualDom_applyAttrs(domNode, value)
			:
		key === 'a4'
			? _VirtualDom_applyAttrsNS(domNode, value)
			:
		((key !== 'value' && key !== 'checked') || domNode[key] !== value) && (domNode[key] = value);
	}
}



// APPLY STYLES


function _VirtualDom_applyStyles(domNode, styles)
{
	var domNodeStyle = domNode.style;

	for (var key in styles)
	{
		domNodeStyle[key] = styles[key];
	}
}



// APPLY ATTRS


function _VirtualDom_applyAttrs(domNode, attrs)
{
	for (var key in attrs)
	{
		var value = attrs[key];
		typeof value !== 'undefined'
			? domNode.setAttribute(key, value)
			: domNode.removeAttribute(key);
	}
}



// APPLY NAMESPACED ATTRS


function _VirtualDom_applyAttrsNS(domNode, nsAttrs)
{
	for (var key in nsAttrs)
	{
		var pair = nsAttrs[key];
		var namespace = pair.f;
		var value = pair.o;

		typeof value !== 'undefined'
			? domNode.setAttributeNS(namespace, key, value)
			: domNode.removeAttributeNS(namespace, key);
	}
}



// APPLY EVENTS


function _VirtualDom_applyEvents(domNode, eventNode, events)
{
	var allCallbacks = domNode.elmFs || (domNode.elmFs = {});

	for (var key in events)
	{
		var newHandler = events[key];
		var oldCallback = allCallbacks[key];

		if (!newHandler)
		{
			domNode.removeEventListener(key, oldCallback);
			allCallbacks[key] = undefined;
			continue;
		}

		if (oldCallback)
		{
			var oldHandler = oldCallback.q;
			if (oldHandler.$ === newHandler.$)
			{
				oldCallback.q = newHandler;
				continue;
			}
			domNode.removeEventListener(key, oldCallback);
		}

		oldCallback = _VirtualDom_makeCallback(eventNode, newHandler);
		domNode.addEventListener(key, oldCallback,
			_VirtualDom_passiveSupported
			&& { passive: $elm$virtual_dom$VirtualDom$toHandlerInt(newHandler) < 2 }
		);
		allCallbacks[key] = oldCallback;
	}
}



// PASSIVE EVENTS


var _VirtualDom_passiveSupported;

try
{
	window.addEventListener('t', null, Object.defineProperty({}, 'passive', {
		get: function() { _VirtualDom_passiveSupported = true; }
	}));
}
catch(e) {}



// EVENT HANDLERS


function _VirtualDom_makeCallback(eventNode, initialHandler)
{
	function callback(event)
	{
		var handler = callback.q;
		var result = _Json_runHelp(handler.a, event);

		if (!$elm$core$Result$isOk(result))
		{
			return;
		}

		var tag = $elm$virtual_dom$VirtualDom$toHandlerInt(handler);

		// 0 = Normal
		// 1 = MayStopPropagation
		// 2 = MayPreventDefault
		// 3 = Custom

		var value = result.a;
		var message = !tag ? value : tag < 3 ? value.a : value.dM;
		var stopPropagation = tag == 1 ? value.b : tag == 3 && value.eG;
		var currentEventNode = (
			stopPropagation && event.stopPropagation(),
			(tag == 2 ? value.b : tag == 3 && value.dZ) && event.preventDefault(),
			eventNode
		);
		var tagger;
		var i;
		while (tagger = currentEventNode.j)
		{
			if (typeof tagger == 'function')
			{
				message = tagger(message);
			}
			else
			{
				for (var i = tagger.length; i--; )
				{
					message = tagger[i](message);
				}
			}
			currentEventNode = currentEventNode.p;
		}
		currentEventNode(message, stopPropagation); // stopPropagation implies isSync
	}

	callback.q = initialHandler;

	return callback;
}

function _VirtualDom_equalEvents(x, y)
{
	return x.$ == y.$ && _Json_equality(x.a, y.a);
}



// DIFF


// TODO: Should we do patches like in iOS?
//
// type Patch
//   = At Int Patch
//   | Batch (List Patch)
//   | Change ...
//
// How could it not be better?
//
function _VirtualDom_diff(x, y)
{
	var patches = [];
	_VirtualDom_diffHelp(x, y, patches, 0);
	return patches;
}


function _VirtualDom_pushPatch(patches, type, index, data)
{
	var patch = {
		$: type,
		r: index,
		s: data,
		t: undefined,
		u: undefined
	};
	patches.push(patch);
	return patch;
}


function _VirtualDom_diffHelp(x, y, patches, index)
{
	if (x === y)
	{
		return;
	}

	var xType = x.$;
	var yType = y.$;

	// Bail if you run into different types of nodes. Implies that the
	// structure has changed significantly and it's not worth a diff.
	if (xType !== yType)
	{
		if (xType === 1 && yType === 2)
		{
			y = _VirtualDom_dekey(y);
			yType = 1;
		}
		else
		{
			_VirtualDom_pushPatch(patches, 0, index, y);
			return;
		}
	}

	// Now we know that both nodes are the same $.
	switch (yType)
	{
		case 5:
			var xRefs = x.l;
			var yRefs = y.l;
			var i = xRefs.length;
			var same = i === yRefs.length;
			while (same && i--)
			{
				same = xRefs[i] === yRefs[i];
			}
			if (same)
			{
				y.k = x.k;
				return;
			}
			y.k = y.m();
			var subPatches = [];
			_VirtualDom_diffHelp(x.k, y.k, subPatches, 0);
			subPatches.length > 0 && _VirtualDom_pushPatch(patches, 1, index, subPatches);
			return;

		case 4:
			// gather nested taggers
			var xTaggers = x.j;
			var yTaggers = y.j;
			var nesting = false;

			var xSubNode = x.k;
			while (xSubNode.$ === 4)
			{
				nesting = true;

				typeof xTaggers !== 'object'
					? xTaggers = [xTaggers, xSubNode.j]
					: xTaggers.push(xSubNode.j);

				xSubNode = xSubNode.k;
			}

			var ySubNode = y.k;
			while (ySubNode.$ === 4)
			{
				nesting = true;

				typeof yTaggers !== 'object'
					? yTaggers = [yTaggers, ySubNode.j]
					: yTaggers.push(ySubNode.j);

				ySubNode = ySubNode.k;
			}

			// Just bail if different numbers of taggers. This implies the
			// structure of the virtual DOM has changed.
			if (nesting && xTaggers.length !== yTaggers.length)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			// check if taggers are "the same"
			if (nesting ? !_VirtualDom_pairwiseRefEqual(xTaggers, yTaggers) : xTaggers !== yTaggers)
			{
				_VirtualDom_pushPatch(patches, 2, index, yTaggers);
			}

			// diff everything below the taggers
			_VirtualDom_diffHelp(xSubNode, ySubNode, patches, index + 1);
			return;

		case 0:
			if (x.a !== y.a)
			{
				_VirtualDom_pushPatch(patches, 3, index, y.a);
			}
			return;

		case 1:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKids);
			return;

		case 2:
			_VirtualDom_diffNodes(x, y, patches, index, _VirtualDom_diffKeyedKids);
			return;

		case 3:
			if (x.h !== y.h)
			{
				_VirtualDom_pushPatch(patches, 0, index, y);
				return;
			}

			var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
			factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

			var patch = y.i(x.g, y.g);
			patch && _VirtualDom_pushPatch(patches, 5, index, patch);

			return;
	}
}

// assumes the incoming arrays are the same length
function _VirtualDom_pairwiseRefEqual(as, bs)
{
	for (var i = 0; i < as.length; i++)
	{
		if (as[i] !== bs[i])
		{
			return false;
		}
	}

	return true;
}

function _VirtualDom_diffNodes(x, y, patches, index, diffKids)
{
	// Bail if obvious indicators have changed. Implies more serious
	// structural changes such that it's not worth it to diff.
	if (x.c !== y.c || x.f !== y.f)
	{
		_VirtualDom_pushPatch(patches, 0, index, y);
		return;
	}

	var factsDiff = _VirtualDom_diffFacts(x.d, y.d);
	factsDiff && _VirtualDom_pushPatch(patches, 4, index, factsDiff);

	diffKids(x, y, patches, index);
}



// DIFF FACTS


// TODO Instead of creating a new diff object, it's possible to just test if
// there *is* a diff. During the actual patch, do the diff again and make the
// modifications directly. This way, there's no new allocations. Worth it?
function _VirtualDom_diffFacts(x, y, category)
{
	var diff;

	// look for changes and removals
	for (var xKey in x)
	{
		if (xKey === 'a1' || xKey === 'a0' || xKey === 'a3' || xKey === 'a4')
		{
			var subDiff = _VirtualDom_diffFacts(x[xKey], y[xKey] || {}, xKey);
			if (subDiff)
			{
				diff = diff || {};
				diff[xKey] = subDiff;
			}
			continue;
		}

		// remove if not in the new facts
		if (!(xKey in y))
		{
			diff = diff || {};
			diff[xKey] =
				!category
					? (typeof x[xKey] === 'string' ? '' : null)
					:
				(category === 'a1')
					? ''
					:
				(category === 'a0' || category === 'a3')
					? undefined
					:
				{ f: x[xKey].f, o: undefined };

			continue;
		}

		var xValue = x[xKey];
		var yValue = y[xKey];

		// reference equal, so don't worry about it
		if (xValue === yValue && xKey !== 'value' && xKey !== 'checked'
			|| category === 'a0' && _VirtualDom_equalEvents(xValue, yValue))
		{
			continue;
		}

		diff = diff || {};
		diff[xKey] = yValue;
	}

	// add new stuff
	for (var yKey in y)
	{
		if (!(yKey in x))
		{
			diff = diff || {};
			diff[yKey] = y[yKey];
		}
	}

	return diff;
}



// DIFF KIDS


function _VirtualDom_diffKids(xParent, yParent, patches, index)
{
	var xKids = xParent.e;
	var yKids = yParent.e;

	var xLen = xKids.length;
	var yLen = yKids.length;

	// FIGURE OUT IF THERE ARE INSERTS OR REMOVALS

	if (xLen > yLen)
	{
		_VirtualDom_pushPatch(patches, 6, index, {
			v: yLen,
			i: xLen - yLen
		});
	}
	else if (xLen < yLen)
	{
		_VirtualDom_pushPatch(patches, 7, index, {
			v: xLen,
			e: yKids
		});
	}

	// PAIRWISE DIFF EVERYTHING ELSE

	for (var minLen = xLen < yLen ? xLen : yLen, i = 0; i < minLen; i++)
	{
		var xKid = xKids[i];
		_VirtualDom_diffHelp(xKid, yKids[i], patches, ++index);
		index += xKid.b || 0;
	}
}



// KEYED DIFF


function _VirtualDom_diffKeyedKids(xParent, yParent, patches, rootIndex)
{
	var localPatches = [];

	var changes = {}; // Dict String Entry
	var inserts = []; // Array { index : Int, entry : Entry }
	// type Entry = { tag : String, vnode : VNode, index : Int, data : _ }

	var xKids = xParent.e;
	var yKids = yParent.e;
	var xLen = xKids.length;
	var yLen = yKids.length;
	var xIndex = 0;
	var yIndex = 0;

	var index = rootIndex;

	while (xIndex < xLen && yIndex < yLen)
	{
		var x = xKids[xIndex];
		var y = yKids[yIndex];

		var xKey = x.a;
		var yKey = y.a;
		var xNode = x.b;
		var yNode = y.b;

		var newMatch = undefined;
		var oldMatch = undefined;

		// check if keys match

		if (xKey === yKey)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNode, localPatches, index);
			index += xNode.b || 0;

			xIndex++;
			yIndex++;
			continue;
		}

		// look ahead 1 to detect insertions and removals.

		var xNext = xKids[xIndex + 1];
		var yNext = yKids[yIndex + 1];

		if (xNext)
		{
			var xNextKey = xNext.a;
			var xNextNode = xNext.b;
			oldMatch = yKey === xNextKey;
		}

		if (yNext)
		{
			var yNextKey = yNext.a;
			var yNextNode = yNext.b;
			newMatch = xKey === yNextKey;
		}


		// swap x and y
		if (newMatch && oldMatch)
		{
			index++;
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			_VirtualDom_insertNode(changes, localPatches, xKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNextNode, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		// insert y
		if (newMatch)
		{
			index++;
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			_VirtualDom_diffHelp(xNode, yNextNode, localPatches, index);
			index += xNode.b || 0;

			xIndex += 1;
			yIndex += 2;
			continue;
		}

		// remove x
		if (oldMatch)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 1;
			continue;
		}

		// remove x, insert y
		if (xNext && xNextKey === yNextKey)
		{
			index++;
			_VirtualDom_removeNode(changes, localPatches, xKey, xNode, index);
			_VirtualDom_insertNode(changes, localPatches, yKey, yNode, yIndex, inserts);
			index += xNode.b || 0;

			index++;
			_VirtualDom_diffHelp(xNextNode, yNextNode, localPatches, index);
			index += xNextNode.b || 0;

			xIndex += 2;
			yIndex += 2;
			continue;
		}

		break;
	}

	// eat up any remaining nodes with removeNode and insertNode

	while (xIndex < xLen)
	{
		index++;
		var x = xKids[xIndex];
		var xNode = x.b;
		_VirtualDom_removeNode(changes, localPatches, x.a, xNode, index);
		index += xNode.b || 0;
		xIndex++;
	}

	while (yIndex < yLen)
	{
		var endInserts = endInserts || [];
		var y = yKids[yIndex];
		_VirtualDom_insertNode(changes, localPatches, y.a, y.b, undefined, endInserts);
		yIndex++;
	}

	if (localPatches.length > 0 || inserts.length > 0 || endInserts)
	{
		_VirtualDom_pushPatch(patches, 8, rootIndex, {
			w: localPatches,
			x: inserts,
			y: endInserts
		});
	}
}



// CHANGES FROM KEYED DIFF


var _VirtualDom_POSTFIX = '_elmW6BL';


function _VirtualDom_insertNode(changes, localPatches, key, vnode, yIndex, inserts)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		entry = {
			c: 0,
			z: vnode,
			r: yIndex,
			s: undefined
		};

		inserts.push({ r: yIndex, A: entry });
		changes[key] = entry;

		return;
	}

	// this key was removed earlier, a match!
	if (entry.c === 1)
	{
		inserts.push({ r: yIndex, A: entry });

		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(entry.z, vnode, subPatches, entry.r);
		entry.r = yIndex;
		entry.s.s = {
			w: subPatches,
			A: entry
		};

		return;
	}

	// this key has already been inserted or moved, a duplicate!
	_VirtualDom_insertNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, yIndex, inserts);
}


function _VirtualDom_removeNode(changes, localPatches, key, vnode, index)
{
	var entry = changes[key];

	// never seen this key before
	if (!entry)
	{
		var patch = _VirtualDom_pushPatch(localPatches, 9, index, undefined);

		changes[key] = {
			c: 1,
			z: vnode,
			r: index,
			s: patch
		};

		return;
	}

	// this key was inserted earlier, a match!
	if (entry.c === 0)
	{
		entry.c = 2;
		var subPatches = [];
		_VirtualDom_diffHelp(vnode, entry.z, subPatches, index);

		_VirtualDom_pushPatch(localPatches, 9, index, {
			w: subPatches,
			A: entry
		});

		return;
	}

	// this key has already been removed or moved, a duplicate!
	_VirtualDom_removeNode(changes, localPatches, key + _VirtualDom_POSTFIX, vnode, index);
}



// ADD DOM NODES
//
// Each DOM node has an "index" assigned in order of traversal. It is important
// to minimize our crawl over the actual DOM, so these indexes (along with the
// descendantsCount of virtual nodes) let us skip touching entire subtrees of
// the DOM if we know there are no patches there.


function _VirtualDom_addDomNodes(domNode, vNode, patches, eventNode)
{
	_VirtualDom_addDomNodesHelp(domNode, vNode, patches, 0, 0, vNode.b, eventNode);
}


// assumes `patches` is non-empty and indexes increase monotonically.
function _VirtualDom_addDomNodesHelp(domNode, vNode, patches, i, low, high, eventNode)
{
	var patch = patches[i];
	var index = patch.r;

	while (index === low)
	{
		var patchType = patch.$;

		if (patchType === 1)
		{
			_VirtualDom_addDomNodes(domNode, vNode.k, patch.s, eventNode);
		}
		else if (patchType === 8)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var subPatches = patch.s.w;
			if (subPatches.length > 0)
			{
				_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
			}
		}
		else if (patchType === 9)
		{
			patch.t = domNode;
			patch.u = eventNode;

			var data = patch.s;
			if (data)
			{
				data.A.s = domNode;
				var subPatches = data.w;
				if (subPatches.length > 0)
				{
					_VirtualDom_addDomNodesHelp(domNode, vNode, subPatches, 0, low, high, eventNode);
				}
			}
		}
		else
		{
			patch.t = domNode;
			patch.u = eventNode;
		}

		i++;

		if (!(patch = patches[i]) || (index = patch.r) > high)
		{
			return i;
		}
	}

	var tag = vNode.$;

	if (tag === 4)
	{
		var subNode = vNode.k;

		while (subNode.$ === 4)
		{
			subNode = subNode.k;
		}

		return _VirtualDom_addDomNodesHelp(domNode, subNode, patches, i, low + 1, high, domNode.elm_event_node_ref);
	}

	// tag must be 1 or 2 at this point

	var vKids = vNode.e;
	var childNodes = domNode.childNodes;
	for (var j = 0; j < vKids.length; j++)
	{
		low++;
		var vKid = tag === 1 ? vKids[j] : vKids[j].b;
		var nextLow = low + (vKid.b || 0);
		if (low <= index && index <= nextLow)
		{
			i = _VirtualDom_addDomNodesHelp(childNodes[j], vKid, patches, i, low, nextLow, eventNode);
			if (!(patch = patches[i]) || (index = patch.r) > high)
			{
				return i;
			}
		}
		low = nextLow;
	}
	return i;
}



// APPLY PATCHES


function _VirtualDom_applyPatches(rootDomNode, oldVirtualNode, patches, eventNode)
{
	if (patches.length === 0)
	{
		return rootDomNode;
	}

	_VirtualDom_addDomNodes(rootDomNode, oldVirtualNode, patches, eventNode);
	return _VirtualDom_applyPatchesHelp(rootDomNode, patches);
}

function _VirtualDom_applyPatchesHelp(rootDomNode, patches)
{
	for (var i = 0; i < patches.length; i++)
	{
		var patch = patches[i];
		var localDomNode = patch.t
		var newNode = _VirtualDom_applyPatch(localDomNode, patch);
		if (localDomNode === rootDomNode)
		{
			rootDomNode = newNode;
		}
	}
	return rootDomNode;
}

function _VirtualDom_applyPatch(domNode, patch)
{
	switch (patch.$)
	{
		case 0:
			return _VirtualDom_applyPatchRedraw(domNode, patch.s, patch.u);

		case 4:
			_VirtualDom_applyFacts(domNode, patch.u, patch.s);
			return domNode;

		case 3:
			domNode.replaceData(0, domNode.length, patch.s);
			return domNode;

		case 1:
			return _VirtualDom_applyPatchesHelp(domNode, patch.s);

		case 2:
			if (domNode.elm_event_node_ref)
			{
				domNode.elm_event_node_ref.j = patch.s;
			}
			else
			{
				domNode.elm_event_node_ref = { j: patch.s, p: patch.u };
			}
			return domNode;

		case 6:
			var data = patch.s;
			for (var i = 0; i < data.i; i++)
			{
				domNode.removeChild(domNode.childNodes[data.v]);
			}
			return domNode;

		case 7:
			var data = patch.s;
			var kids = data.e;
			var i = data.v;
			var theEnd = domNode.childNodes[i];
			for (; i < kids.length; i++)
			{
				domNode.insertBefore(_VirtualDom_render(kids[i], patch.u), theEnd);
			}
			return domNode;

		case 9:
			var data = patch.s;
			if (!data)
			{
				domNode.parentNode.removeChild(domNode);
				return domNode;
			}
			var entry = data.A;
			if (typeof entry.r !== 'undefined')
			{
				domNode.parentNode.removeChild(domNode);
			}
			entry.s = _VirtualDom_applyPatchesHelp(domNode, data.w);
			return domNode;

		case 8:
			return _VirtualDom_applyPatchReorder(domNode, patch);

		case 5:
			return patch.s(domNode);

		default:
			_Debug_crash(10); // 'Ran into an unknown patch!'
	}
}


function _VirtualDom_applyPatchRedraw(domNode, vNode, eventNode)
{
	var parentNode = domNode.parentNode;
	var newNode = _VirtualDom_render(vNode, eventNode);

	if (!newNode.elm_event_node_ref)
	{
		newNode.elm_event_node_ref = domNode.elm_event_node_ref;
	}

	if (parentNode && newNode !== domNode)
	{
		parentNode.replaceChild(newNode, domNode);
	}
	return newNode;
}


function _VirtualDom_applyPatchReorder(domNode, patch)
{
	var data = patch.s;

	// remove end inserts
	var frag = _VirtualDom_applyPatchReorderEndInsertsHelp(data.y, patch);

	// removals
	domNode = _VirtualDom_applyPatchesHelp(domNode, data.w);

	// inserts
	var inserts = data.x;
	for (var i = 0; i < inserts.length; i++)
	{
		var insert = inserts[i];
		var entry = insert.A;
		var node = entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u);
		domNode.insertBefore(node, domNode.childNodes[insert.r]);
	}

	// add end inserts
	if (frag)
	{
		_VirtualDom_appendChild(domNode, frag);
	}

	return domNode;
}


function _VirtualDom_applyPatchReorderEndInsertsHelp(endInserts, patch)
{
	if (!endInserts)
	{
		return;
	}

	var frag = _VirtualDom_doc.createDocumentFragment();
	for (var i = 0; i < endInserts.length; i++)
	{
		var insert = endInserts[i];
		var entry = insert.A;
		_VirtualDom_appendChild(frag, entry.c === 2
			? entry.s
			: _VirtualDom_render(entry.z, patch.u)
		);
	}
	return frag;
}


function _VirtualDom_virtualize(node)
{
	// TEXT NODES

	if (node.nodeType === 3)
	{
		return _VirtualDom_text(node.textContent);
	}


	// WEIRD NODES

	if (node.nodeType !== 1)
	{
		return _VirtualDom_text('');
	}


	// ELEMENT NODES

	var attrList = _List_Nil;
	var attrs = node.attributes;
	for (var i = attrs.length; i--; )
	{
		var attr = attrs[i];
		var name = attr.name;
		var value = attr.value;
		attrList = _List_Cons( A2(_VirtualDom_attribute, name, value), attrList );
	}

	var tag = node.tagName.toLowerCase();
	var kidList = _List_Nil;
	var kids = node.childNodes;

	for (var i = kids.length; i--; )
	{
		kidList = _List_Cons(_VirtualDom_virtualize(kids[i]), kidList);
	}
	return A3(_VirtualDom_node, tag, attrList, kidList);
}

function _VirtualDom_dekey(keyedNode)
{
	var keyedKids = keyedNode.e;
	var len = keyedKids.length;
	var kids = new Array(len);
	for (var i = 0; i < len; i++)
	{
		kids[i] = keyedKids[i].b;
	}

	return {
		$: 1,
		c: keyedNode.c,
		d: keyedNode.d,
		e: kids,
		f: keyedNode.f,
		b: keyedNode.b
	};
}




// ELEMENT


var _Debugger_element;

var _Browser_element = _Debugger_element || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.fG,
		impl.ha,
		impl.gY,
		function(sendToApp, initialModel) {
			var view = impl.hd;
			/**/
			var domNode = args['node'];
			//*/
			/**_UNUSED/
			var domNode = args && args['node'] ? args['node'] : _Debug_crash(0);
			//*/
			var currNode = _VirtualDom_virtualize(domNode);

			return _Browser_makeAnimator(initialModel, function(model)
			{
				var nextNode = view(model);
				var patches = _VirtualDom_diff(currNode, nextNode);
				domNode = _VirtualDom_applyPatches(domNode, currNode, patches, sendToApp);
				currNode = nextNode;
			});
		}
	);
});



// DOCUMENT


var _Debugger_document;

var _Browser_document = _Debugger_document || F4(function(impl, flagDecoder, debugMetadata, args)
{
	return _Platform_initialize(
		flagDecoder,
		args,
		impl.fG,
		impl.ha,
		impl.gY,
		function(sendToApp, initialModel) {
			var divertHrefToApp = impl.cA && impl.cA(sendToApp)
			var view = impl.hd;
			var title = _VirtualDom_doc.title;
			var bodyNode = _VirtualDom_doc.body;
			var currNode = _VirtualDom_virtualize(bodyNode);
			return _Browser_makeAnimator(initialModel, function(model)
			{
				_VirtualDom_divertHrefToApp = divertHrefToApp;
				var doc = view(model);
				var nextNode = _VirtualDom_node('body')(_List_Nil)(doc.e6);
				var patches = _VirtualDom_diff(currNode, nextNode);
				bodyNode = _VirtualDom_applyPatches(bodyNode, currNode, patches, sendToApp);
				currNode = nextNode;
				_VirtualDom_divertHrefToApp = 0;
				(title !== doc.g4) && (_VirtualDom_doc.title = title = doc.g4);
			});
		}
	);
});



// ANIMATION


var _Browser_cancelAnimationFrame =
	typeof cancelAnimationFrame !== 'undefined'
		? cancelAnimationFrame
		: function(id) { clearTimeout(id); };

var _Browser_requestAnimationFrame =
	typeof requestAnimationFrame !== 'undefined'
		? requestAnimationFrame
		: function(callback) { return setTimeout(callback, 1000 / 60); };


function _Browser_makeAnimator(model, draw)
{
	draw(model);

	var state = 0;

	function updateIfNeeded()
	{
		state = state === 1
			? 0
			: ( _Browser_requestAnimationFrame(updateIfNeeded), draw(model), 1 );
	}

	return function(nextModel, isSync)
	{
		model = nextModel;

		isSync
			? ( draw(model),
				state === 2 && (state = 1)
				)
			: ( state === 0 && _Browser_requestAnimationFrame(updateIfNeeded),
				state = 2
				);
	};
}



// APPLICATION


function _Browser_application(impl)
{
	var onUrlChange = impl.gs;
	var onUrlRequest = impl.gt;
	var key = function() { key.a(onUrlChange(_Browser_getUrl())); };

	return _Browser_document({
		cA: function(sendToApp)
		{
			key.a = sendToApp;
			_Browser_window.addEventListener('popstate', key);
			_Browser_window.navigator.userAgent.indexOf('Trident') < 0 || _Browser_window.addEventListener('hashchange', key);

			return F2(function(domNode, event)
			{
				if (!event.ctrlKey && !event.metaKey && !event.shiftKey && event.button < 1 && !domNode.target && !domNode.hasAttribute('download'))
				{
					event.preventDefault();
					var href = domNode.href;
					var curr = _Browser_getUrl();
					var next = $elm$url$Url$fromString(href).a;
					sendToApp(onUrlRequest(
						(next
							&& curr.d2 === next.d2
							&& curr.fC === next.fC
							&& curr.dY.a === next.dY.a
						)
							? $elm$browser$Browser$Internal(next)
							: $elm$browser$Browser$External(href)
					));
				}
			});
		},
		fG: function(flags)
		{
			return A3(impl.fG, flags, _Browser_getUrl(), key);
		},
		hd: impl.hd,
		ha: impl.ha,
		gY: impl.gY
	});
}

function _Browser_getUrl()
{
	return $elm$url$Url$fromString(_VirtualDom_doc.location.href).a || _Debug_crash(1);
}

var _Browser_go = F2(function(key, n)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		n && history.go(n);
		key();
	}));
});

var _Browser_pushUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.pushState({}, '', url);
		key();
	}));
});

var _Browser_replaceUrl = F2(function(key, url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function() {
		history.replaceState({}, '', url);
		key();
	}));
});



// GLOBAL EVENTS


var _Browser_fakeNode = { addEventListener: function() {}, removeEventListener: function() {} };
var _Browser_doc = typeof document !== 'undefined' ? document : _Browser_fakeNode;
var _Browser_window = typeof window !== 'undefined' ? window : _Browser_fakeNode;

var _Browser_on = F3(function(node, eventName, sendToSelf)
{
	return _Scheduler_spawn(_Scheduler_binding(function(callback)
	{
		function handler(event)	{ _Scheduler_rawSpawn(sendToSelf(event)); }
		node.addEventListener(eventName, handler, _VirtualDom_passiveSupported && { passive: true });
		return function() { node.removeEventListener(eventName, handler); };
	}));
});

var _Browser_decodeEvent = F2(function(decoder, event)
{
	var result = _Json_runHelp(decoder, event);
	return $elm$core$Result$isOk(result) ? $elm$core$Maybe$Just(result.a) : $elm$core$Maybe$Nothing;
});



// PAGE VISIBILITY


function _Browser_visibilityInfo()
{
	return (typeof _VirtualDom_doc.hidden !== 'undefined')
		? { fz: 'hidden', e9: 'visibilitychange' }
		:
	(typeof _VirtualDom_doc.mozHidden !== 'undefined')
		? { fz: 'mozHidden', e9: 'mozvisibilitychange' }
		:
	(typeof _VirtualDom_doc.msHidden !== 'undefined')
		? { fz: 'msHidden', e9: 'msvisibilitychange' }
		:
	(typeof _VirtualDom_doc.webkitHidden !== 'undefined')
		? { fz: 'webkitHidden', e9: 'webkitvisibilitychange' }
		: { fz: 'hidden', e9: 'visibilitychange' };
}



// ANIMATION FRAMES


function _Browser_rAF()
{
	return _Scheduler_binding(function(callback)
	{
		var id = _Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(Date.now()));
		});

		return function() {
			_Browser_cancelAnimationFrame(id);
		};
	});
}


function _Browser_now()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(Date.now()));
	});
}



// DOM STUFF


function _Browser_withNode(id, doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			var node = document.getElementById(id);
			callback(node
				? _Scheduler_succeed(doStuff(node))
				: _Scheduler_fail($elm$browser$Browser$Dom$NotFound(id))
			);
		});
	});
}


function _Browser_withWindow(doStuff)
{
	return _Scheduler_binding(function(callback)
	{
		_Browser_requestAnimationFrame(function() {
			callback(_Scheduler_succeed(doStuff()));
		});
	});
}


// FOCUS and BLUR


var _Browser_call = F2(function(functionName, id)
{
	return _Browser_withNode(id, function(node) {
		node[functionName]();
		return _Utils_Tuple0;
	});
});



// WINDOW VIEWPORT


function _Browser_getViewport()
{
	return {
		en: _Browser_getScene(),
		eU: {
			eY: _Browser_window.pageXOffset,
			eZ: _Browser_window.pageYOffset,
			eX: _Browser_doc.documentElement.clientWidth,
			dp: _Browser_doc.documentElement.clientHeight
		}
	};
}

function _Browser_getScene()
{
	var body = _Browser_doc.body;
	var elem = _Browser_doc.documentElement;
	return {
		eX: Math.max(body.scrollWidth, body.offsetWidth, elem.scrollWidth, elem.offsetWidth, elem.clientWidth),
		dp: Math.max(body.scrollHeight, body.offsetHeight, elem.scrollHeight, elem.offsetHeight, elem.clientHeight)
	};
}

var _Browser_setViewport = F2(function(x, y)
{
	return _Browser_withWindow(function()
	{
		_Browser_window.scroll(x, y);
		return _Utils_Tuple0;
	});
});



// ELEMENT VIEWPORT


function _Browser_getViewportOf(id)
{
	return _Browser_withNode(id, function(node)
	{
		return {
			en: {
				eX: node.scrollWidth,
				dp: node.scrollHeight
			},
			eU: {
				eY: node.scrollLeft,
				eZ: node.scrollTop,
				eX: node.clientWidth,
				dp: node.clientHeight
			}
		};
	});
}


var _Browser_setViewportOf = F3(function(id, x, y)
{
	return _Browser_withNode(id, function(node)
	{
		node.scrollLeft = x;
		node.scrollTop = y;
		return _Utils_Tuple0;
	});
});



// ELEMENT


function _Browser_getElement(id)
{
	return _Browser_withNode(id, function(node)
	{
		var rect = node.getBoundingClientRect();
		var x = _Browser_window.pageXOffset;
		var y = _Browser_window.pageYOffset;
		return {
			en: _Browser_getScene(),
			eU: {
				eY: x,
				eZ: y,
				eX: _Browser_doc.documentElement.clientWidth,
				dp: _Browser_doc.documentElement.clientHeight
			},
			fn: {
				eY: x + rect.left,
				eZ: y + rect.top,
				eX: rect.width,
				dp: rect.height
			}
		};
	});
}



// LOAD and RELOAD


function _Browser_reload(skipCache)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		_VirtualDom_doc.location.reload(skipCache);
	}));
}

function _Browser_load(url)
{
	return A2($elm$core$Task$perform, $elm$core$Basics$never, _Scheduler_binding(function(callback)
	{
		try
		{
			_Browser_window.location = url;
		}
		catch(err)
		{
			// Only Firefox can throw a NS_ERROR_MALFORMED_URI exception here.
			// Other browsers reload the page, so let's be consistent about that.
			_VirtualDom_doc.location.reload(false);
		}
	}));
}


function _Url_percentEncode(string)
{
	return encodeURIComponent(string);
}

function _Url_percentDecode(string)
{
	try
	{
		return $elm$core$Maybe$Just(decodeURIComponent(string));
	}
	catch (e)
	{
		return $elm$core$Maybe$Nothing;
	}
}


// SEND REQUEST

var _Http_toTask = F3(function(router, toTask, request)
{
	return _Scheduler_binding(function(callback)
	{
		function done(response) {
			callback(toTask(request.fq.a(response)));
		}

		var xhr = new XMLHttpRequest();
		xhr.addEventListener('error', function() { done($elm$http$Http$NetworkError_); });
		xhr.addEventListener('timeout', function() { done($elm$http$Http$Timeout_); });
		xhr.addEventListener('load', function() { done(_Http_toResponse(request.fq.b, xhr)); });
		$elm$core$Maybe$isJust(request.g6) && _Http_track(router, xhr, request.g6.a);

		try {
			xhr.open(request.f2, request.hc, true);
		} catch (e) {
			return done($elm$http$Http$BadUrl_(request.hc));
		}

		_Http_configureRequest(xhr, request);

		request.e6.a && xhr.setRequestHeader('Content-Type', request.e6.a);
		xhr.send(request.e6.b);

		return function() { xhr.c = true; xhr.abort(); };
	});
});


// CONFIGURE

function _Http_configureRequest(xhr, request)
{
	for (var headers = request.fy; headers.b; headers = headers.b) // WHILE_CONS
	{
		xhr.setRequestHeader(headers.a.a, headers.a.b);
	}
	xhr.timeout = request.g3.a || 0;
	xhr.responseType = request.fq.d;
	xhr.withCredentials = request.e1;
}


// RESPONSES

function _Http_toResponse(toBody, xhr)
{
	return A2(
		200 <= xhr.status && xhr.status < 300 ? $elm$http$Http$GoodStatus_ : $elm$http$Http$BadStatus_,
		_Http_toMetadata(xhr),
		toBody(xhr.response)
	);
}


// METADATA

function _Http_toMetadata(xhr)
{
	return {
		hc: xhr.responseURL,
		gV: xhr.status,
		gW: xhr.statusText,
		fy: _Http_parseHeaders(xhr.getAllResponseHeaders())
	};
}


// HEADERS

function _Http_parseHeaders(rawHeaders)
{
	if (!rawHeaders)
	{
		return $elm$core$Dict$empty;
	}

	var headers = $elm$core$Dict$empty;
	var headerPairs = rawHeaders.split('\r\n');
	for (var i = headerPairs.length; i--; )
	{
		var headerPair = headerPairs[i];
		var index = headerPair.indexOf(': ');
		if (index > 0)
		{
			var key = headerPair.substring(0, index);
			var value = headerPair.substring(index + 2);

			headers = A3($elm$core$Dict$update, key, function(oldValue) {
				return $elm$core$Maybe$Just($elm$core$Maybe$isJust(oldValue)
					? value + ', ' + oldValue.a
					: value
				);
			}, headers);
		}
	}
	return headers;
}


// EXPECT

var _Http_expect = F3(function(type, toBody, toValue)
{
	return {
		$: 0,
		d: type,
		b: toBody,
		a: toValue
	};
});

var _Http_mapExpect = F2(function(func, expect)
{
	return {
		$: 0,
		d: expect.d,
		b: expect.b,
		a: function(x) { return func(expect.a(x)); }
	};
});

function _Http_toDataView(arrayBuffer)
{
	return new DataView(arrayBuffer);
}


// BODY and PARTS

var _Http_emptyBody = { $: 0 };
var _Http_pair = F2(function(a, b) { return { $: 0, a: a, b: b }; });

function _Http_toFormData(parts)
{
	for (var formData = new FormData(); parts.b; parts = parts.b) // WHILE_CONS
	{
		var part = parts.a;
		formData.append(part.a, part.b);
	}
	return formData;
}

var _Http_bytesToBlob = F2(function(mime, bytes)
{
	return new Blob([bytes], { type: mime });
});


// PROGRESS

function _Http_track(router, xhr, tracker)
{
	// TODO check out lengthComputable on loadstart event

	xhr.upload.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Sending({
			gP: event.loaded,
			ev: event.total
		}))));
	});
	xhr.addEventListener('progress', function(event) {
		if (xhr.c) { return; }
		_Scheduler_rawSpawn(A2($elm$core$Platform$sendToSelf, router, _Utils_Tuple2(tracker, $elm$http$Http$Receiving({
			gH: event.loaded,
			ev: event.lengthComputable ? $elm$core$Maybe$Just(event.total) : $elm$core$Maybe$Nothing
		}))));
	});
}


function _Time_now(millisToPosix)
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(millisToPosix(Date.now())));
	});
}

var _Time_setInterval = F2(function(interval, task)
{
	return _Scheduler_binding(function(callback)
	{
		var id = setInterval(function() { _Scheduler_rawSpawn(task); }, interval);
		return function() { clearInterval(id); };
	});
});

function _Time_here()
{
	return _Scheduler_binding(function(callback)
	{
		callback(_Scheduler_succeed(
			A2($elm$time$Time$customZone, -(new Date().getTimezoneOffset()), _List_Nil)
		));
	});
}


function _Time_getZoneName()
{
	return _Scheduler_binding(function(callback)
	{
		try
		{
			var name = $elm$time$Time$Name(Intl.DateTimeFormat().resolvedOptions().timeZone);
		}
		catch (e)
		{
			var name = $elm$time$Time$Offset(new Date().getTimezoneOffset());
		}
		callback(_Scheduler_succeed(name));
	});
}



var _Bitwise_and = F2(function(a, b)
{
	return a & b;
});

var _Bitwise_or = F2(function(a, b)
{
	return a | b;
});

var _Bitwise_xor = F2(function(a, b)
{
	return a ^ b;
});

function _Bitwise_complement(a)
{
	return ~a;
};

var _Bitwise_shiftLeftBy = F2(function(offset, a)
{
	return a << offset;
});

var _Bitwise_shiftRightBy = F2(function(offset, a)
{
	return a >> offset;
});

var _Bitwise_shiftRightZfBy = F2(function(offset, a)
{
	return a >>> offset;
});


// CREATE

var _Regex_never = /.^/;

var _Regex_fromStringWith = F2(function(options, string)
{
	var flags = 'g';
	if (options.f9) { flags += 'm'; }
	if (options.e8) { flags += 'i'; }

	try
	{
		return $elm$core$Maybe$Just(new RegExp(string, flags));
	}
	catch(error)
	{
		return $elm$core$Maybe$Nothing;
	}
});


// USE

var _Regex_contains = F2(function(re, string)
{
	return string.match(re) !== null;
});


var _Regex_findAtMost = F3(function(n, re, str)
{
	var out = [];
	var number = 0;
	var string = str;
	var lastIndex = re.lastIndex;
	var prevLastIndex = -1;
	var result;
	while (number++ < n && (result = re.exec(string)))
	{
		if (prevLastIndex == re.lastIndex) break;
		var i = result.length - 1;
		var subs = new Array(i);
		while (i > 0)
		{
			var submatch = result[i];
			subs[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		out.push(A4($elm$regex$Regex$Match, result[0], result.index, number, _List_fromArray(subs)));
		prevLastIndex = re.lastIndex;
	}
	re.lastIndex = lastIndex;
	return _List_fromArray(out);
});


var _Regex_replaceAtMost = F4(function(n, re, replacer, string)
{
	var count = 0;
	function jsReplacer(match)
	{
		if (count++ >= n)
		{
			return match;
		}
		var i = arguments.length - 3;
		var submatches = new Array(i);
		while (i > 0)
		{
			var submatch = arguments[i];
			submatches[--i] = submatch
				? $elm$core$Maybe$Just(submatch)
				: $elm$core$Maybe$Nothing;
		}
		return replacer(A4($elm$regex$Regex$Match, match, arguments[arguments.length - 2], count, _List_fromArray(submatches)));
	}
	return string.replace(re, jsReplacer);
});

var _Regex_splitAtMost = F3(function(n, re, str)
{
	var string = str;
	var out = [];
	var start = re.lastIndex;
	var restoreLastIndex = re.lastIndex;
	while (n--)
	{
		var result = re.exec(string);
		if (!result) break;
		out.push(string.slice(start, result.index));
		start = re.lastIndex;
	}
	out.push(string.slice(start));
	re.lastIndex = restoreLastIndex;
	return _List_fromArray(out);
});

var _Regex_infinity = Infinity;



// DECODER

var _File_decoder = _Json_decodePrim(function(value) {
	// NOTE: checks if `File` exists in case this is run on node
	return (typeof File !== 'undefined' && value instanceof File)
		? $elm$core$Result$Ok(value)
		: _Json_expecting('a FILE', value);
});


// METADATA

function _File_name(file) { return file.name; }
function _File_mime(file) { return file.type; }
function _File_size(file) { return file.size; }

function _File_lastModified(file)
{
	return $elm$time$Time$millisToPosix(file.lastModified);
}


// DOWNLOAD

var _File_downloadNode;

function _File_getDownloadNode()
{
	return _File_downloadNode || (_File_downloadNode = document.createElement('a'));
}

var _File_download = F3(function(name, mime, content)
{
	return _Scheduler_binding(function(callback)
	{
		var blob = new Blob([content], {type: mime});

		// for IE10+
		if (navigator.msSaveOrOpenBlob)
		{
			navigator.msSaveOrOpenBlob(blob, name);
			return;
		}

		// for HTML5
		var node = _File_getDownloadNode();
		var objectUrl = URL.createObjectURL(blob);
		node.href = objectUrl;
		node.download = name;
		_File_click(node);
		URL.revokeObjectURL(objectUrl);
	});
});

function _File_downloadUrl(href)
{
	return _Scheduler_binding(function(callback)
	{
		var node = _File_getDownloadNode();
		node.href = href;
		node.download = '';
		node.origin === location.origin || (node.target = '_blank');
		_File_click(node);
	});
}


// IE COMPATIBILITY

function _File_makeBytesSafeForInternetExplorer(bytes)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/10
	// all other browsers can just run `new Blob([bytes])` directly with no problem
	//
	return new Uint8Array(bytes.buffer, bytes.byteOffset, bytes.byteLength);
}

function _File_click(node)
{
	// only needed by IE10 and IE11 to fix https://github.com/elm/file/issues/11
	// all other browsers have MouseEvent and do not need this conditional stuff
	//
	if (typeof MouseEvent === 'function')
	{
		node.dispatchEvent(new MouseEvent('click'));
	}
	else
	{
		var event = document.createEvent('MouseEvents');
		event.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
		document.body.appendChild(node);
		node.dispatchEvent(event);
		document.body.removeChild(node);
	}
}


// UPLOAD

var _File_node;

function _File_uploadOne(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			callback(_Scheduler_succeed(event.target.files[0]));
		});
		_File_click(_File_node);
	});
}

function _File_uploadOneOrMore(mimes)
{
	return _Scheduler_binding(function(callback)
	{
		_File_node = document.createElement('input');
		_File_node.type = 'file';
		_File_node.multiple = true;
		_File_node.accept = A2($elm$core$String$join, ',', mimes);
		_File_node.addEventListener('change', function(event)
		{
			var elmFiles = _List_fromArray(event.target.files);
			callback(_Scheduler_succeed(_Utils_Tuple2(elmFiles.a, elmFiles.b)));
		});
		_File_click(_File_node);
	});
}


// CONTENT

function _File_toString(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsText(blob);
		return function() { reader.abort(); };
	});
}

function _File_toBytes(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(new DataView(reader.result)));
		});
		reader.readAsArrayBuffer(blob);
		return function() { reader.abort(); };
	});
}

function _File_toUrl(blob)
{
	return _Scheduler_binding(function(callback)
	{
		var reader = new FileReader();
		reader.addEventListener('loadend', function() {
			callback(_Scheduler_succeed(reader.result));
		});
		reader.readAsDataURL(blob);
		return function() { reader.abort(); };
	});
}





// STRINGS


var _Parser_isSubString = F5(function(smallString, offset, row, col, bigString)
{
	var smallLength = smallString.length;
	var isGood = offset + smallLength <= bigString.length;

	for (var i = 0; isGood && i < smallLength; )
	{
		var code = bigString.charCodeAt(offset);
		isGood =
			smallString[i++] === bigString[offset++]
			&& (
				code === 0x000A /* \n */
					? ( row++, col=1 )
					: ( col++, (code & 0xF800) === 0xD800 ? smallString[i++] === bigString[offset++] : 1 )
			)
	}

	return _Utils_Tuple3(isGood ? offset : -1, row, col);
});



// CHARS


var _Parser_isSubChar = F3(function(predicate, offset, string)
{
	return (
		string.length <= offset
			? -1
			:
		(string.charCodeAt(offset) & 0xF800) === 0xD800
			? (predicate(_Utils_chr(string.substr(offset, 2))) ? offset + 2 : -1)
			:
		(predicate(_Utils_chr(string[offset]))
			? ((string[offset] === '\n') ? -2 : (offset + 1))
			: -1
		)
	);
});


var _Parser_isAsciiCode = F3(function(code, offset, string)
{
	return string.charCodeAt(offset) === code;
});



// NUMBERS


var _Parser_chompBase10 = F2(function(offset, string)
{
	for (; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (code < 0x30 || 0x39 < code)
		{
			return offset;
		}
	}
	return offset;
});


var _Parser_consumeBase = F3(function(base, offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var digit = string.charCodeAt(offset) - 0x30;
		if (digit < 0 || base <= digit) break;
		total = base * total + digit;
	}
	return _Utils_Tuple2(offset, total);
});


var _Parser_consumeBase16 = F2(function(offset, string)
{
	for (var total = 0; offset < string.length; offset++)
	{
		var code = string.charCodeAt(offset);
		if (0x30 <= code && code <= 0x39)
		{
			total = 16 * total + code - 0x30;
		}
		else if (0x41 <= code && code <= 0x46)
		{
			total = 16 * total + code - 55;
		}
		else if (0x61 <= code && code <= 0x66)
		{
			total = 16 * total + code - 87;
		}
		else
		{
			break;
		}
	}
	return _Utils_Tuple2(offset, total);
});



// FIND STRING


var _Parser_findSubString = F5(function(smallString, offset, row, col, bigString)
{
	var newOffset = bigString.indexOf(smallString, offset);
	var target = newOffset < 0 ? bigString.length : newOffset + smallString.length;

	while (offset < target)
	{
		var code = bigString.charCodeAt(offset++);
		code === 0x000A /* \n */
			? ( col=1, row++ )
			: ( col++, (code & 0xF800) === 0xD800 && offset++ )
	}

	return _Utils_Tuple3(newOffset, row, col);
});
var $elm$core$Basics$composeR = F3(
	function (f, g, x) {
		return g(
			f(x));
	});
var $elm$core$Basics$EQ = 1;
var $elm$core$Basics$GT = 2;
var $elm$core$Basics$LT = 0;
var $elm$core$List$cons = _List_cons;
var $elm$core$Dict$foldr = F3(
	function (func, acc, t) {
		foldr:
		while (true) {
			if (t.$ === -2) {
				return acc;
			} else {
				var key = t.b;
				var value = t.c;
				var left = t.d;
				var right = t.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldr, func, acc, right)),
					$temp$t = left;
				func = $temp$func;
				acc = $temp$acc;
				t = $temp$t;
				continue foldr;
			}
		}
	});
var $elm$core$Dict$toList = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, list) {
				return A2(
					$elm$core$List$cons,
					_Utils_Tuple2(key, value),
					list);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Dict$keys = function (dict) {
	return A3(
		$elm$core$Dict$foldr,
		F3(
			function (key, value, keyList) {
				return A2($elm$core$List$cons, key, keyList);
			}),
		_List_Nil,
		dict);
};
var $elm$core$Set$toList = function (_v0) {
	var dict = _v0;
	return $elm$core$Dict$keys(dict);
};
var $elm$core$Elm$JsArray$foldr = _JsArray_foldr;
var $elm$core$Array$foldr = F3(
	function (func, baseCase, _v0) {
		var tree = _v0.c;
		var tail = _v0.d;
		var helper = F2(
			function (node, acc) {
				if (!node.$) {
					var subTree = node.a;
					return A3($elm$core$Elm$JsArray$foldr, helper, acc, subTree);
				} else {
					var values = node.a;
					return A3($elm$core$Elm$JsArray$foldr, func, acc, values);
				}
			});
		return A3(
			$elm$core$Elm$JsArray$foldr,
			helper,
			A3($elm$core$Elm$JsArray$foldr, func, baseCase, tail),
			tree);
	});
var $elm$core$Array$toList = function (array) {
	return A3($elm$core$Array$foldr, $elm$core$List$cons, _List_Nil, array);
};
var $elm$core$Result$Err = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$Failure = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$json$Json$Decode$Field = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$json$Json$Decode$Index = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$core$Result$Ok = function (a) {
	return {$: 0, a: a};
};
var $elm$json$Json$Decode$OneOf = function (a) {
	return {$: 2, a: a};
};
var $elm$core$Basics$False = 1;
var $elm$core$Basics$add = _Basics_add;
var $elm$core$Maybe$Just = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Maybe$Nothing = {$: 1};
var $elm$core$String$all = _String_all;
var $elm$core$Basics$and = _Basics_and;
var $elm$core$Basics$append = _Utils_append;
var $elm$json$Json$Encode$encode = _Json_encode;
var $elm$core$String$fromInt = _String_fromNumber;
var $elm$core$String$join = F2(
	function (sep, chunks) {
		return A2(
			_String_join,
			sep,
			_List_toArray(chunks));
	});
var $elm$core$String$split = F2(
	function (sep, string) {
		return _List_fromArray(
			A2(_String_split, sep, string));
	});
var $elm$json$Json$Decode$indent = function (str) {
	return A2(
		$elm$core$String$join,
		'\n    ',
		A2($elm$core$String$split, '\n', str));
};
var $elm$core$List$foldl = F3(
	function (func, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var x = list.a;
				var xs = list.b;
				var $temp$func = func,
					$temp$acc = A2(func, x, acc),
					$temp$list = xs;
				func = $temp$func;
				acc = $temp$acc;
				list = $temp$list;
				continue foldl;
			}
		}
	});
var $elm$core$List$length = function (xs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, i) {
				return i + 1;
			}),
		0,
		xs);
};
var $elm$core$List$map2 = _List_map2;
var $elm$core$Basics$le = _Utils_le;
var $elm$core$Basics$sub = _Basics_sub;
var $elm$core$List$rangeHelp = F3(
	function (lo, hi, list) {
		rangeHelp:
		while (true) {
			if (_Utils_cmp(lo, hi) < 1) {
				var $temp$lo = lo,
					$temp$hi = hi - 1,
					$temp$list = A2($elm$core$List$cons, hi, list);
				lo = $temp$lo;
				hi = $temp$hi;
				list = $temp$list;
				continue rangeHelp;
			} else {
				return list;
			}
		}
	});
var $elm$core$List$range = F2(
	function (lo, hi) {
		return A3($elm$core$List$rangeHelp, lo, hi, _List_Nil);
	});
var $elm$core$List$indexedMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$map2,
			f,
			A2(
				$elm$core$List$range,
				0,
				$elm$core$List$length(xs) - 1),
			xs);
	});
var $elm$core$Char$toCode = _Char_toCode;
var $elm$core$Char$isLower = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (97 <= code) && (code <= 122);
};
var $elm$core$Char$isUpper = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 90) && (65 <= code);
};
var $elm$core$Basics$or = _Basics_or;
var $elm$core$Char$isAlpha = function (_char) {
	return $elm$core$Char$isLower(_char) || $elm$core$Char$isUpper(_char);
};
var $elm$core$Char$isDigit = function (_char) {
	var code = $elm$core$Char$toCode(_char);
	return (code <= 57) && (48 <= code);
};
var $elm$core$Char$isAlphaNum = function (_char) {
	return $elm$core$Char$isLower(_char) || ($elm$core$Char$isUpper(_char) || $elm$core$Char$isDigit(_char));
};
var $elm$core$List$reverse = function (list) {
	return A3($elm$core$List$foldl, $elm$core$List$cons, _List_Nil, list);
};
var $elm$core$String$uncons = _String_uncons;
var $elm$json$Json$Decode$errorOneOf = F2(
	function (i, error) {
		return '\n\n(' + ($elm$core$String$fromInt(i + 1) + (') ' + $elm$json$Json$Decode$indent(
			$elm$json$Json$Decode$errorToString(error))));
	});
var $elm$json$Json$Decode$errorToString = function (error) {
	return A2($elm$json$Json$Decode$errorToStringHelp, error, _List_Nil);
};
var $elm$json$Json$Decode$errorToStringHelp = F2(
	function (error, context) {
		errorToStringHelp:
		while (true) {
			switch (error.$) {
				case 0:
					var f = error.a;
					var err = error.b;
					var isSimple = function () {
						var _v1 = $elm$core$String$uncons(f);
						if (_v1.$ === 1) {
							return false;
						} else {
							var _v2 = _v1.a;
							var _char = _v2.a;
							var rest = _v2.b;
							return $elm$core$Char$isAlpha(_char) && A2($elm$core$String$all, $elm$core$Char$isAlphaNum, rest);
						}
					}();
					var fieldName = isSimple ? ('.' + f) : ('[\'' + (f + '\']'));
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, fieldName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 1:
					var i = error.a;
					var err = error.b;
					var indexName = '[' + ($elm$core$String$fromInt(i) + ']');
					var $temp$error = err,
						$temp$context = A2($elm$core$List$cons, indexName, context);
					error = $temp$error;
					context = $temp$context;
					continue errorToStringHelp;
				case 2:
					var errors = error.a;
					if (!errors.b) {
						return 'Ran into a Json.Decode.oneOf with no possibilities' + function () {
							if (!context.b) {
								return '!';
							} else {
								return ' at json' + A2(
									$elm$core$String$join,
									'',
									$elm$core$List$reverse(context));
							}
						}();
					} else {
						if (!errors.b.b) {
							var err = errors.a;
							var $temp$error = err,
								$temp$context = context;
							error = $temp$error;
							context = $temp$context;
							continue errorToStringHelp;
						} else {
							var starter = function () {
								if (!context.b) {
									return 'Json.Decode.oneOf';
								} else {
									return 'The Json.Decode.oneOf at json' + A2(
										$elm$core$String$join,
										'',
										$elm$core$List$reverse(context));
								}
							}();
							var introduction = starter + (' failed in the following ' + ($elm$core$String$fromInt(
								$elm$core$List$length(errors)) + ' ways:'));
							return A2(
								$elm$core$String$join,
								'\n\n',
								A2(
									$elm$core$List$cons,
									introduction,
									A2($elm$core$List$indexedMap, $elm$json$Json$Decode$errorOneOf, errors)));
						}
					}
				default:
					var msg = error.a;
					var json = error.b;
					var introduction = function () {
						if (!context.b) {
							return 'Problem with the given value:\n\n';
						} else {
							return 'Problem with the value at json' + (A2(
								$elm$core$String$join,
								'',
								$elm$core$List$reverse(context)) + ':\n\n    ');
						}
					}();
					return introduction + ($elm$json$Json$Decode$indent(
						A2($elm$json$Json$Encode$encode, 4, json)) + ('\n\n' + msg));
			}
		}
	});
var $elm$core$Array$branchFactor = 32;
var $elm$core$Array$Array_elm_builtin = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$core$Elm$JsArray$empty = _JsArray_empty;
var $elm$core$Basics$ceiling = _Basics_ceiling;
var $elm$core$Basics$fdiv = _Basics_fdiv;
var $elm$core$Basics$logBase = F2(
	function (base, number) {
		return _Basics_log(number) / _Basics_log(base);
	});
var $elm$core$Basics$toFloat = _Basics_toFloat;
var $elm$core$Array$shiftStep = $elm$core$Basics$ceiling(
	A2($elm$core$Basics$logBase, 2, $elm$core$Array$branchFactor));
var $elm$core$Array$empty = A4($elm$core$Array$Array_elm_builtin, 0, $elm$core$Array$shiftStep, $elm$core$Elm$JsArray$empty, $elm$core$Elm$JsArray$empty);
var $elm$core$Elm$JsArray$initialize = _JsArray_initialize;
var $elm$core$Array$Leaf = function (a) {
	return {$: 1, a: a};
};
var $elm$core$Basics$apL = F2(
	function (f, x) {
		return f(x);
	});
var $elm$core$Basics$apR = F2(
	function (x, f) {
		return f(x);
	});
var $elm$core$Basics$eq = _Utils_equal;
var $elm$core$Basics$floor = _Basics_floor;
var $elm$core$Elm$JsArray$length = _JsArray_length;
var $elm$core$Basics$gt = _Utils_gt;
var $elm$core$Basics$max = F2(
	function (x, y) {
		return (_Utils_cmp(x, y) > 0) ? x : y;
	});
var $elm$core$Basics$mul = _Basics_mul;
var $elm$core$Array$SubTree = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Elm$JsArray$initializeFromList = _JsArray_initializeFromList;
var $elm$core$Array$compressNodes = F2(
	function (nodes, acc) {
		compressNodes:
		while (true) {
			var _v0 = A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodes);
			var node = _v0.a;
			var remainingNodes = _v0.b;
			var newAcc = A2(
				$elm$core$List$cons,
				$elm$core$Array$SubTree(node),
				acc);
			if (!remainingNodes.b) {
				return $elm$core$List$reverse(newAcc);
			} else {
				var $temp$nodes = remainingNodes,
					$temp$acc = newAcc;
				nodes = $temp$nodes;
				acc = $temp$acc;
				continue compressNodes;
			}
		}
	});
var $elm$core$Tuple$first = function (_v0) {
	var x = _v0.a;
	return x;
};
var $elm$core$Array$treeFromBuilder = F2(
	function (nodeList, nodeListSize) {
		treeFromBuilder:
		while (true) {
			var newNodeSize = $elm$core$Basics$ceiling(nodeListSize / $elm$core$Array$branchFactor);
			if (newNodeSize === 1) {
				return A2($elm$core$Elm$JsArray$initializeFromList, $elm$core$Array$branchFactor, nodeList).a;
			} else {
				var $temp$nodeList = A2($elm$core$Array$compressNodes, nodeList, _List_Nil),
					$temp$nodeListSize = newNodeSize;
				nodeList = $temp$nodeList;
				nodeListSize = $temp$nodeListSize;
				continue treeFromBuilder;
			}
		}
	});
var $elm$core$Array$builderToArray = F2(
	function (reverseNodeList, builder) {
		if (!builder.r) {
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.t),
				$elm$core$Array$shiftStep,
				$elm$core$Elm$JsArray$empty,
				builder.t);
		} else {
			var treeLen = builder.r * $elm$core$Array$branchFactor;
			var depth = $elm$core$Basics$floor(
				A2($elm$core$Basics$logBase, $elm$core$Array$branchFactor, treeLen - 1));
			var correctNodeList = reverseNodeList ? $elm$core$List$reverse(builder.v) : builder.v;
			var tree = A2($elm$core$Array$treeFromBuilder, correctNodeList, builder.r);
			return A4(
				$elm$core$Array$Array_elm_builtin,
				$elm$core$Elm$JsArray$length(builder.t) + treeLen,
				A2($elm$core$Basics$max, 5, depth * $elm$core$Array$shiftStep),
				tree,
				builder.t);
		}
	});
var $elm$core$Basics$idiv = _Basics_idiv;
var $elm$core$Basics$lt = _Utils_lt;
var $elm$core$Array$initializeHelp = F5(
	function (fn, fromIndex, len, nodeList, tail) {
		initializeHelp:
		while (true) {
			if (fromIndex < 0) {
				return A2(
					$elm$core$Array$builderToArray,
					false,
					{v: nodeList, r: (len / $elm$core$Array$branchFactor) | 0, t: tail});
			} else {
				var leaf = $elm$core$Array$Leaf(
					A3($elm$core$Elm$JsArray$initialize, $elm$core$Array$branchFactor, fromIndex, fn));
				var $temp$fn = fn,
					$temp$fromIndex = fromIndex - $elm$core$Array$branchFactor,
					$temp$len = len,
					$temp$nodeList = A2($elm$core$List$cons, leaf, nodeList),
					$temp$tail = tail;
				fn = $temp$fn;
				fromIndex = $temp$fromIndex;
				len = $temp$len;
				nodeList = $temp$nodeList;
				tail = $temp$tail;
				continue initializeHelp;
			}
		}
	});
var $elm$core$Basics$remainderBy = _Basics_remainderBy;
var $elm$core$Array$initialize = F2(
	function (len, fn) {
		if (len <= 0) {
			return $elm$core$Array$empty;
		} else {
			var tailLen = len % $elm$core$Array$branchFactor;
			var tail = A3($elm$core$Elm$JsArray$initialize, tailLen, len - tailLen, fn);
			var initialFromIndex = (len - tailLen) - $elm$core$Array$branchFactor;
			return A5($elm$core$Array$initializeHelp, fn, initialFromIndex, len, _List_Nil, tail);
		}
	});
var $elm$core$Basics$True = 0;
var $elm$core$Result$isOk = function (result) {
	if (!result.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$json$Json$Decode$map = _Json_map1;
var $elm$json$Json$Decode$map2 = _Json_map2;
var $elm$json$Json$Decode$succeed = _Json_succeed;
var $elm$virtual_dom$VirtualDom$toHandlerInt = function (handler) {
	switch (handler.$) {
		case 0:
			return 0;
		case 1:
			return 1;
		case 2:
			return 2;
		default:
			return 3;
	}
};
var $elm$browser$Browser$External = function (a) {
	return {$: 1, a: a};
};
var $elm$browser$Browser$Internal = function (a) {
	return {$: 0, a: a};
};
var $elm$core$Basics$identity = function (x) {
	return x;
};
var $elm$browser$Browser$Dom$NotFound = $elm$core$Basics$identity;
var $elm$url$Url$Http = 0;
var $elm$url$Url$Https = 1;
var $elm$url$Url$Url = F6(
	function (protocol, host, port_, path, query, fragment) {
		return {dm: fragment, fC: host, dW: path, dY: port_, d2: protocol, d3: query};
	});
var $elm$core$String$contains = _String_contains;
var $elm$core$String$length = _String_length;
var $elm$core$String$slice = _String_slice;
var $elm$core$String$dropLeft = F2(
	function (n, string) {
		return (n < 1) ? string : A3(
			$elm$core$String$slice,
			n,
			$elm$core$String$length(string),
			string);
	});
var $elm$core$String$indexes = _String_indexes;
var $elm$core$String$isEmpty = function (string) {
	return string === '';
};
var $elm$core$String$left = F2(
	function (n, string) {
		return (n < 1) ? '' : A3($elm$core$String$slice, 0, n, string);
	});
var $elm$core$String$toInt = _String_toInt;
var $elm$url$Url$chompBeforePath = F5(
	function (protocol, path, params, frag, str) {
		if ($elm$core$String$isEmpty(str) || A2($elm$core$String$contains, '@', str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, ':', str);
			if (!_v0.b) {
				return $elm$core$Maybe$Just(
					A6($elm$url$Url$Url, protocol, str, $elm$core$Maybe$Nothing, path, params, frag));
			} else {
				if (!_v0.b.b) {
					var i = _v0.a;
					var _v1 = $elm$core$String$toInt(
						A2($elm$core$String$dropLeft, i + 1, str));
					if (_v1.$ === 1) {
						return $elm$core$Maybe$Nothing;
					} else {
						var port_ = _v1;
						return $elm$core$Maybe$Just(
							A6(
								$elm$url$Url$Url,
								protocol,
								A2($elm$core$String$left, i, str),
								port_,
								path,
								params,
								frag));
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			}
		}
	});
var $elm$url$Url$chompBeforeQuery = F4(
	function (protocol, params, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '/', str);
			if (!_v0.b) {
				return A5($elm$url$Url$chompBeforePath, protocol, '/', params, frag, str);
			} else {
				var i = _v0.a;
				return A5(
					$elm$url$Url$chompBeforePath,
					protocol,
					A2($elm$core$String$dropLeft, i, str),
					params,
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompBeforeFragment = F3(
	function (protocol, frag, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '?', str);
			if (!_v0.b) {
				return A4($elm$url$Url$chompBeforeQuery, protocol, $elm$core$Maybe$Nothing, frag, str);
			} else {
				var i = _v0.a;
				return A4(
					$elm$url$Url$chompBeforeQuery,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					frag,
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$url$Url$chompAfterProtocol = F2(
	function (protocol, str) {
		if ($elm$core$String$isEmpty(str)) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v0 = A2($elm$core$String$indexes, '#', str);
			if (!_v0.b) {
				return A3($elm$url$Url$chompBeforeFragment, protocol, $elm$core$Maybe$Nothing, str);
			} else {
				var i = _v0.a;
				return A3(
					$elm$url$Url$chompBeforeFragment,
					protocol,
					$elm$core$Maybe$Just(
						A2($elm$core$String$dropLeft, i + 1, str)),
					A2($elm$core$String$left, i, str));
			}
		}
	});
var $elm$core$String$startsWith = _String_startsWith;
var $elm$url$Url$fromString = function (str) {
	return A2($elm$core$String$startsWith, 'http://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		0,
		A2($elm$core$String$dropLeft, 7, str)) : (A2($elm$core$String$startsWith, 'https://', str) ? A2(
		$elm$url$Url$chompAfterProtocol,
		1,
		A2($elm$core$String$dropLeft, 8, str)) : $elm$core$Maybe$Nothing);
};
var $elm$core$Basics$never = function (_v0) {
	never:
	while (true) {
		var nvr = _v0;
		var $temp$_v0 = nvr;
		_v0 = $temp$_v0;
		continue never;
	}
};
var $elm$core$Task$Perform = $elm$core$Basics$identity;
var $elm$core$Task$succeed = _Scheduler_succeed;
var $elm$core$Task$init = $elm$core$Task$succeed(0);
var $elm$core$List$foldrHelper = F4(
	function (fn, acc, ctr, ls) {
		if (!ls.b) {
			return acc;
		} else {
			var a = ls.a;
			var r1 = ls.b;
			if (!r1.b) {
				return A2(fn, a, acc);
			} else {
				var b = r1.a;
				var r2 = r1.b;
				if (!r2.b) {
					return A2(
						fn,
						a,
						A2(fn, b, acc));
				} else {
					var c = r2.a;
					var r3 = r2.b;
					if (!r3.b) {
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(fn, c, acc)));
					} else {
						var d = r3.a;
						var r4 = r3.b;
						var res = (ctr > 500) ? A3(
							$elm$core$List$foldl,
							fn,
							acc,
							$elm$core$List$reverse(r4)) : A4($elm$core$List$foldrHelper, fn, acc, ctr + 1, r4);
						return A2(
							fn,
							a,
							A2(
								fn,
								b,
								A2(
									fn,
									c,
									A2(fn, d, res))));
					}
				}
			}
		}
	});
var $elm$core$List$foldr = F3(
	function (fn, acc, ls) {
		return A4($elm$core$List$foldrHelper, fn, acc, 0, ls);
	});
var $elm$core$List$map = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, acc) {
					return A2(
						$elm$core$List$cons,
						f(x),
						acc);
				}),
			_List_Nil,
			xs);
	});
var $elm$core$Task$andThen = _Scheduler_andThen;
var $elm$core$Task$map = F2(
	function (func, taskA) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return $elm$core$Task$succeed(
					func(a));
			},
			taskA);
	});
var $elm$core$Task$map2 = F3(
	function (func, taskA, taskB) {
		return A2(
			$elm$core$Task$andThen,
			function (a) {
				return A2(
					$elm$core$Task$andThen,
					function (b) {
						return $elm$core$Task$succeed(
							A2(func, a, b));
					},
					taskB);
			},
			taskA);
	});
var $elm$core$Task$sequence = function (tasks) {
	return A3(
		$elm$core$List$foldr,
		$elm$core$Task$map2($elm$core$List$cons),
		$elm$core$Task$succeed(_List_Nil),
		tasks);
};
var $elm$core$Platform$sendToApp = _Platform_sendToApp;
var $elm$core$Task$spawnCmd = F2(
	function (router, _v0) {
		var task = _v0;
		return _Scheduler_spawn(
			A2(
				$elm$core$Task$andThen,
				$elm$core$Platform$sendToApp(router),
				task));
	});
var $elm$core$Task$onEffects = F3(
	function (router, commands, state) {
		return A2(
			$elm$core$Task$map,
			function (_v0) {
				return 0;
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$map,
					$elm$core$Task$spawnCmd(router),
					commands)));
	});
var $elm$core$Task$onSelfMsg = F3(
	function (_v0, _v1, _v2) {
		return $elm$core$Task$succeed(0);
	});
var $elm$core$Task$cmdMap = F2(
	function (tagger, _v0) {
		var task = _v0;
		return A2($elm$core$Task$map, tagger, task);
	});
_Platform_effectManagers['Task'] = _Platform_createManager($elm$core$Task$init, $elm$core$Task$onEffects, $elm$core$Task$onSelfMsg, $elm$core$Task$cmdMap);
var $elm$core$Task$command = _Platform_leaf('Task');
var $elm$core$Task$perform = F2(
	function (toMessage, task) {
		return $elm$core$Task$command(
			A2($elm$core$Task$map, toMessage, task));
	});
var $elm$browser$Browser$element = _Browser_element;
var $author$project$Msg$AdjustTimeZone = function (a) {
	return {$: 2, a: a};
};
var $author$project$Translations$De = 0;
var $author$project$Msg$SetStationDoneState = function (a) {
	return {$: 13, a: a};
};
var $author$project$Msg$Timer = function (a) {
	return {$: 3, a: a};
};
var $elm$json$Json$Decode$field = _Json_decodeField;
var $elm$json$Json$Decode$at = F2(
	function (fields, decoder) {
		return A3($elm$core$List$foldr, $elm$json$Json$Decode$field, decoder, fields);
	});
var $elm$json$Json$Decode$andThen = _Json_andThen;
var $elm$json$Json$Decode$oneOf = _Json_oneOf;
var $elm$json$Json$Decode$maybe = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder),
				$elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing)
			]));
};
var $webbhuset$elm_json_decode$Json$Decode$Field$attempt = F3(
	function (fieldName, valueDecoder, continuation) {
		return A2(
			$elm$json$Json$Decode$andThen,
			continuation,
			$elm$json$Json$Decode$maybe(
				A2($elm$json$Json$Decode$field, fieldName, valueDecoder)));
	});
var $elm$core$Platform$Cmd$batch = _Platform_batch;
var $author$project$Ui$Router$Loading = {$: 0};
var $krisajenkins$remotedata$RemoteData$NotAsked = {$: 0};
var $author$project$Types$Queue$NotStarted = {$: 0};
var $krisajenkins$remotedata$RemoteData$Success = function (a) {
	return {$: 3, a: a};
};
var $author$project$Lib$Sync$Server = {$: 0};
var $author$project$Types$Station$StationSyncWrapper = F3(
	function (syncState, operationClosed, stations) {
		return {gv: operationClosed, aA: stations, gZ: syncState};
	});
var $elm$json$Json$Decode$bool = _Json_decodeBool;
var $elm$json$Json$Decode$null = _Json_decodeNull;
var $elm$json$Json$Decode$nullable = function (decoder) {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$elm$json$Json$Decode$null($elm$core$Maybe$Nothing),
				A2($elm$json$Json$Decode$map, $elm$core$Maybe$Just, decoder)
			]));
};
var $author$project$Lib$Sync$Local = {$: 1};
var $author$project$Lib$Sync$LocalAwaitConfirmation = {$: 2};
var $author$project$Lib$Sync$LocalNotOnDevice = function (a) {
	return {$: 4, a: a};
};
var $author$project$Lib$Sync$LocalOnDevice = function (a) {
	return {$: 3, a: a};
};
var $author$project$Lib$Sync$NotSyncable = {$: 5};
var $author$project$Lib$Sync$localNotOnDeviceStr = 'LocalNotOnDevice#';
var $author$project$Lib$Sync$localOnDeviceStr = 'LocalOnDevice#';
var $elm$core$String$replace = F3(
	function (before, after, string) {
		return A2(
			$elm$core$String$join,
			after,
			A2($elm$core$String$split, before, string));
	});
var $author$project$Lib$Sync$stateFromMabye = function (maybeState) {
	if (!maybeState.$) {
		switch (maybeState.a) {
			case 'Server':
				return $author$project$Lib$Sync$Server;
			case 'Local':
				return $author$project$Lib$Sync$Local;
			case 'LocalAwaitConfirmation':
				return $author$project$Lib$Sync$LocalAwaitConfirmation;
			case 'NotSyncable':
				return $author$project$Lib$Sync$NotSyncable;
			default:
				var str = maybeState.a;
				return A2($elm$core$String$startsWith, $author$project$Lib$Sync$localOnDeviceStr, str) ? $author$project$Lib$Sync$LocalOnDevice(
					A3($elm$core$String$replace, $author$project$Lib$Sync$localOnDeviceStr, '', str)) : (A2($elm$core$String$startsWith, $author$project$Lib$Sync$localNotOnDeviceStr, str) ? $author$project$Lib$Sync$LocalNotOnDevice(
					A3($elm$core$String$replace, $author$project$Lib$Sync$localNotOnDeviceStr, '', str)) : $author$project$Lib$Sync$Server);
		}
	} else {
		return $author$project$Lib$Sync$Server;
	}
};
var $elm$json$Json$Decode$string = _Json_decodeString;
var $author$project$Lib$Sync$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (maybeString) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Lib$Sync$stateFromMabye(maybeString));
	},
	$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string));
var $author$project$Types$Station$Station = function (id) {
	return function (name) {
		return function (description) {
			return function (title) {
				return function (stepOrder) {
					return function (workLog) {
						return function (stepDatabase) {
							return function (inline) {
								return function (aborted) {
									return function (finished) {
										return function (rulesInteractive) {
											return function (rulesVisible) {
												return function (rulesRepeat) {
													return function (counter) {
														return function (iterations) {
															return function (stationDeleteRequest) {
																return {b2: aborted, I: counter, fl: description, cc: finished, bD: id, dw: inline, ab: iterations, dP: name, eg: rulesInteractive, ei: rulesRepeat, ek: rulesVisible, eB: stationDeleteRequest, A: stepDatabase, eE: stepOrder, g4: title, hf: workLog};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Types$Step$And = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$Step$Not = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$Step$Or = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$Step$Active = {$: 8};
var $author$project$Types$Step$decodeActiveRule = A2(
	$elm$json$Json$Decode$andThen,
	function (_v0) {
		return $elm$json$Json$Decode$succeed($author$project$Types$Step$Active);
	},
	A2($elm$json$Json$Decode$field, 'active', $elm$json$Json$Decode$bool));
var $author$project$Types$Step$Compare = function (a) {
	return {$: 3, a: a};
};
var $author$project$Types$Step$CompareAlias = F3(
	function (stepType, stepId, comparison) {
		return {_: comparison, gX: stepId, eF: stepType};
	});
var $author$project$Lib$Comparison$Comparison = F3(
	function (accessor, operator, rawValue) {
		return {cQ: accessor, cr: operator, cx: rawValue};
	});
var $author$project$Lib$Comparison$CTBool = function (a) {
	return {$: 0, a: a};
};
var $author$project$Lib$Comparison$ctBool = A2(
	$elm$json$Json$Decode$andThen,
	function (val) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Lib$Comparison$CTBool(val));
	},
	$elm$json$Json$Decode$bool);
var $author$project$Lib$Comparison$CTFloat = function (a) {
	return {$: 1, a: a};
};
var $elm$json$Json$Decode$float = _Json_decodeFloat;
var $author$project$Lib$Comparison$ctFloat = A2(
	$elm$json$Json$Decode$andThen,
	function (val) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Lib$Comparison$CTFloat(val));
	},
	$elm$json$Json$Decode$float);
var $author$project$Lib$Comparison$CTInt = function (a) {
	return {$: 2, a: a};
};
var $elm$json$Json$Decode$int = _Json_decodeInt;
var $author$project$Lib$Comparison$ctInt = A2(
	$elm$json$Json$Decode$andThen,
	function (val) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Lib$Comparison$CTInt(val));
	},
	$elm$json$Json$Decode$int);
var $author$project$Lib$Comparison$CTString = function (a) {
	return {$: 3, a: a};
};
var $author$project$Lib$Comparison$ctString = A2(
	$elm$json$Json$Decode$andThen,
	function (val) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Lib$Comparison$CTString(val));
	},
	$elm$json$Json$Decode$string);
var $elm$json$Json$Decode$map3 = _Json_map3;
var $author$project$Lib$Comparison$decodeComparison = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Lib$Comparison$Comparison,
	A2(
		$elm$json$Json$Decode$field,
		'accessor',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
	A2($elm$json$Json$Decode$field, 'operator', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'rawValue',
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[$author$project$Lib$Comparison$ctInt, $author$project$Lib$Comparison$ctBool, $author$project$Lib$Comparison$ctString, $author$project$Lib$Comparison$ctFloat]))));
var $author$project$Types$Step$decodeStepId = $elm$json$Json$Decode$string;
var $author$project$Types$Step$Amount = function (a) {
	return {$: 5, a: a};
};
var $author$project$Types$Steps$Amount$decode = $elm$json$Json$Decode$int;
var $author$project$Types$Step$decodeAmount = A2(
	$elm$json$Json$Decode$andThen,
	function (val) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Types$Step$Amount(
				$elm$core$Maybe$Just(val)));
	},
	A2($elm$json$Json$Decode$field, 'amount', $author$project$Types$Steps$Amount$decode));
var $author$project$Types$Step$ArticleInput = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Types$Steps$ArticleInput$NewArticle = F4(
	function (selected, amount, serialNumbers, counter) {
		return {Q: amount, I: counter, gO: selected, ao: serialNumbers};
	});
var $author$project$Types$Steps$ArticleInput$SerialNumber = F3(
	function (sn, brand, markForDelete) {
		return {c1: brand, cm: markForDelete, ex: sn};
	});
var $elm$core$Maybe$withDefault = F2(
	function (_default, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return value;
		} else {
			return _default;
		}
	});
var $author$project$Types$Steps$ArticleInput$decodeSerialNumber = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Types$Steps$ArticleInput$SerialNumber,
	A2($elm$json$Json$Decode$field, 'sn', $elm$json$Json$Decode$string),
	A2(
		$elm$json$Json$Decode$field,
		'brand',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string)),
	A2(
		$elm$json$Json$Decode$andThen,
		function (mfd) {
			return $elm$json$Json$Decode$succeed(
				A2($elm$core$Maybe$withDefault, false, mfd));
		},
		$elm$json$Json$Decode$maybe(
			A2($elm$json$Json$Decode$field, 'markForDelete', $elm$json$Json$Decode$bool))));
var $author$project$Types$Steps$ArticleInput$Template = F3(
	function (templateId, title, serialNumberRequired) {
		return {gQ: serialNumberRequired, g1: templateId, g4: title};
	});
var $author$project$Types$Steps$ArticleInput$decodeTemplate = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Types$Steps$ArticleInput$Template,
	A2($elm$json$Json$Decode$field, 'templateId', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'title', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'serialNumberRequired', $elm$json$Json$Decode$bool));
var $elm$core$Dict$RBEmpty_elm_builtin = {$: -2};
var $elm$core$Dict$empty = $elm$core$Dict$RBEmpty_elm_builtin;
var $elm$core$Dict$Black = 1;
var $elm$core$Dict$RBNode_elm_builtin = F5(
	function (a, b, c, d, e) {
		return {$: -1, a: a, b: b, c: c, d: d, e: e};
	});
var $elm$core$Dict$Red = 0;
var $elm$core$Dict$balance = F5(
	function (color, key, value, left, right) {
		if ((right.$ === -1) && (!right.a)) {
			var _v1 = right.a;
			var rK = right.b;
			var rV = right.c;
			var rLeft = right.d;
			var rRight = right.e;
			if ((left.$ === -1) && (!left.a)) {
				var _v3 = left.a;
				var lK = left.b;
				var lV = left.c;
				var lLeft = left.d;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					key,
					value,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					rK,
					rV,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, left, rLeft),
					rRight);
			}
		} else {
			if ((((left.$ === -1) && (!left.a)) && (left.d.$ === -1)) && (!left.d.a)) {
				var _v5 = left.a;
				var lK = left.b;
				var lV = left.c;
				var _v6 = left.d;
				var _v7 = _v6.a;
				var llK = _v6.b;
				var llV = _v6.c;
				var llLeft = _v6.d;
				var llRight = _v6.e;
				var lRight = left.e;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					0,
					lK,
					lV,
					A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, lRight, right));
			} else {
				return A5($elm$core$Dict$RBNode_elm_builtin, color, key, value, left, right);
			}
		}
	});
var $elm$core$Basics$compare = _Utils_compare;
var $elm$core$Dict$insertHelp = F3(
	function (key, value, dict) {
		if (dict.$ === -2) {
			return A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
		} else {
			var nColor = dict.a;
			var nKey = dict.b;
			var nValue = dict.c;
			var nLeft = dict.d;
			var nRight = dict.e;
			var _v1 = A2($elm$core$Basics$compare, key, nKey);
			switch (_v1) {
				case 0:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						A3($elm$core$Dict$insertHelp, key, value, nLeft),
						nRight);
				case 1:
					return A5($elm$core$Dict$RBNode_elm_builtin, nColor, nKey, value, nLeft, nRight);
				default:
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						nLeft,
						A3($elm$core$Dict$insertHelp, key, value, nRight));
			}
		}
	});
var $elm$core$Dict$insert = F3(
	function (key, value, dict) {
		var _v0 = A3($elm$core$Dict$insertHelp, key, value, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$fromList = function (assocs) {
	return A3(
		$elm$core$List$foldl,
		F2(
			function (_v0, dict) {
				var key = _v0.a;
				var value = _v0.b;
				return A3($elm$core$Dict$insert, key, value, dict);
			}),
		$elm$core$Dict$empty,
		assocs);
};
var $elm$json$Json$Decode$keyValuePairs = _Json_decodeKeyValuePairs;
var $elm$json$Json$Decode$dict = function (decoder) {
	return A2(
		$elm$json$Json$Decode$map,
		$elm$core$Dict$fromList,
		$elm$json$Json$Decode$keyValuePairs(decoder));
};
var $elm$json$Json$Decode$map4 = _Json_map4;
var $author$project$Types$Steps$ArticleInput$decodeNewArticle = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Types$Steps$ArticleInput$NewArticle,
	A2(
		$elm$json$Json$Decode$field,
		'selected',
		$elm$json$Json$Decode$maybe($author$project$Types$Steps$ArticleInput$decodeTemplate)),
	A2($elm$json$Json$Decode$field, 'amount', $elm$json$Json$Decode$int),
	A2(
		$elm$json$Json$Decode$field,
		'serialNumbers',
		$elm$json$Json$Decode$dict($author$project$Types$Steps$ArticleInput$decodeSerialNumber)),
	A2($elm$json$Json$Decode$field, 'counter', $elm$json$Json$Decode$int));
var $elm$json$Json$Decode$list = _Json_decodeList;
var $author$project$Types$Steps$ArticleInput$decode = $elm$json$Json$Decode$list($author$project$Types$Steps$ArticleInput$decodeNewArticle);
var $author$project$Types$Steps$ArticleInput$Config = F2(
	function (options, allowUnknown) {
		return {cT: allowUnknown, dV: options};
	});
var $author$project$Types$Steps$ArticleInput$decodeConfig = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Types$Steps$ArticleInput$Config,
	A2(
		$elm$json$Json$Decode$field,
		'options',
		$elm$json$Json$Decode$list($author$project$Types$Steps$ArticleInput$decodeTemplate)),
	A2($elm$json$Json$Decode$field, 'allowUnknown', $elm$json$Json$Decode$bool));
var $webbhuset$elm_json_decode$Json$Decode$Field$require = F3(
	function (fieldName, valueDecoder, continuation) {
		return A2(
			$elm$json$Json$Decode$andThen,
			continuation,
			A2($elm$json$Json$Decode$field, fieldName, valueDecoder));
	});
var $author$project$Types$Step$decodeArticleInput = function () {
	var articleInputDecoder = A3(
		$webbhuset$elm_json_decode$Json$Decode$Field$require,
		'config',
		$author$project$Types$Steps$ArticleInput$decodeConfig,
		function (config) {
			return A3(
				$webbhuset$elm_json_decode$Json$Decode$Field$attempt,
				'model',
				$author$project$Types$Steps$ArticleInput$decode,
				function (model) {
					return $elm$json$Json$Decode$succeed(
						A2($author$project$Types$Step$ArticleInput, config, model));
				});
		});
	return A2($elm$json$Json$Decode$field, 'articleInput', articleInputDecoder);
}();
var $author$project$Types$Step$ArticleInstallation = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$Steps$ArticleInstallation$NoSn = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$Steps$ArticleInstallation$Sn = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$Steps$ArticleInstallation$TempRma = F7(
	function (articleTemplateId, stationId, stepId, iteration, serialNumber, description, snCounter) {
		return {bq: articleTemplateId, fl: description, fV: iteration, eu: serialNumber, gS: snCounter, gU: stationId, gX: stepId};
	});
var $elm$json$Json$Decode$map7 = _Json_map7;
var $author$project$Types$Steps$ArticleInstallation$decodeTempRma = A8(
	$elm$json$Json$Decode$map7,
	$author$project$Types$Steps$ArticleInstallation$TempRma,
	A2($elm$json$Json$Decode$field, 'articleTemplateId', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'stationId', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'stepId', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'iteration', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'serialNumber', $author$project$Types$Steps$ArticleInput$decodeSerialNumber),
	A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'snCounter', $elm$json$Json$Decode$string));
var $author$project$Types$Steps$ArticleInstallation$TempRmaNoSn = F6(
	function (articleTemplateId, stationId, stepId, iteration, amount, description) {
		return {Q: amount, bq: articleTemplateId, fl: description, fV: iteration, gU: stationId, gX: stepId};
	});
var $elm$json$Json$Decode$map6 = _Json_map6;
var $author$project$Types$Steps$ArticleInstallation$decodeTempRmaNoSn = A7(
	$elm$json$Json$Decode$map6,
	$author$project$Types$Steps$ArticleInstallation$TempRmaNoSn,
	A2($elm$json$Json$Decode$field, 'articleTemplateId', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'stationId', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'stepId', $elm$json$Json$Decode$string),
	A2($elm$json$Json$Decode$field, 'iteration', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'amount', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string));
var $elm$json$Json$Decode$fail = _Json_fail;
var $author$project$Types$Steps$ArticleInstallation$decodeTempArticleId = A3(
	$webbhuset$elm_json_decode$Json$Decode$Field$attempt,
	'noSn',
	$author$project$Types$Steps$ArticleInstallation$decodeTempRmaNoSn,
	function (maybeNoSn) {
		return A3(
			$webbhuset$elm_json_decode$Json$Decode$Field$attempt,
			'sn',
			$author$project$Types$Steps$ArticleInstallation$decodeTempRma,
			function (maybeSn) {
				if (!maybeNoSn.$) {
					var noSn = maybeNoSn.a;
					return $elm$json$Json$Decode$succeed(
						$author$project$Types$Steps$ArticleInstallation$NoSn(noSn));
				} else {
					if (!maybeSn.$) {
						var sn = maybeSn.a;
						return $elm$json$Json$Decode$succeed(
							$author$project$Types$Steps$ArticleInstallation$Sn(sn));
					} else {
						return $elm$json$Json$Decode$fail('Could not decode a temporary article id');
					}
				}
			});
	});
var $toastal$either$Either$Left = function (a) {
	return {$: 0, a: a};
};
var $toastal$either$Either$Right = function (a) {
	return {$: 1, a: a};
};
var $toastal$either$Either$Decode$either = F2(
	function (a, b) {
		return $elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					A2($elm$json$Json$Decode$map, $toastal$either$Either$Right, b),
					A2($elm$json$Json$Decode$map, $toastal$either$Either$Left, a)
				]));
	});
var $author$project$Types$Steps$ArticleInstallation$decodeArticleInstallation = $elm$json$Json$Decode$maybe(
	A2(
		$toastal$either$Either$Decode$either,
		$elm$json$Json$Decode$list($elm$json$Json$Decode$string),
		$author$project$Types$Steps$ArticleInstallation$decodeTempArticleId));
var $author$project$Types$Step$decodeArticleInstallation = A2(
	$elm$json$Json$Decode$andThen,
	function (val) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Types$Step$ArticleInstallation(
				$elm$core$Maybe$Just(val)));
	},
	A2($elm$json$Json$Decode$field, 'articleInstallation', $author$project$Types$Steps$ArticleInstallation$decodeArticleInstallation));
var $author$project$Types$Step$ArticleRemoval = F2(
	function (a, b) {
		return {$: 9, a: a, b: b};
	});
var $author$project$Types$Step$decodeArticleRemoval = function () {
	var articleRemovalDecoder = A3(
		$webbhuset$elm_json_decode$Json$Decode$Field$require,
		'config',
		$author$project$Types$Steps$ArticleInput$decodeConfig,
		function (config) {
			return A3(
				$webbhuset$elm_json_decode$Json$Decode$Field$attempt,
				'model',
				$author$project$Types$Steps$ArticleInput$decode,
				function (model) {
					return $elm$json$Json$Decode$succeed(
						A2($author$project$Types$Step$ArticleRemoval, config, model));
				});
		});
	return A2($elm$json$Json$Decode$field, 'articleRemoval', articleRemovalDecoder);
}();
var $author$project$Types$Step$ArticleReturn = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$Step$decodeArticleReturn = A2(
	$elm$json$Json$Decode$andThen,
	function (val) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Types$Step$ArticleReturn(
				$elm$core$Maybe$Just(val)));
	},
	A2($elm$json$Json$Decode$field, 'articleReturn', $author$project$Types$Steps$ArticleInstallation$decodeArticleInstallation));
var $author$project$Types$Step$Photo = function (a) {
	return {$: 6, a: a};
};
var $author$project$Types$Steps$Photo$Model = F9(
	function (fileType, operationId, stationId, stepId, iteration, syncState, createdAt, image, imageTaken) {
		return {a4: createdAt, bB: fileType, dt: image, fE: imageTaken, fV: iteration, gw: operationId, gU: stationId, gX: stepId, gZ: syncState};
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom = $elm$json$Json$Decode$map2($elm$core$Basics$apR);
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded = A2($elm$core$Basics$composeR, $elm$json$Json$Decode$succeed, $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom);
var $elm$time$Time$Posix = $elm$core$Basics$identity;
var $elm$time$Time$millisToPosix = $elm$core$Basics$identity;
var $elm$json$Json$Decode$decodeValue = _Json_run;
var $elm$json$Json$Decode$value = _Json_decodeValue;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder = F3(
	function (pathDecoder, valDecoder, fallback) {
		var nullOr = function (decoder) {
			return $elm$json$Json$Decode$oneOf(
				_List_fromArray(
					[
						decoder,
						$elm$json$Json$Decode$null(fallback)
					]));
		};
		var handleResult = function (input) {
			var _v0 = A2($elm$json$Json$Decode$decodeValue, pathDecoder, input);
			if (!_v0.$) {
				var rawValue = _v0.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					nullOr(valDecoder),
					rawValue);
				if (!_v1.$) {
					var finalResult = _v1.a;
					return $elm$json$Json$Decode$succeed(finalResult);
				} else {
					var finalErr = _v1.a;
					return $elm$json$Json$Decode$fail(
						$elm$json$Json$Decode$errorToString(finalErr));
				}
			} else {
				return $elm$json$Json$Decode$succeed(fallback);
			}
		};
		return A2($elm$json$Json$Decode$andThen, handleResult, $elm$json$Json$Decode$value);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional = F4(
	function (key, valDecoder, fallback, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optionalDecoder,
				A2($elm$json$Json$Decode$field, key, $elm$json$Json$Decode$value),
				valDecoder,
				fallback),
			decoder);
	});
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required = F3(
	function (key, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$field, key, valDecoder),
			decoder);
	});
var $author$project$Types$Steps$Photo$decode = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'imageTaken',
	$elm$json$Json$Decode$bool,
	false,
	A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
		$elm$core$Maybe$Nothing,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'createdAt',
			A2(
				$elm$json$Json$Decode$andThen,
				function (t) {
					return $elm$json$Json$Decode$succeed(
						$elm$time$Time$millisToPosix(t));
				},
				$elm$json$Json$Decode$int),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'syncState',
				$author$project$Lib$Sync$decode,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'iteration',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'stepId',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'stationId',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'operationId',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'fileType',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Types$Steps$Photo$Model))))))))));
var $author$project$Types$Step$decodePhoto = A2(
	$elm$json$Json$Decode$andThen,
	function (val) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Types$Step$Photo(
				$elm$core$Maybe$Just(val)));
	},
	A2($elm$json$Json$Decode$field, 'photo', $author$project$Types$Steps$Photo$decode));
var $author$project$Types$Step$Signature = function (a) {
	return {$: 8, a: a};
};
var $author$project$Types$Steps$Signature$decode = $elm$json$Json$Decode$nullable($elm$json$Json$Decode$string);
var $author$project$Types$Step$decodeSignature = A2(
	$elm$json$Json$Decode$andThen,
	function (val) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Types$Step$Signature(
				$elm$core$Maybe$Just(val)));
	},
	A2($elm$json$Json$Decode$field, 'signature', $author$project$Types$Steps$Signature$decode));
var $author$project$Types$Step$DescriptionOnly = {$: 10};
var $author$project$Types$Step$Text = function (a) {
	return {$: 4, a: a};
};
var $author$project$Types$Step$Timestamp = function (a) {
	return {$: 3, a: a};
};
var $author$project$Types$Step$YesNo = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$Step$decodeStringToStepType = A2(
	$elm$json$Json$Decode$andThen,
	function (str) {
		switch (str) {
			case 'text':
				return $elm$json$Json$Decode$succeed(
					$author$project$Types$Step$Text($elm$core$Maybe$Nothing));
			case 'timestamp':
				return $elm$json$Json$Decode$succeed(
					$author$project$Types$Step$Timestamp($elm$core$Maybe$Nothing));
			case 'amount':
				return $elm$json$Json$Decode$succeed(
					$author$project$Types$Step$Amount($elm$core$Maybe$Nothing));
			case 'yesNo':
				return $elm$json$Json$Decode$succeed(
					$author$project$Types$Step$YesNo($elm$core$Maybe$Nothing));
			case 'articleInstallation':
				return $elm$json$Json$Decode$succeed(
					$author$project$Types$Step$ArticleInstallation($elm$core$Maybe$Nothing));
			case 'articleReturn':
				return $elm$json$Json$Decode$succeed(
					$author$project$Types$Step$ArticleReturn($elm$core$Maybe$Nothing));
			case 'photo':
				return $elm$json$Json$Decode$succeed(
					$author$project$Types$Step$Photo($elm$core$Maybe$Nothing));
			case 'articleInput':
				return $elm$json$Json$Decode$fail('Cannot decode articleInput without config!');
			case 'articleRemoval':
				return $elm$json$Json$Decode$fail('Cannot decode articleRemoval without config!');
			case 'signature':
				return $elm$json$Json$Decode$succeed(
					$author$project$Types$Step$Signature($elm$core$Maybe$Nothing));
			case 'descriptionOnly':
				return $elm$json$Json$Decode$succeed($author$project$Types$Step$DescriptionOnly);
			default:
				var stepType = str;
				return $elm$json$Json$Decode$fail('Unknown stepType ' + stepType);
		}
	},
	$elm$json$Json$Decode$string);
var $author$project$Types$Steps$Text$decode = $elm$json$Json$Decode$string;
var $author$project$Types$Step$decodeText = A2(
	$elm$json$Json$Decode$andThen,
	function (val) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Types$Step$Text(
				$elm$core$Maybe$Just(val)));
	},
	A2($elm$json$Json$Decode$field, 'text', $author$project$Types$Steps$Text$decode));
var $elm$core$Maybe$map = F2(
	function (f, maybe) {
		if (!maybe.$) {
			var value = maybe.a;
			return $elm$core$Maybe$Just(
				f(value));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $author$project$Types$Steps$Timestamp$decode = A2(
	$elm$json$Json$Decode$andThen,
	function (maybeTime) {
		return $elm$json$Json$Decode$succeed(
			A2($elm$core$Maybe$map, $elm$time$Time$millisToPosix, maybeTime));
	},
	$elm$json$Json$Decode$maybe($elm$json$Json$Decode$int));
var $author$project$Types$Step$decodeTimestamp = A2(
	$elm$json$Json$Decode$andThen,
	function (val) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Types$Step$Timestamp(
				$elm$core$Maybe$Just(val)));
	},
	A2($elm$json$Json$Decode$field, 'timestamp', $author$project$Types$Steps$Timestamp$decode));
var $author$project$Types$Steps$YesNo$decodeYesNo = $elm$json$Json$Decode$bool;
var $author$project$Types$Step$decodeYesNo = A2(
	$elm$json$Json$Decode$andThen,
	function (val) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Types$Step$YesNo(
				$elm$core$Maybe$Just(val)));
	},
	A2($elm$json$Json$Decode$field, 'yesNo', $author$project$Types$Steps$YesNo$decodeYesNo));
var $author$project$Types$Step$decodeStepType = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[$author$project$Types$Step$decodeStringToStepType, $author$project$Types$Step$decodeYesNo, $author$project$Types$Step$decodeArticleReturn, $author$project$Types$Step$decodeArticleInstallation, $author$project$Types$Step$decodeAmount, $author$project$Types$Step$decodeTimestamp, $author$project$Types$Step$decodeText, $author$project$Types$Step$decodePhoto, $author$project$Types$Step$decodeArticleInput, $author$project$Types$Step$decodeArticleRemoval, $author$project$Types$Step$decodeSignature]));
var $author$project$Types$Step$decodeCompareAlias = A4(
	$elm$json$Json$Decode$map3,
	$author$project$Types$Step$CompareAlias,
	A2($elm$json$Json$Decode$field, 'stepType', $author$project$Types$Step$decodeStepType),
	A2($elm$json$Json$Decode$field, 'stepId', $author$project$Types$Step$decodeStepId),
	A2($elm$json$Json$Decode$field, 'comparison', $author$project$Lib$Comparison$decodeComparison));
var $author$project$Types$Step$decodeCompare = A2(
	$elm$json$Json$Decode$andThen,
	function (compAlias) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Types$Step$Compare(compAlias));
	},
	A2($elm$json$Json$Decode$field, 'compare', $author$project$Types$Step$decodeCompareAlias));
var $author$project$Types$Step$Count = function (a) {
	return {$: 5, a: a};
};
var $author$project$Types$Step$CountAlias = F4(
	function (stepType, stepId, amount, operator) {
		return {Q: amount, cr: operator, gX: stepId, eF: stepType};
	});
var $author$project$Types$Step$decodeCountAlias = A5(
	$elm$json$Json$Decode$map4,
	$author$project$Types$Step$CountAlias,
	A2($elm$json$Json$Decode$field, 'stepType', $author$project$Types$Step$decodeStepType),
	$elm$json$Json$Decode$maybe(
		A2($elm$json$Json$Decode$field, 'stepId', $author$project$Types$Step$decodeStepId)),
	A2($elm$json$Json$Decode$field, 'amount', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'operator', $elm$json$Json$Decode$string));
var $author$project$Types$Step$decodeCount = A2(
	$elm$json$Json$Decode$andThen,
	function (compAlias) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Types$Step$Count(compAlias));
	},
	A2($elm$json$Json$Decode$field, 'count', $author$project$Types$Step$decodeCountAlias));
var $author$project$Types$Step$Diff = function (a) {
	return {$: 6, a: a};
};
var $author$project$Types$Step$DiffAlias = F5(
	function (stepType, firstStepId, secondStepId, amount, operator) {
		return {Q: amount, cd: firstStepId, cr: operator, cz: secondStepId, eF: stepType};
	});
var $elm$json$Json$Decode$map5 = _Json_map5;
var $author$project$Types$Step$decodeDiffAlias = A6(
	$elm$json$Json$Decode$map5,
	$author$project$Types$Step$DiffAlias,
	A2($elm$json$Json$Decode$field, 'stepType', $author$project$Types$Step$decodeStepType),
	A2($elm$json$Json$Decode$field, 'firstStepId', $author$project$Types$Step$decodeStepId),
	A2($elm$json$Json$Decode$field, 'secondStepId', $author$project$Types$Step$decodeStepId),
	A2($elm$json$Json$Decode$field, 'amount', $elm$json$Json$Decode$int),
	A2($elm$json$Json$Decode$field, 'operator', $elm$json$Json$Decode$string));
var $author$project$Types$Step$decodeDiff = A2(
	$elm$json$Json$Decode$andThen,
	function (diffAlias) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Types$Step$Diff(diffAlias));
	},
	A2($elm$json$Json$Decode$field, 'diff', $author$project$Types$Step$decodeDiffAlias));
var $author$project$Types$Step$Inactive = {$: 9};
var $author$project$Types$Step$decodeInactiveRule = A2(
	$elm$json$Json$Decode$andThen,
	function (_v0) {
		return $elm$json$Json$Decode$succeed($author$project$Types$Step$Inactive);
	},
	A2($elm$json$Json$Decode$field, 'inactive', $elm$json$Json$Decode$bool));
var $author$project$Types$Step$Present = function (a) {
	return {$: 4, a: a};
};
var $author$project$Types$Step$PresentAlias = F2(
	function (stepType, stepId) {
		return {gX: stepId, eF: stepType};
	});
var $author$project$Types$Step$decodePresentAlias = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Types$Step$PresentAlias,
	A2($elm$json$Json$Decode$field, 'stepType', $author$project$Types$Step$decodeStepType),
	A2($elm$json$Json$Decode$field, 'stepId', $author$project$Types$Step$decodeStepId));
var $author$project$Types$Step$decodePresent = A2(
	$elm$json$Json$Decode$andThen,
	function (compAlias) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Types$Step$Present(compAlias));
	},
	A2($elm$json$Json$Decode$field, 'present', $author$project$Types$Step$decodePresentAlias));
var $author$project$Types$Step$TextPattern = function (a) {
	return {$: 7, a: a};
};
var $author$project$Types$Step$PatternAlias = F2(
	function (stepId, pattern) {
		return {cw: pattern, gX: stepId};
	});
var $author$project$Types$Step$decodeTextPatternAlias = A3(
	$elm$json$Json$Decode$map2,
	$author$project$Types$Step$PatternAlias,
	A2($elm$json$Json$Decode$field, 'stepId', $author$project$Types$Step$decodeStepId),
	A2($elm$json$Json$Decode$field, 'pattern', $elm$json$Json$Decode$string));
var $author$project$Types$Step$decodeTextPattern = A2(
	$elm$json$Json$Decode$andThen,
	function (patternAlias) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Types$Step$TextPattern(patternAlias));
	},
	A2($elm$json$Json$Decode$field, 'textPattern', $author$project$Types$Step$decodeTextPatternAlias));
var $elm$json$Json$Decode$lazy = function (thunk) {
	return A2(
		$elm$json$Json$Decode$andThen,
		thunk,
		$elm$json$Json$Decode$succeed(0));
};
function $author$project$Types$Step$cyclic$decodeRules() {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$author$project$Types$Step$cyclic$decodeAndRule(),
				$author$project$Types$Step$cyclic$decodeOrRule(),
				$author$project$Types$Step$cyclic$decodeNotRule(),
				$author$project$Types$Step$decodeActiveRule,
				$author$project$Types$Step$decodeInactiveRule,
				$author$project$Types$Step$decodePresent,
				$author$project$Types$Step$decodeCompare,
				$author$project$Types$Step$decodeCount,
				$author$project$Types$Step$decodeDiff,
				$author$project$Types$Step$decodeTextPattern
			]));
}
function $author$project$Types$Step$cyclic$decodeAndRule() {
	return A2(
		$elm$json$Json$Decode$field,
		'and',
		A2(
			$elm$json$Json$Decode$andThen,
			function (val) {
				return $elm$json$Json$Decode$succeed(
					$author$project$Types$Step$And(val));
			},
			$elm$json$Json$Decode$list(
				$elm$json$Json$Decode$lazy(
					function (_v2) {
						return $author$project$Types$Step$cyclic$decodeRules();
					}))));
}
function $author$project$Types$Step$cyclic$decodeNotRule() {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (val) {
			return $elm$json$Json$Decode$succeed(
				$author$project$Types$Step$Not(val));
		},
		A2(
			$elm$json$Json$Decode$field,
			'not',
			$elm$json$Json$Decode$lazy(
				function (_v1) {
					return $author$project$Types$Step$cyclic$decodeRules();
				})));
}
function $author$project$Types$Step$cyclic$decodeOrRule() {
	return A2(
		$elm$json$Json$Decode$field,
		'or',
		A2(
			$elm$json$Json$Decode$andThen,
			function (val) {
				return $elm$json$Json$Decode$succeed(
					$author$project$Types$Step$Or(val));
			},
			$elm$json$Json$Decode$list(
				$elm$json$Json$Decode$lazy(
					function (_v0) {
						return $author$project$Types$Step$cyclic$decodeRules();
					}))));
}
var $author$project$Types$Step$decodeRules = $author$project$Types$Step$cyclic$decodeRules();
$author$project$Types$Step$cyclic$decodeRules = function () {
	return $author$project$Types$Step$decodeRules;
};
var $author$project$Types$Step$decodeAndRule = $author$project$Types$Step$cyclic$decodeAndRule();
$author$project$Types$Step$cyclic$decodeAndRule = function () {
	return $author$project$Types$Step$decodeAndRule;
};
var $author$project$Types$Step$decodeNotRule = $author$project$Types$Step$cyclic$decodeNotRule();
$author$project$Types$Step$cyclic$decodeNotRule = function () {
	return $author$project$Types$Step$decodeNotRule;
};
var $author$project$Types$Step$decodeOrRule = $author$project$Types$Step$cyclic$decodeOrRule();
$author$project$Types$Step$cyclic$decodeOrRule = function () {
	return $author$project$Types$Step$decodeOrRule;
};
var $author$project$Types$Station$And = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$Station$Not = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$Station$Or = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$Station$Active = {$: 7};
var $author$project$Types$Station$decodeActiveRule = A2(
	$elm$json$Json$Decode$andThen,
	function (_v0) {
		return $elm$json$Json$Decode$succeed($author$project$Types$Station$Active);
	},
	A2($elm$json$Json$Decode$field, 'Active', $elm$json$Json$Decode$bool));
var $author$project$Types$Station$ApplyRules = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$json$Json$Decode$index = _Json_decodeIndex;
var $author$project$Types$Station$decodeAsTuple2 = F2(
	function (a, b) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (aVal) {
				return A2(
					$elm$json$Json$Decode$andThen,
					function (bVal) {
						return $elm$json$Json$Decode$succeed(
							_Utils_Tuple2(aVal, bVal));
					},
					A2($elm$json$Json$Decode$index, 1, b));
			},
			A2($elm$json$Json$Decode$index, 0, a));
	});
var $author$project$Types$Station$decodeApplyRules = A2(
	$elm$json$Json$Decode$andThen,
	function (_v0) {
		var stationId = _v0.a;
		var rules = _v0.b;
		return $elm$json$Json$Decode$succeed(
			A2($author$project$Types$Station$ApplyRules, stationId, rules));
	},
	A2(
		$elm$json$Json$Decode$field,
		'ApplyRules',
		A2($author$project$Types$Station$decodeAsTuple2, $elm$json$Json$Decode$string, $author$project$Types$Step$decodeRules)));
var $author$project$Types$Station$Completed = function (a) {
	return {$: 3, a: a};
};
var $author$project$Types$Station$decodeCompleted = A2(
	$elm$json$Json$Decode$andThen,
	function (targetId) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Types$Station$Completed(targetId));
	},
	A2($elm$json$Json$Decode$field, 'Completed', $elm$json$Json$Decode$string));
var $author$project$Types$Station$CountBelow = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $author$project$Types$Station$decodeCountBelow = A2(
	$elm$json$Json$Decode$andThen,
	function (_v0) {
		var stationId = _v0.a;
		var either = _v0.b;
		return $elm$json$Json$Decode$succeed(
			A2($author$project$Types$Station$CountBelow, stationId, either));
	},
	A2(
		$elm$json$Json$Decode$field,
		'CountBelow',
		A2(
			$author$project$Types$Station$decodeAsTuple2,
			$elm$json$Json$Decode$string,
			A2(
				$toastal$either$Either$Decode$either,
				A2($author$project$Types$Station$decodeAsTuple2, $elm$json$Json$Decode$string, $elm$json$Json$Decode$string),
				$elm$json$Json$Decode$int))));
var $author$project$Types$Station$Inactive = {$: 6};
var $author$project$Types$Station$decodeInactiveRule = A2(
	$elm$json$Json$Decode$andThen,
	function (_v0) {
		return $elm$json$Json$Decode$succeed($author$project$Types$Station$Inactive);
	},
	A2($elm$json$Json$Decode$field, 'Inactive', $elm$json$Json$Decode$bool));
function $author$project$Types$Station$cyclic$decodeStationRules() {
	return $elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$author$project$Types$Station$cyclic$decodeAndRule(),
				$author$project$Types$Station$cyclic$decodeOrRule(),
				$author$project$Types$Station$cyclic$decodeNotRule(),
				$author$project$Types$Station$decodeActiveRule,
				$author$project$Types$Station$decodeInactiveRule,
				$author$project$Types$Station$decodeCompleted,
				$author$project$Types$Station$decodeApplyRules,
				$author$project$Types$Station$decodeCountBelow
			]));
}
function $author$project$Types$Station$cyclic$decodeAndRule() {
	return A2(
		$elm$json$Json$Decode$field,
		'And',
		A2(
			$elm$json$Json$Decode$andThen,
			function (val) {
				return $elm$json$Json$Decode$succeed(
					$author$project$Types$Station$And(val));
			},
			$elm$json$Json$Decode$list(
				$elm$json$Json$Decode$lazy(
					function (_v2) {
						return $author$project$Types$Station$cyclic$decodeStationRules();
					}))));
}
function $author$project$Types$Station$cyclic$decodeNotRule() {
	return A2(
		$elm$json$Json$Decode$andThen,
		function (val) {
			return $elm$json$Json$Decode$succeed(
				$author$project$Types$Station$Not(val));
		},
		A2(
			$elm$json$Json$Decode$field,
			'Not',
			$elm$json$Json$Decode$lazy(
				function (_v1) {
					return $author$project$Types$Station$cyclic$decodeStationRules();
				})));
}
function $author$project$Types$Station$cyclic$decodeOrRule() {
	return A2(
		$elm$json$Json$Decode$field,
		'Or',
		A2(
			$elm$json$Json$Decode$andThen,
			function (val) {
				return $elm$json$Json$Decode$succeed(
					$author$project$Types$Station$Or(val));
			},
			$elm$json$Json$Decode$list(
				$elm$json$Json$Decode$lazy(
					function (_v0) {
						return $author$project$Types$Station$cyclic$decodeStationRules();
					}))));
}
var $author$project$Types$Station$decodeStationRules = $author$project$Types$Station$cyclic$decodeStationRules();
$author$project$Types$Station$cyclic$decodeStationRules = function () {
	return $author$project$Types$Station$decodeStationRules;
};
var $author$project$Types$Station$decodeAndRule = $author$project$Types$Station$cyclic$decodeAndRule();
$author$project$Types$Station$cyclic$decodeAndRule = function () {
	return $author$project$Types$Station$decodeAndRule;
};
var $author$project$Types$Station$decodeNotRule = $author$project$Types$Station$cyclic$decodeNotRule();
$author$project$Types$Station$cyclic$decodeNotRule = function () {
	return $author$project$Types$Station$decodeNotRule;
};
var $author$project$Types$Station$decodeOrRule = $author$project$Types$Station$cyclic$decodeOrRule();
$author$project$Types$Station$cyclic$decodeOrRule = function () {
	return $author$project$Types$Station$decodeOrRule;
};
var $author$project$Types$Step$Step = F6(
	function (id, name, stepType, rulesVisibility, rulesInteractivity, description) {
		return {fl: description, bD: id, dP: name, eh: rulesInteractivity, ej: rulesVisibility, eF: stepType};
	});
var $author$project$Types$Step$Danger = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$Step$Info = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$Step$None = {$: 3};
var $author$project$Types$Step$StepDescriptionTransport = F2(
	function (type_, description) {
		return {fl: description, eS: type_};
	});
var $author$project$Types$Step$Warning = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$Step$decodeStepDescription = A2(
	$elm$json$Json$Decode$andThen,
	function (transport) {
		var _v0 = transport.eS;
		switch (_v0) {
			case 'warning':
				return $elm$json$Json$Decode$succeed(
					$author$project$Types$Step$Warning(transport.fl));
			case 'danger':
				return $elm$json$Json$Decode$succeed(
					$author$project$Types$Step$Danger(transport.fl));
			case 'info':
				return $elm$json$Json$Decode$succeed(
					$author$project$Types$Step$Info(transport.fl));
			case 'none':
				return $elm$json$Json$Decode$succeed($author$project$Types$Step$None);
			default:
				var t = _v0;
				return $elm$json$Json$Decode$fail('decodeStepDescription failed because no matching type was found: ' + t);
		}
	},
	A3(
		$elm$json$Json$Decode$map2,
		$author$project$Types$Step$StepDescriptionTransport,
		A2($elm$json$Json$Decode$field, 'type', $elm$json$Json$Decode$string),
		A2($elm$json$Json$Decode$field, 'description', $elm$json$Json$Decode$string)));
var $author$project$Types$Step$decodeStep = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'description',
	$author$project$Types$Step$decodeStepDescription,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'rulesInteractivity',
		$author$project$Types$Step$decodeRules,
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'rulesVisibility',
			$author$project$Types$Step$decodeRules,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'stepType',
				$author$project$Types$Step$decodeStepType,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'name',
					$elm$json$Json$Decode$string,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'id',
						$elm$json$Json$Decode$string,
						$elm$json$Json$Decode$succeed($author$project$Types$Step$Step)))))));
var $author$project$Types$Step$StepDb = function (yesNo) {
	return function (articleInstallation) {
		return function (articleReturn) {
			return function (timestamp) {
				return function (text) {
					return function (amount) {
						return function (photo) {
							return function (articleInput) {
								return function (articleRemoval) {
									return function (signature) {
										return {Q: amount, R: articleInput, ag: articleInstallation, ar: articleRemoval, as: articleReturn, P: photo, az: signature, V: text, W: timestamp, X: yesNo};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Types$Step$decodeStepDb = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'signature',
	$elm$json$Json$Decode$dict($author$project$Types$Steps$Signature$decode),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'articleRemoval',
		$elm$json$Json$Decode$dict($author$project$Types$Steps$ArticleInput$decode),
		$elm$core$Dict$empty,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'articleInput',
			$elm$json$Json$Decode$dict($author$project$Types$Steps$ArticleInput$decode),
			$elm$core$Dict$empty,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'photo',
				$elm$json$Json$Decode$dict($author$project$Types$Steps$Photo$decode),
				$elm$core$Dict$empty,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'amount',
					$elm$json$Json$Decode$dict($author$project$Types$Steps$Amount$decode),
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'text',
						$elm$json$Json$Decode$dict($author$project$Types$Steps$Text$decode),
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'timestamp',
							$elm$json$Json$Decode$dict($author$project$Types$Steps$Timestamp$decode),
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'articleReturn',
								$elm$json$Json$Decode$dict($author$project$Types$Steps$ArticleInstallation$decodeArticleInstallation),
								$elm$core$Dict$empty,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'articleInstallation',
									$elm$json$Json$Decode$dict($author$project$Types$Steps$ArticleInstallation$decodeArticleInstallation),
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'yesNo',
										$elm$json$Json$Decode$dict($author$project$Types$Steps$YesNo$decodeYesNo),
										$elm$json$Json$Decode$succeed($author$project$Types$Step$StepDb)))))))))));
var $author$project$Types$Station$decodeStation = A2(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
	$elm$core$Maybe$Nothing,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'iterations',
		$elm$json$Json$Decode$list($elm$json$Json$Decode$int),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'counter',
			$elm$json$Json$Decode$int,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'rulesRepeat',
				$author$project$Types$Station$decodeStationRules,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'rulesVisible',
					$author$project$Types$Station$decodeStationRules,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'rulesInteractive',
						$author$project$Types$Station$decodeStationRules,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'finished',
							$author$project$Types$Step$decodeRules,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'aborted',
								$author$project$Types$Step$decodeRules,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'inline',
									$elm$json$Json$Decode$bool,
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
										'stepDatabase',
										$author$project$Types$Step$decodeStepDb,
										A2(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
											_List_Nil,
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'stepOrder',
												$elm$json$Json$Decode$list($author$project$Types$Step$decodeStep),
												A4(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
													'title',
													$elm$json$Json$Decode$maybe($elm$json$Json$Decode$string),
													$elm$core$Maybe$Nothing,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'description',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'name',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'id',
																$elm$json$Json$Decode$string,
																$elm$json$Json$Decode$succeed($author$project$Types$Station$Station)))))))))))))))));
var $author$project$Types$Station$decode = A3(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
	'stations',
	$elm$json$Json$Decode$list($author$project$Types$Station$decodeStation),
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'operationClosed',
		$elm$json$Json$Decode$bool,
		false,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'syncState',
			$author$project$Lib$Sync$decode,
			$author$project$Lib$Sync$Server,
			$elm$json$Json$Decode$succeed($author$project$Types$Station$StationSyncWrapper))));
var $webbhuset$elm_json_decode$Json$Decode$Field$attemptAt = F3(
	function (path, valueDecoder, continuation) {
		return A2(
			$elm$json$Json$Decode$andThen,
			continuation,
			$elm$json$Json$Decode$maybe(
				A2($elm$json$Json$Decode$at, path, valueDecoder)));
	});
var $author$project$Types$Operation$nothingForString = A2(
	$elm$json$Json$Decode$andThen,
	function (_v0) {
		return $elm$json$Json$Decode$succeed($elm$core$Maybe$Nothing);
	},
	$elm$json$Json$Decode$string);
var $author$project$Types$Operation$validForInt = A2(
	$elm$json$Json$Decode$andThen,
	function (num) {
		return $elm$json$Json$Decode$succeed(
			$elm$core$Maybe$Just(num));
	},
	$elm$json$Json$Decode$int);
var $author$project$Types$Operation$badInt = $elm$json$Json$Decode$oneOf(
	_List_fromArray(
		[$author$project$Types$Operation$validForInt, $author$project$Types$Operation$nothingForString]));
var $author$project$Types$Operation$Part = F5(
	function (rma, description, oldSN, newSN, syncState) {
		return {fl: description, gb: newSN, cp: oldSN, ef: rma, gZ: syncState};
	});
var $elm$core$Basics$composeL = F3(
	function (g, f, x) {
		return g(
			f(x));
	});
var $author$project$Lib$Decode$Helper$decodeToMaybe = function (decoder) {
	return A2(
		$elm$json$Json$Decode$andThen,
		A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $elm$core$Maybe$Just),
		decoder);
};
var $author$project$Types$Operation$decodePart = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'syncState',
	$author$project$Lib$Sync$decode,
	$author$project$Lib$Sync$Server,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'newSN',
		$author$project$Lib$Decode$Helper$decodeToMaybe($elm$json$Json$Decode$string),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'oldSN',
			$author$project$Lib$Decode$Helper$decodeToMaybe($elm$json$Json$Decode$string),
			$elm$core$Maybe$Nothing,
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'description',
				$elm$json$Json$Decode$string,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'rma',
					$elm$json$Json$Decode$string,
					$elm$json$Json$Decode$succeed($author$project$Types$Operation$Part))))));
var $author$project$Types$Operation$initUiState = {dH: '', dI: '', dJ: '', dK: '', dT: $elm$core$Maybe$Nothing, eC: ''};
var $author$project$Types$Operation$decodeOperation = A3(
	$webbhuset$elm_json_decode$Json$Decode$Field$require,
	'id',
	$elm$json$Json$Decode$int,
	function (id) {
		return A3(
			$webbhuset$elm_json_decode$Json$Decode$Field$require,
			'projectId',
			$elm$json$Json$Decode$int,
			function (projectId) {
				return A3(
					$webbhuset$elm_json_decode$Json$Decode$Field$attempt,
					'binId',
					$elm$json$Json$Decode$int,
					function (maybeBinId) {
						return A3(
							$webbhuset$elm_json_decode$Json$Decode$Field$attempt,
							'warehouseId',
							$author$project$Types$Operation$badInt,
							function (maybeWarehouseId) {
								return A3(
									$webbhuset$elm_json_decode$Json$Decode$Field$attemptAt,
									_List_fromArray(
										['report', 'parts']),
									$elm$json$Json$Decode$list($author$project$Types$Operation$decodePart),
									function (maybeParts) {
										return A3(
											$webbhuset$elm_json_decode$Json$Decode$Field$attempt,
											'parts',
											$elm$json$Json$Decode$list($author$project$Types$Operation$decodePart),
											function (maybePartsFromInternal) {
												return A3(
													$webbhuset$elm_json_decode$Json$Decode$Field$attempt,
													'reportClosed',
													$elm$json$Json$Decode$bool,
													function (maybeReportClosed) {
														return $elm$json$Json$Decode$succeed(
															{
																e5: maybeBinId,
																bD: id,
																cv: function () {
																	if (!maybeParts.$) {
																		var parts = maybeParts.a;
																		return parts;
																	} else {
																		if (!maybePartsFromInternal.$) {
																			var parts_ = maybePartsFromInternal.a;
																			return parts_;
																		} else {
																			return _List_Nil;
																		}
																	}
																}(),
																gB: projectId,
																cy: A2($elm$core$Maybe$withDefault, false, maybeReportClosed),
																bj: $author$project$Types$Operation$initUiState,
																he: function () {
																	if (!maybeWarehouseId.$) {
																		var warehouseId = maybeWarehouseId.a;
																		return warehouseId;
																	} else {
																		return $elm$core$Maybe$Nothing;
																	}
																}()
															});
													});
											});
									});
							});
					});
			});
	});
var $author$project$Types$Queue$QueueDeprecated = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$Queue$decodeQueueDeprecated = A3(
	$webbhuset$elm_json_decode$Json$Decode$Field$require,
	'deprecated',
	$elm$json$Json$Decode$string,
	function (deprecated) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Types$Queue$QueueDeprecated(deprecated));
	});
var $author$project$Types$Queue$QueuePhoto = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$Queue$decodeQueuePhoto = A3(
	$webbhuset$elm_json_decode$Json$Decode$Field$require,
	'ref',
	$author$project$Types$Steps$Photo$decode,
	function (ref) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Types$Queue$QueuePhoto(ref));
	});
var $author$project$Types$Queue$QueueStation = function (a) {
	return {$: 0, a: a};
};
var $author$project$Types$Queue$decodeQueueStation = A3(
	$webbhuset$elm_json_decode$Json$Decode$Field$require,
	'operationId',
	$elm$json$Json$Decode$string,
	function (operationId) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Types$Queue$QueueStation(operationId));
	});
var $author$project$Types$Queue$failDecodeQueueReference = function (ref) {
	return $elm$json$Json$Decode$fail('decodeQueueReference failed while decoding an unknown reference: ' + ref);
};
var $author$project$Types$Queue$decodeQueueReference = A3(
	$webbhuset$elm_json_decode$Json$Decode$Field$require,
	'msg',
	$elm$json$Json$Decode$string,
	function (msg) {
		switch (msg) {
			case 'QueueArticle':
				return $elm$json$Json$Decode$succeed(
					$author$project$Types$Queue$QueueDeprecated(msg));
			case 'QueueParts':
				return $elm$json$Json$Decode$succeed(
					$author$project$Types$Queue$QueueDeprecated(msg));
			case 'QueueDeprecated':
				return $author$project$Types$Queue$decodeQueueDeprecated;
			case 'QueueStation':
				return $author$project$Types$Queue$decodeQueueStation;
			case 'QueuePhoto':
				return $author$project$Types$Queue$decodeQueuePhoto;
			default:
				var unknown = msg;
				return $author$project$Types$Queue$failDecodeQueueReference(unknown);
		}
	});
var $author$project$Types$Warehouse$Article = function (id) {
	return function (description) {
		return function (productCategory) {
			return function (vendor) {
				return function (sn) {
					return function (badPart) {
						return function (status) {
							return function (reportStatus) {
								return function (materialId) {
									return function (templateId) {
										return function (installationSite) {
											return function (problemDescription) {
												return function (swapPart) {
													return function (snBadPart) {
														return function (takenIntoCustody) {
															return function (syncState) {
																return function (operationId) {
																	return function (reqType) {
																		return {cX: badPart, fl: description, bD: id, dz: installationSite, fZ: materialId, gw: operationId, d_: problemDescription, d1: productCategory, d9: reportStatus, ea: reqType, ex: sn, ey: snBadPart, eD: status, eK: swapPart, gZ: syncState, eM: takenIntoCustody, g1: templateId, eT: vendor};
																	};
																};
															};
														};
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Types$Warehouse$MReplacement = 0;
var $author$project$Types$Warehouse$MUsage = 1;
var $author$project$Types$Warehouse$materialRequestTypeFromString = function (maybeReqType) {
	switch (maybeReqType) {
		case 'MReplacement':
			return $elm$core$Maybe$Just(0);
		case 'MUsage':
			return $elm$core$Maybe$Just(1);
		default:
			return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Types$Warehouse$decodeMaterialRequestType = A2(
	$elm$json$Json$Decode$andThen,
	function (maybeReqType) {
		return $elm$json$Json$Decode$succeed(
			$author$project$Types$Warehouse$materialRequestTypeFromString(maybeReqType));
	},
	$elm$json$Json$Decode$string);
var $author$project$Types$Warehouse$decodeArticle = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'reqType',
	$author$project$Types$Warehouse$decodeMaterialRequestType,
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'operationId',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
		$elm$core$Maybe$Nothing,
		A4(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
			'syncState',
			$author$project$Lib$Sync$decode,
			$author$project$Lib$Sync$Server,
			A4(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
				'takenIntoCustody',
				$elm$json$Json$Decode$bool,
				false,
				A4(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
					'snBadPart',
					$elm$json$Json$Decode$string,
					'',
					A4(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
						'swapPart',
						$elm$json$Json$Decode$bool,
						false,
						A4(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
							'problemDescription',
							$elm$json$Json$Decode$string,
							'',
							A4(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
								'installationSite',
								$elm$json$Json$Decode$string,
								'',
								A4(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
									'templateId',
									$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
									$elm$core$Maybe$Nothing,
									A4(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
										'materialId',
										$elm$json$Json$Decode$nullable($elm$json$Json$Decode$int),
										$elm$core$Maybe$Nothing,
										A4(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
											'reportStatus',
											$elm$json$Json$Decode$string,
											'',
											A4(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
												'status',
												$elm$json$Json$Decode$string,
												'',
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'badPart',
													$elm$json$Json$Decode$bool,
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'sn',
														$elm$json$Json$Decode$string,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'vendor',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'productCategory',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'description',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'id',
																		$elm$json$Json$Decode$int,
																		$elm$json$Json$Decode$succeed($author$project$Types$Warehouse$Article)))))))))))))))))));
var $author$project$Types$Warehouse$decodeArticleFromWarehouse = function (operationId) {
	return A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
		$elm$core$Maybe$Nothing,
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
			operationId,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
				$author$project$Lib$Sync$Server,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
					true,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
						'',
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
							false,
							A2(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
								'',
								A2(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
									'',
									A2(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
										$elm$core$Maybe$Nothing,
										A2(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
											$elm$core$Maybe$Nothing,
											A2(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
												'',
												A2(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
													'',
													A3(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
														'badPart',
														$elm$json$Json$Decode$bool,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'sn',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																'vendor',
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																	'productCategory',
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																		'description',
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'id',
																			$elm$json$Json$Decode$int,
																			$elm$json$Json$Decode$succeed($author$project$Types$Warehouse$Article)))))))))))))))))));
};
var $author$project$Types$Warehouse$decodeWarehouseInModel = $elm$json$Json$Decode$list(
	$elm$json$Json$Decode$oneOf(
		_List_fromArray(
			[
				$author$project$Types$Warehouse$decodeArticle,
				$author$project$Types$Warehouse$decodeArticleFromWarehouse($elm$core$Maybe$Nothing)
			])));
var $author$project$Ui$Router$NotFound = {$: 1};
var $elm$url$Url$Parser$State = F5(
	function (visited, unvisited, params, frag, value) {
		return {au: frag, ax: params, ap: unvisited, cO: value, aD: visited};
	});
var $elm$url$Url$Parser$getFirstMatch = function (states) {
	getFirstMatch:
	while (true) {
		if (!states.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var state = states.a;
			var rest = states.b;
			var _v1 = state.ap;
			if (!_v1.b) {
				return $elm$core$Maybe$Just(state.cO);
			} else {
				if ((_v1.a === '') && (!_v1.b.b)) {
					return $elm$core$Maybe$Just(state.cO);
				} else {
					var $temp$states = rest;
					states = $temp$states;
					continue getFirstMatch;
				}
			}
		}
	}
};
var $elm$url$Url$Parser$removeFinalEmpty = function (segments) {
	if (!segments.b) {
		return _List_Nil;
	} else {
		if ((segments.a === '') && (!segments.b.b)) {
			return _List_Nil;
		} else {
			var segment = segments.a;
			var rest = segments.b;
			return A2(
				$elm$core$List$cons,
				segment,
				$elm$url$Url$Parser$removeFinalEmpty(rest));
		}
	}
};
var $elm$url$Url$Parser$preparePath = function (path) {
	var _v0 = A2($elm$core$String$split, '/', path);
	if (_v0.b && (_v0.a === '')) {
		var segments = _v0.b;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	} else {
		var segments = _v0;
		return $elm$url$Url$Parser$removeFinalEmpty(segments);
	}
};
var $elm$url$Url$Parser$addToParametersHelp = F2(
	function (value, maybeList) {
		if (maybeList.$ === 1) {
			return $elm$core$Maybe$Just(
				_List_fromArray(
					[value]));
		} else {
			var list = maybeList.a;
			return $elm$core$Maybe$Just(
				A2($elm$core$List$cons, value, list));
		}
	});
var $elm$url$Url$percentDecode = _Url_percentDecode;
var $elm$core$Dict$get = F2(
	function (targetKey, dict) {
		get:
		while (true) {
			if (dict.$ === -2) {
				return $elm$core$Maybe$Nothing;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var _v1 = A2($elm$core$Basics$compare, targetKey, key);
				switch (_v1) {
					case 0:
						var $temp$targetKey = targetKey,
							$temp$dict = left;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
					case 1:
						return $elm$core$Maybe$Just(value);
					default:
						var $temp$targetKey = targetKey,
							$temp$dict = right;
						targetKey = $temp$targetKey;
						dict = $temp$dict;
						continue get;
				}
			}
		}
	});
var $elm$core$Dict$getMin = function (dict) {
	getMin:
	while (true) {
		if ((dict.$ === -1) && (dict.d.$ === -1)) {
			var left = dict.d;
			var $temp$dict = left;
			dict = $temp$dict;
			continue getMin;
		} else {
			return dict;
		}
	}
};
var $elm$core$Dict$moveRedLeft = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.e.d.$ === -1) && (!dict.e.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var lLeft = _v1.d;
			var lRight = _v1.e;
			var _v2 = dict.e;
			var rClr = _v2.a;
			var rK = _v2.b;
			var rV = _v2.c;
			var rLeft = _v2.d;
			var _v3 = rLeft.a;
			var rlK = rLeft.b;
			var rlV = rLeft.c;
			var rlL = rLeft.d;
			var rlR = rLeft.e;
			var rRight = _v2.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				rlK,
				rlV,
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					rlL),
				A5($elm$core$Dict$RBNode_elm_builtin, 1, rK, rV, rlR, rRight));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v4 = dict.d;
			var lClr = _v4.a;
			var lK = _v4.b;
			var lV = _v4.c;
			var lLeft = _v4.d;
			var lRight = _v4.e;
			var _v5 = dict.e;
			var rClr = _v5.a;
			var rK = _v5.b;
			var rV = _v5.c;
			var rLeft = _v5.d;
			var rRight = _v5.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$moveRedRight = function (dict) {
	if (((dict.$ === -1) && (dict.d.$ === -1)) && (dict.e.$ === -1)) {
		if ((dict.d.d.$ === -1) && (!dict.d.d.a)) {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v1 = dict.d;
			var lClr = _v1.a;
			var lK = _v1.b;
			var lV = _v1.c;
			var _v2 = _v1.d;
			var _v3 = _v2.a;
			var llK = _v2.b;
			var llV = _v2.c;
			var llLeft = _v2.d;
			var llRight = _v2.e;
			var lRight = _v1.e;
			var _v4 = dict.e;
			var rClr = _v4.a;
			var rK = _v4.b;
			var rV = _v4.c;
			var rLeft = _v4.d;
			var rRight = _v4.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				0,
				lK,
				lV,
				A5($elm$core$Dict$RBNode_elm_builtin, 1, llK, llV, llLeft, llRight),
				A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					lRight,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight)));
		} else {
			var clr = dict.a;
			var k = dict.b;
			var v = dict.c;
			var _v5 = dict.d;
			var lClr = _v5.a;
			var lK = _v5.b;
			var lV = _v5.c;
			var lLeft = _v5.d;
			var lRight = _v5.e;
			var _v6 = dict.e;
			var rClr = _v6.a;
			var rK = _v6.b;
			var rV = _v6.c;
			var rLeft = _v6.d;
			var rRight = _v6.e;
			if (clr === 1) {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			} else {
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					1,
					k,
					v,
					A5($elm$core$Dict$RBNode_elm_builtin, 0, lK, lV, lLeft, lRight),
					A5($elm$core$Dict$RBNode_elm_builtin, 0, rK, rV, rLeft, rRight));
			}
		}
	} else {
		return dict;
	}
};
var $elm$core$Dict$removeHelpPrepEQGT = F7(
	function (targetKey, dict, color, key, value, left, right) {
		if ((left.$ === -1) && (!left.a)) {
			var _v1 = left.a;
			var lK = left.b;
			var lV = left.c;
			var lLeft = left.d;
			var lRight = left.e;
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				lK,
				lV,
				lLeft,
				A5($elm$core$Dict$RBNode_elm_builtin, 0, key, value, lRight, right));
		} else {
			_v2$2:
			while (true) {
				if ((right.$ === -1) && (right.a === 1)) {
					if (right.d.$ === -1) {
						if (right.d.a === 1) {
							var _v3 = right.a;
							var _v4 = right.d;
							var _v5 = _v4.a;
							return $elm$core$Dict$moveRedRight(dict);
						} else {
							break _v2$2;
						}
					} else {
						var _v6 = right.a;
						var _v7 = right.d;
						return $elm$core$Dict$moveRedRight(dict);
					}
				} else {
					break _v2$2;
				}
			}
			return dict;
		}
	});
var $elm$core$Dict$removeMin = function (dict) {
	if ((dict.$ === -1) && (dict.d.$ === -1)) {
		var color = dict.a;
		var key = dict.b;
		var value = dict.c;
		var left = dict.d;
		var lColor = left.a;
		var lLeft = left.d;
		var right = dict.e;
		if (lColor === 1) {
			if ((lLeft.$ === -1) && (!lLeft.a)) {
				var _v3 = lLeft.a;
				return A5(
					$elm$core$Dict$RBNode_elm_builtin,
					color,
					key,
					value,
					$elm$core$Dict$removeMin(left),
					right);
			} else {
				var _v4 = $elm$core$Dict$moveRedLeft(dict);
				if (_v4.$ === -1) {
					var nColor = _v4.a;
					var nKey = _v4.b;
					var nValue = _v4.c;
					var nLeft = _v4.d;
					var nRight = _v4.e;
					return A5(
						$elm$core$Dict$balance,
						nColor,
						nKey,
						nValue,
						$elm$core$Dict$removeMin(nLeft),
						nRight);
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			}
		} else {
			return A5(
				$elm$core$Dict$RBNode_elm_builtin,
				color,
				key,
				value,
				$elm$core$Dict$removeMin(left),
				right);
		}
	} else {
		return $elm$core$Dict$RBEmpty_elm_builtin;
	}
};
var $elm$core$Dict$removeHelp = F2(
	function (targetKey, dict) {
		if (dict.$ === -2) {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		} else {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_cmp(targetKey, key) < 0) {
				if ((left.$ === -1) && (left.a === 1)) {
					var _v4 = left.a;
					var lLeft = left.d;
					if ((lLeft.$ === -1) && (!lLeft.a)) {
						var _v6 = lLeft.a;
						return A5(
							$elm$core$Dict$RBNode_elm_builtin,
							color,
							key,
							value,
							A2($elm$core$Dict$removeHelp, targetKey, left),
							right);
					} else {
						var _v7 = $elm$core$Dict$moveRedLeft(dict);
						if (_v7.$ === -1) {
							var nColor = _v7.a;
							var nKey = _v7.b;
							var nValue = _v7.c;
							var nLeft = _v7.d;
							var nRight = _v7.e;
							return A5(
								$elm$core$Dict$balance,
								nColor,
								nKey,
								nValue,
								A2($elm$core$Dict$removeHelp, targetKey, nLeft),
								nRight);
						} else {
							return $elm$core$Dict$RBEmpty_elm_builtin;
						}
					}
				} else {
					return A5(
						$elm$core$Dict$RBNode_elm_builtin,
						color,
						key,
						value,
						A2($elm$core$Dict$removeHelp, targetKey, left),
						right);
				}
			} else {
				return A2(
					$elm$core$Dict$removeHelpEQGT,
					targetKey,
					A7($elm$core$Dict$removeHelpPrepEQGT, targetKey, dict, color, key, value, left, right));
			}
		}
	});
var $elm$core$Dict$removeHelpEQGT = F2(
	function (targetKey, dict) {
		if (dict.$ === -1) {
			var color = dict.a;
			var key = dict.b;
			var value = dict.c;
			var left = dict.d;
			var right = dict.e;
			if (_Utils_eq(targetKey, key)) {
				var _v1 = $elm$core$Dict$getMin(right);
				if (_v1.$ === -1) {
					var minKey = _v1.b;
					var minValue = _v1.c;
					return A5(
						$elm$core$Dict$balance,
						color,
						minKey,
						minValue,
						left,
						$elm$core$Dict$removeMin(right));
				} else {
					return $elm$core$Dict$RBEmpty_elm_builtin;
				}
			} else {
				return A5(
					$elm$core$Dict$balance,
					color,
					key,
					value,
					left,
					A2($elm$core$Dict$removeHelp, targetKey, right));
			}
		} else {
			return $elm$core$Dict$RBEmpty_elm_builtin;
		}
	});
var $elm$core$Dict$remove = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$removeHelp, key, dict);
		if ((_v0.$ === -1) && (!_v0.a)) {
			var _v1 = _v0.a;
			var k = _v0.b;
			var v = _v0.c;
			var l = _v0.d;
			var r = _v0.e;
			return A5($elm$core$Dict$RBNode_elm_builtin, 1, k, v, l, r);
		} else {
			var x = _v0;
			return x;
		}
	});
var $elm$core$Dict$update = F3(
	function (targetKey, alter, dictionary) {
		var _v0 = alter(
			A2($elm$core$Dict$get, targetKey, dictionary));
		if (!_v0.$) {
			var value = _v0.a;
			return A3($elm$core$Dict$insert, targetKey, value, dictionary);
		} else {
			return A2($elm$core$Dict$remove, targetKey, dictionary);
		}
	});
var $elm$url$Url$Parser$addParam = F2(
	function (segment, dict) {
		var _v0 = A2($elm$core$String$split, '=', segment);
		if ((_v0.b && _v0.b.b) && (!_v0.b.b.b)) {
			var rawKey = _v0.a;
			var _v1 = _v0.b;
			var rawValue = _v1.a;
			var _v2 = $elm$url$Url$percentDecode(rawKey);
			if (_v2.$ === 1) {
				return dict;
			} else {
				var key = _v2.a;
				var _v3 = $elm$url$Url$percentDecode(rawValue);
				if (_v3.$ === 1) {
					return dict;
				} else {
					var value = _v3.a;
					return A3(
						$elm$core$Dict$update,
						key,
						$elm$url$Url$Parser$addToParametersHelp(value),
						dict);
				}
			}
		} else {
			return dict;
		}
	});
var $elm$url$Url$Parser$prepareQuery = function (maybeQuery) {
	if (maybeQuery.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var qry = maybeQuery.a;
		return A3(
			$elm$core$List$foldr,
			$elm$url$Url$Parser$addParam,
			$elm$core$Dict$empty,
			A2($elm$core$String$split, '&', qry));
	}
};
var $elm$url$Url$Parser$parse = F2(
	function (_v0, url) {
		var parser = _v0;
		return $elm$url$Url$Parser$getFirstMatch(
			parser(
				A5(
					$elm$url$Url$Parser$State,
					_List_Nil,
					$elm$url$Url$Parser$preparePath(url.dW),
					$elm$url$Url$Parser$prepareQuery(url.d3),
					url.dm,
					$elm$core$Basics$identity)));
	});
var $author$project$Ui$Router$Home = {$: 11};
var $author$project$Ui$Router$OperationDetail = function (a) {
	return {$: 2, a: a};
};
var $author$project$Ui$Router$StationCreate = function (a) {
	return {$: 3, a: a};
};
var $author$project$Ui$Router$StationGetSignature = F4(
	function (a, b, c, d) {
		return {$: 5, a: a, b: b, c: c, d: d};
	});
var $author$project$Ui$Router$StationSelectArticle = F4(
	function (a, b, c, d) {
		return {$: 8, a: a, b: b, c: c, d: d};
	});
var $author$project$Ui$Router$StationSelectArticleMulti = F5(
	function (a, b, c, d, e) {
		return {$: 9, a: a, b: b, c: c, d: d, e: e};
	});
var $author$project$Ui$Router$StationSelectArticleMultiTemp = F9(
	function (a, b, c, d, e, f, g, h, i) {
		return {$: 10, a: a, b: b, c: c, d: d, e: e, f: f, g: g, h: h, i: i};
	});
var $author$project$Ui$Router$StationSelectBadPart = F4(
	function (a, b, c, d) {
		return {$: 6, a: a, b: b, c: c, d: d};
	});
var $author$project$Ui$Router$StationShow = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $elm$url$Url$Parser$Parser = $elm$core$Basics$identity;
var $elm$url$Url$Parser$custom = F2(
	function (tipe, stringToSomething) {
		return function (_v0) {
			var visited = _v0.aD;
			var unvisited = _v0.ap;
			var params = _v0.ax;
			var frag = _v0.au;
			var value = _v0.cO;
			if (!unvisited.b) {
				return _List_Nil;
			} else {
				var next = unvisited.a;
				var rest = unvisited.b;
				var _v2 = stringToSomething(next);
				if (!_v2.$) {
					var nextValue = _v2.a;
					return _List_fromArray(
						[
							A5(
							$elm$url$Url$Parser$State,
							A2($elm$core$List$cons, next, visited),
							rest,
							params,
							frag,
							value(nextValue))
						]);
				} else {
					return _List_Nil;
				}
			}
		};
	});
var $elm$url$Url$Parser$int = A2($elm$url$Url$Parser$custom, 'NUMBER', $elm$core$String$toInt);
var $elm$url$Url$Parser$mapState = F2(
	function (func, _v0) {
		var visited = _v0.aD;
		var unvisited = _v0.ap;
		var params = _v0.ax;
		var frag = _v0.au;
		var value = _v0.cO;
		return A5(
			$elm$url$Url$Parser$State,
			visited,
			unvisited,
			params,
			frag,
			func(value));
	});
var $elm$url$Url$Parser$map = F2(
	function (subValue, _v0) {
		var parseArg = _v0;
		return function (_v1) {
			var visited = _v1.aD;
			var unvisited = _v1.ap;
			var params = _v1.ax;
			var frag = _v1.au;
			var value = _v1.cO;
			return A2(
				$elm$core$List$map,
				$elm$url$Url$Parser$mapState(value),
				parseArg(
					A5($elm$url$Url$Parser$State, visited, unvisited, params, frag, subValue)));
		};
	});
var $elm$core$List$append = F2(
	function (xs, ys) {
		if (!ys.b) {
			return xs;
		} else {
			return A3($elm$core$List$foldr, $elm$core$List$cons, ys, xs);
		}
	});
var $elm$core$List$concat = function (lists) {
	return A3($elm$core$List$foldr, $elm$core$List$append, _List_Nil, lists);
};
var $elm$core$List$concatMap = F2(
	function (f, list) {
		return $elm$core$List$concat(
			A2($elm$core$List$map, f, list));
	});
var $elm$url$Url$Parser$oneOf = function (parsers) {
	return function (state) {
		return A2(
			$elm$core$List$concatMap,
			function (_v0) {
				var parser = _v0;
				return parser(state);
			},
			parsers);
	};
};
var $elm$url$Url$Parser$s = function (str) {
	return function (_v0) {
		var visited = _v0.aD;
		var unvisited = _v0.ap;
		var params = _v0.ax;
		var frag = _v0.au;
		var value = _v0.cO;
		if (!unvisited.b) {
			return _List_Nil;
		} else {
			var next = unvisited.a;
			var rest = unvisited.b;
			return _Utils_eq(next, str) ? _List_fromArray(
				[
					A5(
					$elm$url$Url$Parser$State,
					A2($elm$core$List$cons, next, visited),
					rest,
					params,
					frag,
					value)
				]) : _List_Nil;
		}
	};
};
var $elm$url$Url$Parser$slash = F2(
	function (_v0, _v1) {
		var parseBefore = _v0;
		var parseAfter = _v1;
		return function (state) {
			return A2(
				$elm$core$List$concatMap,
				parseAfter,
				parseBefore(state));
		};
	});
var $elm$url$Url$Parser$string = A2($elm$url$Url$Parser$custom, 'STRING', $elm$core$Maybe$Just);
var $elm$url$Url$Parser$top = function (state) {
	return _List_fromArray(
		[state]);
};
var $author$project$Ui$Router$parser = $elm$url$Url$Parser$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Ui$Router$OperationDetail,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('orders'),
				$elm$url$Url$Parser$string)),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Ui$Router$StationCreate,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('orders'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$string,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('stations'),
						$elm$url$Url$Parser$s('create'))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Ui$Router$StationShow,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('orders'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$string,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('stations'),
						A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$int))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Ui$Router$StationGetSignature,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('orders'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$string,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('stations'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$int,
								A2(
									$elm$url$Url$Parser$slash,
									$elm$url$Url$Parser$s('signature'),
									$elm$url$Url$Parser$string))))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Ui$Router$StationSelectArticle,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('orders'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$string,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('stations'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$int,
								A2(
									$elm$url$Url$Parser$slash,
									$elm$url$Url$Parser$s('select-article'),
									$elm$url$Url$Parser$string))))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Ui$Router$StationSelectBadPart,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('orders'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$string,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('stations'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$int,
								A2(
									$elm$url$Url$Parser$slash,
									$elm$url$Url$Parser$s('select-bad-part'),
									$elm$url$Url$Parser$string))))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Ui$Router$StationSelectArticleMulti,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('orders'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$string,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('stations'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$int,
								A2(
									$elm$url$Url$Parser$slash,
									$elm$url$Url$Parser$s('select-article'),
									A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$string, $elm$url$Url$Parser$string)))))))),
			A2(
			$elm$url$Url$Parser$map,
			$author$project$Ui$Router$StationSelectArticleMultiTemp,
			A2(
				$elm$url$Url$Parser$slash,
				$elm$url$Url$Parser$s('orders'),
				A2(
					$elm$url$Url$Parser$slash,
					$elm$url$Url$Parser$string,
					A2(
						$elm$url$Url$Parser$slash,
						$elm$url$Url$Parser$s('stations'),
						A2(
							$elm$url$Url$Parser$slash,
							$elm$url$Url$Parser$string,
							A2(
								$elm$url$Url$Parser$slash,
								$elm$url$Url$Parser$int,
								A2(
									$elm$url$Url$Parser$slash,
									$elm$url$Url$Parser$s('select-article-from-temp'),
									A2(
										$elm$url$Url$Parser$slash,
										$elm$url$Url$Parser$string,
										A2(
											$elm$url$Url$Parser$slash,
											$elm$url$Url$Parser$s('target'),
											A2(
												$elm$url$Url$Parser$slash,
												$elm$url$Url$Parser$string,
												A2(
													$elm$url$Url$Parser$slash,
													$elm$url$Url$Parser$int,
													A2(
														$elm$url$Url$Parser$slash,
														$elm$url$Url$Parser$string,
														A2($elm$url$Url$Parser$slash, $elm$url$Url$Parser$int, $elm$url$Url$Parser$string))))))))))))),
			A2($elm$url$Url$Parser$map, $author$project$Ui$Router$Home, $elm$url$Url$Parser$top)
		]));
var $author$project$Ui$Router$pathToRoute = function (maybeUrl) {
	var _v0 = $elm$url$Url$fromString(maybeUrl);
	if (_v0.$ === 1) {
		return $author$project$Ui$Router$NotFound;
	} else {
		var url = _v0.a;
		var _v1 = A2($elm$url$Url$Parser$parse, $author$project$Ui$Router$parser, url);
		if (_v1.$ === 1) {
			return $author$project$Ui$Router$NotFound;
		} else {
			var route = _v1.a;
			return route;
		}
	}
};
var $elm$time$Time$Zone = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$utc = A2($elm$time$Time$Zone, 0, _List_Nil);
var $author$project$Model$decode = F5(
	function (version, baseUrl, url, deviceId, language) {
		return A3(
			$webbhuset$elm_json_decode$Json$Decode$Field$attempt,
			'operations',
			$elm$json$Json$Decode$dict($author$project$Types$Operation$decodeOperation),
			function (operations) {
				return A3(
					$webbhuset$elm_json_decode$Json$Decode$Field$attempt,
					'warehouse',
					$author$project$Types$Warehouse$decodeWarehouseInModel,
					function (warehouse) {
						return A3(
							$webbhuset$elm_json_decode$Json$Decode$Field$require,
							'stations',
							$elm$json$Json$Decode$dict($author$project$Types$Station$decode),
							function (stations) {
								return A3(
									$webbhuset$elm_json_decode$Json$Decode$Field$attempt,
									'notSyncable',
									$elm$json$Json$Decode$list($author$project$Types$Queue$decodeQueueReference),
									function (notSyncable) {
										return A3(
											$webbhuset$elm_json_decode$Json$Decode$Field$attempt,
											'email',
											$elm$json$Json$Decode$string,
											function (maybeEmail) {
												return $elm$json$Json$Decode$succeed(
													{
														a2: baseUrl,
														c8: $author$project$Types$Queue$NotStarted,
														dd: deviceId,
														aa: maybeEmail,
														bG: $elm$core$Maybe$Nothing,
														ck: language,
														aR: A2($elm$core$Maybe$withDefault, _List_Nil, notSyncable),
														ba: A2($elm$core$Maybe$withDefault, $elm$core$Dict$empty, operations),
														aT: _List_Nil,
														gT: _List_Nil,
														aA: stations,
														g2: $elm$time$Time$millisToPosix(0),
														bj: {
															e4: '',
															c7: function () {
																var _v0 = $author$project$Ui$Router$pathToRoute(url);
																if (_v0.$ === 1) {
																	return $author$project$Ui$Router$Loading;
																} else {
																	var route = _v0;
																	return route;
																}
															}(),
															b8: url,
															fg: $krisajenkins$remotedata$RemoteData$NotAsked,
															fk: $elm$core$Maybe$Nothing,
															fR: true,
															gR: $elm$core$Maybe$Nothing,
															g0: ''
														},
														ae: version,
														eV: function () {
															if (!warehouse.$) {
																var warehouse_ = warehouse.a;
																return $krisajenkins$remotedata$RemoteData$Success(warehouse_);
															} else {
																return $krisajenkins$remotedata$RemoteData$NotAsked;
															}
														}(),
														hi: $elm$time$Time$utc
													});
											});
									});
							});
					});
			});
	});
var $author$project$Translations$En = 1;
var $NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt = F3(
	function (path, valDecoder, decoder) {
		return A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$custom,
			A2($elm$json$Json$Decode$at, path, valDecoder),
			decoder);
	});
var $author$project$Types$Warehouse$decodeArticleFromMaterial = function (operationId) {
	return A2(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
		$elm$core$Maybe$Nothing,
		A2(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
			operationId,
			A2(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
				$author$project$Lib$Sync$Server,
				A2(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
					true,
					A2(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
						'',
						A2(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
							false,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'description',
								$elm$json$Json$Decode$string,
								A2(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
									'',
									A3(
										$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
										_List_fromArray(
											['template', 'id']),
										$author$project$Lib$Decode$Helper$decodeToMaybe($elm$json$Json$Decode$int),
										A3(
											$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
											'id',
											$author$project$Lib$Decode$Helper$decodeToMaybe($elm$json$Json$Decode$int),
											A3(
												$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
												'reportStatus',
												$elm$json$Json$Decode$string,
												A3(
													$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
													'status',
													$elm$json$Json$Decode$string,
													A2(
														$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$hardcoded,
														false,
														A3(
															$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
															'sn',
															$elm$json$Json$Decode$string,
															A3(
																$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
																_List_fromArray(
																	['template', 'vendor']),
																$elm$json$Json$Decode$string,
																A3(
																	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
																	_List_fromArray(
																		['template', 'productCategory']),
																	$elm$json$Json$Decode$string,
																	A3(
																		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$requiredAt,
																		_List_fromArray(
																			['template', 'description']),
																		$elm$json$Json$Decode$string,
																		A3(
																			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
																			'articleId',
																			$elm$json$Json$Decode$int,
																			$elm$json$Json$Decode$succeed($author$project$Types$Warehouse$Article)))))))))))))))))));
};
var $author$project$Types$Warehouse$decodeArticlesFromOperation = A3(
	$webbhuset$elm_json_decode$Json$Decode$Field$require,
	'id',
	$elm$json$Json$Decode$int,
	function (id) {
		return A3(
			$webbhuset$elm_json_decode$Json$Decode$Field$attemptAt,
			_List_fromArray(
				['report', 'materials']),
			$elm$json$Json$Decode$list(
				$author$project$Types$Warehouse$decodeArticleFromMaterial(
					$elm$core$Maybe$Just(id))),
			function (maybeSelectedArticles) {
				return $elm$json$Json$Decode$succeed(
					function () {
						if (!maybeSelectedArticles.$) {
							var articles = maybeSelectedArticles.a;
							return articles;
						} else {
							return _List_Nil;
						}
					}());
			});
	});
var $author$project$Types$Ports$decodeFlags = A3(
	$webbhuset$elm_json_decode$Json$Decode$Field$require,
	'url',
	$elm$json$Json$Decode$string,
	function (url) {
		return A3(
			$webbhuset$elm_json_decode$Json$Decode$Field$attempt,
			'operation',
			$author$project$Types$Operation$decodeOperation,
			function (maybeOperation) {
				return A3(
					$webbhuset$elm_json_decode$Json$Decode$Field$attempt,
					'operation',
					$author$project$Types$Warehouse$decodeArticlesFromOperation,
					function (maybeMaterials) {
						return A3(
							$webbhuset$elm_json_decode$Json$Decode$Field$attempt,
							'jwt',
							$elm$json$Json$Decode$string,
							function (maybeJwt) {
								return A3(
									$webbhuset$elm_json_decode$Json$Decode$Field$require,
									'baseUrl',
									$elm$json$Json$Decode$string,
									function (baseUrl) {
										return A3(
											$webbhuset$elm_json_decode$Json$Decode$Field$require,
											'version',
											$elm$json$Json$Decode$string,
											function (version) {
												return A3(
													$webbhuset$elm_json_decode$Json$Decode$Field$attempt,
													'email',
													$elm$json$Json$Decode$string,
													function (maybeEmail) {
														return A3(
															$webbhuset$elm_json_decode$Json$Decode$Field$attempt,
															'language',
															$elm$json$Json$Decode$string,
															function (maybelanguage) {
																return $elm$json$Json$Decode$succeed(
																	{
																		a2: baseUrl,
																		aa: maybeEmail,
																		bG: maybeJwt,
																		ck: function () {
																			if ((!maybelanguage.$) && (maybelanguage.a === 'en')) {
																				return 1;
																			} else {
																				return 0;
																			}
																		}(),
																		f_: maybeMaterials,
																		dU: maybeOperation,
																		hc: url,
																		ae: version
																	});
															});
													});
											});
									});
							});
					});
			});
	});
var $author$project$Model$defaultBaseUrl = 'https://app.bentomax.de';
var $author$project$Msg$ApiMsg_ = function (a) {
	return {$: 10, a: a};
};
var $author$project$Msg$ApiReceiveOperation = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$core$Task$onError = _Scheduler_onError;
var $elm$core$Task$attempt = F2(
	function (resultToMessage, task) {
		return $elm$core$Task$command(
			A2(
				$elm$core$Task$onError,
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
					$elm$core$Result$Err),
				A2(
					$elm$core$Task$andThen,
					A2(
						$elm$core$Basics$composeL,
						A2($elm$core$Basics$composeL, $elm$core$Task$succeed, resultToMessage),
						$elm$core$Result$Ok),
					task)));
	});
var $author$project$Actions$Warehouse$decodeOperationAndMaterials = A2(
	$elm$json$Json$Decode$andThen,
	function (materials) {
		return A2(
			$elm$json$Json$Decode$andThen,
			function (operation) {
				return $elm$json$Json$Decode$succeed(
					_Utils_Tuple2(operation, materials));
			},
			$author$project$Types$Operation$decodeOperation);
	},
	$author$project$Types$Warehouse$decodeArticlesFromOperation);
var $elm$http$Http$BadStatus_ = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $elm$http$Http$BadUrl_ = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$GoodStatus_ = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $elm$http$Http$NetworkError_ = {$: 2};
var $elm$http$Http$Receiving = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$Sending = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$Timeout_ = {$: 1};
var $elm$core$Maybe$isJust = function (maybe) {
	if (!maybe.$) {
		return true;
	} else {
		return false;
	}
};
var $elm$core$Platform$sendToSelf = _Platform_sendToSelf;
var $elm$http$Http$emptyBody = _Http_emptyBody;
var $krisajenkins$remotedata$RemoteData$Failure = function (a) {
	return {$: 2, a: a};
};
var $krisajenkins$remotedata$RemoteData$fromResult = function (result) {
	if (result.$ === 1) {
		var e = result.a;
		return $krisajenkins$remotedata$RemoteData$Failure(e);
	} else {
		var x = result.a;
		return $krisajenkins$remotedata$RemoteData$Success(x);
	}
};
var $elm$http$Http$BadStatus = function (a) {
	return {$: 3, a: a};
};
var $author$project$Types$Warehouse$decodeWarehouse = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['articles']),
	$elm$json$Json$Decode$list(
		$elm$json$Json$Decode$oneOf(
			_List_fromArray(
				[
					$author$project$Types$Warehouse$decodeArticle,
					$author$project$Types$Warehouse$decodeArticleFromWarehouse($elm$core$Maybe$Nothing)
				]))));
var $elm$core$Task$fail = _Scheduler_fail;
var $elm$http$Http$BadBody = function (a) {
	return {$: 4, a: a};
};
var $elm$http$Http$BadUrl = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$NetworkError = {$: 2};
var $elm$http$Http$Timeout = {$: 1};
var $elm$json$Json$Decode$decodeString = _Json_runOnString;
var $elm$http$Http$stringResolver = A2(_Http_expect, '', $elm$core$Basics$identity);
var $author$project$Lib$Http$Extra$jsonResolver = function (decoder) {
	return $elm$http$Http$stringResolver(
		function (response) {
			switch (response.$) {
				case 0:
					var url = response.a;
					return $elm$core$Result$Err(
						$elm$http$Http$BadUrl(url));
				case 1:
					return $elm$core$Result$Err($elm$http$Http$Timeout);
				case 2:
					return $elm$core$Result$Err($elm$http$Http$NetworkError);
				case 3:
					var metadata = response.a;
					return $elm$core$Result$Err(
						$elm$http$Http$BadStatus(metadata.gV));
				default:
					var body = response.b;
					var _v1 = A2($elm$json$Json$Decode$decodeString, decoder, body);
					if (!_v1.$) {
						var value = _v1.a;
						return $elm$core$Result$Ok(value);
					} else {
						var err = _v1.a;
						return $elm$core$Result$Err(
							$elm$http$Http$BadBody(
								$elm$json$Json$Decode$errorToString(err)));
					}
			}
		});
};
var $elm$http$Http$resultToTask = function (result) {
	if (!result.$) {
		var a = result.a;
		return $elm$core$Task$succeed(a);
	} else {
		var x = result.a;
		return $elm$core$Task$fail(x);
	}
};
var $elm$http$Http$task = function (r) {
	return A3(
		_Http_toTask,
		0,
		$elm$http$Http$resultToTask,
		{e1: false, e6: r.e6, fq: r.ee, fy: r.fy, f2: r.f2, g3: r.g3, g6: $elm$core$Maybe$Nothing, hc: r.hc});
};
var $author$project$Actions$Warehouse$getWarehouseCompleteTask = F3(
	function (token, baseUrl, operation) {
		var _v0 = _Utils_Tuple2(operation.he, operation.e5);
		if ((!_v0.a.$) && (!_v0.b.$)) {
			var warehouseId = _v0.a.a;
			var binId = _v0.b.a;
			return $elm$http$Http$task(
				{
					e6: $elm$http$Http$emptyBody,
					fy: _List_Nil,
					f2: 'GET',
					ee: $author$project$Lib$Http$Extra$jsonResolver($author$project$Types$Warehouse$decodeWarehouse),
					g3: $elm$core$Maybe$Nothing,
					hc: baseUrl + ('/r/api/v1/app/warehouse/' + ($elm$core$String$fromInt(warehouseId) + ('/' + ($elm$core$String$fromInt(binId) + ('?jwt_token=' + (token + '&complete=true'))))))
				});
		} else {
			return $elm$core$Task$fail(
				$elm$http$Http$BadStatus(400));
		}
	});
var $author$project$Actions$Warehouse$getOperation_legacy = F3(
	function (token, baseUrl, operationId) {
		var requestTarget = '/r/api/v1/app/operations/' + (operationId + ('?jwt_token=' + token));
		return A2(
			$elm$core$Task$attempt,
			A2(
				$elm$core$Basics$composeR,
				$krisajenkins$remotedata$RemoteData$fromResult,
				A2(
					$elm$core$Basics$composeR,
					$author$project$Msg$ApiReceiveOperation(operationId),
					$author$project$Msg$ApiMsg_)),
			A2(
				$elm$core$Task$andThen,
				function (_v0) {
					var operation = _v0.a;
					var operationArticles = _v0.b;
					return A2(
						$elm$core$Task$andThen,
						function (articles) {
							return $elm$core$Task$succeed(
								_Utils_Tuple2(
									operation,
									_Utils_Tuple2(articles, operationArticles)));
						},
						A3($author$project$Actions$Warehouse$getWarehouseCompleteTask, token, baseUrl, operation));
				},
				$elm$http$Http$task(
					{
						e6: $elm$http$Http$emptyBody,
						fy: _List_Nil,
						f2: 'GET',
						ee: $author$project$Lib$Http$Extra$jsonResolver($author$project$Actions$Warehouse$decodeOperationAndMaterials),
						g3: $elm$core$Maybe$Nothing,
						hc: _Utils_ap(baseUrl, requestTarget)
					})));
	});
var $author$project$Msg$ApiReceiveWarehouse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Actions$Warehouse$getWarehouseComplete = F3(
	function (token, baseUrl, operation) {
		return A2(
			$elm$core$Task$attempt,
			A2(
				$elm$core$Basics$composeR,
				$krisajenkins$remotedata$RemoteData$fromResult,
				A2($elm$core$Basics$composeR, $author$project$Msg$ApiReceiveWarehouse, $author$project$Msg$ApiMsg_)),
			A3($author$project$Actions$Warehouse$getWarehouseCompleteTask, token, baseUrl, operation));
	});
var $elm$time$Time$Name = function (a) {
	return {$: 0, a: a};
};
var $elm$time$Time$Offset = function (a) {
	return {$: 1, a: a};
};
var $elm$time$Time$customZone = $elm$time$Time$Zone;
var $elm$time$Time$here = _Time_here(0);
var $author$project$Init$initModel = F4(
	function (deviceId, maybeJwt, baseUrl, language) {
		return {
			a2: baseUrl,
			c8: $author$project$Types$Queue$NotStarted,
			dd: deviceId,
			aa: $elm$core$Maybe$Nothing,
			bG: maybeJwt,
			ck: language,
			aR: _List_Nil,
			ba: $elm$core$Dict$empty,
			aT: _List_Nil,
			gT: _List_Nil,
			aA: $elm$core$Dict$empty,
			g2: $elm$time$Time$millisToPosix(0),
			bj: {e4: '', c7: $author$project$Ui$Router$Loading, b8: $author$project$Model$defaultBaseUrl, fg: $krisajenkins$remotedata$RemoteData$NotAsked, fk: $elm$core$Maybe$Nothing, fR: true, gR: $elm$core$Maybe$Nothing, g0: ''},
			ae: '',
			eV: $krisajenkins$remotedata$RemoteData$NotAsked,
			hi: $elm$time$Time$utc
		};
	});
var $author$project$Msg$StationForOperation = F2(
	function (a, b) {
		return {$: 12, a: a, b: b};
	});
var $author$project$Types$Station$OperationMetaDataTable = F2(
	function (metadata, workflowTemplate) {
		return {f1: metadata, hg: workflowTemplate};
	});
var $author$project$Types$Station$decodeOperationMetaDataTable = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'workflow_template',
	$elm$json$Json$Decode$maybe(
		$elm$json$Json$Decode$list($author$project$Types$Station$decodeStation)),
	$elm$core$Maybe$Nothing,
	A4(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
		'metadata',
		$elm$json$Json$Decode$list($author$project$Types$Station$decodeStation),
		_List_Nil,
		$elm$json$Json$Decode$succeed($author$project$Types$Station$OperationMetaDataTable)));
var $elm$http$Http$expectStringResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'',
			$elm$core$Basics$identity,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$core$Result$mapError = F2(
	function (f, result) {
		if (!result.$) {
			var v = result.a;
			return $elm$core$Result$Ok(v);
		} else {
			var e = result.a;
			return $elm$core$Result$Err(
				f(e));
		}
	});
var $elm$http$Http$resolve = F2(
	function (toResult, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.gV));
			default:
				var body = response.b;
				return A2(
					$elm$core$Result$mapError,
					$elm$http$Http$BadBody,
					toResult(body));
		}
	});
var $elm$http$Http$expectJson = F2(
	function (toMsg, decoder) {
		return A2(
			$elm$http$Http$expectStringResponse,
			toMsg,
			$elm$http$Http$resolve(
				function (string) {
					return A2(
						$elm$core$Result$mapError,
						$elm$json$Json$Decode$errorToString,
						A2($elm$json$Json$Decode$decodeString, decoder, string));
				}));
	});
var $elm$http$Http$Request = function (a) {
	return {$: 1, a: a};
};
var $elm$http$Http$State = F2(
	function (reqs, subs) {
		return {eb: reqs, eJ: subs};
	});
var $elm$http$Http$init = $elm$core$Task$succeed(
	A2($elm$http$Http$State, $elm$core$Dict$empty, _List_Nil));
var $elm$core$Process$kill = _Scheduler_kill;
var $elm$core$Process$spawn = _Scheduler_spawn;
var $elm$http$Http$updateReqs = F3(
	function (router, cmds, reqs) {
		updateReqs:
		while (true) {
			if (!cmds.b) {
				return $elm$core$Task$succeed(reqs);
			} else {
				var cmd = cmds.a;
				var otherCmds = cmds.b;
				if (!cmd.$) {
					var tracker = cmd.a;
					var _v2 = A2($elm$core$Dict$get, tracker, reqs);
					if (_v2.$ === 1) {
						var $temp$router = router,
							$temp$cmds = otherCmds,
							$temp$reqs = reqs;
						router = $temp$router;
						cmds = $temp$cmds;
						reqs = $temp$reqs;
						continue updateReqs;
					} else {
						var pid = _v2.a;
						return A2(
							$elm$core$Task$andThen,
							function (_v3) {
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A2($elm$core$Dict$remove, tracker, reqs));
							},
							$elm$core$Process$kill(pid));
					}
				} else {
					var req = cmd.a;
					return A2(
						$elm$core$Task$andThen,
						function (pid) {
							var _v4 = req.g6;
							if (_v4.$ === 1) {
								return A3($elm$http$Http$updateReqs, router, otherCmds, reqs);
							} else {
								var tracker = _v4.a;
								return A3(
									$elm$http$Http$updateReqs,
									router,
									otherCmds,
									A3($elm$core$Dict$insert, tracker, pid, reqs));
							}
						},
						$elm$core$Process$spawn(
							A3(
								_Http_toTask,
								router,
								$elm$core$Platform$sendToApp(router),
								req)));
				}
			}
		}
	});
var $elm$http$Http$onEffects = F4(
	function (router, cmds, subs, state) {
		return A2(
			$elm$core$Task$andThen,
			function (reqs) {
				return $elm$core$Task$succeed(
					A2($elm$http$Http$State, reqs, subs));
			},
			A3($elm$http$Http$updateReqs, router, cmds, state.eb));
	});
var $elm$core$List$maybeCons = F3(
	function (f, mx, xs) {
		var _v0 = f(mx);
		if (!_v0.$) {
			var x = _v0.a;
			return A2($elm$core$List$cons, x, xs);
		} else {
			return xs;
		}
	});
var $elm$core$List$filterMap = F2(
	function (f, xs) {
		return A3(
			$elm$core$List$foldr,
			$elm$core$List$maybeCons(f),
			_List_Nil,
			xs);
	});
var $elm$http$Http$maybeSend = F4(
	function (router, desiredTracker, progress, _v0) {
		var actualTracker = _v0.a;
		var toMsg = _v0.b;
		return _Utils_eq(desiredTracker, actualTracker) ? $elm$core$Maybe$Just(
			A2(
				$elm$core$Platform$sendToApp,
				router,
				toMsg(progress))) : $elm$core$Maybe$Nothing;
	});
var $elm$http$Http$onSelfMsg = F3(
	function (router, _v0, state) {
		var tracker = _v0.a;
		var progress = _v0.b;
		return A2(
			$elm$core$Task$andThen,
			function (_v1) {
				return $elm$core$Task$succeed(state);
			},
			$elm$core$Task$sequence(
				A2(
					$elm$core$List$filterMap,
					A3($elm$http$Http$maybeSend, router, tracker, progress),
					state.eJ)));
	});
var $elm$http$Http$Cancel = function (a) {
	return {$: 0, a: a};
};
var $elm$http$Http$cmdMap = F2(
	function (func, cmd) {
		if (!cmd.$) {
			var tracker = cmd.a;
			return $elm$http$Http$Cancel(tracker);
		} else {
			var r = cmd.a;
			return $elm$http$Http$Request(
				{
					e1: r.e1,
					e6: r.e6,
					fq: A2(_Http_mapExpect, func, r.fq),
					fy: r.fy,
					f2: r.f2,
					g3: r.g3,
					g6: r.g6,
					hc: r.hc
				});
		}
	});
var $elm$http$Http$MySub = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$subMap = F2(
	function (func, _v0) {
		var tracker = _v0.a;
		var toMsg = _v0.b;
		return A2(
			$elm$http$Http$MySub,
			tracker,
			A2($elm$core$Basics$composeR, toMsg, func));
	});
_Platform_effectManagers['Http'] = _Platform_createManager($elm$http$Http$init, $elm$http$Http$onEffects, $elm$http$Http$onSelfMsg, $elm$http$Http$cmdMap, $elm$http$Http$subMap);
var $elm$http$Http$command = _Platform_leaf('Http');
var $elm$http$Http$subscription = _Platform_leaf('Http');
var $elm$http$Http$request = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{e1: false, e6: r.e6, fq: r.fq, fy: r.fy, f2: r.f2, g3: r.g3, g6: r.g6, hc: r.hc}));
};
var $author$project$Actions$Station$load = F2(
	function (baseUrl, operationId) {
		var requestTarget = '/r/api/v1/operation_metadata/' + (operationId + '.json');
		return $elm$http$Http$request(
			{
				e6: $elm$http$Http$emptyBody,
				fq: A2(
					$elm$http$Http$expectJson,
					$author$project$Msg$StationForOperation(operationId),
					$author$project$Types$Station$decodeOperationMetaDataTable),
				fy: _List_Nil,
				f2: 'GET',
				g3: $elm$core$Maybe$Nothing,
				g6: $elm$core$Maybe$Nothing,
				hc: _Utils_ap(baseUrl, requestTarget)
			});
	});
var $author$project$Ui$Router$maybeOperationIdFromUrl = function (url) {
	var _v0 = $author$project$Ui$Router$pathToRoute(url);
	switch (_v0.$) {
		case 0:
			return $elm$core$Maybe$Nothing;
		case 11:
			return $elm$core$Maybe$Nothing;
		case 1:
			return $elm$core$Maybe$Nothing;
		case 2:
			var id = _v0.a;
			return $elm$core$Maybe$Just(id);
		case 3:
			var operationId = _v0.a;
			return $elm$core$Maybe$Just(operationId);
		case 4:
			var operationId = _v0.a;
			return $elm$core$Maybe$Just(operationId);
		case 5:
			var operationId = _v0.a;
			return $elm$core$Maybe$Just(operationId);
		case 6:
			var operationId = _v0.a;
			return $elm$core$Maybe$Just(operationId);
		case 7:
			var operationId = _v0.a;
			return $elm$core$Maybe$Just(operationId);
		case 8:
			var operationId = _v0.a;
			return $elm$core$Maybe$Just(operationId);
		case 9:
			var operationId = _v0.a;
			return $elm$core$Maybe$Just(operationId);
		default:
			var operationId = _v0.a;
			return $elm$core$Maybe$Just(operationId);
	}
};
var $elm$time$Time$now = _Time_now($elm$time$Time$millisToPosix);
var $elm$json$Json$Encode$object = function (pairs) {
	return _Json_wrap(
		A3(
			$elm$core$List$foldl,
			F2(
				function (_v0, obj) {
					var k = _v0.a;
					var v = _v0.b;
					return A3(_Json_addField, k, v, obj);
				}),
			_Json_emptyObject(0),
			pairs));
};
var $author$project$Ports$out_ = _Platform_outgoingPort('out_', $elm$core$Basics$identity);
var $author$project$Lib$send = function (msg) {
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$identity,
		$elm$core$Task$succeed(msg));
};
var $elm$json$Json$Encode$string = _Json_wrap;
var $elm$core$Result$toMaybe = function (result) {
	if (!result.$) {
		var v = result.a;
		return $elm$core$Maybe$Just(v);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $author$project$Init$init = function (flags) {
	var decodedDeviceId = A2(
		$elm$core$Maybe$withDefault,
		'noDeviceId',
		$elm$core$Result$toMaybe(
			A2(
				$elm$json$Json$Decode$decodeValue,
				A2(
					$elm$json$Json$Decode$at,
					_List_fromArray(
						['deviceId']),
					$elm$json$Json$Decode$string),
				flags)));
	var _v0 = function () {
		var _v3 = A2($elm$json$Json$Decode$decodeValue, $author$project$Types$Ports$decodeFlags, flags);
		if (!_v3.$) {
			var flags_ = _v3.a;
			return _Utils_Tuple3(
				$elm$core$Maybe$Just(flags_.hc),
				flags_.bG,
				_Utils_Tuple3(
					flags_.a2,
					flags_.ae,
					_Utils_Tuple3(flags_.dU, flags_.aa, flags_.ck)));
		} else {
			return _Utils_Tuple3(
				$elm$core$Maybe$Nothing,
				$elm$core$Maybe$Nothing,
				_Utils_Tuple3(
					$author$project$Model$defaultBaseUrl,
					'COULD_NOT_DECODE_VERSION',
					_Utils_Tuple3($elm$core$Maybe$Nothing, $elm$core$Maybe$Nothing, 0)));
		}
	}();
	var maybeUrl = _v0.a;
	var maybeJwt = _v0.b;
	var _v1 = _v0.c;
	var baseUrl = _v1.a;
	var version = _v1.b;
	var _v2 = _v1.c;
	var maybeOperation = _v2.a;
	var email = _v2.b;
	var language = _v2.c;
	var initialModel = A4($author$project$Init$initModel, decodedDeviceId, maybeJwt, baseUrl, language);
	var maybeOperationId = $author$project$Ui$Router$maybeOperationIdFromUrl(
		A2($elm$core$Maybe$withDefault, baseUrl, maybeUrl));
	var resModelFromFlags = A2(
		$elm$json$Json$Decode$decodeValue,
		A3(
			$webbhuset$elm_json_decode$Json$Decode$Field$attempt,
			'model',
			A5(
				$author$project$Model$decode,
				version,
				baseUrl,
				A2($elm$core$Maybe$withDefault, baseUrl, maybeUrl),
				decodedDeviceId,
				language),
			$elm$json$Json$Decode$succeed),
		flags);
	return _Utils_Tuple2(
		function () {
			if ((!resModelFromFlags.$) && (!resModelFromFlags.a.$)) {
				var model = resModelFromFlags.a.a;
				return _Utils_update(
					model,
					{aa: email});
			} else {
				return _Utils_update(
					initialModel,
					{aa: email});
			}
		}(),
		$elm$core$Platform$Cmd$batch(
			_Utils_ap(
				_List_fromArray(
					[
						$author$project$Ports$out_(
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'msg',
									$elm$json$Json$Encode$string('DatabaseRequestMsg')),
									_Utils_Tuple2(
									'data',
									$elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'msg',
												$elm$json$Json$Encode$string('LoadModel'))
											])))
								]))),
						A2($elm$core$Task$perform, $author$project$Msg$AdjustTimeZone, $elm$time$Time$here),
						A2($elm$core$Task$perform, $author$project$Msg$Timer, $elm$time$Time$now)
					]),
				_Utils_ap(
					function () {
						var _v5 = _Utils_Tuple2(maybeOperationId, maybeJwt);
						if ((!_v5.a.$) && (!_v5.b.$)) {
							var operationId = _v5.a.a;
							var jwt = _v5.b.a;
							return _List_fromArray(
								[
									A3($author$project$Actions$Warehouse$getOperation_legacy, jwt, baseUrl, operationId)
								]);
						} else {
							return _List_Nil;
						}
					}(),
					_Utils_ap(
						function () {
							var _v6 = _Utils_Tuple2(maybeOperation, maybeJwt);
							if ((!_v6.a.$) && (!_v6.b.$)) {
								var operation = _v6.a.a;
								var jwt = _v6.b.a;
								return _List_fromArray(
									[
										A3($author$project$Actions$Warehouse$getWarehouseComplete, jwt, baseUrl, operation)
									]);
							} else {
								return _List_Nil;
							}
						}(),
						function () {
							if (!maybeOperationId.$) {
								var operationId = maybeOperationId.a;
								return _List_fromArray(
									[
										$author$project$Lib$send(
										$author$project$Msg$SetStationDoneState(operationId)),
										A2($author$project$Actions$Station$load, baseUrl, operationId)
									]);
							} else {
								return _List_Nil;
							}
						}())))));
};
var $author$project$Msg$JsMsg_ = function (a) {
	return {$: 0, a: a};
};
var $author$project$Msg$JsUrlChange = function (a) {
	return {$: 3, a: a};
};
var $author$project$Msg$PortMsg_ = function (a) {
	return {$: 8, a: a};
};
var $author$project$Msg$PortRawMsg = function (a) {
	return {$: 7, a: a};
};
var $author$project$Msg$Tick = function (a) {
	return {$: 4, a: a};
};
var $elm$core$Platform$Sub$batch = _Platform_batch;
var $elm$time$Time$Every = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$time$Time$State = F2(
	function (taggers, processes) {
		return {d0: processes, eL: taggers};
	});
var $elm$time$Time$init = $elm$core$Task$succeed(
	A2($elm$time$Time$State, $elm$core$Dict$empty, $elm$core$Dict$empty));
var $elm$time$Time$addMySub = F2(
	function (_v0, state) {
		var interval = _v0.a;
		var tagger = _v0.b;
		var _v1 = A2($elm$core$Dict$get, interval, state);
		if (_v1.$ === 1) {
			return A3(
				$elm$core$Dict$insert,
				interval,
				_List_fromArray(
					[tagger]),
				state);
		} else {
			var taggers = _v1.a;
			return A3(
				$elm$core$Dict$insert,
				interval,
				A2($elm$core$List$cons, tagger, taggers),
				state);
		}
	});
var $elm$core$Dict$foldl = F3(
	function (func, acc, dict) {
		foldl:
		while (true) {
			if (dict.$ === -2) {
				return acc;
			} else {
				var key = dict.b;
				var value = dict.c;
				var left = dict.d;
				var right = dict.e;
				var $temp$func = func,
					$temp$acc = A3(
					func,
					key,
					value,
					A3($elm$core$Dict$foldl, func, acc, left)),
					$temp$dict = right;
				func = $temp$func;
				acc = $temp$acc;
				dict = $temp$dict;
				continue foldl;
			}
		}
	});
var $elm$core$Dict$merge = F6(
	function (leftStep, bothStep, rightStep, leftDict, rightDict, initialResult) {
		var stepState = F3(
			function (rKey, rValue, _v0) {
				stepState:
				while (true) {
					var list = _v0.a;
					var result = _v0.b;
					if (!list.b) {
						return _Utils_Tuple2(
							list,
							A3(rightStep, rKey, rValue, result));
					} else {
						var _v2 = list.a;
						var lKey = _v2.a;
						var lValue = _v2.b;
						var rest = list.b;
						if (_Utils_cmp(lKey, rKey) < 0) {
							var $temp$rKey = rKey,
								$temp$rValue = rValue,
								$temp$_v0 = _Utils_Tuple2(
								rest,
								A3(leftStep, lKey, lValue, result));
							rKey = $temp$rKey;
							rValue = $temp$rValue;
							_v0 = $temp$_v0;
							continue stepState;
						} else {
							if (_Utils_cmp(lKey, rKey) > 0) {
								return _Utils_Tuple2(
									list,
									A3(rightStep, rKey, rValue, result));
							} else {
								return _Utils_Tuple2(
									rest,
									A4(bothStep, lKey, lValue, rValue, result));
							}
						}
					}
				}
			});
		var _v3 = A3(
			$elm$core$Dict$foldl,
			stepState,
			_Utils_Tuple2(
				$elm$core$Dict$toList(leftDict),
				initialResult),
			rightDict);
		var leftovers = _v3.a;
		var intermediateResult = _v3.b;
		return A3(
			$elm$core$List$foldl,
			F2(
				function (_v4, result) {
					var k = _v4.a;
					var v = _v4.b;
					return A3(leftStep, k, v, result);
				}),
			intermediateResult,
			leftovers);
	});
var $elm$time$Time$setInterval = _Time_setInterval;
var $elm$time$Time$spawnHelp = F3(
	function (router, intervals, processes) {
		if (!intervals.b) {
			return $elm$core$Task$succeed(processes);
		} else {
			var interval = intervals.a;
			var rest = intervals.b;
			var spawnTimer = $elm$core$Process$spawn(
				A2(
					$elm$time$Time$setInterval,
					interval,
					A2($elm$core$Platform$sendToSelf, router, interval)));
			var spawnRest = function (id) {
				return A3(
					$elm$time$Time$spawnHelp,
					router,
					rest,
					A3($elm$core$Dict$insert, interval, id, processes));
			};
			return A2($elm$core$Task$andThen, spawnRest, spawnTimer);
		}
	});
var $elm$time$Time$onEffects = F3(
	function (router, subs, _v0) {
		var processes = _v0.d0;
		var rightStep = F3(
			function (_v6, id, _v7) {
				var spawns = _v7.a;
				var existing = _v7.b;
				var kills = _v7.c;
				return _Utils_Tuple3(
					spawns,
					existing,
					A2(
						$elm$core$Task$andThen,
						function (_v5) {
							return kills;
						},
						$elm$core$Process$kill(id)));
			});
		var newTaggers = A3($elm$core$List$foldl, $elm$time$Time$addMySub, $elm$core$Dict$empty, subs);
		var leftStep = F3(
			function (interval, taggers, _v4) {
				var spawns = _v4.a;
				var existing = _v4.b;
				var kills = _v4.c;
				return _Utils_Tuple3(
					A2($elm$core$List$cons, interval, spawns),
					existing,
					kills);
			});
		var bothStep = F4(
			function (interval, taggers, id, _v3) {
				var spawns = _v3.a;
				var existing = _v3.b;
				var kills = _v3.c;
				return _Utils_Tuple3(
					spawns,
					A3($elm$core$Dict$insert, interval, id, existing),
					kills);
			});
		var _v1 = A6(
			$elm$core$Dict$merge,
			leftStep,
			bothStep,
			rightStep,
			newTaggers,
			processes,
			_Utils_Tuple3(
				_List_Nil,
				$elm$core$Dict$empty,
				$elm$core$Task$succeed(0)));
		var spawnList = _v1.a;
		var existingDict = _v1.b;
		var killTask = _v1.c;
		return A2(
			$elm$core$Task$andThen,
			function (newProcesses) {
				return $elm$core$Task$succeed(
					A2($elm$time$Time$State, newTaggers, newProcesses));
			},
			A2(
				$elm$core$Task$andThen,
				function (_v2) {
					return A3($elm$time$Time$spawnHelp, router, spawnList, existingDict);
				},
				killTask));
	});
var $elm$time$Time$onSelfMsg = F3(
	function (router, interval, state) {
		var _v0 = A2($elm$core$Dict$get, interval, state.eL);
		if (_v0.$ === 1) {
			return $elm$core$Task$succeed(state);
		} else {
			var taggers = _v0.a;
			var tellTaggers = function (time) {
				return $elm$core$Task$sequence(
					A2(
						$elm$core$List$map,
						function (tagger) {
							return A2(
								$elm$core$Platform$sendToApp,
								router,
								tagger(time));
						},
						taggers));
			};
			return A2(
				$elm$core$Task$andThen,
				function (_v1) {
					return $elm$core$Task$succeed(state);
				},
				A2($elm$core$Task$andThen, tellTaggers, $elm$time$Time$now));
		}
	});
var $elm$time$Time$subMap = F2(
	function (f, _v0) {
		var interval = _v0.a;
		var tagger = _v0.b;
		return A2(
			$elm$time$Time$Every,
			interval,
			A2($elm$core$Basics$composeL, f, tagger));
	});
_Platform_effectManagers['Time'] = _Platform_createManager($elm$time$Time$init, $elm$time$Time$onEffects, $elm$time$Time$onSelfMsg, 0, $elm$time$Time$subMap);
var $elm$time$Time$subscription = _Platform_leaf('Time');
var $elm$time$Time$every = F2(
	function (interval, tagger) {
		return $elm$time$Time$subscription(
			A2($elm$time$Time$Every, interval, tagger));
	});
var $author$project$Ports$in_ = _Platform_incomingPort('in_', $elm$json$Json$Decode$value);
var $author$project$Ports$urlChange = _Platform_incomingPort('urlChange', $elm$json$Json$Decode$string);
var $author$project$App$subscriptions = function (_v0) {
	return $elm$core$Platform$Sub$batch(
		_List_fromArray(
			[
				$author$project$Ports$urlChange(
				A2(
					$elm$core$Basics$composeL,
					A2($elm$core$Basics$composeL, $author$project$Msg$PortMsg_, $author$project$Msg$JsMsg_),
					$author$project$Msg$JsUrlChange)),
				$author$project$Ports$in_($author$project$Msg$PortRawMsg),
				A2($elm$time$Time$every, 10000, $author$project$Msg$Timer),
				A2($elm$time$Time$every, 2500, $author$project$Msg$Tick)
			]));
};
var $elm$core$List$isEmpty = function (xs) {
	if (!xs.b) {
		return true;
	} else {
		return false;
	}
};
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles = F2(
	function (_v0, styles) {
		var newStyles = _v0.b;
		var classname = _v0.c;
		return $elm$core$List$isEmpty(newStyles) ? styles : A3($elm$core$Dict$insert, classname, newStyles, styles);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute = function (_v0) {
	var val = _v0.a;
	return val;
};
var $elm$virtual_dom$VirtualDom$keyedNode = function (tag) {
	return _VirtualDom_keyedNode(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$keyedNodeNS = F2(
	function (namespace, tag) {
		return A2(
			_VirtualDom_keyedNodeNS,
			namespace,
			_VirtualDom_noScript(tag));
	});
var $elm$virtual_dom$VirtualDom$node = function (tag) {
	return _VirtualDom_node(
		_VirtualDom_noScript(tag));
};
var $elm$virtual_dom$VirtualDom$nodeNS = function (tag) {
	return _VirtualDom_nodeNS(
		_VirtualDom_noScript(tag));
};
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml = F2(
	function (_v6, _v7) {
		var key = _v6.a;
		var html = _v6.b;
		var pairs = _v7.a;
		var styles = _v7.b;
		switch (html.$) {
			case 4:
				var vdom = html.a;
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v9 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v9.a;
				var finalStyles = _v9.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v10 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v10.a;
				var finalStyles = _v10.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v11 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v11.a;
				var finalStyles = _v11.b;
				var vdom = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v12 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v12.a;
				var finalStyles = _v12.b;
				var vdom = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2(
						$elm$core$List$cons,
						_Utils_Tuple2(key, vdom),
						pairs),
					finalStyles);
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml = F2(
	function (html, _v0) {
		var nodes = _v0.a;
		var styles = _v0.b;
		switch (html.$) {
			case 4:
				var vdomNode = html.a;
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					styles);
			case 0:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v2 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v2.a;
				var finalStyles = _v2.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$node,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 1:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v3 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v3.a;
				var finalStyles = _v3.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$nodeNS,
					ns,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			case 2:
				var elemType = html.a;
				var properties = html.b;
				var children = html.c;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v4 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v4.a;
				var finalStyles = _v4.b;
				var vdomNode = A3(
					$elm$virtual_dom$VirtualDom$keyedNode,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
			default:
				var ns = html.a;
				var elemType = html.b;
				var properties = html.c;
				var children = html.d;
				var combinedStyles = A3($elm$core$List$foldl, $rtfeldman$elm_css$VirtualDom$Styled$accumulateStyles, styles, properties);
				var _v5 = A3(
					$elm$core$List$foldl,
					$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
					_Utils_Tuple2(_List_Nil, combinedStyles),
					children);
				var childNodes = _v5.a;
				var finalStyles = _v5.b;
				var vdomNode = A4(
					$elm$virtual_dom$VirtualDom$keyedNodeNS,
					ns,
					elemType,
					A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties),
					$elm$core$List$reverse(childNodes));
				return _Utils_Tuple2(
					A2($elm$core$List$cons, vdomNode, nodes),
					finalStyles);
		}
	});
var $elm$core$Dict$singleton = F2(
	function (key, value) {
		return A5($elm$core$Dict$RBNode_elm_builtin, 1, key, value, $elm$core$Dict$RBEmpty_elm_builtin, $elm$core$Dict$RBEmpty_elm_builtin);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp = F2(
	function (candidate, properties) {
		stylesFromPropertiesHelp:
		while (true) {
			if (!properties.b) {
				return candidate;
			} else {
				var _v1 = properties.a;
				var styles = _v1.b;
				var classname = _v1.c;
				var rest = properties.b;
				if ($elm$core$String$isEmpty(classname)) {
					var $temp$candidate = candidate,
						$temp$properties = rest;
					candidate = $temp$candidate;
					properties = $temp$properties;
					continue stylesFromPropertiesHelp;
				} else {
					var $temp$candidate = $elm$core$Maybe$Just(
						_Utils_Tuple2(classname, styles)),
						$temp$properties = rest;
					candidate = $temp$candidate;
					properties = $temp$properties;
					continue stylesFromPropertiesHelp;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties = function (properties) {
	var _v0 = A2($rtfeldman$elm_css$VirtualDom$Styled$stylesFromPropertiesHelp, $elm$core$Maybe$Nothing, properties);
	if (_v0.$ === 1) {
		return $elm$core$Dict$empty;
	} else {
		var _v1 = _v0.a;
		var classname = _v1.a;
		var styles = _v1.b;
		return A2($elm$core$Dict$singleton, classname, styles);
	}
};
var $elm$core$List$singleton = function (value) {
	return _List_fromArray(
		[value]);
};
var $elm$virtual_dom$VirtualDom$text = _VirtualDom_text;
var $elm$core$List$any = F2(
	function (isOkay, list) {
		any:
		while (true) {
			if (!list.b) {
				return false;
			} else {
				var x = list.a;
				var xs = list.b;
				if (isOkay(x)) {
					return true;
				} else {
					var $temp$isOkay = isOkay,
						$temp$list = xs;
					isOkay = $temp$isOkay;
					list = $temp$list;
					continue any;
				}
			}
		}
	});
var $elm$core$Basics$not = _Basics_not;
var $elm$core$List$all = F2(
	function (isOkay, list) {
		return !A2(
			$elm$core$List$any,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, isOkay),
			list);
	});
var $rtfeldman$elm_css$Css$Structure$compactHelp = F2(
	function (declaration, _v0) {
		var keyframesByName = _v0.a;
		var declarations = _v0.b;
		switch (declaration.$) {
			case 0:
				var _v2 = declaration.a;
				var properties = _v2.c;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 1:
				var styleBlocks = declaration.b;
				return A2(
					$elm$core$List$all,
					function (_v3) {
						var properties = _v3.c;
						return $elm$core$List$isEmpty(properties);
					},
					styleBlocks) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 2:
				var otherDeclarations = declaration.b;
				return $elm$core$List$isEmpty(otherDeclarations) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 3:
				return _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 4:
				var properties = declaration.b;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 5:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 6:
				var record = declaration.a;
				return $elm$core$String$isEmpty(record.fh) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					A3($elm$core$Dict$insert, record.dP, record.fh, keyframesByName),
					declarations);
			case 7:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			case 8:
				var properties = declaration.a;
				return $elm$core$List$isEmpty(properties) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
			default:
				var tuples = declaration.a;
				return A2(
					$elm$core$List$all,
					function (_v4) {
						var properties = _v4.b;
						return $elm$core$List$isEmpty(properties);
					},
					tuples) ? _Utils_Tuple2(keyframesByName, declarations) : _Utils_Tuple2(
					keyframesByName,
					A2($elm$core$List$cons, declaration, declarations));
		}
	});
var $rtfeldman$elm_css$Css$Structure$Keyframes = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations = F2(
	function (keyframesByName, compactedDeclarations) {
		return A2(
			$elm$core$List$append,
			A2(
				$elm$core$List$map,
				function (_v0) {
					var name = _v0.a;
					var decl = _v0.b;
					return $rtfeldman$elm_css$Css$Structure$Keyframes(
						{fh: decl, dP: name});
				},
				$elm$core$Dict$toList(keyframesByName)),
			compactedDeclarations);
	});
var $rtfeldman$elm_css$Css$Structure$compactStylesheet = function (_v0) {
	var charset = _v0.c4;
	var imports = _v0.du;
	var namespaces = _v0.dQ;
	var declarations = _v0.fi;
	var _v1 = A3(
		$elm$core$List$foldr,
		$rtfeldman$elm_css$Css$Structure$compactHelp,
		_Utils_Tuple2($elm$core$Dict$empty, _List_Nil),
		declarations);
	var keyframesByName = _v1.a;
	var compactedDeclarations = _v1.b;
	var finalDeclarations = A2($rtfeldman$elm_css$Css$Structure$withKeyframeDeclarations, keyframesByName, compactedDeclarations);
	return {c4: charset, fi: finalDeclarations, du: imports, dQ: namespaces};
};
var $rtfeldman$elm_css$Css$Structure$Output$charsetToString = function (charset) {
	return A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			function (str) {
				return '@charset \"' + (str + '\"');
			},
			charset));
};
var $elm$core$List$filter = F2(
	function (isGood, list) {
		return A3(
			$elm$core$List$foldr,
			F2(
				function (x, xs) {
					return isGood(x) ? A2($elm$core$List$cons, x, xs) : xs;
				}),
			_List_Nil,
			list);
	});
var $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString = function (expression) {
	return '(' + (expression.di + (A2(
		$elm$core$Maybe$withDefault,
		'',
		A2(
			$elm$core$Maybe$map,
			$elm$core$Basics$append(': '),
			expression.cO)) + ')'));
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString = function (mediaType) {
	switch (mediaType) {
		case 0:
			return 'print';
		case 1:
			return 'screen';
		default:
			return 'speech';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString = function (mediaQuery) {
	var prefixWith = F3(
		function (str, mediaType, expressions) {
			return str + (' ' + A2(
				$elm$core$String$join,
				' and ',
				A2(
					$elm$core$List$cons,
					$rtfeldman$elm_css$Css$Structure$Output$mediaTypeToString(mediaType),
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions))));
		});
	switch (mediaQuery.$) {
		case 0:
			var expressions = mediaQuery.a;
			return A2(
				$elm$core$String$join,
				' and ',
				A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaExpressionToString, expressions));
		case 1:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'only', mediaType, expressions);
		case 2:
			var mediaType = mediaQuery.a;
			var expressions = mediaQuery.b;
			return A3(prefixWith, 'not', mediaType, expressions);
		default:
			var str = mediaQuery.a;
			return str;
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString = F2(
	function (name, mediaQuery) {
		return '@import \"' + (name + ($rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString(mediaQuery) + '\"'));
	});
var $rtfeldman$elm_css$Css$Structure$Output$importToString = function (_v0) {
	var name = _v0.a;
	var mediaQueries = _v0.b;
	return A2(
		$elm$core$String$join,
		'\n',
		A2(
			$elm$core$List$map,
			$rtfeldman$elm_css$Css$Structure$Output$importMediaQueryToString(name),
			mediaQueries));
};
var $rtfeldman$elm_css$Css$Structure$Output$namespaceToString = function (_v0) {
	var prefix = _v0.a;
	var str = _v0.b;
	return '@namespace ' + (prefix + ('\"' + (str + '\"')));
};
var $rtfeldman$elm_css$Css$Structure$Output$spaceIndent = '    ';
var $rtfeldman$elm_css$Css$Structure$Output$indent = function (str) {
	return _Utils_ap($rtfeldman$elm_css$Css$Structure$Output$spaceIndent, str);
};
var $rtfeldman$elm_css$Css$Structure$Output$noIndent = '';
var $rtfeldman$elm_css$Css$Structure$Output$emitProperty = function (str) {
	return str + ';';
};
var $rtfeldman$elm_css$Css$Structure$Output$emitProperties = function (properties) {
	return A2(
		$elm$core$String$join,
		'\n',
		A2(
			$elm$core$List$map,
			A2($elm$core$Basics$composeL, $rtfeldman$elm_css$Css$Structure$Output$indent, $rtfeldman$elm_css$Css$Structure$Output$emitProperty),
			properties));
};
var $elm$core$String$append = _String_append;
var $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString = function (_v0) {
	var str = _v0;
	return '::' + str;
};
var $rtfeldman$elm_css$Css$Structure$Output$combinatorToString = function (combinator) {
	switch (combinator) {
		case 0:
			return '+';
		case 1:
			return '~';
		case 2:
			return '>';
		default:
			return '';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString = function (repeatableSimpleSelector) {
	switch (repeatableSimpleSelector.$) {
		case 0:
			var str = repeatableSimpleSelector.a;
			return '.' + str;
		case 1:
			var str = repeatableSimpleSelector.a;
			return '#' + str;
		case 2:
			var str = repeatableSimpleSelector.a;
			return ':' + str;
		default:
			var str = repeatableSimpleSelector.a;
			return '[' + (str + ']');
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString = function (simpleSelectorSequence) {
	switch (simpleSelectorSequence.$) {
		case 0:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return A2(
				$elm$core$String$join,
				'',
				A2(
					$elm$core$List$cons,
					str,
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
		case 1:
			var repeatableSimpleSelectors = simpleSelectorSequence.a;
			return $elm$core$List$isEmpty(repeatableSimpleSelectors) ? '*' : A2(
				$elm$core$String$join,
				'',
				A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors));
		default:
			var str = simpleSelectorSequence.a;
			var repeatableSimpleSelectors = simpleSelectorSequence.b;
			return A2(
				$elm$core$String$join,
				'',
				A2(
					$elm$core$List$cons,
					str,
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$repeatableSimpleSelectorToString, repeatableSimpleSelectors)));
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString = function (_v0) {
	var combinator = _v0.a;
	var sequence = _v0.b;
	return A2(
		$elm$core$String$join,
		' ',
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$Structure$Output$combinatorToString(combinator),
				$rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(sequence)
			]));
};
var $rtfeldman$elm_css$Css$Structure$Output$selectorToString = function (_v0) {
	var simpleSelectorSequence = _v0.a;
	var chain = _v0.b;
	var pseudoElement = _v0.c;
	var segments = A2(
		$elm$core$List$cons,
		$rtfeldman$elm_css$Css$Structure$Output$simpleSelectorSequenceToString(simpleSelectorSequence),
		A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$selectorChainToString, chain));
	var pseudoElementsString = A2(
		$elm$core$String$join,
		'',
		_List_fromArray(
			[
				A2(
				$elm$core$Maybe$withDefault,
				'',
				A2($elm$core$Maybe$map, $rtfeldman$elm_css$Css$Structure$Output$pseudoElementToString, pseudoElement))
			]));
	return A2(
		$elm$core$String$append,
		A2(
			$elm$core$String$join,
			' ',
			A2(
				$elm$core$List$filter,
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
				segments)),
		pseudoElementsString);
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock = F2(
	function (indentLevel, _v0) {
		var firstSelector = _v0.a;
		var otherSelectors = _v0.b;
		var properties = _v0.c;
		var selectorStr = A2(
			$elm$core$String$join,
			', ',
			A2(
				$elm$core$List$map,
				$rtfeldman$elm_css$Css$Structure$Output$selectorToString,
				A2($elm$core$List$cons, firstSelector, otherSelectors)));
		return A2(
			$elm$core$String$join,
			'',
			_List_fromArray(
				[
					selectorStr,
					' {\n',
					indentLevel,
					$rtfeldman$elm_css$Css$Structure$Output$emitProperties(properties),
					'\n',
					indentLevel,
					'}'
				]));
	});
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration = function (decl) {
	switch (decl.$) {
		case 0:
			var styleBlock = decl.a;
			return A2($rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock, $rtfeldman$elm_css$Css$Structure$Output$noIndent, styleBlock);
		case 1:
			var mediaQueries = decl.a;
			var styleBlocks = decl.b;
			var query = A2(
				$elm$core$String$join,
				',\n',
				A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$mediaQueryToString, mediaQueries));
			var blocks = A2(
				$elm$core$String$join,
				'\n\n',
				A2(
					$elm$core$List$map,
					A2(
						$elm$core$Basics$composeL,
						$rtfeldman$elm_css$Css$Structure$Output$indent,
						$rtfeldman$elm_css$Css$Structure$Output$prettyPrintStyleBlock($rtfeldman$elm_css$Css$Structure$Output$spaceIndent)),
					styleBlocks));
			return '@media ' + (query + (' {\n' + (blocks + '\n}')));
		case 2:
			return 'TODO';
		case 3:
			return 'TODO';
		case 4:
			return 'TODO';
		case 5:
			return 'TODO';
		case 6:
			var name = decl.a.dP;
			var declaration = decl.a.fh;
			return '@keyframes ' + (name + (' {\n' + (declaration + '\n}')));
		case 7:
			return 'TODO';
		case 8:
			return 'TODO';
		default:
			return 'TODO';
	}
};
var $rtfeldman$elm_css$Css$Structure$Output$prettyPrint = function (_v0) {
	var charset = _v0.c4;
	var imports = _v0.du;
	var namespaces = _v0.dQ;
	var declarations = _v0.fi;
	return A2(
		$elm$core$String$join,
		'\n\n',
		A2(
			$elm$core$List$filter,
			A2($elm$core$Basics$composeL, $elm$core$Basics$not, $elm$core$String$isEmpty),
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$Output$charsetToString(charset),
					A2(
					$elm$core$String$join,
					'\n',
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$importToString, imports)),
					A2(
					$elm$core$String$join,
					'\n',
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$namespaceToString, namespaces)),
					A2(
					$elm$core$String$join,
					'\n\n',
					A2($elm$core$List$map, $rtfeldman$elm_css$Css$Structure$Output$prettyPrintDeclaration, declarations))
				])));
};
var $rtfeldman$elm_css$Css$Structure$CounterStyle = function (a) {
	return {$: 8, a: a};
};
var $rtfeldman$elm_css$Css$Structure$FontFace = function (a) {
	return {$: 5, a: a};
};
var $rtfeldman$elm_css$Css$Structure$PageRule = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$Selector = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$Structure$SupportsRule = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$Viewport = function (a) {
	return {$: 7, a: a};
};
var $rtfeldman$elm_css$Css$Structure$MediaRule = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$mapLast = F2(
	function (update, list) {
		if (!list.b) {
			return list;
		} else {
			if (!list.b.b) {
				var only = list.a;
				return _List_fromArray(
					[
						update(only)
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$mapLast, update, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$withPropertyAppended = F2(
	function (property, _v0) {
		var firstSelector = _v0.a;
		var otherSelectors = _v0.b;
		var properties = _v0.c;
		return A3(
			$rtfeldman$elm_css$Css$Structure$StyleBlock,
			firstSelector,
			otherSelectors,
			_Utils_ap(
				properties,
				_List_fromArray(
					[property])));
	});
var $rtfeldman$elm_css$Css$Structure$appendProperty = F2(
	function (property, declarations) {
		if (!declarations.b) {
			return declarations;
		} else {
			if (!declarations.b.b) {
				switch (declarations.a.$) {
					case 0:
						var styleBlock = declarations.a.a;
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
								A2($rtfeldman$elm_css$Css$Structure$withPropertyAppended, property, styleBlock))
							]);
					case 1:
						var _v1 = declarations.a;
						var mediaQueries = _v1.a;
						var styleBlocks = _v1.b;
						return _List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Css$Structure$MediaRule,
								mediaQueries,
								A2(
									$rtfeldman$elm_css$Css$Structure$mapLast,
									$rtfeldman$elm_css$Css$Structure$withPropertyAppended(property),
									styleBlocks))
							]);
					default:
						return declarations;
				}
			} else {
				var first = declarations.a;
				var rest = declarations.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendToLastSelector = F2(
	function (f, styleBlock) {
		if (!styleBlock.b.b) {
			var only = styleBlock.a;
			var properties = styleBlock.c;
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, only, _List_Nil, properties),
					A3(
					$rtfeldman$elm_css$Css$Structure$StyleBlock,
					f(only),
					_List_Nil,
					_List_Nil)
				]);
		} else {
			var first = styleBlock.a;
			var rest = styleBlock.b;
			var properties = styleBlock.c;
			var newRest = A2($elm$core$List$map, f, rest);
			var newFirst = f(first);
			return _List_fromArray(
				[
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, rest, properties),
					A3($rtfeldman$elm_css$Css$Structure$StyleBlock, newFirst, newRest, _List_Nil)
				]);
		}
	});
var $rtfeldman$elm_css$Css$Structure$applyPseudoElement = F2(
	function (pseudo, _v0) {
		var sequence = _v0.a;
		var selectors = _v0.b;
		return A3(
			$rtfeldman$elm_css$Css$Structure$Selector,
			sequence,
			selectors,
			$elm$core$Maybe$Just(pseudo));
	});
var $rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector = F2(
	function (pseudo, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$applyPseudoElement(pseudo),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Structure$CustomSelector = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$TypeSelectorSequence = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence = function (a) {
	return {$: 1, a: a};
};
var $rtfeldman$elm_css$Css$Structure$appendRepeatable = F2(
	function (selector, sequence) {
		switch (sequence.$) {
			case 0:
				var typeSelector = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$TypeSelectorSequence,
					typeSelector,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			case 1:
				var list = sequence.a;
				return $rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
			default:
				var str = sequence.a;
				var list = sequence.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$CustomSelector,
					str,
					_Utils_ap(
						list,
						_List_fromArray(
							[selector])));
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator = F2(
	function (selector, list) {
		if (!list.b) {
			return _List_Nil;
		} else {
			if (!list.b.b) {
				var _v1 = list.a;
				var combinator = _v1.a;
				var sequence = _v1.b;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						combinator,
						A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, selector, sequence))
					]);
			} else {
				var first = list.a;
				var rest = list.b;
				return A2(
					$elm$core$List$cons,
					first,
					A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, selector, rest));
			}
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableSelector = F2(
	function (repeatableSimpleSelector, selector) {
		if (!selector.b.b) {
			var sequence = selector.a;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatable, repeatableSimpleSelector, sequence),
				_List_Nil,
				pseudoElement);
		} else {
			var firstSelector = selector.a;
			var tuples = selector.b;
			var pseudoElement = selector.c;
			return A3(
				$rtfeldman$elm_css$Css$Structure$Selector,
				firstSelector,
				A2($rtfeldman$elm_css$Css$Structure$appendRepeatableWithCombinator, repeatableSimpleSelector, tuples),
				pseudoElement);
		}
	});
var $rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector = F2(
	function (selector, styleBlock) {
		return A2(
			$rtfeldman$elm_css$Css$Structure$appendToLastSelector,
			$rtfeldman$elm_css$Css$Structure$appendRepeatableSelector(selector),
			styleBlock);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors = function (declarations) {
	collectSelectors:
	while (true) {
		if (!declarations.b) {
			return _List_Nil;
		} else {
			if (!declarations.a.$) {
				var _v1 = declarations.a.a;
				var firstSelector = _v1.a;
				var otherSelectors = _v1.b;
				var rest = declarations.b;
				return _Utils_ap(
					A2($elm$core$List$cons, firstSelector, otherSelectors),
					$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(rest));
			} else {
				var rest = declarations.b;
				var $temp$declarations = rest;
				declarations = $temp$declarations;
				continue collectSelectors;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$DocumentRule = F5(
	function (a, b, c, d, e) {
		return {$: 3, a: a, b: b, c: c, d: d, e: e};
	});
var $rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock = F2(
	function (update, declarations) {
		_v0$12:
		while (true) {
			if (!declarations.b) {
				return declarations;
			} else {
				if (!declarations.b.b) {
					switch (declarations.a.$) {
						case 0:
							var styleBlock = declarations.a.a;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration,
								update(styleBlock));
						case 1:
							if (declarations.a.b.b) {
								if (!declarations.a.b.b.b) {
									var _v1 = declarations.a;
									var mediaQueries = _v1.a;
									var _v2 = _v1.b;
									var styleBlock = _v2.a;
									return _List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Css$Structure$MediaRule,
											mediaQueries,
											update(styleBlock))
										]);
								} else {
									var _v3 = declarations.a;
									var mediaQueries = _v3.a;
									var _v4 = _v3.b;
									var first = _v4.a;
									var rest = _v4.b;
									var _v5 = A2(
										$rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock,
										update,
										_List_fromArray(
											[
												A2($rtfeldman$elm_css$Css$Structure$MediaRule, mediaQueries, rest)
											]));
									if ((_v5.b && (_v5.a.$ === 1)) && (!_v5.b.b)) {
										var _v6 = _v5.a;
										var newMediaQueries = _v6.a;
										var newStyleBlocks = _v6.b;
										return _List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Css$Structure$MediaRule,
												newMediaQueries,
												A2($elm$core$List$cons, first, newStyleBlocks))
											]);
									} else {
										var newDeclarations = _v5;
										return newDeclarations;
									}
								}
							} else {
								break _v0$12;
							}
						case 2:
							var _v7 = declarations.a;
							var str = _v7.a;
							var nestedDeclarations = _v7.b;
							return _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Css$Structure$SupportsRule,
									str,
									A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, nestedDeclarations))
								]);
						case 3:
							var _v8 = declarations.a;
							var str1 = _v8.a;
							var str2 = _v8.b;
							var str3 = _v8.c;
							var str4 = _v8.d;
							var styleBlock = _v8.e;
							return A2(
								$elm$core$List$map,
								A4($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4),
								update(styleBlock));
						case 4:
							var _v9 = declarations.a;
							return declarations;
						case 5:
							return declarations;
						case 6:
							return declarations;
						case 7:
							return declarations;
						case 8:
							return declarations;
						default:
							return declarations;
					}
				} else {
					break _v0$12;
				}
			}
		}
		var first = declarations.a;
		var rest = declarations.b;
		return A2(
			$elm$core$List$cons,
			first,
			A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, update, rest));
	});
var $elm$core$String$cons = _String_cons;
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData = F4(
	function (shift, seed, hash, charsProcessed) {
		return {aG: charsProcessed, aM: hash, M: seed, aU: shift};
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$c1 = 3432918353;
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$c2 = 461845907;
var $elm$core$Bitwise$and = _Bitwise_and;
var $elm$core$Bitwise$shiftLeftBy = _Bitwise_shiftLeftBy;
var $elm$core$Bitwise$shiftRightZfBy = _Bitwise_shiftRightZfBy;
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy = F2(
	function (b, a) {
		return ((a & 65535) * b) + ((((a >>> 16) * b) & 65535) << 16);
	});
var $elm$core$Basics$neq = _Utils_notEqual;
var $elm$core$Bitwise$or = _Bitwise_or;
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy = F2(
	function (b, a) {
		return (a << b) | (a >>> (32 - b));
	});
var $elm$core$Bitwise$xor = _Bitwise_xor;
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize = function (data) {
	var acc = (!(!data.aM)) ? (data.M ^ A2(
		$rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
		$rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
		A2(
			$rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
			15,
			A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, $rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, data.aM)))) : data.M;
	var h0 = acc ^ data.aG;
	var h1 = A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 2246822507, h0 ^ (h0 >>> 16));
	var h2 = A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, 3266489909, h1 ^ (h1 >>> 13));
	return (h2 ^ (h2 >>> 16)) >>> 0;
};
var $elm$core$String$foldl = _String_foldl;
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$mix = F2(
	function (h1, k1) {
		return A2(
			$rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
			5,
			A2(
				$rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
				13,
				h1 ^ A2(
					$rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy,
					$rtfeldman$elm_css$ElmCssVendor$Murmur3$c2,
					A2(
						$rtfeldman$elm_css$ElmCssVendor$Murmur3$rotlBy,
						15,
						A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$multiplyBy, $rtfeldman$elm_css$ElmCssVendor$Murmur3$c1, k1))))) + 3864292196;
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold = F2(
	function (c, data) {
		var res = data.aM | ((255 & $elm$core$Char$toCode(c)) << data.aU);
		var _v0 = data.aU;
		if (_v0 === 24) {
			return {
				aG: data.aG + 1,
				aM: 0,
				M: A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$mix, data.M, res),
				aU: 0
			};
		} else {
			return {aG: data.aG + 1, aM: res, M: data.M, aU: data.aU + 8};
		}
	});
var $rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString = F2(
	function (seed, str) {
		return $rtfeldman$elm_css$ElmCssVendor$Murmur3$finalize(
			A3(
				$elm$core$String$foldl,
				$rtfeldman$elm_css$ElmCssVendor$Murmur3$hashFold,
				A4($rtfeldman$elm_css$ElmCssVendor$Murmur3$HashData, 0, seed, 0, 0),
				str));
	});
var $rtfeldman$elm_css$Hash$murmurSeed = 15739;
var $elm$core$String$fromList = _String_fromList;
var $elm$core$Basics$negate = function (n) {
	return -n;
};
var $elm$core$Basics$modBy = _Basics_modBy;
var $rtfeldman$elm_hex$Hex$unsafeToDigit = function (num) {
	unsafeToDigit:
	while (true) {
		switch (num) {
			case 0:
				return '0';
			case 1:
				return '1';
			case 2:
				return '2';
			case 3:
				return '3';
			case 4:
				return '4';
			case 5:
				return '5';
			case 6:
				return '6';
			case 7:
				return '7';
			case 8:
				return '8';
			case 9:
				return '9';
			case 10:
				return 'a';
			case 11:
				return 'b';
			case 12:
				return 'c';
			case 13:
				return 'd';
			case 14:
				return 'e';
			case 15:
				return 'f';
			default:
				var $temp$num = num;
				num = $temp$num;
				continue unsafeToDigit;
		}
	}
};
var $rtfeldman$elm_hex$Hex$unsafePositiveToDigits = F2(
	function (digits, num) {
		unsafePositiveToDigits:
		while (true) {
			if (num < 16) {
				return A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(num),
					digits);
			} else {
				var $temp$digits = A2(
					$elm$core$List$cons,
					$rtfeldman$elm_hex$Hex$unsafeToDigit(
						A2($elm$core$Basics$modBy, 16, num)),
					digits),
					$temp$num = (num / 16) | 0;
				digits = $temp$digits;
				num = $temp$num;
				continue unsafePositiveToDigits;
			}
		}
	});
var $rtfeldman$elm_hex$Hex$toString = function (num) {
	return $elm$core$String$fromList(
		(num < 0) ? A2(
			$elm$core$List$cons,
			'-',
			A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, -num)) : A2($rtfeldman$elm_hex$Hex$unsafePositiveToDigits, _List_Nil, num));
};
var $rtfeldman$elm_css$Hash$fromString = function (str) {
	return A2(
		$elm$core$String$cons,
		'_',
		$rtfeldman$elm_hex$Hex$toString(
			A2($rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString, $rtfeldman$elm_css$Hash$murmurSeed, str)));
};
var $elm$core$List$head = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(x);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$last = function (list) {
	last:
	while (true) {
		if (!list.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!list.b.b) {
				var singleton = list.a;
				return $elm$core$Maybe$Just(singleton);
			} else {
				var rest = list.b;
				var $temp$list = rest;
				list = $temp$list;
				continue last;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration = function (declarations) {
	lastDeclaration:
	while (true) {
		if (!declarations.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			if (!declarations.b.b) {
				var x = declarations.a;
				return $elm$core$Maybe$Just(
					_List_fromArray(
						[x]));
			} else {
				var xs = declarations.b;
				var $temp$declarations = xs;
				declarations = $temp$declarations;
				continue lastDeclaration;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf = function (maybes) {
	oneOf:
	while (true) {
		if (!maybes.b) {
			return $elm$core$Maybe$Nothing;
		} else {
			var maybe = maybes.a;
			var rest = maybes.b;
			if (maybe.$ === 1) {
				var $temp$maybes = rest;
				maybes = $temp$maybes;
				continue oneOf;
			} else {
				return maybe;
			}
		}
	}
};
var $rtfeldman$elm_css$Css$Structure$FontFeatureValues = function (a) {
	return {$: 9, a: a};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues = function (tuples) {
	var expandTuples = function (tuplesToExpand) {
		if (!tuplesToExpand.b) {
			return _List_Nil;
		} else {
			var properties = tuplesToExpand.a;
			var rest = tuplesToExpand.b;
			return A2(
				$elm$core$List$cons,
				properties,
				expandTuples(rest));
		}
	};
	var newTuples = expandTuples(tuples);
	return _List_fromArray(
		[
			$rtfeldman$elm_css$Css$Structure$FontFeatureValues(newTuples)
		]);
};
var $rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule = F2(
	function (mediaQueries, declaration) {
		if (!declaration.$) {
			var styleBlock = declaration.a;
			return A2(
				$rtfeldman$elm_css$Css$Structure$MediaRule,
				mediaQueries,
				_List_fromArray(
					[styleBlock]));
		} else {
			return declaration;
		}
	});
var $elm$core$List$tail = function (list) {
	if (list.b) {
		var x = list.a;
		var xs = list.b;
		return $elm$core$Maybe$Just(xs);
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $elm$core$List$takeReverse = F3(
	function (n, list, kept) {
		takeReverse:
		while (true) {
			if (n <= 0) {
				return kept;
			} else {
				if (!list.b) {
					return kept;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs,
						$temp$kept = A2($elm$core$List$cons, x, kept);
					n = $temp$n;
					list = $temp$list;
					kept = $temp$kept;
					continue takeReverse;
				}
			}
		}
	});
var $elm$core$List$takeTailRec = F2(
	function (n, list) {
		return $elm$core$List$reverse(
			A3($elm$core$List$takeReverse, n, list, _List_Nil));
	});
var $elm$core$List$takeFast = F3(
	function (ctr, n, list) {
		if (n <= 0) {
			return _List_Nil;
		} else {
			var _v0 = _Utils_Tuple2(n, list);
			_v0$1:
			while (true) {
				_v0$5:
				while (true) {
					if (!_v0.b.b) {
						return list;
					} else {
						if (_v0.b.b.b) {
							switch (_v0.a) {
								case 1:
									break _v0$1;
								case 2:
									var _v2 = _v0.b;
									var x = _v2.a;
									var _v3 = _v2.b;
									var y = _v3.a;
									return _List_fromArray(
										[x, y]);
								case 3:
									if (_v0.b.b.b.b) {
										var _v4 = _v0.b;
										var x = _v4.a;
										var _v5 = _v4.b;
										var y = _v5.a;
										var _v6 = _v5.b;
										var z = _v6.a;
										return _List_fromArray(
											[x, y, z]);
									} else {
										break _v0$5;
									}
								default:
									if (_v0.b.b.b.b && _v0.b.b.b.b.b) {
										var _v7 = _v0.b;
										var x = _v7.a;
										var _v8 = _v7.b;
										var y = _v8.a;
										var _v9 = _v8.b;
										var z = _v9.a;
										var _v10 = _v9.b;
										var w = _v10.a;
										var tl = _v10.b;
										return (ctr > 1000) ? A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A2($elm$core$List$takeTailRec, n - 4, tl))))) : A2(
											$elm$core$List$cons,
											x,
											A2(
												$elm$core$List$cons,
												y,
												A2(
													$elm$core$List$cons,
													z,
													A2(
														$elm$core$List$cons,
														w,
														A3($elm$core$List$takeFast, ctr + 1, n - 4, tl)))));
									} else {
										break _v0$5;
									}
							}
						} else {
							if (_v0.a === 1) {
								break _v0$1;
							} else {
								break _v0$5;
							}
						}
					}
				}
				return list;
			}
			var _v1 = _v0.b;
			var x = _v1.a;
			return _List_fromArray(
				[x]);
		}
	});
var $elm$core$List$take = F2(
	function (n, list) {
		return A3($elm$core$List$takeFast, 0, n, list);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule = F5(
	function (str1, str2, str3, str4, declaration) {
		if (!declaration.$) {
			var structureStyleBlock = declaration.a;
			return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
		} else {
			return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule = F2(
	function (mediaQueries, declaration) {
		switch (declaration.$) {
			case 0:
				var structureStyleBlock = declaration.a;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					mediaQueries,
					_List_fromArray(
						[structureStyleBlock]));
			case 1:
				var newMediaQueries = declaration.a;
				var structureStyleBlocks = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$MediaRule,
					_Utils_ap(mediaQueries, newMediaQueries),
					structureStyleBlocks);
			case 2:
				var str = declaration.a;
				var declarations = declaration.b;
				return A2(
					$rtfeldman$elm_css$Css$Structure$SupportsRule,
					str,
					A2(
						$elm$core$List$map,
						$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
						declarations));
			case 3:
				var str1 = declaration.a;
				var str2 = declaration.b;
				var str3 = declaration.c;
				var str4 = declaration.d;
				var structureStyleBlock = declaration.e;
				return A5($rtfeldman$elm_css$Css$Structure$DocumentRule, str1, str2, str3, str4, structureStyleBlock);
			case 4:
				return declaration;
			case 5:
				return declaration;
			case 6:
				return declaration;
			case 7:
				return declaration;
			case 8:
				return declaration;
			default:
				return declaration;
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet = function (_v0) {
	var declarations = _v0;
	return declarations;
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast = F4(
	function (nestedStyles, rest, f, declarations) {
		var withoutParent = function (decls) {
			return A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$elm$core$List$tail(decls));
		};
		var nextResult = A2(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
			rest,
			A2(
				$elm$core$Maybe$withDefault,
				_List_Nil,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		var newDeclarations = function () {
			var _v14 = _Utils_Tuple2(
				$elm$core$List$head(nextResult),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$last(declarations));
			if ((!_v14.a.$) && (!_v14.b.$)) {
				var nextResultParent = _v14.a.a;
				var originalParent = _v14.b.a;
				return _Utils_ap(
					A2(
						$elm$core$List$take,
						$elm$core$List$length(declarations) - 1,
						declarations),
					_List_fromArray(
						[
							(!_Utils_eq(originalParent, nextResultParent)) ? nextResultParent : originalParent
						]));
			} else {
				return declarations;
			}
		}();
		var insertStylesToNestedDecl = function (lastDecl) {
			return $elm$core$List$concat(
				A2(
					$rtfeldman$elm_css$Css$Structure$mapLast,
					$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles(nestedStyles),
					A2(
						$elm$core$List$map,
						$elm$core$List$singleton,
						A2($rtfeldman$elm_css$Css$Structure$concatMapLastStyleBlock, f, lastDecl))));
		};
		var initialResult = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				insertStylesToNestedDecl,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$lastDeclaration(declarations)));
		return _Utils_ap(
			newDeclarations,
			_Utils_ap(
				withoutParent(initialResult),
				withoutParent(nextResult)));
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles = F2(
	function (styles, declarations) {
		if (!styles.b) {
			return declarations;
		} else {
			switch (styles.a.$) {
				case 0:
					var property = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, property, declarations));
				case 1:
					var _v4 = styles.a;
					var selector = _v4.a;
					var nestedStyles = _v4.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendRepeatableToLastSelector(selector),
						declarations);
				case 2:
					var _v5 = styles.a;
					var selectorCombinator = _v5.a;
					var snippets = _v5.b;
					var rest = styles.b;
					var chain = F2(
						function (_v9, _v10) {
							var originalSequence = _v9.a;
							var originalTuples = _v9.b;
							var originalPseudoElement = _v9.c;
							var newSequence = _v10.a;
							var newTuples = _v10.b;
							var newPseudoElement = _v10.c;
							return A3(
								$rtfeldman$elm_css$Css$Structure$Selector,
								originalSequence,
								_Utils_ap(
									originalTuples,
									A2(
										$elm$core$List$cons,
										_Utils_Tuple2(selectorCombinator, newSequence),
										newTuples)),
								$rtfeldman$elm_css$Css$Preprocess$Resolve$oneOf(
									_List_fromArray(
										[newPseudoElement, originalPseudoElement])));
						});
					var expandDeclaration = function (declaration) {
						switch (declaration.$) {
							case 0:
								var _v7 = declaration.a;
								var firstSelector = _v7.a;
								var otherSelectors = _v7.b;
								var nestedStyles = _v7.c;
								var newSelectors = A2(
									$elm$core$List$concatMap,
									function (originalSelector) {
										return A2(
											$elm$core$List$map,
											chain(originalSelector),
											A2($elm$core$List$cons, firstSelector, otherSelectors));
									},
									$rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations));
								var newDeclarations = function () {
									if (!newSelectors.b) {
										return _List_Nil;
									} else {
										var first = newSelectors.a;
										var remainder = newSelectors.b;
										return _List_fromArray(
											[
												$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
												A3($rtfeldman$elm_css$Css$Structure$StyleBlock, first, remainder, _List_Nil))
											]);
									}
								}();
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, nestedStyles, newDeclarations);
							case 1:
								var mediaQueries = declaration.a;
								var styleBlocks = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
							case 2:
								var str = declaration.a;
								var otherSnippets = declaration.b;
								return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, otherSnippets);
							case 3:
								var str1 = declaration.a;
								var str2 = declaration.b;
								var str3 = declaration.c;
								var str4 = declaration.d;
								var styleBlock = declaration.e;
								return A2(
									$elm$core$List$map,
									A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
									$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
							case 4:
								var str = declaration.a;
								var properties = declaration.b;
								return _List_fromArray(
									[
										A2($rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
									]);
							case 5:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$FontFace(properties)
									]);
							case 6:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$Viewport(properties)
									]);
							case 7:
								var properties = declaration.a;
								return _List_fromArray(
									[
										$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
									]);
							default:
								var tuples = declaration.a;
								return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
						}
					};
					return $elm$core$List$concat(
						_Utils_ap(
							_List_fromArray(
								[
									A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations)
								]),
							A2(
								$elm$core$List$map,
								expandDeclaration,
								A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets))));
				case 3:
					var _v11 = styles.a;
					var pseudoElement = _v11.a;
					var nestedStyles = _v11.b;
					var rest = styles.b;
					return A4(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyNestedStylesToLast,
						nestedStyles,
						rest,
						$rtfeldman$elm_css$Css$Structure$appendPseudoElementToLastSelector(pseudoElement),
						declarations);
				case 5:
					var str = styles.a.a;
					var rest = styles.b;
					var name = $rtfeldman$elm_css$Hash$fromString(str);
					var newProperty = 'animation-name:' + name;
					var newDeclarations = A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						rest,
						A2($rtfeldman$elm_css$Css$Structure$appendProperty, newProperty, declarations));
					return A2(
						$elm$core$List$append,
						newDeclarations,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Css$Structure$Keyframes(
								{fh: str, dP: name})
							]));
				case 4:
					var _v12 = styles.a;
					var mediaQueries = _v12.a;
					var nestedStyles = _v12.b;
					var rest = styles.b;
					var extraDeclarations = function () {
						var _v13 = $rtfeldman$elm_css$Css$Preprocess$Resolve$collectSelectors(declarations);
						if (!_v13.b) {
							return _List_Nil;
						} else {
							var firstSelector = _v13.a;
							var otherSelectors = _v13.b;
							return A2(
								$elm$core$List$map,
								$rtfeldman$elm_css$Css$Structure$styleBlockToMediaRule(mediaQueries),
								A2(
									$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
									nestedStyles,
									$elm$core$List$singleton(
										$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
											A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil)))));
						}
					}();
					return _Utils_ap(
						A2($rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles, rest, declarations),
						extraDeclarations);
				default:
					var otherStyles = styles.a.a;
					var rest = styles.b;
					return A2(
						$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
						_Utils_ap(otherStyles, rest),
						declarations);
			}
		}
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock = function (_v2) {
	var firstSelector = _v2.a;
	var otherSelectors = _v2.b;
	var styles = _v2.c;
	return A2(
		$rtfeldman$elm_css$Css$Preprocess$Resolve$applyStyles,
		styles,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Css$Structure$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Structure$StyleBlock, firstSelector, otherSelectors, _List_Nil))
			]));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$extract = function (snippetDeclarations) {
	if (!snippetDeclarations.b) {
		return _List_Nil;
	} else {
		var first = snippetDeclarations.a;
		var rest = snippetDeclarations.b;
		return _Utils_ap(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations(first),
			$rtfeldman$elm_css$Css$Preprocess$Resolve$extract(rest));
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule = F2(
	function (mediaQueries, styleBlocks) {
		var handleStyleBlock = function (styleBlock) {
			return A2(
				$elm$core$List$map,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$toMediaRule(mediaQueries),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		};
		return A2($elm$core$List$concatMap, handleStyleBlock, styleBlocks);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule = F2(
	function (str, snippets) {
		var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
			A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
		return _List_fromArray(
			[
				A2($rtfeldman$elm_css$Css$Structure$SupportsRule, str, declarations)
			]);
	});
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toDeclarations = function (snippetDeclaration) {
	switch (snippetDeclaration.$) {
		case 0:
			var styleBlock = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock);
		case 1:
			var mediaQueries = snippetDeclaration.a;
			var styleBlocks = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveMediaRule, mediaQueries, styleBlocks);
		case 2:
			var str = snippetDeclaration.a;
			var snippets = snippetDeclaration.b;
			return A2($rtfeldman$elm_css$Css$Preprocess$Resolve$resolveSupportsRule, str, snippets);
		case 3:
			var str1 = snippetDeclaration.a;
			var str2 = snippetDeclaration.b;
			var str3 = snippetDeclaration.c;
			var str4 = snippetDeclaration.d;
			var styleBlock = snippetDeclaration.e;
			return A2(
				$elm$core$List$map,
				A4($rtfeldman$elm_css$Css$Preprocess$Resolve$toDocumentRule, str1, str2, str3, str4),
				$rtfeldman$elm_css$Css$Preprocess$Resolve$expandStyleBlock(styleBlock));
		case 4:
			var str = snippetDeclaration.a;
			var properties = snippetDeclaration.b;
			return _List_fromArray(
				[
					A2($rtfeldman$elm_css$Css$Structure$PageRule, str, properties)
				]);
		case 5:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$FontFace(properties)
				]);
		case 6:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$Viewport(properties)
				]);
		case 7:
			var properties = snippetDeclaration.a;
			return _List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$CounterStyle(properties)
				]);
		default:
			var tuples = snippetDeclaration.a;
			return $rtfeldman$elm_css$Css$Preprocess$Resolve$resolveFontFeatureValues(tuples);
	}
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure = function (_v0) {
	var charset = _v0.c4;
	var imports = _v0.du;
	var namespaces = _v0.dQ;
	var snippets = _v0.ez;
	var declarations = $rtfeldman$elm_css$Css$Preprocess$Resolve$extract(
		A2($elm$core$List$concatMap, $rtfeldman$elm_css$Css$Preprocess$unwrapSnippet, snippets));
	return {c4: charset, fi: declarations, du: imports, dQ: namespaces};
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp = function (sheet) {
	return $rtfeldman$elm_css$Css$Structure$Output$prettyPrint(
		$rtfeldman$elm_css$Css$Structure$compactStylesheet(
			$rtfeldman$elm_css$Css$Preprocess$Resolve$toStructure(sheet)));
};
var $rtfeldman$elm_css$Css$Preprocess$Resolve$compile = function (styles) {
	return A2(
		$elm$core$String$join,
		'\n\n',
		A2($elm$core$List$map, $rtfeldman$elm_css$Css$Preprocess$Resolve$compileHelp, styles));
};
var $rtfeldman$elm_css$Css$Structure$ClassSelector = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$Preprocess$Snippet = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Preprocess$StyleBlock = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$makeSnippet = F2(
	function (styles, sequence) {
		var selector = A3($rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, $elm$core$Maybe$Nothing);
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Preprocess$StyleBlock, selector, _List_Nil, styles))
			]);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair = function (_v0) {
	var classname = _v0.a;
	var styles = _v0.b;
	return A2(
		$rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
		styles,
		$rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$Structure$ClassSelector(classname)
				])));
};
var $rtfeldman$elm_css$Css$Preprocess$stylesheet = function (snippets) {
	return {c4: $elm$core$Maybe$Nothing, du: _List_Nil, dQ: _List_Nil, ez: snippets};
};
var $rtfeldman$elm_css$VirtualDom$Styled$toDeclaration = function (dict) {
	return $rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
		$elm$core$List$singleton(
			$rtfeldman$elm_css$Css$Preprocess$stylesheet(
				A2(
					$elm$core$List$map,
					$rtfeldman$elm_css$VirtualDom$Styled$snippetFromPair,
					$elm$core$Dict$toList(dict)))));
};
var $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode = function (styles) {
	return A3(
		$elm$virtual_dom$VirtualDom$node,
		'style',
		_List_Nil,
		$elm$core$List$singleton(
			$elm$virtual_dom$VirtualDom$text(
				$rtfeldman$elm_css$VirtualDom$Styled$toDeclaration(styles))));
};
var $rtfeldman$elm_css$VirtualDom$Styled$unstyle = F3(
	function (elemType, properties, children) {
		var unstyledProperties = A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
		return A3(
			$elm$virtual_dom$VirtualDom$node,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$containsKey = F2(
	function (key, pairs) {
		containsKey:
		while (true) {
			if (!pairs.b) {
				return false;
			} else {
				var _v1 = pairs.a;
				var str = _v1.a;
				var rest = pairs.b;
				if (_Utils_eq(key, str)) {
					return true;
				} else {
					var $temp$key = key,
						$temp$pairs = rest;
					key = $temp$key;
					pairs = $temp$pairs;
					continue containsKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey = F2(
	function (_default, pairs) {
		getUnusedKey:
		while (true) {
			if (!pairs.b) {
				return _default;
			} else {
				var _v1 = pairs.a;
				var firstKey = _v1.a;
				var rest = pairs.b;
				var newKey = '_' + firstKey;
				if (A2($rtfeldman$elm_css$VirtualDom$Styled$containsKey, newKey, rest)) {
					var $temp$default = newKey,
						$temp$pairs = rest;
					_default = $temp$default;
					pairs = $temp$pairs;
					continue getUnusedKey;
				} else {
					return newKey;
				}
			}
		}
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode = F2(
	function (allStyles, keyedChildNodes) {
		var styleNodeKey = A2($rtfeldman$elm_css$VirtualDom$Styled$getUnusedKey, '_', keyedChildNodes);
		var finalNode = $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(allStyles);
		return _Utils_Tuple2(styleNodeKey, finalNode);
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed = F3(
	function (elemType, properties, keyedChildren) {
		var unstyledProperties = A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
		return A3(
			$elm$virtual_dom$VirtualDom$keyedNode,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS = F4(
	function (ns, elemType, properties, keyedChildren) {
		var unstyledProperties = A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateKeyedStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			keyedChildren);
		var keyedChildNodes = _v0.a;
		var styles = _v0.b;
		var keyedStyleNode = A2($rtfeldman$elm_css$VirtualDom$Styled$toKeyedStyleNode, styles, keyedChildNodes);
		return A4(
			$elm$virtual_dom$VirtualDom$keyedNodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				keyedStyleNode,
				$elm$core$List$reverse(keyedChildNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$unstyleNS = F4(
	function (ns, elemType, properties, children) {
		var unstyledProperties = A2($elm$core$List$map, $rtfeldman$elm_css$VirtualDom$Styled$extractUnstyledAttribute, properties);
		var initialStyles = $rtfeldman$elm_css$VirtualDom$Styled$stylesFromProperties(properties);
		var _v0 = A3(
			$elm$core$List$foldl,
			$rtfeldman$elm_css$VirtualDom$Styled$accumulateStyledHtml,
			_Utils_Tuple2(_List_Nil, initialStyles),
			children);
		var childNodes = _v0.a;
		var styles = _v0.b;
		var styleNode = $rtfeldman$elm_css$VirtualDom$Styled$toStyleNode(styles);
		return A4(
			$elm$virtual_dom$VirtualDom$nodeNS,
			ns,
			elemType,
			unstyledProperties,
			A2(
				$elm$core$List$cons,
				styleNode,
				$elm$core$List$reverse(childNodes)));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled = function (vdom) {
	switch (vdom.$) {
		case 4:
			var plainNode = vdom.a;
			return plainNode;
		case 0:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A3($rtfeldman$elm_css$VirtualDom$Styled$unstyle, elemType, properties, children);
		case 1:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyleNS, ns, elemType, properties, children);
		case 2:
			var elemType = vdom.a;
			var properties = vdom.b;
			var children = vdom.c;
			return A3($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyed, elemType, properties, children);
		default:
			var ns = vdom.a;
			var elemType = vdom.b;
			var properties = vdom.c;
			var children = vdom.d;
			return A4($rtfeldman$elm_css$VirtualDom$Styled$unstyleKeyedNS, ns, elemType, properties, children);
	}
};
var $rtfeldman$elm_css$Html$Styled$toUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$toUnstyled;
var $author$project$Msg$FocusResult = function (a) {
	return {$: 18, a: a};
};
var $author$project$Msg$QueueMsg_ = function (a) {
	return {$: 11, a: a};
};
var $author$project$Msg$SentryResponse = function (a) {
	return {$: 1, a: a};
};
var $author$project$Msg$StartSyncCycle = {$: 0};
var $elm$json$Json$Encode$bool = _Json_wrap;
var $elm$core$Basics$ge = _Utils_ge;
var $author$project$Lib$Http$Extra$errorMessage = F2(
	function (err, id) {
		switch (err.$) {
			case 0:
				var url = err.a;
				return 'Die URL `' + (url + '` ist nicht korrekt.');
			case 1:
				return 'Eine Anfrage hat das Zeitlimit überschritten.';
			case 2:
				return 'Prüfen Sie bitte Ihre Internetverbindung.';
			case 3:
				var status = err.a;
				return ((status >= 400) && (status < 500)) ? ('Die Anfrage konnte nicht autorisiert werden (' + ($elm$core$String$fromInt(status) + ')')) : ((status >= 500) ? ('Es gab einen internen Serverfehler (' + ($elm$core$String$fromInt(status) + ').')) : ('Ein unbekannter Fehler ist aufgetreten (' + ($elm$core$String$fromInt(status) + ').')));
			default:
				var msg_ = err.a;
				return '**Die empfangenen Daten waren Fehlerhaft**: ' + (id + (' \n\n\n' + msg_));
		}
	});
var $author$project$Lib$Comparison$compareByString = function (operator) {
	switch (operator) {
		case '<':
			return $elm$core$Basics$lt;
		case '>':
			return $elm$core$Basics$gt;
		case '>=':
			return $elm$core$Basics$ge;
		case '<=':
			return $elm$core$Basics$le;
		case '==':
			return $elm$core$Basics$eq;
		case '/=':
			return $elm$core$Basics$neq;
		case '!=':
			return $elm$core$Basics$neq;
		default:
			return F2(
				function (_v1, _v2) {
					return false;
				});
	}
};
var $author$project$Lib$Comparison$compareEqualityByString = function (operator) {
	switch (operator) {
		case '==':
			return $elm$core$Basics$eq;
		case '/=':
			return $elm$core$Basics$neq;
		case '!=':
			return $elm$core$Basics$neq;
		default:
			return F2(
				function (_v1, _v2) {
					return false;
				});
	}
};
var $author$project$Lib$Comparison$compareRuleWithType = F2(
	function (compType, _v0) {
		var rawValue = _v0.cx;
		var operator = _v0.cr;
		var _v1 = _Utils_Tuple2(compType, rawValue);
		_v1$4:
		while (true) {
			switch (_v1.a.$) {
				case 0:
					if (!_v1.b.$) {
						var b = _v1.a.a;
						var b2 = _v1.b.a;
						return A3($author$project$Lib$Comparison$compareEqualityByString, operator, b, b2);
					} else {
						break _v1$4;
					}
				case 1:
					if (_v1.b.$ === 1) {
						var f = _v1.a.a;
						var f2 = _v1.b.a;
						return A3($author$project$Lib$Comparison$compareByString, operator, f, f2);
					} else {
						break _v1$4;
					}
				case 2:
					if (_v1.b.$ === 2) {
						var i = _v1.a.a;
						var i2 = _v1.b.a;
						return A3($author$project$Lib$Comparison$compareByString, operator, i, i2);
					} else {
						break _v1$4;
					}
				default:
					if (_v1.b.$ === 3) {
						var s = _v1.a.a;
						var s2 = _v1.b.a;
						return A3($author$project$Lib$Comparison$compareByString, operator, s, s2);
					} else {
						break _v1$4;
					}
			}
		}
		return false;
	});
var $author$project$Types$Steps$Amount$compare = F2(
	function (model, comparison) {
		if (!model.$) {
			var amount = model.a;
			return A2(
				$author$project$Lib$Comparison$compareRuleWithType,
				$author$project$Lib$Comparison$CTInt(amount),
				comparison);
		} else {
			return false;
		}
	});
var $author$project$Types$Steps$ArticleInput$compare = F2(
	function (maybeModel, comparison) {
		return false;
	});
var $author$project$Types$Steps$Photo$compare = F2(
	function (model, comparison) {
		if (!model.$) {
			var photo = model.a;
			var _v1 = comparison.cQ;
			if ((!_v1.$) && (_v1.a === 'imageTaken')) {
				return A2(
					$author$project$Lib$Comparison$compareRuleWithType,
					$author$project$Lib$Comparison$CTBool(photo.fE),
					comparison);
			} else {
				return false;
			}
		} else {
			return false;
		}
	});
var $author$project$Types$Steps$Text$compare = F2(
	function (model, comparison) {
		if (!model.$) {
			var str = model.a;
			return A2(
				$author$project$Lib$Comparison$compareRuleWithType,
				$author$project$Lib$Comparison$CTString(str),
				comparison);
		} else {
			return false;
		}
	});
var $elm$time$Time$posixToMillis = function (_v0) {
	var millis = _v0;
	return millis;
};
var $author$project$Types$Steps$Timestamp$compare = F2(
	function (model, comparison) {
		if (!model.$) {
			if (!model.a.$) {
				var timestamp = model.a.a;
				return A2(
					$author$project$Lib$Comparison$compareRuleWithType,
					$author$project$Lib$Comparison$CTInt(
						$elm$time$Time$posixToMillis(timestamp)),
					comparison);
			} else {
				var _v1 = model.a;
				return false;
			}
		} else {
			return false;
		}
	});
var $author$project$Types$Steps$YesNo$compare = F2(
	function (model, comparison) {
		if (!model.$) {
			var b = model.a;
			return A2(
				$author$project$Lib$Comparison$compareRuleWithType,
				$author$project$Lib$Comparison$CTBool(b),
				comparison);
		} else {
			return false;
		}
	});
var $elm$regex$Regex$Match = F4(
	function (match, index, number, submatches) {
		return {c: index, a8: match, gn: number, cE: submatches};
	});
var $elm$regex$Regex$contains = _Regex_contains;
var $elm$regex$Regex$fromStringWith = _Regex_fromStringWith;
var $elm$regex$Regex$fromString = function (string) {
	return A2(
		$elm$regex$Regex$fromStringWith,
		{e8: false, f9: false},
		string);
};
var $author$project$Types$Step$getStepCount = F4(
	function (id, iteration, t, db) {
		var dictCount = function (d) {
			if (id.$ === 1) {
				return $elm$core$List$length(
					$elm$core$Dict$toList(d));
			} else {
				var id_ = id.a;
				return $elm$core$List$length(
					A2(
						$elm$core$List$filter,
						$elm$core$String$startsWith(
							_Utils_ap(
								id_,
								$elm$core$String$fromInt(iteration))),
						A2(
							$elm$core$List$map,
							$elm$core$Tuple$first,
							$elm$core$Dict$toList(d))));
			}
		};
		switch (t.$) {
			case 0:
				return dictCount(db.X);
			case 1:
				return dictCount(db.ag);
			case 2:
				return dictCount(db.as);
			case 3:
				return dictCount(db.W);
			case 4:
				return dictCount(db.V);
			case 5:
				return dictCount(db.Q);
			case 6:
				return dictCount(db.P);
			case 7:
				return dictCount(db.R);
			case 9:
				return dictCount(db.ar);
			case 8:
				return dictCount(db.az);
			default:
				return 0;
		}
	});
var $author$project$Types$Step$getStepType = F3(
	function (id, t, db) {
		switch (t.$) {
			case 0:
				return $author$project$Types$Step$YesNo(
					A2($elm$core$Dict$get, id, db.X));
			case 1:
				return $author$project$Types$Step$ArticleInstallation(
					A2($elm$core$Dict$get, id, db.ag));
			case 2:
				return $author$project$Types$Step$ArticleReturn(
					A2($elm$core$Dict$get, id, db.as));
			case 3:
				return $author$project$Types$Step$Timestamp(
					A2($elm$core$Dict$get, id, db.W));
			case 4:
				return $author$project$Types$Step$Text(
					A2($elm$core$Dict$get, id, db.V));
			case 10:
				return $author$project$Types$Step$DescriptionOnly;
			case 5:
				return $author$project$Types$Step$Amount(
					A2($elm$core$Dict$get, id, db.Q));
			case 6:
				return $author$project$Types$Step$Photo(
					A2($elm$core$Dict$get, id, db.P));
			case 7:
				var config = t.a;
				return A2(
					$author$project$Types$Step$ArticleInput,
					config,
					A2($elm$core$Dict$get, id, db.R));
			case 8:
				return $author$project$Types$Step$Signature(
					A2($elm$core$Dict$get, id, db.az));
			default:
				var config = t.a;
				return A2(
					$author$project$Types$Step$ArticleRemoval,
					config,
					A2($elm$core$Dict$get, id, db.ar));
		}
	});
var $elm$regex$Regex$never = _Regex_never;
var $elm$core$Dict$member = F2(
	function (key, dict) {
		var _v0 = A2($elm$core$Dict$get, key, dict);
		if (!_v0.$) {
			return true;
		} else {
			return false;
		}
	});
var $author$project$Types$Step$stepTypeIsMember = F3(
	function (id, t, db) {
		switch (t.$) {
			case 0:
				return A2($elm$core$Dict$member, id, db.X);
			case 1:
				return A2($elm$core$Dict$member, id, db.ag);
			case 2:
				return A2($elm$core$Dict$member, id, db.as);
			case 4:
				return A2($elm$core$Dict$member, id, db.V);
			case 3:
				return A2($elm$core$Dict$member, id, db.W);
			case 5:
				return A2($elm$core$Dict$member, id, db.Q);
			case 6:
				return A2($elm$core$Dict$member, id, db.P);
			case 7:
				return A2($elm$core$Dict$member, id, db.R);
			case 9:
				return A2($elm$core$Dict$member, id, db.ar);
			case 8:
				return A2($elm$core$Dict$member, id, db.az);
			default:
				return true;
		}
	});
var $author$project$Types$Step$evaluate = F3(
	function (stepDb, iteration, rules) {
		switch (rules.$) {
			case 8:
				return true;
			case 9:
				return false;
			case 5:
				var infos = rules.a;
				return A3(
					$author$project$Lib$Comparison$compareByString,
					infos.cr,
					A4($author$project$Types$Step$getStepCount, infos.gX, iteration, infos.eF, stepDb),
					infos.Q);
			case 6:
				var infos = rules.a;
				var secondVal = A3(
					$author$project$Types$Step$getStepType,
					_Utils_ap(
						infos.cz,
						$elm$core$String$fromInt(iteration)),
					infos.eF,
					stepDb);
				var firstVal = A3(
					$author$project$Types$Step$getStepType,
					_Utils_ap(
						infos.cd,
						$elm$core$String$fromInt(iteration)),
					infos.eF,
					stepDb);
				var mDifference = function () {
					var _v2 = _Utils_Tuple2(firstVal, secondVal);
					_v2$2:
					while (true) {
						switch (_v2.a.$) {
							case 5:
								if (((!_v2.a.a.$) && (_v2.b.$ === 5)) && (!_v2.b.a.$)) {
									var a1 = _v2.a.a.a;
									var a2 = _v2.b.a.a;
									return $elm$core$Maybe$Just(
										$author$project$Types$Step$Amount(
											$elm$core$Maybe$Just(a1 - a2)));
								} else {
									break _v2$2;
								}
							case 3:
								if (((((!_v2.a.a.$) && (!_v2.a.a.a.$)) && (_v2.b.$ === 3)) && (!_v2.b.a.$)) && (!_v2.b.a.a.$)) {
									var t1 = _v2.a.a.a.a;
									var t2 = _v2.b.a.a.a;
									return $elm$core$Maybe$Just(
										$author$project$Types$Step$Timestamp(
											$elm$core$Maybe$Just(
												$elm$core$Maybe$Just(
													$elm$time$Time$millisToPosix(
														$elm$time$Time$posixToMillis(t1) - $elm$time$Time$posixToMillis(t2))))));
								} else {
									break _v2$2;
								}
							default:
								break _v2$2;
						}
					}
					return $elm$core$Maybe$Nothing;
				}();
				_v1$2:
				while (true) {
					if (!mDifference.$) {
						switch (mDifference.a.$) {
							case 5:
								if (!mDifference.a.a.$) {
									var a1 = mDifference.a.a.a;
									return A3($author$project$Lib$Comparison$compareByString, infos.cr, a1, infos.Q);
								} else {
									break _v1$2;
								}
							case 3:
								if ((!mDifference.a.a.$) && (!mDifference.a.a.a.$)) {
									var t1 = mDifference.a.a.a.a;
									return A3(
										$author$project$Lib$Comparison$compareByString,
										infos.cr,
										$elm$time$Time$posixToMillis(t1),
										infos.Q);
								} else {
									break _v1$2;
								}
							default:
								break _v1$2;
						}
					} else {
						break _v1$2;
					}
				}
				return false;
			case 4:
				var infos = rules.a;
				return A3(
					$author$project$Types$Step$stepTypeIsMember,
					_Utils_ap(
						infos.gX,
						$elm$core$String$fromInt(iteration)),
					infos.eF,
					stepDb);
			case 7:
				var config = rules.a;
				var patternAsRegex = A2(
					$elm$core$Maybe$withDefault,
					$elm$regex$Regex$never,
					$elm$regex$Regex$fromString(config.cw));
				var inputText = A3(
					$author$project$Types$Step$getStepType,
					_Utils_ap(
						config.gX,
						$elm$core$String$fromInt(iteration)),
					$author$project$Types$Step$Text($elm$core$Maybe$Nothing),
					stepDb);
				if ((inputText.$ === 4) && (!inputText.a.$)) {
					var input = inputText.a.a;
					return A2($elm$regex$Regex$contains, patternAsRegex, input);
				} else {
					return false;
				}
			case 3:
				var infos = rules.a;
				var _v4 = A3(
					$author$project$Types$Step$getStepType,
					_Utils_ap(
						infos.gX,
						$elm$core$String$fromInt(iteration)),
					infos.eF,
					stepDb);
				switch (_v4.$) {
					case 0:
						var dynamic = _v4.a;
						return A2($author$project$Types$Steps$YesNo$compare, dynamic, infos._);
					case 5:
						var dynamic = _v4.a;
						return A2($author$project$Types$Steps$Amount$compare, dynamic, infos._);
					case 1:
						return false;
					case 2:
						return false;
					case 4:
						var dynamic = _v4.a;
						return A2($author$project$Types$Steps$Text$compare, dynamic, infos._);
					case 3:
						var dynamic = _v4.a;
						return A2($author$project$Types$Steps$Timestamp$compare, dynamic, infos._);
					case 6:
						var dynamic = _v4.a;
						return A2($author$project$Types$Steps$Photo$compare, dynamic, infos._);
					case 7:
						var dynamic = _v4.b;
						return A2($author$project$Types$Steps$ArticleInput$compare, dynamic, infos._);
					case 9:
						var dynamic = _v4.b;
						return A2($author$project$Types$Steps$ArticleInput$compare, dynamic, infos._);
					case 8:
						return false;
					default:
						return false;
				}
			case 2:
				var rule = rules.a;
				return !A3($author$project$Types$Step$evaluate, stepDb, iteration, rule);
			case 1:
				var ruleList = rules.a;
				return A3(
					$elm$core$List$foldl,
					$elm$core$Basics$or,
					false,
					A2(
						$elm$core$List$map,
						A2($author$project$Types$Step$evaluate, stepDb, iteration),
						ruleList));
			default:
				var ruleList = rules.a;
				return A3(
					$elm$core$List$foldl,
					$elm$core$Basics$and,
					true,
					A2(
						$elm$core$List$map,
						A2($author$project$Types$Step$evaluate, stepDb, iteration),
						ruleList));
		}
	});
var $author$project$Msg$Error = function (a) {
	return {$: 6, a: a};
};
var $author$project$Msg$DbError = function (a) {
	return {$: 6, a: a};
};
var $author$project$Msg$DbMsg_ = function (a) {
	return {$: 1, a: a};
};
var $author$project$Msg$JsError = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Msg$JsFinishOperation = function (a) {
	return {$: 5, a: a};
};
var $author$project$Msg$JsFlagsChange = function (a) {
	return {$: 4, a: a};
};
var $author$project$Msg$JsGetFinishedState = function (a) {
	return {$: 2, a: a};
};
var $author$project$Msg$JsSwitchLocale = function (a) {
	return {$: 8, a: a};
};
var $author$project$Msg$UnknownMsg = function (a) {
	return {$: 5, a: a};
};
var $author$project$Msg$DbLoadedPicture = function (a) {
	return {$: 1, a: a};
};
var $author$project$Msg$DbModelLoaded = function (a) {
	return {$: 0, a: a};
};
var $author$project$Msg$DbPictureNotFound = function (a) {
	return {$: 2, a: a};
};
var $author$project$Msg$DbUnknown = function (a) {
	return {$: 5, a: a};
};
var $author$project$Msg$DeleteSuccessful = {$: 4};
var $author$project$Msg$InsertSuccessful = {$: 3};
var $author$project$Ports$decodeDbMsg = A3(
	$webbhuset$elm_json_decode$Json$Decode$Field$require,
	'msg',
	$elm$json$Json$Decode$string,
	function (msg) {
		return A3(
			$webbhuset$elm_json_decode$Json$Decode$Field$attempt,
			'data',
			$elm$json$Json$Decode$value,
			function (maybeData) {
				return $elm$json$Json$Decode$succeed(
					function () {
						switch (msg) {
							case 'DbModelLoaded':
								if (maybeData.$ === 1) {
									return $author$project$Msg$DbError('DbModelLoaded was called without any data');
								} else {
									var data = maybeData.a;
									return $author$project$Msg$DbModelLoaded(data);
								}
							case 'DbLoadedPicture':
								if (maybeData.$ === 1) {
									return $author$project$Msg$DbError('DbLoadedPicture was called without any data');
								} else {
									var data = maybeData.a;
									return $author$project$Msg$DbLoadedPicture(data);
								}
							case 'InsertSuccessful':
								return $author$project$Msg$InsertSuccessful;
							case 'DeletedSuccessfully':
								return $author$project$Msg$DeleteSuccessful;
							case 'DbPictureNotFound':
								if (maybeData.$ === 1) {
									return $author$project$Msg$DbError('DbPictureNotFound was called without any data');
								} else {
									var data = maybeData.a;
									return $author$project$Msg$DbPictureNotFound(data);
								}
							default:
								var unknownMsg = msg;
								return $author$project$Msg$DbUnknown(unknownMsg);
						}
					}());
			});
	});
var $author$project$Msg$JsLogin = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Msg$JsUnknown = function (a) {
	return {$: 6, a: a};
};
var $author$project$Types$Ports$LoginData = F2(
	function (email, password) {
		return {aa: email, gy: password};
	});
var $author$project$Ports$decodeJsMsg = A3(
	$webbhuset$elm_json_decode$Json$Decode$Field$require,
	'msg',
	$elm$json$Json$Decode$string,
	function (msg) {
		return A3(
			$webbhuset$elm_json_decode$Json$Decode$Field$attempt,
			'data',
			$elm$json$Json$Decode$value,
			function (maybeData) {
				return $elm$json$Json$Decode$succeed(
					function () {
						switch (msg) {
							case 'JsLogin':
								if (maybeData.$ === 1) {
									return A2($author$project$Msg$JsError, $elm$core$Dict$empty, 'JsLogin was called without any login data');
								} else {
									var data = maybeData.a;
									var _v2 = A2(
										$elm$json$Json$Decode$decodeValue,
										A3(
											$elm$json$Json$Decode$map2,
											$author$project$Types$Ports$LoginData,
											A2($elm$json$Json$Decode$field, 'email', $elm$json$Json$Decode$string),
											A2($elm$json$Json$Decode$field, 'password', $elm$json$Json$Decode$string)),
										data);
									if (!_v2.$) {
										var loginData = _v2.a;
										return A2($author$project$Msg$JsLogin, loginData.aa, loginData.gy);
									} else {
										var err = _v2.a;
										return A2(
											$author$project$Msg$JsError,
											$elm$core$Dict$fromList(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'case',
														$elm$json$Json$Encode$string('JsLogin')),
														_Utils_Tuple2(
														'module',
														$elm$json$Json$Encode$string('Ports')),
														_Utils_Tuple2(
														'function',
														$elm$json$Json$Encode$string('decodeJsMsg')),
														_Utils_Tuple2(
														'decodeMsg',
														$elm$json$Json$Encode$string(
															$elm$json$Json$Decode$errorToString(err)))
													])),
											'Decoding error');
									}
								}
							case 'JsFlagsChange':
								if (maybeData.$ === 1) {
									return A2($author$project$Msg$JsError, $elm$core$Dict$empty, 'JsFlagsChange was called without any data.');
								} else {
									var data = maybeData.a;
									var _v4 = A2($elm$json$Json$Decode$decodeValue, $author$project$Types$Ports$decodeFlags, data);
									if (!_v4.$) {
										var flags = _v4.a;
										return $author$project$Msg$JsFlagsChange(flags);
									} else {
										var err = _v4.a;
										return A2(
											$author$project$Msg$JsError,
											$elm$core$Dict$fromList(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'case',
														$elm$json$Json$Encode$string('JsFlagsChange')),
														_Utils_Tuple2(
														'module',
														$elm$json$Json$Encode$string('Ports')),
														_Utils_Tuple2(
														'function',
														$elm$json$Json$Encode$string('decodeJsMsg')),
														_Utils_Tuple2(
														'decodeMsg',
														$elm$json$Json$Encode$string(
															$elm$json$Json$Decode$errorToString(err)))
													])),
											'Decoding error');
									}
								}
							case 'JsGetFinishedState':
								if (maybeData.$ === 1) {
									return A2($author$project$Msg$JsError, $elm$core$Dict$empty, 'JsGetFinishedState was called without any data.');
								} else {
									var data = maybeData.a;
									var _v6 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, data);
									if (!_v6.$) {
										var operationId = _v6.a;
										return $author$project$Msg$JsGetFinishedState(operationId);
									} else {
										var err = _v6.a;
										return A2(
											$author$project$Msg$JsError,
											$elm$core$Dict$fromList(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'case',
														$elm$json$Json$Encode$string('JsGetFinishedState')),
														_Utils_Tuple2(
														'module',
														$elm$json$Json$Encode$string('Ports')),
														_Utils_Tuple2(
														'function',
														$elm$json$Json$Encode$string('decodeJsMsg')),
														_Utils_Tuple2(
														'decodeMsg',
														$elm$json$Json$Encode$string(
															$elm$json$Json$Decode$errorToString(err)))
													])),
											'Decoding error');
									}
								}
							case 'InsertFailure':
								var _v7 = A2(
									$elm$json$Json$Decode$decodeValue,
									$elm$json$Json$Decode$string,
									A2(
										$elm$core$Maybe$withDefault,
										$elm$json$Json$Encode$string('No additional data given'),
										maybeData));
								if (!_v7.$) {
									var error = _v7.a;
									return A2(
										$author$project$Msg$JsError,
										$elm$core$Dict$fromList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'case',
													$elm$json$Json$Encode$string('InsertFailure')),
													_Utils_Tuple2(
													'module',
													$elm$json$Json$Encode$string('Ports')),
													_Utils_Tuple2(
													'function',
													$elm$json$Json$Encode$string('decodeJsMsg')),
													_Utils_Tuple2(
													'databaseErrorMsg',
													$elm$json$Json$Encode$string(error))
												])),
										'Database InsertFailure');
								} else {
									var err = _v7.a;
									return A2(
										$author$project$Msg$JsError,
										$elm$core$Dict$fromList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'case',
													$elm$json$Json$Encode$string('InsertFailure')),
													_Utils_Tuple2(
													'module',
													$elm$json$Json$Encode$string('Ports')),
													_Utils_Tuple2(
													'function',
													$elm$json$Json$Encode$string('decodeJsMsg')),
													_Utils_Tuple2(
													'decodeMsg',
													$elm$json$Json$Encode$string(
														$elm$json$Json$Decode$errorToString(err)))
												])),
										'Decoding error');
								}
							default:
								var unknownMsg = msg;
								return $author$project$Msg$JsUnknown(unknownMsg);
						}
					}());
			});
	});
var $author$project$Ports$decodePortRawMsg = A3(
	$webbhuset$elm_json_decode$Json$Decode$Field$require,
	'msg',
	$elm$json$Json$Decode$string,
	function (msg) {
		return A3(
			$webbhuset$elm_json_decode$Json$Decode$Field$require,
			'data',
			$elm$json$Json$Decode$value,
			function (data) {
				var externalMsg = function () {
					switch (msg) {
						case 'JsMsg':
							var uiMsg = function () {
								var _v1 = A2($elm$json$Json$Decode$decodeValue, $author$project$Ports$decodeJsMsg, data);
								if (!_v1.$) {
									var uiMsg_ = _v1.a;
									return uiMsg_;
								} else {
									var err = _v1.a;
									return A2(
										$author$project$Msg$JsError,
										$elm$core$Dict$fromList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'case',
													$elm$json$Json$Encode$string('JsMsg')),
													_Utils_Tuple2(
													'module',
													$elm$json$Json$Encode$string('Ports')),
													_Utils_Tuple2(
													'function',
													$elm$json$Json$Encode$string('decodePortRawMsg')),
													_Utils_Tuple2(
													'decodeMsg',
													$elm$json$Json$Encode$string(
														$elm$json$Json$Decode$errorToString(err)))
												])),
										'Decoding error');
								}
							}();
							return $author$project$Msg$PortMsg_(
								$author$project$Msg$JsMsg_(uiMsg));
						case 'DatabaseResponseMsg':
							var dbMsg = function () {
								var _v2 = A2($elm$json$Json$Decode$decodeValue, $author$project$Ports$decodeDbMsg, data);
								if (!_v2.$) {
									var dbMsg_ = _v2.a;
									return dbMsg_;
								} else {
									var err = _v2.a;
									return $author$project$Msg$DbError(
										$elm$json$Json$Decode$errorToString(err));
								}
							}();
							return $author$project$Msg$PortMsg_(
								$author$project$Msg$DbMsg_(dbMsg));
						case 'JsFlagsChange':
							var _v3 = A2($elm$json$Json$Decode$decodeValue, $author$project$Types$Ports$decodeFlags, data);
							if (!_v3.$) {
								var flags = _v3.a;
								return $author$project$Msg$PortMsg_(
									$author$project$Msg$JsMsg_(
										$author$project$Msg$JsFlagsChange(flags)));
							} else {
								var err = _v3.a;
								return $author$project$Msg$PortMsg_(
									$author$project$Msg$JsMsg_(
										A2(
											$author$project$Msg$JsError,
											$elm$core$Dict$fromList(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'case',
														$elm$json$Json$Encode$string('JsFlagsChange')),
														_Utils_Tuple2(
														'module',
														$elm$json$Json$Encode$string('Ports')),
														_Utils_Tuple2(
														'function',
														$elm$json$Json$Encode$string('decodePortRawMsg')),
														_Utils_Tuple2(
														'decodeMsg',
														$elm$json$Json$Encode$string(
															$elm$json$Json$Decode$errorToString(err)))
													])),
											'Decoding error')));
							}
						case 'JsGetFinishedState':
							var _v4 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, data);
							if (!_v4.$) {
								var operationId = _v4.a;
								return $author$project$Msg$PortMsg_(
									$author$project$Msg$JsMsg_(
										$author$project$Msg$JsGetFinishedState(operationId)));
							} else {
								var err = _v4.a;
								return $author$project$Msg$PortMsg_(
									$author$project$Msg$JsMsg_(
										A2(
											$author$project$Msg$JsError,
											$elm$core$Dict$fromList(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'case',
														$elm$json$Json$Encode$string('JsGetFinishedState')),
														_Utils_Tuple2(
														'module',
														$elm$json$Json$Encode$string('Ports')),
														_Utils_Tuple2(
														'function',
														$elm$json$Json$Encode$string('decodePortRawMsg')),
														_Utils_Tuple2(
														'decodeMsg',
														$elm$json$Json$Encode$string(
															$elm$json$Json$Decode$errorToString(err)))
													])),
											'Decoding error')));
							}
						case 'JsFinishOperation':
							var _v5 = A2(
								$elm$json$Json$Decode$decodeValue,
								$elm$json$Json$Decode$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$json$Json$Decode$andThen,
											A2($elm$core$Basics$composeL, $elm$json$Json$Decode$succeed, $elm$core$String$fromInt),
											$elm$json$Json$Decode$int),
											$elm$json$Json$Decode$string
										])),
								data);
							if (!_v5.$) {
								var flags = _v5.a;
								return $author$project$Msg$PortMsg_(
									$author$project$Msg$JsMsg_(
										$author$project$Msg$JsFinishOperation(flags)));
							} else {
								var err = _v5.a;
								return $author$project$Msg$PortMsg_(
									$author$project$Msg$JsMsg_(
										A2(
											$author$project$Msg$JsError,
											$elm$core$Dict$fromList(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'case',
														$elm$json$Json$Encode$string('JsFinishOperation')),
														_Utils_Tuple2(
														'module',
														$elm$json$Json$Encode$string('Ports')),
														_Utils_Tuple2(
														'function',
														$elm$json$Json$Encode$string('decodePortRawMsg')),
														_Utils_Tuple2(
														'decodeMsg',
														$elm$json$Json$Encode$string(
															$elm$json$Json$Decode$errorToString(err)))
													])),
											'Decoding error')));
							}
						case 'JsSwitchLocale':
							var _v6 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, data);
							if (!_v6.$) {
								var flags = _v6.a;
								return $author$project$Msg$PortMsg_(
									$author$project$Msg$JsMsg_(
										$author$project$Msg$JsSwitchLocale(flags)));
							} else {
								var err = _v6.a;
								return $author$project$Msg$PortMsg_(
									$author$project$Msg$JsMsg_(
										A2(
											$author$project$Msg$JsError,
											$elm$core$Dict$fromList(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'case',
														$elm$json$Json$Encode$string('JsSwitchLocale')),
														_Utils_Tuple2(
														'module',
														$elm$json$Json$Encode$string('Ports')),
														_Utils_Tuple2(
														'function',
														$elm$json$Json$Encode$string('decodePortRawMsg')),
														_Utils_Tuple2(
														'decodeMsg',
														$elm$json$Json$Encode$string(
															$elm$json$Json$Decode$errorToString(err)))
													])),
											'Decoding error')));
							}
						case 'InsertFailure':
							var _v7 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, data);
							if (!_v7.$) {
								var error = _v7.a;
								return $author$project$Msg$PortMsg_(
									$author$project$Msg$JsMsg_(
										A2(
											$author$project$Msg$JsError,
											$elm$core$Dict$fromList(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'case',
														$elm$json$Json$Encode$string('InsertFailure')),
														_Utils_Tuple2(
														'module',
														$elm$json$Json$Encode$string('Ports')),
														_Utils_Tuple2(
														'function',
														$elm$json$Json$Encode$string('decodePortRawMsg')),
														_Utils_Tuple2(
														'databaseErrorMsg',
														$elm$json$Json$Encode$string(error))
													])),
											'Database InsertFailure')));
							} else {
								var err = _v7.a;
								return $author$project$Msg$PortMsg_(
									$author$project$Msg$JsMsg_(
										A2(
											$author$project$Msg$JsError,
											$elm$core$Dict$fromList(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'case',
														$elm$json$Json$Encode$string('InsertFailure')),
														_Utils_Tuple2(
														'module',
														$elm$json$Json$Encode$string('Ports')),
														_Utils_Tuple2(
														'function',
														$elm$json$Json$Encode$string('decodePortRawMsg')),
														_Utils_Tuple2(
														'decodeMsg',
														$elm$json$Json$Encode$string(
															$elm$json$Json$Decode$errorToString(err)))
													])),
											'Decoding error')));
							}
						default:
							var unknownMsg = msg;
							return $author$project$Msg$UnknownMsg(unknownMsg);
					}
				}();
				return $elm$json$Json$Decode$succeed(externalMsg);
			});
	});
var $author$project$Lib$PortHelpers$extractMsgSendToElm = function (data) {
	var newMsg = function () {
		var _v0 = A2($elm$json$Json$Decode$decodeValue, $author$project$Ports$decodePortRawMsg, data);
		if (!_v0.$) {
			var newMsg_ = _v0.a;
			return newMsg_;
		} else {
			var err = _v0.a;
			return $author$project$Msg$Error(
				$elm$json$Json$Decode$errorToString(err));
		}
	}();
	return A2(
		$elm$core$Task$perform,
		$elm$core$Basics$identity,
		$elm$core$Task$succeed(newMsg));
};
var $elm$core$List$member = F2(
	function (x, xs) {
		return A2(
			$elm$core$List$any,
			function (a) {
				return _Utils_eq(a, x);
			},
			xs);
	});
var $elm$core$Tuple$second = function (_v0) {
	var y = _v0.b;
	return y;
};
var $author$project$Actions$Station$nextPhotos = F3(
	function (deviceId, references, stations) {
		var stationWrapperList = $elm$core$Dict$toList(stations);
		var photoNotSyncable = function (photo) {
			var _v2 = $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					function (r) {
						if (r.$ === 1) {
							var p = r.a;
							return _Utils_eq(p.gw, photo.gw) && (_Utils_eq(p.gU, photo.gU) && (_Utils_eq(p.gX, photo.gX) && _Utils_eq(p.fV, photo.fV)));
						} else {
							return false;
						}
					},
					references));
			if (!_v2.$) {
				return $elm$core$Maybe$Nothing;
			} else {
				return $elm$core$Maybe$Just(photo);
			}
		};
		var hasStationSyncablePhotos = function (station) {
			return A2(
				$elm$core$List$filterMap,
				photoNotSyncable,
				A2(
					$elm$core$List$filterMap,
					function (photo) {
						var _v1 = photo.gZ;
						switch (_v1.$) {
							case 1:
								return $elm$core$Maybe$Just(photo);
							case 4:
								var deviceId_ = _v1.a;
								return _Utils_eq(deviceId_, deviceId) ? $elm$core$Maybe$Nothing : $elm$core$Maybe$Just(photo);
							default:
								return $elm$core$Maybe$Nothing;
						}
					},
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$second,
						$elm$core$Dict$toList(station.A.P))));
		};
		var hasOperationSyncablePhotos = function (_v0) {
			var operationId = _v0.a;
			var wrapper = _v0.b;
			return $elm$core$List$concat(
				A2($elm$core$List$map, hasStationSyncablePhotos, wrapper.aA));
		};
		return $elm$core$List$concat(
			A2($elm$core$List$map, hasOperationSyncablePhotos, stationWrapperList));
	});
var $author$project$Actions$Station$nextStations = function (stations) {
	var stationWrapperList = $elm$core$Dict$toList(stations);
	var hasOperationSyncableParts = function (_v0) {
		var operationId = _v0.a;
		var station = _v0.b;
		return _Utils_eq(station.gZ, $author$project$Lib$Sync$Local) ? $elm$core$Maybe$Just(operationId) : $elm$core$Maybe$Nothing;
	};
	return A2($elm$core$List$filterMap, hasOperationSyncableParts, stationWrapperList);
};
var $author$project$Actions$Queue$findNextSyncableResources = function (model) {
	var syncableStations = A2(
		$elm$core$List$map,
		function (operationId) {
			return $author$project$Types$Queue$QueueStation(operationId);
		},
		$author$project$Actions$Station$nextStations(model.aA));
	var syncablePhotos = A2(
		$elm$core$List$map,
		function (photoReference) {
			return $author$project$Types$Queue$QueuePhoto(
				_Utils_update(
					photoReference,
					{dt: $elm$core$Maybe$Nothing}));
		},
		A3($author$project$Actions$Station$nextPhotos, model.dd, model.aR, model.aA));
	var queue_ = $elm$core$List$concat(
		_List_fromArray(
			[syncableStations, syncablePhotos]));
	var queueWithoutNonSyncableParts = A2(
		$elm$core$List$filter,
		function (queuePart) {
			return !A2($elm$core$List$member, queuePart, model.aR);
		},
		queue_);
	return _Utils_update(
		model,
		{aT: queueWithoutNonSyncableParts});
};
var $elm$browser$Browser$Dom$focus = _Browser_call('focus');
var $krisajenkins$remotedata$RemoteData$Loading = {$: 1};
var $elm$json$Json$Encode$dict = F3(
	function (toKey, toValue, dictionary) {
		return _Json_wrap(
			A3(
				$elm$core$Dict$foldl,
				F3(
					function (key, value, obj) {
						return A3(
							_Json_addField,
							toKey(key),
							toValue(value),
							obj);
					}),
				_Json_emptyObject(0),
				dictionary));
	});
var $author$project$Lib$Sync$encode = function (syncState) {
	return $elm$json$Json$Encode$string(
		function () {
			switch (syncState.$) {
				case 0:
					return 'Server';
				case 1:
					return 'Local';
				case 2:
					return 'LocalAwaitConfirmation';
				case 3:
					var str = syncState.a;
					return _Utils_ap($author$project$Lib$Sync$localOnDeviceStr, str);
				case 4:
					var str = syncState.a;
					return _Utils_ap($author$project$Lib$Sync$localNotOnDeviceStr, str);
				default:
					return 'NotSyncable';
			}
		}());
};
var $elm$json$Json$Encode$float = _Json_wrap;
var $elm$json$Json$Encode$int = _Json_wrap;
var $elm$json$Json$Encode$null = _Json_encodeNull;
var $elm_community$json_extra$Json$Encode$Extra$maybe = function (encoder) {
	return A2(
		$elm$core$Basics$composeR,
		$elm$core$Maybe$map(encoder),
		$elm$core$Maybe$withDefault($elm$json$Json$Encode$null));
};
var $author$project$Lib$Comparison$encodeComparison = function (_v0) {
	var accessor = _v0.cQ;
	var operator = _v0.cr;
	var rawValue = _v0.cx;
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'accessor',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, accessor)),
				_Utils_Tuple2(
				'operator',
				$elm$json$Json$Encode$string(operator)),
				_Utils_Tuple2(
				'rawValue',
				function () {
					switch (rawValue.$) {
						case 0:
							var b = rawValue.a;
							return $elm$json$Json$Encode$bool(b);
						case 1:
							var f = rawValue.a;
							return $elm$json$Json$Encode$float(f);
						case 2:
							var i = rawValue.a;
							return $elm$json$Json$Encode$int(i);
						default:
							var s = rawValue.a;
							return $elm$json$Json$Encode$string(s);
					}
				}())
			]));
};
var $author$project$Types$Steps$Amount$encode = function (model) {
	return $elm$json$Json$Encode$int(model);
};
var $author$project$Types$Steps$ArticleInput$encodeSerialNumber = function (serialNumber) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'sn',
				$elm$json$Json$Encode$string(serialNumber.ex)),
				_Utils_Tuple2(
				'brand',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, serialNumber.c1))
			]));
};
var $author$project$Types$Steps$ArticleInput$encodeTemplate = function (template) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'templateId',
				$elm$json$Json$Encode$int(template.g1)),
				_Utils_Tuple2(
				'title',
				$elm$json$Json$Encode$string(template.g4)),
				_Utils_Tuple2(
				'serialNumberRequired',
				$elm$json$Json$Encode$bool(template.gQ))
			]));
};
var $author$project$Types$Steps$ArticleInput$encodeNewArticle = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'selected',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $author$project$Types$Steps$ArticleInput$encodeTemplate, model.gO)),
				_Utils_Tuple2(
				'amount',
				$elm$json$Json$Encode$int(model.Q)),
				_Utils_Tuple2(
				'serialNumbers',
				A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $author$project$Types$Steps$ArticleInput$encodeSerialNumber, model.ao)),
				_Utils_Tuple2(
				'counter',
				$elm$json$Json$Encode$int(model.I))
			]));
};
var $elm$json$Json$Encode$list = F2(
	function (func, entries) {
		return _Json_wrap(
			A3(
				$elm$core$List$foldl,
				_Json_addEntry(func),
				_Json_emptyArray(0),
				entries));
	});
var $author$project$Types$Steps$ArticleInput$encode = function (model) {
	return A2($elm$json$Json$Encode$list, $author$project$Types$Steps$ArticleInput$encodeNewArticle, model);
};
var $author$project$Types$Steps$Photo$encode = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'fileType',
				$elm$json$Json$Encode$string(model.bB)),
				_Utils_Tuple2(
				'operationId',
				$elm$json$Json$Encode$string(model.gw)),
				_Utils_Tuple2(
				'stationId',
				$elm$json$Json$Encode$string(model.gU)),
				_Utils_Tuple2(
				'stepId',
				$elm$json$Json$Encode$string(model.gX)),
				_Utils_Tuple2(
				'iteration',
				$elm$json$Json$Encode$int(model.fV)),
				_Utils_Tuple2(
				'createdAt',
				$elm$json$Json$Encode$int(
					$elm$time$Time$posixToMillis(model.a4))),
				_Utils_Tuple2(
				'syncState',
				$author$project$Lib$Sync$encode(model.gZ)),
				_Utils_Tuple2(
				'imageTaken',
				$elm$json$Json$Encode$bool(model.fE))
			]));
};
var $author$project$Types$Steps$Signature$encode = function (model) {
	if (!model.$) {
		var mdl = model.a;
		return $elm$json$Json$Encode$string(mdl);
	} else {
		return $elm$json$Json$Encode$null;
	}
};
var $author$project$Types$Steps$Text$encode = function (model) {
	return $elm$json$Json$Encode$string(model);
};
var $author$project$Types$Steps$Timestamp$encodePosix = function (time) {
	return $elm$json$Json$Encode$int(
		$elm$time$Time$posixToMillis(time));
};
var $author$project$Types$Steps$Timestamp$encode = function (model) {
	return A2($elm_community$json_extra$Json$Encode$Extra$maybe, $author$project$Types$Steps$Timestamp$encodePosix, model);
};
var $author$project$Types$Steps$ArticleInstallation$encodeArticleInstallation = function (model) {
	if (!model.$) {
		if (!model.a.$) {
			var rmas = model.a.a;
			return A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$string, rmas);
		} else {
			var tmp = model.a.a;
			var handleSn = function (sn) {
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'sn',
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'articleTemplateId',
										$elm$json$Json$Encode$int(sn.bq)),
										_Utils_Tuple2(
										'stationId',
										$elm$json$Json$Encode$string(sn.gU)),
										_Utils_Tuple2(
										'stepId',
										$elm$json$Json$Encode$string(sn.gX)),
										_Utils_Tuple2(
										'iteration',
										$elm$json$Json$Encode$int(sn.fV)),
										_Utils_Tuple2(
										'serialNumber',
										$author$project$Types$Steps$ArticleInput$encodeSerialNumber(sn.eu)),
										_Utils_Tuple2(
										'description',
										$elm$json$Json$Encode$string(sn.fl)),
										_Utils_Tuple2(
										'snCounter',
										$elm$json$Json$Encode$string(sn.gS))
									])))
						]));
			};
			var handleNoSn = function (noSn) {
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'noSn',
							$elm$json$Json$Encode$object(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'articleTemplateId',
										$elm$json$Json$Encode$int(noSn.bq)),
										_Utils_Tuple2(
										'stationId',
										$elm$json$Json$Encode$string(noSn.gU)),
										_Utils_Tuple2(
										'stepId',
										$elm$json$Json$Encode$string(noSn.gX)),
										_Utils_Tuple2(
										'iteration',
										$elm$json$Json$Encode$int(noSn.fV)),
										_Utils_Tuple2(
										'amount',
										$elm$json$Json$Encode$int(noSn.Q)),
										_Utils_Tuple2(
										'description',
										$elm$json$Json$Encode$string(noSn.fl))
									])))
						]));
			};
			switch (tmp.$) {
				case 1:
					var sn = tmp.a;
					return handleSn(sn);
				case 0:
					var noSn = tmp.a;
					return handleNoSn(noSn);
				case 3:
					var noSn = tmp.a;
					return handleNoSn(noSn);
				default:
					var sn = tmp.a;
					return handleSn(sn);
			}
		}
	} else {
		return $elm$json$Json$Encode$null;
	}
};
var $author$project$Types$Steps$ArticleInput$encodeConfig = function (config) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'options',
				A2($elm$json$Json$Encode$list, $author$project$Types$Steps$ArticleInput$encodeTemplate, config.dV)),
				_Utils_Tuple2(
				'allowUnknown',
				$elm$json$Json$Encode$bool(config.cT))
			]));
};
var $author$project$Types$Steps$YesNo$encodeYesNo = function (yesNo) {
	return $elm$json$Json$Encode$bool(yesNo);
};
var $author$project$Types$Step$encodeStepType = function (stepType) {
	var encodeMaybeStepType = F3(
		function (name, maybe, enc) {
			if (!maybe.$) {
				var a = maybe.a;
				return $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							name,
							enc(a))
						]));
			} else {
				return $elm$json$Json$Encode$string(name);
			}
		});
	switch (stepType.$) {
		case 0:
			var maybeModel = stepType.a;
			return A3(encodeMaybeStepType, 'yesNo', maybeModel, $author$project$Types$Steps$YesNo$encodeYesNo);
		case 1:
			var maybeModel = stepType.a;
			return A3(encodeMaybeStepType, 'articleInstallation', maybeModel, $author$project$Types$Steps$ArticleInstallation$encodeArticleInstallation);
		case 2:
			var maybeModel = stepType.a;
			return A3(encodeMaybeStepType, 'articleReturn', maybeModel, $author$project$Types$Steps$ArticleInstallation$encodeArticleInstallation);
		case 3:
			var maybeModel = stepType.a;
			return A3(encodeMaybeStepType, 'timestamp', maybeModel, $author$project$Types$Steps$Timestamp$encode);
		case 4:
			var maybeModel = stepType.a;
			return A3(encodeMaybeStepType, 'text', maybeModel, $author$project$Types$Steps$Text$encode);
		case 5:
			var maybeModel = stepType.a;
			return A3(encodeMaybeStepType, 'amount', maybeModel, $author$project$Types$Steps$Amount$encode);
		case 6:
			var maybeModel = stepType.a;
			return A3(encodeMaybeStepType, 'photo', maybeModel, $author$project$Types$Steps$Photo$encode);
		case 7:
			var config = stepType.a;
			var maybeModel = stepType.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'articleInput',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'config',
									$author$project$Types$Steps$ArticleInput$encodeConfig(config)),
									_Utils_Tuple2(
									'model',
									A2($elm_community$json_extra$Json$Encode$Extra$maybe, $author$project$Types$Steps$ArticleInput$encode, maybeModel))
								])))
					]));
		case 9:
			var config = stepType.a;
			var maybeModel = stepType.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'articleRemoval',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'config',
									$author$project$Types$Steps$ArticleInput$encodeConfig(config)),
									_Utils_Tuple2(
									'model',
									A2($elm_community$json_extra$Json$Encode$Extra$maybe, $author$project$Types$Steps$ArticleInput$encode, maybeModel))
								])))
					]));
		case 8:
			var maybeModel = stepType.a;
			return A3(encodeMaybeStepType, 'signature', maybeModel, $author$project$Types$Steps$Signature$encode);
		default:
			return $elm$json$Json$Encode$string('descriptionOnly');
	}
};
var $author$project$Types$Step$encodeRules = function (rules) {
	switch (rules.$) {
		case 8:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'active',
						$elm$json$Json$Encode$bool(true))
					]));
		case 9:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'inactive',
						$elm$json$Json$Encode$bool(false))
					]));
		case 5:
			var countAlias = rules.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'count',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'stepType',
									$author$project$Types$Step$encodeStepType(countAlias.eF)),
									_Utils_Tuple2(
									'stepId',
									A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, countAlias.gX)),
									_Utils_Tuple2(
									'amount',
									$elm$json$Json$Encode$int(countAlias.Q)),
									_Utils_Tuple2(
									'operator',
									$elm$json$Json$Encode$string(countAlias.cr))
								])))
					]));
		case 6:
			var diffAlias = rules.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'diff',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'stepType',
									$author$project$Types$Step$encodeStepType(diffAlias.eF)),
									_Utils_Tuple2(
									'firstStepId',
									$elm$json$Json$Encode$string(diffAlias.cd)),
									_Utils_Tuple2(
									'secondStepId',
									$elm$json$Json$Encode$string(diffAlias.cz)),
									_Utils_Tuple2(
									'amount',
									$elm$json$Json$Encode$int(diffAlias.Q)),
									_Utils_Tuple2(
									'operator',
									$elm$json$Json$Encode$string(diffAlias.cr))
								])))
					]));
		case 4:
			var infos = rules.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'present',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'stepType',
									$author$project$Types$Step$encodeStepType(infos.eF)),
									_Utils_Tuple2(
									'stepId',
									$elm$json$Json$Encode$string(infos.gX))
								])))
					]));
		case 3:
			var infos = rules.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'compare',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'stepType',
									$author$project$Types$Step$encodeStepType(infos.eF)),
									_Utils_Tuple2(
									'stepId',
									$elm$json$Json$Encode$string(infos.gX)),
									_Utils_Tuple2(
									'comparison',
									$author$project$Lib$Comparison$encodeComparison(infos._))
								])))
					]));
		case 7:
			var config = rules.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'textPattern',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'stepId',
									$elm$json$Json$Encode$string(config.gX)),
									_Utils_Tuple2(
									'pattern',
									$elm$json$Json$Encode$string(config.cw))
								])))
					]));
		case 2:
			var rule = rules.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'not',
						$author$project$Types$Step$encodeRules(rule))
					]));
		case 1:
			var ruleList = rules.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'or',
						A2($elm$json$Json$Encode$list, $author$project$Types$Step$encodeRules, ruleList))
					]));
		default:
			var ruleList = rules.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'and',
						A2($elm$json$Json$Encode$list, $author$project$Types$Step$encodeRules, ruleList))
					]));
	}
};
var $author$project$Types$Station$encodeEither = F3(
	function (encA, encB, either) {
		if (!either.$) {
			var a = either.a;
			return encA(a);
		} else {
			var b = either.a;
			return encB(b);
		}
	});
var $author$project$Types$Station$tuple2Encoder = F3(
	function (enc1, enc2, _v0) {
		var val1 = _v0.a;
		var val2 = _v0.b;
		return A2(
			$elm$json$Json$Encode$list,
			$elm$core$Basics$identity,
			_List_fromArray(
				[
					enc1(val1),
					enc2(val2)
				]));
	});
var $author$project$Types$Station$encodeStationRules = function (rules) {
	switch (rules.$) {
		case 0:
			var ruleList = rules.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'And',
						A2($elm$json$Json$Encode$list, $author$project$Types$Station$encodeStationRules, ruleList))
					]));
		case 1:
			var ruleList = rules.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'Or',
						A2($elm$json$Json$Encode$list, $author$project$Types$Station$encodeStationRules, ruleList))
					]));
		case 2:
			var rule = rules.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'Not',
						$author$project$Types$Station$encodeStationRules(rule))
					]));
		case 3:
			var stationId = rules.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'Completed',
						$elm$json$Json$Encode$string(stationId))
					]));
		case 4:
			var stationId = rules.a;
			var stepRules = rules.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'ApplyRules',
						A3(
							$author$project$Types$Station$tuple2Encoder,
							$elm$json$Json$Encode$string,
							$author$project$Types$Step$encodeRules,
							_Utils_Tuple2(stationId, stepRules)))
					]));
		case 5:
			var stationId = rules.a;
			var either = rules.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'CountBelow',
						A3(
							$author$project$Types$Station$tuple2Encoder,
							$elm$json$Json$Encode$string,
							A2(
								$author$project$Types$Station$encodeEither,
								A2($author$project$Types$Station$tuple2Encoder, $elm$json$Json$Encode$string, $elm$json$Json$Encode$string),
								$elm$json$Json$Encode$int),
							_Utils_Tuple2(stationId, either)))
					]));
		case 6:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'Inactive',
						$elm$json$Json$Encode$bool(false))
					]));
		default:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'Active',
						$elm$json$Json$Encode$bool(true))
					]));
	}
};
var $author$project$Types$Step$encodeStepDescription = function (description) {
	switch (description.$) {
		case 0:
			var message = description.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('warning')),
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(message))
					]));
		case 1:
			var message = description.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('danger')),
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(message))
					]));
		case 2:
			var message = description.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('info')),
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(message))
					]));
		default:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'type',
						$elm$json$Json$Encode$string('none')),
						_Utils_Tuple2(
						'description',
						$elm$json$Json$Encode$string(''))
					]));
	}
};
var $author$project$Types$Step$encodeStep = function (step) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(step.bD)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(step.dP)),
				_Utils_Tuple2(
				'stepType',
				$author$project$Types$Step$encodeStepType(step.eF)),
				_Utils_Tuple2(
				'rulesVisibility',
				$author$project$Types$Step$encodeRules(step.ej)),
				_Utils_Tuple2(
				'rulesInteractivity',
				$author$project$Types$Step$encodeRules(step.eh)),
				_Utils_Tuple2(
				'description',
				$author$project$Types$Step$encodeStepDescription(step.fl))
			]));
};
var $author$project$Types$Step$encodeStepDb = function (stepDb) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'yesNo',
				A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $author$project$Types$Steps$YesNo$encodeYesNo, stepDb.X)),
				_Utils_Tuple2(
				'articleInstallation',
				A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $author$project$Types$Steps$ArticleInstallation$encodeArticleInstallation, stepDb.ag)),
				_Utils_Tuple2(
				'articleReturn',
				A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $author$project$Types$Steps$ArticleInstallation$encodeArticleInstallation, stepDb.as)),
				_Utils_Tuple2(
				'timestamp',
				A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $author$project$Types$Steps$Timestamp$encode, stepDb.W)),
				_Utils_Tuple2(
				'text',
				A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $author$project$Types$Steps$Text$encode, stepDb.V)),
				_Utils_Tuple2(
				'amount',
				A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $author$project$Types$Steps$Amount$encode, stepDb.Q)),
				_Utils_Tuple2(
				'photo',
				A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $author$project$Types$Steps$Photo$encode, stepDb.P)),
				_Utils_Tuple2(
				'articleInput',
				A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $author$project$Types$Steps$ArticleInput$encode, stepDb.R)),
				_Utils_Tuple2(
				'articleRemoval',
				A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $author$project$Types$Steps$ArticleInput$encode, stepDb.ar)),
				_Utils_Tuple2(
				'signature',
				A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $author$project$Types$Steps$Signature$encode, stepDb.az))
			]));
};
var $author$project$Types$Station$encodeStation = function (station) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$string(station.bD)),
				_Utils_Tuple2(
				'name',
				$elm$json$Json$Encode$string(station.dP)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(station.fl)),
				_Utils_Tuple2(
				'title',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, station.g4)),
				_Utils_Tuple2(
				'stepOrder',
				A2($elm$json$Json$Encode$list, $author$project$Types$Step$encodeStep, station.eE)),
				_Utils_Tuple2(
				'stepDatabase',
				$author$project$Types$Step$encodeStepDb(station.A)),
				_Utils_Tuple2(
				'inline',
				$elm$json$Json$Encode$bool(station.dw)),
				_Utils_Tuple2(
				'aborted',
				$author$project$Types$Step$encodeRules(station.b2)),
				_Utils_Tuple2(
				'finished',
				$author$project$Types$Step$encodeRules(station.cc)),
				_Utils_Tuple2(
				'rulesInteractive',
				$author$project$Types$Station$encodeStationRules(station.eg)),
				_Utils_Tuple2(
				'rulesVisible',
				$author$project$Types$Station$encodeStationRules(station.ek)),
				_Utils_Tuple2(
				'rulesRepeat',
				$author$project$Types$Station$encodeStationRules(station.ei)),
				_Utils_Tuple2(
				'counter',
				$elm$json$Json$Encode$int(station.I)),
				_Utils_Tuple2(
				'iterations',
				A2($elm$json$Json$Encode$list, $elm$json$Json$Encode$int, station.ab))
			]));
};
var $author$project$Types$Station$encode = function (wrapper) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'syncState',
				$author$project$Lib$Sync$encode(wrapper.gZ)),
				_Utils_Tuple2(
				'operationClosed',
				$elm$json$Json$Encode$bool(wrapper.gv)),
				_Utils_Tuple2(
				'stations',
				A2($elm$json$Json$Encode$list, $author$project$Types$Station$encodeStation, wrapper.aA))
			]));
};
var $author$project$Types$Warehouse$encodeArticle = function (article) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(article.bD)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(article.fl)),
				_Utils_Tuple2(
				'productCategory',
				$elm$json$Json$Encode$string(article.d1)),
				_Utils_Tuple2(
				'vendor',
				$elm$json$Json$Encode$string(article.eT)),
				_Utils_Tuple2(
				'sn',
				$elm$json$Json$Encode$string(article.ex)),
				_Utils_Tuple2(
				'badPart',
				$elm$json$Json$Encode$bool(article.cX)),
				_Utils_Tuple2(
				'status',
				$elm$json$Json$Encode$string(article.eD)),
				_Utils_Tuple2(
				'reportStatus',
				$elm$json$Json$Encode$string(article.d9)),
				_Utils_Tuple2(
				'materialId',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$int, article.fZ)),
				_Utils_Tuple2(
				'templateId',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$int, article.g1)),
				_Utils_Tuple2(
				'installationSite',
				$elm$json$Json$Encode$string(article.dz)),
				_Utils_Tuple2(
				'problemDescription',
				$elm$json$Json$Encode$string(article.d_)),
				_Utils_Tuple2(
				'swapPart',
				$elm$json$Json$Encode$bool(article.eK)),
				_Utils_Tuple2(
				'snBadPart',
				$elm$json$Json$Encode$string(article.ey)),
				_Utils_Tuple2(
				'syncState',
				$author$project$Lib$Sync$encode(article.gZ)),
				_Utils_Tuple2(
				'operationId',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$int, article.gw)),
				_Utils_Tuple2(
				'takenIntoCustody',
				$elm$json$Json$Encode$bool(article.eM)),
				_Utils_Tuple2(
				'reqType',
				A2(
					$elm_community$json_extra$Json$Encode$Extra$maybe,
					$elm$json$Json$Encode$string,
					function () {
						var _v0 = article.ea;
						if (!_v0.$) {
							if (_v0.a === 1) {
								var _v1 = _v0.a;
								return $elm$core$Maybe$Just('MUsage');
							} else {
								var _v2 = _v0.a;
								return $elm$core$Maybe$Just('MReplacement');
							}
						} else {
							return $elm$core$Maybe$Nothing;
						}
					}()))
			]));
};
var $author$project$Types$Queue$encodeQueueReference = function (ref) {
	switch (ref.$) {
		case 2:
			var msg = ref.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'msg',
						$elm$json$Json$Encode$string('QueueDeprecated')),
						_Utils_Tuple2(
						'deprecated',
						$elm$json$Json$Encode$string(msg))
					]));
		case 0:
			var operationId = ref.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'msg',
						$elm$json$Json$Encode$string('QueueStation')),
						_Utils_Tuple2(
						'operationId',
						$elm$json$Json$Encode$string(operationId))
					]));
		default:
			var photoReference = ref.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'msg',
						$elm$json$Json$Encode$string('QueuePhoto')),
						_Utils_Tuple2(
						'ref',
						$author$project$Types$Steps$Photo$encode(photoReference))
					]));
	}
};
var $author$project$Types$Queue$encodeSyncType = function (st) {
	if (!st.$) {
		var operationId = st.a;
		var stationSyncWrapper = st.b;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'syncType',
					$elm$json$Json$Encode$string('SyncStation')),
					_Utils_Tuple2(
					'operationId',
					$elm$json$Json$Encode$string(operationId)),
					_Utils_Tuple2(
					'stationSyncWrapper',
					$author$project$Types$Station$encode(stationSyncWrapper))
				]));
	} else {
		var photo = st.a;
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'syncType',
					$elm$json$Json$Encode$string('SyncPhoto')),
					_Utils_Tuple2(
					'photo',
					$author$project$Types$Steps$Photo$encode(photo))
				]));
	}
};
var $author$project$Types$Queue$encodeSyncStatus = function (status) {
	switch (status.$) {
		case 0:
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'syncStatus',
						$elm$json$Json$Encode$string('NotStarted'))
					]));
		case 1:
			var st = status.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'syncStatus',
						$elm$json$Json$Encode$string('Staged')),
						_Utils_Tuple2(
						'status',
						$author$project$Types$Queue$encodeSyncType(st))
					]));
		case 2:
			var retries = status.a;
			var st = status.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'syncStatus',
						$elm$json$Json$Encode$string('StagedRetry')),
						_Utils_Tuple2(
						'retries',
						$elm$json$Json$Encode$int(retries)),
						_Utils_Tuple2(
						'status',
						$author$project$Types$Queue$encodeSyncType(st))
					]));
		case 3:
			var retries = status.a;
			var st = status.b;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'syncStatus',
						$elm$json$Json$Encode$string('Processing')),
						_Utils_Tuple2(
						'retries',
						$elm$json$Json$Encode$int(retries)),
						_Utils_Tuple2(
						'status',
						$author$project$Types$Queue$encodeSyncType(st))
					]));
		default:
			var time = status.a;
			return $elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'syncStatus',
						$elm$json$Json$Encode$string('LoadFromDb')),
						_Utils_Tuple2(
						'time',
						$elm$json$Json$Encode$int(
							$elm$time$Time$posixToMillis(time)))
					]));
	}
};
var $author$project$Actions$Warehouse$mergeMaterials = F2(
	function (operationArticles, currentWarehouse) {
		var operationArticleIds = A2(
			$elm$core$List$map,
			function ($) {
				return $.bD;
			},
			operationArticles);
		return A2(
			$elm$core$List$append,
			operationArticles,
			A2(
				$elm$core$List$filter,
				function (article) {
					return !A2($elm$core$List$member, article.bD, operationArticleIds);
				},
				currentWarehouse));
	});
var $author$project$Actions$Warehouse$mergeWarehouseAndOperation = F2(
	function (remoteWarehouse, materials) {
		return A2($author$project$Actions$Warehouse$mergeMaterials, materials, remoteWarehouse);
	});
var $author$project$Types$Operation$encodePart = function (part) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'rma',
				$elm$json$Json$Encode$string(part.ef)),
				_Utils_Tuple2(
				'description',
				$elm$json$Json$Encode$string(part.fl)),
				_Utils_Tuple2(
				'oldSN',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, part.cp)),
				_Utils_Tuple2(
				'newSN',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, part.cp)),
				_Utils_Tuple2(
				'syncState',
				$author$project$Lib$Sync$encode(part.gZ))
			]));
};
var $author$project$Types$Operation$encodeParts = function (parts) {
	return A2($elm$json$Json$Encode$list, $author$project$Types$Operation$encodePart, parts);
};
var $author$project$Types$Operation$operationEncoder = function (operation) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'projectId',
				$elm$json$Json$Encode$int(operation.gB)),
				_Utils_Tuple2(
				'warehouseId',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$int, operation.he)),
				_Utils_Tuple2(
				'binId',
				A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$int, operation.e5)),
				_Utils_Tuple2(
				'reportClosed',
				$elm$json$Json$Encode$bool(operation.cy)),
				_Utils_Tuple2(
				'id',
				$elm$json$Json$Encode$int(operation.bD)),
				_Utils_Tuple2(
				'parts',
				$author$project$Types$Operation$encodeParts(operation.cv))
			]));
};
var $author$project$Model$encode = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'baseUrl',
				$elm$json$Json$Encode$string(model.a2)),
				_Utils_Tuple2(
				'operations',
				A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $author$project$Types$Operation$operationEncoder, model.ba)),
				_Utils_Tuple2(
				'notSyncable',
				A2($elm$json$Json$Encode$list, $author$project$Types$Queue$encodeQueueReference, model.aR)),
				_Utils_Tuple2(
				'warehouse',
				function () {
					var _v0 = model.eV;
					if (_v0.$ === 3) {
						var articles = _v0.a;
						return A2($elm$json$Json$Encode$list, $author$project$Types$Warehouse$encodeArticle, articles);
					} else {
						return $elm$json$Json$Encode$null;
					}
				}()),
				_Utils_Tuple2(
				'stations',
				A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $author$project$Types$Station$encode, model.aA)),
				_Utils_Tuple2(
				'language',
				function () {
					var _v1 = model.ck;
					if (_v1 === 1) {
						return $elm$json$Json$Encode$string('en');
					} else {
						return $elm$json$Json$Encode$string('de');
					}
				}())
			]));
};
var $author$project$Lib$PortHelpers$nextModel = function (model) {
	var modelEncoded = $author$project$Model$encode(model);
	return $author$project$Ports$out_(
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'msg',
					$elm$json$Json$Encode$string('NextModelMsg')),
					_Utils_Tuple2('data', modelEncoded)
				])));
};
var $elm$core$Platform$Cmd$none = $elm$core$Platform$Cmd$batch(_List_Nil);
var $rlopzc$elm_sentry$Sentry$Config = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rlopzc$elm_sentry$Sentry$Host = $elm$core$Basics$identity;
var $rlopzc$elm_sentry$Sentry$ProjectId = $elm$core$Basics$identity;
var $rlopzc$elm_sentry$Sentry$PublicKey = $elm$core$Basics$identity;
var $rlopzc$elm_sentry$Sentry$config = function (conf) {
	return A3($rlopzc$elm_sentry$Sentry$Config, conf.gF, conf.fC, conf.gB);
};
var $author$project$Lib$Sentry$config = $rlopzc$elm_sentry$Sentry$config(
	{fC: 'o422866.ingest.sentry.io', gB: '5694183', gF: '17fdbdaca89f4accb61968e7ac6f8c10'});
var $rlopzc$elm_sentry$Sentry$Environment = $elm$core$Basics$identity;
var $rlopzc$elm_sentry$Sentry$environment = $elm$core$Basics$identity;
var $author$project$Lib$Sentry$environment = $rlopzc$elm_sentry$Sentry$environment('prod');
var $rlopzc$elm_sentry$Sentry$ReleaseVersion = $elm$core$Basics$identity;
var $rlopzc$elm_sentry$Sentry$releaseVersion = $elm$core$Basics$identity;
var $author$project$Lib$Sentry$releaseVersion = function (version) {
	return $rlopzc$elm_sentry$Sentry$releaseVersion(version);
};
var $rlopzc$elm_sentry$Sentry$Context = $elm$core$Basics$identity;
var $rlopzc$elm_sentry$Sentry$Debug = 4;
var $rlopzc$elm_sentry$Sentry$Error = 1;
var $rlopzc$elm_sentry$Sentry$Fatal = 0;
var $rlopzc$elm_sentry$Sentry$Info = 3;
var $rlopzc$elm_sentry$Sentry$Warning = 2;
var $elm$http$Http$Header = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$http$Http$header = $elm$http$Http$Header;
var $rlopzc$elm_sentry$Sentry$posixToSeconds = function (posix) {
	return ($elm$time$Time$posixToMillis(posix) / 1000) | 0;
};
var $rlopzc$elm_sentry$Sentry$sentryVersion = '7';
var $rlopzc$elm_sentry$Sentry$Internal$version = '1.0.0';
var $rlopzc$elm_sentry$Sentry$authHeader = F2(
	function (posix, _v0) {
		var vpublicKey = _v0;
		return A2(
			$elm$http$Http$header,
			'X-Sentry-Auth',
			('Sentry sentry_version=' + $rlopzc$elm_sentry$Sentry$sentryVersion) + ((',sentry_client=elm-sentry/' + $rlopzc$elm_sentry$Sentry$Internal$version) + ((',sentry_timestamp=' + $elm$core$String$fromInt(
				$rlopzc$elm_sentry$Sentry$posixToSeconds(posix))) + (',sentry_key=' + vpublicKey))));
	});
var $rlopzc$elm_sentry$Sentry$endpointUrl = F2(
	function (_v0, _v1) {
		var vhost = _v0;
		var vprojectId = _v1;
		return 'https://' + (vhost + ('/api/' + (vprojectId + '/store/')));
	});
var $TSFoster$elm_uuid$UUID$UUID = F4(
	function (a, b, c, d) {
		return {$: 0, a: a, b: b, c: c, d: d};
	});
var $elm$random$Random$Generator = $elm$core$Basics$identity;
var $elm$random$Random$map = F2(
	function (func, _v0) {
		var genA = _v0;
		return function (seed0) {
			var _v1 = genA(seed0);
			var a = _v1.a;
			var seed1 = _v1.b;
			return _Utils_Tuple2(
				func(a),
				seed1);
		};
	});
var $elm$random$Random$map4 = F5(
	function (func, _v0, _v1, _v2, _v3) {
		var genA = _v0;
		var genB = _v1;
		var genC = _v2;
		var genD = _v3;
		return function (seed0) {
			var _v4 = genA(seed0);
			var a = _v4.a;
			var seed1 = _v4.b;
			var _v5 = genB(seed1);
			var b = _v5.a;
			var seed2 = _v5.b;
			var _v6 = genC(seed2);
			var c = _v6.a;
			var seed3 = _v6.b;
			var _v7 = genD(seed3);
			var d = _v7.a;
			var seed4 = _v7.b;
			return _Utils_Tuple2(
				A4(func, a, b, c, d),
				seed4);
		};
	});
var $TSFoster$elm_uuid$UUID$forceUnsigned = $elm$core$Bitwise$shiftRightZfBy(0);
var $elm$random$Random$Seed = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$random$Random$next = function (_v0) {
	var state0 = _v0.a;
	var incr = _v0.b;
	return A2($elm$random$Random$Seed, ((state0 * 1664525) + incr) >>> 0, incr);
};
var $elm$random$Random$peel = function (_v0) {
	var state = _v0.a;
	var word = (state ^ (state >>> ((state >>> 28) + 4))) * 277803737;
	return ((word >>> 22) ^ word) >>> 0;
};
var $elm$random$Random$int = F2(
	function (a, b) {
		return function (seed0) {
			var _v0 = (_Utils_cmp(a, b) < 0) ? _Utils_Tuple2(a, b) : _Utils_Tuple2(b, a);
			var lo = _v0.a;
			var hi = _v0.b;
			var range = (hi - lo) + 1;
			if (!((range - 1) & range)) {
				return _Utils_Tuple2(
					(((range - 1) & $elm$random$Random$peel(seed0)) >>> 0) + lo,
					$elm$random$Random$next(seed0));
			} else {
				var threshhold = (((-range) >>> 0) % range) >>> 0;
				var accountForBias = function (seed) {
					accountForBias:
					while (true) {
						var x = $elm$random$Random$peel(seed);
						var seedN = $elm$random$Random$next(seed);
						if (_Utils_cmp(x, threshhold) < 0) {
							var $temp$seed = seedN;
							seed = $temp$seed;
							continue accountForBias;
						} else {
							return _Utils_Tuple2((x % range) + lo, seedN);
						}
					}
				};
				return accountForBias(seed0);
			}
		};
	});
var $elm$random$Random$maxInt = 2147483647;
var $elm$random$Random$minInt = -2147483648;
var $TSFoster$elm_uuid$UUID$randomU32 = A2(
	$elm$random$Random$map,
	$TSFoster$elm_uuid$UUID$forceUnsigned,
	A2($elm$random$Random$int, $elm$random$Random$minInt, $elm$random$Random$maxInt));
var $TSFoster$elm_uuid$UUID$toVariant1 = function (_v0) {
	var a = _v0.a;
	var b = _v0.b;
	var c = _v0.c;
	var d = _v0.d;
	return A4(
		$TSFoster$elm_uuid$UUID$UUID,
		a,
		b,
		$TSFoster$elm_uuid$UUID$forceUnsigned(2147483648 | (1073741823 & c)),
		d);
};
var $TSFoster$elm_uuid$UUID$toVersion = F2(
	function (v, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		var c = _v0.c;
		var d = _v0.d;
		return A4(
			$TSFoster$elm_uuid$UUID$UUID,
			a,
			$TSFoster$elm_uuid$UUID$forceUnsigned((v << 12) | (4294905855 & b)),
			c,
			d);
	});
var $TSFoster$elm_uuid$UUID$generator = A2(
	$elm$random$Random$map,
	A2(
		$elm$core$Basics$composeR,
		$TSFoster$elm_uuid$UUID$toVersion(4),
		$TSFoster$elm_uuid$UUID$toVariant1),
	A5($elm$random$Random$map4, $TSFoster$elm_uuid$UUID$UUID, $TSFoster$elm_uuid$UUID$randomU32, $TSFoster$elm_uuid$UUID$randomU32, $TSFoster$elm_uuid$UUID$randomU32, $TSFoster$elm_uuid$UUID$randomU32));
var $rlopzc$elm_sentry$Sentry$httpResolver = F2(
	function (uuid, response) {
		switch (response.$) {
			case 0:
				var url = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadUrl(url));
			case 1:
				return $elm$core$Result$Err($elm$http$Http$Timeout);
			case 2:
				return $elm$core$Result$Err($elm$http$Http$NetworkError);
			case 3:
				var metadata = response.a;
				return $elm$core$Result$Err(
					$elm$http$Http$BadStatus(metadata.gV));
			default:
				return $elm$core$Result$Ok(uuid);
		}
	});
var $elm$random$Random$initialSeed = function (x) {
	var _v0 = $elm$random$Random$next(
		A2($elm$random$Random$Seed, 0, 1013904223));
	var state1 = _v0.a;
	var incr = _v0.b;
	var state2 = (state1 + x) >>> 0;
	return $elm$random$Random$next(
		A2($elm$random$Random$Seed, state2, incr));
};
var $rlopzc$elm_sentry$Sentry$retries = {dL: 60, dO: 1000};
var $elm$random$Random$step = F2(
	function (_v0, seed) {
		var generator = _v0;
		return generator(seed);
	});
var $TSFoster$elm_uuid$UUID$Compact = 3;
var $elm$http$Http$jsonBody = function (value) {
	return A2(
		_Http_pair,
		'application/json',
		A2($elm$json$Json$Encode$encode, 0, value));
};
var $rlopzc$elm_sentry$Sentry$levelToString = function (level) {
	switch (level) {
		case 0:
			return 'fatal';
		case 1:
			return 'error';
		case 2:
			return 'warning';
		case 3:
			return 'info';
		default:
			return 'debug';
	}
};
var $rlopzc$elm_sentry$Sentry$messageEncoder = function (vmessage) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'formatted',
				$elm$json$Json$Encode$string(vmessage))
			]));
};
var $elm$core$String$fromChar = function (_char) {
	return A2($elm$core$String$cons, _char, '');
};
var $elm$core$Bitwise$shiftRightBy = _Bitwise_shiftRightBy;
var $elm$core$String$repeatHelp = F3(
	function (n, chunk, result) {
		return (n <= 0) ? result : A3(
			$elm$core$String$repeatHelp,
			n >> 1,
			_Utils_ap(chunk, chunk),
			(!(n & 1)) ? result : _Utils_ap(result, chunk));
	});
var $elm$core$String$repeat = F2(
	function (n, chunk) {
		return A3($elm$core$String$repeatHelp, n, chunk, '');
	});
var $elm$core$String$padLeft = F3(
	function (n, _char, string) {
		return _Utils_ap(
			A2(
				$elm$core$String$repeat,
				n - $elm$core$String$length(string),
				$elm$core$String$fromChar(_char)),
			string);
	});
var $TSFoster$elm_uuid$UUID$toHex = F2(
	function (acc, _int) {
		toHex:
		while (true) {
			if (!_int) {
				return $elm$core$String$fromList(acc);
			} else {
				var _char = function () {
					var _v0 = 15 & _int;
					switch (_v0) {
						case 0:
							return '0';
						case 1:
							return '1';
						case 2:
							return '2';
						case 3:
							return '3';
						case 4:
							return '4';
						case 5:
							return '5';
						case 6:
							return '6';
						case 7:
							return '7';
						case 8:
							return '8';
						case 9:
							return '9';
						case 10:
							return 'a';
						case 11:
							return 'b';
						case 12:
							return 'c';
						case 13:
							return 'd';
						case 14:
							return 'e';
						default:
							return 'f';
					}
				}();
				var $temp$acc = A2($elm$core$List$cons, _char, acc),
					$temp$int = _int >>> 4;
				acc = $temp$acc;
				_int = $temp$int;
				continue toHex;
			}
		}
	});
var $TSFoster$elm_uuid$UUID$toStringWith = F2(
	function (sep, _v0) {
		var a = _v0.a;
		var b = _v0.b;
		var c = _v0.c;
		var d = _v0.d;
		return _Utils_ap(
			A3(
				$elm$core$String$padLeft,
				8,
				'0',
				A2($TSFoster$elm_uuid$UUID$toHex, _List_Nil, a)),
			_Utils_ap(
				sep,
				_Utils_ap(
					A3(
						$elm$core$String$padLeft,
						4,
						'0',
						A2($TSFoster$elm_uuid$UUID$toHex, _List_Nil, b >>> 16)),
					_Utils_ap(
						sep,
						_Utils_ap(
							A3(
								$elm$core$String$padLeft,
								4,
								'0',
								A2($TSFoster$elm_uuid$UUID$toHex, _List_Nil, 65535 & b)),
							_Utils_ap(
								sep,
								_Utils_ap(
									A3(
										$elm$core$String$padLeft,
										4,
										'0',
										A2($TSFoster$elm_uuid$UUID$toHex, _List_Nil, c >>> 16)),
									_Utils_ap(
										sep,
										_Utils_ap(
											A3(
												$elm$core$String$padLeft,
												4,
												'0',
												A2($TSFoster$elm_uuid$UUID$toHex, _List_Nil, 65535 & c)),
											A3(
												$elm$core$String$padLeft,
												8,
												'0',
												A2($TSFoster$elm_uuid$UUID$toHex, _List_Nil, d)))))))))));
	});
var $TSFoster$elm_uuid$UUID$toString = $TSFoster$elm_uuid$UUID$toStringWith('-');
var $TSFoster$elm_uuid$UUID$toRepresentation = F2(
	function (representation, uuid) {
		switch (representation) {
			case 0:
				return $TSFoster$elm_uuid$UUID$toString(uuid);
			case 1:
				return 'urn:uuid:' + $TSFoster$elm_uuid$UUID$toString(uuid);
			case 2:
				return '{' + ($TSFoster$elm_uuid$UUID$toString(uuid) + '}');
			default:
				return A2($TSFoster$elm_uuid$UUID$toStringWith, '', uuid);
		}
	});
var $rlopzc$elm_sentry$Sentry$toJsonBody = F8(
	function (uuid, posix, level, _v0, _v1, _v2, message, metadata) {
		var vreleaseVersion = _v0;
		var venvironment = _v1;
		var vcontext = _v2;
		return $elm$http$Http$jsonBody(
			$elm$json$Json$Encode$object(
				_List_fromArray(
					[
						_Utils_Tuple2(
						'event_id',
						$elm$json$Json$Encode$string(
							A2($TSFoster$elm_uuid$UUID$toRepresentation, 3, uuid))),
						_Utils_Tuple2(
						'timestamp',
						$elm$json$Json$Encode$int(
							$rlopzc$elm_sentry$Sentry$posixToSeconds(posix))),
						_Utils_Tuple2(
						'platform',
						$elm$json$Json$Encode$string('elm')),
						_Utils_Tuple2(
						'level',
						$elm$json$Json$Encode$string(
							$rlopzc$elm_sentry$Sentry$levelToString(level))),
						_Utils_Tuple2(
						'release',
						$elm$json$Json$Encode$string(vreleaseVersion)),
						_Utils_Tuple2(
						'environment',
						$elm$json$Json$Encode$string(venvironment)),
						_Utils_Tuple2(
						'tags',
						$elm$json$Json$Encode$object(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'context',
									$elm$json$Json$Encode$string(vcontext))
								]))),
						_Utils_Tuple2(
						'message',
						$rlopzc$elm_sentry$Sentry$messageEncoder(message)),
						_Utils_Tuple2(
						'extra',
						$elm$json$Json$Encode$object(
							$elm$core$Dict$toList(metadata)))
					])));
	});
var $elm$core$Process$sleep = _Process_sleep;
var $rlopzc$elm_sentry$Sentry$withRetry = F2(
	function (maxRetryAttempts, task) {
		var retry = function (httpError) {
			if (maxRetryAttempts > 0) {
				if (httpError.$ === 3) {
					var statusCode = httpError.a;
					return (statusCode === 429) ? A2(
						$elm$core$Task$andThen,
						function (_v1) {
							return A2($rlopzc$elm_sentry$Sentry$withRetry, maxRetryAttempts - 1, task);
						},
						$elm$core$Process$sleep($rlopzc$elm_sentry$Sentry$retries.dO)) : $elm$core$Task$fail(httpError);
				} else {
					return $elm$core$Task$fail(httpError);
				}
			} else {
				return $elm$core$Task$fail(httpError);
			}
		};
		return A2($elm$core$Task$onError, retry, task);
	});
var $rlopzc$elm_sentry$Sentry$sendWithTime = F8(
	function (_v0, level, vreleaseVersion, venvironment, vcontext, message, metadata, posix) {
		var vpublicKey = _v0.a;
		var vhost = _v0.b;
		var vprojectId = _v0.c;
		var uuid = A2(
			$elm$random$Random$step,
			$TSFoster$elm_uuid$UUID$generator,
			$elm$random$Random$initialSeed(
				$rlopzc$elm_sentry$Sentry$posixToSeconds(posix))).a;
		var body = A8($rlopzc$elm_sentry$Sentry$toJsonBody, uuid, posix, level, vreleaseVersion, venvironment, vcontext, message, metadata);
		return A2(
			$rlopzc$elm_sentry$Sentry$withRetry,
			$rlopzc$elm_sentry$Sentry$retries.dL,
			$elm$http$Http$task(
				{
					e6: body,
					fy: _List_fromArray(
						[
							A2($rlopzc$elm_sentry$Sentry$authHeader, posix, vpublicKey)
						]),
					f2: 'POST',
					ee: $elm$http$Http$stringResolver(
						$rlopzc$elm_sentry$Sentry$httpResolver(uuid)),
					g3: $elm$core$Maybe$Nothing,
					hc: A2($rlopzc$elm_sentry$Sentry$endpointUrl, vhost, vprojectId)
				}));
	});
var $rlopzc$elm_sentry$Sentry$send = F7(
	function (vconfig, level, vreleaseVersion, venvironment, vcontext, message, metadata) {
		return A2(
			$elm$core$Task$andThen,
			A7($rlopzc$elm_sentry$Sentry$sendWithTime, vconfig, level, vreleaseVersion, venvironment, vcontext, message, metadata),
			$elm$time$Time$now);
	});
var $rlopzc$elm_sentry$Sentry$withContext = F4(
	function (vconfig, vreleaseVersion, venvironment, contextStr) {
		var vcontext = contextStr;
		return {
			da: A5($rlopzc$elm_sentry$Sentry$send, vconfig, 4, vreleaseVersion, venvironment, vcontext),
			bA: A5($rlopzc$elm_sentry$Sentry$send, vconfig, 1, vreleaseVersion, venvironment, vcontext),
			dh: A5($rlopzc$elm_sentry$Sentry$send, vconfig, 0, vreleaseVersion, venvironment, vcontext),
			bE: A5($rlopzc$elm_sentry$Sentry$send, vconfig, 3, vreleaseVersion, venvironment, vcontext),
			eW: A5($rlopzc$elm_sentry$Sentry$send, vconfig, 2, vreleaseVersion, venvironment, vcontext)
		};
	});
var $author$project$Lib$Sentry$sentry = function (version) {
	return A4(
		$rlopzc$elm_sentry$Sentry$withContext,
		$author$project$Lib$Sentry$config,
		$author$project$Lib$Sentry$releaseVersion(version),
		$author$project$Lib$Sentry$environment,
		'profile/settings');
};
var $author$project$Msg$ApiErrorReportResult = function (a) {
	return {$: 5, a: a};
};
var $elm$http$Http$expectBytesResponse = F2(
	function (toMsg, toResult) {
		return A3(
			_Http_expect,
			'arraybuffer',
			_Http_toDataView,
			A2($elm$core$Basics$composeR, toResult, toMsg));
	});
var $elm$http$Http$expectWhatever = function (toMsg) {
	return A2(
		$elm$http$Http$expectBytesResponse,
		toMsg,
		$elm$http$Http$resolve(
			function (_v0) {
				return $elm$core$Result$Ok(0);
			}));
};
var $author$project$Actions$Debugger$uploadErrorReport = F3(
	function (baseUrl, source, data) {
		var requestTarget = '/r/api/v1/technicians/upload_errorreport.json';
		return $elm$http$Http$request(
			{
				e6: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2('content', data),
								_Utils_Tuple2(
								'source',
								$elm$json$Json$Encode$string(source))
							]))),
				fq: $elm$http$Http$expectWhatever(
					A2($elm$core$Basics$composeL, $author$project$Msg$ApiMsg_, $author$project$Msg$ApiErrorReportResult)),
				fy: _List_Nil,
				f2: 'POST',
				g3: $elm$core$Maybe$Nothing,
				g6: $elm$core$Maybe$Nothing,
				hc: _Utils_ap(baseUrl, requestTarget)
			});
	});
var $author$project$Update$handleApiMsg = F2(
	function (apiMsg, model) {
		switch (apiMsg.$) {
			case 0:
				var operationId = apiMsg.a;
				var res = apiMsg.b;
				if (res.$ === 3) {
					var _v2 = res.a;
					var remoteOperation = _v2.a;
					var _v3 = _v2.b;
					var remoteWarehouse = _v3.a;
					var materials = _v3.b;
					var warehouse = A2($author$project$Actions$Warehouse$mergeWarehouseAndOperation, remoteWarehouse, materials);
					var operations = A3(
						$elm$core$Dict$update,
						operationId,
						function (_v4) {
							return $elm$core$Maybe$Just(remoteOperation);
						},
						model.ba);
					var model_ = _Utils_update(
						model,
						{
							ba: operations,
							eV: $krisajenkins$remotedata$RemoteData$Success(warehouse)
						});
					return _Utils_Tuple2(
						model_,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Lib$PortHelpers$nextModel(model_)
								])));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 1:
				var res = apiMsg.a;
				if (res.$ === 3) {
					var model_ = _Utils_update(
						model,
						{eV: res});
					return _Utils_Tuple2(
						model_,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Lib$PortHelpers$nextModel(model_)
								])));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 2:
				var res = apiMsg.a;
				if (!res.$) {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				} else {
					var err = res.a;
					switch (err.$) {
						case 0:
							var url = err.a;
							return _Utils_Tuple2(
								model,
								A2(
									$elm$core$Task$attempt,
									$author$project$Msg$SentryResponse,
									A2(
										$author$project$Lib$Sentry$sentry(model.ae).dh,
										'Could not login due to malformed URL: ' + url,
										$elm$core$Dict$fromList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'userEmail',
													A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, model.aa))
												])))));
						case 1:
							return _Utils_Tuple2(
								model,
								$author$project$Ports$out_(
									$elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'msg',
												$elm$json$Json$Encode$string('TODO')),
												_Utils_Tuple2(
												'data',
												$elm$json$Json$Encode$string('TODO::show notification, that a login is currently not possible, because the server is not responding'))
											]))));
						case 2:
							return _Utils_Tuple2(
								model,
								$author$project$Ports$out_(
									$elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'msg',
												$elm$json$Json$Encode$string('TODO')),
												_Utils_Tuple2(
												'data',
												$elm$json$Json$Encode$string('TODO::show notification, that a login is currently not possible'))
											]))));
						case 3:
							var statusCode = err.a;
							return _Utils_Tuple2(
								model,
								$author$project$Ports$out_(
									$elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'msg',
												$elm$json$Json$Encode$string('TODO')),
												_Utils_Tuple2(
												'data',
												$elm$json$Json$Encode$object(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'status',
															$elm$json$Json$Encode$int(statusCode)),
															_Utils_Tuple2(
															'msg',
															$elm$json$Json$Encode$string('Login failed with bad status'))
														])))
											]))));
						default:
							var badBody = err.a;
							return _Utils_Tuple2(
								model,
								A2(
									$elm$core$Task$attempt,
									$author$project$Msg$SentryResponse,
									A2(
										$author$project$Lib$Sentry$sentry(model.ae).bA,
										'Could not login due to malformed response body: ' + badBody,
										$elm$core$Dict$fromList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'userEmail',
													A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, model.aa))
												])))));
					}
				}
			case 3:
				var operationId = apiMsg.a;
				var res = apiMsg.b;
				if (!res.$) {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aA: A3(
									$elm$core$Dict$update,
									operationId,
									$elm$core$Maybe$map(
										function (station) {
											return _Utils_update(
												station,
												{gZ: $author$project$Lib$Sync$Server});
										}),
									model.aA)
							}),
						$elm$core$Platform$Cmd$none);
				} else {
					var err = res.a;
					switch (err.$) {
						case 0:
							var url = err.a;
							return _Utils_Tuple2(
								model,
								A2(
									$elm$core$Task$attempt,
									$author$project$Msg$SentryResponse,
									A2(
										$author$project$Lib$Sentry$sentry(model.ae).dh,
										'Could not login due to malformed URL: ' + url,
										$elm$core$Dict$fromList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'userEmail',
													A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, model.aa))
												])))));
						case 1:
							return _Utils_Tuple2(
								model,
								$author$project$Ports$out_(
									$elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'msg',
												$elm$json$Json$Encode$string('TODO')),
												_Utils_Tuple2(
												'data',
												$elm$json$Json$Encode$string('TODO::show notification, that a login is currently not possible, because the server is not responding'))
											]))));
						case 2:
							return _Utils_Tuple2(
								model,
								$author$project$Ports$out_(
									$elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'msg',
												$elm$json$Json$Encode$string('TODO')),
												_Utils_Tuple2(
												'data',
												$elm$json$Json$Encode$string('TODO::show notification, that a login is currently not possible'))
											]))));
						case 3:
							var statusCode = err.a;
							return _Utils_Tuple2(
								model,
								$author$project$Ports$out_(
									$elm$json$Json$Encode$object(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'msg',
												$elm$json$Json$Encode$string('TODO')),
												_Utils_Tuple2(
												'data',
												$elm$json$Json$Encode$object(
													_List_fromArray(
														[
															_Utils_Tuple2(
															'status',
															$elm$json$Json$Encode$int(statusCode)),
															_Utils_Tuple2(
															'msg',
															$elm$json$Json$Encode$string('Login failed with bad status'))
														])))
											]))));
						default:
							var badBody = err.a;
							return _Utils_Tuple2(
								model,
								A2(
									$elm$core$Task$attempt,
									$author$project$Msg$SentryResponse,
									A2(
										$author$project$Lib$Sentry$sentry(model.ae).bA,
										'Could not login due to malformed response body: ' + badBody,
										$elm$core$Dict$fromList(
											_List_fromArray(
												[
													_Utils_Tuple2(
													'userEmail',
													A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, model.aa))
												])))));
					}
				}
			case 4:
				var uiState = model.bj;
				var encodedModel = $elm$json$Json$Encode$object(
					_List_fromArray(
						[
							_Utils_Tuple2(
							'baseUrl',
							$elm$json$Json$Encode$string(model.a2)),
							_Utils_Tuple2(
							'operations',
							A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $author$project$Types$Operation$operationEncoder, model.ba)),
							_Utils_Tuple2(
							'notSyncable',
							A2($elm$json$Json$Encode$list, $author$project$Types$Queue$encodeQueueReference, model.aR)),
							_Utils_Tuple2(
							'warehouse',
							function () {
								var _v10 = model.eV;
								if (_v10.$ === 3) {
									var articles = _v10.a;
									return A2($elm$json$Json$Encode$list, $author$project$Types$Warehouse$encodeArticle, articles);
								} else {
									return $elm$json$Json$Encode$null;
								}
							}()),
							_Utils_Tuple2(
							'stations',
							A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $author$project$Types$Station$encode, model.aA)),
							_Utils_Tuple2(
							'currentSync',
							$author$project$Types$Queue$encodeSyncStatus(model.c8)),
							_Utils_Tuple2(
							'queue',
							A2($elm$json$Json$Encode$list, $author$project$Types$Queue$encodeQueueReference, model.aT)),
							_Utils_Tuple2(
							'notSyncable',
							A2($elm$json$Json$Encode$list, $author$project$Types$Queue$encodeQueueReference, model.aR)),
							_Utils_Tuple2(
							'time',
							$elm$json$Json$Encode$int(
								$elm$time$Time$posixToMillis(model.g2))),
							_Utils_Tuple2(
							'jwt',
							A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, model.bG)),
							_Utils_Tuple2(
							'email',
							A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, model.aa)),
							_Utils_Tuple2(
							'version',
							$elm$json$Json$Encode$string(model.ae))
						]));
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bj: _Utils_update(
								uiState,
								{fg: $krisajenkins$remotedata$RemoteData$Loading})
						}),
					A3($author$project$Actions$Debugger$uploadErrorReport, model.a2, 'Dump vom Techniker', encodedModel));
			default:
				var res = apiMsg.a;
				var uiState = model.bj;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bj: _Utils_update(
								uiState,
								{
									fg: function () {
										if (!res.$) {
											return $krisajenkins$remotedata$RemoteData$Success(0);
										} else {
											var err = res.a;
											return $krisajenkins$remotedata$RemoteData$Failure(err);
										}
									}()
								})
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Msg$PhotoNotOnThisDevice = function (a) {
	return {$: 2, a: a};
};
var $author$project$Msg$StationMsg_ = F3(
	function (a, b, c) {
		return {$: 15, a: a, b: b, c: c};
	});
var $author$project$Msg$StationUpdateStepState = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Msg$StepPhotoMsg = function (a) {
	return {$: 6, a: a};
};
var $author$project$Msg$AttemptSync = {$: 1};
var $author$project$Types$Queue$Staged = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$Queue$SyncPhoto = function (a) {
	return {$: 1, a: a};
};
var $author$project$Actions$Operation$stagePhoto = function (photoReference) {
	return _Utils_Tuple2(
		$author$project$Types$Queue$Staged(
			$author$project$Types$Queue$SyncPhoto(photoReference)),
		$author$project$Lib$send(
			$author$project$Msg$QueueMsg_($author$project$Msg$AttemptSync)));
};
var $author$project$Types$Queue$SyncStation = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Actions$Operation$stageStation = F2(
	function (operationId, station) {
		return _Utils_Tuple2(
			$author$project$Types$Queue$Staged(
				A2($author$project$Types$Queue$SyncStation, operationId, station)),
			$author$project$Lib$send(
				$author$project$Msg$QueueMsg_($author$project$Msg$AttemptSync)));
	});
var $author$project$Actions$Queue$attemptSyncStaging = F2(
	function (model, queueReference) {
		switch (queueReference.$) {
			case 2:
				return _Utils_Tuple2($author$project$Types$Queue$NotStarted, $elm$core$Platform$Cmd$none);
			case 0:
				var operationId = queueReference.a;
				var _v1 = A2($elm$core$Dict$get, operationId, model.aA);
				if (!_v1.$) {
					var station = _v1.a;
					return A2($author$project$Actions$Operation$stageStation, operationId, station);
				} else {
					return _Utils_Tuple2(
						$author$project$Types$Queue$NotStarted,
						A2(
							$elm$core$Task$attempt,
							$author$project$Msg$SentryResponse,
							A2(
								$author$project$Lib$Sentry$sentry(model.ae).bA,
								'attemptSyncStaging::QueueStation failed because the station was not found (OperationID: ' + (operationId + ')'),
								$elm$core$Dict$fromList(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'userEmail',
											A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, model.aa))
										])))));
				}
			default:
				var photoReference = queueReference.a;
				return $author$project$Actions$Operation$stagePhoto(photoReference);
		}
	});
var $author$project$Types$Steps$Photo$decodeFull = A4(
	$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$optional,
	'imageTaken',
	$elm$json$Json$Decode$bool,
	false,
	A3(
		$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
		'image',
		$elm$json$Json$Decode$nullable($elm$json$Json$Decode$string),
		A3(
			$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
			'createdAt',
			A2(
				$elm$json$Json$Decode$andThen,
				function (t) {
					return $elm$json$Json$Decode$succeed(
						$elm$time$Time$millisToPosix(t));
				},
				$elm$json$Json$Decode$int),
			A3(
				$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
				'syncState',
				$author$project$Lib$Sync$decode,
				A3(
					$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
					'iteration',
					$elm$json$Json$Decode$int,
					A3(
						$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
						'stepId',
						$elm$json$Json$Decode$string,
						A3(
							$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
							'stationId',
							$elm$json$Json$Decode$string,
							A3(
								$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
								'operationId',
								$elm$json$Json$Decode$string,
								A3(
									$NoRedInk$elm_json_decode_pipeline$Json$Decode$Pipeline$required,
									'fileType',
									$elm$json$Json$Decode$string,
									$elm$json$Json$Decode$succeed($author$project$Types$Steps$Photo$Model))))))))));
var $author$project$Actions$Ports$handleDbMsg = F2(
	function (msg, model) {
		switch (msg.$) {
			case 6:
				var err = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$attempt,
						$author$project$Msg$SentryResponse,
						A2(
							$author$project$Lib$Sentry$sentry(model.ae).bA,
							'Actions.Ports.handleDbMsg - DB_ERROR: ' + err,
							$elm$core$Dict$fromList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'userEmail',
										A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, model.aa))
									])))));
			case 3:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 4:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 0:
				var value = msg.a;
				var _v1 = A2(
					$elm$json$Json$Decode$decodeValue,
					A5($author$project$Model$decode, model.ae, model.a2, model.bj.b8, model.dd, model.ck),
					value);
				if (!_v1.$) {
					var m = _v1.a;
					return _Utils_Tuple2(
						m,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2($elm$core$Task$perform, $author$project$Msg$AdjustTimeZone, $elm$time$Time$here),
									$author$project$Lib$send(
									$author$project$Msg$QueueMsg_($author$project$Msg$StartSyncCycle))
								])));
				} else {
					var err = _v1.a;
					var meta = $elm$core$Dict$fromList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'error',
								$elm$json$Json$Encode$string(
									$elm$json$Json$Decode$errorToString(err))),
								_Utils_Tuple2(
								'module',
								$elm$json$Json$Encode$string('Actions.Ports')),
								_Utils_Tuple2(
								'function',
								$elm$json$Json$Encode$string('handleDbMsg')),
								_Utils_Tuple2(
								'handler',
								$elm$json$Json$Encode$string('DbModelLoaded')),
								_Utils_Tuple2(
								'userEmail',
								A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, model.aa))
							]));
					return _Utils_Tuple2(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									$elm$core$Task$attempt,
									$author$project$Msg$SentryResponse,
									A2(
										$author$project$Lib$Sentry$sentry(model.ae).bA,
										'Actions.Ports.handleDbMsg - Could not decode the model loaded from the database: ',
										meta)),
									$author$project$Lib$send(
									$author$project$Msg$PortMsg_(
										$author$project$Msg$JsMsg_(
											A2($author$project$Msg$JsError, meta, 'Actions.Ports - Msg.DbModelLoaded failed to decode'))))
								])));
				}
			case 1:
				var value = msg.a;
				var _v2 = A2($elm$json$Json$Decode$decodeValue, $author$project$Types$Steps$Photo$decodeFull, value);
				if (!_v2.$) {
					var photo = _v2.a;
					var _v3 = A2(
						$author$project$Actions$Queue$attemptSyncStaging,
						model,
						$author$project$Types$Queue$QueuePhoto(photo));
					var currentSync = _v3.a;
					var cmd = _v3.b;
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{c8: currentSync}),
						cmd);
				} else {
					var err = _v2.a;
					var meta = $elm$core$Dict$fromList(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'error',
								$elm$json$Json$Encode$string(
									$elm$json$Json$Decode$errorToString(err))),
								_Utils_Tuple2(
								'module',
								$elm$json$Json$Encode$string('Actions.Ports')),
								_Utils_Tuple2(
								'function',
								$elm$json$Json$Encode$string('handleDbMsg')),
								_Utils_Tuple2(
								'handler',
								$elm$json$Json$Encode$string('DbLoadedPicture')),
								_Utils_Tuple2(
								'userEmail',
								A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, model.aa))
							]));
					return _Utils_Tuple2(
						model,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									A2(
									$elm$core$Task$attempt,
									$author$project$Msg$SentryResponse,
									A2(
										$author$project$Lib$Sentry$sentry(model.ae).bA,
										'Could not decode a photo loaded from the database.',
										meta)),
									$author$project$Lib$send(
									$author$project$Msg$PortMsg_(
										$author$project$Msg$JsMsg_(
											A2($author$project$Msg$JsError, meta, 'Actions.Ports - Msg.DbLoadedPicture failed to decode'))))
								])));
				}
			case 2:
				var pictureId = msg.a;
				var _v4 = A2($elm$json$Json$Decode$decodeValue, $elm$json$Json$Decode$string, pictureId);
				if (!_v4.$) {
					var id = _v4.a;
					var _v5 = A2($elm$core$String$split, '#', id);
					if ((((_v5.b && _v5.b.b) && _v5.b.b.b) && _v5.b.b.b.b) && (!_v5.b.b.b.b.b)) {
						var operationId = _v5.a;
						var _v6 = _v5.b;
						var stationId = _v6.a;
						var _v7 = _v6.b;
						var stepId = _v7.a;
						var _v8 = _v7.b;
						var iteration = _v8.a;
						return _Utils_Tuple2(
							_Utils_update(
								model,
								{c8: $author$project$Types$Queue$NotStarted}),
							$author$project$Lib$send(
								A3(
									$author$project$Msg$StationMsg_,
									operationId,
									stationId,
									A3(
										$author$project$Msg$StationUpdateStepState,
										stepId,
										A2(
											$elm$core$Maybe$withDefault,
											0,
											$elm$core$String$toInt(iteration)),
										$author$project$Msg$StepPhotoMsg(
											$author$project$Msg$PhotoNotOnThisDevice(model.dd))))));
					} else {
						var meta = $elm$core$Dict$fromList(
							_List_fromArray(
								[
									_Utils_Tuple2(
									'module',
									$elm$json$Json$Encode$string('Actions.Ports')),
									_Utils_Tuple2(
									'function',
									$elm$json$Json$Encode$string('handleDbMsg')),
									_Utils_Tuple2(
									'handler',
									$elm$json$Json$Encode$string('DbPictureNotFound')),
									_Utils_Tuple2(
									'userEmail',
									A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, model.aa))
								]));
						return _Utils_Tuple2(
							model,
							A2(
								$elm$core$Task$attempt,
								$author$project$Msg$SentryResponse,
								A2(
									$author$project$Lib$Sentry$sentry(model.ae).bE,
									'Picture ID had an unknown format ' + id,
									meta)));
					}
				} else {
					var err = _v4.a;
					var meta = $elm$core$Dict$fromList(
						_List_fromArray(
							[
								_Utils_Tuple2('pictureId', pictureId),
								_Utils_Tuple2(
								'error',
								$elm$json$Json$Encode$string(
									$elm$json$Json$Decode$errorToString(err))),
								_Utils_Tuple2(
								'module',
								$elm$json$Json$Encode$string('Actions.Ports')),
								_Utils_Tuple2(
								'function',
								$elm$json$Json$Encode$string('handleDbMsg')),
								_Utils_Tuple2(
								'handler',
								$elm$json$Json$Encode$string('DbPictureNotFound')),
								_Utils_Tuple2(
								'userEmail',
								A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, model.aa))
							]));
					return _Utils_Tuple2(
						model,
						A2(
							$elm$core$Task$attempt,
							$author$project$Msg$SentryResponse,
							A2(
								$author$project$Lib$Sentry$sentry(model.ae).bE,
								'Could not load picture because the ID was not a string.',
								meta)));
				}
			default:
				var unknownMsg = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$attempt,
						$author$project$Msg$SentryResponse,
						A2(
							$author$project$Lib$Sentry$sentry(model.ae).bE,
							'Actions.Ports.handleDbMsg - Received the unknown DB message: ' + unknownMsg,
							$elm$core$Dict$empty)));
		}
	});
var $author$project$Msg$CloseStation = function (a) {
	return {$: 16, a: a};
};
var $author$project$Msg$FocusSearch = function (a) {
	return {$: 17, a: a};
};
var $author$project$Msg$SetStationDoneStateForAll = {$: 14};
var $author$project$Msg$ApiLoginResult = function (a) {
	return {$: 2, a: a};
};
var $elm$http$Http$riskyRequest = function (r) {
	return $elm$http$Http$command(
		$elm$http$Http$Request(
			{e1: true, e6: r.e6, fq: r.fq, fy: r.fy, f2: r.f2, g3: r.g3, g6: r.g6, hc: r.hc}));
};
var $elm$http$Http$stringBody = _Http_pair;
var $author$project$Actions$Authentication$login = F3(
	function (baseUrl, email, password) {
		var requestTarget = '/r/api/v1/login.json';
		return $elm$http$Http$riskyRequest(
			{
				e6: A2($elm$http$Http$stringBody, 'application/x-www-form-urlencoded', 'email=' + (email + ('&password=' + password))),
				fq: $elm$http$Http$expectWhatever(
					A2($elm$core$Basics$composeL, $author$project$Msg$ApiMsg_, $author$project$Msg$ApiLoginResult)),
				fy: _List_Nil,
				f2: 'POST',
				g3: $elm$core$Maybe$Nothing,
				g6: $elm$core$Maybe$Nothing,
				hc: _Utils_ap(baseUrl, requestTarget)
			});
	});
var $author$project$Ports$navigateToLink = _Platform_outgoingPort('navigateToLink', $elm$json$Json$Encode$string);
var $krisajenkins$remotedata$RemoteData$withDefault = F2(
	function (_default, data) {
		if (data.$ === 3) {
			var x = data.a;
			return x;
		} else {
			return _default;
		}
	});
var $author$project$Actions$Ports$handleJsMsg = F2(
	function (msg, model) {
		switch (msg.$) {
			case 7:
				var extra = msg.a;
				var err = msg.b;
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Task$attempt,
								$author$project$Msg$SentryResponse,
								A2(
									$author$project$Lib$Sentry$sentry(model.ae).bA,
									err,
									A3(
										$elm$core$Dict$insert,
										'userEmail',
										A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, model.aa),
										extra))),
								$author$project$Ports$out_(
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'msg',
											$elm$json$Json$Encode$string('DecodeError')),
											_Utils_Tuple2(
											'data',
											$elm$json$Json$Encode$object(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'error',
														$elm$json$Json$Encode$string(err)),
														_Utils_Tuple2(
														'extra',
														A3($elm$json$Json$Encode$dict, $elm$core$Basics$identity, $elm$core$Basics$identity, extra))
													])))
										])))
							])));
			case 6:
				var unknownMsg = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$attempt,
						$author$project$Msg$SentryResponse,
						A2(
							$author$project$Lib$Sentry$sentry(model.ae).bE,
							'Received the unknown message: ' + unknownMsg,
							$elm$core$Dict$fromList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'userEmail',
										A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, model.aa))
									])))));
			case 0:
				var username = msg.a;
				var password = msg.b;
				return _Utils_Tuple2(
					model,
					A3($author$project$Actions$Authentication$login, model.a2, username, password));
			case 1:
				var target = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Ports$navigateToLink(target));
			case 2:
				var operationId = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Lib$send(
						$author$project$Msg$SetStationDoneState(operationId)));
			case 4:
				var flags = msg.a;
				var wh = A2($krisajenkins$remotedata$RemoteData$withDefault, _List_Nil, model.eV);
				var uiState = model.bj;
				var _v1 = function () {
					var _v2 = _Utils_Tuple2(flags.dU, flags.f_);
					if (!_v2.a.$) {
						if (!_v2.b.$) {
							var operation = _v2.a.a;
							var materials = _v2.b.a;
							return _Utils_Tuple2(
								A3(
									$elm$core$Dict$insert,
									$elm$core$String$fromInt(operation.bD),
									operation,
									model.ba),
								A2($author$project$Actions$Warehouse$mergeMaterials, materials, wh));
						} else {
							var operation = _v2.a.a;
							var _v3 = _v2.b;
							return _Utils_Tuple2(
								A3(
									$elm$core$Dict$insert,
									$elm$core$String$fromInt(operation.bD),
									operation,
									model.ba),
								wh);
						}
					} else {
						if (!_v2.b.$) {
							var _v4 = _v2.a;
							return _Utils_Tuple2(model.ba, wh);
						} else {
							var _v5 = _v2.a;
							var _v6 = _v2.b;
							return _Utils_Tuple2(model.ba, wh);
						}
					}
				}();
				var operations = _v1.a;
				var warehouse_ = _v1.b;
				var model_ = _Utils_update(
					model,
					{
						aa: flags.aa,
						bG: flags.bG,
						ba: operations,
						bj: _Utils_update(
							uiState,
							{
								c7: $author$project$Ui$Router$pathToRoute(flags.hc),
								b8: flags.hc
							}),
						eV: $krisajenkins$remotedata$RemoteData$Success(warehouse_)
					});
				return _Utils_Tuple2(
					model_,
					$elm$core$Platform$Cmd$batch(
						_Utils_ap(
							_List_fromArray(
								[
									$author$project$Lib$send(
									$author$project$Msg$FocusSearch('search-box')),
									$author$project$Lib$send($author$project$Msg$SetStationDoneStateForAll)
								]),
							function () {
								var _v7 = _Utils_Tuple3(model.bG, flags.bG, flags.dU);
								if (!_v7.c.$) {
									if ((_v7.a.$ === 1) && (!_v7.b.$)) {
										var _v8 = _v7.a;
										var jwt = _v7.b.a;
										var operation = _v7.c.a;
										return _List_fromArray(
											[
												A3($author$project$Actions$Warehouse$getWarehouseComplete, jwt, flags.a2, operation),
												A2(
												$author$project$Actions$Station$load,
												model.a2,
												$elm$core$String$fromInt(operation.bD))
											]);
									} else {
										var operation = _v7.c.a;
										return _List_fromArray(
											[
												A2(
												$author$project$Actions$Station$load,
												model.a2,
												$elm$core$String$fromInt(operation.bD))
											]);
									}
								} else {
									return _List_Nil;
								}
							}())));
			case 3:
				var url = msg.a;
				var uiState = model.bj;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bj: _Utils_update(
								uiState,
								{
									c7: $author$project$Ui$Router$pathToRoute(url),
									b8: url
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				var operationId = msg.a;
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Lib$send(
								$author$project$Msg$CloseStation(operationId))
							])));
			default:
				var locale = msg.a;
				if (locale === 'en') {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ck: 1}),
						$elm$core$Platform$Cmd$none);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{ck: 0}),
						$elm$core$Platform$Cmd$none);
				}
		}
	});
var $author$project$Lib$PortHelpers$deletePhoto = function (photoReference) {
	return $author$project$Ports$out_(
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'msg',
					$elm$json$Json$Encode$string('DatabaseRequestMsg')),
					_Utils_Tuple2(
					'data',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'msg',
								$elm$json$Json$Encode$string('DeletePhoto')),
								_Utils_Tuple2(
								'photoId',
								$elm$json$Json$Encode$string(
									photoReference.gw + ('#' + (photoReference.gU + ('#' + (photoReference.gX + ('#' + $elm$core$String$fromInt(photoReference.fV))))))))
							])))
				])));
};
var $author$project$Actions$Queue$BadStatus = function (a) {
	return {$: 0, a: a};
};
var $author$project$Actions$Queue$BadUrl = function (a) {
	return {$: 1, a: a};
};
var $author$project$Lib$PortHelpers$logout = $author$project$Ports$out_(
	$elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'msg',
				$elm$json$Json$Encode$string('LogoutMsg')),
				_Utils_Tuple2('data', $elm$json$Json$Encode$null)
			])));
var $author$project$Actions$Queue$markNotSyncable = F2(
	function (model, reason) {
		var meta = function () {
			if (!reason.$) {
				var statusCode = reason.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'Bad statusCode',
						$elm$json$Json$Encode$int(statusCode))
					]);
			} else {
				var url = reason.a;
				return _List_fromArray(
					[
						_Utils_Tuple2(
						'Bad url',
						$elm$json$Json$Encode$string(url))
					]);
			}
		}();
		var _v0 = $elm$core$List$head(model.aT);
		if (_v0.$ === 1) {
			return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
		} else {
			var queueReference = _v0.a;
			switch (queueReference.$) {
				case 2:
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								aT: A2(
									$elm$core$Maybe$withDefault,
									_List_Nil,
									$elm$core$List$tail(model.aT))
							}),
						$elm$core$Platform$Cmd$none);
				case 0:
					var operationId = queueReference.a;
					var notification = A2(
						$elm$core$Task$attempt,
						$author$project$Msg$SentryResponse,
						A2(
							$author$project$Lib$Sentry$sentry(model.ae).bA,
							'Queue::Actions::markNotSyncable::QueueStation station is not syncable!',
							$elm$core$Dict$fromList(
								_Utils_ap(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'operationId',
											$elm$json$Json$Encode$string(operationId)),
											_Utils_Tuple2(
											'userEmail',
											A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, model.aa))
										]),
									meta))));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								c8: $author$project$Types$Queue$NotStarted,
								aR: A2($elm$core$List$cons, queueReference, model.aR)
							}),
						notification);
				default:
					var photoReference = queueReference.a;
					var notification = A2(
						$elm$core$Task$attempt,
						$author$project$Msg$SentryResponse,
						A2(
							$author$project$Lib$Sentry$sentry(model.ae).bA,
							'Queue::Actions::markNotSyncable::QueuePhoto station is not syncable!',
							$elm$core$Dict$fromList(
								_Utils_ap(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'operationId',
											$elm$json$Json$Encode$string(photoReference.gw)),
											_Utils_Tuple2(
											'stationId',
											$elm$json$Json$Encode$string(photoReference.gU)),
											_Utils_Tuple2(
											'stepId',
											$elm$json$Json$Encode$string(photoReference.gX)),
											_Utils_Tuple2(
											'iteration',
											$elm$json$Json$Encode$int(photoReference.fV)),
											_Utils_Tuple2(
											'userEmail',
											A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, model.aa))
										]),
									meta))));
					return _Utils_Tuple2(
						_Utils_update(
							model,
							{
								c8: $author$project$Types$Queue$NotStarted,
								aR: A2($elm$core$List$cons, queueReference, model.aR)
							}),
						notification);
			}
		}
	});
var $author$project$Types$Queue$StagedRetry = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$core$Basics$always = F2(
	function (a, _v0) {
		return a;
	});
var $author$project$Actions$Queue$retrySync = function (model) {
	var _v0 = model.c8;
	if (_v0.$ === 3) {
		var retryNum = _v0.a;
		var data = _v0.b;
		var sleepDuration = (retryNum < 60) ? (1000 * retryNum) : (60 * 1000);
		return _Utils_Tuple2(
			_Utils_update(
				model,
				{
					c8: A2($author$project$Types$Queue$StagedRetry, retryNum + 1, data)
				}),
			A2(
				$elm$core$Task$perform,
				$elm$core$Basics$always(
					$author$project$Msg$QueueMsg_($author$project$Msg$AttemptSync)),
				$elm$core$Process$sleep(sleepDuration)));
	} else {
		return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
	}
};
var $author$project$Actions$Queue$handleSyncError = F2(
	function (model, err) {
		switch (err.$) {
			case 0:
				var url = err.a;
				return A2(
					$author$project$Actions$Queue$markNotSyncable,
					model,
					$author$project$Actions$Queue$BadUrl(url));
			case 1:
				return $author$project$Actions$Queue$retrySync(model);
			case 2:
				return $author$project$Actions$Queue$retrySync(model);
			case 3:
				var status = err.a;
				return (status >= 500) ? $author$project$Actions$Queue$retrySync(model) : ((status === 401) ? _Utils_Tuple2(model, $author$project$Lib$PortHelpers$logout) : A2(
					$author$project$Actions$Queue$markNotSyncable,
					model,
					$author$project$Actions$Queue$BadStatus(status)));
			default:
				var badBody = err.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$attempt,
						$author$project$Msg$SentryResponse,
						A2(
							$author$project$Lib$Sentry$sentry(model.ae).bE,
							'Received a BadBody after sync: ' + badBody,
							$elm$core$Dict$fromList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'userEmail',
										A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, model.aa))
									])))));
		}
	});
var $author$project$Actions$Station$markPhotoSynced = F2(
	function (stations, photo) {
		var stationWrapperList = $elm$core$Dict$toList(stations);
		var findPhoto = function (_v1) {
			var id = _v1.a;
			var p = _v1.b;
			return (_Utils_eq(p.gX, photo.gX) && _Utils_eq(p.fV, photo.fV)) ? _Utils_Tuple2(
				id,
				_Utils_update(
					p,
					{gZ: $author$project$Lib$Sync$Server})) : _Utils_Tuple2(id, p);
		};
		var findStation = function (station) {
			var stepDb = station.A;
			return _Utils_eq(station.bD, photo.gU) ? _Utils_update(
				station,
				{
					A: _Utils_update(
						stepDb,
						{
							P: $elm$core$Dict$fromList(
								A2(
									$elm$core$List$map,
									findPhoto,
									$elm$core$Dict$toList(stepDb.P)))
						})
				}) : station;
		};
		var hasOperationSyncablePhotos = function (_v0) {
			var operationId = _v0.a;
			var wrapper = _v0.b;
			return _Utils_eq(photo.gw, operationId) ? _Utils_Tuple2(
				operationId,
				_Utils_update(
					wrapper,
					{
						aA: A2($elm$core$List$map, findStation, wrapper.aA)
					})) : _Utils_Tuple2(operationId, wrapper);
		};
		return $elm$core$Dict$fromList(
			A2($elm$core$List$map, hasOperationSyncablePhotos, stationWrapperList));
	});
var $author$project$Types$Queue$LoadFromDb = function (a) {
	return {$: 4, a: a};
};
var $author$project$Types$Queue$Processing = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $author$project$Lib$PortHelpers$getPicture = function (photoReference) {
	return $author$project$Ports$out_(
		$elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'msg',
					$elm$json$Json$Encode$string('DatabaseRequestMsg')),
					_Utils_Tuple2(
					'data',
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'msg',
								$elm$json$Json$Encode$string('GetPicture')),
								_Utils_Tuple2(
								'photoId',
								$elm$json$Json$Encode$string(
									photoReference.gw + ('#' + (photoReference.gU + ('#' + (photoReference.gX + ('#' + $elm$core$String$fromInt(photoReference.fV))))))))
							])))
				])));
};
var $author$project$Msg$ReceiveSyncResponse = function (a) {
	return {$: 2, a: a};
};
var $author$project$Types$Queue$ResponseStation = function (a) {
	return {$: 0, a: a};
};
var $author$project$Actions$Station$save = F3(
	function (baseUrl, operationId, station) {
		var requestTarget = '/r/api/v1/operation_metadata.json';
		return $elm$http$Http$request(
			{
				e6: $elm$http$Http$jsonBody(
					$elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(
								'operation_id',
								$elm$json$Json$Encode$string(operationId)),
								_Utils_Tuple2(
								'metadata',
								A2($elm$json$Json$Encode$list, $author$project$Types$Station$encodeStation, station.aA)),
								_Utils_Tuple2(
								'done',
								$elm$json$Json$Encode$bool(station.gv))
							]))),
				fq: $elm$http$Http$expectWhatever(
					function (res) {
						if (!res.$) {
							return $author$project$Msg$QueueMsg_(
								$author$project$Msg$ReceiveSyncResponse(
									$elm$core$Result$Ok(
										$author$project$Types$Queue$ResponseStation(operationId))));
						} else {
							var err = res.a;
							return $author$project$Msg$QueueMsg_(
								$author$project$Msg$ReceiveSyncResponse(
									$elm$core$Result$Err(err)));
						}
					}),
				fy: _List_Nil,
				f2: 'POST',
				g3: $elm$core$Maybe$Nothing,
				g6: $elm$core$Maybe$Nothing,
				hc: _Utils_ap(baseUrl, requestTarget)
			});
	});
var $author$project$Types$Queue$ResponsePhoto = function (a) {
	return {$: 1, a: a};
};
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth = function (month) {
	switch (month) {
		case 0:
			return 1;
		case 1:
			return 2;
		case 2:
			return 3;
		case 3:
			return 4;
		case 4:
			return 5;
		case 5:
			return 6;
		case 6:
			return 7;
		case 7:
			return 8;
		case 8:
			return 9;
		case 9:
			return 10;
		case 10:
			return 11;
		default:
			return 12;
	}
};
var $elm$time$Time$flooredDiv = F2(
	function (numerator, denominator) {
		return $elm$core$Basics$floor(numerator / denominator);
	});
var $elm$time$Time$toAdjustedMinutesHelp = F3(
	function (defaultOffset, posixMinutes, eras) {
		toAdjustedMinutesHelp:
		while (true) {
			if (!eras.b) {
				return posixMinutes + defaultOffset;
			} else {
				var era = eras.a;
				var olderEras = eras.b;
				if (_Utils_cmp(era.l, posixMinutes) < 0) {
					return posixMinutes + era.d;
				} else {
					var $temp$defaultOffset = defaultOffset,
						$temp$posixMinutes = posixMinutes,
						$temp$eras = olderEras;
					defaultOffset = $temp$defaultOffset;
					posixMinutes = $temp$posixMinutes;
					eras = $temp$eras;
					continue toAdjustedMinutesHelp;
				}
			}
		}
	});
var $elm$time$Time$toAdjustedMinutes = F2(
	function (_v0, time) {
		var defaultOffset = _v0.a;
		var eras = _v0.b;
		return A3(
			$elm$time$Time$toAdjustedMinutesHelp,
			defaultOffset,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				60000),
			eras);
	});
var $elm$time$Time$toCivil = function (minutes) {
	var rawDay = A2($elm$time$Time$flooredDiv, minutes, 60 * 24) + 719468;
	var era = (((rawDay >= 0) ? rawDay : (rawDay - 146096)) / 146097) | 0;
	var dayOfEra = rawDay - (era * 146097);
	var yearOfEra = ((((dayOfEra - ((dayOfEra / 1460) | 0)) + ((dayOfEra / 36524) | 0)) - ((dayOfEra / 146096) | 0)) / 365) | 0;
	var dayOfYear = dayOfEra - (((365 * yearOfEra) + ((yearOfEra / 4) | 0)) - ((yearOfEra / 100) | 0));
	var mp = (((5 * dayOfYear) + 2) / 153) | 0;
	var month = mp + ((mp < 10) ? 3 : (-9));
	var year = yearOfEra + (era * 400);
	return {
		c9: (dayOfYear - ((((153 * mp) + 2) / 5) | 0)) + 1,
		dN: month,
		e_: year + ((month <= 2) ? 1 : 0)
	};
};
var $elm$time$Time$toDay = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).c9;
	});
var $elm$time$Time$toHour = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			24,
			A2(
				$elm$time$Time$flooredDiv,
				A2($elm$time$Time$toAdjustedMinutes, zone, time),
				60));
	});
var $elm$time$Time$toMillis = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			1000,
			$elm$time$Time$posixToMillis(time));
	});
var $elm$time$Time$toMinute = F2(
	function (zone, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2($elm$time$Time$toAdjustedMinutes, zone, time));
	});
var $elm$time$Time$Apr = 3;
var $elm$time$Time$Aug = 7;
var $elm$time$Time$Dec = 11;
var $elm$time$Time$Feb = 1;
var $elm$time$Time$Jan = 0;
var $elm$time$Time$Jul = 6;
var $elm$time$Time$Jun = 5;
var $elm$time$Time$Mar = 2;
var $elm$time$Time$May = 4;
var $elm$time$Time$Nov = 10;
var $elm$time$Time$Oct = 9;
var $elm$time$Time$Sep = 8;
var $elm$time$Time$toMonth = F2(
	function (zone, time) {
		var _v0 = $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).dN;
		switch (_v0) {
			case 1:
				return 0;
			case 2:
				return 1;
			case 3:
				return 2;
			case 4:
				return 3;
			case 5:
				return 4;
			case 6:
				return 5;
			case 7:
				return 6;
			case 8:
				return 7;
			case 9:
				return 8;
			case 10:
				return 9;
			case 11:
				return 10;
			default:
				return 11;
		}
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString = F2(
	function (digits, time) {
		return A3(
			$elm$core$String$padLeft,
			digits,
			'0',
			$elm$core$String$fromInt(time));
	});
var $elm$time$Time$toSecond = F2(
	function (_v0, time) {
		return A2(
			$elm$core$Basics$modBy,
			60,
			A2(
				$elm$time$Time$flooredDiv,
				$elm$time$Time$posixToMillis(time),
				1000));
	});
var $elm$time$Time$toYear = F2(
	function (zone, time) {
		return $elm$time$Time$toCivil(
			A2($elm$time$Time$toAdjustedMinutes, zone, time)).e_;
	});
var $rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime = function (time) {
	return A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		4,
		A2($elm$time$Time$toYear, $elm$time$Time$utc, time)) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		$rtfeldman$elm_iso8601_date_strings$Iso8601$fromMonth(
			A2($elm$time$Time$toMonth, $elm$time$Time$utc, time))) + ('-' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toDay, $elm$time$Time$utc, time)) + ('T' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toHour, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toMinute, $elm$time$Time$utc, time)) + (':' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		2,
		A2($elm$time$Time$toSecond, $elm$time$Time$utc, time)) + ('.' + (A2(
		$rtfeldman$elm_iso8601_date_strings$Iso8601$toPaddedString,
		3,
		A2($elm$time$Time$toMillis, $elm$time$Time$utc, time)) + 'Z'))))))))))));
};
var $author$project$Types$Steps$Photo$encodeApi = F2(
	function (image, model) {
		return $elm$json$Json$Encode$object(
			_List_fromArray(
				[
					_Utils_Tuple2(
					'operation_id',
					$elm$json$Json$Encode$string(model.gw)),
					_Utils_Tuple2(
					'station_id',
					$elm$json$Json$Encode$string(model.gU)),
					_Utils_Tuple2(
					'station_job_id',
					$elm$json$Json$Encode$string(
						_Utils_ap(
							model.gX,
							$elm$core$String$fromInt(model.fV)))),
					_Utils_Tuple2(
					'created_at',
					$elm$json$Json$Encode$string(
						$rtfeldman$elm_iso8601_date_strings$Iso8601$fromTime(model.a4))),
					_Utils_Tuple2(
					'image',
					$elm$json$Json$Encode$string(image))
				]));
	});
var $author$project$Actions$Station$uploadPhoto = F3(
	function (baseUrl, photoReference, photo) {
		var requestTarget = '/r/api/v1/operation_metadata/upload_image.json';
		return $elm$http$Http$request(
			{
				e6: $elm$http$Http$jsonBody(
					A2($author$project$Types$Steps$Photo$encodeApi, photo, photoReference)),
				fq: $elm$http$Http$expectWhatever(
					function (res) {
						if (!res.$) {
							return $author$project$Msg$QueueMsg_(
								$author$project$Msg$ReceiveSyncResponse(
									$elm$core$Result$Ok(
										$author$project$Types$Queue$ResponsePhoto(
											_Utils_update(
												photoReference,
												{dt: $elm$core$Maybe$Nothing})))));
						} else {
							var err = res.a;
							return $author$project$Msg$QueueMsg_(
								$author$project$Msg$ReceiveSyncResponse(
									$elm$core$Result$Err(err)));
						}
					}),
				fy: _List_Nil,
				f2: 'POST',
				g3: $elm$core$Maybe$Nothing,
				g6: $elm$core$Maybe$Nothing,
				hc: _Utils_ap(baseUrl, requestTarget)
			});
	});
var $author$project$Actions$Queue$sync = F3(
	function (model, retryNum, syncType) {
		if (!syncType.$) {
			var operationId = syncType.a;
			var station = syncType.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						c8: A2(
							$author$project$Types$Queue$Processing,
							retryNum,
							A2($author$project$Types$Queue$SyncStation, operationId, station))
					}),
				A3($author$project$Actions$Station$save, model.a2, operationId, station));
		} else {
			var photoReference = syncType.a;
			var _v1 = photoReference.dt;
			if (_v1.$ === 1) {
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							c8: $author$project$Types$Queue$LoadFromDb(model.g2)
						}),
					$author$project$Lib$PortHelpers$getPicture(photoReference));
			} else {
				var photo = _v1.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							c8: A2(
								$author$project$Types$Queue$Processing,
								retryNum,
								$author$project$Types$Queue$SyncPhoto(photoReference))
						}),
					A3($author$project$Actions$Station$uploadPhoto, model.a2, photoReference, photo));
			}
		}
	});
var $author$project$Actions$Queue$handleQueueMsg = F2(
	function (queueMsg, model) {
		switch (queueMsg.$) {
			case 0:
				var _v1 = function () {
					var _v2 = $elm$core$List$head(model.aT);
					if (!_v2.$) {
						var syncType = _v2.a;
						return A2($author$project$Actions$Queue$attemptSyncStaging, model, syncType);
					} else {
						return _Utils_Tuple2($author$project$Types$Queue$NotStarted, $elm$core$Platform$Cmd$none);
					}
				}();
				var currentSync = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{c8: currentSync}),
					cmd);
			case 1:
				var _v3 = model.c8;
				switch (_v3.$) {
					case 1:
						var syncType = _v3.a;
						return A3($author$project$Actions$Queue$sync, model, 0, syncType);
					case 0:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					case 2:
						var retryNum = _v3.a;
						var syncType = _v3.b;
						return A3($author$project$Actions$Queue$sync, model, retryNum, syncType);
					case 3:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
					default:
						return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			default:
				var res = queueMsg.a;
				var cmdsAfterSuccess = function (model_) {
					return ($elm$core$List$isEmpty(model.aT) && _Utils_eq(model.c8, $author$project$Types$Queue$NotStarted)) ? $author$project$Lib$PortHelpers$nextModel(model_) : $elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Lib$send(
								$author$project$Msg$QueueMsg_($author$project$Msg$StartSyncCycle)),
								$author$project$Lib$PortHelpers$nextModel(model_)
							]));
				};
				if (!res.$) {
					if (!res.a.$) {
						var operationId = res.a.a;
						var model_ = $author$project$Actions$Queue$findNextSyncableResources(
							_Utils_update(
								model,
								{
									c8: $author$project$Types$Queue$NotStarted,
									aA: A3(
										$elm$core$Dict$update,
										operationId,
										$elm$core$Maybe$map(
											function (wrapper) {
												return _Utils_update(
													wrapper,
													{gZ: $author$project$Lib$Sync$Server});
											}),
										model.aA)
								}));
						return _Utils_Tuple2(
							model_,
							cmdsAfterSuccess(model_));
					} else {
						var photoReference = res.a.a;
						var model_ = $author$project$Actions$Queue$findNextSyncableResources(
							_Utils_update(
								model,
								{
									c8: $author$project$Types$Queue$NotStarted,
									aA: A2($author$project$Actions$Station$markPhotoSynced, model.aA, photoReference)
								}));
						return _Utils_Tuple2(
							model_,
							$elm$core$Platform$Cmd$batch(
								_List_fromArray(
									[
										cmdsAfterSuccess(model_),
										$author$project$Lib$PortHelpers$deletePhoto(photoReference)
									])));
					}
				} else {
					var err = res.a;
					return A2($author$project$Actions$Queue$handleSyncError, model, err);
				}
		}
	});
var $author$project$Actions$Station$noCommand = function (m) {
	return _Utils_Tuple2(m, $elm$core$Platform$Cmd$none);
};
var $author$project$Actions$Station$removeFromStepDb = F3(
	function (db, stepId, stepType) {
		switch (stepType.$) {
			case 0:
				return _Utils_update(
					db,
					{
						X: A2($elm$core$Dict$remove, stepId, db.X)
					});
			case 1:
				return _Utils_update(
					db,
					{
						ag: A2($elm$core$Dict$remove, stepId, db.ag)
					});
			case 2:
				return _Utils_update(
					db,
					{
						as: A2($elm$core$Dict$remove, stepId, db.as)
					});
			case 3:
				return _Utils_update(
					db,
					{
						W: A2($elm$core$Dict$remove, stepId, db.W)
					});
			case 4:
				return _Utils_update(
					db,
					{
						V: A2($elm$core$Dict$remove, stepId, db.V)
					});
			case 5:
				return _Utils_update(
					db,
					{
						Q: A2($elm$core$Dict$remove, stepId, db.Q)
					});
			case 6:
				return _Utils_update(
					db,
					{
						P: A2($elm$core$Dict$remove, stepId, db.P)
					});
			case 7:
				return _Utils_update(
					db,
					{
						R: A2($elm$core$Dict$remove, stepId, db.R)
					});
			case 9:
				return _Utils_update(
					db,
					{
						ar: A2($elm$core$Dict$remove, stepId, db.ar)
					});
			case 8:
				return _Utils_update(
					db,
					{
						az: A2($elm$core$Dict$remove, stepId, db.az)
					});
			default:
				return db;
		}
	});
var $author$project$Msg$JsInternalNav = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$Steps$Amount$init = 0;
var $author$project$Types$Steps$ArticleInput$init = _List_Nil;
var $author$project$Types$Steps$ArticleInstallation$init = $elm$core$Maybe$Nothing;
var $author$project$Types$Steps$Photo$init = F5(
	function (operationId, stationId, stepId, iteration, createdAt) {
		return {a4: createdAt, bB: 'images/jpeg', dt: $elm$core$Maybe$Nothing, fE: false, fV: iteration, gw: operationId, gU: stationId, gX: stepId, gZ: $author$project$Lib$Sync$Local};
	});
var $author$project$Types$Steps$Text$init = '';
var $author$project$Types$Steps$Timestamp$init = $elm$core$Maybe$Nothing;
var $elm$url$Url$Builder$Absolute = {$: 0};
var $elm$url$Url$Builder$toQueryPair = function (_v0) {
	var key = _v0.a;
	var value = _v0.b;
	return key + ('=' + value);
};
var $elm$url$Url$Builder$toQuery = function (parameters) {
	if (!parameters.b) {
		return '';
	} else {
		return '?' + A2(
			$elm$core$String$join,
			'&',
			A2($elm$core$List$map, $elm$url$Url$Builder$toQueryPair, parameters));
	}
};
var $elm$url$Url$Builder$absolute = F2(
	function (pathSegments, parameters) {
		return '/' + (A2($elm$core$String$join, '/', pathSegments) + $elm$url$Url$Builder$toQuery(parameters));
	});
var $elm$url$Url$Builder$rootToPrePath = function (root) {
	switch (root.$) {
		case 0:
			return '/';
		case 1:
			return '';
		default:
			var prePath = root.a;
			return prePath + '/';
	}
};
var $elm$url$Url$Builder$custom = F4(
	function (root, pathSegments, parameters, maybeFragment) {
		var fragmentless = _Utils_ap(
			$elm$url$Url$Builder$rootToPrePath(root),
			_Utils_ap(
				A2($elm$core$String$join, '/', pathSegments),
				$elm$url$Url$Builder$toQuery(parameters)));
		if (maybeFragment.$ === 1) {
			return fragmentless;
		} else {
			var fragment = maybeFragment.a;
			return fragmentless + ('#' + fragment);
		}
	});
var $author$project$Ui$Router$routeToPath = function (route) {
	switch (route.$) {
		case 0:
			return A2($elm$url$Url$Builder$absolute, _List_Nil, _List_Nil);
		case 1:
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['404']),
				_List_Nil);
		case 2:
			var id = route.a;
			return A2(
				$elm$url$Url$Builder$absolute,
				_List_fromArray(
					['orders', id]),
				_List_Nil);
		case 3:
			var operationId = route.a;
			return A4(
				$elm$url$Url$Builder$custom,
				$elm$url$Url$Builder$Absolute,
				_List_fromArray(
					['orders', operationId]),
				_List_Nil,
				$elm$core$Maybe$Just(
					A2(
						$elm$core$String$join,
						'/',
						_List_fromArray(
							['stations', 'create']))));
		case 4:
			var operationId = route.a;
			var stationId = route.b;
			var iteration = route.c;
			return A4(
				$elm$url$Url$Builder$custom,
				$elm$url$Url$Builder$Absolute,
				_List_fromArray(
					['orders', operationId]),
				_List_Nil,
				$elm$core$Maybe$Just(
					A2(
						$elm$core$String$join,
						'/',
						_List_fromArray(
							[
								'stations',
								stationId,
								$elm$core$String$fromInt(iteration)
							]))));
		case 5:
			var operationId = route.a;
			var stationId = route.b;
			var iteration = route.c;
			var stepId = route.d;
			return A4(
				$elm$url$Url$Builder$custom,
				$elm$url$Url$Builder$Absolute,
				_List_fromArray(
					['orders', operationId]),
				_List_Nil,
				$elm$core$Maybe$Just(
					A2(
						$elm$core$String$join,
						'/',
						_List_fromArray(
							[
								'stations',
								stationId,
								$elm$core$String$fromInt(iteration),
								'signature',
								stepId
							]))));
		case 8:
			var operationId = route.a;
			var stationId = route.b;
			var iteration = route.c;
			var stepId = route.d;
			return A4(
				$elm$url$Url$Builder$custom,
				$elm$url$Url$Builder$Absolute,
				_List_fromArray(
					['orders', operationId]),
				_List_Nil,
				$elm$core$Maybe$Just(
					A2(
						$elm$core$String$join,
						'/',
						_List_fromArray(
							[
								'stations',
								stationId,
								$elm$core$String$fromInt(iteration),
								'select-article',
								stepId
							]))));
		case 9:
			var operationId = route.a;
			var stationId = route.b;
			var iteration = route.c;
			var stepId = route.d;
			var description = route.e;
			return A4(
				$elm$url$Url$Builder$custom,
				$elm$url$Url$Builder$Absolute,
				_List_fromArray(
					['orders', operationId]),
				_List_Nil,
				$elm$core$Maybe$Just(
					A2(
						$elm$core$String$join,
						'/',
						_List_fromArray(
							[
								'stations',
								stationId,
								$elm$core$String$fromInt(iteration),
								'select-article',
								stepId,
								description
							]))));
		case 6:
			var operationId = route.a;
			var stationId = route.b;
			var iteration = route.c;
			var stepId = route.d;
			return A4(
				$elm$url$Url$Builder$custom,
				$elm$url$Url$Builder$Absolute,
				_List_fromArray(
					['orders', operationId]),
				_List_Nil,
				$elm$core$Maybe$Just(
					A2(
						$elm$core$String$join,
						'/',
						_List_fromArray(
							[
								'stations',
								stationId,
								$elm$core$String$fromInt(iteration),
								'select-bad-part',
								stepId
							]))));
		case 7:
			var operationId = route.a;
			var stationId = route.b;
			var iteration = route.c;
			var stepId = route.d;
			var description = route.e;
			return A4(
				$elm$url$Url$Builder$custom,
				$elm$url$Url$Builder$Absolute,
				_List_fromArray(
					['orders', operationId]),
				_List_Nil,
				$elm$core$Maybe$Just(
					A2(
						$elm$core$String$join,
						'/',
						_List_fromArray(
							[
								'stations',
								stationId,
								$elm$core$String$fromInt(iteration),
								'select-bad-part',
								stepId,
								description
							]))));
		case 10:
			var operationId = route.a;
			var stationId = route.b;
			var iteration = route.c;
			var stepId = route.d;
			var targetStationId = route.e;
			var targetIteration = route.f;
			var targetStepId = route.g;
			var templateId = route.h;
			var description = route.i;
			return A4(
				$elm$url$Url$Builder$custom,
				$elm$url$Url$Builder$Absolute,
				_List_fromArray(
					['orders', operationId]),
				_List_Nil,
				$elm$core$Maybe$Just(
					A2(
						$elm$core$String$join,
						'/',
						_List_fromArray(
							[
								'stations',
								stationId,
								$elm$core$String$fromInt(iteration),
								'select-article-from-temp',
								stepId,
								'target',
								targetStationId,
								$elm$core$String$fromInt(targetIteration),
								targetStepId,
								$elm$core$String$fromInt(templateId),
								description
							]))));
		default:
			return A2($elm$url$Url$Builder$absolute, _List_Nil, _List_Nil);
	}
};
var $author$project$Types$Steps$ArticleInput$initArticle = {Q: 0, I: 0, gO: $elm$core$Maybe$Nothing, ao: $elm$core$Dict$empty};
var $author$project$Actions$Steps$ArticleInput$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var idx = msg.a;
				var templates = msg.b;
				var id = msg.c;
				var _v1 = $elm$core$List$head(
					A2(
						$elm$core$List$filter,
						function (template) {
							return _Utils_eq(
								$elm$core$String$fromInt(template.g1),
								id);
						},
						templates));
				if (!_v1.$) {
					var template = _v1.a;
					return A2(
						$elm$core$List$indexedMap,
						F2(
							function (i, article) {
								return _Utils_eq(idx, i) ? _Utils_update(
									article,
									{
										gO: $elm$core$Maybe$Just(template)
									}) : article;
							}),
						model);
				} else {
					return model;
				}
			case 1:
				var idx = msg.a;
				var amountStr = msg.b;
				var _v2 = $elm$core$String$toInt(amountStr);
				if (!_v2.$) {
					var amount = _v2.a;
					return A2(
						$elm$core$List$indexedMap,
						F2(
							function (i, article) {
								return _Utils_eq(idx, i) ? _Utils_update(
									article,
									{Q: amount}) : article;
							}),
						model);
				} else {
					return (amountStr === '') ? A2(
						$elm$core$List$indexedMap,
						F2(
							function (i, article) {
								return _Utils_eq(idx, i) ? _Utils_update(
									article,
									{Q: 0}) : article;
							}),
						model) : model;
				}
			case 4:
				var idx = msg.a;
				return A2(
					$elm$core$List$indexedMap,
					F2(
						function (i, article) {
							if (_Utils_eq(idx, i)) {
								var newCounter = article.I + 1;
								return _Utils_update(
									article,
									{
										I: newCounter,
										ao: A3(
											$elm$core$Dict$insert,
											$elm$core$String$fromInt(newCounter),
											{c1: $elm$core$Maybe$Nothing, cm: false, ex: ''},
											article.ao)
									});
							} else {
								return article;
							}
						}),
					model);
			case 3:
				var idx = msg.a;
				var idxSerialNum = msg.b;
				var serialNum = msg.c;
				return A2(
					$elm$core$List$indexedMap,
					F2(
						function (i, article) {
							return _Utils_eq(idx, i) ? _Utils_update(
								article,
								{
									ao: A3(
										$elm$core$Dict$insert,
										idxSerialNum,
										{c1: $elm$core$Maybe$Nothing, cm: false, ex: serialNum},
										article.ao)
								}) : article;
						}),
					model);
			case 5:
				var idx = msg.a;
				var idxSerialNum = msg.b;
				var del = msg.c;
				return A2(
					$elm$core$List$indexedMap,
					F2(
						function (i, article) {
							return _Utils_eq(idx, i) ? _Utils_update(
								article,
								{
									ao: A3(
										$elm$core$Dict$update,
										idxSerialNum,
										function (serialNum) {
											if (!serialNum.$) {
												var serialNum_ = serialNum.a;
												return $elm$core$Maybe$Just(
													_Utils_update(
														serialNum_,
														{cm: del}));
											} else {
												return $elm$core$Maybe$Nothing;
											}
										},
										article.ao)
								}) : article;
						}),
					model);
			case 6:
				var idx = msg.a;
				var idxSerialNum = msg.b;
				return A2(
					$elm$core$List$indexedMap,
					F2(
						function (i, article) {
							return _Utils_eq(idx, i) ? _Utils_update(
								article,
								{
									ao: A2($elm$core$Dict$remove, idxSerialNum, article.ao)
								}) : article;
						}),
					model);
			default:
				return $elm$core$List$concat(
					_List_fromArray(
						[
							model,
							_List_fromArray(
							[$author$project$Types$Steps$ArticleInput$initArticle])
						]));
		}
	});
var $author$project$Types$Steps$ArticleInstallation$DeleteNoSn = function (a) {
	return {$: 3, a: a};
};
var $author$project$Types$Steps$ArticleInstallation$DeleteSn = function (a) {
	return {$: 2, a: a};
};
var $author$project$Actions$Steps$ArticleInstallation$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				var ids = msg.a;
				if ((!model.$) && (!model.a.$)) {
					var presentIds = model.a.a;
					return $elm$core$Maybe$Just(
						$toastal$either$Either$Left(
							_Utils_ap(ids, presentIds)));
				} else {
					return $elm$core$Maybe$Just(
						$toastal$either$Either$Left(ids));
				}
			case 1:
				var id = msg.a;
				return $elm$core$Maybe$Just(
					$toastal$either$Either$Right(id));
			case 2:
				_v2$2:
				while (true) {
					if ((!model.$) && (model.a.$ === 1)) {
						switch (model.a.a.$) {
							case 0:
								var id = model.a.a.a;
								return $elm$core$Maybe$Just(
									$toastal$either$Either$Right(
										$author$project$Types$Steps$ArticleInstallation$DeleteNoSn(id)));
							case 1:
								var id = model.a.a.a;
								return $elm$core$Maybe$Just(
									$toastal$either$Either$Right(
										$author$project$Types$Steps$ArticleInstallation$DeleteSn(id)));
							default:
								break _v2$2;
						}
					} else {
						break _v2$2;
					}
				}
				return model;
			case 3:
				_v3$2:
				while (true) {
					if ((!model.$) && (model.a.$ === 1)) {
						switch (model.a.a.$) {
							case 3:
								var id = model.a.a.a;
								return $elm$core$Maybe$Just(
									$toastal$either$Either$Right(
										$author$project$Types$Steps$ArticleInstallation$NoSn(id)));
							case 2:
								var id = model.a.a.a;
								return $elm$core$Maybe$Just(
									$toastal$either$Either$Right(
										$author$project$Types$Steps$ArticleInstallation$Sn(id)));
							default:
								break _v3$2;
						}
					} else {
						break _v3$2;
					}
				}
				return model;
			case 4:
				if (!model.$) {
					if (!model.a.$) {
						return model;
					} else {
						return $elm$core$Maybe$Nothing;
					}
				} else {
					return $elm$core$Maybe$Nothing;
				}
			default:
				var articleId = msg.a;
				if ((!model.$) && (!model.a.$)) {
					var ids = model.a.a;
					var _v6 = A2(
						$elm$core$List$filter,
						function (id) {
							return !_Utils_eq(
								id,
								$elm$core$String$fromInt(articleId));
						},
						ids);
					if (!_v6.b) {
						return $elm$core$Maybe$Nothing;
					} else {
						var list = _v6;
						return $elm$core$Maybe$Just(
							$toastal$either$Either$Left(list));
					}
				} else {
					return model;
				}
		}
	});
var $author$project$Msg$PhotoLoaded = function (a) {
	return {$: 1, a: a};
};
var $author$project$Types$Steps$Photo$encodeFull = function (model) {
	return $elm$json$Json$Encode$object(
		_List_fromArray(
			[
				_Utils_Tuple2(
				'fileType',
				$elm$json$Json$Encode$string(model.bB)),
				_Utils_Tuple2(
				'operationId',
				$elm$json$Json$Encode$string(model.gw)),
				_Utils_Tuple2(
				'stationId',
				$elm$json$Json$Encode$string(model.gU)),
				_Utils_Tuple2(
				'stepId',
				$elm$json$Json$Encode$string(model.gX)),
				_Utils_Tuple2(
				'iteration',
				$elm$json$Json$Encode$int(model.fV)),
				_Utils_Tuple2(
				'createdAt',
				$elm$json$Json$Encode$int(
					$elm$time$Time$posixToMillis(model.a4))),
				_Utils_Tuple2(
				'syncState',
				$author$project$Lib$Sync$encode(model.gZ)),
				_Utils_Tuple2(
				'image',
				function () {
					var _v0 = model.dt;
					if (!_v0.$) {
						var image = _v0.a;
						return $elm$json$Json$Encode$string(image);
					} else {
						return $elm$json$Json$Encode$null;
					}
				}()),
				_Utils_Tuple2(
				'imageTaken',
				$elm$json$Json$Encode$bool(model.fE))
			]));
};
var $elm$file$File$toUrl = _File_toUrl;
var $author$project$Actions$Steps$Photo$update = F2(
	function (msg, model) {
		var pictureType = 'operation_' + model.gw;
		var fileId = model.gw + ('#' + (model.gU + ('#' + (model.gX + ('#' + $elm$core$String$fromInt(model.fV))))));
		switch (msg.$) {
			case 0:
				var file = msg.a;
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								A2(
								$elm$core$Task$perform,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Msg$PhotoLoaded,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Msg$StepPhotoMsg,
										A2(
											$elm$core$Basics$composeR,
											A2($author$project$Msg$StationUpdateStepState, model.gX, model.fV),
											A2($author$project$Msg$StationMsg_, model.gw, model.gU)))),
								$elm$file$File$toUrl(file))
							])));
			case 2:
				var deviceId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							gZ: $author$project$Lib$Sync$LocalNotOnDevice(deviceId)
						}),
					$elm$core$Platform$Cmd$none);
			default:
				var base64 = msg.a;
				var model_ = _Utils_update(
					model,
					{fE: true, gZ: $author$project$Lib$Sync$Local});
				return _Utils_Tuple2(
					model_,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Ports$out_(
								$elm$json$Json$Encode$object(
									_List_fromArray(
										[
											_Utils_Tuple2(
											'msg',
											$elm$json$Json$Encode$string('DatabaseRequestMsg')),
											_Utils_Tuple2(
											'data',
											$elm$json$Json$Encode$object(
												_List_fromArray(
													[
														_Utils_Tuple2(
														'msg',
														$elm$json$Json$Encode$string('PutPicture')),
														_Utils_Tuple2(
														'data',
														$elm$json$Json$Encode$object(
															_List_fromArray(
																[
																	_Utils_Tuple2(
																	'data',
																	$author$project$Types$Steps$Photo$encodeFull(
																		_Utils_update(
																			model_,
																			{
																				dt: $elm$core$Maybe$Just(base64)
																			}))),
																	_Utils_Tuple2(
																	'picture_type',
																	$elm$json$Json$Encode$string(pictureType)),
																	_Utils_Tuple2(
																	'id',
																	$elm$json$Json$Encode$string(fileId))
																])))
													])))
										])))
							])));
		}
	});
var $author$project$Actions$Steps$Signature$update = F2(
	function (msg, _v0) {
		var sig = msg;
		return _Utils_Tuple2(
			$elm$core$Maybe$Just(sig),
			$elm$core$Platform$Cmd$none);
	});
var $author$project$Actions$Steps$Amount$updateAmountState = F2(
	function (msg, model) {
		var str = msg;
		var _v1 = $elm$core$String$toInt(str);
		if (!_v1.$) {
			var a = _v1.a;
			return (a < 0) ? 0 : a;
		} else {
			return (str === '') ? 0 : model;
		}
	});
var $author$project$Actions$Steps$Text$updateTextState = F2(
	function (msg, model) {
		var str = msg;
		return str;
	});
var $author$project$Actions$Steps$Timestamp$updateTimestampState = F2(
	function (msg, _v0) {
		var newtime = msg.a;
		return $elm$core$Maybe$Just(newtime);
	});
var $author$project$Actions$Station$updateYesNoState = F2(
	function (msg, _v0) {
		if (!msg) {
			return true;
		} else {
			return false;
		}
	});
var $author$project$Actions$Station$updateStepDb = F7(
	function (currentTime, operationId, stationId, stepDb, stepId, iteration, msg) {
		var stepIdWithIteration = _Utils_ap(
			stepId,
			$elm$core$String$fromInt(iteration));
		switch (msg.$) {
			case 0:
				var yesNoMsg = msg.a;
				return A2($elm$core$Dict$member, stepIdWithIteration, stepDb.X) ? $author$project$Actions$Station$noCommand(
					_Utils_update(
						stepDb,
						{
							X: A3(
								$elm$core$Dict$update,
								stepIdWithIteration,
								$elm$core$Maybe$map(
									$author$project$Actions$Station$updateYesNoState(yesNoMsg)),
								stepDb.X)
						})) : $author$project$Actions$Station$noCommand(
					_Utils_update(
						stepDb,
						{
							X: A3(
								$elm$core$Dict$insert,
								stepIdWithIteration,
								A2($author$project$Actions$Station$updateYesNoState, yesNoMsg, true),
								stepDb.X)
						}));
			case 2:
				var amountMsg = msg.a;
				return A2($elm$core$Dict$member, stepIdWithIteration, stepDb.Q) ? $author$project$Actions$Station$noCommand(
					_Utils_update(
						stepDb,
						{
							Q: A3(
								$elm$core$Dict$update,
								stepIdWithIteration,
								$elm$core$Maybe$map(
									$author$project$Actions$Steps$Amount$updateAmountState(amountMsg)),
								stepDb.Q)
						})) : $author$project$Actions$Station$noCommand(
					_Utils_update(
						stepDb,
						{
							Q: A3(
								$elm$core$Dict$insert,
								stepIdWithIteration,
								A2($author$project$Actions$Steps$Amount$updateAmountState, amountMsg, $author$project$Types$Steps$Amount$init),
								stepDb.Q)
						}));
			case 3:
				var textMsg = msg.a;
				return A2($elm$core$Dict$member, stepIdWithIteration, stepDb.V) ? $author$project$Actions$Station$noCommand(
					_Utils_update(
						stepDb,
						{
							V: A3(
								$elm$core$Dict$update,
								stepIdWithIteration,
								$elm$core$Maybe$map(
									$author$project$Actions$Steps$Text$updateTextState(textMsg)),
								stepDb.V)
						})) : $author$project$Actions$Station$noCommand(
					_Utils_update(
						stepDb,
						{
							V: A3(
								$elm$core$Dict$insert,
								stepIdWithIteration,
								A2($author$project$Actions$Steps$Text$updateTextState, textMsg, $author$project$Types$Steps$Text$init),
								stepDb.V)
						}));
			case 4:
				var timestampMsg = msg.a;
				return A2($elm$core$Dict$member, stepIdWithIteration, stepDb.W) ? $author$project$Actions$Station$noCommand(
					_Utils_update(
						stepDb,
						{
							W: A3(
								$elm$core$Dict$update,
								stepIdWithIteration,
								$elm$core$Maybe$map(
									$author$project$Actions$Steps$Timestamp$updateTimestampState(timestampMsg)),
								stepDb.W)
						})) : $author$project$Actions$Station$noCommand(
					_Utils_update(
						stepDb,
						{
							W: A3(
								$elm$core$Dict$insert,
								stepIdWithIteration,
								A2($author$project$Actions$Steps$Timestamp$updateTimestampState, timestampMsg, $author$project$Types$Steps$Timestamp$init),
								stepDb.W)
						}));
			case 1:
				var installationType = msg.a;
				var installationMsg = msg.b;
				var cmd = function () {
					if (installationMsg.$ === 1) {
						return $author$project$Lib$send(
							$author$project$Msg$PortMsg_(
								$author$project$Msg$JsMsg_(
									$author$project$Msg$JsInternalNav(
										$author$project$Ui$Router$routeToPath(
											A3($author$project$Ui$Router$StationShow, operationId, stationId, iteration))))));
					} else {
						return $elm$core$Platform$Cmd$none;
					}
				}();
				var articles = function () {
					if (!installationType) {
						return stepDb.as;
					} else {
						return stepDb.ag;
					}
				}();
				var updated = A2($elm$core$Dict$member, stepIdWithIteration, articles) ? A3(
					$elm$core$Dict$update,
					stepIdWithIteration,
					$elm$core$Maybe$map(
						$author$project$Actions$Steps$ArticleInstallation$update(installationMsg)),
					articles) : A3(
					$elm$core$Dict$insert,
					stepIdWithIteration,
					A2($author$project$Actions$Steps$ArticleInstallation$update, installationMsg, $author$project$Types$Steps$ArticleInstallation$init),
					articles);
				if (!installationType) {
					return _Utils_Tuple2(
						_Utils_update(
							stepDb,
							{as: updated}),
						cmd);
				} else {
					return _Utils_Tuple2(
						_Utils_update(
							stepDb,
							{ag: updated}),
						cmd);
				}
			case 5:
				var stepType = msg.a;
				return $author$project$Actions$Station$noCommand(
					A3($author$project$Actions$Station$removeFromStepDb, stepDb, stepIdWithIteration, stepType));
			case 6:
				var photoMsg = msg.a;
				var _v4 = function () {
					var _v5 = A2($elm$core$Dict$get, stepIdWithIteration, stepDb.P);
					if (!_v5.$) {
						var p = _v5.a;
						return A2($author$project$Actions$Steps$Photo$update, photoMsg, p);
					} else {
						return A2(
							$author$project$Actions$Steps$Photo$update,
							photoMsg,
							A5($author$project$Types$Steps$Photo$init, operationId, stationId, stepId, iteration, currentTime));
					}
				}();
				var photo = _v4.a;
				var cmd = _v4.b;
				return _Utils_Tuple2(
					_Utils_update(
						stepDb,
						{
							P: A3($elm$core$Dict$insert, stepIdWithIteration, photo, stepDb.P)
						}),
					cmd);
			case 7:
				var articleHandler = msg.a;
				var articleInputMsg = msg.b;
				if (!articleHandler) {
					return A2($elm$core$Dict$member, stepIdWithIteration, stepDb.R) ? $author$project$Actions$Station$noCommand(
						_Utils_update(
							stepDb,
							{
								R: A3(
									$elm$core$Dict$update,
									stepIdWithIteration,
									$elm$core$Maybe$map(
										$author$project$Actions$Steps$ArticleInput$update(articleInputMsg)),
									stepDb.R)
							})) : $author$project$Actions$Station$noCommand(
						_Utils_update(
							stepDb,
							{
								R: A3(
									$elm$core$Dict$insert,
									stepIdWithIteration,
									A2($author$project$Actions$Steps$ArticleInput$update, articleInputMsg, $author$project$Types$Steps$ArticleInput$init),
									stepDb.R)
							}));
				} else {
					return $author$project$Actions$Station$noCommand(
						_Utils_update(
							stepDb,
							{
								ar: A3(
									$elm$core$Dict$update,
									stepIdWithIteration,
									function (maybeArticle) {
										if (!maybeArticle.$) {
											var article = maybeArticle.a;
											return $elm$core$Maybe$Just(
												A2($author$project$Actions$Steps$ArticleInput$update, articleInputMsg, article));
										} else {
											return $elm$core$Maybe$Just(
												A2($author$project$Actions$Steps$ArticleInput$update, articleInputMsg, $author$project$Types$Steps$ArticleInput$init));
										}
									},
									stepDb.ar)
							}));
				}
			default:
				var sigMsg = msg.a;
				var _v8 = A2($author$project$Actions$Steps$Signature$update, sigMsg, $elm$core$Maybe$Nothing);
				var sig = _v8.a;
				var cmd = _v8.b;
				return _Utils_Tuple2(
					_Utils_update(
						stepDb,
						{
							az: A3($elm$core$Dict$insert, stepIdWithIteration, sig, stepDb.az)
						}),
					cmd);
		}
	});
var $author$project$Actions$Station$update = F5(
	function (currentTime, operationId, stationId, msg, station) {
		switch (msg.$) {
			case 0:
				var stepId = msg.a;
				var iteration = msg.b;
				var stepMsg = msg.c;
				var _v1 = A7($author$project$Actions$Station$updateStepDb, currentTime, operationId, stationId, station.A, stepId, iteration, stepMsg);
				var stepDb = _v1.a;
				var cmd = _v1.b;
				return _Utils_Tuple2(
					_Utils_update(
						station,
						{A: stepDb}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								$author$project$Lib$send(
								$author$project$Msg$SetStationDoneState(operationId))
							])));
			case 1:
				return _Utils_Tuple2(
					_Utils_update(
						station,
						{
							I: station.I + 1,
							ab: A2(
								$elm$core$List$append,
								station.ab,
								_List_fromArray(
									[station.I + 1]))
						}),
					$author$project$Lib$send(
						$author$project$Msg$SetStationDoneState(operationId)));
			case 2:
				var iteration = msg.a;
				var stepDb = A3(
					$elm$core$List$foldl,
					F2(
						function (step, db) {
							var stepId = _Utils_ap(
								step.bD,
								$elm$core$String$fromInt(iteration));
							return A3($author$project$Actions$Station$removeFromStepDb, db, stepId, step.eF);
						}),
					station.A,
					station.eE);
				var newInterations = A2(
					$elm$core$List$filter,
					function (iter) {
						return !_Utils_eq(iteration, iter);
					},
					station.ab);
				return _Utils_Tuple2(
					_Utils_update(
						station,
						{ab: newInterations, A: stepDb}),
					$author$project$Lib$send(
						$author$project$Msg$SetStationDoneState(operationId)));
			case 3:
				var iteration = msg.a;
				return $author$project$Actions$Station$noCommand(
					_Utils_update(
						station,
						{
							eB: $elm$core$Maybe$Just(iteration)
						}));
			default:
				return $author$project$Actions$Station$noCommand(
					_Utils_update(
						station,
						{eB: $elm$core$Maybe$Nothing}));
		}
	});
var $author$project$Actions$Station$handleStationMsg = F4(
	function (operationId, stationId, msg, model) {
		var updateStationById = function (station) {
			return _Utils_eq(station.bD, stationId) ? A5($author$project$Actions$Station$update, model.g2, operationId, stationId, msg, station) : $author$project$Actions$Station$noCommand(station);
		};
		var _v0 = A2($elm$core$Dict$get, operationId, model.aA);
		if (!_v0.$) {
			var wrapper = _v0.a;
			var listing = A2($elm$core$List$map, updateStationById, wrapper.aA);
			var _v1 = A3(
				$elm$core$List$foldl,
				F2(
					function (_v2, _v3) {
						var station = _v2.a;
						var cmd = _v2.b;
						var stationList = _v3.a;
						var commandList = _v3.b;
						return _Utils_Tuple2(
							A2(
								$elm$core$List$append,
								stationList,
								_List_fromArray(
									[station])),
							A2(
								$elm$core$List$append,
								commandList,
								_List_fromArray(
									[cmd])));
					}),
				_Utils_Tuple2(_List_Nil, _List_Nil),
				listing);
			var stations = _v1.a;
			var cmds = _v1.b;
			return _Utils_Tuple2(
				_Utils_update(
					model,
					{
						aA: A3(
							$elm$core$Dict$insert,
							operationId,
							_Utils_update(
								wrapper,
								{aA: stations, gZ: $author$project$Lib$Sync$Local}),
							model.aA)
					}),
				$elm$core$Platform$Cmd$batch(
					_Utils_ap(cmds, _List_Nil)));
		} else {
			return $author$project$Actions$Station$noCommand(model);
		}
	});
var $author$project$Msg$PutArticleBack = function (a) {
	return {$: 5, a: a};
};
var $author$project$Msg$SetArticleIds = function (a) {
	return {$: 0, a: a};
};
var $author$project$Msg$StepArticleInstallationMsg = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Msg$StepReset = function (a) {
	return {$: 5, a: a};
};
var $author$project$Msg$WarehouseCloseNotUsedOverlay = {$: 3};
var $author$project$Msg$WarehouseMsg_ = function (a) {
	return {$: 9, a: a};
};
var $author$project$Actions$Station$getUsedArticleIds = function (stations) {
	var getPermanentIdsOnly = function (e) {
		if (!e.$) {
			var l = e.a;
			return l;
		} else {
			return _List_Nil;
		}
	};
	var extractIdsFromStation = function (station) {
		return $elm$core$List$concat(
			A2(
				$elm$core$List$map,
				getPermanentIdsOnly,
				A2(
					$elm$core$List$filterMap,
					$elm$core$Basics$identity,
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$second,
						$elm$core$Dict$toList(station.A.ag)))));
	};
	return $elm$core$List$concat(
		A2($elm$core$List$map, extractIdsFromStation, stations));
};
var $author$project$Actions$Warehouse$getUnusedArticleIds = F4(
	function (description, stations, takeThisManyArticles, warehouse) {
		var usedArticleIds = $author$project$Actions$Station$getUsedArticleIds(
			$elm$core$List$concat(
				A2(
					$elm$core$List$map,
					function ($) {
						return $.aA;
					},
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$second,
						$elm$core$Dict$toList(stations)))));
		var lessThanSelected = function (alreadySelected) {
			if (!takeThisManyArticles.$) {
				var t = takeThisManyArticles.a;
				return _Utils_cmp(t, alreadySelected) > 0;
			} else {
				return true;
			}
		};
		var getNotSelectedByDescription = F2(
			function (article, _v0) {
				var res = _v0.a;
				var alreadySelected = _v0.b;
				return (_Utils_eq(article.fl, description) && (lessThanSelected(alreadySelected) && (_Utils_eq(article.fZ, $elm$core$Maybe$Nothing) && (_Utils_eq(article.gZ, $author$project$Lib$Sync$Server) && (!A2(
					$elm$core$List$member,
					$elm$core$String$fromInt(article.bD),
					usedArticleIds)))))) ? _Utils_Tuple2(
					A2($elm$core$List$cons, article, res),
					alreadySelected + 1) : _Utils_Tuple2(res, alreadySelected);
			});
		return A2(
			$elm$core$List$map,
			A2(
				$elm$core$Basics$composeR,
				function ($) {
					return $.bD;
				},
				$elm$core$String$fromInt),
			A3(
				$elm$core$List$foldl,
				getNotSelectedByDescription,
				_Utils_Tuple2(_List_Nil, 0),
				warehouse).a);
	});
var $author$project$Update$handleWarehouseMsg = F3(
	function (msg, model, uiState) {
		switch (msg.$) {
			case 0:
				var searchterm = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bj: _Utils_update(
								uiState,
								{e4: searchterm})
						}),
					$elm$core$Platform$Cmd$none);
			case 1:
				var count = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bj: _Utils_update(
								uiState,
								{g0: count})
						}),
					$elm$core$Platform$Cmd$none);
			case 2:
				var value = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bj: _Utils_update(
								uiState,
								{
									gR: $elm$core$Maybe$Just(value)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 3:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bj: _Utils_update(
								uiState,
								{gR: $elm$core$Maybe$Nothing})
						}),
					$elm$core$Platform$Cmd$none);
			case 4:
				var _int = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bj: _Utils_update(
								uiState,
								{
									fk: $elm$core$Maybe$Just(_int)
								})
						}),
					$elm$core$Platform$Cmd$none);
			case 5:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bj: _Utils_update(
								uiState,
								{fk: $elm$core$Maybe$Nothing})
						}),
					$elm$core$Platform$Cmd$none);
			case 6:
				var operationId = msg.a;
				var articleId = msg.b;
				var stationId = msg.c;
				var iteration = msg.d;
				var stepId = msg.e;
				var installationType = msg.f;
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Lib$send(
								A3(
									$author$project$Msg$StationMsg_,
									operationId,
									stationId,
									A3(
										$author$project$Msg$StationUpdateStepState,
										stepId,
										iteration,
										A2(
											$author$project$Msg$StepArticleInstallationMsg,
											installationType,
											$author$project$Msg$SetArticleIds(
												_List_fromArray(
													[
														$elm$core$String$fromInt(articleId)
													])))))),
								$author$project$Lib$send(
								$author$project$Msg$PortMsg_(
									$author$project$Msg$JsMsg_(
										$author$project$Msg$JsInternalNav(
											$author$project$Ui$Router$routeToPath(
												A3($author$project$Ui$Router$StationShow, operationId, stationId, iteration))))))
							])));
			case 7:
				var operationId = msg.a;
				var stationId = msg.b;
				var iteration = msg.c;
				var stepId = msg.d;
				var description = msg.e;
				var takeThisManyArticles = msg.f;
				var installationType = msg.g;
				var _v1 = model.eV;
				if (_v1.$ === 3) {
					var articles = _v1.a;
					var selectedArticleIds = A4(
						$author$project$Actions$Warehouse$getUnusedArticleIds,
						description,
						model.aA,
						$elm$core$Maybe$Just(takeThisManyArticles),
						articles);
					var model_ = _Utils_update(
						model,
						{
							bj: _Utils_update(
								uiState,
								{g0: ''})
						});
					return _Utils_Tuple2(
						model_,
						$elm$core$Platform$Cmd$batch(
							_List_fromArray(
								[
									$author$project$Lib$send(
									$author$project$Msg$WarehouseMsg_($author$project$Msg$WarehouseCloseNotUsedOverlay)),
									$author$project$Lib$send(
									A3(
										$author$project$Msg$StationMsg_,
										operationId,
										stationId,
										A3(
											$author$project$Msg$StationUpdateStepState,
											stepId,
											iteration,
											A2(
												$author$project$Msg$StepArticleInstallationMsg,
												installationType,
												$author$project$Msg$SetArticleIds(selectedArticleIds))))),
									$author$project$Lib$send(
									$author$project$Msg$PortMsg_(
										$author$project$Msg$JsMsg_(
											$author$project$Msg$JsInternalNav(
												$author$project$Ui$Router$routeToPath(
													A3($author$project$Ui$Router$StationShow, operationId, stationId, iteration))))))
								])));
				} else {
					return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
				}
			case 8:
				var operationId = msg.a;
				var articleId = msg.b;
				var stationId = msg.c;
				var iteration = msg.d;
				var stepId = msg.e;
				var installationType = msg.f;
				return _Utils_Tuple2(
					model,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Lib$send(
								A3(
									$author$project$Msg$StationMsg_,
									operationId,
									stationId,
									A3(
										$author$project$Msg$StationUpdateStepState,
										stepId,
										iteration,
										A2(
											$author$project$Msg$StepArticleInstallationMsg,
											installationType,
											$author$project$Msg$PutArticleBack(articleId))))),
								$author$project$Lib$send(
								$author$project$Msg$WarehouseMsg_($author$project$Msg$WarehouseCloseNotUsedOverlay)),
								$author$project$Lib$send(
								$author$project$Msg$PortMsg_(
									$author$project$Msg$JsMsg_(
										$author$project$Msg$JsInternalNav(
											$author$project$Ui$Router$routeToPath(
												A3($author$project$Ui$Router$StationShow, operationId, stationId, iteration))))))
							])));
			case 9:
				var operationId = msg.a;
				var stationId = msg.c;
				var iteration = msg.d;
				var stepId = msg.e;
				var installationType = msg.f;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bj: _Utils_update(
								uiState,
								{g0: ''})
						}),
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								$author$project$Lib$send(
								A3(
									$author$project$Msg$StationMsg_,
									operationId,
									stationId,
									A3(
										$author$project$Msg$StationUpdateStepState,
										stepId,
										iteration,
										$author$project$Msg$StepReset(
											function () {
												if (installationType === 1) {
													return $author$project$Types$Step$ArticleInstallation;
												} else {
													return $author$project$Types$Step$ArticleReturn;
												}
											}()($elm$core$Maybe$Nothing)))))
							])));
			default:
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							bj: _Utils_update(
								uiState,
								{e4: ''})
						}),
					$elm$core$Platform$Cmd$none);
		}
	});
var $author$project$Types$Station$init = {gv: false, aA: _List_Nil, gZ: $author$project$Lib$Sync$Local};
var $author$project$Actions$Station$getLocalStation = F2(
	function (id, stations) {
		return $elm$core$List$head(
			A2(
				$elm$core$List$filter,
				A2(
					$elm$core$Basics$composeR,
					function ($) {
						return $.bD;
					},
					$elm$core$Basics$eq(id)),
				stations));
	});
var $author$project$Actions$Station$useNewWorkflowForStation = F2(
	function (localStation, remoteStation) {
		return _Utils_update(
			remoteStation,
			{I: localStation.I, ab: localStation.ab, A: localStation.A});
	});
var $author$project$Actions$Station$mergeNewWorkflow = F2(
	function (serverWorkflow, localStationWrapper) {
		return _Utils_update(
			localStationWrapper,
			{
				aA: A2(
					$elm$core$List$map,
					function (remoteStation) {
						var _v0 = A2($author$project$Actions$Station$getLocalStation, remoteStation.bD, localStationWrapper.aA);
						if (!_v0.$) {
							var localStation = _v0.a;
							return A2($author$project$Actions$Station$useNewWorkflowForStation, localStation, remoteStation);
						} else {
							return remoteStation;
						}
					},
					serverWorkflow)
			});
	});
var $author$project$Actions$Station$mergeStepDatabases = F2(
	function (localDb, remoteDb) {
		var getRemoteOnly = F2(
			function (l, r) {
				return A2(
					$elm$core$List$filter,
					function (_v0) {
						var key = _v0.a;
						return !A2(
							$elm$core$List$member,
							key,
							A2($elm$core$List$map, $elm$core$Tuple$first, l));
					},
					r);
			});
		var mergeDicts = F2(
			function (localDict, remoteDict) {
				return $elm$core$Dict$fromList(
					$elm$core$List$concat(
						_List_fromArray(
							[
								$elm$core$Dict$toList(localDict),
								A2(
								getRemoteOnly,
								$elm$core$Dict$toList(localDict),
								$elm$core$Dict$toList(remoteDict))
							])));
			});
		return {
			Q: A2(mergeDicts, localDb.Q, remoteDb.Q),
			R: A2(mergeDicts, localDb.R, remoteDb.R),
			ag: A2(mergeDicts, localDb.ag, remoteDb.ag),
			ar: A2(mergeDicts, localDb.ar, remoteDb.ar),
			as: A2(mergeDicts, localDb.as, remoteDb.as),
			P: A2(mergeDicts, localDb.P, remoteDb.P),
			az: A2(mergeDicts, localDb.az, remoteDb.az),
			V: A2(mergeDicts, localDb.V, remoteDb.V),
			W: A2(mergeDicts, localDb.W, remoteDb.W),
			X: A2(mergeDicts, localDb.X, remoteDb.X)
		};
	});
var $author$project$Actions$Station$mergeStation = F2(
	function (localStation, remoteStation) {
		return _Utils_update(
			localStation,
			{
				I: (_Utils_cmp(localStation.I, remoteStation.I) > 0) ? localStation.I : remoteStation.I,
				ab: (_Utils_cmp(localStation.I, remoteStation.I) > 0) ? localStation.ab : remoteStation.ab,
				A: A2($author$project$Actions$Station$mergeStepDatabases, localStation.A, remoteStation.A)
			});
	});
var $author$project$Actions$Station$mergeStations = F2(
	function (remoteStations, localStationWrapper) {
		return _Utils_update(
			localStationWrapper,
			{
				aA: A2(
					$elm$core$List$map,
					function (remoteStation) {
						var _v0 = A2($author$project$Actions$Station$getLocalStation, remoteStation.bD, localStationWrapper.aA);
						if (!_v0.$) {
							var localStation = _v0.a;
							return A2($author$project$Actions$Station$mergeStation, localStation, remoteStation);
						} else {
							return remoteStation;
						}
					},
					remoteStations)
			});
	});
var $author$project$Ports$operationDoneState = _Platform_outgoingPort('operationDoneState', $elm$core$Basics$identity);
var $author$project$Update$update = F2(
	function (msg, model) {
		switch (msg.$) {
			case 0:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 1:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			case 2:
				var newZone = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{hi: newZone}),
					$elm$core$Platform$Cmd$none);
			case 3:
				var newTime = msg.a;
				var model_ = $author$project$Actions$Queue$findNextSyncableResources(
					_Utils_update(
						model,
						{g2: newTime}));
				return _Utils_eq(model.c8, $author$project$Types$Queue$NotStarted) ? _Utils_Tuple2(
					model_,
					$author$project$Lib$send(
						$author$project$Msg$QueueMsg_($author$project$Msg$StartSyncCycle))) : _Utils_Tuple2(model_, $elm$core$Platform$Cmd$none);
			case 4:
				var newTime = msg.a;
				var model_ = _Utils_update(
					model,
					{g2: newTime});
				return _Utils_Tuple2(model_, $elm$core$Platform$Cmd$none);
			case 5:
				var unknownMsg = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$attempt,
						$author$project$Msg$SentryResponse,
						A2(
							$author$project$Lib$Sentry$sentry(model.ae).bE,
							'Received the unknown message (on global level): ' + unknownMsg,
							$elm$core$Dict$fromList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'userEmail',
										A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, model.aa))
									])))));
			case 6:
				var err = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$attempt,
						$author$project$Msg$SentryResponse,
						A2(
							$author$project$Lib$Sentry$sentry(model.ae).bE,
							'Received and error (on global level): ' + err,
							$elm$core$Dict$fromList(
								_List_fromArray(
									[
										_Utils_Tuple2(
										'userEmail',
										A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, model.aa))
									])))));
			case 7:
				var data = msg.a;
				return _Utils_Tuple2(
					model,
					$author$project$Lib$PortHelpers$extractMsgSendToElm(data));
			case 8:
				var portMsg = msg.a;
				if (!portMsg.$) {
					var jsMsg = portMsg.a;
					return A2($author$project$Actions$Ports$handleJsMsg, jsMsg, model);
				} else {
					var dbMsg = portMsg.a;
					return A2($author$project$Actions$Ports$handleDbMsg, dbMsg, model);
				}
			case 9:
				var warehouseMsg = msg.a;
				return A3($author$project$Update$handleWarehouseMsg, warehouseMsg, model, model.bj);
			case 10:
				var apiMsg = msg.a;
				return A2($author$project$Update$handleApiMsg, apiMsg, model);
			case 11:
				var queueMsg = msg.a;
				return A2($author$project$Actions$Queue$handleQueueMsg, queueMsg, model);
			case 13:
				var operationId = msg.a;
				var stationState = function () {
					var stationsFinishedForOperationId = $elm$json$Json$Encode$bool(
						A3(
							$elm$core$List$foldl,
							$elm$core$Basics$and,
							true,
							A2(
								$elm$core$List$map,
								function (station) {
									return A3(
										$elm$core$List$foldl,
										$elm$core$Basics$and,
										true,
										A2(
											$elm$core$List$map,
											function (iteration) {
												return A3($author$project$Types$Step$evaluate, station.A, iteration, station.cc);
											},
											station.ab));
								},
								A2(
									$elm$core$Maybe$withDefault,
									$author$project$Types$Station$init,
									A2($elm$core$Dict$get, operationId, model.aA)).aA)));
					return $elm$json$Json$Encode$object(
						_List_fromArray(
							[
								_Utils_Tuple2(operationId, stationsFinishedForOperationId)
							]));
				}();
				return _Utils_Tuple2(
					model,
					$author$project$Ports$operationDoneState(stationState));
			case 14:
				var stationState = function () {
					var isStationFinished = function (station) {
						return A3(
							$elm$core$List$foldl,
							$elm$core$Basics$and,
							true,
							A2(
								$elm$core$List$map,
								function (iteration) {
									return A3($author$project$Types$Step$evaluate, station.A, iteration, station.cc);
								},
								station.ab));
					};
					var stationsFinished = A2(
						$elm$core$List$map,
						function (_v2) {
							var operationId = _v2.a;
							var wrapper = _v2.b;
							return _Utils_Tuple2(
								operationId,
								$elm$json$Json$Encode$bool(
									A3(
										$elm$core$List$foldl,
										$elm$core$Basics$and,
										true,
										A2($elm$core$List$map, isStationFinished, wrapper.aA))));
						},
						$elm$core$Dict$toList(model.aA));
					return $elm$json$Json$Encode$object(stationsFinished);
				}();
				return _Utils_Tuple2(
					model,
					$author$project$Ports$operationDoneState(stationState));
			case 15:
				var operationId = msg.a;
				var stationId = msg.b;
				var stationMsg = msg.c;
				var _v3 = A4($author$project$Actions$Station$handleStationMsg, operationId, stationId, stationMsg, model);
				var model_ = _v3.a;
				var cmd = _v3.b;
				return _Utils_Tuple2(
					model_,
					$elm$core$Platform$Cmd$batch(
						_List_fromArray(
							[
								cmd,
								$author$project$Lib$PortHelpers$nextModel(model_)
							])));
			case 12:
				var operationId = msg.a;
				var result = msg.b;
				if (!result.$) {
					var operationMetaDataTable = result.a;
					var workflowTemplate = A2($elm$core$Maybe$withDefault, _List_Nil, operationMetaDataTable.hg);
					var metaData = operationMetaDataTable.f1;
					var emptyStation = $author$project$Types$Station$init;
					var stations = A3(
						$elm$core$Dict$update,
						operationId,
						function (maybeStationWrapper) {
							if (!maybeStationWrapper.$) {
								var existingStationWrapper = maybeStationWrapper.a;
								return $elm$core$Maybe$Just(
									A2(
										$author$project$Actions$Station$mergeNewWorkflow,
										workflowTemplate,
										A2($author$project$Actions$Station$mergeStations, metaData, existingStationWrapper)));
							} else {
								return $elm$core$Maybe$Just(
									_Utils_update(
										emptyStation,
										{aA: metaData}));
							}
						},
						model.aA);
					var model_ = _Utils_update(
						model,
						{aA: stations});
					return _Utils_Tuple2(
						model_,
						$author$project$Lib$PortHelpers$nextModel(model_));
				} else {
					var e = result.a;
					if ((e.$ === 3) && (e.a === 401)) {
						return _Utils_Tuple2(model, $author$project$Lib$PortHelpers$logout);
					} else {
						return _Utils_Tuple2(
							model,
							A2(
								$elm$core$Task$attempt,
								$author$project$Msg$SentryResponse,
								A2(
									$author$project$Lib$Sentry$sentry(model.ae).bA,
									'Could not load the stations',
									$elm$core$Dict$fromList(
										_List_fromArray(
											[
												_Utils_Tuple2(
												'operationId',
												$elm$json$Json$Encode$string(operationId)),
												_Utils_Tuple2(
												'availableOperationIds',
												A2(
													$elm$json$Json$Encode$list,
													$elm$json$Json$Encode$string,
													A2(
														$elm$core$List$map,
														$elm$core$Tuple$first,
														$elm$core$Dict$toList(model.ba)))),
												_Utils_Tuple2(
												'userEmail',
												A2($elm_community$json_extra$Json$Encode$Extra$maybe, $elm$json$Json$Encode$string, model.aa)),
												_Utils_Tuple2(
												'error',
												$elm$json$Json$Encode$string(
													A2($author$project$Lib$Http$Extra$errorMessage, e, operationId)))
											])))));
					}
				}
			case 17:
				var id = msg.a;
				return _Utils_Tuple2(
					model,
					A2(
						$elm$core$Task$attempt,
						$author$project$Msg$FocusResult,
						$elm$browser$Browser$Dom$focus(id)));
			case 18:
				return _Utils_Tuple2(model, $elm$core$Platform$Cmd$none);
			default:
				var operationId = msg.a;
				return _Utils_Tuple2(
					_Utils_update(
						model,
						{
							aA: A3(
								$elm$core$Dict$update,
								operationId,
								function (stationWrapper) {
									if (!stationWrapper.$) {
										var wrapper = stationWrapper.a;
										return $elm$core$Maybe$Just(
											_Utils_update(
												wrapper,
												{gv: true, gZ: $author$project$Lib$Sync$Local}));
									} else {
										return $elm$core$Maybe$Nothing;
									}
								},
								model.aA)
						}),
					$author$project$Lib$send(
						$author$project$Msg$QueueMsg_($author$project$Msg$StartSyncCycle)));
		}
	});
var $author$project$Msg$ApiSendErrorReport = {$: 4};
var $author$project$Types$Step$BadPart = 0;
var $author$project$Types$Step$GoodPart = 1;
var $rtfeldman$elm_css$Css$Preprocess$AppendProperty = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Css$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $rtfeldman$elm_css$Css$backgroundColor = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'background-color', c.cO);
};
var $rtfeldman$elm_css$Css$Preprocess$ApplyStyles = function (a) {
	return {$: 6, a: a};
};
var $rtfeldman$elm_css$Css$batch = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles;
var $rtfeldman$elm_css$Css$Structure$Compatible = 0;
var $rtfeldman$elm_css$Css$withPrecedingHash = function (str) {
	return A2($elm$core$String$startsWith, '#', str) ? str : A2($elm$core$String$cons, '#', str);
};
var $rtfeldman$elm_css$Css$erroneousHex = function (str) {
	return {
		a0: 1,
		a3: 0,
		Z: 0,
		a6: 0,
		be: 0,
		cO: $rtfeldman$elm_css$Css$withPrecedingHash(str)
	};
};
var $elm$core$String$foldr = _String_foldr;
var $elm$core$String$toList = function (string) {
	return A3($elm$core$String$foldr, $elm$core$List$cons, _List_Nil, string);
};
var $elm$core$Basics$pow = _Basics_pow;
var $rtfeldman$elm_hex$Hex$fromStringHelp = F3(
	function (position, chars, accumulated) {
		fromStringHelp:
		while (true) {
			if (!chars.b) {
				return $elm$core$Result$Ok(accumulated);
			} else {
				var _char = chars.a;
				var rest = chars.b;
				switch (_char) {
					case '0':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated;
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '1':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + A2($elm$core$Basics$pow, 16, position);
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '2':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (2 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '3':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (3 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '4':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (4 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '5':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (5 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '6':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (6 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '7':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (7 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '8':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (8 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case '9':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (9 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'a':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (10 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'b':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (11 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'c':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (12 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'd':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (13 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'e':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (14 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					case 'f':
						var $temp$position = position - 1,
							$temp$chars = rest,
							$temp$accumulated = accumulated + (15 * A2($elm$core$Basics$pow, 16, position));
						position = $temp$position;
						chars = $temp$chars;
						accumulated = $temp$accumulated;
						continue fromStringHelp;
					default:
						var nonHex = _char;
						return $elm$core$Result$Err(
							$elm$core$String$fromChar(nonHex) + ' is not a valid hexadecimal character.');
				}
			}
		}
	});
var $elm$core$Result$map = F2(
	function (func, ra) {
		if (!ra.$) {
			var a = ra.a;
			return $elm$core$Result$Ok(
				func(a));
		} else {
			var e = ra.a;
			return $elm$core$Result$Err(e);
		}
	});
var $rtfeldman$elm_hex$Hex$fromString = function (str) {
	if ($elm$core$String$isEmpty(str)) {
		return $elm$core$Result$Err('Empty strings are not valid hexadecimal strings.');
	} else {
		var result = function () {
			if (A2($elm$core$String$startsWith, '-', str)) {
				var list = A2(
					$elm$core$Maybe$withDefault,
					_List_Nil,
					$elm$core$List$tail(
						$elm$core$String$toList(str)));
				return A2(
					$elm$core$Result$map,
					$elm$core$Basics$negate,
					A3(
						$rtfeldman$elm_hex$Hex$fromStringHelp,
						$elm$core$List$length(list) - 1,
						list,
						0));
			} else {
				return A3(
					$rtfeldman$elm_hex$Hex$fromStringHelp,
					$elm$core$String$length(str) - 1,
					$elm$core$String$toList(str),
					0);
			}
		}();
		var formatError = function (err) {
			return A2(
				$elm$core$String$join,
				' ',
				_List_fromArray(
					['\"' + (str + '\"'), 'is not a valid hexadecimal string because', err]));
		};
		return A2($elm$core$Result$mapError, formatError, result);
	}
};
var $elm$core$String$toLower = _String_toLower;
var $rtfeldman$elm_css$Css$validHex = F5(
	function (str, _v0, _v1, _v2, _v3) {
		var r1 = _v0.a;
		var r2 = _v0.b;
		var g1 = _v1.a;
		var g2 = _v1.b;
		var b1 = _v2.a;
		var b2 = _v2.b;
		var a1 = _v3.a;
		var a2 = _v3.b;
		var toResult = A2(
			$elm$core$Basics$composeR,
			$elm$core$String$fromList,
			A2($elm$core$Basics$composeR, $elm$core$String$toLower, $rtfeldman$elm_hex$Hex$fromString));
		var results = _Utils_Tuple2(
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[r1, r2])),
				toResult(
					_List_fromArray(
						[g1, g2]))),
			_Utils_Tuple2(
				toResult(
					_List_fromArray(
						[b1, b2])),
				toResult(
					_List_fromArray(
						[a1, a2]))));
		if ((((!results.a.a.$) && (!results.a.b.$)) && (!results.b.a.$)) && (!results.b.b.$)) {
			var _v5 = results.a;
			var red = _v5.a.a;
			var green = _v5.b.a;
			var _v6 = results.b;
			var blue = _v6.a.a;
			var alpha = _v6.b.a;
			return {
				a0: alpha / 255,
				a3: blue,
				Z: 0,
				a6: green,
				be: red,
				cO: $rtfeldman$elm_css$Css$withPrecedingHash(str)
			};
		} else {
			return $rtfeldman$elm_css$Css$erroneousHex(str);
		}
	});
var $rtfeldman$elm_css$Css$hex = function (str) {
	var withoutHash = A2($elm$core$String$startsWith, '#', str) ? A2($elm$core$String$dropLeft, 1, str) : str;
	var _v0 = $elm$core$String$toList(withoutHash);
	_v0$4:
	while (true) {
		if ((_v0.b && _v0.b.b) && _v0.b.b.b) {
			if (!_v0.b.b.b.b) {
				var r = _v0.a;
				var _v1 = _v0.b;
				var g = _v1.a;
				var _v2 = _v1.b;
				var b = _v2.a;
				return A5(
					$rtfeldman$elm_css$Css$validHex,
					str,
					_Utils_Tuple2(r, r),
					_Utils_Tuple2(g, g),
					_Utils_Tuple2(b, b),
					_Utils_Tuple2('f', 'f'));
			} else {
				if (!_v0.b.b.b.b.b) {
					var r = _v0.a;
					var _v3 = _v0.b;
					var g = _v3.a;
					var _v4 = _v3.b;
					var b = _v4.a;
					var _v5 = _v4.b;
					var a = _v5.a;
					return A5(
						$rtfeldman$elm_css$Css$validHex,
						str,
						_Utils_Tuple2(r, r),
						_Utils_Tuple2(g, g),
						_Utils_Tuple2(b, b),
						_Utils_Tuple2(a, a));
				} else {
					if (_v0.b.b.b.b.b.b) {
						if (!_v0.b.b.b.b.b.b.b) {
							var r1 = _v0.a;
							var _v6 = _v0.b;
							var r2 = _v6.a;
							var _v7 = _v6.b;
							var g1 = _v7.a;
							var _v8 = _v7.b;
							var g2 = _v8.a;
							var _v9 = _v8.b;
							var b1 = _v9.a;
							var _v10 = _v9.b;
							var b2 = _v10.a;
							return A5(
								$rtfeldman$elm_css$Css$validHex,
								str,
								_Utils_Tuple2(r1, r2),
								_Utils_Tuple2(g1, g2),
								_Utils_Tuple2(b1, b2),
								_Utils_Tuple2('f', 'f'));
						} else {
							if (_v0.b.b.b.b.b.b.b.b && (!_v0.b.b.b.b.b.b.b.b.b)) {
								var r1 = _v0.a;
								var _v11 = _v0.b;
								var r2 = _v11.a;
								var _v12 = _v11.b;
								var g1 = _v12.a;
								var _v13 = _v12.b;
								var g2 = _v13.a;
								var _v14 = _v13.b;
								var b1 = _v14.a;
								var _v15 = _v14.b;
								var b2 = _v15.a;
								var _v16 = _v15.b;
								var a1 = _v16.a;
								var _v17 = _v16.b;
								var a2 = _v17.a;
								return A5(
									$rtfeldman$elm_css$Css$validHex,
									str,
									_Utils_Tuple2(r1, r2),
									_Utils_Tuple2(g1, g2),
									_Utils_Tuple2(b1, b2),
									_Utils_Tuple2(a1, a2));
							} else {
								break _v0$4;
							}
						}
					} else {
						break _v0$4;
					}
				}
			}
		} else {
			break _v0$4;
		}
	}
	return $rtfeldman$elm_css$Css$erroneousHex(str);
};
var $author$project$TW$Utilities$bg_red_200 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--bg-opacity', '1'),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('#fed7d7')),
			A2($rtfeldman$elm_css$Css$property, 'background-color', 'rgba(254, 215, 215, var(--bg-opacity))')
		]));
var $author$project$TW$Utilities$bg_yellow_200 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--bg-opacity', '1'),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('#fefcbf')),
			A2($rtfeldman$elm_css$Css$property, 'background-color', 'rgba(254, 252, 191, var(--bg-opacity))')
		]));
var $author$project$TW$Utilities$bg_blue_200 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--bg-opacity', '1'),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('#bee3f8')),
			A2($rtfeldman$elm_css$Css$property, 'background-color', 'rgba(190, 227, 248, var(--bg-opacity))')
		]));
var $author$project$TW$Utilities$bg_gray_200 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--bg-opacity', '1'),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('#edf2f7')),
			A2($rtfeldman$elm_css$Css$property, 'background-color', 'rgba(237, 242, 247, var(--bg-opacity))')
		]));
var $rtfeldman$elm_css$Css$prop1 = F2(
	function (key, arg) {
		return A2($rtfeldman$elm_css$Css$property, key, arg.cO);
	});
var $rtfeldman$elm_css$Css$borderWidth = $rtfeldman$elm_css$Css$prop1('border-width');
var $rtfeldman$elm_css$Css$PxUnits = 0;
var $elm$core$String$fromFloat = _String_fromNumber;
var $rtfeldman$elm_css$Css$Internal$lengthConverter = F3(
	function (units, unitLabel, numericValue) {
		return {
			cP: 0,
			c2: 0,
			aJ: 0,
			D: 0,
			cl: 0,
			aO: 0,
			al: 0,
			aP: 0,
			aQ: 0,
			av: 0,
			aw: 0,
			ac: 0,
			am: numericValue,
			aX: 0,
			aZ: unitLabel,
			bl: units,
			cO: _Utils_ap(
				$elm$core$String$fromFloat(numericValue),
				unitLabel)
		};
	});
var $rtfeldman$elm_css$Css$px = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'px');
var $author$project$TW$Utilities$border = $rtfeldman$elm_css$Css$borderWidth(
	$rtfeldman$elm_css$Css$px(1));
var $rtfeldman$elm_css$Css$borderColor = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'border-color', c.cO);
};
var $author$project$TW$Utilities$border_blue_300 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--border-opacity', '1'),
			$rtfeldman$elm_css$Css$borderColor(
			$rtfeldman$elm_css$Css$hex('#90cdf4')),
			A2($rtfeldman$elm_css$Css$property, 'border-color', 'rgba(144, 205, 244, var(--border-opacity))')
		]));
var $author$project$TW$Utilities$border_gray_300 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--border-opacity', '1'),
			$rtfeldman$elm_css$Css$borderColor(
			$rtfeldman$elm_css$Css$hex('#e2e8f0')),
			A2($rtfeldman$elm_css$Css$property, 'border-color', 'rgba(226, 232, 240, var(--border-opacity))')
		]));
var $rtfeldman$elm_css$Css$borderStyle = $rtfeldman$elm_css$Css$prop1('border-style');
var $rtfeldman$elm_css$Css$solid = {H: 0, aB: 0, cO: 'solid'};
var $author$project$TW$Utilities$border_solid = $rtfeldman$elm_css$Css$borderStyle($rtfeldman$elm_css$Css$solid);
var $rtfeldman$elm_css$VirtualDom$Styled$Node = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$Node;
var $rtfeldman$elm_css$Html$Styled$node = $rtfeldman$elm_css$VirtualDom$Styled$node;
var $rtfeldman$elm_css$Html$Styled$button = $rtfeldman$elm_css$Html$Styled$node('button');
var $rtfeldman$elm_css$VirtualDom$Styled$Attribute = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $rtfeldman$elm_css$VirtualDom$Styled$murmurSeed = 15739;
var $rtfeldman$elm_css$VirtualDom$Styled$getClassname = function (styles) {
	return $elm$core$List$isEmpty(styles) ? 'unstyled' : A2(
		$elm$core$String$cons,
		'_',
		$rtfeldman$elm_hex$Hex$toString(
			A2(
				$rtfeldman$elm_css$ElmCssVendor$Murmur3$hashString,
				$rtfeldman$elm_css$VirtualDom$Styled$murmurSeed,
				$rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
					$elm$core$List$singleton(
						$rtfeldman$elm_css$Css$Preprocess$stylesheet(
							$elm$core$List$singleton(
								A2(
									$rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
									styles,
									$rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(_List_Nil)))))))));
};
var $elm$virtual_dom$VirtualDom$property = F2(
	function (key, value) {
		return A2(
			_VirtualDom_property,
			_VirtualDom_noInnerHtmlOrFormAction(key),
			_VirtualDom_noJavaScriptOrHtmlUri(value));
	});
var $rtfeldman$elm_css$Html$Styled$Internal$css = function (styles) {
	var classname = $rtfeldman$elm_css$VirtualDom$Styled$getClassname(styles);
	var classProperty = A2(
		$elm$virtual_dom$VirtualDom$property,
		'className',
		$elm$json$Json$Encode$string(classname));
	return A3($rtfeldman$elm_css$VirtualDom$Styled$Attribute, classProperty, styles, classname);
};
var $rtfeldman$elm_css$Html$Styled$Attributes$css = $rtfeldman$elm_css$Html$Styled$Internal$css;
var $rtfeldman$elm_css$VirtualDom$Styled$property = F2(
	function (key, value) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$property, key, value),
			_List_Nil,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$disabled = $rtfeldman$elm_css$Html$Styled$Attributes$boolProperty('disabled');
var $rtfeldman$elm_css$Css$UnitlessFloat = 0;
var $rtfeldman$elm_css$Css$num = function (val) {
	return {
		aw: 0,
		ac: 0,
		gn: 0,
		bL: 0,
		am: val,
		aZ: '',
		bl: 0,
		cO: $elm$core$String$fromFloat(val)
	};
};
var $rtfeldman$elm_css$Css$opacity = $rtfeldman$elm_css$Css$prop1('opacity');
var $author$project$TW$Utilities$opacity_50 = $rtfeldman$elm_css$Css$opacity(
	$rtfeldman$elm_css$Css$num(0.5));
var $rtfeldman$elm_css$Css$paddingLeft = $rtfeldman$elm_css$Css$prop1('padding-left');
var $rtfeldman$elm_css$Css$paddingRight = $rtfeldman$elm_css$Css$prop1('padding-right');
var $rtfeldman$elm_css$Css$RemUnits = 0;
var $rtfeldman$elm_css$Css$rem = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'rem');
var $author$project$TW$Utilities$px_2 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$rem(0.5)),
			$rtfeldman$elm_css$Css$paddingRight(
			$rtfeldman$elm_css$Css$rem(0.5))
		]));
var $rtfeldman$elm_css$Css$paddingBottom = $rtfeldman$elm_css$Css$prop1('padding-bottom');
var $rtfeldman$elm_css$Css$paddingTop = $rtfeldman$elm_css$Css$prop1('padding-top');
var $author$project$TW$Utilities$py_2 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$rem(0.5)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$rem(0.5))
		]));
var $rtfeldman$elm_css$Css$borderRadius = $rtfeldman$elm_css$Css$prop1('border-radius');
var $author$project$TW$Utilities$rounded = $rtfeldman$elm_css$Css$borderRadius(
	$rtfeldman$elm_css$Css$rem(0.25));
var $rtfeldman$elm_css$Css$color = function (c) {
	return A2($rtfeldman$elm_css$Css$property, 'color', c.cO);
};
var $author$project$TW$Utilities$text_blue_800 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--text-opacity', '1'),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('#2c5282')),
			A2($rtfeldman$elm_css$Css$property, 'color', 'rgba(44, 82, 130, var(--text-opacity))')
		]));
var $author$project$TW$Utilities$text_gray_800 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--text-opacity', '1'),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('#2d3748')),
			A2($rtfeldman$elm_css$Css$property, 'color', 'rgba(45, 55, 72, var(--text-opacity))')
		]));
var $author$project$Ui$UiComponents$Form$btn = F3(
	function (disabled, attributes, children) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							_List_fromArray(
								[$author$project$TW$Utilities$px_2, $author$project$TW$Utilities$py_2, $author$project$TW$Utilities$rounded, $author$project$TW$Utilities$border, $author$project$TW$Utilities$border_solid]),
							disabled ? _List_fromArray(
								[$author$project$TW$Utilities$opacity_50, $author$project$TW$Utilities$bg_gray_200, $author$project$TW$Utilities$text_gray_800, $author$project$TW$Utilities$border_gray_300]) : _List_fromArray(
								[$author$project$TW$Utilities$bg_blue_200, $author$project$TW$Utilities$text_blue_800, $author$project$TW$Utilities$border_blue_300]))),
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(disabled)
					]),
				attributes),
			children);
	});
var $rtfeldman$elm_css$Html$Styled$div = $rtfeldman$elm_css$Html$Styled$node('div');
var $author$project$TW$Utilities$bg_white = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--bg-opacity', '1'),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('#fff')),
			A2($rtfeldman$elm_css$Css$property, 'background-color', 'rgba(255, 255, 255, var(--bg-opacity))')
		]));
var $rtfeldman$elm_css$Css$bottom = $rtfeldman$elm_css$Css$prop1('bottom');
var $author$project$TW$Utilities$bottom_0 = $rtfeldman$elm_css$Css$bottom(
	$rtfeldman$elm_css$Css$px(0));
var $rtfeldman$elm_css$Css$fixed = {a1: 0, bd: 0, bY: 0, cO: 'fixed'};
var $rtfeldman$elm_css$Css$position = $rtfeldman$elm_css$Css$prop1('position');
var $author$project$TW$Utilities$fixed = $rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$fixed);
var $rtfeldman$elm_css$Css$left = $rtfeldman$elm_css$Css$prop1('left');
var $author$project$TW$Utilities$left_0 = $rtfeldman$elm_css$Css$left(
	$rtfeldman$elm_css$Css$px(0));
var $rtfeldman$elm_css$Css$hidden = {H: 0, aS: 0, cO: 'hidden', bm: 0};
var $rtfeldman$elm_css$Css$overflowX = $rtfeldman$elm_css$Css$prop1('overflow-x');
var $author$project$TW$Utilities$overflow_x_hidden = $rtfeldman$elm_css$Css$overflowX($rtfeldman$elm_css$Css$hidden);
var $rtfeldman$elm_css$Css$auto = {e0: 0, e: 0, aJ: 0, bF: 0, fW: 0, aO: 0, al: 0, ac: 0, aS: 0, U: 0, bY: 0, aY: 0, N: 0, cO: 'auto'};
var $rtfeldman$elm_css$Css$overflowY = $rtfeldman$elm_css$Css$prop1('overflow-y');
var $author$project$TW$Utilities$overflow_y_auto = $rtfeldman$elm_css$Css$overflowY($rtfeldman$elm_css$Css$auto);
var $rtfeldman$elm_css$Css$right = $rtfeldman$elm_css$Css$prop1('right');
var $author$project$TW$Utilities$right_0 = $rtfeldman$elm_css$Css$right(
	$rtfeldman$elm_css$Css$px(0));
var $rtfeldman$elm_css$Css$top = $rtfeldman$elm_css$Css$prop1('top');
var $author$project$TW$Utilities$top_0 = $rtfeldman$elm_css$Css$top(
	$rtfeldman$elm_css$Css$px(0));
var $rtfeldman$elm_css$Css$UnitlessInteger = 0;
var $rtfeldman$elm_css$Css$int = function (val) {
	return {
		ak: 0,
		bF: 0,
		aw: 0,
		ac: 0,
		gn: 0,
		bL: 0,
		am: val,
		aZ: '',
		bl: 0,
		cO: $elm$core$String$fromInt(val)
	};
};
var $rtfeldman$elm_css$Css$zIndex = $rtfeldman$elm_css$Css$prop1('z-index');
var $author$project$TW$Utilities$z_40 = $rtfeldman$elm_css$Css$zIndex(
	$rtfeldman$elm_css$Css$int(40));
var $author$project$Ui$View$elevator = function (child) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_fromArray(
			[
				$rtfeldman$elm_css$Html$Styled$Attributes$css(
				_List_fromArray(
					[$author$project$TW$Utilities$z_40, $author$project$TW$Utilities$fixed, $author$project$TW$Utilities$top_0, $author$project$TW$Utilities$bottom_0, $author$project$TW$Utilities$left_0, $author$project$TW$Utilities$right_0, $author$project$TW$Utilities$bg_white, $author$project$TW$Utilities$overflow_y_auto, $author$project$TW$Utilities$overflow_x_hidden]))
			]),
		_List_fromArray(
			[child]));
};
var $rtfeldman$elm_css$Css$displayFlex = A2($rtfeldman$elm_css$Css$property, 'display', 'flex');
var $author$project$TW$Utilities$flex = $rtfeldman$elm_css$Css$displayFlex;
var $rtfeldman$elm_css$Css$fontWeight = function (_v0) {
	var value = _v0.cO;
	return A2($rtfeldman$elm_css$Css$property, 'font-weight', value);
};
var $author$project$TW$Utilities$font_bold = $rtfeldman$elm_css$Css$fontWeight(
	$rtfeldman$elm_css$Css$int(700));
var $rtfeldman$elm_css$Html$Styled$h4 = $rtfeldman$elm_css$Html$Styled$node('h4');
var $rtfeldman$elm_css$Css$display = $rtfeldman$elm_css$Css$prop1('display');
var $rtfeldman$elm_css$Css$inlineBlock = {q: 0, cO: 'inline-block'};
var $author$project$TW$Utilities$inline_block = $rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$inlineBlock);
var $rtfeldman$elm_css$Css$Internal$property = F2(
	function (key, value) {
		return $rtfeldman$elm_css$Css$Preprocess$AppendProperty(key + (':' + value));
	});
var $rtfeldman$elm_css$Css$Internal$getOverloadedProperty = F3(
	function (functionName, desiredKey, style) {
		getOverloadedProperty:
		while (true) {
			switch (style.$) {
				case 0:
					var str = style.a;
					var key = A2(
						$elm$core$Maybe$withDefault,
						'',
						$elm$core$List$head(
							A2($elm$core$String$split, ':', str)));
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, key);
				case 1:
					var selector = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-selector'));
				case 2:
					var combinator = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-combinator'));
				case 3:
					var pseudoElement = style.a;
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-pseudo-element setter'));
				case 4:
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-media-query'));
				case 5:
					return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-inapplicable-Style-for-keyframes'));
				default:
					if (!style.a.b) {
						return A2($rtfeldman$elm_css$Css$Internal$property, desiredKey, 'elm-css-error-cannot-apply-' + (functionName + '-with-empty-Style'));
					} else {
						if (!style.a.b.b) {
							var _v1 = style.a;
							var only = _v1.a;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = only;
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						} else {
							var _v2 = style.a;
							var first = _v2.a;
							var rest = _v2.b;
							var $temp$functionName = functionName,
								$temp$desiredKey = desiredKey,
								$temp$style = $rtfeldman$elm_css$Css$Preprocess$ApplyStyles(rest);
							functionName = $temp$functionName;
							desiredKey = $temp$desiredKey;
							style = $temp$style;
							continue getOverloadedProperty;
						}
					}
			}
		}
	});
var $rtfeldman$elm_css$Css$Internal$IncompatibleUnits = 0;
var $rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty = A3($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '', 0);
var $rtfeldman$elm_css$Css$alignItems = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'alignItems',
		'align-items',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $rtfeldman$elm_css$Css$center = $rtfeldman$elm_css$Css$prop1('center');
var $author$project$TW$Utilities$items_center = $rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$center);
var $rtfeldman$elm_css$Css$justifyContent = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'justifyContent',
		'justify-content',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $author$project$TW$Utilities$justify_center = $rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$center);
var $rtfeldman$elm_css$Css$marginBottom = $rtfeldman$elm_css$Css$prop1('margin-bottom');
var $rtfeldman$elm_css$Css$marginTop = $rtfeldman$elm_css$Css$prop1('margin-top');
var $author$project$TW$Utilities$my_4 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$rem(1)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$rem(1))
		]));
var $elm$virtual_dom$VirtualDom$Normal = function (a) {
	return {$: 0, a: a};
};
var $elm$virtual_dom$VirtualDom$on = _VirtualDom_on;
var $rtfeldman$elm_css$VirtualDom$Styled$on = F2(
	function (eventName, handler) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$on, eventName, handler),
			_List_Nil,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Events$on = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$Normal(decoder));
	});
var $rtfeldman$elm_css$Html$Styled$Events$onClick = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'click',
		$elm$json$Json$Decode$succeed(msg));
};
var $rtfeldman$elm_css$Html$Styled$p = $rtfeldman$elm_css$Html$Styled$node('p');
var $rtfeldman$elm_css$Css$padding = $rtfeldman$elm_css$Css$prop1('padding');
var $author$project$TW$Utilities$p_4 = $rtfeldman$elm_css$Css$padding(
	$rtfeldman$elm_css$Css$rem(1));
var $author$project$Msg$StationIncrementCounter = {$: 1};
var $author$project$TW$Utilities$col_span_2 = A2($rtfeldman$elm_css$Css$property, 'grid-column', 'span 2 / span 2');
var $author$project$Types$Station$evaluate = F2(
	function (stations, stationRules) {
		var evaluateStepRules = F2(
			function (stationId, evaluator) {
				return A2(
					$elm$core$Maybe$withDefault,
					false,
					A2(
						$elm$core$Maybe$map,
						evaluator,
						$elm$core$List$head(
							A2(
								$elm$core$List$filter,
								A2(
									$elm$core$Basics$composeR,
									function ($) {
										return $.bD;
									},
									$elm$core$Basics$eq(stationId)),
								stations))));
			});
		var evaluateForIteration = F2(
			function (iterations, evaluator) {
				return function (completedList) {
					return (!$elm$core$List$length(completedList)) ? false : A3($elm$core$List$foldl, $elm$core$Basics$and, true, completedList);
				}(
					A2($elm$core$List$map, evaluator, iterations));
			});
		switch (stationRules.$) {
			case 7:
				return true;
			case 6:
				return false;
			case 3:
				var stationId = stationRules.a;
				return A2(
					evaluateStepRules,
					stationId,
					function (station) {
						return A2(
							evaluateForIteration,
							station.ab,
							function (iteration) {
								return A3($author$project$Types$Step$evaluate, station.A, iteration, station.b2) || A3($author$project$Types$Step$evaluate, station.A, iteration, station.cc);
							});
					});
			case 4:
				var stationId = stationRules.a;
				var rules = stationRules.b;
				return A2(
					evaluateStepRules,
					stationId,
					function (station) {
						return A2(
							evaluateForIteration,
							station.ab,
							function (iteration) {
								return A3($author$project$Types$Step$evaluate, station.A, iteration, rules);
							});
					});
			case 5:
				var stationIdOfCounterTarget = stationRules.a;
				var comparer = stationRules.b;
				if (comparer.$ === 1) {
					var count = comparer.a;
					return A2(
						evaluateStepRules,
						stationIdOfCounterTarget,
						function (station) {
							return _Utils_cmp(
								$elm$core$List$length(station.ab),
								count) < 0;
						});
				} else {
					var _v2 = comparer.a;
					var stationId = _v2.a;
					var amountId = _v2.b;
					return A2(
						evaluateStepRules,
						stationId,
						function (stationAmountTarget) {
							return A2(
								evaluateForIteration,
								stationAmountTarget.ab,
								function (iteration) {
									var _v3 = A2(
										$elm$core$Dict$get,
										_Utils_ap(
											amountId,
											$elm$core$String$fromInt(iteration)),
										stationAmountTarget.A.Q);
									if (!_v3.$) {
										var count = _v3.a;
										return A2(
											evaluateStepRules,
											stationIdOfCounterTarget,
											function (station) {
												return _Utils_cmp(
													$elm$core$List$length(station.ab),
													count) < 0;
											});
									} else {
										return false;
									}
								});
						});
				}
			case 2:
				var rule = stationRules.a;
				return !A2($author$project$Types$Station$evaluate, stations, rule);
			case 1:
				var ruleList = stationRules.a;
				return A3(
					$elm$core$List$foldl,
					$elm$core$Basics$or,
					false,
					A2(
						$elm$core$List$map,
						$author$project$Types$Station$evaluate(stations),
						ruleList));
			default:
				var ruleList = stationRules.a;
				return A3(
					$elm$core$List$foldl,
					$elm$core$Basics$and,
					true,
					A2(
						$elm$core$List$map,
						$author$project$Types$Station$evaluate(stations),
						ruleList));
		}
	});
var $author$project$Actions$Station$getTitleFromOrder = F2(
	function (station, iteration) {
		var _v0 = station.g4;
		if (!_v0.$) {
			var stepId = _v0.a;
			var stepIdWithIndex = _Utils_ap(
				stepId,
				$elm$core$String$fromInt(iteration));
			var stepTypeToString = function (step) {
				var _v1 = A3($author$project$Types$Step$getStepType, stepIdWithIndex, step.eF, station.A);
				_v1$2:
				while (true) {
					switch (_v1.$) {
						case 4:
							if (!_v1.a.$) {
								var model = _v1.a.a;
								return model;
							} else {
								break _v1$2;
							}
						case 5:
							if (!_v1.a.$) {
								var model = _v1.a.a;
								return $elm$core$String$fromInt(model);
							} else {
								break _v1$2;
							}
						default:
							break _v1$2;
					}
				}
				return '';
			};
			return A2(
				$elm$core$Maybe$withDefault,
				'',
				A2(
					$elm$core$Maybe$map,
					stepTypeToString,
					$elm$core$List$head(
						A2(
							$elm$core$List$filter,
							A2(
								$elm$core$Basics$composeR,
								function ($) {
									return $.bD;
								},
								$elm$core$Basics$eq(stepId)),
							station.eE))));
		} else {
			return '';
		}
	});
var $author$project$TW$Utilities$grid = A2($rtfeldman$elm_css$Css$property, 'display', 'grid');
var $author$project$TW$Utilities$grid_cols_3 = A2($rtfeldman$elm_css$Css$property, 'grid-template-columns', 'repeat(3, minmax(0, 1fr))');
var $rtfeldman$elm_css$Html$Styled$a = $rtfeldman$elm_css$Html$Styled$node('a');
var $elm$virtual_dom$VirtualDom$Custom = function (a) {
	return {$: 3, a: a};
};
var $rtfeldman$elm_css$Html$Styled$Events$custom = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$Custom(decoder));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$href = function (url) {
	return A2($rtfeldman$elm_css$Html$Styled$Attributes$stringProperty, 'href', url);
};
var $author$project$Ui$UiComponents$Link$link = F3(
	function (target, attributes, children) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$a,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$href(target),
						A2(
						$rtfeldman$elm_css$Html$Styled$Events$custom,
						'click',
						$elm$json$Json$Decode$succeed(
							{
								dM: $author$project$Msg$PortMsg_(
									$author$project$Msg$JsMsg_(
										$author$project$Msg$JsInternalNav(target))),
								dZ: true,
								eG: true
							}))
					]),
				attributes),
			children);
	});
var $author$project$TW$Utilities$mb_3 = $rtfeldman$elm_css$Css$marginBottom(
	$rtfeldman$elm_css$Css$rem(0.75));
var $rtfeldman$elm_css$Css$marginLeft = $rtfeldman$elm_css$Css$prop1('margin-left');
var $author$project$TW$Utilities$ml_3 = $rtfeldman$elm_css$Css$marginLeft(
	$rtfeldman$elm_css$Css$rem(0.75));
var $rtfeldman$elm_css$Css$marginRight = $rtfeldman$elm_css$Css$prop1('margin-right');
var $author$project$TW$Utilities$mr_1 = $rtfeldman$elm_css$Css$marginRight(
	$rtfeldman$elm_css$Css$rem(0.25));
var $author$project$TW$Utilities$pl_2 = $rtfeldman$elm_css$Css$paddingLeft(
	$rtfeldman$elm_css$Css$rem(0.5));
var $rtfeldman$elm_css$Html$Styled$section = $rtfeldman$elm_css$Html$Styled$node('section');
var $rtfeldman$elm_css$Html$Styled$h3 = $rtfeldman$elm_css$Html$Styled$node('h3');
var $author$project$TW$Utilities$opacity_75 = $rtfeldman$elm_css$Css$opacity(
	$rtfeldman$elm_css$Css$num(0.75));
var $rtfeldman$elm_css$Css$fontSize = $rtfeldman$elm_css$Css$prop1('font-size');
var $author$project$TW$Utilities$text_base = $rtfeldman$elm_css$Css$fontSize(
	$rtfeldman$elm_css$Css$rem(1));
var $author$project$TW$Utilities$text_gray_700 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--text-opacity', '1'),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('#4a5568')),
			A2($rtfeldman$elm_css$Css$property, 'color', 'rgba(74, 85, 104, var(--text-opacity))')
		]));
var $author$project$Ui$UiComponents$Text$sectionHeadline = F2(
	function (attr, children) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$h3,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[$author$project$TW$Utilities$text_base, $author$project$TW$Utilities$text_gray_700, $author$project$TW$Utilities$opacity_75]))
					]),
				attr),
			children);
	});
var $rtfeldman$elm_css$Html$Styled$span = $rtfeldman$elm_css$Html$Styled$node('span');
var $rtfeldman$elm_css$Css$listStyleType = $rtfeldman$elm_css$Css$prop1('list-style-type');
var $rtfeldman$elm_css$Css$none = {aE: 0, c_: 0, H: 0, e: 0, q: 0, fD: 0, dx: 0, cj: 0, aQ: 0, av: 0, ac: 0, h: 0, f: 0, co: 0, bN: 0, gz: 0, U: 0, bR: 0, gM: 0, aW: 0, aC: 0, N: 0, n: 0, hb: 0, cO: 'none'};
var $author$project$TW$Utilities$list_none = $rtfeldman$elm_css$Css$listStyleType($rtfeldman$elm_css$Css$none);
var $rtfeldman$elm_css$Css$margin = $rtfeldman$elm_css$Css$prop1('margin');
var $author$project$TW$Utilities$m_0 = $rtfeldman$elm_css$Css$margin(
	$rtfeldman$elm_css$Css$px(0));
var $author$project$TW$Utilities$p_0 = $rtfeldman$elm_css$Css$padding(
	$rtfeldman$elm_css$Css$px(0));
var $rtfeldman$elm_css$Css$pointerEvents = $rtfeldman$elm_css$Css$prop1('pointer-events');
var $author$project$TW$Utilities$pointer_events_none = $rtfeldman$elm_css$Css$pointerEvents($rtfeldman$elm_css$Css$none);
var $author$project$Msg$ArticleHandlerInput = 0;
var $author$project$Msg$ArticleHandlerRemoval = 1;
var $author$project$Msg$AmountUpdate = $elm$core$Basics$identity;
var $author$project$Msg$StepAmountMsg = function (a) {
	return {$: 2, a: a};
};
var $rtfeldman$elm_css$Html$Styled$Attributes$for = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('htmlFor');
var $rtfeldman$elm_css$Html$Styled$Attributes$id = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('id');
var $rtfeldman$elm_css$Css$block = {q: 0, cO: 'block'};
var $author$project$TW$Utilities$block = $rtfeldman$elm_css$Css$display($rtfeldman$elm_css$Css$block);
var $rtfeldman$elm_css$Html$Styled$input = $rtfeldman$elm_css$Html$Styled$node('input');
var $author$project$TW$Utilities$mt_1 = $rtfeldman$elm_css$Css$marginTop(
	$rtfeldman$elm_css$Css$rem(0.25));
var $author$project$TW$Utilities$p_2 = $rtfeldman$elm_css$Css$padding(
	$rtfeldman$elm_css$Css$rem(0.5));
var $rtfeldman$elm_css$Css$PercentageUnits = 0;
var $rtfeldman$elm_css$Css$pct = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, '%');
var $rtfeldman$elm_css$Css$width = $rtfeldman$elm_css$Css$prop1('width');
var $author$project$TW$Utilities$w_full = $rtfeldman$elm_css$Css$width(
	$rtfeldman$elm_css$Css$pct(100));
var $author$project$Ui$UiComponents$Form$input = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$input,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[$author$project$TW$Utilities$w_full, $author$project$TW$Utilities$p_2, $author$project$TW$Utilities$rounded, $author$project$TW$Utilities$border, $author$project$TW$Utilities$border_gray_300, $author$project$TW$Utilities$border_solid, $author$project$TW$Utilities$block, $author$project$TW$Utilities$mt_1, $author$project$TW$Utilities$mb_3, $author$project$TW$Utilities$bg_white]))
					]),
				attributes),
			children);
	});
var $rtfeldman$elm_css$Html$Styled$Events$alwaysStop = function (x) {
	return _Utils_Tuple2(x, true);
};
var $elm$virtual_dom$VirtualDom$MayStopPropagation = function (a) {
	return {$: 1, a: a};
};
var $rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn = F2(
	function (event, decoder) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$on,
			event,
			$elm$virtual_dom$VirtualDom$MayStopPropagation(decoder));
	});
var $rtfeldman$elm_css$Html$Styled$Events$targetValue = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'value']),
	$elm$json$Json$Decode$string);
var $rtfeldman$elm_css$Html$Styled$Events$onInput = function (tagger) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$stopPropagationOn,
		'input',
		A2(
			$elm$json$Json$Decode$map,
			$rtfeldman$elm_css$Html$Styled$Events$alwaysStop,
			A2($elm$json$Json$Decode$map, tagger, $rtfeldman$elm_css$Html$Styled$Events$targetValue)));
};
var $rtfeldman$elm_css$Html$Styled$Attributes$class = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('className');
var $rtfeldman$elm_css$Css$Structure$Child = 2;
var $rtfeldman$elm_css$Css$Preprocess$NestSnippet = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Global$children = $rtfeldman$elm_css$Css$Preprocess$NestSnippet(2);
var $rtfeldman$elm_css$Css$Global$class = F2(
	function (str, styles) {
		return A2(
			$rtfeldman$elm_css$VirtualDom$Styled$makeSnippet,
			styles,
			$rtfeldman$elm_css$Css$Structure$UniversalSelectorSequence(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Css$Structure$ClassSelector(str)
					])));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$Unstyled = function (a) {
	return {$: 4, a: a};
};
var $rtfeldman$elm_css$VirtualDom$Styled$unstyledNode = $rtfeldman$elm_css$VirtualDom$Styled$Unstyled;
var $rtfeldman$elm_css$Css$Global$global = function (snippets) {
	return $rtfeldman$elm_css$VirtualDom$Styled$unstyledNode(
		A3(
			$elm$virtual_dom$VirtualDom$node,
			'style',
			_List_Nil,
			$elm$core$List$singleton(
				$elm$virtual_dom$VirtualDom$text(
					$rtfeldman$elm_css$Css$Preprocess$Resolve$compile(
						$elm$core$List$singleton(
							$rtfeldman$elm_css$Css$Preprocess$stylesheet(snippets)))))));
};
var $rtfeldman$elm_css$Css$Preprocess$ExtendSelector = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $rtfeldman$elm_css$Css$Structure$PseudoClassSelector = function (a) {
	return {$: 2, a: a};
};
var $rtfeldman$elm_css$Css$pseudoClass = function (_class) {
	return $rtfeldman$elm_css$Css$Preprocess$ExtendSelector(
		$rtfeldman$elm_css$Css$Structure$PseudoClassSelector(_class));
};
var $rtfeldman$elm_css$Css$lastChild = $rtfeldman$elm_css$Css$pseudoClass('last-child');
var $rtfeldman$elm_css$Css$Structure$TypeSelector = $elm$core$Basics$identity;
var $rtfeldman$elm_css$Css$Global$typeSelector = F2(
	function (selectorStr, styles) {
		var sequence = A2($rtfeldman$elm_css$Css$Structure$TypeSelectorSequence, selectorStr, _List_Nil);
		var sel = A3($rtfeldman$elm_css$Css$Structure$Selector, sequence, _List_Nil, $elm$core$Maybe$Nothing);
		return _List_fromArray(
			[
				$rtfeldman$elm_css$Css$Preprocess$StyleBlockDeclaration(
				A3($rtfeldman$elm_css$Css$Preprocess$StyleBlock, sel, _List_Nil, styles))
			]);
	});
var $author$project$Ui$UiComponents$StepHelper$removeLastElementMargin = $rtfeldman$elm_css$Css$Global$global(
	_List_fromArray(
		[
			A2(
			$rtfeldman$elm_css$Css$Global$class,
			'markdown-field',
			_List_fromArray(
				[
					$rtfeldman$elm_css$Css$Global$children(
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Css$Global$typeSelector,
							'*',
							_List_fromArray(
								[
									$rtfeldman$elm_css$Css$lastChild(
									_List_fromArray(
										[
											$rtfeldman$elm_css$Css$margin(
											$rtfeldman$elm_css$Css$px(0))
										]))
								]))
						]))
				]))
		]));
var $elm$core$Result$andThen = F2(
	function (callback, result) {
		if (!result.$) {
			var value = result.a;
			return callback(value);
		} else {
			var msg = result.a;
			return $elm$core$Result$Err(msg);
		}
	});
var $elm$html$Html$a = _VirtualDom_node('a');
var $elm$html$Html$Attributes$stringProperty = F2(
	function (key, string) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$string(string));
	});
var $elm$html$Html$Attributes$align = $elm$html$Html$Attributes$stringProperty('align');
var $elm$html$Html$Attributes$alt = $elm$html$Html$Attributes$stringProperty('alt');
var $elm$html$Html$blockquote = _VirtualDom_node('blockquote');
var $elm$html$Html$br = _VirtualDom_node('br');
var $elm$html$Html$Attributes$boolProperty = F2(
	function (key, bool) {
		return A2(
			_VirtualDom_property,
			key,
			$elm$json$Json$Encode$bool(bool));
	});
var $elm$html$Html$Attributes$checked = $elm$html$Html$Attributes$boolProperty('checked');
var $elm$html$Html$Attributes$class = $elm$html$Html$Attributes$stringProperty('className');
var $elm$html$Html$code = _VirtualDom_node('code');
var $elm$html$Html$del = _VirtualDom_node('del');
var $elm$html$Html$Attributes$disabled = $elm$html$Html$Attributes$boolProperty('disabled');
var $elm$html$Html$em = _VirtualDom_node('em');
var $elm$html$Html$h1 = _VirtualDom_node('h1');
var $elm$html$Html$h2 = _VirtualDom_node('h2');
var $elm$html$Html$h3 = _VirtualDom_node('h3');
var $elm$html$Html$h4 = _VirtualDom_node('h4');
var $elm$html$Html$h5 = _VirtualDom_node('h5');
var $elm$html$Html$h6 = _VirtualDom_node('h6');
var $elm$html$Html$hr = _VirtualDom_node('hr');
var $elm$html$Html$Attributes$href = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'href',
		_VirtualDom_noJavaScriptUri(url));
};
var $elm$html$Html$img = _VirtualDom_node('img');
var $elm$html$Html$input = _VirtualDom_node('input');
var $elm$html$Html$li = _VirtualDom_node('li');
var $elm$html$Html$ol = _VirtualDom_node('ol');
var $dillonkearns$elm_markdown$Markdown$HtmlRenderer$HtmlRenderer = $elm$core$Basics$identity;
var $dillonkearns$elm_markdown$Markdown$Html$resultOr = F2(
	function (ra, rb) {
		if (ra.$ === 1) {
			var singleError = ra.a;
			if (!rb.$) {
				var okValue = rb.a;
				return $elm$core$Result$Ok(okValue);
			} else {
				var errorsSoFar = rb.a;
				return $elm$core$Result$Err(
					A2($elm$core$List$cons, singleError, errorsSoFar));
			}
		} else {
			var okValue = ra.a;
			return $elm$core$Result$Ok(okValue);
		}
	});
var $dillonkearns$elm_markdown$Markdown$Html$attributesToString = function (attributes) {
	return A2(
		$elm$core$String$join,
		' ',
		A2(
			$elm$core$List$map,
			function (_v0) {
				var name = _v0.dP;
				var value = _v0.cO;
				return name + ('=\"' + (value + '\"'));
			},
			attributes));
};
var $dillonkearns$elm_markdown$Markdown$Html$tagToString = F2(
	function (tagName, attributes) {
		return $elm$core$List$isEmpty(attributes) ? ('<' + (tagName + '>')) : ('<' + (tagName + (' ' + ($dillonkearns$elm_markdown$Markdown$Html$attributesToString(attributes) + '>'))));
	});
var $dillonkearns$elm_markdown$Markdown$Html$oneOf = function (decoders) {
	var unwrappedDecoders = A2(
		$elm$core$List$map,
		function (_v1) {
			var rawDecoder = _v1;
			return rawDecoder;
		},
		decoders);
	return function (rawDecoder) {
		return F3(
			function (tagName, attributes, innerBlocks) {
				return A2(
					$elm$core$Result$mapError,
					function (errors) {
						if (!errors.b) {
							return 'Ran into a oneOf with no possibilities!';
						} else {
							if (!errors.b.b) {
								var singleError = errors.a;
								return 'Problem with the given value:\n\n' + (A2($dillonkearns$elm_markdown$Markdown$Html$tagToString, tagName, attributes) + ('\n\n' + (singleError + '\n')));
							} else {
								return 'oneOf failed parsing this value:\n    ' + (A2($dillonkearns$elm_markdown$Markdown$Html$tagToString, tagName, attributes) + ('\n\nParsing failed in the following 2 ways:\n\n\n' + (A2(
									$elm$core$String$join,
									'\n\n',
									A2(
										$elm$core$List$indexedMap,
										F2(
											function (index, error) {
												return '(' + ($elm$core$String$fromInt(index + 1) + (') ' + error));
											}),
										errors)) + '\n')));
							}
						}
					},
					A3(rawDecoder, tagName, attributes, innerBlocks));
			});
	}(
		A3(
			$elm$core$List$foldl,
			F2(
				function (decoder, soFar) {
					return F3(
						function (tagName, attributes, children) {
							return A2(
								$dillonkearns$elm_markdown$Markdown$Html$resultOr,
								A3(decoder, tagName, attributes, children),
								A3(soFar, tagName, attributes, children));
						});
				}),
			F3(
				function (tagName, attributes, children) {
					return $elm$core$Result$Err(_List_Nil);
				}),
			unwrappedDecoders));
};
var $elm$html$Html$p = _VirtualDom_node('p');
var $elm$html$Html$pre = _VirtualDom_node('pre');
var $elm$html$Html$Attributes$src = function (url) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'src',
		_VirtualDom_noJavaScriptOrHtmlUri(url));
};
var $elm$html$Html$Attributes$start = function (n) {
	return A2(
		$elm$html$Html$Attributes$stringProperty,
		'start',
		$elm$core$String$fromInt(n));
};
var $elm$html$Html$strong = _VirtualDom_node('strong');
var $elm$html$Html$table = _VirtualDom_node('table');
var $elm$html$Html$tbody = _VirtualDom_node('tbody');
var $elm$html$Html$td = _VirtualDom_node('td');
var $elm$html$Html$text = $elm$virtual_dom$VirtualDom$text;
var $elm$html$Html$th = _VirtualDom_node('th');
var $elm$html$Html$thead = _VirtualDom_node('thead');
var $elm$html$Html$Attributes$title = $elm$html$Html$Attributes$stringProperty('title');
var $elm$html$Html$tr = _VirtualDom_node('tr');
var $elm$html$Html$Attributes$type_ = $elm$html$Html$Attributes$stringProperty('type');
var $elm$html$Html$ul = _VirtualDom_node('ul');
var $elm$core$String$words = _String_words;
var $dillonkearns$elm_markdown$Markdown$Renderer$defaultHtmlRenderer = {
	b5: $elm$html$Html$blockquote(_List_Nil),
	b6: function (_v0) {
		var body = _v0.e6;
		var language = _v0.ck;
		var classes = function () {
			var _v1 = A2($elm$core$Maybe$map, $elm$core$String$words, language);
			if ((!_v1.$) && _v1.a.b) {
				var _v2 = _v1.a;
				var actualLanguage = _v2.a;
				return _List_fromArray(
					[
						$elm$html$Html$Attributes$class('language-' + actualLanguage)
					]);
			} else {
				return _List_Nil;
			}
		}();
		return A2(
			$elm$html$Html$pre,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$elm$html$Html$code,
					classes,
					_List_fromArray(
						[
							$elm$html$Html$text(body)
						]))
				]));
	},
	b7: function (content) {
		return A2(
			$elm$html$Html$code,
			_List_Nil,
			_List_fromArray(
				[
					$elm$html$Html$text(content)
				]));
	},
	ca: function (children) {
		return A2($elm$html$Html$em, _List_Nil, children);
	},
	cf: A2($elm$html$Html$br, _List_Nil, _List_Nil),
	cg: function (_v3) {
		var level = _v3.dG;
		var children = _v3.c5;
		switch (level) {
			case 0:
				return A2($elm$html$Html$h1, _List_Nil, children);
			case 1:
				return A2($elm$html$Html$h2, _List_Nil, children);
			case 2:
				return A2($elm$html$Html$h3, _List_Nil, children);
			case 3:
				return A2($elm$html$Html$h4, _List_Nil, children);
			case 4:
				return A2($elm$html$Html$h5, _List_Nil, children);
			default:
				return A2($elm$html$Html$h6, _List_Nil, children);
		}
	},
	ch: $dillonkearns$elm_markdown$Markdown$Html$oneOf(_List_Nil),
	dt: function (imageInfo) {
		var _v5 = imageInfo.g4;
		if (!_v5.$) {
			var title = _v5.a;
			return A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src(imageInfo.cB),
						$elm$html$Html$Attributes$alt(imageInfo.b3),
						$elm$html$Html$Attributes$title(title)
					]),
				_List_Nil);
		} else {
			return A2(
				$elm$html$Html$img,
				_List_fromArray(
					[
						$elm$html$Html$Attributes$src(imageInfo.cB),
						$elm$html$Html$Attributes$alt(imageInfo.b3)
					]),
				_List_Nil);
		}
	},
	fX: F2(
		function (link, content) {
			var _v6 = link.g4;
			if (!_v6.$) {
				var title = _v6.a;
				return A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(link.dc),
							$elm$html$Html$Attributes$title(title)
						]),
					content);
			} else {
				return A2(
					$elm$html$Html$a,
					_List_fromArray(
						[
							$elm$html$Html$Attributes$href(link.dc)
						]),
					content);
			}
		}),
	cs: F2(
		function (startingIndex, items) {
			return A2(
				$elm$html$Html$ol,
				function () {
					if (startingIndex === 1) {
						return _List_fromArray(
							[
								$elm$html$Html$Attributes$start(startingIndex)
							]);
					} else {
						return _List_Nil;
					}
				}(),
				A2(
					$elm$core$List$map,
					function (itemBlocks) {
						return A2($elm$html$Html$li, _List_Nil, itemBlocks);
					},
					items));
		}),
	cu: $elm$html$Html$p(_List_Nil),
	cC: function (children) {
		return A2($elm$html$Html$del, _List_Nil, children);
	},
	cD: function (children) {
		return A2($elm$html$Html$strong, _List_Nil, children);
	},
	cF: $elm$html$Html$table(_List_Nil),
	cG: $elm$html$Html$tbody(_List_Nil),
	cH: function (maybeAlignment) {
		var attrs = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				A2(
					$elm$core$Maybe$map,
					$elm$html$Html$Attributes$align,
					A2(
						$elm$core$Maybe$map,
						function (alignment) {
							switch (alignment) {
								case 0:
									return 'left';
								case 2:
									return 'center';
								default:
									return 'right';
							}
						},
						maybeAlignment))));
		return $elm$html$Html$td(attrs);
	},
	cI: $elm$html$Html$thead(_List_Nil),
	cJ: function (maybeAlignment) {
		var attrs = A2(
			$elm$core$Maybe$withDefault,
			_List_Nil,
			A2(
				$elm$core$Maybe$map,
				$elm$core$List$singleton,
				A2(
					$elm$core$Maybe$map,
					$elm$html$Html$Attributes$align,
					A2(
						$elm$core$Maybe$map,
						function (alignment) {
							switch (alignment) {
								case 0:
									return 'left';
								case 2:
									return 'center';
								default:
									return 'right';
							}
						},
						maybeAlignment))));
		return $elm$html$Html$th(attrs);
	},
	bZ: $elm$html$Html$tr(_List_Nil),
	V: $elm$html$Html$text,
	cM: A2($elm$html$Html$hr, _List_Nil, _List_Nil),
	cN: function (items) {
		return A2(
			$elm$html$Html$ul,
			_List_Nil,
			A2(
				$elm$core$List$map,
				function (item) {
					var task = item.a;
					var children = item.b;
					var checkbox = function () {
						switch (task) {
							case 0:
								return $elm$html$Html$text('');
							case 1:
								return A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$disabled(true),
											$elm$html$Html$Attributes$checked(false),
											$elm$html$Html$Attributes$type_('checkbox')
										]),
									_List_Nil);
							default:
								return A2(
									$elm$html$Html$input,
									_List_fromArray(
										[
											$elm$html$Html$Attributes$disabled(true),
											$elm$html$Html$Attributes$checked(true),
											$elm$html$Html$Attributes$type_('checkbox')
										]),
									_List_Nil);
						}
					}();
					return A2(
						$elm$html$Html$li,
						_List_Nil,
						A2($elm$core$List$cons, checkbox, children));
				},
				items));
	}
};
var $elm$html$Html$Attributes$target = $elm$html$Html$Attributes$stringProperty('target');
var $author$project$Ui$UiComponents$StepHelper$customHtmlRenderer = function () {
	var r = $dillonkearns$elm_markdown$Markdown$Renderer$defaultHtmlRenderer;
	return _Utils_update(
		r,
		{
			fX: F2(
				function (link, content) {
					var _v0 = link.g4;
					if (!_v0.$) {
						var title = _v0.a;
						return A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(link.dc),
									$elm$html$Html$Attributes$title(title),
									$elm$html$Html$Attributes$target('blank_')
								]),
							content);
					} else {
						return A2(
							$elm$html$Html$a,
							_List_fromArray(
								[
									$elm$html$Html$Attributes$href(link.dc),
									$elm$html$Html$Attributes$target('blank_')
								]),
							content);
					}
				})
		});
}();
var $dillonkearns$elm_markdown$Markdown$Parser$problemToString = function (problem) {
	switch (problem.$) {
		case 0:
			var string = problem.a;
			return 'Expecting ' + string;
		case 1:
			return 'Expecting int';
		case 2:
			return 'Expecting hex';
		case 3:
			return 'Expecting octal';
		case 4:
			return 'Expecting binary';
		case 5:
			return 'Expecting float';
		case 6:
			return 'Expecting number';
		case 7:
			return 'Expecting variable';
		case 8:
			var string = problem.a;
			return 'Expecting symbol ' + string;
		case 9:
			var string = problem.a;
			return 'Expecting keyword ' + string;
		case 10:
			return 'Expecting keyword end';
		case 11:
			return 'Unexpected char';
		case 12:
			var problemDescription = problem.a;
			return problemDescription;
		default:
			return 'Bad repeat';
	}
};
var $dillonkearns$elm_markdown$Markdown$Parser$deadEndToString = function (deadEnd) {
	return 'Problem at row ' + ($elm$core$String$fromInt(deadEnd.gL) + ('\n' + $dillonkearns$elm_markdown$Markdown$Parser$problemToString(deadEnd.gA)));
};
var $author$project$Ui$UiComponents$StepHelper$deadEndsToString = function (deadEnds) {
	return A2(
		$elm$core$String$join,
		'\n',
		A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$deadEndToString, deadEnds));
};
var $rtfeldman$elm_css$Html$Styled$fromUnstyled = $rtfeldman$elm_css$VirtualDom$Styled$unstyledNode;
var $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine = {$: 10};
var $dillonkearns$elm_markdown$Markdown$Block$BlockQuote = function (a) {
	return {$: 3, a: a};
};
var $dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote = function (a) {
	return {$: 11, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Cdata = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$CodeBlock = function (a) {
	return {$: 7, a: a};
};
var $dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$CodeSpan = function (a) {
	return {$: 6, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$CompletedTask = 2;
var $elm$parser$Parser$Advanced$Done = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Emphasis = function (a) {
	return {$: 3, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Inline$Emphasis = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Parser$EmptyBlock = {$: 0};
var $elm$parser$Parser$Expecting = function (a) {
	return {$: 0, a: a};
};
var $elm$parser$Parser$ExpectingSymbol = function (a) {
	return {$: 8, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$HardLineBreak = {$: 8};
var $dillonkearns$elm_markdown$Markdown$Block$Heading = F2(
	function (a, b) {
		return {$: 4, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$Heading = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$Html = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$HtmlBlock = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$HtmlComment = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration = F2(
	function (a, b) {
		return {$: 3, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Block$HtmlElement = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Block$HtmlInline = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Image = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Block$IncompleteTask = 1;
var $dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock = function (a) {
	return {$: 6, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Parser$InlineProblem = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Link = F3(
	function (a, b, c) {
		return {$: 1, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Block$ListItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Loop = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$NoTask = 0;
var $dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$OrderedList = F3(
	function (a, b, c) {
		return {$: 2, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock = F6(
	function (a, b, c, d, e, f) {
		return {$: 4, a: a, b: b, c: c, d: d, e: e, f: f};
	});
var $dillonkearns$elm_markdown$Markdown$Block$Paragraph = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote = function (a) {
	return {$: 12, a: a};
};
var $elm$parser$Parser$Problem = function (a) {
	return {$: 12, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Strikethrough = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Strong = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$Table = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$Table = function (a) {
	return {$: 8, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Table$Table = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Table$TableDelimiterRow = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Block$Text = function (a) {
	return {$: 7, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Block$ThematicBreak = {$: 8};
var $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak = {$: 7};
var $elm$parser$Parser$Advanced$Token = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$Block$UnorderedList = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock = F4(
	function (a, b, c, d) {
		return {$: 3, a: a, b: b, c: c, d: d};
	});
var $dillonkearns$elm_markdown$Markdown$RawBlock$UnparsedInlines = $elm$core$Basics$identity;
var $dillonkearns$elm_markdown$Markdown$Parser$addReference = F2(
	function (state, linkRef) {
		return {
			a: A2($elm$core$List$cons, linkRef, state.a),
			b: state.b
		};
	});
var $elm$parser$Parser$Advanced$Bad = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$Good = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $elm$parser$Parser$Advanced$Parser = $elm$core$Basics$identity;
var $elm$parser$Parser$Advanced$andThen = F2(
	function (callback, _v0) {
		var parseA = _v0;
		return function (s0) {
			var _v1 = parseA(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				var _v2 = callback(a);
				var parseB = _v2;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3($elm$parser$Parser$Advanced$Good, p1 || p2, b, s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$backtrackable = function (_v0) {
	var parse = _v0;
	return function (s0) {
		var _v1 = parse(s0);
		if (_v1.$ === 1) {
			var x = _v1.b;
			return A2($elm$parser$Parser$Advanced$Bad, false, x);
		} else {
			var a = _v1.b;
			var s1 = _v1.c;
			return A3($elm$parser$Parser$Advanced$Good, false, a, s1);
		}
	};
};
var $elm$parser$Parser$Advanced$isSubChar = _Parser_isSubChar;
var $elm$parser$Parser$Advanced$chompWhileHelp = F5(
	function (isGood, offset, row, col, s0) {
		chompWhileHelp:
		while (true) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, offset, s0.cB);
			if (_Utils_eq(newOffset, -1)) {
				return A3(
					$elm$parser$Parser$Advanced$Good,
					_Utils_cmp(s0.d, offset) < 0,
					0,
					{c6: col, i: s0.i, k: s0.k, d: offset, gL: row, cB: s0.cB});
			} else {
				if (_Utils_eq(newOffset, -2)) {
					var $temp$isGood = isGood,
						$temp$offset = offset + 1,
						$temp$row = row + 1,
						$temp$col = 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				} else {
					var $temp$isGood = isGood,
						$temp$offset = newOffset,
						$temp$row = row,
						$temp$col = col + 1,
						$temp$s0 = s0;
					isGood = $temp$isGood;
					offset = $temp$offset;
					row = $temp$row;
					col = $temp$col;
					s0 = $temp$s0;
					continue chompWhileHelp;
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$chompWhile = function (isGood) {
	return function (s) {
		return A5($elm$parser$Parser$Advanced$chompWhileHelp, isGood, s.d, s.gL, s.c6, s);
	};
};
var $elm$parser$Parser$Advanced$map2 = F3(
	function (func, _v0, _v1) {
		var parseA = _v0;
		var parseB = _v1;
		return function (s0) {
			var _v2 = parseA(s0);
			if (_v2.$ === 1) {
				var p = _v2.a;
				var x = _v2.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p1 = _v2.a;
				var a = _v2.b;
				var s1 = _v2.c;
				var _v3 = parseB(s1);
				if (_v3.$ === 1) {
					var p2 = _v3.a;
					var x = _v3.b;
					return A2($elm$parser$Parser$Advanced$Bad, p1 || p2, x);
				} else {
					var p2 = _v3.a;
					var b = _v3.b;
					var s2 = _v3.c;
					return A3(
						$elm$parser$Parser$Advanced$Good,
						p1 || p2,
						A2(func, a, b),
						s2);
				}
			}
		};
	});
var $elm$parser$Parser$Advanced$ignorer = F2(
	function (keepParser, ignoreParser) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$always, keepParser, ignoreParser);
	});
var $dillonkearns$elm_markdown$Whitespace$isSpaceOrTab = function (_char) {
	switch (_char) {
		case ' ':
			return true;
		case '\t':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Parser$Token$carriageReturn = A2(
	$elm$parser$Parser$Advanced$Token,
	'\r',
	$elm$parser$Parser$Expecting('a carriage return'));
var $dillonkearns$elm_markdown$Parser$Token$newline = A2(
	$elm$parser$Parser$Advanced$Token,
	'\n',
	$elm$parser$Parser$Expecting('a newline'));
var $elm$parser$Parser$Advanced$Empty = {$: 0};
var $elm$parser$Parser$Advanced$Append = F2(
	function (a, b) {
		return {$: 2, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$oneOfHelp = F3(
	function (s0, bag, parsers) {
		oneOfHelp:
		while (true) {
			if (!parsers.b) {
				return A2($elm$parser$Parser$Advanced$Bad, false, bag);
			} else {
				var parse = parsers.a;
				var remainingParsers = parsers.b;
				var _v1 = parse(s0);
				if (!_v1.$) {
					var step = _v1;
					return step;
				} else {
					var step = _v1;
					var p = step.a;
					var x = step.b;
					if (p) {
						return step;
					} else {
						var $temp$s0 = s0,
							$temp$bag = A2($elm$parser$Parser$Advanced$Append, bag, x),
							$temp$parsers = remainingParsers;
						s0 = $temp$s0;
						bag = $temp$bag;
						parsers = $temp$parsers;
						continue oneOfHelp;
					}
				}
			}
		}
	});
var $elm$parser$Parser$Advanced$oneOf = function (parsers) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$oneOfHelp, s, $elm$parser$Parser$Advanced$Empty, parsers);
	};
};
var $elm$parser$Parser$Advanced$succeed = function (a) {
	return function (s) {
		return A3($elm$parser$Parser$Advanced$Good, false, a, s);
	};
};
var $elm$parser$Parser$Advanced$AddRight = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $elm$parser$Parser$Advanced$DeadEnd = F4(
	function (row, col, problem, contextStack) {
		return {c6: col, fd: contextStack, gA: problem, gL: row};
	});
var $elm$parser$Parser$Advanced$fromState = F2(
	function (s, x) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, s.gL, s.c6, x, s.i));
	});
var $elm$parser$Parser$Advanced$isSubString = _Parser_isSubString;
var $elm$parser$Parser$Advanced$token = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	var progress = !$elm$core$String$isEmpty(str);
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$isSubString, str, s.d, s.gL, s.c6, s.cB);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : A3(
			$elm$parser$Parser$Advanced$Good,
			progress,
			0,
			{c6: newCol, i: s.i, k: s.k, d: newOffset, gL: newRow, cB: s.cB});
	};
};
var $dillonkearns$elm_markdown$Whitespace$lineEnd = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			$elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$newline),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$carriageReturn),
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$newline),
						$elm$parser$Parser$Advanced$succeed(0)
					])))
		]));
var $elm$parser$Parser$Advanced$map = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					func(a),
					s1);
			} else {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			}
		};
	});
var $dillonkearns$elm_markdown$Markdown$Parser$blankLine = A2(
	$elm$parser$Parser$Advanced$map,
	function (_v0) {
		return $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine;
	},
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$backtrackable(
			$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
		$dillonkearns$elm_markdown$Whitespace$lineEnd));
var $dillonkearns$elm_markdown$Parser$Token$space = A2(
	$elm$parser$Parser$Advanced$Token,
	' ',
	$elm$parser$Parser$Expecting('a space'));
var $elm$parser$Parser$Advanced$symbol = $elm$parser$Parser$Advanced$token;
var $dillonkearns$elm_markdown$Markdown$Parser$blockQuoteStarts = _List_fromArray(
	[
		$elm$parser$Parser$Advanced$symbol(
		A2(
			$elm$parser$Parser$Advanced$Token,
			'>',
			$elm$parser$Parser$Expecting('>'))),
		A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$backtrackable(
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space)),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						'>',
						$elm$parser$Parser$Expecting(' >'))),
					$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						' >',
						$elm$parser$Parser$Expecting('  >'))),
					$elm$parser$Parser$Advanced$symbol(
					A2(
						$elm$parser$Parser$Advanced$Token,
						'  >',
						$elm$parser$Parser$Expecting('   >')))
				])))
	]);
var $dillonkearns$elm_markdown$Whitespace$isLineEnd = function (_char) {
	switch (_char) {
		case '\n':
			return true;
		case '\r':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd = $elm$parser$Parser$Advanced$chompWhile(
	A2($elm$core$Basics$composeL, $elm$core$Basics$not, $dillonkearns$elm_markdown$Whitespace$isLineEnd));
var $elm$parser$Parser$Advanced$mapChompedString = F2(
	function (func, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(s0);
			if (_v1.$ === 1) {
				var p = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p, x);
			} else {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					A2(
						func,
						A3($elm$core$String$slice, s0.d, s1.d, s0.cB),
						a),
					s1);
			}
		};
	});
var $elm$parser$Parser$Advanced$getChompedString = function (parser) {
	return A2($elm$parser$Parser$Advanced$mapChompedString, $elm$core$Basics$always, parser);
};
var $elm$parser$Parser$Advanced$keeper = F2(
	function (parseFunc, parseArg) {
		return A3($elm$parser$Parser$Advanced$map2, $elm$core$Basics$apL, parseFunc, parseArg);
	});
var $elm$parser$Parser$Advanced$end = function (x) {
	return function (s) {
		return _Utils_eq(
			$elm$core$String$length(s.cB),
			s.d) ? A3($elm$parser$Parser$Advanced$Good, false, 0, s) : A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $dillonkearns$elm_markdown$Helpers$endOfFile = $elm$parser$Parser$Advanced$end(
	$elm$parser$Parser$Expecting('the end of the input'));
var $dillonkearns$elm_markdown$Helpers$lineEndOrEnd = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[$dillonkearns$elm_markdown$Whitespace$lineEnd, $dillonkearns$elm_markdown$Helpers$endOfFile]));
var $dillonkearns$elm_markdown$Markdown$Parser$blockQuote = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote),
			$elm$parser$Parser$Advanced$oneOf($dillonkearns$elm_markdown$Markdown$Parser$blockQuoteStarts)),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space),
					$elm$parser$Parser$Advanced$succeed(0)
				]))),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString = function (deadEnds) {
	return A2(
		$elm$core$String$join,
		'\n',
		A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$deadEndToString, deadEnds));
};
var $dillonkearns$elm_markdown$HtmlParser$Cdata = function (a) {
	return {$: 3, a: a};
};
var $dillonkearns$elm_markdown$HtmlParser$Element = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$HtmlParser$Text = function (a) {
	return {$: 1, a: a};
};
var $elm$parser$Parser$Advanced$chompIf = F2(
	function (isGood, expecting) {
		return function (s) {
			var newOffset = A3($elm$parser$Parser$Advanced$isSubChar, isGood, s.d, s.cB);
			return _Utils_eq(newOffset, -1) ? A2(
				$elm$parser$Parser$Advanced$Bad,
				false,
				A2($elm$parser$Parser$Advanced$fromState, s, expecting)) : (_Utils_eq(newOffset, -2) ? A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{c6: 1, i: s.i, k: s.k, d: s.d + 1, gL: s.gL + 1, cB: s.cB}) : A3(
				$elm$parser$Parser$Advanced$Good,
				true,
				0,
				{c6: s.c6 + 1, i: s.i, k: s.k, d: newOffset, gL: s.gL, cB: s.cB}));
		};
	});
var $dillonkearns$elm_markdown$HtmlParser$expectTagNameCharacter = $elm$parser$Parser$Expecting('at least 1 tag name character');
var $dillonkearns$elm_markdown$HtmlParser$tagNameCharacter = function (c) {
	switch (c) {
		case ' ':
			return false;
		case '\r':
			return false;
		case '\n':
			return false;
		case '\t':
			return false;
		case '/':
			return false;
		case '<':
			return false;
		case '>':
			return false;
		case '\"':
			return false;
		case '\'':
			return false;
		case '=':
			return false;
		default:
			return true;
	}
};
var $dillonkearns$elm_markdown$HtmlParser$tagName = A2(
	$elm$parser$Parser$Advanced$mapChompedString,
	F2(
		function (name, _v0) {
			return $elm$core$String$toLower(name);
		}),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2($elm$parser$Parser$Advanced$chompIf, $dillonkearns$elm_markdown$HtmlParser$tagNameCharacter, $dillonkearns$elm_markdown$HtmlParser$expectTagNameCharacter),
		$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$tagNameCharacter)));
var $dillonkearns$elm_markdown$HtmlParser$attributeName = $dillonkearns$elm_markdown$HtmlParser$tagName;
var $dillonkearns$elm_markdown$HtmlParser$symbol = function (str) {
	return $elm$parser$Parser$Advanced$token(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$ExpectingSymbol(str)));
};
var $elm$parser$Parser$Advanced$loopHelp = F4(
	function (p, state, callback, s0) {
		loopHelp:
		while (true) {
			var _v0 = callback(state);
			var parse = _v0;
			var _v1 = parse(s0);
			if (!_v1.$) {
				var p1 = _v1.a;
				var step = _v1.b;
				var s1 = _v1.c;
				if (!step.$) {
					var newState = step.a;
					var $temp$p = p || p1,
						$temp$state = newState,
						$temp$callback = callback,
						$temp$s0 = s1;
					p = $temp$p;
					state = $temp$state;
					callback = $temp$callback;
					s0 = $temp$s0;
					continue loopHelp;
				} else {
					var result = step.a;
					return A3($elm$parser$Parser$Advanced$Good, p || p1, result, s1);
				}
			} else {
				var p1 = _v1.a;
				var x = _v1.b;
				return A2($elm$parser$Parser$Advanced$Bad, p || p1, x);
			}
		}
	});
var $elm$parser$Parser$Advanced$loop = F2(
	function (state, callback) {
		return function (s) {
			return A4($elm$parser$Parser$Advanced$loopHelp, false, state, callback, s);
		};
	});
var $dillonkearns$elm_markdown$HtmlParser$entities = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('amp', '&'),
			_Utils_Tuple2('lt', '<'),
			_Utils_Tuple2('gt', '>'),
			_Utils_Tuple2('apos', '\''),
			_Utils_Tuple2('quot', '\"')
		]));
var $elm$core$Char$fromCode = _Char_fromCode;
var $elm$core$Result$fromMaybe = F2(
	function (err, maybe) {
		if (!maybe.$) {
			var v = maybe.a;
			return $elm$core$Result$Ok(v);
		} else {
			return $elm$core$Result$Err(err);
		}
	});
var $dillonkearns$elm_markdown$HtmlParser$decodeEscape = function (s) {
	return A2($elm$core$String$startsWith, '#x', s) ? A2(
		$elm$core$Result$mapError,
		$elm$parser$Parser$Problem,
		A2(
			$elm$core$Result$map,
			$elm$core$Char$fromCode,
			$rtfeldman$elm_hex$Hex$fromString(
				A2($elm$core$String$dropLeft, 2, s)))) : (A2($elm$core$String$startsWith, '#', s) ? A2(
		$elm$core$Result$fromMaybe,
		$elm$parser$Parser$Problem('Invalid escaped character: ' + s),
		A2(
			$elm$core$Maybe$map,
			$elm$core$Char$fromCode,
			$elm$core$String$toInt(
				A2($elm$core$String$dropLeft, 1, s)))) : A2(
		$elm$core$Result$fromMaybe,
		$elm$parser$Parser$Problem('No entity named \"&' + (s + ';\" found.')),
		A2($elm$core$Dict$get, s, $dillonkearns$elm_markdown$HtmlParser$entities)));
};
var $elm$parser$Parser$Advanced$problem = function (x) {
	return function (s) {
		return A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A2($elm$parser$Parser$Advanced$fromState, s, x));
	};
};
var $dillonkearns$elm_markdown$HtmlParser$escapedChar = function (end_) {
	var process = function (entityStr) {
		var _v0 = $dillonkearns$elm_markdown$HtmlParser$decodeEscape(entityStr);
		if (!_v0.$) {
			var c = _v0.a;
			return $elm$parser$Parser$Advanced$succeed(c);
		} else {
			var e = _v0.a;
			return $elm$parser$Parser$Advanced$problem(e);
		}
	};
	var isEntityChar = function (c) {
		return (!_Utils_eq(c, end_)) && (c !== ';');
	};
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			$dillonkearns$elm_markdown$HtmlParser$symbol('&')),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$andThen,
				process,
				$elm$parser$Parser$Advanced$getChompedString(
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$chompIf,
							isEntityChar,
							$elm$parser$Parser$Expecting('an entity character')),
						$elm$parser$Parser$Advanced$chompWhile(isEntityChar)))),
			$dillonkearns$elm_markdown$HtmlParser$symbol(';')));
};
var $dillonkearns$elm_markdown$HtmlParser$textStringStep = F3(
	function (closingChar, predicate, accum) {
		return A2(
			$elm$parser$Parser$Advanced$andThen,
			function (soFar) {
				return $elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							A2(
							$elm$parser$Parser$Advanced$map,
							function (escaped) {
								return $elm$parser$Parser$Advanced$Loop(
									_Utils_ap(
										accum,
										_Utils_ap(
											soFar,
											$elm$core$String$fromChar(escaped))));
							},
							$dillonkearns$elm_markdown$HtmlParser$escapedChar(closingChar)),
							$elm$parser$Parser$Advanced$succeed(
							$elm$parser$Parser$Advanced$Done(
								_Utils_ap(accum, soFar)))
						]));
			},
			$elm$parser$Parser$Advanced$getChompedString(
				$elm$parser$Parser$Advanced$chompWhile(predicate)));
	});
var $dillonkearns$elm_markdown$HtmlParser$textString = function (closingChar) {
	var predicate = function (c) {
		return (!_Utils_eq(c, closingChar)) && (c !== '&');
	};
	return A2(
		$elm$parser$Parser$Advanced$loop,
		'',
		A2($dillonkearns$elm_markdown$HtmlParser$textStringStep, closingChar, predicate));
};
var $dillonkearns$elm_markdown$HtmlParser$attributeValue = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
				$dillonkearns$elm_markdown$HtmlParser$symbol('\"')),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$dillonkearns$elm_markdown$HtmlParser$textString('\"'),
				$dillonkearns$elm_markdown$HtmlParser$symbol('\"'))),
			A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
				$dillonkearns$elm_markdown$HtmlParser$symbol('\'')),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$dillonkearns$elm_markdown$HtmlParser$textString('\''),
				$dillonkearns$elm_markdown$HtmlParser$symbol('\'')))
		]));
var $dillonkearns$elm_markdown$HtmlParser$keepOldest = F2(
	function (_new, mValue) {
		if (!mValue.$) {
			var v = mValue.a;
			return $elm$core$Maybe$Just(v);
		} else {
			return $elm$core$Maybe$Just(_new);
		}
	});
var $dillonkearns$elm_markdown$HtmlParser$isWhitespace = function (c) {
	switch (c) {
		case ' ':
			return true;
		case '\r':
			return true;
		case '\n':
			return true;
		case '\t':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$HtmlParser$whiteSpace = $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$isWhitespace);
var $dillonkearns$elm_markdown$HtmlParser$attributesStep = function (attrs) {
	var process = F2(
		function (name, value) {
			return $elm$parser$Parser$Advanced$Loop(
				A3(
					$elm$core$Dict$update,
					$elm$core$String$toLower(name),
					$dillonkearns$elm_markdown$HtmlParser$keepOldest(value),
					attrs));
		});
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					$elm$parser$Parser$Advanced$succeed(process),
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$HtmlParser$attributeName, $dillonkearns$elm_markdown$HtmlParser$whiteSpace),
							$dillonkearns$elm_markdown$HtmlParser$symbol('=')),
						$dillonkearns$elm_markdown$HtmlParser$whiteSpace)),
				A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$HtmlParser$attributeValue, $dillonkearns$elm_markdown$HtmlParser$whiteSpace)),
				$elm$parser$Parser$Advanced$succeed(
				$elm$parser$Parser$Advanced$Done(attrs))
			]));
};
var $dillonkearns$elm_markdown$HtmlParser$attributes = A2(
	$elm$parser$Parser$Advanced$map,
	A2(
		$elm$core$Dict$foldl,
		F3(
			function (key, value, accum) {
				return A2(
					$elm$core$List$cons,
					{dP: key, cO: value},
					accum);
			}),
		_List_Nil),
	A2($elm$parser$Parser$Advanced$loop, $elm$core$Dict$empty, $dillonkearns$elm_markdown$HtmlParser$attributesStep));
var $elm$parser$Parser$Advanced$chompUntilEndOr = function (str) {
	return function (s) {
		var _v0 = A5(_Parser_findSubString, str, s.d, s.gL, s.c6, s.cB);
		var newOffset = _v0.a;
		var newRow = _v0.b;
		var newCol = _v0.c;
		var adjustedOffset = (newOffset < 0) ? $elm$core$String$length(s.cB) : newOffset;
		return A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.d, adjustedOffset) < 0,
			0,
			{c6: newCol, i: s.i, k: s.k, d: adjustedOffset, gL: newRow, cB: s.cB});
	};
};
var $dillonkearns$elm_markdown$HtmlParser$cdata = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
		$dillonkearns$elm_markdown$HtmlParser$symbol('<![CDATA[')),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntilEndOr(']]>')),
		$dillonkearns$elm_markdown$HtmlParser$symbol(']]>')));
var $dillonkearns$elm_markdown$HtmlParser$childrenStep = F2(
	function (options, accum) {
		return A2(
			$elm$parser$Parser$Advanced$map,
			function (f) {
				return f(accum);
			},
			$elm$parser$Parser$Advanced$oneOf(options));
	});
var $dillonkearns$elm_markdown$HtmlParser$fail = function (str) {
	return $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Problem(str));
};
var $dillonkearns$elm_markdown$HtmlParser$closingTag = function (startTagName) {
	var closingTagName = A2(
		$elm$parser$Parser$Advanced$andThen,
		function (endTagName) {
			return _Utils_eq(startTagName, endTagName) ? $elm$parser$Parser$Advanced$succeed(0) : $dillonkearns$elm_markdown$HtmlParser$fail('tag name mismatch: ' + (startTagName + (' and ' + endTagName)));
		},
		$dillonkearns$elm_markdown$HtmlParser$tagName);
	return A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$dillonkearns$elm_markdown$HtmlParser$symbol('</'),
					$dillonkearns$elm_markdown$HtmlParser$whiteSpace),
				closingTagName),
			$dillonkearns$elm_markdown$HtmlParser$whiteSpace),
		$dillonkearns$elm_markdown$HtmlParser$symbol('>'));
};
var $dillonkearns$elm_markdown$HtmlParser$Comment = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$HtmlParser$toToken = function (str) {
	return A2(
		$elm$parser$Parser$Advanced$Token,
		str,
		$elm$parser$Parser$Expecting(str));
};
var $dillonkearns$elm_markdown$HtmlParser$comment = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$HtmlParser$Comment),
		$elm$parser$Parser$Advanced$token(
			$dillonkearns$elm_markdown$HtmlParser$toToken('<!--'))),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntilEndOr('-->')),
		$elm$parser$Parser$Advanced$token(
			$dillonkearns$elm_markdown$HtmlParser$toToken('-->'))));
var $dillonkearns$elm_markdown$HtmlParser$Declaration = F2(
	function (a, b) {
		return {$: 5, a: a, b: b};
	});
var $dillonkearns$elm_markdown$HtmlParser$expectUppercaseCharacter = $elm$parser$Parser$Expecting('at least 1 uppercase character');
var $dillonkearns$elm_markdown$HtmlParser$allUppercase = $elm$parser$Parser$Advanced$getChompedString(
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2($elm$parser$Parser$Advanced$chompIf, $elm$core$Char$isUpper, $dillonkearns$elm_markdown$HtmlParser$expectUppercaseCharacter),
		$elm$parser$Parser$Advanced$chompWhile($elm$core$Char$isUpper)));
var $dillonkearns$elm_markdown$HtmlParser$oneOrMoreWhiteSpace = A2(
	$elm$parser$Parser$Advanced$ignorer,
	A2(
		$elm$parser$Parser$Advanced$chompIf,
		$dillonkearns$elm_markdown$HtmlParser$isWhitespace,
		$elm$parser$Parser$Expecting('at least one whitespace')),
	$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$isWhitespace));
var $dillonkearns$elm_markdown$HtmlParser$docType = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$HtmlParser$Declaration),
			$dillonkearns$elm_markdown$HtmlParser$symbol('<!')),
		A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$HtmlParser$allUppercase, $dillonkearns$elm_markdown$HtmlParser$oneOrMoreWhiteSpace)),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntilEndOr('>')),
		$dillonkearns$elm_markdown$HtmlParser$symbol('>')));
var $dillonkearns$elm_markdown$HtmlParser$ProcessingInstruction = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_markdown$HtmlParser$processingInstruction = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$HtmlParser$ProcessingInstruction),
		$dillonkearns$elm_markdown$HtmlParser$symbol('<?')),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntilEndOr('?>')),
		$dillonkearns$elm_markdown$HtmlParser$symbol('?>')));
var $dillonkearns$elm_markdown$HtmlParser$isNotTextNodeIgnoreChar = function (c) {
	switch (c) {
		case '<':
			return false;
		case '&':
			return false;
		default:
			return true;
	}
};
var $dillonkearns$elm_markdown$HtmlParser$textNodeStringStepOptions = _List_fromArray(
	[
		A2(
		$elm$parser$Parser$Advanced$map,
		function (_v0) {
			return $elm$parser$Parser$Advanced$Loop(0);
		},
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$chompIf,
				$dillonkearns$elm_markdown$HtmlParser$isNotTextNodeIgnoreChar,
				$elm$parser$Parser$Expecting('is not & or <')),
			$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$HtmlParser$isNotTextNodeIgnoreChar))),
		A2(
		$elm$parser$Parser$Advanced$map,
		function (_v1) {
			return $elm$parser$Parser$Advanced$Loop(0);
		},
		$dillonkearns$elm_markdown$HtmlParser$escapedChar('<')),
		$elm$parser$Parser$Advanced$succeed(
		$elm$parser$Parser$Advanced$Done(0))
	]);
var $dillonkearns$elm_markdown$HtmlParser$textNodeStringStep = function (_v0) {
	return $elm$parser$Parser$Advanced$oneOf($dillonkearns$elm_markdown$HtmlParser$textNodeStringStepOptions);
};
var $dillonkearns$elm_markdown$HtmlParser$textNodeString = $elm$parser$Parser$Advanced$getChompedString(
	A2($elm$parser$Parser$Advanced$loop, 0, $dillonkearns$elm_markdown$HtmlParser$textNodeStringStep));
var $dillonkearns$elm_markdown$HtmlParser$children = function (startTagName) {
	return A2(
		$elm$parser$Parser$Advanced$loop,
		_List_Nil,
		$dillonkearns$elm_markdown$HtmlParser$childrenStep(
			$dillonkearns$elm_markdown$HtmlParser$childrenStepOptions(startTagName)));
};
var $dillonkearns$elm_markdown$HtmlParser$childrenStepOptions = function (startTagName) {
	return _List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$map,
			F2(
				function (_v1, accum) {
					return $elm$parser$Parser$Advanced$Done(
						$elm$core$List$reverse(accum));
				}),
			$dillonkearns$elm_markdown$HtmlParser$closingTag(startTagName)),
			A2(
			$elm$parser$Parser$Advanced$andThen,
			function (text) {
				return $elm$core$String$isEmpty(text) ? A2(
					$elm$parser$Parser$Advanced$map,
					F2(
						function (_v2, accum) {
							return $elm$parser$Parser$Advanced$Done(
								$elm$core$List$reverse(accum));
						}),
					$dillonkearns$elm_markdown$HtmlParser$closingTag(startTagName)) : $elm$parser$Parser$Advanced$succeed(
					function (accum) {
						return $elm$parser$Parser$Advanced$Loop(
							A2(
								$elm$core$List$cons,
								$dillonkearns$elm_markdown$HtmlParser$Text(text),
								accum));
					});
			},
			$dillonkearns$elm_markdown$HtmlParser$textNodeString),
			A2(
			$elm$parser$Parser$Advanced$map,
			F2(
				function (_new, accum) {
					return $elm$parser$Parser$Advanced$Loop(
						A2($elm$core$List$cons, _new, accum));
				}),
			$dillonkearns$elm_markdown$HtmlParser$cyclic$html())
		]);
};
var $dillonkearns$elm_markdown$HtmlParser$elementContinuation = function (startTagName) {
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed(
					$dillonkearns$elm_markdown$HtmlParser$Element(startTagName)),
				$dillonkearns$elm_markdown$HtmlParser$whiteSpace),
			A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$HtmlParser$attributes, $dillonkearns$elm_markdown$HtmlParser$whiteSpace)),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					A2(
					$elm$parser$Parser$Advanced$map,
					function (_v0) {
						return _List_Nil;
					},
					$dillonkearns$elm_markdown$HtmlParser$symbol('/>')),
					A2(
					$elm$parser$Parser$Advanced$keeper,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
						$dillonkearns$elm_markdown$HtmlParser$symbol('>')),
					$dillonkearns$elm_markdown$HtmlParser$children(startTagName))
				])));
};
function $dillonkearns$elm_markdown$HtmlParser$cyclic$html() {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2($elm$parser$Parser$Advanced$map, $dillonkearns$elm_markdown$HtmlParser$Cdata, $dillonkearns$elm_markdown$HtmlParser$cdata),
				$dillonkearns$elm_markdown$HtmlParser$processingInstruction,
				$dillonkearns$elm_markdown$HtmlParser$comment,
				$dillonkearns$elm_markdown$HtmlParser$docType,
				$dillonkearns$elm_markdown$HtmlParser$cyclic$element()
			]));
}
function $dillonkearns$elm_markdown$HtmlParser$cyclic$element() {
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			$dillonkearns$elm_markdown$HtmlParser$symbol('<')),
		A2($elm$parser$Parser$Advanced$andThen, $dillonkearns$elm_markdown$HtmlParser$elementContinuation, $dillonkearns$elm_markdown$HtmlParser$tagName));
}
var $dillonkearns$elm_markdown$HtmlParser$html = $dillonkearns$elm_markdown$HtmlParser$cyclic$html();
$dillonkearns$elm_markdown$HtmlParser$cyclic$html = function () {
	return $dillonkearns$elm_markdown$HtmlParser$html;
};
var $dillonkearns$elm_markdown$HtmlParser$element = $dillonkearns$elm_markdown$HtmlParser$cyclic$element();
$dillonkearns$elm_markdown$HtmlParser$cyclic$element = function () {
	return $dillonkearns$elm_markdown$HtmlParser$element;
};
var $dillonkearns$elm_markdown$Parser$Token$tab = A2(
	$elm$parser$Parser$Advanced$Token,
	'\t',
	$elm$parser$Parser$Expecting('a tab'));
var $dillonkearns$elm_markdown$Markdown$Parser$exactlyFourSpaces = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$tab),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$backtrackable(
				$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space)),
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$Advanced$symbol(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'   ',
							$elm$parser$Parser$ExpectingSymbol('Indentation'))),
						$elm$parser$Parser$Advanced$symbol(
						A2(
							$elm$parser$Parser$Advanced$Token,
							' \t',
							$elm$parser$Parser$ExpectingSymbol('Indentation'))),
						$elm$parser$Parser$Advanced$symbol(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'  \t',
							$elm$parser$Parser$ExpectingSymbol('Indentation')))
					])))
		]));
var $dillonkearns$elm_markdown$Markdown$Parser$indentedCodeBlock = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock),
		$dillonkearns$elm_markdown$Markdown$Parser$exactlyFourSpaces),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$Helpers$isEven = function (_int) {
	return !A2($elm$core$Basics$modBy, 2, _int);
};
var $dillonkearns$elm_markdown$Markdown$Block$Loose = 0;
var $dillonkearns$elm_markdown$Markdown$Block$Tight = 1;
var $dillonkearns$elm_markdown$Markdown$Parser$isTightBoolToListDisplay = function (isTight) {
	return isTight ? 1 : 0;
};
var $dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith = F3(
	function (joinWith, string1, string2) {
		var _v0 = _Utils_Tuple2(string1, string2);
		if (_v0.a === '') {
			return string2;
		} else {
			if (_v0.b === '') {
				return string1;
			} else {
				return _Utils_ap(
					string1,
					_Utils_ap(joinWith, string2));
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll = F2(
	function (string1, string2) {
		return string1 + ('\n' + string2);
	});
var $elm$core$Tuple$mapSecond = F2(
	function (func, _v0) {
		var x = _v0.a;
		var y = _v0.b;
		return _Utils_Tuple2(
			x,
			func(y));
	});
var $dillonkearns$elm_markdown$Markdown$Parser$innerParagraphParser = A2(
	$elm$parser$Parser$Advanced$mapChompedString,
	F2(
		function (rawLine, _v0) {
			return $dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(rawLine);
		}),
	$dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd);
var $dillonkearns$elm_markdown$Markdown$Parser$openBlockOrParagraphParser = A2($elm$parser$Parser$Advanced$ignorer, $dillonkearns$elm_markdown$Markdown$Parser$innerParagraphParser, $dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
var $dillonkearns$elm_markdown$Markdown$OrderedList$ListItem = F4(
	function (order, intended, marker, body) {
		return {e6: body, fO: intended, fY: marker, gx: order};
	});
var $elm$parser$Parser$Advanced$getCol = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.c6, s);
};
var $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListEmptyItemParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	$elm$parser$Parser$Advanced$succeed(
		function (bodyStartPos) {
			return _Utils_Tuple2(bodyStartPos, '');
		}),
	A2($elm$parser$Parser$Advanced$ignorer, $elm$parser$Parser$Advanced$getCol, $dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore = function (condition) {
	return A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2(
			$elm$parser$Parser$Advanced$chompIf,
			condition,
			$elm$parser$Parser$Problem('Expected one or more character')),
		$elm$parser$Parser$Advanced$chompWhile(condition));
};
var $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListItemBodyParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(
				F2(
					function (bodyStartPos, item) {
						return _Utils_Tuple2(bodyStartPos, item);
					})),
			$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
		$elm$parser$Parser$Advanced$getCol),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$OrderedList$Dot = 0;
var $dillonkearns$elm_markdown$Markdown$OrderedList$Paren = 1;
var $dillonkearns$elm_markdown$Parser$Token$closingParen = A2(
	$elm$parser$Parser$Advanced$Token,
	')',
	$elm$parser$Parser$Expecting('a `)`'));
var $dillonkearns$elm_markdown$Parser$Token$dot = A2(
	$elm$parser$Parser$Advanced$Token,
	'.',
	$elm$parser$Parser$Expecting('a `.`'));
var $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListMarkerParser = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(0),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$dot)),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(1),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$closingParen))
		]));
var $dillonkearns$elm_markdown$Parser$Extra$positiveInteger = A2(
	$elm$parser$Parser$Advanced$mapChompedString,
	F2(
		function (str, _v0) {
			return A2(
				$elm$core$Maybe$withDefault,
				0,
				$elm$core$String$toInt(str));
		}),
	$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore($elm$core$Char$isDigit));
var $dillonkearns$elm_markdown$Markdown$OrderedList$positiveIntegerMaxOf9Digits = A2(
	$elm$parser$Parser$Advanced$andThen,
	function (parsed) {
		return (parsed <= 999999999) ? $elm$parser$Parser$Advanced$succeed(parsed) : $elm$parser$Parser$Advanced$problem(
			$elm$parser$Parser$Problem('Starting numbers must be nine digits or less.'));
	},
	$dillonkearns$elm_markdown$Parser$Extra$positiveInteger);
var $dillonkearns$elm_markdown$Whitespace$space = $elm$parser$Parser$Advanced$token($dillonkearns$elm_markdown$Parser$Token$space);
var $elm$core$List$repeatHelp = F3(
	function (result, n, value) {
		repeatHelp:
		while (true) {
			if (n <= 0) {
				return result;
			} else {
				var $temp$result = A2($elm$core$List$cons, value, result),
					$temp$n = n - 1,
					$temp$value = value;
				result = $temp$result;
				n = $temp$n;
				value = $temp$value;
				continue repeatHelp;
			}
		}
	});
var $elm$core$List$repeat = F2(
	function (n, value) {
		return A3($elm$core$List$repeatHelp, _List_Nil, n, value);
	});
var $dillonkearns$elm_markdown$Parser$Extra$upTo = F2(
	function (n, parser) {
		var _v0 = A2($elm$core$List$repeat, n, parser);
		if (!_v0.b) {
			return $elm$parser$Parser$Advanced$succeed(0);
		} else {
			var firstParser = _v0.a;
			var remainingParsers = _v0.b;
			return A3(
				$elm$core$List$foldl,
				F2(
					function (p, parsers) {
						return $elm$parser$Parser$Advanced$oneOf(
							_List_fromArray(
								[
									A2($elm$parser$Parser$Advanced$ignorer, p, parsers),
									$elm$parser$Parser$Advanced$succeed(0)
								]));
					}),
				$elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							firstParser,
							$elm$parser$Parser$Advanced$succeed(0)
						])),
				remainingParsers);
		}
	});
var $dillonkearns$elm_markdown$Markdown$OrderedList$validateStartsWith1 = function (parsed) {
	if (parsed === 1) {
		return $elm$parser$Parser$Advanced$succeed(parsed);
	} else {
		return $elm$parser$Parser$Advanced$problem(
			$elm$parser$Parser$Problem('Lists inside a paragraph or after a paragraph without a blank line must start with 1'));
	}
};
var $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListOrderParser = function (previousWasBody) {
	return previousWasBody ? A2(
		$elm$parser$Parser$Advanced$andThen,
		$dillonkearns$elm_markdown$Markdown$OrderedList$validateStartsWith1,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
				A2($dillonkearns$elm_markdown$Parser$Extra$upTo, 3, $dillonkearns$elm_markdown$Whitespace$space)),
			$dillonkearns$elm_markdown$Markdown$OrderedList$positiveIntegerMaxOf9Digits)) : A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			A2($dillonkearns$elm_markdown$Parser$Extra$upTo, 3, $dillonkearns$elm_markdown$Whitespace$space)),
		$dillonkearns$elm_markdown$Markdown$OrderedList$positiveIntegerMaxOf9Digits);
};
var $dillonkearns$elm_markdown$Markdown$OrderedList$parser = function (previousWasBody) {
	var parseSubsequentItem = F5(
		function (start, order, marker, mid, _v0) {
			var end = _v0.a;
			var body = _v0.b;
			return ((end - mid) <= 4) ? A4($dillonkearns$elm_markdown$Markdown$OrderedList$ListItem, order, end - start, marker, body) : A4(
				$dillonkearns$elm_markdown$Markdown$OrderedList$ListItem,
				order,
				(mid - start) + 1,
				marker,
				_Utils_ap(
					A2($elm$core$String$repeat, (end - mid) - 1, ' '),
					body));
		});
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					A2(
						$elm$parser$Parser$Advanced$keeper,
						$elm$parser$Parser$Advanced$succeed(parseSubsequentItem),
						$elm$parser$Parser$Advanced$getCol),
					$elm$parser$Parser$Advanced$backtrackable(
						$dillonkearns$elm_markdown$Markdown$OrderedList$orderedListOrderParser(previousWasBody))),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$OrderedList$orderedListMarkerParser)),
			$elm$parser$Parser$Advanced$getCol),
		previousWasBody ? $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListItemBodyParser : $elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[$dillonkearns$elm_markdown$Markdown$OrderedList$orderedListEmptyItemParser, $dillonkearns$elm_markdown$Markdown$OrderedList$orderedListItemBodyParser])));
};
var $dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock = function (previousWasBody) {
	return A2(
		$elm$parser$Parser$Advanced$map,
		function (item) {
			return A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, true, item.fO, item.fY, item.gx, _List_Nil, item.e6);
		},
		$dillonkearns$elm_markdown$Markdown$OrderedList$parser(previousWasBody));
};
var $dillonkearns$elm_markdown$Markdown$Inline$CodeInline = function (a) {
	return {$: 2, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Inline$HardLineBreak = {$: 1};
var $dillonkearns$elm_markdown$Markdown$Inline$HtmlInline = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Inline$Image = F3(
	function (a, b, c) {
		return {$: 4, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Inline$Link = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $dillonkearns$elm_markdown$Markdown$Inline$Strikethrough = function (a) {
	return {$: 7, a: a};
};
var $dillonkearns$elm_markdown$Markdown$Inline$Text = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$matchToInline = function (_v0) {
	var match = _v0;
	var _v1 = match.eS;
	switch (_v1.$) {
		case 0:
			return $dillonkearns$elm_markdown$Markdown$Inline$Text(match.V);
		case 1:
			return $dillonkearns$elm_markdown$Markdown$Inline$HardLineBreak;
		case 2:
			return $dillonkearns$elm_markdown$Markdown$Inline$CodeInline(match.V);
		case 3:
			var _v2 = _v1.a;
			var text = _v2.a;
			var url = _v2.b;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Inline$Link,
				url,
				$elm$core$Maybe$Nothing,
				_List_fromArray(
					[
						$dillonkearns$elm_markdown$Markdown$Inline$Text(text)
					]));
		case 4:
			var _v3 = _v1.a;
			var url = _v3.a;
			var maybeTitle = _v3.b;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Inline$Link,
				url,
				maybeTitle,
				$dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.u));
		case 5:
			var _v4 = _v1.a;
			var url = _v4.a;
			var maybeTitle = _v4.b;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Inline$Image,
				url,
				maybeTitle,
				$dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.u));
		case 6:
			var model = _v1.a;
			return $dillonkearns$elm_markdown$Markdown$Inline$HtmlInline(model);
		case 7:
			var length = _v1.a;
			return A2(
				$dillonkearns$elm_markdown$Markdown$Inline$Emphasis,
				length,
				$dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.u));
		default:
			return $dillonkearns$elm_markdown$Markdown$Inline$Strikethrough(
				$dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(match.u));
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines = function (matches) {
	return A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$InlineParser$matchToInline, matches);
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$Match = $elm$core$Basics$identity;
var $dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch = F2(
	function (parentMatch, childMatch) {
		return {j: childMatch.j - parentMatch.w, u: childMatch.u, l: childMatch.l - parentMatch.w, V: childMatch.V, G: childMatch.G - parentMatch.w, w: childMatch.w - parentMatch.w, eS: childMatch.eS};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$addChild = F2(
	function (parentMatch, childMatch) {
		return {
			j: parentMatch.j,
			u: A2(
				$elm$core$List$cons,
				A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch, parentMatch, childMatch),
				parentMatch.u),
			l: parentMatch.l,
			V: parentMatch.V,
			G: parentMatch.G,
			w: parentMatch.w,
			eS: parentMatch.eS
		};
	});
var $elm$core$List$sortBy = _List_sortBy;
var $dillonkearns$elm_markdown$Markdown$InlineParser$organizeChildren = function (_v4) {
	var match = _v4;
	return {
		j: match.j,
		u: $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatches(match.u),
		l: match.l,
		V: match.V,
		G: match.G,
		w: match.w,
		eS: match.eS
	};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatches = function (matches) {
	var _v2 = A2(
		$elm$core$List$sortBy,
		function (_v3) {
			var match = _v3;
			return match.l;
		},
		matches);
	if (!_v2.b) {
		return _List_Nil;
	} else {
		var first = _v2.a;
		var rest = _v2.b;
		return A3($dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatchesHelp, rest, first, _List_Nil);
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatchesHelp = F3(
	function (remaining, _v0, matchesTail) {
		organizeMatchesHelp:
		while (true) {
			var prevMatch = _v0;
			if (!remaining.b) {
				return A2(
					$elm$core$List$cons,
					$dillonkearns$elm_markdown$Markdown$InlineParser$organizeChildren(prevMatch),
					matchesTail);
			} else {
				var match = remaining.a;
				var rest = remaining.b;
				if (_Utils_cmp(prevMatch.j, match.l) < 1) {
					var $temp$remaining = rest,
						$temp$_v0 = match,
						$temp$matchesTail = A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$InlineParser$organizeChildren(prevMatch),
						matchesTail);
					remaining = $temp$remaining;
					_v0 = $temp$_v0;
					matchesTail = $temp$matchesTail;
					continue organizeMatchesHelp;
				} else {
					if ((_Utils_cmp(prevMatch.l, match.l) < 0) && (_Utils_cmp(prevMatch.j, match.j) > 0)) {
						var $temp$remaining = rest,
							$temp$_v0 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$addChild, prevMatch, match),
							$temp$matchesTail = matchesTail;
						remaining = $temp$remaining;
						_v0 = $temp$_v0;
						matchesTail = $temp$matchesTail;
						continue organizeMatchesHelp;
					} else {
						var $temp$remaining = rest,
							$temp$_v0 = prevMatch,
							$temp$matchesTail = matchesTail;
						remaining = $temp$remaining;
						_v0 = $temp$_v0;
						matchesTail = $temp$matchesTail;
						continue organizeMatchesHelp;
					}
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$NormalType = {$: 0};
var $dillonkearns$elm_markdown$Markdown$Helpers$containsAmpersand = function (string) {
	return A2($elm$core$String$contains, '&', string);
};
var $dillonkearns$elm_markdown$Markdown$Entity$decimalRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('&#([0-9]{1,8});'));
var $elm$regex$Regex$replace = _Regex_replaceAtMost(_Regex_infinity);
var $dillonkearns$elm_markdown$Markdown$Entity$isBadEndUnicode = function (_int) {
	var remain_ = A2($elm$core$Basics$modBy, 16, _int);
	var remain = A2($elm$core$Basics$modBy, 131070, _int);
	return (_int >= 131070) && ((((0 <= remain) && (remain <= 15)) || ((65536 <= remain) && (remain <= 65551))) && ((remain_ === 14) || (remain_ === 15)));
};
var $dillonkearns$elm_markdown$Markdown$Entity$isValidUnicode = function (_int) {
	return (_int === 9) || ((_int === 10) || ((_int === 13) || ((_int === 133) || (((32 <= _int) && (_int <= 126)) || (((160 <= _int) && (_int <= 55295)) || (((57344 <= _int) && (_int <= 64975)) || (((65008 <= _int) && (_int <= 65533)) || ((65536 <= _int) && (_int <= 1114109)))))))));
};
var $dillonkearns$elm_markdown$Markdown$Entity$validUnicode = function (_int) {
	return ($dillonkearns$elm_markdown$Markdown$Entity$isValidUnicode(_int) && (!$dillonkearns$elm_markdown$Markdown$Entity$isBadEndUnicode(_int))) ? $elm$core$String$fromChar(
		$elm$core$Char$fromCode(_int)) : $elm$core$String$fromChar(
		$elm$core$Char$fromCode(65533));
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceDecimal = function (match) {
	var _v0 = match.cE;
	if (_v0.b && (!_v0.a.$)) {
		var first = _v0.a.a;
		var _v1 = $elm$core$String$toInt(first);
		if (!_v1.$) {
			var v = _v1.a;
			return $dillonkearns$elm_markdown$Markdown$Entity$validUnicode(v);
		} else {
			return match.a8;
		}
	} else {
		return match.a8;
	}
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceDecimals = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$Entity$decimalRegex, $dillonkearns$elm_markdown$Markdown$Entity$replaceDecimal);
var $dillonkearns$elm_markdown$Markdown$Entity$entitiesRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('&([0-9a-zA-Z]+);'));
var $dillonkearns$elm_markdown$Markdown$Entity$entities = $elm$core$Dict$fromList(
	_List_fromArray(
		[
			_Utils_Tuple2('quot', 34),
			_Utils_Tuple2('amp', 38),
			_Utils_Tuple2('apos', 39),
			_Utils_Tuple2('lt', 60),
			_Utils_Tuple2('gt', 62),
			_Utils_Tuple2('nbsp', 160),
			_Utils_Tuple2('iexcl', 161),
			_Utils_Tuple2('cent', 162),
			_Utils_Tuple2('pound', 163),
			_Utils_Tuple2('curren', 164),
			_Utils_Tuple2('yen', 165),
			_Utils_Tuple2('brvbar', 166),
			_Utils_Tuple2('sect', 167),
			_Utils_Tuple2('uml', 168),
			_Utils_Tuple2('copy', 169),
			_Utils_Tuple2('ordf', 170),
			_Utils_Tuple2('laquo', 171),
			_Utils_Tuple2('not', 172),
			_Utils_Tuple2('shy', 173),
			_Utils_Tuple2('reg', 174),
			_Utils_Tuple2('macr', 175),
			_Utils_Tuple2('deg', 176),
			_Utils_Tuple2('plusmn', 177),
			_Utils_Tuple2('sup2', 178),
			_Utils_Tuple2('sup3', 179),
			_Utils_Tuple2('acute', 180),
			_Utils_Tuple2('micro', 181),
			_Utils_Tuple2('para', 182),
			_Utils_Tuple2('middot', 183),
			_Utils_Tuple2('cedil', 184),
			_Utils_Tuple2('sup1', 185),
			_Utils_Tuple2('ordm', 186),
			_Utils_Tuple2('raquo', 187),
			_Utils_Tuple2('frac14', 188),
			_Utils_Tuple2('frac12', 189),
			_Utils_Tuple2('frac34', 190),
			_Utils_Tuple2('iquest', 191),
			_Utils_Tuple2('Agrave', 192),
			_Utils_Tuple2('Aacute', 193),
			_Utils_Tuple2('Acirc', 194),
			_Utils_Tuple2('Atilde', 195),
			_Utils_Tuple2('Auml', 196),
			_Utils_Tuple2('Aring', 197),
			_Utils_Tuple2('AElig', 198),
			_Utils_Tuple2('Ccedil', 199),
			_Utils_Tuple2('Egrave', 200),
			_Utils_Tuple2('Eacute', 201),
			_Utils_Tuple2('Ecirc', 202),
			_Utils_Tuple2('Euml', 203),
			_Utils_Tuple2('Igrave', 204),
			_Utils_Tuple2('Iacute', 205),
			_Utils_Tuple2('Icirc', 206),
			_Utils_Tuple2('Iuml', 207),
			_Utils_Tuple2('ETH', 208),
			_Utils_Tuple2('Ntilde', 209),
			_Utils_Tuple2('Ograve', 210),
			_Utils_Tuple2('Oacute', 211),
			_Utils_Tuple2('Ocirc', 212),
			_Utils_Tuple2('Otilde', 213),
			_Utils_Tuple2('Ouml', 214),
			_Utils_Tuple2('times', 215),
			_Utils_Tuple2('Oslash', 216),
			_Utils_Tuple2('Ugrave', 217),
			_Utils_Tuple2('Uacute', 218),
			_Utils_Tuple2('Ucirc', 219),
			_Utils_Tuple2('Uuml', 220),
			_Utils_Tuple2('Yacute', 221),
			_Utils_Tuple2('THORN', 222),
			_Utils_Tuple2('szlig', 223),
			_Utils_Tuple2('agrave', 224),
			_Utils_Tuple2('aacute', 225),
			_Utils_Tuple2('acirc', 226),
			_Utils_Tuple2('atilde', 227),
			_Utils_Tuple2('auml', 228),
			_Utils_Tuple2('aring', 229),
			_Utils_Tuple2('aelig', 230),
			_Utils_Tuple2('ccedil', 231),
			_Utils_Tuple2('egrave', 232),
			_Utils_Tuple2('eacute', 233),
			_Utils_Tuple2('ecirc', 234),
			_Utils_Tuple2('euml', 235),
			_Utils_Tuple2('igrave', 236),
			_Utils_Tuple2('iacute', 237),
			_Utils_Tuple2('icirc', 238),
			_Utils_Tuple2('iuml', 239),
			_Utils_Tuple2('eth', 240),
			_Utils_Tuple2('ntilde', 241),
			_Utils_Tuple2('ograve', 242),
			_Utils_Tuple2('oacute', 243),
			_Utils_Tuple2('ocirc', 244),
			_Utils_Tuple2('otilde', 245),
			_Utils_Tuple2('ouml', 246),
			_Utils_Tuple2('divide', 247),
			_Utils_Tuple2('oslash', 248),
			_Utils_Tuple2('ugrave', 249),
			_Utils_Tuple2('uacute', 250),
			_Utils_Tuple2('ucirc', 251),
			_Utils_Tuple2('uuml', 252),
			_Utils_Tuple2('yacute', 253),
			_Utils_Tuple2('thorn', 254),
			_Utils_Tuple2('yuml', 255),
			_Utils_Tuple2('OElig', 338),
			_Utils_Tuple2('oelig', 339),
			_Utils_Tuple2('Scaron', 352),
			_Utils_Tuple2('scaron', 353),
			_Utils_Tuple2('Yuml', 376),
			_Utils_Tuple2('fnof', 402),
			_Utils_Tuple2('circ', 710),
			_Utils_Tuple2('tilde', 732),
			_Utils_Tuple2('Alpha', 913),
			_Utils_Tuple2('Beta', 914),
			_Utils_Tuple2('Gamma', 915),
			_Utils_Tuple2('Delta', 916),
			_Utils_Tuple2('Epsilon', 917),
			_Utils_Tuple2('Zeta', 918),
			_Utils_Tuple2('Eta', 919),
			_Utils_Tuple2('Theta', 920),
			_Utils_Tuple2('Iota', 921),
			_Utils_Tuple2('Kappa', 922),
			_Utils_Tuple2('Lambda', 923),
			_Utils_Tuple2('Mu', 924),
			_Utils_Tuple2('Nu', 925),
			_Utils_Tuple2('Xi', 926),
			_Utils_Tuple2('Omicron', 927),
			_Utils_Tuple2('Pi', 928),
			_Utils_Tuple2('Rho', 929),
			_Utils_Tuple2('Sigma', 931),
			_Utils_Tuple2('Tau', 932),
			_Utils_Tuple2('Upsilon', 933),
			_Utils_Tuple2('Phi', 934),
			_Utils_Tuple2('Chi', 935),
			_Utils_Tuple2('Psi', 936),
			_Utils_Tuple2('Omega', 937),
			_Utils_Tuple2('alpha', 945),
			_Utils_Tuple2('beta', 946),
			_Utils_Tuple2('gamma', 947),
			_Utils_Tuple2('delta', 948),
			_Utils_Tuple2('epsilon', 949),
			_Utils_Tuple2('zeta', 950),
			_Utils_Tuple2('eta', 951),
			_Utils_Tuple2('theta', 952),
			_Utils_Tuple2('iota', 953),
			_Utils_Tuple2('kappa', 954),
			_Utils_Tuple2('lambda', 955),
			_Utils_Tuple2('mu', 956),
			_Utils_Tuple2('nu', 957),
			_Utils_Tuple2('xi', 958),
			_Utils_Tuple2('omicron', 959),
			_Utils_Tuple2('pi', 960),
			_Utils_Tuple2('rho', 961),
			_Utils_Tuple2('sigmaf', 962),
			_Utils_Tuple2('sigma', 963),
			_Utils_Tuple2('tau', 964),
			_Utils_Tuple2('upsilon', 965),
			_Utils_Tuple2('phi', 966),
			_Utils_Tuple2('chi', 967),
			_Utils_Tuple2('psi', 968),
			_Utils_Tuple2('omega', 969),
			_Utils_Tuple2('thetasym', 977),
			_Utils_Tuple2('upsih', 978),
			_Utils_Tuple2('piv', 982),
			_Utils_Tuple2('ensp', 8194),
			_Utils_Tuple2('emsp', 8195),
			_Utils_Tuple2('thinsp', 8201),
			_Utils_Tuple2('zwnj', 8204),
			_Utils_Tuple2('zwj', 8205),
			_Utils_Tuple2('lrm', 8206),
			_Utils_Tuple2('rlm', 8207),
			_Utils_Tuple2('ndash', 8211),
			_Utils_Tuple2('mdash', 8212),
			_Utils_Tuple2('lsquo', 8216),
			_Utils_Tuple2('rsquo', 8217),
			_Utils_Tuple2('sbquo', 8218),
			_Utils_Tuple2('ldquo', 8220),
			_Utils_Tuple2('rdquo', 8221),
			_Utils_Tuple2('bdquo', 8222),
			_Utils_Tuple2('dagger', 8224),
			_Utils_Tuple2('Dagger', 8225),
			_Utils_Tuple2('bull', 8226),
			_Utils_Tuple2('hellip', 8230),
			_Utils_Tuple2('permil', 8240),
			_Utils_Tuple2('prime', 8242),
			_Utils_Tuple2('Prime', 8243),
			_Utils_Tuple2('lsaquo', 8249),
			_Utils_Tuple2('rsaquo', 8250),
			_Utils_Tuple2('oline', 8254),
			_Utils_Tuple2('frasl', 8260),
			_Utils_Tuple2('euro', 8364),
			_Utils_Tuple2('image', 8465),
			_Utils_Tuple2('weierp', 8472),
			_Utils_Tuple2('real', 8476),
			_Utils_Tuple2('trade', 8482),
			_Utils_Tuple2('alefsym', 8501),
			_Utils_Tuple2('larr', 8592),
			_Utils_Tuple2('uarr', 8593),
			_Utils_Tuple2('rarr', 8594),
			_Utils_Tuple2('darr', 8595),
			_Utils_Tuple2('harr', 8596),
			_Utils_Tuple2('crarr', 8629),
			_Utils_Tuple2('lArr', 8656),
			_Utils_Tuple2('uArr', 8657),
			_Utils_Tuple2('rArr', 8658),
			_Utils_Tuple2('dArr', 8659),
			_Utils_Tuple2('hArr', 8660),
			_Utils_Tuple2('forall', 8704),
			_Utils_Tuple2('part', 8706),
			_Utils_Tuple2('exist', 8707),
			_Utils_Tuple2('empty', 8709),
			_Utils_Tuple2('nabla', 8711),
			_Utils_Tuple2('isin', 8712),
			_Utils_Tuple2('notin', 8713),
			_Utils_Tuple2('ni', 8715),
			_Utils_Tuple2('prod', 8719),
			_Utils_Tuple2('sum', 8721),
			_Utils_Tuple2('minus', 8722),
			_Utils_Tuple2('lowast', 8727),
			_Utils_Tuple2('radic', 8730),
			_Utils_Tuple2('prop', 8733),
			_Utils_Tuple2('infin', 8734),
			_Utils_Tuple2('ang', 8736),
			_Utils_Tuple2('and', 8743),
			_Utils_Tuple2('or', 8744),
			_Utils_Tuple2('cap', 8745),
			_Utils_Tuple2('cup', 8746),
			_Utils_Tuple2('int', 8747),
			_Utils_Tuple2('there4', 8756),
			_Utils_Tuple2('sim', 8764),
			_Utils_Tuple2('cong', 8773),
			_Utils_Tuple2('asymp', 8776),
			_Utils_Tuple2('ne', 8800),
			_Utils_Tuple2('equiv', 8801),
			_Utils_Tuple2('le', 8804),
			_Utils_Tuple2('ge', 8805),
			_Utils_Tuple2('sub', 8834),
			_Utils_Tuple2('sup', 8835),
			_Utils_Tuple2('nsub', 8836),
			_Utils_Tuple2('sube', 8838),
			_Utils_Tuple2('supe', 8839),
			_Utils_Tuple2('oplus', 8853),
			_Utils_Tuple2('otimes', 8855),
			_Utils_Tuple2('perp', 8869),
			_Utils_Tuple2('sdot', 8901),
			_Utils_Tuple2('lceil', 8968),
			_Utils_Tuple2('rceil', 8969),
			_Utils_Tuple2('lfloor', 8970),
			_Utils_Tuple2('rfloor', 8971),
			_Utils_Tuple2('lang', 9001),
			_Utils_Tuple2('rang', 9002),
			_Utils_Tuple2('loz', 9674),
			_Utils_Tuple2('spades', 9824),
			_Utils_Tuple2('clubs', 9827),
			_Utils_Tuple2('hearts', 9829),
			_Utils_Tuple2('diams', 9830)
		]));
var $dillonkearns$elm_markdown$Markdown$Entity$replaceEntity = function (match) {
	var _v0 = match.cE;
	if (_v0.b && (!_v0.a.$)) {
		var first = _v0.a.a;
		var _v1 = A2($elm$core$Dict$get, first, $dillonkearns$elm_markdown$Markdown$Entity$entities);
		if (!_v1.$) {
			var code = _v1.a;
			return $elm$core$String$fromChar(
				$elm$core$Char$fromCode(code));
		} else {
			return match.a8;
		}
	} else {
		return match.a8;
	}
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceEntities = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$Entity$entitiesRegex, $dillonkearns$elm_markdown$Markdown$Entity$replaceEntity);
var $dillonkearns$elm_markdown$Markdown$Helpers$escapableRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\+)([!\"#$%&\\\'()*+,./:;<=>?@[\\\\\\]^_`{|}~-])'));
var $dillonkearns$elm_markdown$Markdown$Helpers$replaceEscapable = A2(
	$elm$regex$Regex$replace,
	$dillonkearns$elm_markdown$Markdown$Helpers$escapableRegex,
	function (regexMatch) {
		var _v0 = regexMatch.cE;
		if (((_v0.b && (!_v0.a.$)) && _v0.b.b) && (!_v0.b.a.$)) {
			var backslashes = _v0.a.a;
			var _v1 = _v0.b;
			var escapedStr = _v1.a.a;
			return _Utils_ap(
				A2(
					$elm$core$String$repeat,
					($elm$core$String$length(backslashes) / 2) | 0,
					'\\'),
				escapedStr);
		} else {
			return regexMatch.a8;
		}
	});
var $dillonkearns$elm_markdown$Markdown$Entity$hexadecimalRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('&#[Xx]([0-9a-fA-F]{1,8});'));
var $dillonkearns$elm_markdown$Markdown$Entity$hexToInt = function (string) {
	var folder = F2(
		function (hexDigit, _int) {
			return ((_int * 16) + A2(
				$elm$core$Basics$modBy,
				39,
				$elm$core$Char$toCode(hexDigit))) - 9;
		});
	return A3(
		$elm$core$String$foldl,
		folder,
		0,
		$elm$core$String$toLower(string));
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimal = function (match) {
	var _v0 = match.cE;
	if (_v0.b && (!_v0.a.$)) {
		var first = _v0.a.a;
		return $dillonkearns$elm_markdown$Markdown$Entity$validUnicode(
			$dillonkearns$elm_markdown$Markdown$Entity$hexToInt(first));
	} else {
		return match.a8;
	}
};
var $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimals = A2($elm$regex$Regex$replace, $dillonkearns$elm_markdown$Markdown$Entity$hexadecimalRegex, $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimal);
var $dillonkearns$elm_markdown$Markdown$Helpers$formatStr = function (str) {
	var withEscapes = $dillonkearns$elm_markdown$Markdown$Helpers$replaceEscapable(str);
	return $dillonkearns$elm_markdown$Markdown$Helpers$containsAmpersand(withEscapes) ? $dillonkearns$elm_markdown$Markdown$Entity$replaceHexadecimals(
		$dillonkearns$elm_markdown$Markdown$Entity$replaceDecimals(
			$dillonkearns$elm_markdown$Markdown$Entity$replaceEntities(withEscapes))) : withEscapes;
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch = function (text) {
	return {
		j: 0,
		u: _List_Nil,
		l: 0,
		V: $dillonkearns$elm_markdown$Markdown$Helpers$formatStr(text),
		G: 0,
		w: 0,
		eS: $dillonkearns$elm_markdown$Markdown$InlineParser$NormalType
	};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatch = F3(
	function (rawText, _v2, parsedMatches) {
		var matchModel = _v2;
		var updtMatch = {
			j: matchModel.j,
			u: A3($dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches, matchModel.V, _List_Nil, matchModel.u),
			l: matchModel.l,
			V: matchModel.V,
			G: matchModel.G,
			w: matchModel.w,
			eS: matchModel.eS
		};
		if (!parsedMatches.b) {
			var finalStr = A2($elm$core$String$dropLeft, matchModel.j, rawText);
			return $elm$core$String$isEmpty(finalStr) ? _List_fromArray(
				[updtMatch]) : _List_fromArray(
				[
					updtMatch,
					$dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(finalStr)
				]);
		} else {
			var matchHead = parsedMatches.a;
			var matchesTail = parsedMatches.b;
			var _v4 = matchHead.eS;
			if (!_v4.$) {
				return A2($elm$core$List$cons, updtMatch, parsedMatches);
			} else {
				return _Utils_eq(matchModel.j, matchHead.l) ? A2($elm$core$List$cons, updtMatch, parsedMatches) : ((_Utils_cmp(matchModel.j, matchHead.l) < 0) ? A2(
					$elm$core$List$cons,
					updtMatch,
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(
							A3($elm$core$String$slice, matchModel.j, matchHead.l, rawText)),
						parsedMatches)) : parsedMatches);
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches = F3(
	function (rawText, parsedMatches, matches) {
		parseTextMatches:
		while (true) {
			if (!matches.b) {
				if (!parsedMatches.b) {
					return $elm$core$String$isEmpty(rawText) ? _List_Nil : _List_fromArray(
						[
							$dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(rawText)
						]);
				} else {
					var matchModel = parsedMatches.a;
					return (matchModel.l > 0) ? A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$InlineParser$normalMatch(
							A2($elm$core$String$left, matchModel.l, rawText)),
						parsedMatches) : parsedMatches;
				}
			} else {
				var match = matches.a;
				var matchesTail = matches.b;
				var $temp$rawText = rawText,
					$temp$parsedMatches = A3($dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatch, rawText, match, parsedMatches),
					$temp$matches = matchesTail;
				rawText = $temp$rawText;
				parsedMatches = $temp$parsedMatches;
				matches = $temp$matches;
				continue parseTextMatches;
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketLTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\<)'));
var $elm$regex$Regex$find = _Regex_findAtMost(_Regex_infinity);
var $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketOpen = {$: 4};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketLToken = function (regMatch) {
	var _v0 = regMatch.cE;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var delimiter = _v1.a.a;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just(
			{c: regMatch.c + backslashesLength, cl: 1, g: $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketOpen}) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketLTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketLToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketLTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketRTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\>)'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketClose = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$Escaped = 0;
var $dillonkearns$elm_markdown$Markdown$InlineParser$NotEscaped = 1;
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketRToken = function (regMatch) {
	var _v0 = regMatch.cE;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $elm$core$Maybe$Just(
			{
				c: regMatch.c + backslashesLength,
				cl: 1,
				g: $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketClose(1) : $dillonkearns$elm_markdown$Markdown$InlineParser$AngleBracketClose(0)
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketRTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToAngleBracketRToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketRTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$asteriskEmphasisTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)([^*])?(\\*+)([^*])?'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisToken = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$isPunctuation = function (c) {
	switch (c) {
		case '!':
			return true;
		case '\"':
			return true;
		case '#':
			return true;
		case '%':
			return true;
		case '&':
			return true;
		case '\'':
			return true;
		case '(':
			return true;
		case ')':
			return true;
		case '*':
			return true;
		case ',':
			return true;
		case '-':
			return true;
		case '.':
			return true;
		case '/':
			return true;
		case ':':
			return true;
		case ';':
			return true;
		case '?':
			return true;
		case '@':
			return true;
		case '[':
			return true;
		case ']':
			return true;
		case '_':
			return true;
		case '{':
			return true;
		case '}':
			return true;
		case '~':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$containPunctuation = A2(
	$elm$core$String$foldl,
	F2(
		function (c, accum) {
			return accum || $dillonkearns$elm_markdown$Markdown$InlineParser$isPunctuation(c);
		}),
	false);
var $dillonkearns$elm_markdown$Markdown$InlineParser$isWhitespace = function (c) {
	switch (c) {
		case ' ':
			return true;
		case '\u000C':
			return true;
		case '\n':
			return true;
		case '\r':
			return true;
		case '\t':
			return true;
		case '\u000B':
			return true;
		case '\u00A0':
			return true;
		case '\u2028':
			return true;
		case '\u2029':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$containSpace = A2(
	$elm$core$String$foldl,
	F2(
		function (c, accum) {
			return accum || $dillonkearns$elm_markdown$Markdown$InlineParser$isWhitespace(c);
		}),
	false);
var $dillonkearns$elm_markdown$Markdown$InlineParser$getFringeRank = function (mstring) {
	if (!mstring.$) {
		var string = mstring.a;
		return ($elm$core$String$isEmpty(string) || $dillonkearns$elm_markdown$Markdown$InlineParser$containSpace(string)) ? 0 : ($dillonkearns$elm_markdown$Markdown$InlineParser$containPunctuation(string) ? 1 : 2);
	} else {
		return 0;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken = F3(
	function (_char, rawText, regMatch) {
		var _v0 = regMatch.cE;
		if ((((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.a.$)) && _v0.b.b.b.b) {
			var maybeBackslashes = _v0.a;
			var _v1 = _v0.b;
			var maybeLeftFringe = _v1.a;
			var _v2 = _v1.b;
			var delimiter = _v2.a.a;
			var _v3 = _v2.b;
			var maybeRightFringe = _v3.a;
			var rFringeRank = $dillonkearns$elm_markdown$Markdown$InlineParser$getFringeRank(maybeRightFringe);
			var leftFringeLength = function () {
				if (!maybeLeftFringe.$) {
					var left = maybeLeftFringe.a;
					return $elm$core$String$length(left);
				} else {
					return 0;
				}
			}();
			var mLeftFringe = ((!(!regMatch.c)) && (!leftFringeLength)) ? $elm$core$Maybe$Just(
				A3($elm$core$String$slice, regMatch.c - 1, regMatch.c, rawText)) : maybeLeftFringe;
			var backslashesLength = function () {
				if (!maybeBackslashes.$) {
					var backslashes = maybeBackslashes.a;
					return $elm$core$String$length(backslashes);
				} else {
					return 0;
				}
			}();
			var isEscaped = ((!$dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength)) && (!leftFringeLength)) || function () {
				if ((!mLeftFringe.$) && (mLeftFringe.a === '\\')) {
					return true;
				} else {
					return false;
				}
			}();
			var delimiterLength = isEscaped ? ($elm$core$String$length(delimiter) - 1) : $elm$core$String$length(delimiter);
			var lFringeRank = isEscaped ? 1 : $dillonkearns$elm_markdown$Markdown$InlineParser$getFringeRank(mLeftFringe);
			if ((delimiterLength <= 0) || ((_char === '_') && ((lFringeRank === 2) && (rFringeRank === 2)))) {
				return $elm$core$Maybe$Nothing;
			} else {
				var index = ((regMatch.c + backslashesLength) + leftFringeLength) + (isEscaped ? 1 : 0);
				return $elm$core$Maybe$Just(
					{
						c: index,
						cl: delimiterLength,
						g: A2(
							$dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisToken,
							_char,
							{bI: lFringeRank, bT: rFringeRank})
					});
			}
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$findAsteriskEmphasisTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		A2($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken, '*', str),
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$asteriskEmphasisTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$codeTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\`+)'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$CodeToken = function (a) {
	return {$: 0, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToCodeToken = function (regMatch) {
	var _v0 = regMatch.cE;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var backtick = _v1.a.a;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $elm$core$Maybe$Just(
			{
				c: regMatch.c + backslashesLength,
				cl: $elm$core$String$length(backtick),
				g: $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $dillonkearns$elm_markdown$Markdown$InlineParser$CodeToken(1) : $dillonkearns$elm_markdown$Markdown$InlineParser$CodeToken(0)
			});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findCodeTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToCodeToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$codeTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$hardBreakTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(?:(\\\\+)|( {2,}))\\n'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken = {$: 9};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToHardBreakToken = function (regMatch) {
	var _v0 = regMatch.cE;
	_v0$2:
	while (true) {
		if (_v0.b) {
			if (!_v0.a.$) {
				var backslashes = _v0.a.a;
				var backslashesLength = $elm$core$String$length(backslashes);
				return (!$dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength)) ? $elm$core$Maybe$Just(
					{c: (regMatch.c + backslashesLength) - 1, cl: 2, g: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken}) : $elm$core$Maybe$Nothing;
			} else {
				if (_v0.b.b && (!_v0.b.a.$)) {
					var _v1 = _v0.b;
					return $elm$core$Maybe$Just(
						{
							c: regMatch.c,
							cl: $elm$core$String$length(regMatch.a8),
							g: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken
						});
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToSoftHardBreakToken = function (regMatch) {
	var _v0 = regMatch.cE;
	_v0$2:
	while (true) {
		if (_v0.b) {
			if (!_v0.a.$) {
				var backslashes = _v0.a.a;
				var backslashesLength = $elm$core$String$length(backslashes);
				return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just(
					{c: regMatch.c + backslashesLength, cl: 1, g: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken}) : $elm$core$Maybe$Just(
					{c: (regMatch.c + backslashesLength) - 1, cl: 2, g: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken});
			} else {
				if (_v0.b.b) {
					var _v1 = _v0.b;
					var maybeSpaces = _v1.a;
					return $elm$core$Maybe$Just(
						{
							c: regMatch.c,
							cl: $elm$core$String$length(regMatch.a8),
							g: $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakToken
						});
				} else {
					break _v0$2;
				}
			}
		} else {
			break _v0$2;
		}
	}
	return $elm$core$Maybe$Nothing;
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreak = false;
var $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreakTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(?:(\\\\+)|( *))\\n'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$findHardBreakTokens = function (str) {
	return $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreak ? A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToSoftHardBreakToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$softAsHardLineBreakTokenRegex, str)) : A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToHardBreakToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$hardBreakTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageCloseTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\])'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$SquareBracketClose = {$: 3};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageCloseToken = function (regMatch) {
	var _v0 = regMatch.cE;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? $elm$core$Maybe$Just(
			{c: regMatch.c + backslashesLength, cl: 1, g: $dillonkearns$elm_markdown$Markdown$InlineParser$SquareBracketClose}) : $elm$core$Maybe$Nothing;
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageCloseTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageCloseToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageCloseTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageOpenTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(\\!)?(\\[)'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$Active = 0;
var $dillonkearns$elm_markdown$Markdown$InlineParser$ImageOpenToken = {$: 2};
var $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageOpenToken = function (regMatch) {
	var _v0 = regMatch.cE;
	if (((_v0.b && _v0.b.b) && _v0.b.b.b) && (!_v0.b.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var maybeImageOpen = _v1.a;
		var _v2 = _v1.b;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		var isEscaped = !$dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength);
		var index = isEscaped ? ((regMatch.c + backslashesLength) + 1) : (regMatch.c + backslashesLength);
		if (isEscaped) {
			if (!maybeImageOpen.$) {
				return $elm$core$Maybe$Just(
					{
						c: index,
						cl: 1,
						g: $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken(0)
					});
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			if (!maybeImageOpen.$) {
				return $elm$core$Maybe$Just(
					{c: index, cl: 2, g: $dillonkearns$elm_markdown$Markdown$InlineParser$ImageOpenToken});
			} else {
				return $elm$core$Maybe$Just(
					{
						c: index,
						cl: 1,
						g: $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken(0)
					});
			}
		}
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageOpenTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToLinkImageOpenToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageOpenTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughToken = function (a) {
	return {$: 10, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToStrikethroughToken = function (regMatch) {
	var _v0 = regMatch.cE;
	if ((_v0.b && _v0.b.b) && (!_v0.b.a.$)) {
		var maybeBackslashes = _v0.a;
		var _v1 = _v0.b;
		var tilde = _v1.a.a;
		var backslashesLength = A2(
			$elm$core$Maybe$withDefault,
			0,
			A2($elm$core$Maybe$map, $elm$core$String$length, maybeBackslashes));
		var _v2 = $dillonkearns$elm_markdown$Markdown$Helpers$isEven(backslashesLength) ? _Utils_Tuple2(
			$elm$core$String$length(tilde),
			$dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughToken(1)) : _Utils_Tuple2(
			$elm$core$String$length(tilde),
			$dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughToken(0));
		var length = _v2.a;
		var meaning = _v2.b;
		return $elm$core$Maybe$Just(
			{c: regMatch.c + backslashesLength, cl: length, g: meaning});
	} else {
		return $elm$core$Maybe$Nothing;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)(~{2,})([^~])?'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$findStrikethroughTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		$dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToStrikethroughToken,
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$underlineEmphasisTokenRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('(\\\\*)([^_])?(\\_+)([^_])?'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$findUnderlineEmphasisTokens = function (str) {
	return A2(
		$elm$core$List$filterMap,
		A2($dillonkearns$elm_markdown$Markdown$InlineParser$regMatchToEmphasisToken, '_', str),
		A2($elm$regex$Regex$find, $dillonkearns$elm_markdown$Markdown$InlineParser$underlineEmphasisTokenRegex, str));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex = F2(
	function (left, right) {
		if (left.b) {
			var lfirst = left.a;
			var lrest = left.b;
			if (right.b) {
				var rfirst = right.a;
				var rrest = right.b;
				return (_Utils_cmp(lfirst.c, rfirst.c) < 0) ? A2(
					$elm$core$List$cons,
					lfirst,
					A2($dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex, lrest, right)) : A2(
					$elm$core$List$cons,
					rfirst,
					A2($dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex, left, rrest));
			} else {
				return left;
			}
		} else {
			return right;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$tokenize = function (rawText) {
	return A2(
		$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
		$dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketRTokens(rawText),
		A2(
			$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
			$dillonkearns$elm_markdown$Markdown$InlineParser$findAngleBracketLTokens(rawText),
			A2(
				$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
				$dillonkearns$elm_markdown$Markdown$InlineParser$findHardBreakTokens(rawText),
				A2(
					$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
					$dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageCloseTokens(rawText),
					A2(
						$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
						$dillonkearns$elm_markdown$Markdown$InlineParser$findLinkImageOpenTokens(rawText),
						A2(
							$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
							$dillonkearns$elm_markdown$Markdown$InlineParser$findStrikethroughTokens(rawText),
							A2(
								$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
								$dillonkearns$elm_markdown$Markdown$InlineParser$findUnderlineEmphasisTokens(rawText),
								A2(
									$dillonkearns$elm_markdown$Markdown$InlineParser$mergeByIndex,
									$dillonkearns$elm_markdown$Markdown$InlineParser$findAsteriskEmphasisTokens(rawText),
									$dillonkearns$elm_markdown$Markdown$InlineParser$findCodeTokens(rawText)))))))));
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$CodeType = {$: 2};
var $dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisType = function (a) {
	return {$: 7, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$HtmlType = function (a) {
	return {$: 6, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType = function (a) {
	return {$: 5, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$Inactive = 1;
var $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType = function (a) {
	return {$: 4, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughType = {$: 8};
var $dillonkearns$elm_markdown$Markdown$InlineParser$AutolinkType = function (a) {
	return {$: 3, a: a};
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$decodeUrlRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('%(?:3B|2C|2F|3F|3A|40|26|3D|2B|24|23|25)'));
var $elm$url$Url$percentEncode = _Url_percentEncode;
var $dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl = A2(
	$elm$core$Basics$composeR,
	$elm$url$Url$percentEncode,
	A2(
		$elm$regex$Regex$replace,
		$dillonkearns$elm_markdown$Markdown$InlineParser$decodeUrlRegex,
		function (match) {
			return A2(
				$elm$core$Maybe$withDefault,
				match.a8,
				$elm$url$Url$percentDecode(match.a8));
		}));
var $dillonkearns$elm_markdown$Markdown$InlineParser$urlRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^([A-Za-z][A-Za-z0-9.+\\-]{1,31}:[^<>\\x00-\\x20]*)$'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$autolinkToMatch = function (_v0) {
	var match = _v0;
	return A2($elm$regex$Regex$contains, $dillonkearns$elm_markdown$Markdown$InlineParser$urlRegex, match.V) ? $elm$core$Result$Ok(
		_Utils_update(
			match,
			{
				eS: $dillonkearns$elm_markdown$Markdown$InlineParser$AutolinkType(
					_Utils_Tuple2(
						match.V,
						$dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl(match.V)))
			})) : $elm$core$Result$Err(match);
};
var $elm$regex$Regex$findAtMost = _Regex_findAtMost;
var $dillonkearns$elm_markdown$Markdown$Helpers$insideSquareBracketRegex = '[^\\[\\]\\\\]*(?:\\\\.[^\\[\\]\\\\]*)*';
var $dillonkearns$elm_markdown$Markdown$InlineParser$refLabelRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^\\[\\s*(' + ($dillonkearns$elm_markdown$Markdown$Helpers$insideSquareBracketRegex + ')\\s*\\]')));
var $elm$core$Maybe$andThen = F2(
	function (callback, maybeValue) {
		if (!maybeValue.$) {
			var value = maybeValue.a;
			return callback(value);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces = function (original) {
	return original;
};
var $dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel = A2($elm$core$Basics$composeR, $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces, $elm$core$String$toLower);
var $dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle = F2(
	function (rawUrl, maybeTitle) {
		return _Utils_Tuple2(
			$dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl(
				$dillonkearns$elm_markdown$Markdown$Helpers$formatStr(rawUrl)),
			A2($elm$core$Maybe$map, $dillonkearns$elm_markdown$Markdown$Helpers$formatStr, maybeTitle));
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$refRegexToMatch = F3(
	function (matchModel, references, maybeRegexMatch) {
		var refLabel = function (str) {
			return $elm$core$String$isEmpty(str) ? matchModel.V : str;
		}(
			A2(
				$elm$core$Maybe$withDefault,
				matchModel.V,
				A2(
					$elm$core$Maybe$withDefault,
					$elm$core$Maybe$Nothing,
					A2(
						$elm$core$Maybe$andThen,
						A2(
							$elm$core$Basics$composeR,
							function ($) {
								return $.cE;
							},
							$elm$core$List$head),
						maybeRegexMatch))));
		var _v0 = A2(
			$elm$core$Dict$get,
			$dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel(refLabel),
			references);
		if (_v0.$ === 1) {
			return $elm$core$Maybe$Nothing;
		} else {
			var _v1 = _v0.a;
			var rawUrl = _v1.a;
			var maybeTitle = _v1.b;
			var type_ = function () {
				var _v3 = matchModel.eS;
				if (_v3.$ === 5) {
					return $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType(
						A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle, rawUrl, maybeTitle));
				} else {
					return $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType(
						A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle, rawUrl, maybeTitle));
				}
			}();
			var regexMatchLength = function () {
				if (!maybeRegexMatch.$) {
					var match = maybeRegexMatch.a.a8;
					return $elm$core$String$length(match);
				} else {
					return 0;
				}
			}();
			return $elm$core$Maybe$Just(
				_Utils_update(
					matchModel,
					{j: matchModel.j + regexMatchLength, eS: type_}));
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineReferences = F3(
	function (remainText, _v0, references) {
		var tempMatch = _v0;
		var matches = A3($elm$regex$Regex$findAtMost, 1, $dillonkearns$elm_markdown$Markdown$InlineParser$refLabelRegex, remainText);
		return A3(
			$dillonkearns$elm_markdown$Markdown$InlineParser$refRegexToMatch,
			tempMatch,
			references,
			$elm$core$List$head(matches));
	});
var $dillonkearns$elm_markdown$Markdown$Helpers$lineEndChars = '\\f\\v\\r\\n';
var $dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars = ' \\t\\f\\v\\r\\n';
var $dillonkearns$elm_markdown$Markdown$InlineParser$hrefRegex = '(?:<([^<>' + ($dillonkearns$elm_markdown$Markdown$Helpers$lineEndChars + (']*)>|([^' + ($dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars + ('\\(\\)\\\\]*(?:\\\\.[^' + ($dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars + '\\(\\)\\\\]*)*))')))));
var $dillonkearns$elm_markdown$Markdown$Helpers$titleRegex = '(?:[' + ($dillonkearns$elm_markdown$Markdown$Helpers$whiteSpaceChars + (']+' + ('(?:\'([^\'\\\\]*(?:\\\\.[^\'\\\\]*)*)\'|' + ('\"([^\"\\\\]*(?:\\\\.[^\"\\\\]*)*)\"|' + '\\(([^\\)\\\\]*(?:\\\\.[^\\)\\\\]*)*)\\)))?'))));
var $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^\\(\\s*' + ($dillonkearns$elm_markdown$Markdown$InlineParser$hrefRegex + ($dillonkearns$elm_markdown$Markdown$Helpers$titleRegex + '\\s*\\)'))));
var $dillonkearns$elm_markdown$Markdown$Helpers$returnFirstJust = function (maybes) {
	var process = F2(
		function (a, maybeFound) {
			if (!maybeFound.$) {
				var found = maybeFound.a;
				return $elm$core$Maybe$Just(found);
			} else {
				return a;
			}
		});
	return A3($elm$core$List$foldl, process, $elm$core$Maybe$Nothing, maybes);
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegexToMatch = F2(
	function (matchModel, regexMatch) {
		var _v0 = regexMatch.cE;
		if ((((_v0.b && _v0.b.b) && _v0.b.b.b) && _v0.b.b.b.b) && _v0.b.b.b.b.b) {
			var maybeRawUrlAngleBrackets = _v0.a;
			var _v1 = _v0.b;
			var maybeRawUrlWithoutBrackets = _v1.a;
			var _v2 = _v1.b;
			var maybeTitleSingleQuotes = _v2.a;
			var _v3 = _v2.b;
			var maybeTitleDoubleQuotes = _v3.a;
			var _v4 = _v3.b;
			var maybeTitleParenthesis = _v4.a;
			var maybeTitle = $dillonkearns$elm_markdown$Markdown$Helpers$returnFirstJust(
				_List_fromArray(
					[maybeTitleSingleQuotes, maybeTitleDoubleQuotes, maybeTitleParenthesis]));
			var toMatch = function (rawUrl) {
				return _Utils_update(
					matchModel,
					{
						j: matchModel.j + $elm$core$String$length(regexMatch.a8),
						eS: function () {
							var _v5 = matchModel.eS;
							if (_v5.$ === 5) {
								return $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType;
							} else {
								return $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType;
							}
						}()(
							A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareUrlAndTitle, rawUrl, maybeTitle))
					});
			};
			var maybeRawUrl = $dillonkearns$elm_markdown$Markdown$Helpers$returnFirstJust(
				_List_fromArray(
					[maybeRawUrlAngleBrackets, maybeRawUrlWithoutBrackets]));
			return $elm$core$Maybe$Just(
				toMatch(
					A2($elm$core$Maybe$withDefault, '', maybeRawUrl)));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType = F3(
	function (remainText, _v0, refs) {
		var tempMatch = _v0;
		var _v1 = A3($elm$regex$Regex$findAtMost, 1, $dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegex, remainText);
		if (_v1.b) {
			var first = _v1.a;
			var _v2 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$inlineLinkTypeOrImageTypeRegexToMatch, tempMatch, first);
			if (!_v2.$) {
				var match = _v2.a;
				return $elm$core$Maybe$Just(match);
			} else {
				return A3($dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineReferences, remainText, tempMatch, refs);
			}
		} else {
			return A3($dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineReferences, remainText, tempMatch, refs);
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping = F2(
	function (_v0, remainMatches) {
		var match = _v0;
		var overlappingMatches = $elm$core$List$filter(
			function (_v1) {
				var testMatch = _v1;
				return (_Utils_cmp(match.j, testMatch.l) > 0) && (_Utils_cmp(match.j, testMatch.j) < 0);
			});
		return ($elm$core$List$isEmpty(remainMatches) || $elm$core$List$isEmpty(
			overlappingMatches(remainMatches))) ? $elm$core$Maybe$Just(
			A2($elm$core$List$cons, match, remainMatches)) : $elm$core$Maybe$Nothing;
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$emailRegex = A2(
	$elm$core$Maybe$withDefault,
	$elm$regex$Regex$never,
	$elm$regex$Regex$fromString('^([a-zA-Z0-9.!#$%&\'*+\\/=?^_`{|}~\\-]+@[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?(?:\\.[a-zA-Z0-9](?:[a-zA-Z0-9\\-]{0,61}[a-zA-Z0-9])?)*)$'));
var $dillonkearns$elm_markdown$Markdown$InlineParser$emailAutolinkTypeToMatch = function (_v0) {
	var match = _v0;
	return A2($elm$regex$Regex$contains, $dillonkearns$elm_markdown$Markdown$InlineParser$emailRegex, match.V) ? $elm$core$Result$Ok(
		_Utils_update(
			match,
			{
				eS: $dillonkearns$elm_markdown$Markdown$InlineParser$AutolinkType(
					_Utils_Tuple2(
						match.V,
						'mailto:' + $dillonkearns$elm_markdown$Markdown$InlineParser$encodeUrl(match.V)))
			})) : $elm$core$Result$Err(match);
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$findTokenHelp = F3(
	function (innerTokens, isToken, tokens) {
		findTokenHelp:
		while (true) {
			if (!tokens.b) {
				return $elm$core$Maybe$Nothing;
			} else {
				var nextToken = tokens.a;
				var remainingTokens = tokens.b;
				if (isToken(nextToken)) {
					return $elm$core$Maybe$Just(
						_Utils_Tuple3(
							nextToken,
							$elm$core$List$reverse(innerTokens),
							remainingTokens));
				} else {
					var $temp$innerTokens = A2($elm$core$List$cons, nextToken, innerTokens),
						$temp$isToken = isToken,
						$temp$tokens = remainingTokens;
					innerTokens = $temp$innerTokens;
					isToken = $temp$isToken;
					tokens = $temp$tokens;
					continue findTokenHelp;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$findToken = F2(
	function (isToken, tokens) {
		return A3($dillonkearns$elm_markdown$Markdown$InlineParser$findTokenHelp, _List_Nil, isToken, tokens);
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$HtmlToken = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$NotOpening = 1;
var $elm$parser$Parser$Advanced$getOffset = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.d, s);
};
var $elm$parser$Parser$Advanced$bagToList = F2(
	function (bag, list) {
		bagToList:
		while (true) {
			switch (bag.$) {
				case 0:
					return list;
				case 1:
					var bag1 = bag.a;
					var x = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$core$List$cons, x, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
				default:
					var bag1 = bag.a;
					var bag2 = bag.b;
					var $temp$bag = bag1,
						$temp$list = A2($elm$parser$Parser$Advanced$bagToList, bag2, list);
					bag = $temp$bag;
					list = $temp$list;
					continue bagToList;
			}
		}
	});
var $elm$parser$Parser$Advanced$run = F2(
	function (_v0, src) {
		var parse = _v0;
		var _v1 = parse(
			{c6: 1, i: _List_Nil, k: 1, d: 0, gL: 1, cB: src});
		if (!_v1.$) {
			var value = _v1.b;
			return $elm$core$Result$Ok(value);
		} else {
			var bag = _v1.b;
			return $elm$core$Result$Err(
				A2($elm$parser$Parser$Advanced$bagToList, bag, _List_Nil));
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$htmlToToken = F2(
	function (rawText, _v0) {
		var match = _v0;
		var consumedCharacters = A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					$elm$parser$Parser$Advanced$succeed(
						F3(
							function (startOffset, htmlTag, endOffset) {
								return {ds: htmlTag, cl: endOffset - startOffset};
							})),
					$elm$parser$Parser$Advanced$getOffset),
				$dillonkearns$elm_markdown$HtmlParser$html),
			$elm$parser$Parser$Advanced$getOffset);
		var parsed = A2(
			$elm$parser$Parser$Advanced$run,
			consumedCharacters,
			A2($elm$core$String$dropLeft, match.l, rawText));
		if (!parsed.$) {
			var htmlTag = parsed.a.ds;
			var length = parsed.a.cl;
			var htmlToken = A2($dillonkearns$elm_markdown$Markdown$InlineParser$HtmlToken, 1, htmlTag);
			return $elm$core$Maybe$Just(
				{c: match.l, cl: length, g: htmlToken});
		} else {
			return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$Helpers$ifError = F2(
	function (_function, result) {
		if (!result.$) {
			return result;
		} else {
			var err = result.a;
			return _function(err);
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$isCloseToken = F2(
	function (htmlModel, token) {
		return false;
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$isCodeTokenPair = F2(
	function (closeToken, openToken) {
		var _v0 = openToken.g;
		if (!_v0.$) {
			if (!_v0.a) {
				var _v1 = _v0.a;
				return _Utils_eq(openToken.cl - 1, closeToken.cl);
			} else {
				var _v2 = _v0.a;
				return _Utils_eq(openToken.cl, closeToken.cl);
			}
		} else {
			return false;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$isLinkTypeOrImageOpenToken = function (token) {
	var _v0 = token.g;
	switch (_v0.$) {
		case 1:
			return true;
		case 2:
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken = F2(
	function (closeToken, openToken) {
		var _v0 = openToken.g;
		if (_v0.$ === 7) {
			var openChar = _v0.a;
			var open = _v0.b;
			var _v1 = closeToken.g;
			if (_v1.$ === 7) {
				var closeChar = _v1.a;
				var close = _v1.b;
				return _Utils_eq(openChar, closeChar) ? ((_Utils_eq(open.bI, open.bT) || _Utils_eq(close.bI, close.bT)) ? ((!(!A2($elm$core$Basics$modBy, 3, closeToken.cl + openToken.cl))) || ((!A2($elm$core$Basics$modBy, 3, closeToken.cl)) && (!A2($elm$core$Basics$modBy, 3, openToken.cl)))) : true) : false;
			} else {
				return false;
			}
		} else {
			return false;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$isStrikethroughTokenPair = F2(
	function (closeToken, openToken) {
		var _v0 = function () {
			var _v1 = openToken.g;
			if (_v1.$ === 10) {
				if (!_v1.a) {
					var _v2 = _v1.a;
					return _Utils_Tuple2(true, openToken.cl - 1);
				} else {
					var _v3 = _v1.a;
					return _Utils_Tuple2(true, openToken.cl);
				}
			} else {
				return _Utils_Tuple2(false, 0);
			}
		}();
		var openTokenIsStrikethrough = _v0.a;
		var openTokenLength = _v0.b;
		var _v4 = function () {
			var _v5 = closeToken.g;
			if (_v5.$ === 10) {
				if (!_v5.a) {
					var _v6 = _v5.a;
					return _Utils_Tuple2(true, closeToken.cl - 1);
				} else {
					var _v7 = _v5.a;
					return _Utils_Tuple2(true, closeToken.cl);
				}
			} else {
				return _Utils_Tuple2(false, 0);
			}
		}();
		var closeTokenIsStrikethrough = _v4.a;
		var closeTokenLength = _v4.b;
		return closeTokenIsStrikethrough && (openTokenIsStrikethrough && _Utils_eq(closeTokenLength, openTokenLength));
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakType = {$: 1};
var $dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch = F2(
	function (token, type_) {
		return {j: token.c + token.cl, u: _List_Nil, l: token.c, V: '', G: 0, w: 0, eS: type_};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$lineBreakTTM = F5(
	function (remaining, tokens, matches, refs, rawText) {
		lineBreakTTM:
		while (true) {
			if (!remaining.b) {
				return matches;
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v1 = token.g;
				if (_v1.$ === 9) {
					var $temp$remaining = tokensTail,
						$temp$tokens = tokens,
						$temp$matches = A2(
						$elm$core$List$cons,
						A2($dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch, token, $dillonkearns$elm_markdown$Markdown$InlineParser$HardLineBreakType),
						matches),
						$temp$refs = refs,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					refs = $temp$refs;
					rawText = $temp$rawText;
					continue lineBreakTTM;
				} else {
					var $temp$remaining = tokensTail,
						$temp$tokens = A2($elm$core$List$cons, token, tokens),
						$temp$matches = matches,
						$temp$refs = refs,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					refs = $temp$refs;
					rawText = $temp$rawText;
					continue lineBreakTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens = F2(
	function (_v0, tokensTail) {
		var match = _v0;
		return A2(
			$elm$core$List$filter,
			function (token) {
				return _Utils_cmp(token.c, match.j) > -1;
			},
			tokensTail);
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketsToMatch = F6(
	function (closeToken, escaped, matches, references, rawText, _v46) {
		var openToken = _v46.a;
		var remainTokens = _v46.c;
		var result = A2(
			$dillonkearns$elm_markdown$Markdown$Helpers$ifError,
			$dillonkearns$elm_markdown$Markdown$InlineParser$emailAutolinkTypeToMatch,
			$dillonkearns$elm_markdown$Markdown$InlineParser$autolinkToMatch(
				A7(
					$dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
					references,
					rawText,
					function (s) {
						return s;
					},
					$dillonkearns$elm_markdown$Markdown$InlineParser$CodeType,
					openToken,
					closeToken,
					_List_Nil)));
		if (result.$ === 1) {
			var tempMatch = result.a;
			if (escaped === 1) {
				var _v49 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$htmlToToken, rawText, tempMatch);
				if (!_v49.$) {
					var newToken = _v49.a;
					return $elm$core$Maybe$Just(
						_Utils_Tuple2(
							A2($elm$core$List$cons, newToken, remainTokens),
							matches));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			} else {
				return $elm$core$Maybe$Nothing;
			}
		} else {
			var newMatch = result.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					remainTokens,
					A2($elm$core$List$cons, newMatch, matches)));
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		codeAutolinkTypeHtmlTagTTM:
		while (true) {
			if (!remaining.b) {
				return A5(
					$dillonkearns$elm_markdown$Markdown$InlineParser$htmlElementTTM,
					$elm$core$List$reverse(tokens),
					_List_Nil,
					matches,
					references,
					rawText);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v38 = token.g;
				switch (_v38.$) {
					case 0:
						var isEscaped = _v38.a;
						var _v39 = A2(
							$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
							$dillonkearns$elm_markdown$Markdown$InlineParser$isCodeTokenPair(token),
							tokens);
						if (!_v39.$) {
							var code = _v39.a;
							var _v40 = A5($dillonkearns$elm_markdown$Markdown$InlineParser$codeToMatch, token, matches, references, rawText, code);
							var newTokens = _v40.a;
							var newMatches = _v40.b;
							var $temp$remaining = tokensTail,
								$temp$tokens = newTokens,
								$temp$matches = newMatches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue codeAutolinkTypeHtmlTagTTM;
						} else {
							var $temp$remaining = tokensTail,
								$temp$tokens = A2($elm$core$List$cons, token, tokens),
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue codeAutolinkTypeHtmlTagTTM;
						}
					case 5:
						var isEscaped = _v38.a;
						var isAngleBracketOpen = function (_v45) {
							var meaning = _v45.g;
							if (meaning.$ === 4) {
								return true;
							} else {
								return false;
							}
						};
						var _v41 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$findToken, isAngleBracketOpen, tokens);
						if (!_v41.$) {
							var found = _v41.a;
							var _v42 = A6($dillonkearns$elm_markdown$Markdown$InlineParser$angleBracketsToMatch, token, isEscaped, matches, references, rawText, found);
							if (!_v42.$) {
								var _v43 = _v42.a;
								var newTokens = _v43.a;
								var newMatches = _v43.b;
								var $temp$remaining = tokensTail,
									$temp$tokens = A2(
									$elm$core$List$filter,
									A2($elm$core$Basics$composeL, $elm$core$Basics$not, isAngleBracketOpen),
									newTokens),
									$temp$matches = newMatches,
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue codeAutolinkTypeHtmlTagTTM;
							} else {
								var $temp$remaining = tokensTail,
									$temp$tokens = A2(
									$elm$core$List$filter,
									A2($elm$core$Basics$composeL, $elm$core$Basics$not, isAngleBracketOpen),
									tokens),
									$temp$matches = matches,
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue codeAutolinkTypeHtmlTagTTM;
							}
						} else {
							var $temp$remaining = tokensTail,
								$temp$tokens = A2(
								$elm$core$List$filter,
								A2($elm$core$Basics$composeL, $elm$core$Basics$not, isAngleBracketOpen),
								tokens),
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue codeAutolinkTypeHtmlTagTTM;
						}
					default:
						var $temp$remaining = tokensTail,
							$temp$tokens = A2($elm$core$List$cons, token, tokens),
							$temp$matches = matches,
							$temp$references = references,
							$temp$rawText = rawText;
						remaining = $temp$remaining;
						tokens = $temp$tokens;
						matches = $temp$matches;
						references = $temp$references;
						rawText = $temp$rawText;
						continue codeAutolinkTypeHtmlTagTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$codeToMatch = F5(
	function (closeToken, matches, references, rawText, _v34) {
		var openToken = _v34.a;
		var remainTokens = _v34.c;
		var updatedOpenToken = function () {
			var _v35 = openToken.g;
			if ((!_v35.$) && (!_v35.a)) {
				var _v36 = _v35.a;
				return _Utils_update(
					openToken,
					{c: openToken.c + 1, cl: openToken.cl - 1});
			} else {
				return openToken;
			}
		}();
		var match = A7($dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch, references, rawText, $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces, $dillonkearns$elm_markdown$Markdown$InlineParser$CodeType, updatedOpenToken, closeToken, _List_Nil);
		return _Utils_Tuple2(
			remainTokens,
			A2($elm$core$List$cons, match, matches));
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$emphasisTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		emphasisTTM:
		while (true) {
			if (!remaining.b) {
				return A5(
					$dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTTM,
					$elm$core$List$reverse(tokens),
					_List_Nil,
					matches,
					references,
					rawText);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v29 = token.g;
				if (_v29.$ === 7) {
					var _char = _v29.a;
					var leftFringeRank = _v29.b.bI;
					var rightFringeRank = _v29.b.bT;
					if (_Utils_eq(leftFringeRank, rightFringeRank)) {
						if ((!(!rightFringeRank)) && ((_char !== '_') || (rightFringeRank === 1))) {
							var _v30 = A2(
								$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
								$dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken(token),
								tokens);
							if (!_v30.$) {
								var found = _v30.a;
								var _v31 = A5($dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch, references, rawText, token, tokensTail, found);
								var newRemaining = _v31.a;
								var match = _v31.b;
								var newTokens = _v31.c;
								var $temp$remaining = newRemaining,
									$temp$tokens = newTokens,
									$temp$matches = A2($elm$core$List$cons, match, matches),
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue emphasisTTM;
							} else {
								var $temp$remaining = tokensTail,
									$temp$tokens = A2($elm$core$List$cons, token, tokens),
									$temp$matches = matches,
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue emphasisTTM;
							}
						} else {
							var $temp$remaining = tokensTail,
								$temp$tokens = tokens,
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue emphasisTTM;
						}
					} else {
						if (_Utils_cmp(leftFringeRank, rightFringeRank) < 0) {
							var $temp$remaining = tokensTail,
								$temp$tokens = A2($elm$core$List$cons, token, tokens),
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue emphasisTTM;
						} else {
							var _v32 = A2(
								$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
								$dillonkearns$elm_markdown$Markdown$InlineParser$isOpenEmphasisToken(token),
								tokens);
							if (!_v32.$) {
								var found = _v32.a;
								var _v33 = A5($dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch, references, rawText, token, tokensTail, found);
								var newRemaining = _v33.a;
								var match = _v33.b;
								var newTokens = _v33.c;
								var $temp$remaining = newRemaining,
									$temp$tokens = newTokens,
									$temp$matches = A2($elm$core$List$cons, match, matches),
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue emphasisTTM;
							} else {
								var $temp$remaining = tokensTail,
									$temp$tokens = tokens,
									$temp$matches = matches,
									$temp$references = references,
									$temp$rawText = rawText;
								remaining = $temp$remaining;
								tokens = $temp$tokens;
								matches = $temp$matches;
								references = $temp$references;
								rawText = $temp$rawText;
								continue emphasisTTM;
							}
						}
					}
				} else {
					var $temp$remaining = tokensTail,
						$temp$tokens = A2($elm$core$List$cons, token, tokens),
						$temp$matches = matches,
						$temp$references = references,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					references = $temp$references;
					rawText = $temp$rawText;
					continue emphasisTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$emphasisToMatch = F5(
	function (references, rawText, closeToken, tokensTail, _v27) {
		var openToken = _v27.a;
		var innerTokens = _v27.b;
		var remainTokens = _v27.c;
		var remainLength = openToken.cl - closeToken.cl;
		var updt = (!remainLength) ? {bx: closeToken, a9: openToken, bP: remainTokens, b0: tokensTail} : ((remainLength > 0) ? {
			bx: closeToken,
			a9: _Utils_update(
				openToken,
				{c: openToken.c + remainLength, cl: closeToken.cl}),
			bP: A2(
				$elm$core$List$cons,
				_Utils_update(
					openToken,
					{cl: remainLength}),
				remainTokens),
			b0: tokensTail
		} : {
			bx: _Utils_update(
				closeToken,
				{cl: openToken.cl}),
			a9: openToken,
			bP: remainTokens,
			b0: A2(
				$elm$core$List$cons,
				_Utils_update(
					closeToken,
					{c: closeToken.c + openToken.cl, cl: -remainLength}),
				tokensTail)
		});
		var match = A7(
			$dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
			references,
			rawText,
			function (s) {
				return s;
			},
			$dillonkearns$elm_markdown$Markdown$InlineParser$EmphasisType(updt.a9.cl),
			updt.a9,
			updt.bx,
			$elm$core$List$reverse(innerTokens));
		return _Utils_Tuple3(updt.b0, match, updt.bP);
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$htmlElementTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		htmlElementTTM:
		while (true) {
			if (!remaining.b) {
				return A5(
					$dillonkearns$elm_markdown$Markdown$InlineParser$linkImageTypeTTM,
					$elm$core$List$reverse(tokens),
					_List_Nil,
					matches,
					references,
					rawText);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v23 = token.g;
				if (_v23.$ === 6) {
					var isOpen = _v23.a;
					var htmlModel = _v23.b;
					if (isOpen === 1) {
						var $temp$remaining = tokensTail,
							$temp$tokens = tokens,
							$temp$matches = A2(
							$elm$core$List$cons,
							A2(
								$dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch,
								token,
								$dillonkearns$elm_markdown$Markdown$InlineParser$HtmlType(htmlModel)),
							matches),
							$temp$references = references,
							$temp$rawText = rawText;
						remaining = $temp$remaining;
						tokens = $temp$tokens;
						matches = $temp$matches;
						references = $temp$references;
						rawText = $temp$rawText;
						continue htmlElementTTM;
					} else {
						var _v25 = A2(
							$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
							$dillonkearns$elm_markdown$Markdown$InlineParser$isCloseToken(htmlModel),
							tokensTail);
						if (_v25.$ === 1) {
							var $temp$remaining = tokensTail,
								$temp$tokens = tokens,
								$temp$matches = A2(
								$elm$core$List$cons,
								A2(
									$dillonkearns$elm_markdown$Markdown$InlineParser$tokenToMatch,
									token,
									$dillonkearns$elm_markdown$Markdown$InlineParser$HtmlType(htmlModel)),
								matches),
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue htmlElementTTM;
						} else {
							var _v26 = _v25.a;
							var closeToken = _v26.a;
							var innerTokens = _v26.b;
							var newTail = _v26.c;
							var newMatch = A7(
								$dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
								references,
								rawText,
								function (s) {
									return s;
								},
								$dillonkearns$elm_markdown$Markdown$InlineParser$HtmlType(htmlModel),
								token,
								closeToken,
								innerTokens);
							var $temp$remaining = newTail,
								$temp$tokens = tokens,
								$temp$matches = A2($elm$core$List$cons, newMatch, matches),
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue htmlElementTTM;
						}
					}
				} else {
					var $temp$remaining = tokensTail,
						$temp$tokens = A2($elm$core$List$cons, token, tokens),
						$temp$matches = matches,
						$temp$references = references,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					references = $temp$references;
					rawText = $temp$rawText;
					continue htmlElementTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$linkImageTypeTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		linkImageTypeTTM:
		while (true) {
			if (!remaining.b) {
				return A5(
					$dillonkearns$elm_markdown$Markdown$InlineParser$emphasisTTM,
					$elm$core$List$reverse(tokens),
					_List_Nil,
					matches,
					references,
					rawText);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v18 = token.g;
				if (_v18.$ === 3) {
					var _v19 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$findToken, $dillonkearns$elm_markdown$Markdown$InlineParser$isLinkTypeOrImageOpenToken, tokens);
					if (!_v19.$) {
						var found = _v19.a;
						var _v20 = A6($dillonkearns$elm_markdown$Markdown$InlineParser$linkOrImageTypeToMatch, token, tokensTail, matches, references, rawText, found);
						if (!_v20.$) {
							var _v21 = _v20.a;
							var x = _v21.a;
							var newMatches = _v21.b;
							var newTokens = _v21.c;
							var $temp$remaining = x,
								$temp$tokens = newTokens,
								$temp$matches = newMatches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue linkImageTypeTTM;
						} else {
							var $temp$remaining = tokensTail,
								$temp$tokens = tokens,
								$temp$matches = matches,
								$temp$references = references,
								$temp$rawText = rawText;
							remaining = $temp$remaining;
							tokens = $temp$tokens;
							matches = $temp$matches;
							references = $temp$references;
							rawText = $temp$rawText;
							continue linkImageTypeTTM;
						}
					} else {
						var $temp$remaining = tokensTail,
							$temp$tokens = tokens,
							$temp$matches = matches,
							$temp$references = references,
							$temp$rawText = rawText;
						remaining = $temp$remaining;
						tokens = $temp$tokens;
						matches = $temp$matches;
						references = $temp$references;
						rawText = $temp$rawText;
						continue linkImageTypeTTM;
					}
				} else {
					var $temp$remaining = tokensTail,
						$temp$tokens = A2($elm$core$List$cons, token, tokens),
						$temp$matches = matches,
						$temp$references = references,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					references = $temp$references;
					rawText = $temp$rawText;
					continue linkImageTypeTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$linkOrImageTypeToMatch = F6(
	function (closeToken, tokensTail, oldMatches, references, rawText, _v8) {
		var openToken = _v8.a;
		var innerTokens = _v8.b;
		var remainTokens = _v8.c;
		var removeOpenToken = _Utils_Tuple3(
			tokensTail,
			oldMatches,
			_Utils_ap(innerTokens, remainTokens));
		var remainText = A2($elm$core$String$dropLeft, closeToken.c + 1, rawText);
		var inactivateLinkOpenToken = function (token) {
			var _v16 = token.g;
			if (_v16.$ === 1) {
				return _Utils_update(
					token,
					{
						g: $dillonkearns$elm_markdown$Markdown$InlineParser$LinkOpenToken(1)
					});
			} else {
				return token;
			}
		};
		var findTempMatch = function (isLinkType) {
			return A7(
				$dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch,
				references,
				rawText,
				function (s) {
					return s;
				},
				isLinkType ? $dillonkearns$elm_markdown$Markdown$InlineParser$LinkType(
					_Utils_Tuple2('', $elm$core$Maybe$Nothing)) : $dillonkearns$elm_markdown$Markdown$InlineParser$ImageType(
					_Utils_Tuple2('', $elm$core$Maybe$Nothing)),
				openToken,
				closeToken,
				$elm$core$List$reverse(innerTokens));
		};
		var _v9 = openToken.g;
		switch (_v9.$) {
			case 2:
				var tempMatch = findTempMatch(false);
				var _v10 = A3($dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType, remainText, tempMatch, references);
				if (_v10.$ === 1) {
					return $elm$core$Maybe$Just(removeOpenToken);
				} else {
					var match = _v10.a;
					var _v11 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping, match, oldMatches);
					if (!_v11.$) {
						var matches = _v11.a;
						return $elm$core$Maybe$Just(
							_Utils_Tuple3(
								A2($dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens, match, tokensTail),
								matches,
								remainTokens));
					} else {
						return $elm$core$Maybe$Just(removeOpenToken);
					}
				}
			case 1:
				if (!_v9.a) {
					var _v12 = _v9.a;
					var tempMatch = findTempMatch(true);
					var _v13 = A3($dillonkearns$elm_markdown$Markdown$InlineParser$checkForInlineLinkTypeOrImageType, remainText, tempMatch, references);
					if (_v13.$ === 1) {
						return $elm$core$Maybe$Just(removeOpenToken);
					} else {
						var match = _v13.a;
						var _v14 = A2($dillonkearns$elm_markdown$Markdown$InlineParser$checkParsedAheadOverlapping, match, oldMatches);
						if (!_v14.$) {
							var matches = _v14.a;
							return $elm$core$Maybe$Just(
								_Utils_Tuple3(
									A2($dillonkearns$elm_markdown$Markdown$InlineParser$removeParsedAheadTokens, match, tokensTail),
									matches,
									A2($elm$core$List$map, inactivateLinkOpenToken, remainTokens)));
						} else {
							return $elm$core$Maybe$Just(removeOpenToken);
						}
					}
				} else {
					var _v15 = _v9.a;
					return $elm$core$Maybe$Just(removeOpenToken);
				}
			default:
				return $elm$core$Maybe$Nothing;
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughTTM = F5(
	function (remaining, tokens, matches, references, rawText) {
		strikethroughTTM:
		while (true) {
			if (!remaining.b) {
				return A5(
					$dillonkearns$elm_markdown$Markdown$InlineParser$lineBreakTTM,
					$elm$core$List$reverse(tokens),
					_List_Nil,
					matches,
					references,
					rawText);
			} else {
				var token = remaining.a;
				var tokensTail = remaining.b;
				var _v5 = token.g;
				if (_v5.$ === 10) {
					var isEscaped = _v5.a;
					var _v6 = A2(
						$dillonkearns$elm_markdown$Markdown$InlineParser$findToken,
						$dillonkearns$elm_markdown$Markdown$InlineParser$isStrikethroughTokenPair(token),
						tokens);
					if (!_v6.$) {
						var content = _v6.a;
						var _v7 = A5($dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughToMatch, token, matches, references, rawText, content);
						var newTokens = _v7.a;
						var newMatches = _v7.b;
						var $temp$remaining = tokensTail,
							$temp$tokens = newTokens,
							$temp$matches = newMatches,
							$temp$references = references,
							$temp$rawText = rawText;
						remaining = $temp$remaining;
						tokens = $temp$tokens;
						matches = $temp$matches;
						references = $temp$references;
						rawText = $temp$rawText;
						continue strikethroughTTM;
					} else {
						var $temp$remaining = tokensTail,
							$temp$tokens = A2($elm$core$List$cons, token, tokens),
							$temp$matches = matches,
							$temp$references = references,
							$temp$rawText = rawText;
						remaining = $temp$remaining;
						tokens = $temp$tokens;
						matches = $temp$matches;
						references = $temp$references;
						rawText = $temp$rawText;
						continue strikethroughTTM;
					}
				} else {
					var $temp$remaining = tokensTail,
						$temp$tokens = A2($elm$core$List$cons, token, tokens),
						$temp$matches = matches,
						$temp$references = references,
						$temp$rawText = rawText;
					remaining = $temp$remaining;
					tokens = $temp$tokens;
					matches = $temp$matches;
					references = $temp$references;
					rawText = $temp$rawText;
					continue strikethroughTTM;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$strikethroughToMatch = F5(
	function (closeToken, matches, references, rawText, _v1) {
		var openToken = _v1.a;
		var remainTokens = _v1.c;
		var updatedOpenToken = function () {
			var _v2 = openToken.g;
			if ((_v2.$ === 10) && (!_v2.a)) {
				var _v3 = _v2.a;
				return _Utils_update(
					openToken,
					{c: openToken.c + 1, cl: openToken.cl - 1});
			} else {
				return openToken;
			}
		}();
		var match = A7($dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch, references, rawText, $dillonkearns$elm_markdown$Markdown$Helpers$cleanWhitespaces, $dillonkearns$elm_markdown$Markdown$InlineParser$StrikethroughType, updatedOpenToken, closeToken, _List_Nil);
		return _Utils_Tuple2(
			remainTokens,
			A2($elm$core$List$cons, match, matches));
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$tokenPairToMatch = F7(
	function (references, rawText, processText, type_, openToken, closeToken, innerTokens) {
		var textStart = openToken.c + openToken.cl;
		var textEnd = closeToken.c;
		var text = processText(
			A3($elm$core$String$slice, textStart, textEnd, rawText));
		var start = openToken.c;
		var end = closeToken.c + closeToken.cl;
		var match = {j: end, u: _List_Nil, l: start, V: text, G: textEnd, w: textStart, eS: type_};
		var matches = A2(
			$elm$core$List$map,
			function (_v0) {
				var matchModel = _v0;
				return A2($dillonkearns$elm_markdown$Markdown$InlineParser$prepareChildMatch, match, matchModel);
			},
			A4($dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches, innerTokens, _List_Nil, references, rawText));
		return {j: end, u: matches, l: start, V: text, G: textEnd, w: textStart, eS: type_};
	});
var $dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches = F4(
	function (tokens, matches, references, rawText) {
		return A5($dillonkearns$elm_markdown$Markdown$InlineParser$codeAutolinkTypeHtmlTagTTM, tokens, _List_Nil, matches, references, rawText);
	});
var $elm$core$String$trim = _String_trim;
var $dillonkearns$elm_markdown$Markdown$InlineParser$parse = F2(
	function (refs, rawText_) {
		var rawText = $elm$core$String$trim(rawText_);
		var tokens = $dillonkearns$elm_markdown$Markdown$InlineParser$tokenize(rawText);
		return $dillonkearns$elm_markdown$Markdown$InlineParser$matchesToInlines(
			A3(
				$dillonkearns$elm_markdown$Markdown$InlineParser$parseTextMatches,
				rawText,
				_List_Nil,
				$dillonkearns$elm_markdown$Markdown$InlineParser$organizeMatches(
					A4($dillonkearns$elm_markdown$Markdown$InlineParser$tokensToMatches, tokens, _List_Nil, refs, rawText))));
	});
var $dillonkearns$elm_markdown$Markdown$Parser$thisIsDefinitelyNotAnHtmlTag = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			$elm$parser$Parser$Advanced$token(
			A2(
				$elm$parser$Parser$Advanced$Token,
				' ',
				$elm$parser$Parser$Expecting(' '))),
			$elm$parser$Parser$Advanced$token(
			A2(
				$elm$parser$Parser$Advanced$Token,
				'>',
				$elm$parser$Parser$Expecting('>'))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$chompIf,
					$elm$core$Char$isAlpha,
					$elm$parser$Parser$Expecting('Alpha')),
				$elm$parser$Parser$Advanced$chompWhile(
					function (c) {
						return $elm$core$Char$isAlphaNum(c) || (c === '-');
					})),
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							':',
							$elm$parser$Parser$Expecting(':'))),
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'@',
							$elm$parser$Parser$Expecting('@'))),
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'\\',
							$elm$parser$Parser$Expecting('\\'))),
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'+',
							$elm$parser$Parser$Expecting('+'))),
						$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'.',
							$elm$parser$Parser$Expecting('.')))
					])))
		]));
var $dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock = $elm$parser$Parser$Advanced$backtrackable(
	A2(
		$elm$parser$Parser$Advanced$mapChompedString,
		F2(
			function (rawLine, _v0) {
				return $dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(rawLine);
			}),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$token(
						A2(
							$elm$parser$Parser$Advanced$Token,
							'<',
							$elm$parser$Parser$Expecting('<'))),
					$dillonkearns$elm_markdown$Markdown$Parser$thisIsDefinitelyNotAnHtmlTag),
				$dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
			$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)));
var $dillonkearns$elm_markdown$Markdown$Table$TableHeader = $elm$core$Basics$identity;
var $dillonkearns$elm_markdown$Parser$Token$parseString = function (str) {
	return $elm$parser$Parser$Advanced$token(
		A2(
			$elm$parser$Parser$Advanced$Token,
			str,
			$elm$parser$Parser$Expecting(str)));
};
var $dillonkearns$elm_markdown$Markdown$TableParser$parseCellHelper = function (_v0) {
	var curr = _v0.a;
	var acc = _v0.b;
	var _return = A2(
		$elm$core$Maybe$withDefault,
		$elm$parser$Parser$Advanced$Done(acc),
		A2(
			$elm$core$Maybe$map,
			function (cell) {
				return $elm$parser$Parser$Advanced$Done(
					A2($elm$core$List$cons, cell, acc));
			},
			curr));
	var finishCell = A2(
		$elm$core$Maybe$withDefault,
		$elm$parser$Parser$Advanced$Loop(
			_Utils_Tuple2($elm$core$Maybe$Nothing, acc)),
		A2(
			$elm$core$Maybe$map,
			function (cell) {
				return $elm$parser$Parser$Advanced$Loop(
					_Utils_Tuple2(
						$elm$core$Maybe$Nothing,
						A2($elm$core$List$cons, cell, acc)));
			},
			curr));
	var addToCurrent = function (c) {
		return _Utils_ap(
			A2($elm$core$Maybe$withDefault, '', curr),
			c);
	};
	var continueCell = function (c) {
		return $elm$parser$Parser$Advanced$Loop(
			_Utils_Tuple2(
				$elm$core$Maybe$Just(
					addToCurrent(c)),
				acc));
	};
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v1) {
					return _return;
				},
				$dillonkearns$elm_markdown$Parser$Token$parseString('|\n')),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v2) {
					return _return;
				},
				$dillonkearns$elm_markdown$Parser$Token$parseString('\n')),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v3) {
					return _return;
				},
				$elm$parser$Parser$Advanced$end(
					$elm$parser$Parser$Expecting('end'))),
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$backtrackable(
					$elm$parser$Parser$Advanced$succeed(
						continueCell('|'))),
				$dillonkearns$elm_markdown$Parser$Token$parseString('\\\\|')),
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$backtrackable(
					$elm$parser$Parser$Advanced$succeed(
						continueCell('\\'))),
				$dillonkearns$elm_markdown$Parser$Token$parseString('\\\\')),
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$backtrackable(
					$elm$parser$Parser$Advanced$succeed(
						continueCell('|'))),
				$dillonkearns$elm_markdown$Parser$Token$parseString('\\|')),
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$backtrackable(
					$elm$parser$Parser$Advanced$succeed(finishCell)),
				$dillonkearns$elm_markdown$Parser$Token$parseString('|')),
				A2(
				$elm$parser$Parser$Advanced$mapChompedString,
				F2(
					function (_char, _v4) {
						return continueCell(_char);
					}),
				A2(
					$elm$parser$Parser$Advanced$chompIf,
					$elm$core$Basics$always(true),
					$elm$parser$Parser$Problem('No character found')))
			]));
};
var $dillonkearns$elm_markdown$Markdown$TableParser$parseCells = A2(
	$elm$parser$Parser$Advanced$map,
	A2(
		$elm$core$List$foldl,
		F2(
			function (cell, acc) {
				return A2(
					$elm$core$List$cons,
					$elm$core$String$trim(cell),
					acc);
			}),
		_List_Nil),
	A2(
		$elm$parser$Parser$Advanced$loop,
		_Utils_Tuple2($elm$core$Maybe$Nothing, _List_Nil),
		$dillonkearns$elm_markdown$Markdown$TableParser$parseCellHelper));
var $dillonkearns$elm_markdown$Markdown$TableParser$rowParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$dillonkearns$elm_markdown$Parser$Token$parseString('|'),
					$elm$parser$Parser$Advanced$succeed(0)
				]))),
	$dillonkearns$elm_markdown$Markdown$TableParser$parseCells);
var $dillonkearns$elm_markdown$Markdown$TableParser$parseHeader = F2(
	function (_v0, headersRow) {
		var columnAlignments = _v0.b;
		var headersWithAlignment = function (headers) {
			return A3(
				$elm$core$List$map2,
				F2(
					function (headerCell, alignment) {
						return {bo: alignment, aN: headerCell};
					}),
				headers,
				columnAlignments);
		};
		var combineHeaderAndDelimiter = function (headers) {
			return _Utils_eq(
				$elm$core$List$length(headers),
				$elm$core$List$length(columnAlignments)) ? $elm$core$Result$Ok(
				headersWithAlignment(headers)) : $elm$core$Result$Err(
				'Tables must have the same number of header columns (' + ($elm$core$String$fromInt(
					$elm$core$List$length(headers)) + (') as delimiter columns (' + ($elm$core$String$fromInt(
					$elm$core$List$length(columnAlignments)) + ')'))));
		};
		var _v1 = A2($elm$parser$Parser$Advanced$run, $dillonkearns$elm_markdown$Markdown$TableParser$rowParser, headersRow);
		if (!_v1.$) {
			var headers = _v1.a;
			return combineHeaderAndDelimiter(headers);
		} else {
			return $elm$core$Result$Err('Unable to parse previous line as a table header');
		}
	});
var $dillonkearns$elm_markdown$Markdown$CodeBlock$CodeBlock = F2(
	function (language, body) {
		return {e6: body, ck: language};
	});
var $dillonkearns$elm_markdown$Markdown$CodeBlock$infoString = function (fenceCharacter) {
	var toInfoString = F2(
		function (str, _v2) {
			var _v1 = $elm$core$String$trim(str);
			if (_v1 === '') {
				return $elm$core$Maybe$Nothing;
			} else {
				var trimmed = _v1;
				return $elm$core$Maybe$Just(trimmed);
			}
		});
	var _v0 = fenceCharacter.bH;
	if (!_v0) {
		return A2(
			$elm$parser$Parser$Advanced$mapChompedString,
			toInfoString,
			$elm$parser$Parser$Advanced$chompWhile(
				function (c) {
					return (c !== '`') && (!$dillonkearns$elm_markdown$Whitespace$isLineEnd(c));
				}));
	} else {
		return A2(
			$elm$parser$Parser$Advanced$mapChompedString,
			toInfoString,
			$elm$parser$Parser$Advanced$chompWhile(
				A2($elm$core$Basics$composeL, $elm$core$Basics$not, $dillonkearns$elm_markdown$Whitespace$isLineEnd)));
	}
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$Backtick = 0;
var $dillonkearns$elm_markdown$Parser$Token$backtick = A2(
	$elm$parser$Parser$Advanced$Token,
	'`',
	$elm$parser$Parser$Expecting('a \'`\''));
var $dillonkearns$elm_markdown$Markdown$CodeBlock$backtick = {bu: '`', bH: 0, b$: $dillonkearns$elm_markdown$Parser$Token$backtick};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$colToIndentation = function (_int) {
	switch (_int) {
		case 1:
			return $elm$parser$Parser$Advanced$succeed(0);
		case 2:
			return $elm$parser$Parser$Advanced$succeed(1);
		case 3:
			return $elm$parser$Parser$Advanced$succeed(2);
		case 4:
			return $elm$parser$Parser$Advanced$succeed(3);
		default:
			return $elm$parser$Parser$Advanced$problem(
				$elm$parser$Parser$Expecting('Fenced code blocks should be indented no more than 3 spaces'));
	}
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast = F2(
	function (minLength, fenceCharacter) {
		var builtTokens = A3(
			$elm$core$List$foldl,
			F2(
				function (t, p) {
					return A2($elm$parser$Parser$Advanced$ignorer, p, t);
				}),
			$elm$parser$Parser$Advanced$succeed(0),
			A2(
				$elm$core$List$repeat,
				minLength,
				$elm$parser$Parser$Advanced$token(fenceCharacter.b$)));
		return A2(
			$elm$parser$Parser$Advanced$mapChompedString,
			F2(
				function (str, _v0) {
					return _Utils_Tuple2(
						fenceCharacter,
						$elm$core$String$length(str));
				}),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				builtTokens,
				$elm$parser$Parser$Advanced$chompWhile(
					$elm$core$Basics$eq(fenceCharacter.bu))));
	});
var $dillonkearns$elm_markdown$Markdown$CodeBlock$Tilde = 1;
var $dillonkearns$elm_markdown$Parser$Token$tilde = A2(
	$elm$parser$Parser$Advanced$Token,
	'~',
	$elm$parser$Parser$Expecting('a `~`'));
var $dillonkearns$elm_markdown$Markdown$CodeBlock$tilde = {bu: '~', bH: 1, b$: $dillonkearns$elm_markdown$Parser$Token$tilde};
var $dillonkearns$elm_markdown$Whitespace$upToThreeSpaces = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$dillonkearns$elm_markdown$Whitespace$space,
				$elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							$dillonkearns$elm_markdown$Whitespace$space,
							$elm$parser$Parser$Advanced$succeed(0)
						]))),
			$elm$parser$Parser$Advanced$oneOf(
				_List_fromArray(
					[
						$dillonkearns$elm_markdown$Whitespace$space,
						$elm$parser$Parser$Advanced$succeed(0)
					]))),
			$elm$parser$Parser$Advanced$succeed(0)
		]));
var $dillonkearns$elm_markdown$Markdown$CodeBlock$openingFence = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(
				F2(
					function (indent, _v0) {
						var character = _v0.a;
						var length = _v0.b;
						return {bv: character, ci: indent, cl: length};
					})),
			$dillonkearns$elm_markdown$Whitespace$upToThreeSpaces),
		A2($elm$parser$Parser$Advanced$andThen, $dillonkearns$elm_markdown$Markdown$CodeBlock$colToIndentation, $elm$parser$Parser$Advanced$getCol)),
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2($dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast, 3, $dillonkearns$elm_markdown$Markdown$CodeBlock$backtick),
				A2($dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast, 3, $dillonkearns$elm_markdown$Markdown$CodeBlock$tilde)
			])));
var $elm$parser$Parser$ExpectingEnd = {$: 10};
var $dillonkearns$elm_markdown$Whitespace$isSpace = $elm$core$Basics$eq(' ');
var $dillonkearns$elm_markdown$Markdown$CodeBlock$closingFence = F2(
	function (minLength, fenceCharacter) {
		return A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed(0),
						$dillonkearns$elm_markdown$Whitespace$upToThreeSpaces),
					A2($dillonkearns$elm_markdown$Markdown$CodeBlock$fenceOfAtLeast, minLength, fenceCharacter)),
				$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpace)),
			$dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
	});
var $dillonkearns$elm_markdown$Markdown$CodeBlock$codeBlockLine = function (indented) {
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
			A2($dillonkearns$elm_markdown$Parser$Extra$upTo, indented, $dillonkearns$elm_markdown$Whitespace$space)),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2($elm$parser$Parser$Advanced$ignorer, $elm$parser$Parser$Advanced$getOffset, $dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
			$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
};
var $elm$parser$Parser$Advanced$getSource = function (s) {
	return A3($elm$parser$Parser$Advanced$Good, false, s.cB, s);
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlockHelp = function (_v0) {
	var fence = _v0.a;
	var body = _v0.b;
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed(
					$elm$parser$Parser$Advanced$Done(body)),
				$elm$parser$Parser$Advanced$end($elm$parser$Parser$ExpectingEnd)),
				A2(
				$elm$parser$Parser$Advanced$mapChompedString,
				F2(
					function (lineEnd, _v1) {
						return $elm$parser$Parser$Advanced$Loop(
							_Utils_Tuple2(
								fence,
								_Utils_ap(body, lineEnd)));
					}),
				$dillonkearns$elm_markdown$Whitespace$lineEnd),
				$elm$parser$Parser$Advanced$backtrackable(
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed(
						$elm$parser$Parser$Advanced$Done(body)),
					A2($dillonkearns$elm_markdown$Markdown$CodeBlock$closingFence, fence.cl, fence.bv))),
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					A2(
						$elm$parser$Parser$Advanced$keeper,
						$elm$parser$Parser$Advanced$succeed(
							F3(
								function (start, end, source) {
									return $elm$parser$Parser$Advanced$Loop(
										_Utils_Tuple2(
											fence,
											_Utils_ap(
												body,
												A3($elm$core$String$slice, start, end, source))));
								})),
						$dillonkearns$elm_markdown$Markdown$CodeBlock$codeBlockLine(fence.ci)),
					$elm$parser$Parser$Advanced$getOffset),
				$elm$parser$Parser$Advanced$getSource)
			]));
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlock = function (fence) {
	return A2(
		$elm$parser$Parser$Advanced$loop,
		_Utils_Tuple2(fence, ''),
		$dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlockHelp);
};
var $dillonkearns$elm_markdown$Markdown$CodeBlock$parser = A2(
	$elm$parser$Parser$Advanced$andThen,
	function (fence) {
		return A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$CodeBlock$CodeBlock),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$dillonkearns$elm_markdown$Markdown$CodeBlock$infoString(fence.bv),
					$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)),
			$dillonkearns$elm_markdown$Markdown$CodeBlock$remainingBlock(fence));
	},
	$dillonkearns$elm_markdown$Markdown$CodeBlock$openingFence);
var $elm$core$String$dropRight = F2(
	function (n, string) {
		return (n < 1) ? string : A3($elm$core$String$slice, 0, -n, string);
	});
var $elm$core$String$endsWith = _String_endsWith;
var $dillonkearns$elm_markdown$Markdown$Heading$dropTrailingHashes = function (headingString) {
	return A2($elm$core$String$endsWith, '#', headingString) ? $dillonkearns$elm_markdown$Markdown$Heading$dropTrailingHashes(
		A2($elm$core$String$dropRight, 1, headingString)) : headingString;
};
var $elm$core$String$trimRight = _String_trimRight;
var $dillonkearns$elm_markdown$Markdown$Heading$dropClosingSequence = function (headingString) {
	var droppedTrailingHashesString = $dillonkearns$elm_markdown$Markdown$Heading$dropTrailingHashes(headingString);
	return (A2($elm$core$String$endsWith, ' ', droppedTrailingHashesString) || $elm$core$String$isEmpty(droppedTrailingHashesString)) ? $elm$core$String$trimRight(droppedTrailingHashesString) : headingString;
};
var $dillonkearns$elm_markdown$Parser$Token$hash = A2(
	$elm$parser$Parser$Advanced$Token,
	'#',
	$elm$parser$Parser$Expecting('a `#`'));
var $dillonkearns$elm_markdown$Markdown$Heading$isHash = function (c) {
	if ('#' === c) {
		return true;
	} else {
		return false;
	}
};
var $elm$parser$Parser$Advanced$spaces = $elm$parser$Parser$Advanced$chompWhile(
	function (c) {
		return (c === ' ') || ((c === '\n') || (c === '\r'));
	});
var $dillonkearns$elm_markdown$Markdown$Heading$parser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$RawBlock$Heading),
				A2(
					$elm$parser$Parser$Advanced$andThen,
					function (startingSpaces) {
						var startSpace = $elm$core$String$length(startingSpaces);
						return (startSpace >= 4) ? $elm$parser$Parser$Advanced$problem(
							$elm$parser$Parser$Expecting('heading with < 4 spaces in front')) : $elm$parser$Parser$Advanced$succeed(startSpace);
					},
					$elm$parser$Parser$Advanced$getChompedString($elm$parser$Parser$Advanced$spaces))),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$hash)),
		A2(
			$elm$parser$Parser$Advanced$andThen,
			function (additionalHashes) {
				var level = $elm$core$String$length(additionalHashes) + 1;
				return (level >= 7) ? $elm$parser$Parser$Advanced$problem(
					$elm$parser$Parser$Expecting('heading with < 7 #\'s')) : $elm$parser$Parser$Advanced$succeed(level);
			},
			$elm$parser$Parser$Advanced$getChompedString(
				$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Markdown$Heading$isHash)))),
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed(''),
				$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$newline)),
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
					$elm$parser$Parser$Advanced$oneOf(
						_List_fromArray(
							[
								$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$space),
								$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$tab)
							]))),
				A2(
					$elm$parser$Parser$Advanced$mapChompedString,
					F2(
						function (headingText, _v0) {
							return $dillonkearns$elm_markdown$Markdown$Heading$dropClosingSequence(
								$elm$core$String$trim(headingText));
						}),
					$dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd))
			])));
var $elm$parser$Parser$Advanced$findSubString = _Parser_findSubString;
var $elm$parser$Parser$Advanced$fromInfo = F4(
	function (row, col, x, context) {
		return A2(
			$elm$parser$Parser$Advanced$AddRight,
			$elm$parser$Parser$Advanced$Empty,
			A4($elm$parser$Parser$Advanced$DeadEnd, row, col, x, context));
	});
var $elm$parser$Parser$Advanced$chompUntil = function (_v0) {
	var str = _v0.a;
	var expecting = _v0.b;
	return function (s) {
		var _v1 = A5($elm$parser$Parser$Advanced$findSubString, str, s.d, s.gL, s.c6, s.cB);
		var newOffset = _v1.a;
		var newRow = _v1.b;
		var newCol = _v1.c;
		return _Utils_eq(newOffset, -1) ? A2(
			$elm$parser$Parser$Advanced$Bad,
			false,
			A4($elm$parser$Parser$Advanced$fromInfo, newRow, newCol, expecting, s.i)) : A3(
			$elm$parser$Parser$Advanced$Good,
			_Utils_cmp(s.d, newOffset) < 0,
			0,
			{c6: newCol, i: s.i, k: s.k, d: newOffset, gL: newRow, cB: s.cB});
	};
};
var $dillonkearns$elm_markdown$Parser$Token$greaterThan = A2(
	$elm$parser$Parser$Advanced$Token,
	'>',
	$elm$parser$Parser$Expecting('a `>`'));
var $elm$parser$Parser$Advanced$Located = F3(
	function (row, col, context) {
		return {c6: col, i: context, gL: row};
	});
var $elm$parser$Parser$Advanced$changeContext = F2(
	function (newContext, s) {
		return {c6: s.c6, i: newContext, k: s.k, d: s.d, gL: s.gL, cB: s.cB};
	});
var $elm$parser$Parser$Advanced$inContext = F2(
	function (context, _v0) {
		var parse = _v0;
		return function (s0) {
			var _v1 = parse(
				A2(
					$elm$parser$Parser$Advanced$changeContext,
					A2(
						$elm$core$List$cons,
						A3($elm$parser$Parser$Advanced$Located, s0.gL, s0.c6, context),
						s0.i),
					s0));
			if (!_v1.$) {
				var p = _v1.a;
				var a = _v1.b;
				var s1 = _v1.c;
				return A3(
					$elm$parser$Parser$Advanced$Good,
					p,
					a,
					A2($elm$parser$Parser$Advanced$changeContext, s0.i, s1));
			} else {
				var step = _v1;
				return step;
			}
		};
	});
var $dillonkearns$elm_markdown$Whitespace$isWhitespace = function (_char) {
	switch (_char) {
		case ' ':
			return true;
		case '\n':
			return true;
		case '\t':
			return true;
		case '\u000B':
			return true;
		case '\u000C':
			return true;
		case '\r':
			return true;
		default:
			return false;
	}
};
var $dillonkearns$elm_markdown$Parser$Token$lessThan = A2(
	$elm$parser$Parser$Advanced$Token,
	'<',
	$elm$parser$Parser$Expecting('a `<`'));
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$destinationParser = A2(
	$elm$parser$Parser$Advanced$inContext,
	'link destination',
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed($elm$url$Url$percentEncode),
					$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$lessThan)),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$getChompedString(
						$elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$greaterThan)),
					$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$greaterThan))),
				$elm$parser$Parser$Advanced$getChompedString(
				$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore(
					A2($elm$core$Basics$composeL, $elm$core$Basics$not, $dillonkearns$elm_markdown$Whitespace$isWhitespace)))
			])));
var $dillonkearns$elm_markdown$Parser$Token$closingSquareBracket = A2(
	$elm$parser$Parser$Advanced$Token,
	']',
	$elm$parser$Parser$Expecting('a `]`'));
var $dillonkearns$elm_markdown$Parser$Token$openingSquareBracket = A2(
	$elm$parser$Parser$Advanced$Token,
	'[',
	$elm$parser$Parser$Expecting('a `[`'));
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$labelParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$Helpers$prepareRefLabel),
		$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$openingSquareBracket)),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString(
			$elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$closingSquareBracket)),
		$elm$parser$Parser$Advanced$symbol(
			A2(
				$elm$parser$Parser$Advanced$Token,
				']:',
				$elm$parser$Parser$Expecting(']:')))));
var $dillonkearns$elm_markdown$Parser$Token$doubleQuote = A2(
	$elm$parser$Parser$Advanced$Token,
	'\"',
	$elm$parser$Parser$Expecting('a double quote'));
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$hasNoBlankLine = function (str) {
	return A2($elm$core$String$contains, '\n\n', str) ? $elm$parser$Parser$Advanced$problem(
		$elm$parser$Parser$Expecting('no blank line')) : $elm$parser$Parser$Advanced$succeed(str);
};
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline = A2(
	$elm$parser$Parser$Advanced$ignorer,
	$elm$parser$Parser$Advanced$chompWhile(
		function (c) {
			return (!$dillonkearns$elm_markdown$Whitespace$isLineEnd(c)) && $dillonkearns$elm_markdown$Whitespace$isWhitespace(c);
		}),
	$dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
var $dillonkearns$elm_markdown$Whitespace$requiredWhitespace = A2(
	$elm$parser$Parser$Advanced$ignorer,
	A2(
		$elm$parser$Parser$Advanced$chompIf,
		$dillonkearns$elm_markdown$Whitespace$isWhitespace,
		$elm$parser$Parser$Expecting('Required whitespace')),
	$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isWhitespace));
var $dillonkearns$elm_markdown$Parser$Token$singleQuote = A2(
	$elm$parser$Parser$Advanced$Token,
	'\'',
	$elm$parser$Parser$Expecting('a single quote'));
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$titleParser = function () {
	var inSingleQuotes = A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Just),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$singleQuote)),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$andThen,
					$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$hasNoBlankLine,
					$elm$parser$Parser$Advanced$getChompedString(
						$elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$singleQuote))),
				$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$singleQuote)),
			$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline));
	var inDoubleQuotes = A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Just),
			$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$doubleQuote)),
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$andThen,
					$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$hasNoBlankLine,
					$elm$parser$Parser$Advanced$getChompedString(
						$elm$parser$Parser$Advanced$chompUntil($dillonkearns$elm_markdown$Parser$Token$doubleQuote))),
				$elm$parser$Parser$Advanced$symbol($dillonkearns$elm_markdown$Parser$Token$doubleQuote)),
			$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline));
	return A2(
		$elm$parser$Parser$Advanced$inContext,
		'title',
		$elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[
					$elm$parser$Parser$Advanced$backtrackable(
					A2(
						$elm$parser$Parser$Advanced$keeper,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
							$dillonkearns$elm_markdown$Whitespace$requiredWhitespace),
						$elm$parser$Parser$Advanced$oneOf(
							_List_fromArray(
								[
									inDoubleQuotes,
									inSingleQuotes,
									$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Nothing)
								])))),
					A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed($elm$core$Maybe$Nothing),
					$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$onlyWhitespaceTillNewline)
				])));
}();
var $dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$parser = A2(
	$elm$parser$Parser$Advanced$inContext,
	'link reference definition',
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed(
						F3(
							function (label, destination, title) {
								return _Utils_Tuple2(
									label,
									{dc: destination, g4: title});
							})),
					$dillonkearns$elm_markdown$Whitespace$upToThreeSpaces),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$labelParser,
							$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
						$elm$parser$Parser$Advanced$oneOf(
							_List_fromArray(
								[
									$dillonkearns$elm_markdown$Whitespace$lineEnd,
									$elm$parser$Parser$Advanced$succeed(0)
								]))),
					$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab))),
			$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$destinationParser),
		$dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$titleParser));
var $dillonkearns$elm_markdown$ThematicBreak$ThematicBreak = 0;
var $dillonkearns$elm_markdown$ThematicBreak$whitespace = $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab);
var $dillonkearns$elm_markdown$ThematicBreak$withChar = function (tchar) {
	var token = $dillonkearns$elm_markdown$Parser$Token$parseString(
		$elm$core$String$fromChar(tchar));
	return A2(
		$elm$parser$Parser$Advanced$ignorer,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							A2(
								$elm$parser$Parser$Advanced$ignorer,
								$elm$parser$Parser$Advanced$succeed(0),
								token),
							$dillonkearns$elm_markdown$ThematicBreak$whitespace),
						token),
					$dillonkearns$elm_markdown$ThematicBreak$whitespace),
				token),
			$elm$parser$Parser$Advanced$chompWhile(
				function (c) {
					return _Utils_eq(c, tchar) || $dillonkearns$elm_markdown$Whitespace$isSpaceOrTab(c);
				})),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd);
};
var $dillonkearns$elm_markdown$ThematicBreak$parseThematicBreak = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			$dillonkearns$elm_markdown$ThematicBreak$withChar('-'),
			$dillonkearns$elm_markdown$ThematicBreak$withChar('*'),
			$dillonkearns$elm_markdown$ThematicBreak$withChar('_')
		]));
var $dillonkearns$elm_markdown$ThematicBreak$parser = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
						$dillonkearns$elm_markdown$Whitespace$space),
					$elm$parser$Parser$Advanced$oneOf(
						_List_fromArray(
							[
								$dillonkearns$elm_markdown$Whitespace$space,
								$elm$parser$Parser$Advanced$succeed(0)
							]))),
				$elm$parser$Parser$Advanced$oneOf(
					_List_fromArray(
						[
							$dillonkearns$elm_markdown$Whitespace$space,
							$elm$parser$Parser$Advanced$succeed(0)
						]))),
			$dillonkearns$elm_markdown$ThematicBreak$parseThematicBreak),
			$dillonkearns$elm_markdown$ThematicBreak$parseThematicBreak
		]));
var $dillonkearns$elm_markdown$Markdown$RawBlock$LevelOne = 0;
var $dillonkearns$elm_markdown$Markdown$RawBlock$LevelTwo = 1;
var $dillonkearns$elm_markdown$Markdown$RawBlock$SetextLine = F2(
	function (a, b) {
		return {$: 13, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Parser$Token$equals = A2(
	$elm$parser$Parser$Advanced$Token,
	'=',
	$elm$parser$Parser$Expecting('a `=`'));
var $dillonkearns$elm_markdown$Parser$Token$minus = A2(
	$elm$parser$Parser$Advanced$Token,
	'-',
	$elm$parser$Parser$Expecting('a `-`'));
var $dillonkearns$elm_markdown$Markdown$Parser$setextLineParser = function () {
	var setextLevel = F3(
		function (level, levelToken, levelChar) {
			return A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$succeed(level),
					$elm$parser$Parser$Advanced$token(levelToken)),
				$elm$parser$Parser$Advanced$chompWhile(
					$elm$core$Basics$eq(levelChar)));
		});
	return A2(
		$elm$parser$Parser$Advanced$mapChompedString,
		F2(
			function (raw, level) {
				return A2($dillonkearns$elm_markdown$Markdown$RawBlock$SetextLine, level, raw);
			}),
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
				$dillonkearns$elm_markdown$Whitespace$upToThreeSpaces),
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$oneOf(
						_List_fromArray(
							[
								A3(setextLevel, 0, $dillonkearns$elm_markdown$Parser$Token$equals, '='),
								A3(setextLevel, 1, $dillonkearns$elm_markdown$Parser$Token$minus, '-')
							])),
					$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
				$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)));
}();
var $dillonkearns$elm_markdown$Markdown$RawBlock$TableDelimiter = function (a) {
	return {$: 9, a: a};
};
var $dillonkearns$elm_markdown$Markdown$TableParser$chompSinglelineWhitespace = $elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab);
var $dillonkearns$elm_markdown$Parser$Extra$maybeChomp = function (condition) {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$chompIf,
				condition,
				$elm$parser$Parser$Problem('Character not found')),
				$elm$parser$Parser$Advanced$succeed(0)
			]));
};
var $dillonkearns$elm_markdown$Markdown$TableParser$requirePipeIfNotFirst = function (columns) {
	return $elm$core$List$isEmpty(columns) ? $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_markdown$Parser$Token$parseString('|'),
				$elm$parser$Parser$Advanced$succeed(0)
			])) : $dillonkearns$elm_markdown$Parser$Token$parseString('|');
};
var $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowHelp = function (revDelimiterColumns) {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$elm$parser$Parser$Advanced$backtrackable(
				A2(
					$elm$parser$Parser$Advanced$map,
					function (_v0) {
						return $elm$parser$Parser$Advanced$Done(revDelimiterColumns);
					},
					$dillonkearns$elm_markdown$Parser$Token$parseString('|\n'))),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v1) {
					return $elm$parser$Parser$Advanced$Done(revDelimiterColumns);
				},
				$dillonkearns$elm_markdown$Parser$Token$parseString('\n')),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v2) {
					return $elm$parser$Parser$Advanced$Done(revDelimiterColumns);
				},
				$elm$parser$Parser$Advanced$end(
					$elm$parser$Parser$Expecting('end'))),
				$elm$parser$Parser$Advanced$backtrackable(
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed(
							$elm$parser$Parser$Advanced$Done(revDelimiterColumns)),
						$dillonkearns$elm_markdown$Parser$Token$parseString('|')),
					$elm$parser$Parser$Advanced$end(
						$elm$parser$Parser$Expecting('end')))),
				A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					A2(
						$elm$parser$Parser$Advanced$ignorer,
						$elm$parser$Parser$Advanced$succeed(
							function (column) {
								return $elm$parser$Parser$Advanced$Loop(
									A2($elm$core$List$cons, column, revDelimiterColumns));
							}),
						$dillonkearns$elm_markdown$Markdown$TableParser$requirePipeIfNotFirst(revDelimiterColumns)),
					$dillonkearns$elm_markdown$Markdown$TableParser$chompSinglelineWhitespace),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$elm$parser$Parser$Advanced$getChompedString(
						A2(
							$elm$parser$Parser$Advanced$ignorer,
							A2(
								$elm$parser$Parser$Advanced$ignorer,
								A2(
									$elm$parser$Parser$Advanced$ignorer,
									$elm$parser$Parser$Advanced$succeed(0),
									$dillonkearns$elm_markdown$Parser$Extra$maybeChomp(
										function (c) {
											return c === ':';
										})),
								$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore(
									function (c) {
										return c === '-';
									})),
							$dillonkearns$elm_markdown$Parser$Extra$maybeChomp(
								function (c) {
									return c === ':';
								}))),
					$dillonkearns$elm_markdown$Markdown$TableParser$chompSinglelineWhitespace))
			]));
};
var $dillonkearns$elm_markdown$Markdown$Block$AlignCenter = 2;
var $dillonkearns$elm_markdown$Markdown$Block$AlignLeft = 0;
var $dillonkearns$elm_markdown$Markdown$Block$AlignRight = 1;
var $dillonkearns$elm_markdown$Markdown$TableParser$delimiterToAlignment = function (cell) {
	var _v0 = _Utils_Tuple2(
		A2($elm$core$String$startsWith, ':', cell),
		A2($elm$core$String$endsWith, ':', cell));
	if (_v0.a) {
		if (_v0.b) {
			return $elm$core$Maybe$Just(2);
		} else {
			return $elm$core$Maybe$Just(0);
		}
	} else {
		if (_v0.b) {
			return $elm$core$Maybe$Just(1);
		} else {
			return $elm$core$Maybe$Nothing;
		}
	}
};
var $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowParser = A2(
	$elm$parser$Parser$Advanced$andThen,
	function (delimiterRow) {
		var trimmed = delimiterRow.a.eR;
		var headers = delimiterRow.b;
		return $elm$core$List$isEmpty(headers) ? $elm$parser$Parser$Advanced$problem(
			$elm$parser$Parser$Expecting('Must have at least one column in delimiter row.')) : ((($elm$core$List$length(headers) === 1) && (!(A2($elm$core$String$startsWith, '|', trimmed) && A2($elm$core$String$endsWith, '|', trimmed)))) ? $elm$parser$Parser$Advanced$problem(
			$elm$parser$Parser$Problem('Tables with a single column must have pipes at the start and end of the delimiter row to avoid ambiguity.')) : $elm$parser$Parser$Advanced$succeed(delimiterRow));
	},
	A2(
		$elm$parser$Parser$Advanced$mapChompedString,
		F2(
			function (delimiterText, revDelimiterColumns) {
				return A2(
					$dillonkearns$elm_markdown$Markdown$Table$TableDelimiterRow,
					{
						d5: delimiterText,
						eR: $elm$core$String$trim(delimiterText)
					},
					A2(
						$elm$core$List$map,
						$dillonkearns$elm_markdown$Markdown$TableParser$delimiterToAlignment,
						$elm$core$List$reverse(revDelimiterColumns)));
			}),
		A2($elm$parser$Parser$Advanced$loop, _List_Nil, $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowHelp)));
var $dillonkearns$elm_markdown$Markdown$Parser$tableDelimiterInOpenParagraph = A2($elm$parser$Parser$Advanced$map, $dillonkearns$elm_markdown$Markdown$RawBlock$TableDelimiter, $dillonkearns$elm_markdown$Markdown$TableParser$delimiterRowParser);
var $dillonkearns$elm_markdown$Markdown$TableParser$standardizeRowLength = F2(
	function (expectedLength, row) {
		var rowLength = $elm$core$List$length(row);
		var _v0 = A2($elm$core$Basics$compare, expectedLength, rowLength);
		switch (_v0) {
			case 0:
				return A2($elm$core$List$take, expectedLength, row);
			case 1:
				return row;
			default:
				return _Utils_ap(
					row,
					A2($elm$core$List$repeat, expectedLength - rowLength, ''));
		}
	});
var $dillonkearns$elm_markdown$Markdown$TableParser$bodyRowParser = function (expectedRowLength) {
	return A2(
		$elm$parser$Parser$Advanced$andThen,
		function (row) {
			return ($elm$core$List$isEmpty(row) || A2($elm$core$List$all, $elm$core$String$isEmpty, row)) ? $elm$parser$Parser$Advanced$problem(
				$elm$parser$Parser$Problem('A line must have at least one column')) : $elm$parser$Parser$Advanced$succeed(
				A2($dillonkearns$elm_markdown$Markdown$TableParser$standardizeRowLength, expectedRowLength, row));
		},
		$dillonkearns$elm_markdown$Markdown$TableParser$rowParser);
};
var $dillonkearns$elm_markdown$Markdown$Parser$tableRowIfTableStarted = function (_v0) {
	var headers = _v0.a;
	var body = _v0.b;
	return A2(
		$elm$parser$Parser$Advanced$map,
		function (row) {
			return $dillonkearns$elm_markdown$Markdown$RawBlock$Table(
				A2(
					$dillonkearns$elm_markdown$Markdown$Table$Table,
					headers,
					_Utils_ap(
						body,
						_List_fromArray(
							[row]))));
		},
		$dillonkearns$elm_markdown$Markdown$TableParser$bodyRowParser(
			$elm$core$List$length(headers)));
};
var $dillonkearns$elm_markdown$Markdown$Block$H1 = 0;
var $dillonkearns$elm_markdown$Markdown$Block$H2 = 1;
var $dillonkearns$elm_markdown$Markdown$Block$H3 = 2;
var $dillonkearns$elm_markdown$Markdown$Block$H4 = 3;
var $dillonkearns$elm_markdown$Markdown$Block$H5 = 4;
var $dillonkearns$elm_markdown$Markdown$Block$H6 = 5;
var $dillonkearns$elm_markdown$Markdown$Parser$toHeading = function (level) {
	switch (level) {
		case 1:
			return $elm$core$Result$Ok(0);
		case 2:
			return $elm$core$Result$Ok(1);
		case 3:
			return $elm$core$Result$Ok(2);
		case 4:
			return $elm$core$Result$Ok(3);
		case 5:
			return $elm$core$Result$Ok(4);
		case 6:
			return $elm$core$Result$Ok(5);
		default:
			return $elm$core$Result$Err(
				$elm$parser$Parser$Expecting(
					'A heading with 1 to 6 #\'s, but found ' + $elm$core$String$fromInt(level)));
	}
};
var $dillonkearns$elm_markdown$Markdown$ListItem$EmptyItem = {$: 2};
var $dillonkearns$elm_markdown$Markdown$ListItem$PlainItem = function (a) {
	return {$: 1, a: a};
};
var $dillonkearns$elm_markdown$Markdown$ListItem$TaskItem = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $dillonkearns$elm_markdown$Markdown$UnorderedList$getIntendedCodeItem = F4(
	function (markerStartPos, listMarker, markerEndPos, _v0) {
		var bodyStartPos = _v0.a;
		var item = _v0.b;
		var spaceNum = bodyStartPos - markerEndPos;
		if (spaceNum <= 4) {
			return _Utils_Tuple3(listMarker, bodyStartPos - markerStartPos, item);
		} else {
			var intendedCodeItem = function () {
				switch (item.$) {
					case 0:
						var completion = item.a;
						var string = item.b;
						return A2(
							$dillonkearns$elm_markdown$Markdown$ListItem$TaskItem,
							completion,
							_Utils_ap(
								A2($elm$core$String$repeat, spaceNum - 1, ' '),
								string));
					case 1:
						var string = item.a;
						return $dillonkearns$elm_markdown$Markdown$ListItem$PlainItem(
							_Utils_ap(
								A2($elm$core$String$repeat, spaceNum - 1, ' '),
								string));
					default:
						return $dillonkearns$elm_markdown$Markdown$ListItem$EmptyItem;
				}
			}();
			return _Utils_Tuple3(listMarker, (markerEndPos - markerStartPos) + 1, intendedCodeItem);
		}
	});
var $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListEmptyItemParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	$elm$parser$Parser$Advanced$succeed(
		function (bodyStartPos) {
			return _Utils_Tuple2(bodyStartPos, $dillonkearns$elm_markdown$Markdown$ListItem$EmptyItem);
		}),
	A2($elm$parser$Parser$Advanced$ignorer, $elm$parser$Parser$Advanced$getCol, $dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$ListItem$Complete = 1;
var $dillonkearns$elm_markdown$Markdown$ListItem$Incomplete = 0;
var $dillonkearns$elm_markdown$Markdown$ListItem$taskItemParser = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(1),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'[x] ',
					$elm$parser$Parser$ExpectingSymbol('[x] ')))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(1),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'[X] ',
					$elm$parser$Parser$ExpectingSymbol('[X] ')))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(0),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'[ ] ',
					$elm$parser$Parser$ExpectingSymbol('[ ] '))))
		]));
var $dillonkearns$elm_markdown$Markdown$ListItem$parser = A2(
	$elm$parser$Parser$Advanced$keeper,
	$elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$keeper,
				$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$ListItem$TaskItem),
				A2(
					$elm$parser$Parser$Advanced$ignorer,
					$dillonkearns$elm_markdown$Markdown$ListItem$taskItemParser,
					$elm$parser$Parser$Advanced$chompWhile($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab))),
				$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$ListItem$PlainItem)
			])),
	A2(
		$elm$parser$Parser$Advanced$ignorer,
		$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
		$dillonkearns$elm_markdown$Helpers$lineEndOrEnd));
var $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListItemBodyParser = A2(
	$elm$parser$Parser$Advanced$keeper,
	A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(
				F2(
					function (bodyStartPos, item) {
						return _Utils_Tuple2(bodyStartPos, item);
					})),
			$dillonkearns$elm_markdown$Parser$Extra$chompOneOrMore($dillonkearns$elm_markdown$Whitespace$isSpaceOrTab)),
		$elm$parser$Parser$Advanced$getCol),
	$dillonkearns$elm_markdown$Markdown$ListItem$parser);
var $dillonkearns$elm_markdown$Markdown$UnorderedList$Asterisk = 2;
var $dillonkearns$elm_markdown$Markdown$UnorderedList$Minus = 0;
var $dillonkearns$elm_markdown$Markdown$UnorderedList$Plus = 1;
var $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListMarkerParser = $elm$parser$Parser$Advanced$oneOf(
	_List_fromArray(
		[
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			A2(
				$elm$parser$Parser$Advanced$ignorer,
				$elm$parser$Parser$Advanced$succeed(0),
				A2($dillonkearns$elm_markdown$Parser$Extra$upTo, 3, $dillonkearns$elm_markdown$Whitespace$space)),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'-',
					$elm$parser$Parser$ExpectingSymbol('-')))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(1),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'+',
					$elm$parser$Parser$ExpectingSymbol('+')))),
			A2(
			$elm$parser$Parser$Advanced$ignorer,
			$elm$parser$Parser$Advanced$succeed(2),
			$elm$parser$Parser$Advanced$symbol(
				A2(
					$elm$parser$Parser$Advanced$Token,
					'*',
					$elm$parser$Parser$ExpectingSymbol('*'))))
		]));
var $dillonkearns$elm_markdown$Markdown$UnorderedList$parser = function (previousWasBody) {
	return A2(
		$elm$parser$Parser$Advanced$keeper,
		A2(
			$elm$parser$Parser$Advanced$keeper,
			A2(
				$elm$parser$Parser$Advanced$keeper,
				A2(
					$elm$parser$Parser$Advanced$keeper,
					$elm$parser$Parser$Advanced$succeed($dillonkearns$elm_markdown$Markdown$UnorderedList$getIntendedCodeItem),
					$elm$parser$Parser$Advanced$getCol),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListMarkerParser)),
			$elm$parser$Parser$Advanced$getCol),
		previousWasBody ? $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListItemBodyParser : $elm$parser$Parser$Advanced$oneOf(
			_List_fromArray(
				[$dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListEmptyItemParser, $dillonkearns$elm_markdown$Markdown$UnorderedList$unorderedListItemBodyParser])));
};
var $dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock = function (previousWasBody) {
	var parseListItem = F3(
		function (listmarker, intended, unparsedListItem) {
			switch (unparsedListItem.$) {
				case 0:
					var completion = unparsedListItem.a;
					var body = unparsedListItem.b;
					return {
						e6: body,
						fY: listmarker,
						p: $elm$core$Maybe$Just(
							function () {
								if (completion === 1) {
									return true;
								} else {
									return false;
								}
							}())
					};
				case 1:
					var body = unparsedListItem.a;
					return {e6: body, fY: listmarker, p: $elm$core$Maybe$Nothing};
				default:
					return {e6: '', fY: listmarker, p: $elm$core$Maybe$Nothing};
			}
		});
	return A2(
		$elm$parser$Parser$Advanced$map,
		function (_v0) {
			var listmarker = _v0.a;
			var intended = _v0.b;
			var unparsedListItem = _v0.c;
			return A4(
				$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
				true,
				intended,
				_List_Nil,
				A3(parseListItem, listmarker, intended, unparsedListItem));
		},
		$dillonkearns$elm_markdown$Markdown$UnorderedList$parser(previousWasBody));
};
var $elm$core$Result$withDefault = F2(
	function (def, result) {
		if (!result.$) {
			var a = result.a;
			return a;
		} else {
			return def;
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$childToBlocks = F2(
	function (node, blocks) {
		switch (node.$) {
			case 0:
				var tag = node.a;
				var attributes = node.b;
				var children = node.c;
				var _v99 = $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocks(children);
				if (!_v99.$) {
					var childrenAsBlocks = _v99.a;
					var block = $dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
						A3($dillonkearns$elm_markdown$Markdown$Block$HtmlElement, tag, attributes, childrenAsBlocks));
					return $elm$core$Result$Ok(
						A2($elm$core$List$cons, block, blocks));
				} else {
					var err = _v99.a;
					return $elm$core$Result$Err(err);
				}
			case 1:
				var innerText = node.a;
				var _v100 = $dillonkearns$elm_markdown$Markdown$Parser$parse(innerText);
				if (!_v100.$) {
					var value = _v100.a;
					return $elm$core$Result$Ok(
						_Utils_ap(
							$elm$core$List$reverse(value),
							blocks));
				} else {
					var error = _v100.a;
					return $elm$core$Result$Err(
						$elm$parser$Parser$Expecting(
							A2(
								$elm$core$String$join,
								'\n',
								A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$deadEndToString, error))));
				}
			case 2:
				var string = node.a;
				return $elm$core$Result$Ok(
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							$dillonkearns$elm_markdown$Markdown$Block$HtmlComment(string)),
						blocks));
			case 3:
				var string = node.a;
				return $elm$core$Result$Ok(
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							$dillonkearns$elm_markdown$Markdown$Block$Cdata(string)),
						blocks));
			case 4:
				var string = node.a;
				return $elm$core$Result$Ok(
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							$dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction(string)),
						blocks));
			default:
				var declarationType = node.a;
				var content = node.b;
				return $elm$core$Result$Ok(
					A2(
						$elm$core$List$cons,
						$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							A2($dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration, declarationType, content)),
						blocks));
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$completeBlocks = function (state) {
	var _v84 = state.b;
	_v84$5:
	while (true) {
		if (_v84.b) {
			switch (_v84.a.$) {
				case 11:
					var body2 = _v84.a.a;
					var rest = _v84.b;
					var _v85 = A2(
						$elm$parser$Parser$Advanced$run,
						$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
						body2);
					if (!_v85.$) {
						var value = _v85.a;
						return $elm$parser$Parser$Advanced$succeed(
							{
								a: _Utils_ap(state.a, value.a),
								b: A2(
									$elm$core$List$cons,
									$dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote(value.b),
									rest)
							});
					} else {
						var error = _v85.a;
						return $elm$parser$Parser$Advanced$problem(
							$elm$parser$Parser$Problem(
								$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(error)));
					}
				case 3:
					var _v86 = _v84.a;
					var tight = _v86.a;
					var intended = _v86.b;
					var closeListItems = _v86.c;
					var openListItem = _v86.d;
					var rest = _v84.b;
					var _v87 = A2(
						$elm$parser$Parser$Advanced$run,
						$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
						openListItem.e6);
					if (!_v87.$) {
						var value = _v87.a;
						var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
						return $elm$parser$Parser$Advanced$succeed(
							{
								a: _Utils_ap(state.a, value.a),
								b: A2(
									$elm$core$List$cons,
									A4(
										$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
										tight2,
										intended,
										A2(
											$elm$core$List$cons,
											{e6: value.b, p: openListItem.p},
											closeListItems),
										openListItem),
									rest)
							});
					} else {
						var e = _v87.a;
						return $elm$parser$Parser$Advanced$problem(
							$elm$parser$Parser$Problem(
								$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
					}
				case 4:
					var _v92 = _v84.a;
					var tight = _v92.a;
					var intended = _v92.b;
					var marker = _v92.c;
					var order = _v92.d;
					var closeListItems = _v92.e;
					var openListItem = _v92.f;
					var rest = _v84.b;
					var _v93 = A2(
						$elm$parser$Parser$Advanced$run,
						$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
						openListItem);
					if (!_v93.$) {
						var value = _v93.a;
						var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
						return $elm$parser$Parser$Advanced$succeed(
							{
								a: _Utils_ap(state.a, value.a),
								b: A2(
									$elm$core$List$cons,
									A6(
										$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
										tight2,
										intended,
										marker,
										order,
										A2($elm$core$List$cons, value.b, closeListItems),
										openListItem),
									rest)
							});
					} else {
						var e = _v93.a;
						return $elm$parser$Parser$Advanced$problem(
							$elm$parser$Parser$Problem(
								$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
					}
				case 10:
					if (_v84.b.b) {
						switch (_v84.b.a.$) {
							case 3:
								var _v88 = _v84.a;
								var _v89 = _v84.b;
								var _v90 = _v89.a;
								var tight = _v90.a;
								var intended = _v90.b;
								var closeListItems = _v90.c;
								var openListItem = _v90.d;
								var rest = _v89.b;
								var _v91 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									openListItem.e6);
								if (!_v91.$) {
									var value = _v91.a;
									var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: _Utils_ap(state.a, value.a),
											b: A2(
												$elm$core$List$cons,
												A4(
													$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
													tight2,
													intended,
													A2(
														$elm$core$List$cons,
														{e6: value.b, p: openListItem.p},
														closeListItems),
													openListItem),
												rest)
										});
								} else {
									var e = _v91.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
							case 4:
								var _v94 = _v84.a;
								var _v95 = _v84.b;
								var _v96 = _v95.a;
								var tight = _v96.a;
								var intended = _v96.b;
								var marker = _v96.c;
								var order = _v96.d;
								var closeListItems = _v96.e;
								var openListItem = _v96.f;
								var rest = _v95.b;
								var _v97 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									openListItem);
								if (!_v97.$) {
									var value = _v97.a;
									var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: _Utils_ap(state.a, value.a),
											b: A2(
												$elm$core$List$cons,
												A6(
													$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
													tight2,
													intended,
													marker,
													order,
													A2($elm$core$List$cons, value.b, closeListItems),
													openListItem),
												rest)
										});
								} else {
									var e = _v97.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
							default:
								break _v84$5;
						}
					} else {
						break _v84$5;
					}
				default:
					break _v84$5;
			}
		} else {
			break _v84$5;
		}
	}
	return $elm$parser$Parser$Advanced$succeed(state);
};
var $dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks = F2(
	function (state, newRawBlock) {
		var _v41 = _Utils_Tuple2(newRawBlock, state.b);
		_v41$13:
		while (true) {
			if (_v41.b.b) {
				switch (_v41.b.a.$) {
					case 5:
						if (_v41.a.$ === 5) {
							var block1 = _v41.a.a;
							var _v42 = _v41.b;
							var block2 = _v42.a.a;
							var rest = _v42.b;
							return $elm$parser$Parser$Advanced$succeed(
								{
									a: state.a,
									b: A2(
										$elm$core$List$cons,
										$dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock(
											{
												e6: A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, block2.e6, block1.e6),
												ck: $elm$core$Maybe$Nothing
											}),
										rest)
								});
						} else {
							break _v41$13;
						}
					case 6:
						switch (_v41.a.$) {
							case 6:
								var block1 = _v41.a.a;
								var _v43 = _v41.b;
								var block2 = _v43.a.a;
								var rest = _v43.b;
								return $elm$parser$Parser$Advanced$succeed(
									{
										a: state.a,
										b: A2(
											$elm$core$List$cons,
											$dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock(
												A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, block2, block1)),
											rest)
									});
							case 10:
								var _v44 = _v41.a;
								var _v45 = _v41.b;
								var block = _v45.a.a;
								var rest = _v45.b;
								return $elm$parser$Parser$Advanced$succeed(
									{
										a: state.a,
										b: A2(
											$elm$core$List$cons,
											$dillonkearns$elm_markdown$Markdown$RawBlock$IndentedCodeBlock(
												A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, block, '\n')),
											rest)
									});
							default:
								break _v41$13;
						}
					case 11:
						var _v46 = _v41.b;
						var body2 = _v46.a.a;
						var rest = _v46.b;
						switch (newRawBlock.$) {
							case 11:
								var body1 = newRawBlock.a;
								return $elm$parser$Parser$Advanced$succeed(
									{
										a: state.a,
										b: A2(
											$elm$core$List$cons,
											$dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote(
												A2($dillonkearns$elm_markdown$Markdown$Parser$joinStringsPreserveAll, body2, body1)),
											rest)
									});
							case 1:
								var body1 = newRawBlock.a;
								return $elm$parser$Parser$Advanced$succeed(
									{
										a: state.a,
										b: A2(
											$elm$core$List$cons,
											$dillonkearns$elm_markdown$Markdown$RawBlock$BlockQuote(
												A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', body2, body1)),
											rest)
									});
							default:
								var _v48 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									body2);
								if (!_v48.$) {
									var value = _v48.a;
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: _Utils_ap(state.a, value.a),
											b: A2(
												$elm$core$List$cons,
												newRawBlock,
												A2(
													$elm$core$List$cons,
													$dillonkearns$elm_markdown$Markdown$RawBlock$ParsedBlockQuote(value.b),
													rest))
										});
								} else {
									var e = _v48.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
						}
					case 3:
						var _v49 = _v41.b;
						var _v50 = _v49.a;
						var tight = _v50.a;
						var intended1 = _v50.b;
						var closeListItems2 = _v50.c;
						var openListItem2 = _v50.d;
						var rest = _v49.b;
						switch (newRawBlock.$) {
							case 3:
								var intended2 = newRawBlock.b;
								var closeListItems1 = newRawBlock.c;
								var openListItem1 = newRawBlock.d;
								if (_Utils_eq(openListItem2.fY, openListItem1.fY)) {
									var _v52 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2.e6);
									if (!_v52.$) {
										var value = _v52.a;
										return A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? $elm$parser$Parser$Advanced$succeed(
											{
												a: _Utils_ap(state.a, value.a),
												b: A2(
													$elm$core$List$cons,
													A4(
														$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
														false,
														intended2,
														A2(
															$elm$core$List$cons,
															{e6: value.b, p: openListItem2.p},
															closeListItems2),
														openListItem1),
													rest)
											}) : $elm$parser$Parser$Advanced$succeed(
											{
												a: _Utils_ap(state.a, value.a),
												b: A2(
													$elm$core$List$cons,
													A4(
														$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
														tight,
														intended2,
														A2(
															$elm$core$List$cons,
															{e6: value.b, p: openListItem2.p},
															closeListItems2),
														openListItem1),
													rest)
											});
									} else {
										var e = _v52.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								} else {
									var _v53 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2.e6);
									if (!_v53.$) {
										var value = _v53.a;
										var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
										return $elm$parser$Parser$Advanced$succeed(
											{
												a: _Utils_ap(state.a, value.a),
												b: A2(
													$elm$core$List$cons,
													newRawBlock,
													A2(
														$elm$core$List$cons,
														A4(
															$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
															tight2,
															intended1,
															A2(
																$elm$core$List$cons,
																{e6: value.b, p: openListItem2.p},
																closeListItems2),
															openListItem1),
														rest))
											});
									} else {
										var e = _v53.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								}
							case 1:
								var body1 = newRawBlock.a;
								return $elm$parser$Parser$Advanced$succeed(
									{
										a: state.a,
										b: A2(
											$elm$core$List$cons,
											A4(
												$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
												tight,
												intended1,
												closeListItems2,
												_Utils_update(
													openListItem2,
													{
														e6: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', openListItem2.e6, body1)
													})),
											rest)
									});
							default:
								var _v54 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									openListItem2.e6);
								if (!_v54.$) {
									var value = _v54.a;
									var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: _Utils_ap(state.a, value.a),
											b: A2(
												$elm$core$List$cons,
												newRawBlock,
												A2(
													$elm$core$List$cons,
													A4(
														$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
														tight2,
														intended1,
														A2(
															$elm$core$List$cons,
															{e6: value.b, p: openListItem2.p},
															closeListItems2),
														openListItem2),
													rest))
										});
								} else {
									var e = _v54.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
						}
					case 4:
						var _v55 = _v41.b;
						var _v56 = _v55.a;
						var tight = _v56.a;
						var intended1 = _v56.b;
						var marker = _v56.c;
						var order = _v56.d;
						var closeListItems2 = _v56.e;
						var openListItem2 = _v56.f;
						var rest = _v55.b;
						switch (newRawBlock.$) {
							case 4:
								var intended2 = newRawBlock.b;
								var marker2 = newRawBlock.c;
								var closeListItems1 = newRawBlock.e;
								var openListItem1 = newRawBlock.f;
								if (_Utils_eq(marker, marker2)) {
									var _v58 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2);
									if (!_v58.$) {
										var value = _v58.a;
										var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
										return $elm$parser$Parser$Advanced$succeed(
											{
												a: _Utils_ap(state.a, value.a),
												b: A2(
													$elm$core$List$cons,
													A6(
														$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
														tight2,
														intended2,
														marker,
														order,
														A2($elm$core$List$cons, value.b, closeListItems2),
														openListItem1),
													rest)
											});
									} else {
										var e = _v58.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								} else {
									var _v59 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2);
									if (!_v59.$) {
										var value = _v59.a;
										var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
										return $elm$parser$Parser$Advanced$succeed(
											{
												a: _Utils_ap(state.a, value.a),
												b: A2(
													$elm$core$List$cons,
													newRawBlock,
													A2(
														$elm$core$List$cons,
														A6(
															$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
															tight2,
															intended1,
															marker,
															order,
															A2($elm$core$List$cons, value.b, closeListItems2),
															openListItem2),
														rest))
											});
									} else {
										var e = _v59.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								}
							case 1:
								var body1 = newRawBlock.a;
								return $elm$parser$Parser$Advanced$succeed(
									{
										a: state.a,
										b: A2(
											$elm$core$List$cons,
											A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended1, marker, order, closeListItems2, openListItem2 + ('\n' + body1)),
											rest)
									});
							default:
								var _v60 = A2(
									$elm$parser$Parser$Advanced$run,
									$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
									openListItem2);
								if (!_v60.$) {
									var value = _v60.a;
									var tight2 = A2($elm$core$List$member, $dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine, value.b) ? false : tight;
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: _Utils_ap(state.a, value.a),
											b: A2(
												$elm$core$List$cons,
												newRawBlock,
												A2(
													$elm$core$List$cons,
													A6(
														$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
														tight2,
														intended1,
														marker,
														order,
														A2($elm$core$List$cons, value.b, closeListItems2),
														openListItem2),
													rest))
										});
								} else {
									var e = _v60.a;
									return $elm$parser$Parser$Advanced$problem(
										$elm$parser$Parser$Problem(
											$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
								}
						}
					case 1:
						switch (_v41.a.$) {
							case 1:
								var body1 = _v41.a.a;
								var _v61 = _v41.b;
								var body2 = _v61.a.a;
								var rest = _v61.b;
								return $elm$parser$Parser$Advanced$succeed(
									{
										a: state.a,
										b: A2(
											$elm$core$List$cons,
											$dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(
												A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', body2, body1)),
											rest)
									});
							case 13:
								if (!_v41.a.a) {
									var _v62 = _v41.a;
									var _v63 = _v62.a;
									var _v64 = _v41.b;
									var unparsedInlines = _v64.a.a;
									var rest = _v64.b;
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: state.a,
											b: A2(
												$elm$core$List$cons,
												A2($dillonkearns$elm_markdown$Markdown$RawBlock$Heading, 1, unparsedInlines),
												rest)
										});
								} else {
									var _v65 = _v41.a;
									var _v66 = _v65.a;
									var _v67 = _v41.b;
									var unparsedInlines = _v67.a.a;
									var rest = _v67.b;
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: state.a,
											b: A2(
												$elm$core$List$cons,
												A2($dillonkearns$elm_markdown$Markdown$RawBlock$Heading, 2, unparsedInlines),
												rest)
										});
								}
							case 9:
								var _v68 = _v41.a.a;
								var text = _v68.a;
								var alignments = _v68.b;
								var _v69 = _v41.b;
								var rawHeaders = _v69.a.a;
								var rest = _v69.b;
								var _v70 = A2(
									$dillonkearns$elm_markdown$Markdown$TableParser$parseHeader,
									A2($dillonkearns$elm_markdown$Markdown$Table$TableDelimiterRow, text, alignments),
									rawHeaders);
								if (!_v70.$) {
									var headers = _v70.a;
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: state.a,
											b: A2(
												$elm$core$List$cons,
												$dillonkearns$elm_markdown$Markdown$RawBlock$Table(
													A2($dillonkearns$elm_markdown$Markdown$Table$Table, headers, _List_Nil)),
												rest)
										});
								} else {
									return $elm$parser$Parser$Advanced$succeed(
										{
											a: state.a,
											b: A2(
												$elm$core$List$cons,
												$dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(
													A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', rawHeaders, text.d5)),
												rest)
										});
								}
							default:
								break _v41$13;
						}
					case 8:
						if (_v41.a.$ === 8) {
							var updatedTable = _v41.a.a;
							var _v71 = _v41.b;
							var rest = _v71.b;
							return $elm$parser$Parser$Advanced$succeed(
								{
									a: state.a,
									b: A2(
										$elm$core$List$cons,
										$dillonkearns$elm_markdown$Markdown$RawBlock$Table(updatedTable),
										rest)
								});
						} else {
							break _v41$13;
						}
					case 10:
						if (_v41.b.b.b) {
							switch (_v41.b.b.a.$) {
								case 4:
									var _v72 = _v41.b;
									var _v73 = _v72.a;
									var _v74 = _v72.b;
									var _v75 = _v74.a;
									var tight = _v75.a;
									var intended1 = _v75.b;
									var marker = _v75.c;
									var order = _v75.d;
									var closeListItems2 = _v75.e;
									var openListItem2 = _v75.f;
									var rest = _v74.b;
									var _v76 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2);
									if (!_v76.$) {
										var value = _v76.a;
										if (newRawBlock.$ === 4) {
											var intended2 = newRawBlock.b;
											var openListItem = newRawBlock.f;
											return $elm$parser$Parser$Advanced$succeed(
												{
													a: _Utils_ap(state.a, value.a),
													b: A2(
														$elm$core$List$cons,
														A6(
															$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
															false,
															intended2,
															marker,
															order,
															A2($elm$core$List$cons, value.b, closeListItems2),
															openListItem),
														rest)
												});
										} else {
											return $elm$parser$Parser$Advanced$succeed(
												{
													a: _Utils_ap(state.a, value.a),
													b: A2(
														$elm$core$List$cons,
														newRawBlock,
														A2(
															$elm$core$List$cons,
															$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
															A2(
																$elm$core$List$cons,
																A6(
																	$dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock,
																	tight,
																	intended1,
																	marker,
																	order,
																	A2($elm$core$List$cons, value.b, closeListItems2),
																	openListItem2),
																rest)))
												});
										}
									} else {
										var e = _v76.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								case 3:
									var _v78 = _v41.b;
									var _v79 = _v78.a;
									var _v80 = _v78.b;
									var _v81 = _v80.a;
									var tight = _v81.a;
									var intended1 = _v81.b;
									var closeListItems2 = _v81.c;
									var openListItem2 = _v81.d;
									var rest = _v80.b;
									var _v82 = A2(
										$elm$parser$Parser$Advanced$run,
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
										openListItem2.e6);
									if (!_v82.$) {
										var value = _v82.a;
										if (newRawBlock.$ === 3) {
											var openListItem = newRawBlock.d;
											return $elm$parser$Parser$Advanced$succeed(
												{
													a: _Utils_ap(state.a, value.a),
													b: A2(
														$elm$core$List$cons,
														A4(
															$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
															false,
															intended1,
															A2(
																$elm$core$List$cons,
																{e6: value.b, p: openListItem2.p},
																closeListItems2),
															openListItem),
														rest)
												});
										} else {
											return $elm$parser$Parser$Advanced$succeed(
												{
													a: _Utils_ap(state.a, value.a),
													b: A2(
														$elm$core$List$cons,
														newRawBlock,
														A2(
															$elm$core$List$cons,
															$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
															A2(
																$elm$core$List$cons,
																A4(
																	$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
																	tight,
																	intended1,
																	A2(
																		$elm$core$List$cons,
																		{e6: value.b, p: openListItem2.p},
																		closeListItems2),
																	openListItem2),
																rest)))
												});
										}
									} else {
										var e = _v82.a;
										return $elm$parser$Parser$Advanced$problem(
											$elm$parser$Parser$Problem(
												$dillonkearns$elm_markdown$Markdown$Parser$deadEndsToString(e)));
									}
								default:
									break _v41$13;
							}
						} else {
							break _v41$13;
						}
					default:
						break _v41$13;
				}
			} else {
				break _v41$13;
			}
		}
		return $elm$parser$Parser$Advanced$succeed(
			{
				a: state.a,
				b: A2($elm$core$List$cons, newRawBlock, state.b)
			});
	});
var $dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper = F2(
	function (referencesDict, _v36) {
		var unparsedInlines = _v36;
		var mappedReferencesDict = $elm$core$Dict$fromList(
			A2(
				$elm$core$List$map,
				$elm$core$Tuple$mapSecond(
					function (_v37) {
						var destination = _v37.dc;
						var title = _v37.g4;
						return _Utils_Tuple2(destination, title);
					}),
				referencesDict));
		return A2(
			$elm$core$List$map,
			$dillonkearns$elm_markdown$Markdown$Parser$mapInline,
			A2($dillonkearns$elm_markdown$Markdown$InlineParser$parse, mappedReferencesDict, unparsedInlines));
	});
var $dillonkearns$elm_markdown$Markdown$Parser$mapInline = function (inline) {
	switch (inline.$) {
		case 0:
			var string = inline.a;
			return $dillonkearns$elm_markdown$Markdown$Block$Text(string);
		case 1:
			return $dillonkearns$elm_markdown$Markdown$Block$HardLineBreak;
		case 2:
			var string = inline.a;
			return $dillonkearns$elm_markdown$Markdown$Block$CodeSpan(string);
		case 3:
			var string = inline.a;
			var maybeString = inline.b;
			var inlines = inline.c;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Block$Link,
				string,
				maybeString,
				A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
		case 4:
			var string = inline.a;
			var maybeString = inline.b;
			var inlines = inline.c;
			return A3(
				$dillonkearns$elm_markdown$Markdown$Block$Image,
				string,
				maybeString,
				A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
		case 5:
			var node = inline.a;
			return $dillonkearns$elm_markdown$Markdown$Block$HtmlInline(
				$dillonkearns$elm_markdown$Markdown$Parser$nodeToRawBlock(node));
		case 6:
			var level = inline.a;
			var inlines = inline.b;
			switch (level) {
				case 1:
					return $dillonkearns$elm_markdown$Markdown$Block$Emphasis(
						A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
				case 2:
					return $dillonkearns$elm_markdown$Markdown$Block$Strong(
						A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
				default:
					return $dillonkearns$elm_markdown$Markdown$Helpers$isEven(level) ? $dillonkearns$elm_markdown$Markdown$Block$Strong(
						_List_fromArray(
							[
								$dillonkearns$elm_markdown$Markdown$Parser$mapInline(
								A2($dillonkearns$elm_markdown$Markdown$Inline$Emphasis, level - 2, inlines))
							])) : $dillonkearns$elm_markdown$Markdown$Block$Emphasis(
						_List_fromArray(
							[
								$dillonkearns$elm_markdown$Markdown$Parser$mapInline(
								A2($dillonkearns$elm_markdown$Markdown$Inline$Emphasis, level - 1, inlines))
							]));
			}
		default:
			var inlines = inline.a;
			return $dillonkearns$elm_markdown$Markdown$Block$Strikethrough(
				A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Parser$mapInline, inlines));
	}
};
var $dillonkearns$elm_markdown$Markdown$Parser$nodeToRawBlock = function (node) {
	switch (node.$) {
		case 1:
			var innerText = node.a;
			return $dillonkearns$elm_markdown$Markdown$Block$HtmlComment('TODO this never happens, but use types to drop this case.');
		case 0:
			var tag = node.a;
			var attributes = node.b;
			var children = node.c;
			var parseChild = function (child) {
				if (child.$ === 1) {
					var text = child.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$textNodeToBlocks(text);
				} else {
					return _List_fromArray(
						[
							$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(
							$dillonkearns$elm_markdown$Markdown$Parser$nodeToRawBlock(child))
						]);
				}
			};
			return A3(
				$dillonkearns$elm_markdown$Markdown$Block$HtmlElement,
				tag,
				attributes,
				A2($elm$core$List$concatMap, parseChild, children));
		case 2:
			var string = node.a;
			return $dillonkearns$elm_markdown$Markdown$Block$HtmlComment(string);
		case 3:
			var string = node.a;
			return $dillonkearns$elm_markdown$Markdown$Block$Cdata(string);
		case 4:
			var string = node.a;
			return $dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction(string);
		default:
			var declarationType = node.a;
			var content = node.b;
			return A2($dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration, declarationType, content);
	}
};
var $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocks = function (children) {
	return A2($dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocksHelp, children, _List_Nil);
};
var $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocksHelp = F2(
	function (remaining, soFar) {
		nodesToBlocksHelp:
		while (true) {
			if (remaining.b) {
				var node = remaining.a;
				var rest = remaining.b;
				var _v31 = A2($dillonkearns$elm_markdown$Markdown$Parser$childToBlocks, node, soFar);
				if (!_v31.$) {
					var newSoFar = _v31.a;
					var $temp$remaining = rest,
						$temp$soFar = newSoFar;
					remaining = $temp$remaining;
					soFar = $temp$soFar;
					continue nodesToBlocksHelp;
				} else {
					var e = _v31.a;
					return $elm$core$Result$Err(e);
				}
			} else {
				return $elm$core$Result$Ok(
					$elm$core$List$reverse(soFar));
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$parse = function (input) {
	var _v27 = A2(
		$elm$parser$Parser$Advanced$run,
		A2(
			$elm$parser$Parser$Advanced$ignorer,
			$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser(),
			$dillonkearns$elm_markdown$Helpers$endOfFile),
		input);
	if (_v27.$ === 1) {
		var e = _v27.a;
		return $elm$core$Result$Err(e);
	} else {
		var v = _v27.a;
		var _v28 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines(v);
		if (_v28.$ === 1) {
			var e = _v28.a;
			return A2(
				$elm$parser$Parser$Advanced$run,
				$elm$parser$Parser$Advanced$problem(e),
				'');
		} else {
			var blocks = _v28.a;
			var isNotEmptyParagraph = function (block) {
				if ((block.$ === 5) && (!block.a.b)) {
					return false;
				} else {
					return true;
				}
			};
			return $elm$core$Result$Ok(
				A2($elm$core$List$filter, isNotEmptyParagraph, blocks));
		}
	}
};
var $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines = function (state) {
	return A3($dillonkearns$elm_markdown$Markdown$Parser$parseAllInlinesHelp, state, state.b, _List_Nil);
};
var $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlinesHelp = F3(
	function (state, rawBlocks, parsedBlocks) {
		parseAllInlinesHelp:
		while (true) {
			if (rawBlocks.b) {
				var rawBlock = rawBlocks.a;
				var rest = rawBlocks.b;
				var _v26 = A2($dillonkearns$elm_markdown$Markdown$Parser$parseInlines, state.a, rawBlock);
				switch (_v26.$) {
					case 1:
						var newParsedBlock = _v26.a;
						var $temp$state = state,
							$temp$rawBlocks = rest,
							$temp$parsedBlocks = A2($elm$core$List$cons, newParsedBlock, parsedBlocks);
						state = $temp$state;
						rawBlocks = $temp$rawBlocks;
						parsedBlocks = $temp$parsedBlocks;
						continue parseAllInlinesHelp;
					case 0:
						var $temp$state = state,
							$temp$rawBlocks = rest,
							$temp$parsedBlocks = parsedBlocks;
						state = $temp$state;
						rawBlocks = $temp$rawBlocks;
						parsedBlocks = $temp$parsedBlocks;
						continue parseAllInlinesHelp;
					default:
						var e = _v26.a;
						return $elm$core$Result$Err(e);
				}
			} else {
				return $elm$core$Result$Ok(parsedBlocks);
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$parseHeaderInlines = F2(
	function (linkReferences, header) {
		return A2(
			$elm$core$List$map,
			function (_v24) {
				var label = _v24.aN;
				var alignment = _v24.bo;
				return A3(
					$dillonkearns$elm_markdown$Markdown$Parser$parseRawInline,
					linkReferences,
					function (parsedHeaderLabel) {
						return {bo: alignment, aN: parsedHeaderLabel};
					},
					label);
			},
			header);
	});
var $dillonkearns$elm_markdown$Markdown$Parser$parseInlines = F2(
	function (linkReferences, rawBlock) {
		switch (rawBlock.$) {
			case 0:
				var level = rawBlock.a;
				var unparsedInlines = rawBlock.b;
				var _v17 = $dillonkearns$elm_markdown$Markdown$Parser$toHeading(level);
				if (!_v17.$) {
					var parsedLevel = _v17.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
						A2(
							$dillonkearns$elm_markdown$Markdown$Block$Heading,
							parsedLevel,
							A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, unparsedInlines)));
				} else {
					var e = _v17.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$InlineProblem(e);
				}
			case 1:
				var unparsedInlines = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$Paragraph(
						A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, unparsedInlines)));
			case 2:
				var html = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$HtmlBlock(html));
			case 3:
				var tight = rawBlock.a;
				var intended = rawBlock.b;
				var unparsedItems = rawBlock.c;
				var parseItem = F2(
					function (rawBlockTask, rawBlocks) {
						var blocksTask = function () {
							if (!rawBlockTask.$) {
								if (!rawBlockTask.a) {
									return 1;
								} else {
									return 2;
								}
							} else {
								return 0;
							}
						}();
						var blocks = function () {
							var _v18 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines(
								{a: linkReferences, b: rawBlocks});
							if (!_v18.$) {
								var parsedBlocks = _v18.a;
								return parsedBlocks;
							} else {
								var e = _v18.a;
								return _List_Nil;
							}
						}();
						return A2($dillonkearns$elm_markdown$Markdown$Block$ListItem, blocksTask, blocks);
					});
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					A2(
						$dillonkearns$elm_markdown$Markdown$Block$UnorderedList,
						$dillonkearns$elm_markdown$Markdown$Parser$isTightBoolToListDisplay(tight),
						$elm$core$List$reverse(
							A2(
								$elm$core$List$map,
								function (item) {
									return A2(parseItem, item.p, item.e6);
								},
								unparsedItems))));
			case 4:
				var tight = rawBlock.a;
				var startingIndex = rawBlock.d;
				var unparsedItems = rawBlock.e;
				var parseItem = function (rawBlocks) {
					var _v20 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines(
						{a: linkReferences, b: rawBlocks});
					if (!_v20.$) {
						var parsedBlocks = _v20.a;
						return parsedBlocks;
					} else {
						var e = _v20.a;
						return _List_Nil;
					}
				};
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					A3(
						$dillonkearns$elm_markdown$Markdown$Block$OrderedList,
						$dillonkearns$elm_markdown$Markdown$Parser$isTightBoolToListDisplay(tight),
						startingIndex,
						$elm$core$List$reverse(
							A2($elm$core$List$map, parseItem, unparsedItems))));
			case 5:
				var codeBlock = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$CodeBlock(codeBlock));
			case 7:
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock($dillonkearns$elm_markdown$Markdown$Block$ThematicBreak);
			case 10:
				return $dillonkearns$elm_markdown$Markdown$Parser$EmptyBlock;
			case 11:
				var rawBlocks = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$EmptyBlock;
			case 12:
				var rawBlocks = rawBlock.a;
				var _v21 = $dillonkearns$elm_markdown$Markdown$Parser$parseAllInlines(
					{a: linkReferences, b: rawBlocks});
				if (!_v21.$) {
					var parsedBlocks = _v21.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
						$dillonkearns$elm_markdown$Markdown$Block$BlockQuote(parsedBlocks));
				} else {
					var e = _v21.a;
					return $dillonkearns$elm_markdown$Markdown$Parser$InlineProblem(e);
				}
			case 6:
				var codeBlockBody = rawBlock.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$CodeBlock(
						{e6: codeBlockBody, ck: $elm$core$Maybe$Nothing}));
			case 8:
				var _v22 = rawBlock.a;
				var header = _v22.a;
				var rows = _v22.b;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					A2(
						$dillonkearns$elm_markdown$Markdown$Block$Table,
						A2($dillonkearns$elm_markdown$Markdown$Parser$parseHeaderInlines, linkReferences, header),
						A2($dillonkearns$elm_markdown$Markdown$Parser$parseRowInlines, linkReferences, rows)));
			case 9:
				var _v23 = rawBlock.a;
				var text = _v23.a;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$Paragraph(
						A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, text.d5)));
			default:
				var raw = rawBlock.b;
				return $dillonkearns$elm_markdown$Markdown$Parser$ParsedBlock(
					$dillonkearns$elm_markdown$Markdown$Block$Paragraph(
						A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, raw)));
		}
	});
var $dillonkearns$elm_markdown$Markdown$Parser$parseRawInline = F3(
	function (linkReferences, wrap, unparsedInlines) {
		return wrap(
			A2($dillonkearns$elm_markdown$Markdown$Parser$inlineParseHelper, linkReferences, unparsedInlines));
	});
var $dillonkearns$elm_markdown$Markdown$Parser$parseRowInlines = F2(
	function (linkReferences, rows) {
		return A2(
			$elm$core$List$map,
			function (row) {
				return A2(
					$elm$core$List$map,
					function (column) {
						return A3($dillonkearns$elm_markdown$Markdown$Parser$parseRawInline, linkReferences, $elm$core$Basics$identity, column);
					},
					row);
			},
			rows);
	});
var $dillonkearns$elm_markdown$Markdown$Parser$stepRawBlock = function (revStmts) {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v2) {
					return $elm$parser$Parser$Advanced$Done(revStmts);
				},
				$dillonkearns$elm_markdown$Helpers$endOfFile),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (reference) {
					return $elm$parser$Parser$Advanced$Loop(
						A2($dillonkearns$elm_markdown$Markdown$Parser$addReference, revStmts, reference));
				},
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$LinkReferenceDefinition$parser)),
				function () {
				var _v3 = revStmts.b;
				_v3$6:
				while (true) {
					if (_v3.b) {
						switch (_v3.a.$) {
							case 1:
								return A2(
									$elm$parser$Parser$Advanced$map,
									function (block) {
										return $elm$parser$Parser$Advanced$Loop(block);
									},
									A2(
										$elm$parser$Parser$Advanced$andThen,
										$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
										$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser()));
							case 8:
								var table = _v3.a.a;
								return A2(
									$elm$parser$Parser$Advanced$map,
									function (block) {
										return $elm$parser$Parser$Advanced$Loop(block);
									},
									A2(
										$elm$parser$Parser$Advanced$andThen,
										$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
										$elm$parser$Parser$Advanced$oneOf(
											_List_fromArray(
												[
													$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser(),
													$dillonkearns$elm_markdown$Markdown$Parser$tableRowIfTableStarted(table)
												]))));
							case 3:
								var _v4 = _v3.a;
								var tight = _v4.a;
								var intended = _v4.b;
								var closeListItems = _v4.c;
								var openListItem = _v4.d;
								var rest = _v3.b;
								var completeOrMergeUnorderedListBlockBlankLine = F2(
									function (state, newString) {
										return _Utils_update(
											state,
											{
												b: A2(
													$elm$core$List$cons,
													$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
													A2(
														$elm$core$List$cons,
														A4(
															$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
															tight,
															intended,
															closeListItems,
															_Utils_update(
																openListItem,
																{
																	e6: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '', openListItem.e6, newString)
																})),
														rest))
											});
									});
								var completeOrMergeUnorderedListBlock = F2(
									function (state, newString) {
										return _Utils_update(
											state,
											{
												b: A2(
													$elm$core$List$cons,
													A4(
														$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
														tight,
														intended,
														closeListItems,
														_Utils_update(
															openListItem,
															{
																e6: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', openListItem.e6, newString)
															})),
													rest)
											});
									});
								return $elm$parser$Parser$Advanced$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$map,
												function (_v5) {
													return A2(completeOrMergeUnorderedListBlockBlankLine, revStmts, '\n');
												},
												$dillonkearns$elm_markdown$Markdown$Parser$blankLine)),
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$map,
												completeOrMergeUnorderedListBlock(revStmts),
												A2(
													$elm$parser$Parser$Advanced$keeper,
													A2(
														$elm$parser$Parser$Advanced$ignorer,
														$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
														$elm$parser$Parser$Advanced$symbol(
															A2(
																$elm$parser$Parser$Advanced$Token,
																A2($elm$core$String$repeat, intended, ' '),
																$elm$parser$Parser$ExpectingSymbol('Indentation')))),
													A2(
														$elm$parser$Parser$Advanced$ignorer,
														$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
														$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)))),
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$andThen,
												$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
												$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList()))
										]));
							case 4:
								var _v10 = _v3.a;
								var tight = _v10.a;
								var intended = _v10.b;
								var marker = _v10.c;
								var order = _v10.d;
								var closeListItems = _v10.e;
								var openListItem = _v10.f;
								var rest = _v3.b;
								var completeOrMergeUnorderedListBlockBlankLine = F2(
									function (state, newString) {
										return _Utils_update(
											state,
											{
												b: A2(
													$elm$core$List$cons,
													$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
													A2(
														$elm$core$List$cons,
														A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended, marker, order, closeListItems, openListItem + ('\n' + newString)),
														rest))
											});
									});
								var completeOrMergeUnorderedListBlock = F2(
									function (state, newString) {
										return _Utils_update(
											state,
											{
												b: A2(
													$elm$core$List$cons,
													A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended, marker, order, closeListItems, openListItem + ('\n' + newString)),
													rest)
											});
									});
								return $elm$parser$Parser$Advanced$oneOf(
									_List_fromArray(
										[
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$map,
												function (_v11) {
													return A2(completeOrMergeUnorderedListBlockBlankLine, revStmts, '\n');
												},
												$dillonkearns$elm_markdown$Markdown$Parser$blankLine)),
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$map,
												completeOrMergeUnorderedListBlock(revStmts),
												A2(
													$elm$parser$Parser$Advanced$keeper,
													A2(
														$elm$parser$Parser$Advanced$ignorer,
														$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
														$elm$parser$Parser$Advanced$symbol(
															A2(
																$elm$parser$Parser$Advanced$Token,
																A2($elm$core$String$repeat, intended, ' '),
																$elm$parser$Parser$ExpectingSymbol('Indentation')))),
													A2(
														$elm$parser$Parser$Advanced$ignorer,
														$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
														$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)))),
											A2(
											$elm$parser$Parser$Advanced$map,
											function (block) {
												return $elm$parser$Parser$Advanced$Loop(block);
											},
											A2(
												$elm$parser$Parser$Advanced$andThen,
												$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
												$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList()))
										]));
							case 10:
								if (_v3.b.b) {
									switch (_v3.b.a.$) {
										case 3:
											var _v6 = _v3.a;
											var _v7 = _v3.b;
											var _v8 = _v7.a;
											var tight = _v8.a;
											var intended = _v8.b;
											var closeListItems = _v8.c;
											var openListItem = _v8.d;
											var rest = _v7.b;
											var completeOrMergeUnorderedListBlockBlankLine = F2(
												function (state, newString) {
													return _Utils_update(
														state,
														{
															b: A2(
																$elm$core$List$cons,
																$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
																A2(
																	$elm$core$List$cons,
																	A4(
																		$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
																		tight,
																		intended,
																		closeListItems,
																		_Utils_update(
																			openListItem,
																			{
																				e6: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '', openListItem.e6, newString)
																			})),
																	rest))
														});
												});
											var completeOrMergeUnorderedListBlock = F2(
												function (state, newString) {
													return _Utils_update(
														state,
														{
															b: A2(
																$elm$core$List$cons,
																A4(
																	$dillonkearns$elm_markdown$Markdown$RawBlock$UnorderedListBlock,
																	tight,
																	intended,
																	closeListItems,
																	_Utils_update(
																		openListItem,
																		{
																			e6: A3($dillonkearns$elm_markdown$Markdown$Parser$joinRawStringsWith, '\n', openListItem.e6, newString)
																		})),
																rest)
														});
												});
											return ($elm$core$String$trim(openListItem.e6) === '') ? A2(
												$elm$parser$Parser$Advanced$map,
												function (block) {
													return $elm$parser$Parser$Advanced$Loop(block);
												},
												A2(
													$elm$parser$Parser$Advanced$andThen,
													$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
													$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser())) : $elm$parser$Parser$Advanced$oneOf(
												_List_fromArray(
													[
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$map,
															function (_v9) {
																return A2(completeOrMergeUnorderedListBlockBlankLine, revStmts, '\n');
															},
															$dillonkearns$elm_markdown$Markdown$Parser$blankLine)),
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$map,
															completeOrMergeUnorderedListBlock(revStmts),
															A2(
																$elm$parser$Parser$Advanced$keeper,
																A2(
																	$elm$parser$Parser$Advanced$ignorer,
																	$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
																	$elm$parser$Parser$Advanced$symbol(
																		A2(
																			$elm$parser$Parser$Advanced$Token,
																			A2($elm$core$String$repeat, intended, ' '),
																			$elm$parser$Parser$ExpectingSymbol('Indentation')))),
																A2(
																	$elm$parser$Parser$Advanced$ignorer,
																	$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
																	$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)))),
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$andThen,
															$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
															$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser()))
													]));
										case 4:
											var _v12 = _v3.a;
											var _v13 = _v3.b;
											var _v14 = _v13.a;
											var tight = _v14.a;
											var intended = _v14.b;
											var marker = _v14.c;
											var order = _v14.d;
											var closeListItems = _v14.e;
											var openListItem = _v14.f;
											var rest = _v13.b;
											var completeOrMergeUnorderedListBlockBlankLine = F2(
												function (state, newString) {
													return _Utils_update(
														state,
														{
															b: A2(
																$elm$core$List$cons,
																$dillonkearns$elm_markdown$Markdown$RawBlock$BlankLine,
																A2(
																	$elm$core$List$cons,
																	A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended, marker, order, closeListItems, openListItem + ('\n' + newString)),
																	rest))
														});
												});
											var completeOrMergeUnorderedListBlock = F2(
												function (state, newString) {
													return _Utils_update(
														state,
														{
															b: A2(
																$elm$core$List$cons,
																A6($dillonkearns$elm_markdown$Markdown$RawBlock$OrderedListBlock, tight, intended, marker, order, closeListItems, openListItem + ('\n' + newString)),
																rest)
														});
												});
											return ($elm$core$String$trim(openListItem) === '') ? A2(
												$elm$parser$Parser$Advanced$map,
												function (block) {
													return $elm$parser$Parser$Advanced$Loop(block);
												},
												A2(
													$elm$parser$Parser$Advanced$andThen,
													$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
													$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser())) : $elm$parser$Parser$Advanced$oneOf(
												_List_fromArray(
													[
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$map,
															function (_v15) {
																return A2(completeOrMergeUnorderedListBlockBlankLine, revStmts, '\n');
															},
															$dillonkearns$elm_markdown$Markdown$Parser$blankLine)),
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$map,
															completeOrMergeUnorderedListBlock(revStmts),
															A2(
																$elm$parser$Parser$Advanced$keeper,
																A2(
																	$elm$parser$Parser$Advanced$ignorer,
																	$elm$parser$Parser$Advanced$succeed($elm$core$Basics$identity),
																	$elm$parser$Parser$Advanced$symbol(
																		A2(
																			$elm$parser$Parser$Advanced$Token,
																			A2($elm$core$String$repeat, intended, ' '),
																			$elm$parser$Parser$ExpectingSymbol('Indentation')))),
																A2(
																	$elm$parser$Parser$Advanced$ignorer,
																	$elm$parser$Parser$Advanced$getChompedString($dillonkearns$elm_markdown$Helpers$chompUntilLineEndOrEnd),
																	$dillonkearns$elm_markdown$Helpers$lineEndOrEnd)))),
														A2(
														$elm$parser$Parser$Advanced$map,
														function (block) {
															return $elm$parser$Parser$Advanced$Loop(block);
														},
														A2(
															$elm$parser$Parser$Advanced$andThen,
															$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
															$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser()))
													]));
										default:
											break _v3$6;
									}
								} else {
									break _v3$6;
								}
							default:
								break _v3$6;
						}
					} else {
						break _v3$6;
					}
				}
				return A2(
					$elm$parser$Parser$Advanced$map,
					function (block) {
						return $elm$parser$Parser$Advanced$Loop(block);
					},
					A2(
						$elm$parser$Parser$Advanced$andThen,
						$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
						$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser()));
			}(),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (block) {
					return $elm$parser$Parser$Advanced$Loop(block);
				},
				A2(
					$elm$parser$Parser$Advanced$andThen,
					$dillonkearns$elm_markdown$Markdown$Parser$completeOrMergeBlocks(revStmts),
					$dillonkearns$elm_markdown$Markdown$Parser$openBlockOrParagraphParser))
			]));
};
var $dillonkearns$elm_markdown$Markdown$Parser$textNodeToBlocks = function (textNodeValue) {
	return A2(
		$elm$core$Result$withDefault,
		_List_Nil,
		$dillonkearns$elm_markdown$Markdown$Parser$parse(textNodeValue));
};
var $dillonkearns$elm_markdown$Markdown$Parser$xmlNodeToHtmlNode = function (xmlNode) {
	switch (xmlNode.$) {
		case 1:
			var innerText = xmlNode.a;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$OpenBlockOrParagraph(innerText));
		case 0:
			var tag = xmlNode.a;
			var attributes = xmlNode.b;
			var children = xmlNode.c;
			var _v1 = $dillonkearns$elm_markdown$Markdown$Parser$nodesToBlocks(children);
			if (!_v1.$) {
				var parsedChildren = _v1.a;
				return $elm$parser$Parser$Advanced$succeed(
					$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
						A3($dillonkearns$elm_markdown$Markdown$Block$HtmlElement, tag, attributes, parsedChildren)));
			} else {
				var err = _v1.a;
				return $elm$parser$Parser$Advanced$problem(err);
			}
		case 2:
			var string = xmlNode.a;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
					$dillonkearns$elm_markdown$Markdown$Block$HtmlComment(string)));
		case 3:
			var string = xmlNode.a;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
					$dillonkearns$elm_markdown$Markdown$Block$Cdata(string)));
		case 4:
			var string = xmlNode.a;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
					$dillonkearns$elm_markdown$Markdown$Block$ProcessingInstruction(string)));
		default:
			var declarationType = xmlNode.a;
			var content = xmlNode.b;
			return $elm$parser$Parser$Advanced$succeed(
				$dillonkearns$elm_markdown$Markdown$RawBlock$Html(
					A2($dillonkearns$elm_markdown$Markdown$Block$HtmlDeclaration, declarationType, content)));
	}
};
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser() {
	return A2(
		$elm$parser$Parser$Advanced$andThen,
		$dillonkearns$elm_markdown$Markdown$Parser$completeBlocks,
		A2(
			$elm$parser$Parser$Advanced$loop,
			{a: _List_Nil, b: _List_Nil},
			$dillonkearns$elm_markdown$Markdown$Parser$stepRawBlock));
}
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser() {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock,
				$dillonkearns$elm_markdown$Markdown$Parser$blankLine,
				$dillonkearns$elm_markdown$Markdown$Parser$blockQuote,
				A2(
				$elm$parser$Parser$Advanced$map,
				$dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock,
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$CodeBlock$parser)),
				$dillonkearns$elm_markdown$Markdown$Parser$indentedCodeBlock,
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v40) {
					return $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak;
				},
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$ThematicBreak$parser)),
				$dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock(false),
				$dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock(false),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Heading$parser),
				$dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser()
			]));
}
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser() {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock,
				$dillonkearns$elm_markdown$Markdown$Parser$blankLine,
				$dillonkearns$elm_markdown$Markdown$Parser$blockQuote,
				A2(
				$elm$parser$Parser$Advanced$map,
				$dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock,
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$CodeBlock$parser)),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Parser$setextLineParser),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v39) {
					return $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak;
				},
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$ThematicBreak$parser)),
				$dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock(true),
				$dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock(true),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Heading$parser),
				$dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser(),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Parser$tableDelimiterInOpenParagraph)
			]));
}
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList() {
	return $elm$parser$Parser$Advanced$oneOf(
		_List_fromArray(
			[
				$dillonkearns$elm_markdown$Markdown$Parser$parseAsParagraphInsteadOfHtmlBlock,
				$dillonkearns$elm_markdown$Markdown$Parser$blankLine,
				$dillonkearns$elm_markdown$Markdown$Parser$blockQuote,
				A2(
				$elm$parser$Parser$Advanced$map,
				$dillonkearns$elm_markdown$Markdown$RawBlock$CodeBlock,
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$CodeBlock$parser)),
				A2(
				$elm$parser$Parser$Advanced$map,
				function (_v38) {
					return $dillonkearns$elm_markdown$Markdown$RawBlock$ThematicBreak;
				},
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$ThematicBreak$parser)),
				$dillonkearns$elm_markdown$Markdown$Parser$unorderedListBlock(false),
				$dillonkearns$elm_markdown$Markdown$Parser$orderedListBlock(false),
				$elm$parser$Parser$Advanced$backtrackable($dillonkearns$elm_markdown$Markdown$Heading$parser),
				$dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser()
			]));
}
function $dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser() {
	return A2($elm$parser$Parser$Advanced$andThen, $dillonkearns$elm_markdown$Markdown$Parser$xmlNodeToHtmlNode, $dillonkearns$elm_markdown$HtmlParser$html);
}
var $dillonkearns$elm_markdown$Markdown$Parser$rawBlockParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser();
$dillonkearns$elm_markdown$Markdown$Parser$cyclic$rawBlockParser = function () {
	return $dillonkearns$elm_markdown$Markdown$Parser$rawBlockParser;
};
var $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockNotAfterOpenBlockOrParagraphParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser();
$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockNotAfterOpenBlockOrParagraphParser = function () {
	return $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockNotAfterOpenBlockOrParagraphParser;
};
var $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterOpenBlockOrParagraphParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser();
$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterOpenBlockOrParagraphParser = function () {
	return $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterOpenBlockOrParagraphParser;
};
var $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterList = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList();
$dillonkearns$elm_markdown$Markdown$Parser$cyclic$mergeableBlockAfterList = function () {
	return $dillonkearns$elm_markdown$Markdown$Parser$mergeableBlockAfterList;
};
var $dillonkearns$elm_markdown$Markdown$Parser$htmlParser = $dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser();
$dillonkearns$elm_markdown$Markdown$Parser$cyclic$htmlParser = function () {
	return $dillonkearns$elm_markdown$Markdown$Parser$htmlParser;
};
var $elm$core$Result$map2 = F3(
	function (func, ra, rb) {
		if (ra.$ === 1) {
			var x = ra.a;
			return $elm$core$Result$Err(x);
		} else {
			var a = ra.a;
			if (rb.$ === 1) {
				var x = rb.a;
				return $elm$core$Result$Err(x);
			} else {
				var b = rb.a;
				return $elm$core$Result$Ok(
					A2(func, a, b));
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$combineResults = A2(
	$elm$core$List$foldr,
	$elm$core$Result$map2($elm$core$List$cons),
	$elm$core$Result$Ok(_List_Nil));
var $elm$core$List$drop = F2(
	function (n, list) {
		drop:
		while (true) {
			if (n <= 0) {
				return list;
			} else {
				if (!list.b) {
					return list;
				} else {
					var x = list.a;
					var xs = list.b;
					var $temp$n = n - 1,
						$temp$list = xs;
					n = $temp$n;
					list = $temp$list;
					continue drop;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Block$foldl = F3(
	function (_function, acc, list) {
		foldl:
		while (true) {
			if (!list.b) {
				return acc;
			} else {
				var block = list.a;
				var remainingBlocks = list.b;
				switch (block.$) {
					case 0:
						var html = block.a;
						if (!html.$) {
							var children = html.c;
							var $temp$function = _function,
								$temp$acc = A2(_function, block, acc),
								$temp$list = _Utils_ap(children, remainingBlocks);
							_function = $temp$function;
							acc = $temp$acc;
							list = $temp$list;
							continue foldl;
						} else {
							var $temp$function = _function,
								$temp$acc = A2(_function, block, acc),
								$temp$list = remainingBlocks;
							_function = $temp$function;
							acc = $temp$acc;
							list = $temp$list;
							continue foldl;
						}
					case 1:
						var tight = block.a;
						var blocks = block.b;
						var childBlocks = A2(
							$elm$core$List$concatMap,
							function (_v3) {
								var children = _v3.b;
								return children;
							},
							blocks);
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = _Utils_ap(childBlocks, remainingBlocks);
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 2:
						var _int = block.b;
						var blocks = block.c;
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = _Utils_ap(
							$elm$core$List$concat(blocks),
							remainingBlocks);
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 3:
						var blocks = block.a;
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = _Utils_ap(blocks, remainingBlocks);
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 4:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 5:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 6:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					case 7:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
					default:
						var $temp$function = _function,
							$temp$acc = A2(_function, block, acc),
							$temp$list = remainingBlocks;
						_function = $temp$function;
						acc = $temp$acc;
						list = $temp$list;
						continue foldl;
				}
			}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText = function (block) {
	switch (block.$) {
		case 5:
			var inlines = block.a;
			return $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines);
		case 0:
			var html = block.a;
			if (!html.$) {
				var blocks = html.c;
				return A3(
					$dillonkearns$elm_markdown$Markdown$Block$foldl,
					F2(
						function (nestedBlock, soFar) {
							return _Utils_ap(
								soFar,
								$dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText(nestedBlock));
						}),
					'',
					blocks);
			} else {
				return '';
			}
		case 1:
			var tight = block.a;
			var items = block.b;
			return A2(
				$elm$core$String$join,
				'\n',
				A2(
					$elm$core$List$map,
					function (_v4) {
						var task = _v4.a;
						var blocks = _v4.b;
						return A2(
							$elm$core$String$join,
							'\n',
							A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText, blocks));
					},
					items));
		case 2:
			var tight = block.a;
			var _int = block.b;
			var items = block.c;
			return A2(
				$elm$core$String$join,
				'\n',
				A2(
					$elm$core$List$map,
					function (blocks) {
						return A2(
							$elm$core$String$join,
							'\n',
							A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText, blocks));
					},
					items));
		case 3:
			var blocks = block.a;
			return A2(
				$elm$core$String$join,
				'\n',
				A2($elm$core$List$map, $dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText, blocks));
		case 4:
			var headingLevel = block.a;
			var inlines = block.b;
			return $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines);
		case 6:
			var header = block.a;
			var rows = block.b;
			return A2(
				$elm$core$String$join,
				'\n',
				$elm$core$List$concat(
					_List_fromArray(
						[
							A2(
							$elm$core$List$map,
							$dillonkearns$elm_markdown$Markdown$Block$extractInlineText,
							A2(
								$elm$core$List$map,
								function ($) {
									return $.aN;
								},
								header)),
							$elm$core$List$concat(
							A2(
								$elm$core$List$map,
								$elm$core$List$map($dillonkearns$elm_markdown$Markdown$Block$extractInlineText),
								rows))
						])));
		case 7:
			var body = block.a.e6;
			return body;
		default:
			return '';
	}
};
var $dillonkearns$elm_markdown$Markdown$Block$extractInlineText = function (inlines) {
	return A3($elm$core$List$foldl, $dillonkearns$elm_markdown$Markdown$Block$extractTextHelp, '', inlines);
};
var $dillonkearns$elm_markdown$Markdown$Block$extractTextHelp = F2(
	function (inline, text) {
		switch (inline.$) {
			case 7:
				var str = inline.a;
				return _Utils_ap(text, str);
			case 8:
				return text + ' ';
			case 6:
				var str = inline.a;
				return _Utils_ap(text, str);
			case 1:
				var inlines = inline.c;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			case 2:
				var inlines = inline.c;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			case 0:
				var html = inline.a;
				if (!html.$) {
					var blocks = html.c;
					return A3(
						$dillonkearns$elm_markdown$Markdown$Block$foldl,
						F2(
							function (block, soFar) {
								return _Utils_ap(
									soFar,
									$dillonkearns$elm_markdown$Markdown$Block$extractInlineBlockText(block));
							}),
						text,
						blocks);
				} else {
					return text;
				}
			case 4:
				var inlines = inline.a;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			case 3:
				var inlines = inline.a;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
			default:
				var inlines = inline.a;
				return _Utils_ap(
					text,
					$dillonkearns$elm_markdown$Markdown$Block$extractInlineText(inlines));
		}
	});
var $elm$core$Tuple$pair = F2(
	function (a, b) {
		return _Utils_Tuple2(a, b);
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderHtml = F5(
	function (tagName, attributes, children, _v0, renderedChildren) {
		var htmlRenderer = _v0;
		return A2(
			$elm$core$Result$andThen,
			function (okChildren) {
				return A2(
					$elm$core$Result$map,
					function (myRenderer) {
						return myRenderer(okChildren);
					},
					A3(htmlRenderer, tagName, attributes, children));
			},
			$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(renderedChildren));
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$foldThing = F3(
	function (renderer, topLevelInline, soFar) {
		var _v12 = A2($dillonkearns$elm_markdown$Markdown$Renderer$renderSingleInline, renderer, topLevelInline);
		if (!_v12.$) {
			var inline = _v12.a;
			return A2($elm$core$List$cons, inline, soFar);
		} else {
			return soFar;
		}
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderHelper = F2(
	function (renderer, blocks) {
		return A2(
			$elm$core$List$filterMap,
			$dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle(renderer),
			blocks);
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle = function (renderer) {
	return function (block) {
		switch (block.$) {
			case 4:
				var level = block.a;
				var content = block.b;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						function (children) {
							return renderer.cg(
								{
									c5: children,
									dG: level,
									gG: $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(content)
								});
						},
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, content)));
			case 5:
				var content = block.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.cu,
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, content)));
			case 0:
				var html = block.a;
				if (!html.$) {
					var tag = html.a;
					var attributes = html.b;
					var children = html.c;
					return $elm$core$Maybe$Just(
						A4($dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode, renderer, tag, attributes, children));
				} else {
					return $elm$core$Maybe$Nothing;
				}
			case 1:
				var tight = block.a;
				var items = block.b;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						function (listItems) {
							return renderer.cN(
								A2(
									$elm$core$List$map,
									function (_v7) {
										var task = _v7.a;
										var children = _v7.b;
										return A2(
											$dillonkearns$elm_markdown$Markdown$Block$ListItem,
											task,
											$elm$core$List$concat(children));
									},
									listItems));
						},
						$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
							A2(
								$elm$core$List$map,
								function (_v4) {
									var task = _v4.a;
									var children = _v4.b;
									return A2(
										$elm$core$Result$map,
										$dillonkearns$elm_markdown$Markdown$Block$ListItem(task),
										$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
											function (blocks) {
												return A2(
													$elm$core$List$filterMap,
													function (listItemBlock) {
														var _v5 = _Utils_Tuple2(tight, listItemBlock);
														if ((_v5.a === 1) && (_v5.b.$ === 5)) {
															var _v6 = _v5.a;
															var content = _v5.b.a;
															return $elm$core$Maybe$Just(
																A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, content));
														} else {
															return A2(
																$elm$core$Maybe$map,
																$elm$core$Result$map($elm$core$List$singleton),
																A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle, renderer, listItemBlock));
														}
													},
													blocks);
											}(children)));
								},
								items))));
			case 2:
				var tight = block.a;
				var startingIndex = block.b;
				var items = block.c;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						function (listItems) {
							return A2(
								renderer.cs,
								startingIndex,
								A2(
									$elm$core$List$map,
									function (children) {
										return $elm$core$List$concat(children);
									},
									listItems));
						},
						$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
							A2(
								$elm$core$List$map,
								function (itemsblocks) {
									return $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
										function (blocks) {
											return A2(
												$elm$core$List$filterMap,
												function (listItemBlock) {
													var _v8 = _Utils_Tuple2(tight, listItemBlock);
													if ((_v8.a === 1) && (_v8.b.$ === 5)) {
														var _v9 = _v8.a;
														var content = _v8.b.a;
														return $elm$core$Maybe$Just(
															A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, content));
													} else {
														return A2(
															$elm$core$Maybe$map,
															$elm$core$Result$map($elm$core$List$singleton),
															A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelperSingle, renderer, listItemBlock));
													}
												},
												blocks);
										}(itemsblocks));
								},
								items))));
			case 7:
				var codeBlock = block.a;
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(
						renderer.b6(codeBlock)));
			case 8:
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(renderer.cM));
			case 3:
				var nestedBlocks = block.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.b5,
						$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
							A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelper, renderer, nestedBlocks))));
			default:
				var header = block.a;
				var rows = block.b;
				var renderedHeaderCells = $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
					A2(
						$elm$core$List$map,
						function (_v11) {
							var label = _v11.aN;
							var alignment = _v11.bo;
							return A2(
								$elm$core$Result$map,
								$elm$core$Tuple$pair(alignment),
								A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, label));
						},
						header));
				var renderedHeader = A2(
					$elm$core$Result$map,
					function (listListView) {
						return renderer.cI(
							$elm$core$List$singleton(
								renderer.bZ(
									A2(
										$elm$core$List$map,
										function (_v10) {
											var maybeAlignment = _v10.a;
											var item = _v10.b;
											return A2(renderer.cJ, maybeAlignment, item);
										},
										listListView))));
					},
					renderedHeaderCells);
				var renderedBody = function (r) {
					return $elm$core$List$isEmpty(r) ? _List_Nil : _List_fromArray(
						[
							renderer.cG(r)
						]);
				};
				var alignmentForColumn = function (columnIndex) {
					return A2(
						$elm$core$Maybe$andThen,
						function ($) {
							return $.bo;
						},
						$elm$core$List$head(
							A2($elm$core$List$drop, columnIndex, header)));
				};
				var renderRow = function (cells) {
					return A2(
						$elm$core$Result$map,
						renderer.bZ,
						A2(
							$elm$core$Result$map,
							$elm$core$List$indexedMap(
								F2(
									function (index, cell) {
										return A2(
											renderer.cH,
											alignmentForColumn(index),
											cell);
									})),
							$dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
								A2(
									$elm$core$List$map,
									$dillonkearns$elm_markdown$Markdown$Renderer$renderStyled(renderer),
									cells))));
				};
				var renderedRows = $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
					A2($elm$core$List$map, renderRow, rows));
				return $elm$core$Maybe$Just(
					A3(
						$elm$core$Result$map2,
						F2(
							function (h, r) {
								return renderer.cF(
									A2(
										$elm$core$List$cons,
										h,
										renderedBody(r)));
							}),
						renderedHeader,
						renderedRows));
		}
	};
};
var $dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode = F4(
	function (renderer, tag, attributes, children) {
		return A5(
			$dillonkearns$elm_markdown$Markdown$Renderer$renderHtml,
			tag,
			attributes,
			children,
			renderer.ch,
			A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelper, renderer, children));
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderSingleInline = F2(
	function (renderer, inline) {
		switch (inline.$) {
			case 4:
				var innerInlines = inline.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.cD,
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, innerInlines)));
			case 3:
				var innerInlines = inline.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.ca,
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, innerInlines)));
			case 5:
				var innerInlines = inline.a;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$map,
						renderer.cC,
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, innerInlines)));
			case 2:
				var src = inline.a;
				var title = inline.b;
				var children = inline.c;
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(
						renderer.dt(
							{
								b3: $dillonkearns$elm_markdown$Markdown$Block$extractInlineText(children),
								cB: src,
								g4: title
							})));
			case 7:
				var string = inline.a;
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(
						renderer.V(string)));
			case 6:
				var string = inline.a;
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(
						renderer.b7(string)));
			case 1:
				var destination = inline.a;
				var title = inline.b;
				var inlines = inline.c;
				return $elm$core$Maybe$Just(
					A2(
						$elm$core$Result$andThen,
						function (children) {
							return $elm$core$Result$Ok(
								A2(
									renderer.fX,
									{dc: destination, g4: title},
									children));
						},
						A2($dillonkearns$elm_markdown$Markdown$Renderer$renderStyled, renderer, inlines)));
			case 8:
				return $elm$core$Maybe$Just(
					$elm$core$Result$Ok(renderer.cf));
			default:
				var html = inline.a;
				if (!html.$) {
					var tag = html.a;
					var attributes = html.b;
					var children = html.c;
					return $elm$core$Maybe$Just(
						A4($dillonkearns$elm_markdown$Markdown$Renderer$renderHtmlNode, renderer, tag, attributes, children));
				} else {
					return $elm$core$Maybe$Nothing;
				}
		}
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$renderStyled = F2(
	function (renderer, styledStrings) {
		return $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
			A3(
				$elm$core$List$foldr,
				$dillonkearns$elm_markdown$Markdown$Renderer$foldThing(renderer),
				_List_Nil,
				styledStrings));
	});
var $dillonkearns$elm_markdown$Markdown$Renderer$render = F2(
	function (renderer, ast) {
		return $dillonkearns$elm_markdown$Markdown$Renderer$combineResults(
			A2($dillonkearns$elm_markdown$Markdown$Renderer$renderHelper, renderer, ast));
	});
var $rtfeldman$elm_css$VirtualDom$Styled$text = function (str) {
	return $rtfeldman$elm_css$VirtualDom$Styled$Unstyled(
		$elm$virtual_dom$VirtualDom$text(str));
};
var $rtfeldman$elm_css$Html$Styled$text = $rtfeldman$elm_css$VirtualDom$Styled$text;
var $author$project$Ui$UiComponents$StepHelper$renderMarkdown = F2(
	function (wrapper, text) {
		var _v0 = A2(
			$elm$core$Result$andThen,
			function (ast) {
				return A2($dillonkearns$elm_markdown$Markdown$Renderer$render, $author$project$Ui$UiComponents$StepHelper$customHtmlRenderer, ast);
			},
			A2(
				$elm$core$Result$mapError,
				$author$project$Ui$UiComponents$StepHelper$deadEndsToString,
				$dillonkearns$elm_markdown$Markdown$Parser$parse(text)));
		if (!_v0.$) {
			var rendered = _v0.a;
			return wrapper(
				A2($elm$core$List$map, $rtfeldman$elm_css$Html$Styled$fromUnstyled, rendered));
		} else {
			var errors = _v0.a;
			return $rtfeldman$elm_css$Html$Styled$text(errors);
		}
	});
var $author$project$TW$Utilities$text_red_700 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--text-opacity', '1'),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('#c53030')),
			A2($rtfeldman$elm_css$Css$property, 'color', 'rgba(197, 48, 48, var(--text-opacity))')
		]));
var $author$project$TW$Utilities$text_yellow_800 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--text-opacity', '1'),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('#975a16')),
			A2($rtfeldman$elm_css$Css$property, 'color', 'rgba(151, 90, 22, var(--text-opacity))')
		]));
var $author$project$Ui$UiComponents$StepHelper$renderDescription = function (step) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$div,
		_List_Nil,
		_List_fromArray(
			[
				$author$project$Ui$UiComponents$StepHelper$removeLastElementMargin,
				function () {
				var _v0 = step.fl;
				switch (_v0.$) {
					case 2:
						var info = _v0.a;
						return A2(
							$author$project$Ui$UiComponents$StepHelper$renderMarkdown,
							$rtfeldman$elm_css$Html$Styled$div(_List_Nil),
							info);
					case 0:
						var warning = _v0.a;
						return A2(
							$author$project$Ui$UiComponents$StepHelper$renderMarkdown,
							$rtfeldman$elm_css$Html$Styled$div(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('markdown-field'),
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[$author$project$TW$Utilities$p_2, $author$project$TW$Utilities$bg_yellow_200, $author$project$TW$Utilities$text_yellow_800, $author$project$TW$Utilities$font_bold, $author$project$TW$Utilities$mb_3]))
									])),
							warning);
					case 1:
						var danger = _v0.a;
						return A2(
							$author$project$Ui$UiComponents$StepHelper$renderMarkdown,
							$rtfeldman$elm_css$Html$Styled$div(
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$class('markdown-field'),
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[$author$project$TW$Utilities$p_2, $author$project$TW$Utilities$bg_red_200, $author$project$TW$Utilities$text_red_700, $author$project$TW$Utilities$font_bold, $author$project$TW$Utilities$mb_3]))
									])),
							danger);
					default:
						return $rtfeldman$elm_css$Html$Styled$text('');
				}
			}()
			]));
};
var $author$project$TW$Utilities$mb_2 = $rtfeldman$elm_css$Css$marginBottom(
	$rtfeldman$elm_css$Css$rem(0.5));
var $author$project$TW$Utilities$text_lg = $rtfeldman$elm_css$Css$fontSize(
	$rtfeldman$elm_css$Css$rem(1.125));
var $author$project$Ui$UiComponents$Form$stepHeadlineStyle = $rtfeldman$elm_css$Html$Styled$Attributes$css(
	_List_fromArray(
		[$author$project$TW$Utilities$block, $author$project$TW$Utilities$text_lg, $author$project$TW$Utilities$text_gray_700, $author$project$TW$Utilities$font_bold, $author$project$TW$Utilities$mb_2]));
var $author$project$Ui$UiComponents$Form$step_headline = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$h3,
			A2($elm$core$List$cons, $author$project$Ui$UiComponents$Form$stepHeadlineStyle, attributes),
			children);
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$type_ = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('type');
var $rtfeldman$elm_css$Html$Styled$Attributes$value = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('value');
var $author$project$Ui$Pages$Steps$Amount$inline = F5(
	function (operationId, station, step, iteration, amountModel) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$UiComponents$Form$step_headline,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$for(
							A2(
								$elm$core$String$join,
								'_',
								_List_fromArray(
									[
										operationId,
										station.bD,
										_Utils_ap(
										step.bD,
										$elm$core$String$fromInt(iteration))
									])))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(step.dP)
						])),
					$author$project$Ui$UiComponents$StepHelper$renderDescription(step),
					A2(
					$author$project$Ui$UiComponents$Form$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onInput(
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Basics$identity,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Msg$StepAmountMsg,
									A2(
										$elm$core$Basics$composeR,
										A2($author$project$Msg$StationUpdateStepState, step.bD, iteration),
										A2($author$project$Msg$StationMsg_, operationId, station.bD))))),
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('number'),
							$rtfeldman$elm_css$Html$Styled$Attributes$value(
							$elm$core$String$fromInt(
								A2($elm$core$Maybe$withDefault, 0, amountModel))),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(
							A2(
								$elm$core$String$join,
								'_',
								_List_fromArray(
									[
										operationId,
										station.bD,
										_Utils_ap(
										step.bD,
										$elm$core$String$fromInt(iteration))
									])))
						]),
					_List_Nil)
				]));
	});
var $author$project$Msg$ArticleInputNewArticleType = {$: 2};
var $author$project$Msg$StepArticleInputMsg = F2(
	function (a, b) {
		return {$: 7, a: a, b: b};
	});
var $author$project$Msg$ArticleInputAddSn = function (a) {
	return {$: 4, a: a};
};
var $author$project$Msg$ArticleInputDeleteSn = F2(
	function (a, b) {
		return {$: 6, a: a, b: b};
	});
var $author$project$Msg$ArticleInputSelectTemplate = F3(
	function (a, b, c) {
		return {$: 0, a: a, b: b, c: c};
	});
var $author$project$Msg$ArticleInputSerialNum = F3(
	function (a, b, c) {
		return {$: 3, a: a, b: b, c: c};
	});
var $author$project$Msg$ArticleInputSetAmount = F2(
	function (a, b) {
		return {$: 1, a: a, b: b};
	});
var $author$project$Msg$ArticleInputToggleDeleteSn = F3(
	function (a, b, c) {
		return {$: 5, a: a, b: b, c: c};
	});
var $author$project$TW$Utilities$bg_gray_500 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--bg-opacity', '1'),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('#a0aec0')),
			A2($rtfeldman$elm_css$Css$property, 'background-color', 'rgba(160, 174, 192, var(--bg-opacity))')
		]));
var $author$project$TW$Utilities$bg_red_500 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--bg-opacity', '1'),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('#f56565')),
			A2($rtfeldman$elm_css$Css$property, 'background-color', 'rgba(245, 101, 101, var(--bg-opacity))')
		]));
var $rtfeldman$elm_css$Css$borderBottomWidth = $rtfeldman$elm_css$Css$prop1('border-bottom-width');
var $author$project$TW$Utilities$border_b = $rtfeldman$elm_css$Css$borderBottomWidth(
	$rtfeldman$elm_css$Css$px(1));
var $rtfeldman$elm_css$Css$borderLeftWidth = $rtfeldman$elm_css$Css$prop1('border-left-width');
var $author$project$TW$Utilities$border_l_0 = $rtfeldman$elm_css$Css$borderLeftWidth(
	$rtfeldman$elm_css$Css$px(0));
var $rtfeldman$elm_css$Css$borderRightWidth = $rtfeldman$elm_css$Css$prop1('border-right-width');
var $author$project$TW$Utilities$border_r_0 = $rtfeldman$elm_css$Css$borderRightWidth(
	$rtfeldman$elm_css$Css$px(0));
var $rtfeldman$elm_css$Css$borderTopWidth = $rtfeldman$elm_css$Css$prop1('border-top-width');
var $author$project$TW$Utilities$border_t_0 = $rtfeldman$elm_css$Css$borderTopWidth(
	$rtfeldman$elm_css$Css$px(0));
var $rtfeldman$elm_css$Html$Styled$br = $rtfeldman$elm_css$Html$Styled$node('br');
var $author$project$TW$Utilities$border_gray_600 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--border-opacity', '1'),
			$rtfeldman$elm_css$Css$borderColor(
			$rtfeldman$elm_css$Css$hex('#718096')),
			A2($rtfeldman$elm_css$Css$property, 'border-color', 'rgba(113, 128, 150, var(--border-opacity))')
		]));
var $author$project$Ui$UiComponents$Form$btnClear = F3(
	function (disabled, attributes, children) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							_List_fromArray(
								[$author$project$TW$Utilities$py_2, $author$project$TW$Utilities$px_2, $author$project$TW$Utilities$rounded, $author$project$TW$Utilities$border, $author$project$TW$Utilities$border_solid]),
							disabled ? _List_fromArray(
								[$author$project$TW$Utilities$opacity_50, $author$project$TW$Utilities$bg_gray_200, $author$project$TW$Utilities$text_gray_800, $author$project$TW$Utilities$border_gray_300]) : _List_fromArray(
								[$author$project$TW$Utilities$bg_white, $author$project$TW$Utilities$text_gray_800, $author$project$TW$Utilities$border_gray_600]))),
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(disabled)
					]),
				attributes),
			children);
	});
var $author$project$TW$Utilities$border_red_500 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--border-opacity', '1'),
			$rtfeldman$elm_css$Css$borderColor(
			$rtfeldman$elm_css$Css$hex('#f56565')),
			A2($rtfeldman$elm_css$Css$property, 'border-color', 'rgba(245, 101, 101, var(--border-opacity))')
		]));
var $author$project$TW$Utilities$text_red_800 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--text-opacity', '1'),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('#9b2c2c')),
			A2($rtfeldman$elm_css$Css$property, 'color', 'rgba(155, 44, 44, var(--text-opacity))')
		]));
var $author$project$Ui$UiComponents$Form$btnRed = F3(
	function (disabled, attributes, children) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							_List_fromArray(
								[$author$project$TW$Utilities$px_2, $author$project$TW$Utilities$py_2, $author$project$TW$Utilities$rounded, $author$project$TW$Utilities$border, $author$project$TW$Utilities$border_solid]),
							disabled ? _List_fromArray(
								[$author$project$TW$Utilities$opacity_50, $author$project$TW$Utilities$bg_gray_200, $author$project$TW$Utilities$text_gray_800, $author$project$TW$Utilities$border_gray_300]) : _List_fromArray(
								[$author$project$TW$Utilities$bg_red_200, $author$project$TW$Utilities$text_red_800, $author$project$TW$Utilities$border_red_500]))),
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(disabled)
					]),
				attributes),
			children);
	});
var $author$project$TemporaryWarehouse$clusterArticlesByType = function (stations) {
	var articlesWithId = A2(
		$elm$core$List$map,
		function (station) {
			var inputIds = A2(
				$elm$core$List$filterMap,
				function (step) {
					var _v9 = step.eF;
					if (_v9.$ === 7) {
						return $elm$core$Maybe$Just(step.bD);
					} else {
						return $elm$core$Maybe$Nothing;
					}
				},
				station.eE);
			var data = $elm$core$List$concat(
				A2(
					$elm$core$List$map,
					function (iteration) {
						return A2(
							$elm$core$List$filterMap,
							function (stepId) {
								return A2(
									$elm$core$Maybe$map,
									function (articleInputModel) {
										return _Utils_Tuple3(stepId, iteration, articleInputModel);
									},
									A2(
										$elm$core$Dict$get,
										_Utils_ap(
											stepId,
											$elm$core$String$fromInt(iteration)),
										station.A.R));
							},
							inputIds);
					},
					station.ab));
			return _Utils_Tuple2(station.bD, data);
		},
		stations);
	var articlesToTempId = F4(
		function (stationId, stepId, iteration, articles) {
			return A3(
				$elm$core$List$foldl,
				F2(
					function (_v7, inner) {
						var article = _v7.a;
						var template = _v7.b;
						var articleIds = template.gQ ? A2(
							$elm$core$List$map,
							function (_v8) {
								var snCounter = _v8.a;
								var sn = _v8.b;
								return $author$project$Types$Steps$ArticleInstallation$Sn(
									{bq: template.g1, fl: template.g4, fV: iteration, eu: sn, gS: snCounter, gU: stationId, gX: stepId});
							},
							$elm$core$Dict$toList(article.ao)) : _List_fromArray(
							[
								$author$project$Types$Steps$ArticleInstallation$NoSn(
								{Q: article.Q, bq: template.g1, fl: template.g4, fV: iteration, gU: stationId, gX: stepId})
							]);
						return A2($elm$core$List$append, inner, articleIds);
					}),
				_List_Nil,
				A2(
					$elm$core$List$filterMap,
					function (article) {
						var _v6 = article.gO;
						if (!_v6.$) {
							var template = _v6.a;
							return $elm$core$Maybe$Just(
								_Utils_Tuple2(article, template));
						} else {
							return $elm$core$Maybe$Nothing;
						}
					},
					articles));
		});
	var transformToTempId = function (_v5) {
		var stationId = _v5.a;
		var articleList = _v5.b;
		return $elm$core$List$concat(
			A2(
				$elm$core$List$map,
				function (_v4) {
					var stepId = _v4.a;
					var iteration = _v4.b;
					var articles = _v4.c;
					return A4(articlesToTempId, stationId, stepId, iteration, articles);
				},
				articleList));
	};
	var temporaryWarehouseArticleIds = $elm$core$List$concat(
		A2($elm$core$List$map, transformToTempId, articlesWithId));
	var clusteredArticles = function () {
		var handleSn = F3(
			function (rma, sn, noSn) {
				return (rma.eu.ex !== '') ? _Utils_Tuple2(
					A3(
						$elm$core$Dict$update,
						rma.bq,
						function (res) {
							if (!res.$) {
								var list = res.a;
								return $elm$core$Maybe$Just(
									A2(
										$elm$core$List$append,
										list,
										_List_fromArray(
											[rma])));
							} else {
								return $elm$core$Maybe$Just(
									_List_fromArray(
										[rma]));
							}
						},
						sn),
					noSn) : _Utils_Tuple2(sn, noSn);
			});
		var handleNoSn = F3(
			function (rma, sn, noSn) {
				return _Utils_Tuple2(
					sn,
					A3(
						$elm$core$Dict$update,
						rma.bq,
						function (res) {
							if (!res.$) {
								var acc = res.a;
								return $elm$core$Maybe$Just(
									_Utils_update(
										acc,
										{Q: acc.Q + rma.Q}));
							} else {
								return $elm$core$Maybe$Just(rma);
							}
						},
						noSn));
			});
		return A3(
			$elm$core$List$foldl,
			F2(
				function (article, _v0) {
					var sn = _v0.a;
					var noSn = _v0.b;
					switch (article.$) {
						case 1:
							var rma = article.a;
							return A3(handleSn, rma, sn, noSn);
						case 0:
							var rma = article.a;
							return A3(handleNoSn, rma, sn, noSn);
						case 2:
							var rma = article.a;
							return A3(handleSn, rma, sn, noSn);
						default:
							var rma = article.a;
							return A3(handleNoSn, rma, sn, noSn);
					}
				}),
			_Utils_Tuple2($elm$core$Dict$empty, $elm$core$Dict$empty),
			temporaryWarehouseArticleIds);
	}();
	return clusteredArticles;
};
var $author$project$TemporaryWarehouse$findUsedTempArticles = function (stations) {
	return $elm$core$List$concat(
		A2(
			$elm$core$List$map,
			function (station) {
				var data = A2(
					$elm$core$List$filterMap,
					function (articleInstallationModel) {
						if ((!articleInstallationModel.$) && (articleInstallationModel.a.$ === 1)) {
							var tempArticleId = articleInstallationModel.a.a;
							return $elm$core$Maybe$Just(tempArticleId);
						} else {
							return $elm$core$Maybe$Nothing;
						}
					},
					A2(
						$elm$core$List$map,
						$elm$core$Tuple$second,
						$elm$core$Dict$toList(station.A.ag)));
				return data;
			},
			stations));
};
var $rtfeldman$elm_css$Html$Styled$li = $rtfeldman$elm_css$Html$Styled$node('li');
var $author$project$TW$Utilities$mb_1 = $rtfeldman$elm_css$Css$marginBottom(
	$rtfeldman$elm_css$Css$rem(0.25));
var $author$project$TW$Utilities$mb_4 = $rtfeldman$elm_css$Css$marginBottom(
	$rtfeldman$elm_css$Css$rem(1));
var $author$project$TW$Utilities$ml_2 = $rtfeldman$elm_css$Css$marginLeft(
	$rtfeldman$elm_css$Css$rem(0.5));
var $author$project$TW$Utilities$mr_2 = $rtfeldman$elm_css$Css$marginRight(
	$rtfeldman$elm_css$Css$rem(0.5));
var $author$project$TW$Utilities$my_0 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$px(0))
		]));
var $rtfeldman$elm_css$Html$Styled$option = $rtfeldman$elm_css$Html$Styled$node('option');
var $rtfeldman$elm_css$Html$Styled$Attributes$placeholder = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('placeholder');
var $author$project$TW$Utilities$px_4 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$rem(1)),
			$rtfeldman$elm_css$Css$paddingRight(
			$rtfeldman$elm_css$Css$rem(1))
		]));
var $rtfeldman$elm_css$Css$absolute = {bd: 0, cO: 'absolute'};
var $author$project$TW$Utilities$absolute = $rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$absolute);
var $feathericons$elm_feather$FeatherIcons$Icon = $elm$core$Basics$identity;
var $feathericons$elm_feather$FeatherIcons$defaultAttributes = function (name) {
	return {
		bw: $elm$core$Maybe$Just('feather feather-' + name),
		ev: 24,
		bf: '',
		bX: 2,
		b1: '0 0 24 24'
	};
};
var $feathericons$elm_feather$FeatherIcons$makeBuilder = F2(
	function (name, src) {
		return {
			B: $feathericons$elm_feather$FeatherIcons$defaultAttributes(name),
			cB: src
		};
	});
var $elm$svg$Svg$Attributes$points = _VirtualDom_attribute('points');
var $elm$svg$Svg$trustedNode = _VirtualDom_nodeNS('http://www.w3.org/2000/svg');
var $elm$svg$Svg$polyline = $elm$svg$Svg$trustedNode('polyline');
var $feathericons$elm_feather$FeatherIcons$chevronDown = A2(
	$feathericons$elm_feather$FeatherIcons$makeBuilder,
	'chevron-down',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$polyline,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('6 9 12 15 18 9')
				]),
			_List_Nil)
		]));
var $elm$svg$Svg$Attributes$class = _VirtualDom_attribute('class');
var $elm$svg$Svg$Attributes$fill = _VirtualDom_attribute('fill');
var $elm$svg$Svg$Attributes$height = _VirtualDom_attribute('height');
var $elm$virtual_dom$VirtualDom$map = _VirtualDom_map;
var $elm$svg$Svg$map = $elm$virtual_dom$VirtualDom$map;
var $elm$svg$Svg$Attributes$stroke = _VirtualDom_attribute('stroke');
var $elm$svg$Svg$Attributes$strokeLinecap = _VirtualDom_attribute('stroke-linecap');
var $elm$svg$Svg$Attributes$strokeLinejoin = _VirtualDom_attribute('stroke-linejoin');
var $elm$svg$Svg$Attributes$strokeWidth = _VirtualDom_attribute('stroke-width');
var $elm$svg$Svg$svg = $elm$svg$Svg$trustedNode('svg');
var $elm$svg$Svg$Attributes$viewBox = _VirtualDom_attribute('viewBox');
var $elm$svg$Svg$Attributes$width = _VirtualDom_attribute('width');
var $feathericons$elm_feather$FeatherIcons$toHtml = F2(
	function (attributes, _v0) {
		var src = _v0.cB;
		var attrs = _v0.B;
		var strSize = $elm$core$String$fromFloat(attrs.ev);
		var baseAttributes = _List_fromArray(
			[
				$elm$svg$Svg$Attributes$fill('none'),
				$elm$svg$Svg$Attributes$height(
				_Utils_ap(strSize, attrs.bf)),
				$elm$svg$Svg$Attributes$width(
				_Utils_ap(strSize, attrs.bf)),
				$elm$svg$Svg$Attributes$stroke('currentColor'),
				$elm$svg$Svg$Attributes$strokeLinecap('round'),
				$elm$svg$Svg$Attributes$strokeLinejoin('round'),
				$elm$svg$Svg$Attributes$strokeWidth(
				$elm$core$String$fromFloat(attrs.bX)),
				$elm$svg$Svg$Attributes$viewBox(attrs.b1)
			]);
		var combinedAttributes = _Utils_ap(
			function () {
				var _v1 = attrs.bw;
				if (!_v1.$) {
					var c = _v1.a;
					return A2(
						$elm$core$List$cons,
						$elm$svg$Svg$Attributes$class(c),
						baseAttributes);
				} else {
					return baseAttributes;
				}
			}(),
			attributes);
		return A2(
			$elm$svg$Svg$svg,
			combinedAttributes,
			A2(
				$elm$core$List$map,
				$elm$svg$Svg$map($elm$core$Basics$never),
				src));
	});
var $author$project$Ui$UiComponents$Icons$icon = function (i) {
	return $rtfeldman$elm_css$Html$Styled$fromUnstyled(
		A2($feathericons$elm_feather$FeatherIcons$toHtml, _List_Nil, i));
};
var $rtfeldman$elm_css$Css$relative = {bd: 0, cO: 'relative'};
var $author$project$TW$Utilities$relative = $rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$relative);
var $rtfeldman$elm_css$Html$Styled$select = $rtfeldman$elm_css$Html$Styled$node('select');
var $author$project$TW$Utilities$text_gray_400 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--text-opacity', '1'),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('#cbd5e0')),
			A2($rtfeldman$elm_css$Css$property, 'color', 'rgba(203, 213, 224, var(--text-opacity))')
		]));
var $author$project$Ui$UiComponents$Form$select = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[$author$project$TW$Utilities$relative, $author$project$TW$Utilities$w_full]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$select,
					_Utils_ap(
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[$author$project$TW$Utilities$w_full, $author$project$TW$Utilities$p_2, $author$project$TW$Utilities$rounded, $author$project$TW$Utilities$border, $author$project$TW$Utilities$border_gray_300, $author$project$TW$Utilities$border_solid, $author$project$TW$Utilities$block, $author$project$TW$Utilities$mt_1, $author$project$TW$Utilities$mb_3, $author$project$TW$Utilities$bg_white]))
							]),
						attributes),
					children),
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$author$project$TW$Utilities$text_gray_400, $author$project$TW$Utilities$absolute, $author$project$TW$Utilities$right_0, $author$project$TW$Utilities$top_0, $author$project$TW$Utilities$p_2]))
						]),
					_List_fromArray(
						[
							$author$project$Ui$UiComponents$Icons$icon($feathericons$elm_feather$FeatherIcons$chevronDown)
						]))
				]));
	});
var $rtfeldman$elm_css$Css$textAlign = function (fn) {
	return A3(
		$rtfeldman$elm_css$Css$Internal$getOverloadedProperty,
		'textAlign',
		'text-align',
		fn($rtfeldman$elm_css$Css$Internal$lengthForOverloadedProperty));
};
var $author$project$TW$Utilities$text_center = $rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$center);
var $author$project$TW$Utilities$text_left = $rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$left);
var $author$project$TW$Utilities$text_red_500 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--text-opacity', '1'),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('#f56565')),
			A2($rtfeldman$elm_css$Css$property, 'color', 'rgba(245, 101, 101, var(--text-opacity))')
		]));
var $author$project$TW$Utilities$text_white = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--text-opacity', '1'),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('#fff')),
			A2($rtfeldman$elm_css$Css$property, 'color', 'rgba(255, 255, 255, var(--text-opacity))')
		]));
var $author$project$Translations$uiPagesStepsArticle_inputAbort = function (lang) {
	if (!lang) {
		return 'Abbruch';
	} else {
		return 'Abort';
	}
};
var $author$project$Translations$uiPagesStepsArticle_inputAdd_sn = function (lang) {
	if (!lang) {
		return 'SN hinzufügen';
	} else {
		return 'add SN';
	}
};
var $author$project$Translations$uiPagesStepsArticle_inputAmount = function (lang) {
	if (!lang) {
		return 'Anzahl';
	} else {
		return 'Amount';
	}
};
var $author$project$Translations$uiPagesStepsArticle_inputAttention_sn_duplicate = function (lang) {
	if (!lang) {
		return 'Vorsicht! SN-Duplikat!';
	} else {
		return 'Attention! SN-Duplicate';
	}
};
var $author$project$Translations$uiPagesStepsArticle_inputManufacturer_name = function (lang) {
	if (!lang) {
		return 'Herstellername';
	} else {
		return 'Manufacturer name';
	}
};
var $author$project$Translations$uiPagesStepsArticle_inputMissing = function (lang) {
	if (!lang) {
		return 'Es Fehlen: ';
	} else {
		return 'Missing: ';
	}
};
var $author$project$Translations$uiPagesStepsArticle_inputReally_delete_sn = function (lang) {
	if (!lang) {
		return 'SN wirklich löschen?';
	} else {
		return 'Really delete SN?';
	}
};
var $author$project$Translations$uiPagesStepsArticle_inputSerial_number = function (lang) {
	if (!lang) {
		return 'Seriennummer';
	} else {
		return 'Serial number';
	}
};
var $author$project$Translations$uiPagesStepsArticle_inputYou_used_more_articles_than_you_have_in_stock = function (lang) {
	if (!lang) {
		return 'Sie haben jetzt mehr Artikel von diesem Typ verwendet, als Sie auf Lager haben.';
	} else {
		return 'You used more articles than you have in stock.';
	}
};
var $rtfeldman$elm_css$Html$Styled$ul = $rtfeldman$elm_css$Html$Styled$node('ul');
var $author$project$Ui$Pages$Steps$ArticleInput$articleInput = function (language) {
	return function (handler) {
		return function (stations) {
			return function (capturedSnList) {
				return function (listOfUsedTemplateIds) {
					return function (notSelectedOptions) {
						return function (usedArticles) {
							return function (operationId) {
								return function (station) {
									return function (step) {
										return function (iteration) {
											return function (config) {
												return function (idx) {
													return function (article) {
														var isSelectboxDisabled = !(($elm$core$List$isEmpty(
															$elm$core$Dict$toList(article.ao)) && (!article.Q)) || _Utils_eq(article.gO, $elm$core$Maybe$Nothing));
														var isMoreSnDisabled = _Utils_cmp(
															article.Q,
															$elm$core$List$length(
																$elm$core$Dict$toList(article.ao))) < 1;
														var currentlySelectedOption = function () {
															var _v7 = article.gO;
															if (_v7.$ === 1) {
																return _List_Nil;
															} else {
																var selectedTemplate = _v7.a;
																return _List_fromArray(
																	[selectedTemplate]);
															}
														}();
														var options = $elm$core$List$concat(
															_List_fromArray(
																[currentlySelectedOption, notSelectedOptions]));
														return A2(
															$rtfeldman$elm_css$Html$Styled$li,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css(
																	_List_fromArray(
																		[$author$project$TW$Utilities$border_b, $author$project$TW$Utilities$border_solid, $author$project$TW$Utilities$border_t_0, $author$project$TW$Utilities$border_l_0, $author$project$TW$Utilities$border_r_0, $author$project$TW$Utilities$border_gray_300, $author$project$TW$Utilities$mb_4]))
																]),
															_List_fromArray(
																[
																	A2(
																	$author$project$Ui$UiComponents$Form$select,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$css(
																			_List_fromArray(
																				[$author$project$TW$Utilities$border, $author$project$TW$Utilities$border_solid])),
																			$rtfeldman$elm_css$Html$Styled$Events$onInput(
																			A2(
																				$elm$core$Basics$composeR,
																				A2($author$project$Msg$ArticleInputSelectTemplate, idx, config.dV),
																				A2(
																					$elm$core$Basics$composeR,
																					$author$project$Msg$StepArticleInputMsg(handler),
																					A2(
																						$elm$core$Basics$composeR,
																						A2($author$project$Msg$StationUpdateStepState, step.bD, iteration),
																						A2($author$project$Msg$StationMsg_, operationId, station.bD))))),
																			$rtfeldman$elm_css$Html$Styled$Attributes$value(
																			function () {
																				var _v0 = article.gO;
																				if (!_v0.$) {
																					var template = _v0.a;
																					return $elm$core$String$fromInt(template.g1);
																				} else {
																					return '';
																				}
																			}()),
																			$rtfeldman$elm_css$Html$Styled$Attributes$disabled(isSelectboxDisabled),
																			$rtfeldman$elm_css$Html$Styled$Attributes$css(
																			isSelectboxDisabled ? _List_fromArray(
																				[$author$project$TW$Utilities$opacity_75, $author$project$TW$Utilities$bg_gray_500]) : _List_Nil)
																		]),
																	A2(
																		$elm$core$List$map,
																		function (template) {
																			return A2(
																				$rtfeldman$elm_css$Html$Styled$option,
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$Attributes$value(
																						$elm$core$String$fromInt(template.g1))
																					]),
																				_List_fromArray(
																					[
																						$rtfeldman$elm_css$Html$Styled$text(template.g4)
																					]));
																		},
																		options)),
																	A2(
																	$rtfeldman$elm_css$Html$Styled$div,
																	_List_Nil,
																	_List_fromArray(
																		[
																			A2(
																			$author$project$Ui$UiComponents$Form$input,
																			_List_fromArray(
																				[
																					$rtfeldman$elm_css$Html$Styled$Attributes$type_('number'),
																					$rtfeldman$elm_css$Html$Styled$Attributes$value(
																					$elm$core$String$fromInt(article.Q)),
																					$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(
																					$author$project$Translations$uiPagesStepsArticle_inputAmount(language)),
																					$rtfeldman$elm_css$Html$Styled$Events$onInput(
																					A2(
																						$elm$core$Basics$composeR,
																						$author$project$Msg$ArticleInputSetAmount(idx),
																						A2(
																							$elm$core$Basics$composeR,
																							$author$project$Msg$StepArticleInputMsg(handler),
																							A2(
																								$elm$core$Basics$composeR,
																								A2($author$project$Msg$StationUpdateStepState, step.bD, iteration),
																								A2($author$project$Msg$StationMsg_, operationId, station.bD)))))
																				]),
																			_List_Nil),
																			function () {
																			var _v1 = article.gO;
																			if (!_v1.$) {
																				var template = _v1.a;
																				if (template.gQ) {
																					return A2(
																						$rtfeldman$elm_css$Html$Styled$div,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$css(
																								_List_fromArray(
																									[$author$project$TW$Utilities$text_center]))
																							]),
																						_List_fromArray(
																							[
																								A2(
																								$rtfeldman$elm_css$Html$Styled$ul,
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$Attributes$css(
																										_List_fromArray(
																											[$author$project$TW$Utilities$text_left, $author$project$TW$Utilities$p_0, $author$project$TW$Utilities$list_none]))
																									]),
																								A2(
																									$elm$core$List$map,
																									function (_v2) {
																										var i = _v2.a;
																										var sn = _v2.b;
																										var isAlreadyCaptured = A3(
																											$elm$core$Basics$composeR,
																											$elm$core$List$length,
																											$elm$core$Basics$lt(1),
																											A2(
																												$elm$core$List$filter,
																												$elm$core$Basics$eq(sn.ex),
																												A2(
																													$elm$core$List$filter,
																													$elm$core$Basics$neq(''),
																													A2(
																														$elm$core$Maybe$withDefault,
																														_List_Nil,
																														A2($elm$core$Dict$get, template.g1, capturedSnList)))));
																										var compare = function (rma) {
																											return _Utils_eq(rma.gU, station.bD) && (_Utils_eq(rma.fV, iteration) && (_Utils_eq(rma.gX, step.bD) && (_Utils_eq(rma.eu, sn) && _Utils_eq(rma.gS, i))));
																										};
																										var isDisabled = A3(
																											$elm$core$List$foldl,
																											F2(
																												function (r, comparison) {
																													switch (r.$) {
																														case 1:
																															var rma = r.a;
																															return comparison || compare(rma);
																														case 2:
																															var rma = r.a;
																															return comparison || compare(rma);
																														default:
																															return comparison;
																													}
																												}),
																											false,
																											usedArticles);
																										return sn.cm ? A2(
																											$rtfeldman$elm_css$Html$Styled$li,
																											_List_fromArray(
																												[
																													$rtfeldman$elm_css$Html$Styled$Attributes$css(
																													_List_fromArray(
																														[$author$project$TW$Utilities$flex, $author$project$TW$Utilities$items_center, $author$project$TW$Utilities$mb_2]))
																												]),
																											_List_fromArray(
																												[
																													A3(
																													$author$project$Ui$UiComponents$Form$btnClear,
																													false,
																													_List_fromArray(
																														[
																															$rtfeldman$elm_css$Html$Styled$Events$onClick(
																															A3(
																																$author$project$Msg$StationMsg_,
																																operationId,
																																station.bD,
																																A3(
																																	$author$project$Msg$StationUpdateStepState,
																																	step.bD,
																																	iteration,
																																	A2(
																																		$author$project$Msg$StepArticleInputMsg,
																																		handler,
																																		A3($author$project$Msg$ArticleInputToggleDeleteSn, idx, i, false))))),
																															$rtfeldman$elm_css$Html$Styled$Attributes$css(
																															_List_fromArray(
																																[$author$project$TW$Utilities$px_4, $author$project$TW$Utilities$ml_2]))
																														]),
																													_List_fromArray(
																														[
																															$rtfeldman$elm_css$Html$Styled$text(
																															$author$project$Translations$uiPagesStepsArticle_inputAbort(language))
																														])),
																													A3(
																													$author$project$Ui$UiComponents$Form$btnRed,
																													false,
																													_List_fromArray(
																														[
																															$rtfeldman$elm_css$Html$Styled$Events$onClick(
																															A3(
																																$author$project$Msg$StationMsg_,
																																operationId,
																																station.bD,
																																A3(
																																	$author$project$Msg$StationUpdateStepState,
																																	step.bD,
																																	iteration,
																																	A2(
																																		$author$project$Msg$StepArticleInputMsg,
																																		handler,
																																		A2($author$project$Msg$ArticleInputDeleteSn, idx, i))))),
																															$rtfeldman$elm_css$Html$Styled$Attributes$css(
																															_List_fromArray(
																																[$author$project$TW$Utilities$px_4, $author$project$TW$Utilities$ml_2]))
																														]),
																													_List_fromArray(
																														[
																															$rtfeldman$elm_css$Html$Styled$text(
																															$author$project$Translations$uiPagesStepsArticle_inputReally_delete_sn(language))
																														]))
																												])) : A2(
																											$rtfeldman$elm_css$Html$Styled$li,
																											_List_fromArray(
																												[
																													$rtfeldman$elm_css$Html$Styled$Attributes$css(
																													_List_fromArray(
																														[$author$project$TW$Utilities$flex, $author$project$TW$Utilities$items_center, $author$project$TW$Utilities$mb_2]))
																												]),
																											_List_fromArray(
																												[
																													A2(
																													$rtfeldman$elm_css$Html$Styled$p,
																													_List_fromArray(
																														[
																															$rtfeldman$elm_css$Html$Styled$Attributes$css(
																															_List_fromArray(
																																[$author$project$TW$Utilities$my_0, $author$project$TW$Utilities$mr_2, $author$project$TW$Utilities$opacity_50]))
																														]),
																													_List_fromArray(
																														[
																															$rtfeldman$elm_css$Html$Styled$text('SN: ')
																														])),
																													A2(
																													$rtfeldman$elm_css$Html$Styled$div,
																													_List_fromArray(
																														[
																															$rtfeldman$elm_css$Html$Styled$Attributes$css(
																															_List_fromArray(
																																[$author$project$TW$Utilities$w_full]))
																														]),
																													_List_fromArray(
																														[
																															isAlreadyCaptured ? A2(
																															$rtfeldman$elm_css$Html$Styled$p,
																															_List_fromArray(
																																[
																																	$rtfeldman$elm_css$Html$Styled$Attributes$css(
																																	_List_fromArray(
																																		[$author$project$TW$Utilities$text_red_500, $author$project$TW$Utilities$font_bold, $author$project$TW$Utilities$text_center, $author$project$TW$Utilities$mb_1]))
																																]),
																															_List_fromArray(
																																[
																																	$rtfeldman$elm_css$Html$Styled$text(
																																	$author$project$Translations$uiPagesStepsArticle_inputAttention_sn_duplicate(language))
																																])) : $rtfeldman$elm_css$Html$Styled$text(''),
																															A2(
																															$author$project$Ui$UiComponents$Form$input,
																															_List_fromArray(
																																[
																																	$rtfeldman$elm_css$Html$Styled$Attributes$value(sn.ex),
																																	$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(
																																	$author$project$Translations$uiPagesStepsArticle_inputSerial_number(language)),
																																	$rtfeldman$elm_css$Html$Styled$Events$onInput(
																																	A2(
																																		$elm$core$Basics$composeR,
																																		A2($author$project$Msg$ArticleInputSerialNum, idx, i),
																																		A2(
																																			$elm$core$Basics$composeR,
																																			$author$project$Msg$StepArticleInputMsg(handler),
																																			A2(
																																				$elm$core$Basics$composeR,
																																				A2($author$project$Msg$StationUpdateStepState, step.bD, iteration),
																																				A2($author$project$Msg$StationMsg_, operationId, station.bD))))),
																																	$rtfeldman$elm_css$Html$Styled$Attributes$disabled(isDisabled),
																																	$rtfeldman$elm_css$Html$Styled$Attributes$css(
																																	isDisabled ? _List_fromArray(
																																		[$author$project$TW$Utilities$opacity_75, $author$project$TW$Utilities$bg_gray_500]) : (isAlreadyCaptured ? _List_fromArray(
																																		[$author$project$TW$Utilities$opacity_75, $author$project$TW$Utilities$bg_red_500, $author$project$TW$Utilities$text_white]) : _List_Nil)),
																																	$rtfeldman$elm_css$Html$Styled$Attributes$css(
																																	_List_fromArray(
																																		[$author$project$TW$Utilities$my_0]))
																																]),
																															_List_Nil),
																															config.cT ? A2(
																															$author$project$Ui$UiComponents$Form$input,
																															_List_fromArray(
																																[
																																	$rtfeldman$elm_css$Html$Styled$Attributes$value(
																																	A2($elm$core$Maybe$withDefault, '', sn.c1)),
																																	$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(
																																	$author$project$Translations$uiPagesStepsArticle_inputManufacturer_name(language))
																																]),
																															_List_Nil) : $rtfeldman$elm_css$Html$Styled$text('')
																														])),
																													(!isDisabled) ? A3(
																													$author$project$Ui$UiComponents$Form$btnClear,
																													false,
																													_List_fromArray(
																														[
																															$rtfeldman$elm_css$Html$Styled$Events$onClick(
																															A3(
																																$author$project$Msg$StationMsg_,
																																operationId,
																																station.bD,
																																A3(
																																	$author$project$Msg$StationUpdateStepState,
																																	step.bD,
																																	iteration,
																																	A2(
																																		$author$project$Msg$StepArticleInputMsg,
																																		handler,
																																		A3($author$project$Msg$ArticleInputToggleDeleteSn, idx, i, true))))),
																															$rtfeldman$elm_css$Html$Styled$Attributes$css(
																															_List_fromArray(
																																[$author$project$TW$Utilities$px_4, $author$project$TW$Utilities$ml_2]))
																														]),
																													_List_fromArray(
																														[
																															$rtfeldman$elm_css$Html$Styled$text('x')
																														])) : $rtfeldman$elm_css$Html$Styled$text('')
																												]));
																									},
																									$elm$core$Dict$toList(article.ao))),
																								isMoreSnDisabled ? $rtfeldman$elm_css$Html$Styled$text('') : A3(
																								$author$project$Ui$UiComponents$Form$btn,
																								false,
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$Events$onClick(
																										A3(
																											$author$project$Msg$StationMsg_,
																											operationId,
																											station.bD,
																											A3(
																												$author$project$Msg$StationUpdateStepState,
																												step.bD,
																												iteration,
																												A2(
																													$author$project$Msg$StepArticleInputMsg,
																													handler,
																													$author$project$Msg$ArticleInputAddSn(idx))))),
																										$rtfeldman$elm_css$Html$Styled$Attributes$css(
																										_List_fromArray(
																											[$author$project$TW$Utilities$mb_3]))
																									]),
																								_List_fromArray(
																									[
																										$rtfeldman$elm_css$Html$Styled$text(
																										$author$project$Translations$uiPagesStepsArticle_inputAdd_sn(language))
																									]))
																							]));
																				} else {
																					var usedArticleCount = function (a) {
																						if (!a.$) {
																							var a_ = a.a;
																							return a_.Q;
																						} else {
																							return 0;
																						}
																					}(
																						$elm$core$List$head(
																							A2(
																								$elm$core$List$filter,
																								A2(
																									$elm$core$Basics$composeR,
																									function ($) {
																										return $.bq;
																									},
																									$elm$core$Basics$eq(template.g1)),
																								A2(
																									$elm$core$List$filterMap,
																									function (articleId) {
																										switch (articleId.$) {
																											case 0:
																												var a = articleId.a;
																												return $elm$core$Maybe$Just(a);
																											case 3:
																												var a = articleId.a;
																												return $elm$core$Maybe$Just(a);
																											default:
																												return $elm$core$Maybe$Nothing;
																										}
																									},
																									$author$project$TemporaryWarehouse$findUsedTempArticles(stations)))));
																					var storedArticleCount = function (a) {
																						if (!a.$) {
																							var a_ = a.a;
																							return a_.Q;
																						} else {
																							return 0;
																						}
																					}(
																						$elm$core$List$head(
																							A2(
																								$elm$core$List$filter,
																								A2(
																									$elm$core$Basics$composeR,
																									function ($) {
																										return $.bq;
																									},
																									$elm$core$Basics$eq(template.g1)),
																								A2(
																									$elm$core$List$map,
																									$elm$core$Tuple$second,
																									$elm$core$Dict$toList(
																										$author$project$TemporaryWarehouse$clusterArticlesByType(stations).b)))));
																					return (_Utils_cmp(usedArticleCount, storedArticleCount) > 0) ? A2(
																						$rtfeldman$elm_css$Html$Styled$p,
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$Attributes$css(
																								_List_fromArray(
																									[$author$project$TW$Utilities$text_red_500, $author$project$TW$Utilities$font_bold, $author$project$TW$Utilities$text_center, $author$project$TW$Utilities$mb_3]))
																							]),
																						_List_fromArray(
																							[
																								$rtfeldman$elm_css$Html$Styled$text(
																								$author$project$Translations$uiPagesStepsArticle_inputYou_used_more_articles_than_you_have_in_stock(language)),
																								A2($rtfeldman$elm_css$Html$Styled$br, _List_Nil, _List_Nil),
																								$rtfeldman$elm_css$Html$Styled$text(
																								_Utils_ap(
																									$author$project$Translations$uiPagesStepsArticle_inputMissing(language),
																									$elm$core$String$fromInt(usedArticleCount - storedArticleCount)))
																							])) : $rtfeldman$elm_css$Html$Styled$text('');
																				}
																			} else {
																				return $rtfeldman$elm_css$Html$Styled$text('');
																			}
																		}()
																		]))
																]));
													};
												};
											};
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$TemporaryWarehouse$findUsedSerialNumbers = function (stations) {
	var getTemplateIdAndSerialNumbers = function (article) {
		var _v2 = article.gO;
		if (!_v2.$) {
			var template = _v2.a;
			return $elm$core$Maybe$Just(
				_Utils_Tuple2(
					template.g1,
					A2(
						$elm$core$List$map,
						function ($) {
							return $.ex;
						},
						A2(
							$elm$core$List$map,
							$elm$core$Tuple$second,
							$elm$core$Dict$toList(article.ao)))));
		} else {
			return $elm$core$Maybe$Nothing;
		}
	};
	var getTemplateIdAndSerialNumbersForAllArticles = function (model) {
		return A2($elm$core$List$filterMap, getTemplateIdAndSerialNumbers, model);
	};
	var addToDict = F2(
		function (_v1, acc) {
			var templateId = _v1.a;
			var snList = _v1.b;
			return A3(
				$elm$core$Dict$update,
				templateId,
				function (maybeSnListPresent) {
					if (!maybeSnListPresent.$) {
						var snListPresent = maybeSnListPresent.a;
						return $elm$core$Maybe$Just(
							$elm$core$List$concat(
								_List_fromArray(
									[snListPresent, snList])));
					} else {
						return $elm$core$Maybe$Just(snList);
					}
				},
				acc);
		});
	var transformToDict = F2(
		function (station, acc) {
			return A3(
				$elm$core$List$foldl,
				addToDict,
				acc,
				$elm$core$List$concat(
					A2(
						$elm$core$List$map,
						getTemplateIdAndSerialNumbersForAllArticles,
						A2(
							$elm$core$List$map,
							$elm$core$Tuple$second,
							$elm$core$Dict$toList(station.A.R)))));
		});
	return A3($elm$core$List$foldl, transformToDict, $elm$core$Dict$empty, stations);
};
var $author$project$TW$Utilities$mb_6 = $rtfeldman$elm_css$Css$marginBottom(
	$rtfeldman$elm_css$Css$rem(1.5));
var $author$project$Translations$uiPagesStepsArticle_inputAdd_additional_item = function (lang) {
	if (!lang) {
		return 'Weiteren Artikel hinzufügen';
	} else {
		return 'Add additional item';
	}
};
var $author$project$Ui$Pages$Steps$ArticleInput$inline = F9(
	function (language, handler, stations, operationId, station, step, iteration, config, maybeModel) {
		var usedArticles = $author$project$TemporaryWarehouse$findUsedTempArticles(stations);
		var maybeStepFromDb = (handler === 1) ? A2(
			$elm$core$Dict$get,
			_Utils_ap(
				step.bD,
				$elm$core$String$fromInt(iteration)),
			station.A.ar) : A2(
			$elm$core$Dict$get,
			_Utils_ap(
				step.bD,
				$elm$core$String$fromInt(iteration)),
			station.A.R);
		var listOfUsedTemplateIds = function () {
			if (maybeStepFromDb.$ === 1) {
				return _List_Nil;
			} else {
				var listOfArticleInput = maybeStepFromDb.a;
				return A2(
					$elm$core$List$map,
					function ($) {
						return $.g1;
					},
					A2(
						$elm$core$List$filterMap,
						$elm$core$Basics$identity,
						A2(
							$elm$core$List$map,
							function ($) {
								return $.gO;
							},
							listOfArticleInput)));
			}
		}();
		var notSelectedOptions = A2(
			$elm$core$List$filter,
			function (option) {
				return !A2($elm$core$List$member, option.g1, listOfUsedTemplateIds);
			},
			config.dV);
		var capturedSnList = $author$project$TemporaryWarehouse$findUsedSerialNumbers(stations);
		var articles = A2($elm$core$Maybe$withDefault, _List_Nil, maybeModel);
		var moreOptionsThanArticles = _Utils_cmp(
			$elm$core$List$length(articles),
			$elm$core$List$length(config.dV)) < 0;
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[$author$project$TW$Utilities$mb_6]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$UiComponents$Form$step_headline,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(step.dP)
						])),
					$author$project$Ui$UiComponents$StepHelper$renderDescription(step),
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$author$project$TW$Utilities$list_none, $author$project$TW$Utilities$p_0, $author$project$TW$Utilities$m_0]))
						]),
					A2(
						$elm$core$List$indexedMap,
						$author$project$Ui$Pages$Steps$ArticleInput$articleInput(language)(handler)(stations)(capturedSnList)(listOfUsedTemplateIds)(notSelectedOptions)(usedArticles)(operationId)(station)(step)(iteration)(config),
						articles)),
					moreOptionsThanArticles ? A3(
					$author$project$Ui$UiComponents$Form$btn,
					false,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$author$project$TW$Utilities$w_full])),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							A3(
								$author$project$Msg$StationMsg_,
								operationId,
								station.bD,
								A3(
									$author$project$Msg$StationUpdateStepState,
									step.bD,
									iteration,
									A2($author$project$Msg$StepArticleInputMsg, handler, $author$project$Msg$ArticleInputNewArticleType))))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Translations$uiPagesStepsArticle_inputAdd_additional_item(language))
						])) : $rtfeldman$elm_css$Html$Styled$text('')
				]));
	});
var $author$project$Msg$ArticleInputAttemptDelete = {$: 2};
var $author$project$Msg$ArticleInputDelete = {$: 4};
var $author$project$Msg$ArticleInputResetDelete = {$: 3};
var $author$project$Ui$UiComponents$Form$btnLink = F4(
	function (path, disabled, attributes, children) {
		return A3(
			$author$project$Ui$UiComponents$Form$btn,
			disabled,
			_Utils_ap(
				attributes,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$Events$custom,
						'click',
						$elm$json$Json$Decode$succeed(
							{
								dM: $author$project$Msg$PortMsg_(
									$author$project$Msg$JsMsg_(
										$author$project$Msg$JsInternalNav(path))),
								dZ: true,
								eG: true
							}))
					])),
			children);
	});
var $author$project$Msg$StationPutBackAllMaterials = F6(
	function (a, b, c, d, e, f) {
		return {$: 9, a: a, b: b, c: c, d: d, e: e, f: f};
	});
var $author$project$Msg$WarehouseOpenNotUsedOverlay = function (a) {
	return {$: 2, a: a};
};
var $author$project$Msg$StationPutBackMaterial = F6(
	function (a, b, c, d, e, f) {
		return {$: 8, a: a, b: b, c: c, d: d, e: e, f: f};
	});
var $author$project$TW$Utilities$px_1 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$rem(0.25)),
			$rtfeldman$elm_css$Css$paddingRight(
			$rtfeldman$elm_css$Css$rem(0.25))
		]));
var $author$project$TW$Utilities$py_0 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$px(0)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$px(0))
		]));
var $author$project$Ui$UiComponents$Form$btnClearSmall = F3(
	function (disabled, attributes, children) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							_List_fromArray(
								[$author$project$TW$Utilities$py_0, $author$project$TW$Utilities$px_1, $author$project$TW$Utilities$rounded, $author$project$TW$Utilities$border, $author$project$TW$Utilities$border_solid]),
							disabled ? _List_fromArray(
								[$author$project$TW$Utilities$opacity_50, $author$project$TW$Utilities$bg_gray_200, $author$project$TW$Utilities$text_gray_800, $author$project$TW$Utilities$border_gray_300]) : _List_fromArray(
								[$author$project$TW$Utilities$bg_white, $author$project$TW$Utilities$text_gray_800, $author$project$TW$Utilities$border_gray_600]))),
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(disabled)
					]),
				attributes),
			children);
	});
var $author$project$Ui$UiComponents$Form$btnRedSmall = F3(
	function (disabled, attributes, children) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							_List_fromArray(
								[$author$project$TW$Utilities$py_0, $author$project$TW$Utilities$px_1, $author$project$TW$Utilities$rounded, $author$project$TW$Utilities$border, $author$project$TW$Utilities$border_solid]),
							disabled ? _List_fromArray(
								[$author$project$TW$Utilities$opacity_50, $author$project$TW$Utilities$bg_gray_200, $author$project$TW$Utilities$text_gray_800, $author$project$TW$Utilities$border_gray_300]) : _List_fromArray(
								[$author$project$TW$Utilities$bg_red_200, $author$project$TW$Utilities$text_red_800, $author$project$TW$Utilities$border_red_500]))),
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(disabled)
					]),
				attributes),
			children);
	});
var $author$project$TW$Utilities$pr_2 = $rtfeldman$elm_css$Css$paddingRight(
	$rtfeldman$elm_css$Css$rem(0.5));
var $author$project$TW$Utilities$pr_4 = $rtfeldman$elm_css$Css$paddingRight(
	$rtfeldman$elm_css$Css$rem(1));
var $rtfeldman$elm_css$Html$Styled$td = $rtfeldman$elm_css$Html$Styled$node('td');
var $rtfeldman$elm_css$Html$Styled$tr = $rtfeldman$elm_css$Html$Styled$node('tr');
var $author$project$Translations$uiPagesStepsArticle_installationAbort = function (lang) {
	if (!lang) {
		return 'Abbruch';
	} else {
		return 'Abort';
	}
};
var $author$project$Translations$uiPagesStepsArticle_installationDelete = function (lang) {
	if (!lang) {
		return 'Löschen';
	} else {
		return 'Delete';
	}
};
var $author$project$Translations$uiPagesStepsArticle_installationRemove = function (lang) {
	if (!lang) {
		return 'Entfernen';
	} else {
		return 'Remove';
	}
};
var $author$project$Ui$Pages$Steps$ArticleInstallation$articleRenderer = F8(
	function (language, deleteIndicator, operation, stationId, iteration, stepId, installationType, article) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$author$project$TW$Utilities$pr_2]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(article.ex)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$author$project$TW$Utilities$pr_4]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(article.bD))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_Nil,
					_Utils_eq(
						deleteIndicator,
						$elm$core$Maybe$Just(article.bD)) ? _List_fromArray(
						[
							A3(
							$author$project$Ui$UiComponents$Form$btnClearSmall,
							false,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Msg$WarehouseMsg_($author$project$Msg$WarehouseCloseNotUsedOverlay))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Translations$uiPagesStepsArticle_installationAbort(language))
								])),
							A3(
							$author$project$Ui$UiComponents$Form$btnRedSmall,
							false,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Msg$WarehouseMsg_(
										A6(
											$author$project$Msg$StationPutBackMaterial,
											$elm$core$String$fromInt(operation.bD),
											article.bD,
											stationId,
											iteration,
											stepId,
											installationType)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Translations$uiPagesStepsArticle_installationDelete(language))
								]))
						]) : _List_fromArray(
						[
							A3(
							$author$project$Ui$UiComponents$Form$btnClearSmall,
							false,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Msg$WarehouseMsg_(
										$author$project$Msg$WarehouseOpenNotUsedOverlay(
											$toastal$either$Either$Right(article.bD))))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Translations$uiPagesStepsArticle_installationRemove(language))
								]))
						]))
				]));
	});
var $author$project$TW$Utilities$bg_red_100 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--bg-opacity', '1'),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('#fff5f5')),
			A2($rtfeldman$elm_css$Css$property, 'background-color', 'rgba(255, 245, 245, var(--bg-opacity))')
		]));
var $author$project$Ui$UiComponents$Form$btnLinkClear = F4(
	function (path, disabled, attributes, children) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_Utils_ap(
				attributes,
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$Events$custom,
						'click',
						$elm$json$Json$Decode$succeed(
							{
								dM: $author$project$Msg$PortMsg_(
									$author$project$Msg$JsMsg_(
										$author$project$Msg$JsInternalNav(path))),
								dZ: true,
								eG: true
							})),
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							_List_fromArray(
								[$author$project$TW$Utilities$p_2, $author$project$TW$Utilities$rounded, $author$project$TW$Utilities$border, $author$project$TW$Utilities$border_gray_300, $author$project$TW$Utilities$border_solid, $author$project$TW$Utilities$block, $author$project$TW$Utilities$mt_1, $author$project$TW$Utilities$mb_3, $author$project$TW$Utilities$bg_white]),
							disabled ? _List_fromArray(
								[$author$project$TW$Utilities$opacity_50, $author$project$TW$Utilities$bg_gray_200, $author$project$TW$Utilities$text_gray_800, $author$project$TW$Utilities$border_gray_300]) : _List_fromArray(
								[$author$project$TW$Utilities$bg_white, $author$project$TW$Utilities$text_gray_800, $author$project$TW$Utilities$border_gray_600])))
					])),
			children);
	});
var $rtfeldman$elm_css$Css$row = {ce: 0, a5: 0, cO: 'row'};
var $rtfeldman$elm_css$Css$column = _Utils_update(
	$rtfeldman$elm_css$Css$row,
	{cO: 'column'});
var $rtfeldman$elm_css$Css$flexDirection = $rtfeldman$elm_css$Css$prop1('flex-direction');
var $author$project$TW$Utilities$flex_col = $rtfeldman$elm_css$Css$flexDirection($rtfeldman$elm_css$Css$column);
var $rtfeldman$elm_css$Css$spaceBetween = $rtfeldman$elm_css$Css$prop1('space-between');
var $author$project$TW$Utilities$justify_between = $rtfeldman$elm_css$Css$justifyContent($rtfeldman$elm_css$Css$spaceBetween);
var $author$project$TW$Utilities$m_4 = $rtfeldman$elm_css$Css$margin(
	$rtfeldman$elm_css$Css$rem(1));
var $author$project$TW$Utilities$pb_4 = $rtfeldman$elm_css$Css$paddingBottom(
	$rtfeldman$elm_css$Css$rem(1));
var $elm$virtual_dom$VirtualDom$style = _VirtualDom_style;
var $rtfeldman$elm_css$VirtualDom$Styled$style = F2(
	function (key, val) {
		return A3(
			$rtfeldman$elm_css$VirtualDom$Styled$Attribute,
			A2($elm$virtual_dom$VirtualDom$style, key, val),
			_List_Nil,
			'');
	});
var $rtfeldman$elm_css$Html$Styled$Attributes$style = $rtfeldman$elm_css$VirtualDom$Styled$style;
var $rtfeldman$elm_css$Html$Styled$table = $rtfeldman$elm_css$Html$Styled$node('table');
var $rtfeldman$elm_css$Css$tableLayout = $rtfeldman$elm_css$Css$prop1('table-layout');
var $author$project$TW$Utilities$table_fixed = $rtfeldman$elm_css$Css$tableLayout($rtfeldman$elm_css$Css$fixed);
var $rtfeldman$elm_css$Html$Styled$tbody = $rtfeldman$elm_css$Html$Styled$node('tbody');
var $author$project$TW$Utilities$text_sm = $rtfeldman$elm_css$Css$fontSize(
	$rtfeldman$elm_css$Css$rem(0.875));
var $rtfeldman$elm_css$Html$Styled$th = $rtfeldman$elm_css$Html$Styled$node('th');
var $rtfeldman$elm_css$Html$Styled$thead = $rtfeldman$elm_css$Html$Styled$node('thead');
var $author$project$Translations$uiPagesStepsArticle_installationAdd_more = function (lang) {
	if (!lang) {
		return 'Mehr hinzufügen';
	} else {
		return 'Add more';
	}
};
var $author$project$Translations$uiPagesStepsArticle_installationClear = function (lang) {
	if (!lang) {
		return 'Alles zurücklegen';
	} else {
		return 'Clear everything';
	}
};
var $author$project$Translations$uiPagesStepsArticle_installationConfirmation = function (lang) {
	if (!lang) {
		return 'Bestätigung';
	} else {
		return 'Corfirmation';
	}
};
var $author$project$Translations$uiPagesStepsArticle_installationReally_clear_all_items = function (lang) {
	if (!lang) {
		return 'Wirklich alle Artikel zurücklegen?';
	} else {
		return 'Really clear all items?';
	}
};
var $author$project$Translations$uiPagesStepsArticle_installationThere_is_no_item_with_description = F2(
	function (lang, str0) {
		if (!lang) {
			return 'Es gibt keinen Artikel mit der Beschreibung \' ' + (str0 + ' \' mehr');
		} else {
			return 'There is no item with description \' ' + (str0 + ' \' anymore');
		}
	});
var $author$project$TW$Utilities$w_1over3 = $rtfeldman$elm_css$Css$width(
	$rtfeldman$elm_css$Css$pct(33.333333));
var $author$project$Ui$Pages$Steps$ArticleInstallation$clusterRenderer = F8(
	function (language, operation, uiState, stationId, iteration, stepId, installationType, _v0) {
		var description = _v0.a;
		var warehouse = _v0.b;
		var _v1 = $elm$core$List$head(warehouse);
		if (!_v1.$) {
			var renderSubArticles = function (deleteArticle) {
				return _List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$table,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[$author$project$TW$Utilities$w_full, $author$project$TW$Utilities$table_fixed]))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$thead,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$tr,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css(
												_List_fromArray(
													[$author$project$TW$Utilities$text_sm, $author$project$TW$Utilities$opacity_50]))
											]),
										_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css(
														_List_fromArray(
															[$author$project$TW$Utilities$w_1over3]))
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('SN')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css(
														_List_fromArray(
															[$author$project$TW$Utilities$w_1over3]))
													]),
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$text('RMA')
													])),
												A2(
												$rtfeldman$elm_css$Html$Styled$th,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css(
														_List_fromArray(
															[$author$project$TW$Utilities$w_1over3]))
													]),
												_List_Nil)
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$tbody,
								_List_Nil,
								A2(
									$elm$core$List$map,
									A7($author$project$Ui$Pages$Steps$ArticleInstallation$articleRenderer, language, deleteArticle, operation, stationId, iteration, stepId, installationType),
									warehouse))
							])),
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[$author$project$TW$Utilities$flex]))
							]),
						_List_fromArray(
							[
								A3(
								$author$project$Ui$UiComponents$Form$btnClear,
								false,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Events$onClick(
										$author$project$Msg$WarehouseMsg_(
											$author$project$Msg$WarehouseOpenNotUsedOverlay(
												$toastal$either$Either$Left(description)))),
										A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '50%')
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$Translations$uiPagesStepsArticle_installationClear(language))
									])),
								function () {
								if (installationType === 1) {
									return A4(
										$author$project$Ui$UiComponents$Form$btnLinkClear,
										$author$project$Ui$Router$routeToPath(
											A4(
												$author$project$Ui$Router$StationSelectArticle,
												$elm$core$String$fromInt(operation.bD),
												stationId,
												iteration,
												stepId)),
										false,
										_List_fromArray(
											[
												A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '50%'),
												A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin', '0 0 0 0.5rem')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$Translations$uiPagesStepsArticle_installationAdd_more(language))
											]));
								} else {
									return A4(
										$author$project$Ui$UiComponents$Form$btnLinkClear,
										$author$project$Ui$Router$routeToPath(
											A4(
												$author$project$Ui$Router$StationSelectBadPart,
												$elm$core$String$fromInt(operation.bD),
												stationId,
												iteration,
												stepId)),
										false,
										_List_fromArray(
											[
												A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '50%'),
												A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'margin', '0 0 0 0.5rem')
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$Translations$uiPagesStepsArticle_installationAdd_more(language))
											]));
								}
							}()
							]))
					]);
			};
			var renderDeleteAll = _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil)
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Translations$uiPagesStepsArticle_installationReally_clear_all_items(language))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[$author$project$TW$Utilities$justify_between, $author$project$TW$Utilities$flex]))
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$UiComponents$Form$btnClear,
									false,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Msg$WarehouseMsg_($author$project$Msg$WarehouseCloseNotUsedOverlay))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Translations$uiPagesStepsArticle_installationAbort(language))
										])),
									A3(
									$author$project$Ui$UiComponents$Form$btnRed,
									false,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Msg$WarehouseMsg_(
												A6(
													$author$project$Msg$StationPutBackAllMaterials,
													$elm$core$String$fromInt(operation.bD),
													description,
													stationId,
													iteration,
													stepId,
													installationType)))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Translations$uiPagesStepsArticle_installationConfirmation(language))
										]))
								]))
						]))
				]);
			var infos = function () {
				var _v2 = uiState.gR;
				if (!_v2.$) {
					if (!_v2.a.$) {
						return renderDeleteAll;
					} else {
						var deleteArticle = _v2.a.a;
						return renderSubArticles(
							$elm$core$Maybe$Just(deleteArticle));
					}
				} else {
					return renderSubArticles($elm$core$Maybe$Nothing);
				}
			}();
			return A2(
				$rtfeldman$elm_css$Html$Styled$li,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[$author$project$TW$Utilities$flex, $author$project$TW$Utilities$flex_col, $author$project$TW$Utilities$mb_4, $author$project$TW$Utilities$pb_4]))
					]),
				$elm$core$List$concat(
					_List_fromArray(
						[
							_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$h4,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(description)
									]))
							]),
							infos
						])));
		} else {
			return A2(
				$rtfeldman$elm_css$Html$Styled$li,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[$author$project$TW$Utilities$m_4, $author$project$TW$Utilities$bg_red_100]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($author$project$Translations$uiPagesStepsArticle_installationThere_is_no_item_with_description, language, description))
					]));
		}
	});
var $rtfeldman$elm_css$Html$Styled$em = $rtfeldman$elm_css$Html$Styled$node('em');
var $author$project$Translations$uiPagesStepsArticle_installationCant_load_warehouse = function (lang) {
	if (!lang) {
		return 'Konnte das Warenlager nicht laden...';
	} else {
		return 'Can\'t load warehouse...';
	}
};
var $author$project$Translations$uiPagesStepsArticle_installationCount = function (lang) {
	if (!lang) {
		return 'Anzahl: ';
	} else {
		return 'Amount: ';
	}
};
var $author$project$Translations$uiPagesStepsArticle_installationItem = function (lang) {
	if (!lang) {
		return 'Artikel: ';
	} else {
		return 'Item: ';
	}
};
var $author$project$Translations$uiPagesStepsArticle_installationLoading = function (lang) {
	if (!lang) {
		return '... laden ...';
	} else {
		return '... loading ...';
	}
};
var $author$project$Translations$uiPagesStepsArticle_installationReally_delete = function (lang) {
	if (!lang) {
		return 'Wirklich löschen?';
	} else {
		return 'Really delete?';
	}
};
var $author$project$Translations$uiPagesStepsArticle_installationReturn_material = function (lang) {
	if (!lang) {
		return 'Material zurücksenden';
	} else {
		return 'Return material';
	}
};
var $author$project$Translations$uiPagesStepsArticle_installationUse_material = function (lang) {
	if (!lang) {
		return 'Material verwenden';
	} else {
		return 'Use material';
	}
};
var $author$project$Ui$Pages$Steps$ArticleInstallation$inline = F8(
	function (model, operation, operationId, station, step, iteration, maybeInstallationModel, installationType) {
		var _v0 = model.eV;
		switch (_v0.$) {
			case 3:
				var warehouse = _v0.a;
				var renderer = function () {
					if (!maybeInstallationModel.$) {
						var installationModel = maybeInstallationModel.a;
						if (!installationModel.$) {
							if (!installationModel.a.$) {
								var snList = installationModel.a.a;
								var selectedArticles = $elm$core$Dict$toList(
									A3(
										$elm$core$List$foldl,
										F2(
											function (article, newArticles) {
												return A3(
													$elm$core$Dict$update,
													article.fl,
													function (articles) {
														if (!articles.$) {
															var articles_ = articles.a;
															return $elm$core$Maybe$Just(
																A2($elm$core$List$cons, article, articles_));
														} else {
															return $elm$core$Maybe$Just(
																_List_fromArray(
																	[article]));
														}
													},
													newArticles);
											}),
										$elm$core$Dict$empty,
										A2(
											$elm$core$List$filter,
											function (article) {
												return A2(
													$elm$core$List$member,
													$elm$core$String$fromInt(article.bD),
													snList);
											},
											warehouse)));
								return A2(
									$rtfeldman$elm_css$Html$Styled$ul,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[$author$project$TW$Utilities$p_0, $author$project$TW$Utilities$m_0]))
										]),
									A2(
										$elm$core$List$map,
										A7($author$project$Ui$Pages$Steps$ArticleInstallation$clusterRenderer, model.ck, operation, model.bj, station.bD, iteration, step.bD, installationType),
										selectedArticles));
							} else {
								var article = installationModel.a.a;
								switch (article.$) {
									case 1:
										var rma = article.a;
										return A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$p,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$css(
															_List_fromArray(
																[$author$project$TW$Utilities$mb_1]))
														]),
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$em,
															_List_Nil,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	$author$project$Translations$uiPagesStepsArticle_installationItem(model.ck))
																])),
															$rtfeldman$elm_css$Html$Styled$text(rma.fl)
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$p,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$em,
															_List_Nil,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('SN: ')
																])),
															$rtfeldman$elm_css$Html$Styled$text(rma.eu.ex)
														])),
													A3(
													$author$project$Ui$UiComponents$Form$btnClear,
													false,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Events$onClick(
															A3(
																$author$project$Msg$StationMsg_,
																operationId,
																station.bD,
																A3(
																	$author$project$Msg$StationUpdateStepState,
																	step.bD,
																	iteration,
																	A2($author$project$Msg$StepArticleInstallationMsg, installationType, $author$project$Msg$ArticleInputAttemptDelete))))
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$Translations$uiPagesStepsArticle_installationRemove(model.ck))
														]))
												]));
									case 0:
										var rma = article.a;
										return A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$p,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$css(
															_List_fromArray(
																[$author$project$TW$Utilities$mb_1]))
														]),
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$em,
															_List_Nil,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	$author$project$Translations$uiPagesStepsArticle_installationItem(model.ck))
																])),
															$rtfeldman$elm_css$Html$Styled$text(rma.fl)
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$p,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$em,
															_List_Nil,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	$author$project$Translations$uiPagesStepsArticle_installationCount(model.ck))
																])),
															$rtfeldman$elm_css$Html$Styled$text(
															$elm$core$String$fromInt(rma.Q))
														])),
													A3(
													$author$project$Ui$UiComponents$Form$btnClear,
													false,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Events$onClick(
															A3(
																$author$project$Msg$StationMsg_,
																operationId,
																station.bD,
																A3(
																	$author$project$Msg$StationUpdateStepState,
																	step.bD,
																	iteration,
																	A2($author$project$Msg$StepArticleInstallationMsg, installationType, $author$project$Msg$ArticleInputAttemptDelete))))
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$Translations$uiPagesStepsArticle_installationRemove(model.ck))
														]))
												]));
									default:
										return A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_Nil,
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$p,
													_List_Nil,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$Translations$uiPagesStepsArticle_installationReally_delete(model.ck))
														])),
													A3(
													$author$project$Ui$UiComponents$Form$btnClear,
													false,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Events$onClick(
															A3(
																$author$project$Msg$StationMsg_,
																operationId,
																station.bD,
																A3(
																	$author$project$Msg$StationUpdateStepState,
																	step.bD,
																	iteration,
																	A2($author$project$Msg$StepArticleInstallationMsg, installationType, $author$project$Msg$ArticleInputResetDelete))))
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$Translations$uiPagesStepsArticle_installationAbort(model.ck))
														])),
													A3(
													$author$project$Ui$UiComponents$Form$btnRed,
													false,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Events$onClick(
															A3(
																$author$project$Msg$StationMsg_,
																operationId,
																station.bD,
																A3(
																	$author$project$Msg$StationUpdateStepState,
																	step.bD,
																	iteration,
																	A2($author$project$Msg$StepArticleInstallationMsg, installationType, $author$project$Msg$ArticleInputDelete)))),
															$rtfeldman$elm_css$Html$Styled$Attributes$css(
															_List_fromArray(
																[$author$project$TW$Utilities$ml_2]))
														]),
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$text(
															$author$project$Translations$uiPagesStepsArticle_installationDelete(model.ck))
														]))
												]));
								}
							}
						} else {
							if (installationType === 1) {
								return A4(
									$author$project$Ui$UiComponents$Form$btnLink,
									$author$project$Ui$Router$routeToPath(
										A4($author$project$Ui$Router$StationSelectArticle, operationId, station.bD, iteration, step.bD)),
									false,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[$author$project$TW$Utilities$w_full]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Translations$uiPagesStepsArticle_installationUse_material(model.ck))
										]));
							} else {
								return A4(
									$author$project$Ui$UiComponents$Form$btnLink,
									$author$project$Ui$Router$routeToPath(
										A4($author$project$Ui$Router$StationSelectBadPart, operationId, station.bD, iteration, step.bD)),
									false,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[$author$project$TW$Utilities$w_full]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Translations$uiPagesStepsArticle_installationReturn_material(model.ck))
										]));
							}
						}
					} else {
						return $rtfeldman$elm_css$Html$Styled$text('');
					}
				}();
				return A2(
					$rtfeldman$elm_css$Html$Styled$section,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$UiComponents$Form$step_headline,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$for(
									A2(
										$elm$core$String$join,
										'_',
										_List_fromArray(
											[
												operationId,
												station.bD,
												_Utils_ap(
												step.bD,
												$elm$core$String$fromInt(iteration))
											])))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(step.dP)
								])),
							$author$project$Ui$UiComponents$StepHelper$renderDescription(step),
							renderer,
							function () {
							if (maybeInstallationModel.$ === 1) {
								if (installationType === 1) {
									return A4(
										$author$project$Ui$UiComponents$Form$btnLink,
										$author$project$Ui$Router$routeToPath(
											A4($author$project$Ui$Router$StationSelectArticle, operationId, station.bD, iteration, step.bD)),
										false,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css(
												_List_fromArray(
													[$author$project$TW$Utilities$w_full]))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$Translations$uiPagesStepsArticle_installationUse_material(model.ck))
											]));
								} else {
									return A4(
										$author$project$Ui$UiComponents$Form$btnLink,
										$author$project$Ui$Router$routeToPath(
											A4($author$project$Ui$Router$StationSelectBadPart, operationId, station.bD, iteration, step.bD)),
										false,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css(
												_List_fromArray(
													[$author$project$TW$Utilities$w_full]))
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$Translations$uiPagesStepsArticle_installationReturn_material(model.ck))
											]));
								}
							} else {
								return $rtfeldman$elm_css$Html$Styled$text('');
							}
						}()
						]));
			case 2:
				return $rtfeldman$elm_css$Html$Styled$text(
					$author$project$Translations$uiPagesStepsArticle_installationCant_load_warehouse(model.ck));
			default:
				return $rtfeldman$elm_css$Html$Styled$text(
					$author$project$Translations$uiPagesStepsArticle_installationLoading(model.ck));
		}
	});
var $author$project$Ui$Pages$Steps$DescriptionOnly$inline = F4(
	function (operationId, station, step, iteration) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$UiComponents$Form$step_headline,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$for(
							A2(
								$elm$core$String$join,
								'_',
								_List_fromArray(
									[
										operationId,
										station.bD,
										_Utils_ap(
										step.bD,
										$elm$core$String$fromInt(iteration))
									])))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(step.dP)
						])),
					$author$project$Ui$UiComponents$StepHelper$renderDescription(step)
				]));
	});
var $author$project$Msg$PhotoSelected = function (a) {
	return {$: 0, a: a};
};
var $rtfeldman$elm_css$Html$Styled$Attributes$accept = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('accept');
var $elm$file$File$decoder = _File_decoder;
var $author$project$Ui$Pages$Steps$Photo$filesDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['target', 'files']),
	A2($elm$json$Json$Decode$index, 0, $elm$file$File$decoder));
var $author$project$TW$Utilities$my_3 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$rem(0.75)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$rem(0.75))
		]));
var $author$project$TW$Utilities$text_green_700 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--text-opacity', '1'),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('#2f855a')),
			A2($rtfeldman$elm_css$Css$property, 'color', 'rgba(47, 133, 90, var(--text-opacity))')
		]));
var $author$project$Translations$uiPagesStepsPhotoPhoto_was_already_taken = function (lang) {
	if (!lang) {
		return 'Bild wurde bereits aufgenommen.';
	} else {
		return 'Photo was already taken.';
	}
};
var $author$project$Translations$uiPagesStepsPhotoPlease_take_a_photo = function (lang) {
	if (!lang) {
		return 'Bitte ein Bild machen. (Auf \'Datei auswählen\' tippen)';
	} else {
		return 'Please take a photo.';
	}
};
var $author$project$Ui$Pages$Steps$Photo$inline = F6(
	function (language, operationId, station, step, iteration, maybePhotoModel) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[$author$project$TW$Utilities$my_3]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$UiComponents$Form$step_headline,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$for(
							A2(
								$elm$core$String$join,
								'_',
								_List_fromArray(
									[
										operationId,
										station.bD,
										_Utils_ap(
										step.bD,
										$elm$core$String$fromInt(iteration))
									])))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(step.dP)
						])),
					$author$project$Ui$UiComponents$StepHelper$renderDescription(step),
					A2(
					$author$project$Ui$UiComponents$Form$input,
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$Events$on,
							'change',
							A2(
								$elm$json$Json$Decode$map,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Msg$PhotoSelected,
									A2(
										$elm$core$Basics$composeR,
										$author$project$Msg$StepPhotoMsg,
										A2(
											$elm$core$Basics$composeR,
											A2($author$project$Msg$StationUpdateStepState, step.bD, iteration),
											A2($author$project$Msg$StationMsg_, operationId, station.bD)))),
								$author$project$Ui$Pages$Steps$Photo$filesDecoder)),
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('file'),
							$rtfeldman$elm_css$Html$Styled$Attributes$accept('image/*'),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(
							A2(
								$elm$core$String$join,
								'_',
								_List_fromArray(
									[
										operationId,
										station.bD,
										_Utils_ap(
										step.bD,
										$elm$core$String$fromInt(iteration))
									])))
						]),
					_List_Nil),
					function () {
					if (!maybePhotoModel.$) {
						var photoModel = maybePhotoModel.a;
						return photoModel.fE ? A2(
							$rtfeldman$elm_css$Html$Styled$p,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[$author$project$TW$Utilities$w_full, $author$project$TW$Utilities$text_center, $author$project$TW$Utilities$text_green_700, $author$project$TW$Utilities$font_bold]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Translations$uiPagesStepsPhotoPhoto_was_already_taken(language))
								])) : $rtfeldman$elm_css$Html$Styled$text(
							$author$project$Translations$uiPagesStepsPhotoPlease_take_a_photo(language));
					} else {
						return $rtfeldman$elm_css$Html$Styled$text('');
					}
				}()
				]));
	});
var $rtfeldman$elm_css$Html$Styled$img = $rtfeldman$elm_css$Html$Styled$node('img');
var $author$project$TW$Utilities$m_auto = $rtfeldman$elm_css$Css$margin($rtfeldman$elm_css$Css$auto);
var $rtfeldman$elm_css$Css$maxWidth = $rtfeldman$elm_css$Css$prop1('max-width');
var $author$project$TW$Utilities$max_w_full = $rtfeldman$elm_css$Css$maxWidth(
	$rtfeldman$elm_css$Css$pct(100));
var $rtfeldman$elm_css$Html$Styled$Attributes$src = function (url) {
	return A2($rtfeldman$elm_css$Html$Styled$Attributes$stringProperty, 'src', url);
};
var $author$project$Translations$uiPagesStepsSignatureAgain = function (lang) {
	if (!lang) {
		return 'Noch einmal';
	} else {
		return 'Again';
	}
};
var $author$project$Translations$uiPagesStepsSignatureRecord_signature = function (lang) {
	if (!lang) {
		return 'Unterschrift erfassen';
	} else {
		return 'Record signature';
	}
};
var $author$project$TW$Utilities$w_24 = $rtfeldman$elm_css$Css$width(
	$rtfeldman$elm_css$Css$rem(6));
var $author$project$Ui$Pages$Steps$Signature$inline = F6(
	function (language, operationId, station, step, iteration, amountModel) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$UiComponents$Form$step_headline,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(step.dP)
						])),
					$author$project$Ui$UiComponents$StepHelper$renderDescription(step),
					function () {
					if ((!amountModel.$) && (!amountModel.a.$)) {
						var str = amountModel.a.a;
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$img,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$src(str),
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[$author$project$TW$Utilities$max_w_full]))
										]),
									_List_Nil),
									A4(
									$author$project$Ui$UiComponents$Form$btnLinkClear,
									$author$project$Ui$Router$routeToPath(
										A4($author$project$Ui$Router$StationGetSignature, operationId, station.bD, iteration, step.bD)),
									false,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[$author$project$TW$Utilities$w_24, $author$project$TW$Utilities$m_auto, $author$project$TW$Utilities$w_full]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Translations$uiPagesStepsSignatureAgain(language))
										]))
								]));
					} else {
						return A4(
							$author$project$Ui$UiComponents$Form$btnLink,
							$author$project$Ui$Router$routeToPath(
								A4($author$project$Ui$Router$StationGetSignature, operationId, station.bD, iteration, step.bD)),
							false,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[$author$project$TW$Utilities$w_24, $author$project$TW$Utilities$m_auto, $author$project$TW$Utilities$w_full]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Translations$uiPagesStepsSignatureRecord_signature(language))
								]));
					}
				}()
				]));
	});
var $author$project$Msg$StepTextMsg = function (a) {
	return {$: 3, a: a};
};
var $author$project$Msg$TextUpdate = $elm$core$Basics$identity;
var $author$project$Ui$Pages$Steps$Text$inline = F5(
	function (operationId, station, step, iteration, text) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			_List_fromArray(
				[
					A2(
					$author$project$Ui$UiComponents$Form$step_headline,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$for(
							A2(
								$elm$core$String$join,
								'_',
								_List_fromArray(
									[
										operationId,
										station.bD,
										_Utils_ap(
										step.bD,
										$elm$core$String$fromInt(iteration))
									])))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(step.dP)
						])),
					$author$project$Ui$UiComponents$StepHelper$renderDescription(step),
					A2(
					$author$project$Ui$UiComponents$Form$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onInput(
							A2(
								$elm$core$Basics$composeR,
								$elm$core$Basics$identity,
								A2(
									$elm$core$Basics$composeR,
									$author$project$Msg$StepTextMsg,
									A2(
										$elm$core$Basics$composeR,
										A2($author$project$Msg$StationUpdateStepState, step.bD, iteration),
										A2($author$project$Msg$StationMsg_, operationId, station.bD))))),
							$rtfeldman$elm_css$Html$Styled$Attributes$type_('string'),
							$rtfeldman$elm_css$Html$Styled$Attributes$value(
							A2($elm$core$Maybe$withDefault, '', text)),
							$rtfeldman$elm_css$Html$Styled$Attributes$id(
							A2(
								$elm$core$String$join,
								'_',
								_List_fromArray(
									[
										operationId,
										station.bD,
										_Utils_ap(
										step.bD,
										$elm$core$String$fromInt(iteration))
									])))
						]),
					_List_Nil)
				]));
	});
var $author$project$Msg$StepTimestampMsg = function (a) {
	return {$: 4, a: a};
};
var $author$project$Msg$TimestampUpdate = F2(
	function (a, b) {
		return {$: 0, a: a, b: b};
	});
var $author$project$Translations$uiPagesStepsTimestampNo_time_recorded = function (lang) {
	if (!lang) {
		return 'Noch keine Zeit erfasst...';
	} else {
		return 'No time recorded...';
	}
};
var $author$project$Translations$uiPagesStepsTimestampRecord_time = function (lang) {
	if (!lang) {
		return 'Zeit erfassen';
	} else {
		return 'Record time';
	}
};
var $author$project$Ui$Pages$Steps$Timestamp$inline = F8(
	function (language, operationId, station, step, iteration, time, zone, timestampModel) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[$author$project$TW$Utilities$my_3]))
				]),
			function () {
				if (timestampModel.$ === 1) {
					return _List_fromArray(
						[
							A2(
							$author$project$Ui$UiComponents$Form$step_headline,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$for(
									A2(
										$elm$core$String$join,
										'_',
										_List_fromArray(
											[
												operationId,
												station.bD,
												_Utils_ap(
												step.bD,
												$elm$core$String$fromInt(iteration))
											])))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(step.dP)
								])),
							$author$project$Ui$UiComponents$StepHelper$renderDescription(step),
							A3(
							$author$project$Ui$UiComponents$Form$btn,
							false,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									A3(
										$author$project$Msg$StationMsg_,
										operationId,
										station.bD,
										A3(
											$author$project$Msg$StationUpdateStepState,
											step.bD,
											iteration,
											$author$project$Msg$StepTimestampMsg(
												A2($author$project$Msg$TimestampUpdate, time, zone))))),
									$rtfeldman$elm_css$Html$Styled$Attributes$type_('string'),
									$rtfeldman$elm_css$Html$Styled$Attributes$id(
									A2(
										$elm$core$String$join,
										'_',
										_List_fromArray(
											[
												operationId,
												station.bD,
												_Utils_ap(
												step.bD,
												$elm$core$String$fromInt(iteration))
											]))),
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[$author$project$TW$Utilities$w_full, $author$project$TW$Utilities$mt_1]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Translations$uiPagesStepsTimestampRecord_time(language))
								]))
						]);
				} else {
					var tsModel = timestampModel.a;
					if (!tsModel.$) {
						var time_ = tsModel.a;
						var year = $elm$core$String$fromInt(
							A2($elm$time$Time$toYear, zone, time_));
						var monthToInt = function (m) {
							switch (m) {
								case 0:
									return '1';
								case 1:
									return '2';
								case 2:
									return '3';
								case 3:
									return '4';
								case 4:
									return '5';
								case 5:
									return '6';
								case 6:
									return '7';
								case 7:
									return '8';
								case 8:
									return '9';
								case 9:
									return '10';
								case 10:
									return '11';
								default:
									return '12';
							}
						};
						var month = monthToInt(
							A2($elm$time$Time$toMonth, zone, time_));
						var minute = $elm$core$String$fromInt(
							A2($elm$time$Time$toMinute, zone, time_));
						var hour = $elm$core$String$fromInt(
							A2($elm$time$Time$toHour, zone, time_));
						var day = $elm$core$String$fromInt(
							A2($elm$time$Time$toDay, zone, time_));
						return _List_fromArray(
							[
								A2(
								$author$project$Ui$UiComponents$Form$step_headline,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$for(
										A2(
											$elm$core$String$join,
											'_',
											_List_fromArray(
												[
													operationId,
													station.bD,
													_Utils_ap(
													step.bD,
													$elm$core$String$fromInt(iteration))
												])))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(step.dP)
									])),
								$author$project$Ui$UiComponents$StepHelper$renderDescription(step),
								$rtfeldman$elm_css$Html$Styled$text(day + ('.' + (month + ('.' + (year + (' ' + (hour + (':' + minute))))))))
							]);
					} else {
						return _List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$Translations$uiPagesStepsTimestampNo_time_recorded(language))
							]);
					}
				}
			}());
	});
var $author$project$Msg$No = 1;
var $author$project$Msg$StepYesNoMsg = function (a) {
	return {$: 0, a: a};
};
var $author$project$Msg$Yes = 0;
var $author$project$TW$Utilities$mb_10 = $rtfeldman$elm_css$Css$marginBottom(
	$rtfeldman$elm_css$Css$rem(2.5));
var $author$project$Translations$uiPagesStepsYes_noNo = function (lang) {
	if (!lang) {
		return 'Nein';
	} else {
		return 'No';
	}
};
var $author$project$Translations$uiPagesStepsYes_noYes = function (lang) {
	if (!lang) {
		return 'Ja';
	} else {
		return 'Yes';
	}
};
var $author$project$Ui$Pages$Steps$YesNo$inline = F6(
	function (language, operationId, station, step, iteration, state) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$li,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[
							$author$project$TW$Utilities$mb_10,
							$rtfeldman$elm_css$Css$lastChild(
							_List_fromArray(
								[$author$project$TW$Utilities$mb_4]))
						]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$UiComponents$Form$step_headline,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$for(
							A2(
								$elm$core$String$join,
								'_',
								_List_fromArray(
									[
										operationId,
										station.bD,
										_Utils_ap(
										step.bD,
										$elm$core$String$fromInt(iteration))
									])))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(step.dP)
						])),
					$author$project$Ui$UiComponents$StepHelper$renderDescription(step),
					function () {
					if (!state.$) {
						var yesNoModel = state.a;
						return yesNoModel ? A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[$author$project$TW$Utilities$flex]))
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$UiComponents$Form$btn,
									false,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											A3(
												$author$project$Msg$StationMsg_,
												operationId,
												station.bD,
												A3(
													$author$project$Msg$StationUpdateStepState,
													step.bD,
													iteration,
													$author$project$Msg$StepYesNoMsg(0)))),
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[$author$project$TW$Utilities$w_full, $author$project$TW$Utilities$mr_2]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Translations$uiPagesStepsYes_noYes(language))
										])),
									A3(
									$author$project$Ui$UiComponents$Form$btnClear,
									false,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											A3(
												$author$project$Msg$StationMsg_,
												operationId,
												station.bD,
												A3(
													$author$project$Msg$StationUpdateStepState,
													step.bD,
													iteration,
													$author$project$Msg$StepYesNoMsg(1)))),
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[$author$project$TW$Utilities$w_full]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Translations$uiPagesStepsYes_noNo(language))
										]))
								])) : A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[$author$project$TW$Utilities$flex]))
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$UiComponents$Form$btnClear,
									false,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											A3(
												$author$project$Msg$StationMsg_,
												operationId,
												station.bD,
												A3(
													$author$project$Msg$StationUpdateStepState,
													step.bD,
													iteration,
													$author$project$Msg$StepYesNoMsg(0)))),
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[$author$project$TW$Utilities$w_full, $author$project$TW$Utilities$mr_2]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Translations$uiPagesStepsYes_noYes(language))
										])),
									A3(
									$author$project$Ui$UiComponents$Form$btn,
									false,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											A3(
												$author$project$Msg$StationMsg_,
												operationId,
												station.bD,
												A3(
													$author$project$Msg$StationUpdateStepState,
													step.bD,
													iteration,
													$author$project$Msg$StepYesNoMsg(1)))),
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[$author$project$TW$Utilities$w_full]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Translations$uiPagesStepsYes_noNo(language))
										]))
								]));
					} else {
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[$author$project$TW$Utilities$flex]))
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$UiComponents$Form$btnClear,
									false,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											A3(
												$author$project$Msg$StationMsg_,
												operationId,
												station.bD,
												A3(
													$author$project$Msg$StationUpdateStepState,
													step.bD,
													iteration,
													$author$project$Msg$StepYesNoMsg(0)))),
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[$author$project$TW$Utilities$w_full, $author$project$TW$Utilities$mr_2]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Translations$uiPagesStepsYes_noYes(language))
										])),
									A3(
									$author$project$Ui$UiComponents$Form$btnClear,
									false,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											A3(
												$author$project$Msg$StationMsg_,
												operationId,
												station.bD,
												A3(
													$author$project$Msg$StationUpdateStepState,
													step.bD,
													iteration,
													$author$project$Msg$StepYesNoMsg(1)))),
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[$author$project$TW$Utilities$w_full]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Translations$uiPagesStepsYes_noNo(language))
										]))
								]));
					}
				}()
				]));
	});
var $author$project$Ui$Pages$Station$Show$stepRenderer = F6(
	function (model, operation, operationId, station, iteration, step) {
		var stepIdWithIter = _Utils_ap(
			step.bD,
			$elm$core$String$fromInt(iteration));
		if (A3($author$project$Types$Step$evaluate, station.A, iteration, step.ej)) {
			var _v0 = A3($author$project$Types$Step$getStepType, stepIdWithIter, step.eF, station.A);
			switch (_v0.$) {
				case 0:
					var state = _v0.a;
					return A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$author$project$TW$Utilities$mb_10,
										$rtfeldman$elm_css$Css$lastChild(
										_List_fromArray(
											[$author$project$TW$Utilities$mb_4]))
									]))
							]),
						_List_fromArray(
							[
								A6($author$project$Ui$Pages$Steps$YesNo$inline, model.ck, operationId, station, step, iteration, state)
							]));
				case 1:
					var installationModel = _v0.a;
					return A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$author$project$TW$Utilities$mb_10,
										$rtfeldman$elm_css$Css$lastChild(
										_List_fromArray(
											[$author$project$TW$Utilities$mb_4]))
									]))
							]),
						_List_fromArray(
							[
								A8($author$project$Ui$Pages$Steps$ArticleInstallation$inline, model, operation, operationId, station, step, iteration, installationModel, 1)
							]));
				case 2:
					var installationModel = _v0.a;
					return A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$author$project$TW$Utilities$mb_10,
										$rtfeldman$elm_css$Css$lastChild(
										_List_fromArray(
											[$author$project$TW$Utilities$mb_4]))
									]))
							]),
						_List_fromArray(
							[
								A8($author$project$Ui$Pages$Steps$ArticleInstallation$inline, model, operation, operationId, station, step, iteration, installationModel, 0)
							]));
				case 3:
					var timestampModel = _v0.a;
					return A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$author$project$TW$Utilities$mb_10,
										$rtfeldman$elm_css$Css$lastChild(
										_List_fromArray(
											[$author$project$TW$Utilities$mb_4]))
									]))
							]),
						_List_fromArray(
							[
								A8($author$project$Ui$Pages$Steps$Timestamp$inline, model.ck, operationId, station, step, iteration, model.g2, model.hi, timestampModel)
							]));
				case 4:
					var text = _v0.a;
					return A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$author$project$TW$Utilities$mb_10,
										$rtfeldman$elm_css$Css$lastChild(
										_List_fromArray(
											[$author$project$TW$Utilities$mb_4]))
									]))
							]),
						_List_fromArray(
							[
								A5($author$project$Ui$Pages$Steps$Text$inline, operationId, station, step, iteration, text)
							]));
				case 10:
					return A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$author$project$TW$Utilities$mb_10,
										$rtfeldman$elm_css$Css$lastChild(
										_List_fromArray(
											[$author$project$TW$Utilities$mb_4]))
									]))
							]),
						_List_fromArray(
							[
								A4($author$project$Ui$Pages$Steps$DescriptionOnly$inline, operationId, station, step, iteration)
							]));
				case 5:
					var amountModel = _v0.a;
					return A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$author$project$TW$Utilities$mb_10,
										$rtfeldman$elm_css$Css$lastChild(
										_List_fromArray(
											[$author$project$TW$Utilities$mb_4]))
									]))
							]),
						_List_fromArray(
							[
								A5($author$project$Ui$Pages$Steps$Amount$inline, operationId, station, step, iteration, amountModel)
							]));
				case 6:
					var photoModel = _v0.a;
					return A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$author$project$TW$Utilities$mb_10,
										$rtfeldman$elm_css$Css$lastChild(
										_List_fromArray(
											[$author$project$TW$Utilities$mb_4]))
									]))
							]),
						_List_fromArray(
							[
								A6($author$project$Ui$Pages$Steps$Photo$inline, model.ck, operationId, station, step, iteration, photoModel)
							]));
				case 7:
					var config = _v0.a;
					var articleModel = _v0.b;
					return A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$author$project$TW$Utilities$mb_10,
										$rtfeldman$elm_css$Css$lastChild(
										_List_fromArray(
											[$author$project$TW$Utilities$mb_4]))
									]))
							]),
						_List_fromArray(
							[
								A9(
								$author$project$Ui$Pages$Steps$ArticleInput$inline,
								model.ck,
								0,
								function (wrapper) {
									if (!wrapper.$) {
										var w = wrapper.a;
										return w.aA;
									} else {
										return _List_Nil;
									}
								}(
									A2($elm$core$Dict$get, operationId, model.aA)),
								operationId,
								station,
								step,
								iteration,
								config,
								articleModel)
							]));
				case 9:
					var config = _v0.a;
					var articleModel = _v0.b;
					return A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$author$project$TW$Utilities$mb_10,
										$rtfeldman$elm_css$Css$lastChild(
										_List_fromArray(
											[$author$project$TW$Utilities$mb_4]))
									]))
							]),
						_List_fromArray(
							[
								A9(
								$author$project$Ui$Pages$Steps$ArticleInput$inline,
								model.ck,
								1,
								function (wrapper) {
									if (!wrapper.$) {
										var w = wrapper.a;
										return w.aA;
									} else {
										return _List_Nil;
									}
								}(
									A2($elm$core$Dict$get, operationId, model.aA)),
								operationId,
								station,
								step,
								iteration,
								config,
								articleModel)
							]));
				default:
					var signatureModel = _v0.a;
					return A2(
						$rtfeldman$elm_css$Html$Styled$li,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[
										$author$project$TW$Utilities$mb_10,
										$rtfeldman$elm_css$Css$lastChild(
										_List_fromArray(
											[$author$project$TW$Utilities$mb_4]))
									]))
							]),
						_List_fromArray(
							[
								A6($author$project$Ui$Pages$Steps$Signature$inline, model.ck, operationId, station, step, iteration, signatureModel)
							]));
			}
		} else {
			return $rtfeldman$elm_css$Html$Styled$text('');
		}
	});
var $author$project$Ui$Pages$Station$Show$stepList = F5(
	function (model, operation, operationId, station, iteration) {
		return _Utils_eq(station.eg, $author$project$Types$Station$Inactive) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[$author$project$TW$Utilities$pointer_events_none, $author$project$TW$Utilities$opacity_50]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$author$project$TW$Utilities$m_0, $author$project$TW$Utilities$p_0, $author$project$TW$Utilities$list_none]))
						]),
					A2(
						$elm$core$List$map,
						A5($author$project$Ui$Pages$Station$Show$stepRenderer, model, operation, operationId, station, iteration),
						station.eE))
				])) : A2(
			$rtfeldman$elm_css$Html$Styled$ul,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[$author$project$TW$Utilities$m_0, $author$project$TW$Utilities$p_0, $author$project$TW$Utilities$list_none]))
				]),
			A2(
				$elm$core$List$map,
				A5($author$project$Ui$Pages$Station$Show$stepRenderer, model, operation, operationId, station, iteration),
				station.eE));
	});
var $author$project$TW$Utilities$text_green_400 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--text-opacity', '1'),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('#68d391')),
			A2($rtfeldman$elm_css$Css$property, 'color', 'rgba(104, 211, 145, var(--text-opacity))')
		]));
var $author$project$TW$Utilities$text_right = $rtfeldman$elm_css$Css$textAlign($rtfeldman$elm_css$Css$right);
var $author$project$TW$Utilities$text_xs = $rtfeldman$elm_css$Css$fontSize(
	$rtfeldman$elm_css$Css$rem(0.75));
var $author$project$Translations$uiPagesStationShowAdd = function (lang) {
	if (!lang) {
		return ' hinzufügen';
	} else {
		return ' add';
	}
};
var $author$project$Translations$uiPagesStationShowEdit = function (lang) {
	if (!lang) {
		return 'Bearbeiten';
	} else {
		return 'edit';
	}
};
var $author$project$Translations$uiPagesStationShowFinish = function (lang) {
	if (!lang) {
		return 'Fertig';
	} else {
		return 'finish';
	}
};
var $author$project$Translations$uiPagesStationShowSteps_open = function (lang) {
	if (!lang) {
		return ' Schritt(e) offen';
	} else {
		return ' step(s) open';
	}
};
var $rtfeldman$elm_css$Css$textTransform = $rtfeldman$elm_css$Css$prop1('text-transform');
var $rtfeldman$elm_css$Css$uppercase = {aC: 0, cO: 'uppercase'};
var $author$project$TW$Utilities$uppercase = $rtfeldman$elm_css$Css$textTransform($rtfeldman$elm_css$Css$uppercase);
var $author$project$Ui$Pages$Station$Show$inline = F4(
	function (operationId, model, operation, station) {
		var stationWrapper = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Types$Station$init,
			A2($elm$core$Dict$get, operationId, model.aA));
		var stations = stationWrapper.aA;
		return A2($author$project$Types$Station$evaluate, stations, station.ek) ? A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_Nil,
			A2(
				$elm$core$List$append,
				A2(
					$elm$core$List$map,
					function (iteration) {
						return A2(
							$rtfeldman$elm_css$Html$Styled$section,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[$author$project$TW$Utilities$mb_3]))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$UiComponents$Text$sectionHeadline,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[$author$project$TW$Utilities$flex, $author$project$TW$Utilities$items_center]))
										]),
									_List_fromArray(
										[
											(iteration > 0) ? A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_List_fromArray(
														[$author$project$TW$Utilities$opacity_50, $author$project$TW$Utilities$text_xs, $author$project$TW$Utilities$mr_1]))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('#'),
													$rtfeldman$elm_css$Html$Styled$text(
													$elm$core$String$fromInt(iteration)),
													$rtfeldman$elm_css$Html$Styled$text(': ')
												])) : $rtfeldman$elm_css$Html$Styled$text(''),
											$rtfeldman$elm_css$Html$Styled$text(station.dP),
											function () {
											var _v0 = A2($author$project$Actions$Station$getTitleFromOrder, station, iteration);
											if (_v0 === '') {
												return $rtfeldman$elm_css$Html$Styled$text('');
											} else {
												var title = _v0;
												return $rtfeldman$elm_css$Html$Styled$text(' - ' + title);
											}
										}(),
											((!_Utils_eq(station.cc, $author$project$Types$Step$Inactive)) && A3($author$project$Types$Step$evaluate, station.A, iteration, station.cc)) ? A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_List_fromArray(
														[$author$project$TW$Utilities$text_green_400, $author$project$TW$Utilities$text_xs, $author$project$TW$Utilities$ml_3, $author$project$TW$Utilities$text_right, $author$project$TW$Utilities$uppercase]))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text(
													$author$project$Translations$uiPagesStationShowFinish(model.ck))
												])) : $rtfeldman$elm_css$Html$Styled$text('')
										])),
									function () {
									if (station.dw) {
										return A5($author$project$Ui$Pages$Station$Show$stepList, model, operation, operationId, station, iteration);
									} else {
										var requiredSteps = A2(
											$elm$core$List$filter,
											function (step) {
												return A3($author$project$Types$Step$evaluate, station.A, iteration, step.ej);
											},
											station.eE);
										var openSteps = $elm$core$String$fromInt(
											$elm$core$List$length(
												A2(
													$elm$core$List$filter,
													function (step) {
														return !A3(
															$author$project$Types$Step$stepTypeIsMember,
															_Utils_ap(
																step.bD,
																$elm$core$String$fromInt(iteration)),
															step.eF,
															station.A);
													},
													requiredSteps)));
										return A2(
											$rtfeldman$elm_css$Html$Styled$div,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_List_fromArray(
														[$author$project$TW$Utilities$grid, $author$project$TW$Utilities$grid_cols_3]))
												]),
											_List_fromArray(
												[
													A2(
													$rtfeldman$elm_css$Html$Styled$div,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$css(
															_List_fromArray(
																[$author$project$TW$Utilities$col_span_2]))
														]),
													_List_fromArray(
														[
															A2(
															$rtfeldman$elm_css$Html$Styled$span,
															_List_Nil,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	_Utils_ap(
																		openSteps,
																		$author$project$Translations$uiPagesStationShowSteps_open(model.ck)))
																]))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$div,
													_List_Nil,
													_List_fromArray(
														[
															A3(
															$author$project$Ui$UiComponents$Link$link,
															$author$project$Ui$Router$routeToPath(
																A3($author$project$Ui$Router$StationShow, operationId, station.bD, iteration)),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css(
																	_List_fromArray(
																		[$author$project$TW$Utilities$pl_2]))
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	$author$project$Translations$uiPagesStationShowEdit(model.ck))
																]))
														]))
												]));
									}
								}()
								]));
					},
					station.ab),
				_List_fromArray(
					[
						A2($author$project$Types$Station$evaluate, stations, station.ei) ? A3(
						$author$project$Ui$UiComponents$Form$btn,
						false,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								A3($author$project$Msg$StationMsg_, operationId, station.bD, $author$project$Msg$StationIncrementCounter)),
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[$author$project$TW$Utilities$w_full]))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								_Utils_ap(
									station.dP,
									$author$project$Translations$uiPagesStationShowAdd(model.ck)))
							])) : $rtfeldman$elm_css$Html$Styled$text('')
					]))) : $rtfeldman$elm_css$Html$Styled$text('');
	});
var $author$project$Translations$uiPagesOperation_detailHere_should_be_stations = function (lang) {
	if (!lang) {
		return 'Hier sollten Stationen sein... Bitte einmal neu Laden';
	} else {
		return 'There should be stations here, please reload.';
	}
};
var $author$project$Ui$Pages$OperationDetail$stationsView = F3(
	function (operationId, model, operation) {
		var stations = A2(
			$elm$core$Maybe$withDefault,
			$author$project$Types$Station$init,
			A2($elm$core$Dict$get, operationId, model.aA)).aA;
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[$author$project$TW$Utilities$mb_10]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$ul,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$author$project$TW$Utilities$m_0, $author$project$TW$Utilities$p_0, $author$project$TW$Utilities$list_none]))
						]),
					A2(
						$elm$core$List$map,
						function (station) {
							return A4($author$project$Ui$Pages$Station$Show$inline, operationId, model, operation, station);
						},
						stations)),
					$elm$core$List$isEmpty(stations) ? $rtfeldman$elm_css$Html$Styled$text(
					$author$project$Translations$uiPagesOperation_detailHere_should_be_stations(model.ck)) : $rtfeldman$elm_css$Html$Styled$text('')
				]));
	});
var $author$project$Translations$uiPagesOperation_detailCant_find_operation = F2(
	function (lang, str0) {
		if (!lang) {
			return 'Konnte die Operation ' + (str0 + ' nicht finden.');
		} else {
			return 'Can\'t find operation ' + (str0 + '');
		}
	});
var $author$project$Ui$Pages$OperationDetail$page = F2(
	function (operationId, model) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[$author$project$TW$Utilities$p_4]))
				]),
			_List_fromArray(
				[
					function () {
					var _v0 = A2($elm$core$Dict$get, operationId, model.ba);
					if (_v0.$ === 1) {
						return $rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Translations$uiPagesOperation_detailCant_find_operation, model.ck, operationId));
					} else {
						var operation = _v0.a;
						return A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_Nil,
							_List_fromArray(
								[
									A3($author$project$Ui$Pages$OperationDetail$stationsView, operationId, model, operation)
								]));
					}
				}()
				]));
	});
var $elm$svg$Svg$line = $elm$svg$Svg$trustedNode('line');
var $elm$svg$Svg$Attributes$x1 = _VirtualDom_attribute('x1');
var $elm$svg$Svg$Attributes$x2 = _VirtualDom_attribute('x2');
var $elm$svg$Svg$Attributes$y1 = _VirtualDom_attribute('y1');
var $elm$svg$Svg$Attributes$y2 = _VirtualDom_attribute('y2');
var $feathericons$elm_feather$FeatherIcons$arrowLeft = A2(
	$feathericons$elm_feather$FeatherIcons$makeBuilder,
	'arrow-left',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('19'),
					$elm$svg$Svg$Attributes$y1('12'),
					$elm$svg$Svg$Attributes$x2('5'),
					$elm$svg$Svg$Attributes$y2('12')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$polyline,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$points('12 19 5 12 12 5')
				]),
			_List_Nil)
		]));
var $author$project$TW$Utilities$p_3 = $rtfeldman$elm_css$Css$padding(
	$rtfeldman$elm_css$Css$rem(0.75));
var $rtfeldman$elm_css$Html$Styled$Attributes$title = $rtfeldman$elm_css$Html$Styled$Attributes$stringProperty('title');
var $author$project$Ui$UiComponents$Link$backLink = F2(
	function (path, attributes) {
		return A3(
			$author$project$Ui$UiComponents$Link$link,
			path,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$title('zurück'),
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[$author$project$TW$Utilities$block, $author$project$TW$Utilities$p_3, $author$project$TW$Utilities$text_white]))
					]),
				attributes),
			_List_fromArray(
				[
					$author$project$Ui$UiComponents$Icons$icon($feathericons$elm_feather$FeatherIcons$arrowLeft)
				]));
	});
var $rtfeldman$elm_css$Html$Styled$h1 = $rtfeldman$elm_css$Html$Styled$node('h1');
var $rtfeldman$elm_css$Css$height = $rtfeldman$elm_css$Css$prop1('height');
var $rtfeldman$elm_css$Css$VhUnits = 0;
var $rtfeldman$elm_css$Css$vh = A2($rtfeldman$elm_css$Css$Internal$lengthConverter, 0, 'vh');
var $author$project$TW$Utilities$h_screen = $rtfeldman$elm_css$Css$height(
	$rtfeldman$elm_css$Css$vh(100));
var $rtfeldman$elm_css$Html$Styled$main_ = $rtfeldman$elm_css$Html$Styled$node('main');
var $author$project$TW$Utilities$text_gray_600 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--text-opacity', '1'),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('#718096')),
			A2($rtfeldman$elm_css$Css$property, 'color', 'rgba(113, 128, 150, var(--text-opacity))')
		]));
var $author$project$Ui$UiComponents$Form$labelStyle = $rtfeldman$elm_css$Html$Styled$Attributes$css(
	_List_fromArray(
		[$author$project$TW$Utilities$block, $author$project$TW$Utilities$text_xs, $author$project$TW$Utilities$uppercase, $author$project$TW$Utilities$text_gray_600]));
var $author$project$Translations$uiPagesStationCreateCreate = function (lang) {
	if (!lang) {
		return 'Anlegen';
	} else {
		return 'create';
	}
};
var $author$project$Translations$uiPagesStationCreateInsert_number = function (lang) {
	if (!lang) {
		return 'Bitte eine Nummer eingeben';
	} else {
		return 'Please insert a number';
	}
};
var $author$project$Translations$uiPagesStationCreatePos = function (lang) {
	if (!lang) {
		return 'Kassenplatz';
	} else {
		return 'Point of service';
	}
};
var $author$project$Ui$Pages$Station$Create$stationCreateForm = F3(
	function (operationId, model, operation) {
		var placeholderStationName = $author$project$Translations$uiPagesStationCreateInsert_number(model.ck);
		var labelStationName = $author$project$Translations$uiPagesStationCreatePos(model.ck);
		return A2(
			$rtfeldman$elm_css$Html$Styled$section,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[$author$project$TW$Utilities$mb_10, $author$project$TW$Utilities$w_full, $author$project$TW$Utilities$p_3]))
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$span,
					_List_fromArray(
						[$author$project$Ui$UiComponents$Form$labelStyle]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(labelStationName)
						])),
					A2(
					$author$project$Ui$UiComponents$Form$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(placeholderStationName),
							$rtfeldman$elm_css$Html$Styled$Attributes$value(operation.bj.eC)
						]),
					_List_Nil),
					A3(
					$author$project$Ui$UiComponents$Form$btn,
					false,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$author$project$TW$Utilities$w_full]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Translations$uiPagesStationCreateCreate(model.ck))
						]))
				]));
	});
var $author$project$TW$Utilities$bg_blue_600 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--bg-opacity', '1'),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('#3182ce')),
			A2($rtfeldman$elm_css$Css$property, 'background-color', 'rgba(49, 130, 206, var(--bg-opacity))')
		]));
var $author$project$TW$Utilities$bottom_auto = $rtfeldman$elm_css$Css$bottom($rtfeldman$elm_css$Css$auto);
var $rtfeldman$elm_css$Css$sticky = {bd: 0, cO: 'sticky'};
var $author$project$TW$Utilities$sticky = $rtfeldman$elm_css$Css$position($rtfeldman$elm_css$Css$sticky);
var $author$project$Ui$Bentomax$toolbar = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[$author$project$TW$Utilities$w_full, $author$project$TW$Utilities$flex, $author$project$TW$Utilities$bg_blue_600, $author$project$TW$Utilities$bottom_auto, $author$project$TW$Utilities$top_0, $author$project$TW$Utilities$left_0, $author$project$TW$Utilities$right_0, $author$project$TW$Utilities$sticky, $author$project$TW$Utilities$text_white, $author$project$TW$Utilities$flex, $author$project$TW$Utilities$items_center]))
					]),
				attributes),
			children);
	});
var $author$project$Translations$uiPagesStationCreateCant_find_operation = F2(
	function (lang, str0) {
		if (!lang) {
			return 'Konnte die Operation ' + (str0 + ' nicht finden.');
		} else {
			return 'Can\'t find operation ' + (str0 + '');
		}
	});
var $author$project$Translations$uiPagesStationCreateCreate_station = function (lang) {
	if (!lang) {
		return 'Station anlegen';
	} else {
		return 'create station';
	}
};
var $author$project$Ui$Pages$Station$Create$page = F2(
	function (operationId, model) {
		var _v0 = A2($elm$core$Dict$get, operationId, model.ba);
		if (_v0.$ === 1) {
			return $rtfeldman$elm_css$Html$Styled$text(
				A2($author$project$Translations$uiPagesStationCreateCant_find_operation, model.ck, operationId));
		} else {
			var operation = _v0.a;
			return A2(
				$rtfeldman$elm_css$Html$Styled$main_,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[$author$project$TW$Utilities$p_3, $author$project$TW$Utilities$flex, $author$project$TW$Utilities$items_center, $author$project$TW$Utilities$h_screen, $author$project$TW$Utilities$justify_center]))
					]),
				_List_fromArray(
					[
						A2(
						$author$project$Ui$Bentomax$toolbar,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[$author$project$TW$Utilities$fixed, $author$project$TW$Utilities$top_0, $author$project$TW$Utilities$left_0]))
							]),
						_List_fromArray(
							[
								A2(
								$author$project$Ui$UiComponents$Link$backLink,
								$author$project$Ui$Router$routeToPath(
									$author$project$Ui$Router$OperationDetail(operationId)),
								_List_Nil),
								A2(
								$rtfeldman$elm_css$Html$Styled$h1,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[$author$project$TW$Utilities$text_lg]))
									]),
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$Translations$uiPagesStationCreateCreate_station(model.ck))
									]))
							])),
						A3($author$project$Ui$Pages$Station$Create$stationCreateForm, operationId, model, operation)
					]));
		}
	});
var $author$project$Msg$StationDeleteIncrement = function (a) {
	return {$: 2, a: a};
};
var $author$project$Msg$StationDeleteRequest = function (a) {
	return {$: 3, a: a};
};
var $author$project$Msg$StationDeleteRequestAbort = function (a) {
	return {$: 4, a: a};
};
var $author$project$TW$Utilities$border_0 = $rtfeldman$elm_css$Css$borderWidth(
	$rtfeldman$elm_css$Css$px(0));
var $author$project$TW$Utilities$border_gray_200 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--border-opacity', '1'),
			$rtfeldman$elm_css$Css$borderColor(
			$rtfeldman$elm_css$Css$hex('#edf2f7')),
			A2($rtfeldman$elm_css$Css$property, 'border-color', 'rgba(237, 242, 247, var(--border-opacity))')
		]));
var $author$project$TW$Utilities$border_t = $rtfeldman$elm_css$Css$borderTopWidth(
	$rtfeldman$elm_css$Css$px(1));
var $author$project$Types$Station$iterationExists = F3(
	function (stations, stationId, iteration) {
		var iterationInStation = function (station) {
			return _Utils_eq(station.bD, stationId) ? (0 < $elm$core$List$length(
				A2(
					$elm$core$List$filter,
					$elm$core$Basics$eq(iteration),
					station.ab))) : false;
		};
		return A3(
			$elm$core$List$foldl,
			$elm$core$Basics$or,
			false,
			A2($elm$core$List$map, iterationInStation, stations));
	});
var $author$project$TW$Utilities$mt_8 = $rtfeldman$elm_css$Css$marginTop(
	$rtfeldman$elm_css$Css$rem(2));
var $author$project$TW$Utilities$pt_16 = $rtfeldman$elm_css$Css$paddingTop(
	$rtfeldman$elm_css$Css$rem(4));
var $author$project$TW$Utilities$pt_4 = $rtfeldman$elm_css$Css$paddingTop(
	$rtfeldman$elm_css$Css$rem(1));
var $author$project$TW$Utilities$bg_green_200 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--bg-opacity', '1'),
			$rtfeldman$elm_css$Css$backgroundColor(
			$rtfeldman$elm_css$Css$hex('#c6f6d5')),
			A2($rtfeldman$elm_css$Css$property, 'background-color', 'rgba(198, 246, 213, var(--bg-opacity))')
		]));
var $author$project$TW$Utilities$my_8 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$rem(2)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$rem(2))
		]));
var $author$project$TW$Utilities$text_green_800 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--text-opacity', '1'),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('#276749')),
			A2($rtfeldman$elm_css$Css$property, 'color', 'rgba(39, 103, 73, var(--text-opacity))')
		]));
var $author$project$Ui$UiComponents$Flash$success = F2(
	function (attr, children) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[$author$project$TW$Utilities$bg_green_200, $author$project$TW$Utilities$p_2, $author$project$TW$Utilities$text_green_800, $author$project$TW$Utilities$font_bold, $author$project$TW$Utilities$text_center, $author$project$TW$Utilities$my_8]))
					]),
				attr),
			children);
	});
var $author$project$Ui$UiComponents$Text$textMuted = F2(
	function (attr, children) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$p,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[$author$project$TW$Utilities$text_base, $author$project$TW$Utilities$opacity_50, $author$project$TW$Utilities$text_sm]))
					]),
				attr),
			children);
	});
var $author$project$Translations$uiPagesStationShowAbort = function (lang) {
	if (!lang) {
		return 'Abbrechen';
	} else {
		return 'abort';
	}
};
var $author$project$Translations$uiPagesStationShowCant_find_operation = F2(
	function (lang, str0) {
		if (!lang) {
			return 'Konnte die Operation ' + (str0 + ' nicht finden. Deswegen können keine Stationen angezeigt werden.');
		} else {
			return 'Can\'t find operation ' + (str0 + '. Therafore no stations can be displayed.');
		}
	});
var $author$project$Translations$uiPagesStationShowCant_find_station = function (lang) {
	if (!lang) {
		return 'Konnte die Station nicht finden...';
	} else {
		return 'Can\'t find station';
	}
};
var $author$project$Translations$uiPagesStationShowDelete = function (lang) {
	if (!lang) {
		return ' Löschen?';
	} else {
		return ' delete?';
	}
};
var $author$project$Translations$uiPagesStationShowReally_delete = function (lang) {
	if (!lang) {
		return 'Wirklich Löschen';
	} else {
		return 'really delete?';
	}
};
var $author$project$Translations$uiPagesStationShowSave = function (lang) {
	if (!lang) {
		return 'Speichern';
	} else {
		return 'save';
	}
};
var $author$project$Translations$uiPagesStationShowStation_cant_be_deleted = function (lang) {
	if (!lang) {
		return 'Diese Station kann nicht gelöscht werden, solange Sie Material erfasst haben.';
	} else {
		return 'This station can\'t be deleted as long as you have recorded material';
	}
};
var $author$project$Translations$uiPagesStationShowStation_completed = function (lang) {
	if (!lang) {
		return 'Diese Station ist abgeschlossen!';
	} else {
		return 'Station completed!';
	}
};
var $author$project$Translations$uiPagesStationShowStation_not_existing = function (lang) {
	if (!lang) {
		return 'Station nicht vorhanden - Zurück';
	} else {
		return 'Station not existing - return';
	}
};
var $author$project$Ui$Pages$Station$Show$page = F4(
	function (operationId, stationId, iteration, model) {
		var _v0 = A2($elm$core$Dict$get, operationId, model.ba);
		if (_v0.$ === 1) {
			return $rtfeldman$elm_css$Html$Styled$text(
				A2($author$project$Translations$uiPagesStationShowCant_find_operation, model.ck, operationId));
		} else {
			var operation = _v0.a;
			var stationWrapper = A2(
				$elm$core$Maybe$withDefault,
				$author$project$Types$Station$init,
				A2($elm$core$Dict$get, operationId, model.aA));
			var _v1 = $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.bD;
						},
						$elm$core$Basics$eq(stationId)),
					stationWrapper.aA));
			if (!_v1.$) {
				var station = _v1.a;
				var fakeSaveButton = A4(
					$author$project$Ui$UiComponents$Form$btnLink,
					$author$project$Ui$Router$routeToPath(
						$author$project$Ui$Router$OperationDetail(operationId)),
					false,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$author$project$TW$Utilities$w_full, $author$project$TW$Utilities$mb_2]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Translations$uiPagesStationShowSave(model.ck))
						]));
				var articleInstallationIds = A2(
					$elm$core$List$filterMap,
					function (step) {
						var _v5 = step.eF;
						if (_v5.$ === 1) {
							return $elm$core$Maybe$Just(
								_Utils_ap(
									step.bD,
									$elm$core$String$fromInt(iteration)));
						} else {
							return $elm$core$Maybe$Nothing;
						}
					},
					station.eE);
				var hasIterationInstalledArticles = A3(
					$elm$core$List$foldl,
					$elm$core$Basics$or,
					false,
					A2(
						$elm$core$List$map,
						function (_v4) {
							var stepId = _v4.a;
							return A2($elm$core$List$member, stepId, articleInstallationIds);
						},
						$elm$core$Dict$toList(station.A.ag)));
				return A2(
					$rtfeldman$elm_css$Html$Styled$main_,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$author$project$TW$Utilities$p_3, $author$project$TW$Utilities$flex, $author$project$TW$Utilities$h_screen, $author$project$TW$Utilities$justify_center, $author$project$TW$Utilities$pt_16]))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Bentomax$toolbar,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[$author$project$TW$Utilities$fixed, $author$project$TW$Utilities$top_0, $author$project$TW$Utilities$left_0]))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$UiComponents$Link$backLink,
									$author$project$Ui$Router$routeToPath(
										$author$project$Ui$Router$OperationDetail(operationId)),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$h1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[$author$project$TW$Utilities$text_lg]))
										]),
									_List_fromArray(
										[
											(iteration > 0) ? A2(
											$rtfeldman$elm_css$Html$Styled$span,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(
													_List_fromArray(
														[$author$project$TW$Utilities$opacity_50]))
												]),
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('#'),
													$rtfeldman$elm_css$Html$Styled$text(
													$elm$core$String$fromInt(iteration)),
													$rtfeldman$elm_css$Html$Styled$text(': ')
												])) : $rtfeldman$elm_css$Html$Styled$text(''),
											$rtfeldman$elm_css$Html$Styled$text(station.dP),
											function () {
											var _v2 = A2($author$project$Actions$Station$getTitleFromOrder, station, iteration);
											if (_v2 === '') {
												return $rtfeldman$elm_css$Html$Styled$text('');
											} else {
												var title = _v2;
												return $rtfeldman$elm_css$Html$Styled$text(' - ' + title);
											}
										}()
										]))
								])),
							A3($author$project$Types$Station$iterationExists, stationWrapper.aA, stationId, iteration) ? A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[$author$project$TW$Utilities$w_full]))
								]),
							_List_fromArray(
								[
									A5($author$project$Ui$Pages$Station$Show$stepList, model, operation, operationId, station, iteration),
									A3($author$project$Types$Step$evaluate, station.A, iteration, station.cc) ? A2(
									$author$project$Ui$UiComponents$Flash$success,
									_List_Nil,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Translations$uiPagesStationShowStation_completed(model.ck))
										])) : $rtfeldman$elm_css$Html$Styled$text(''),
									A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[$author$project$TW$Utilities$w_full, $author$project$TW$Utilities$mt_8, $author$project$TW$Utilities$pt_4, $author$project$TW$Utilities$border_0, $author$project$TW$Utilities$border_gray_200, $author$project$TW$Utilities$border_t, $author$project$TW$Utilities$border_solid, $author$project$TW$Utilities$mb_4]))
										]),
									function () {
										if (!A2($author$project$Types$Station$evaluate, stationWrapper.aA, station.ei)) {
											return _List_fromArray(
												[fakeSaveButton]);
										} else {
											var _v3 = station.eB;
											if (!_v3.$) {
												var val = _v3.a;
												return _Utils_eq(val, iteration) ? _List_fromArray(
													[
														fakeSaveButton,
														A2(
														$rtfeldman$elm_css$Html$Styled$div,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$css(
																_List_fromArray(
																	[$author$project$TW$Utilities$flex]))
															]),
														_List_fromArray(
															[
																A3(
																$author$project$Ui$UiComponents$Form$btnRed,
																false,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Events$onClick(
																		A3(
																			$author$project$Msg$StationMsg_,
																			operationId,
																			station.bD,
																			$author$project$Msg$StationDeleteIncrement(iteration))),
																		$rtfeldman$elm_css$Html$Styled$Attributes$css(
																		_List_fromArray(
																			[$author$project$TW$Utilities$w_full, $author$project$TW$Utilities$mr_2]))
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(
																		$author$project$Translations$uiPagesStationShowReally_delete(model.ck))
																	])),
																A3(
																$author$project$Ui$UiComponents$Form$btnClear,
																false,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Events$onClick(
																		A3(
																			$author$project$Msg$StationMsg_,
																			operationId,
																			station.bD,
																			$author$project$Msg$StationDeleteRequestAbort(iteration))),
																		$rtfeldman$elm_css$Html$Styled$Attributes$css(
																		_List_fromArray(
																			[$author$project$TW$Utilities$w_full]))
																	]),
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text(
																		$author$project$Translations$uiPagesStationShowAbort(model.ck))
																	]))
															]))
													]) : _List_fromArray(
													[
														fakeSaveButton,
														(!hasIterationInstalledArticles) ? A3(
														$author$project$Ui$UiComponents$Form$btnClear,
														false,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Events$onClick(
																A3(
																	$author$project$Msg$StationMsg_,
																	operationId,
																	station.bD,
																	$author$project$Msg$StationDeleteRequest(iteration))),
																$rtfeldman$elm_css$Html$Styled$Attributes$css(
																_List_fromArray(
																	[$author$project$TW$Utilities$w_full]))
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																_Utils_ap(
																	station.dP,
																	$author$project$Translations$uiPagesStationShowDelete(model.ck)))
															])) : A2(
														$author$project$Ui$UiComponents$Text$textMuted,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$css(
																_List_fromArray(
																	[$author$project$TW$Utilities$text_center]))
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$Translations$uiPagesStationShowStation_cant_be_deleted(model.ck))
															]))
													]);
											} else {
												return _List_fromArray(
													[
														fakeSaveButton,
														(!hasIterationInstalledArticles) ? A3(
														$author$project$Ui$UiComponents$Form$btnClear,
														false,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Events$onClick(
																A3(
																	$author$project$Msg$StationMsg_,
																	operationId,
																	station.bD,
																	$author$project$Msg$StationDeleteRequest(iteration))),
																$rtfeldman$elm_css$Html$Styled$Attributes$css(
																_List_fromArray(
																	[$author$project$TW$Utilities$w_full]))
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																_Utils_ap(
																	station.dP,
																	$author$project$Translations$uiPagesStationShowDelete(model.ck)))
															])) : A2(
														$author$project$Ui$UiComponents$Text$textMuted,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$Attributes$css(
																_List_fromArray(
																	[$author$project$TW$Utilities$text_center]))
															]),
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$Translations$uiPagesStationShowStation_cant_be_deleted(model.ck))
															]))
													]);
											}
										}
									}())
								])) : A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[$author$project$TW$Utilities$w_full]))
								]),
							_List_fromArray(
								[
									A4(
									$author$project$Ui$UiComponents$Form$btnLinkClear,
									$author$project$Ui$Router$routeToPath(
										$author$project$Ui$Router$OperationDetail(operationId)),
									false,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[$author$project$TW$Utilities$w_full]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Translations$uiPagesStationShowStation_not_existing(model.ck))
										]))
								]))
						]));
			} else {
				return $rtfeldman$elm_css$Html$Styled$text(
					$author$project$Translations$uiPagesStationShowCant_find_station(model.ck));
			}
		}
	});
var $author$project$TW$Utilities$font_sans = A2($rtfeldman$elm_css$Css$property, 'font-family', 'system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, \"Helvetica Neue\", Arial, \"Noto Sans\", sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"');
var $author$project$Translations$uiPagesStepsArticle_installation_folderSearchCant_find_operation = F2(
	function (lang, str0) {
		if (!lang) {
			return 'Konnte die Operation ' + (str0 + ' nicht finden.');
		} else {
			return 'Can\'t find operation ' + (str0 + '.');
		}
	});
var $author$project$Translations$uiPagesStepsArticle_installation_folderSearchCant_load_warehouse = function (lang) {
	if (!lang) {
		return 'Konnte das Warenlager nicht laden...';
	} else {
		return 'Can\'t load the warehouse...';
	}
};
var $author$project$Translations$uiPagesStepsArticle_installation_folderSearchLoading = function (lang) {
	if (!lang) {
		return '... laden ...';
	} else {
		return '... loading ...';
	}
};
var $author$project$Msg$OperationResetWarehouseSearch = function (a) {
	return {$: 10, a: a};
};
var $author$project$Msg$WarehouseUpdateArticleSearchTerm = function (a) {
	return {$: 0, a: a};
};
var $author$project$TW$Utilities$flex_auto = A2($rtfeldman$elm_css$Css$property, 'flex', '1 1 auto');
var $rtfeldman$elm_css$Html$Styled$header = $rtfeldman$elm_css$Html$Styled$node('header');
var $author$project$TW$Utilities$px_3 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingLeft(
			$rtfeldman$elm_css$Css$rem(0.75)),
			$rtfeldman$elm_css$Css$paddingRight(
			$rtfeldman$elm_css$Css$rem(0.75))
		]));
var $author$project$TW$Utilities$py_3 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$rem(0.75)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$rem(0.75))
		]));
var $elm$svg$Svg$circle = $elm$svg$Svg$trustedNode('circle');
var $elm$svg$Svg$Attributes$cx = _VirtualDom_attribute('cx');
var $elm$svg$Svg$Attributes$cy = _VirtualDom_attribute('cy');
var $elm$svg$Svg$Attributes$r = _VirtualDom_attribute('r');
var $feathericons$elm_feather$FeatherIcons$search = A2(
	$feathericons$elm_feather$FeatherIcons$makeBuilder,
	'search',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$circle,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$cx('11'),
					$elm$svg$Svg$Attributes$cy('11'),
					$elm$svg$Svg$Attributes$r('8')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('21'),
					$elm$svg$Svg$Attributes$y1('21'),
					$elm$svg$Svg$Attributes$x2('16.65'),
					$elm$svg$Svg$Attributes$y2('16.65')
				]),
			_List_Nil)
		]));
var $author$project$Translations$uiPagesStepsArticle_installation_folderSearchSearch = function (lang) {
	if (!lang) {
		return 'Suche';
	} else {
		return 'Search';
	}
};
var $feathericons$elm_feather$FeatherIcons$x = A2(
	$feathericons$elm_feather$FeatherIcons$makeBuilder,
	'x',
	_List_fromArray(
		[
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('18'),
					$elm$svg$Svg$Attributes$y1('6'),
					$elm$svg$Svg$Attributes$x2('6'),
					$elm$svg$Svg$Attributes$y2('18')
				]),
			_List_Nil),
			A2(
			$elm$svg$Svg$line,
			_List_fromArray(
				[
					$elm$svg$Svg$Attributes$x1('6'),
					$elm$svg$Svg$Attributes$y1('6'),
					$elm$svg$Svg$Attributes$x2('18'),
					$elm$svg$Svg$Attributes$y2('18')
				]),
			_List_Nil)
		]));
var $author$project$TW$Utilities$z_10 = $rtfeldman$elm_css$Css$zIndex(
	$rtfeldman$elm_css$Css$int(10));
var $author$project$Ui$Pages$Steps$ArticleInstallation$Search$warehouseSearchBox = F5(
	function (model, operationId, stationId, iteration, warehouse) {
		var hasActiveSearch = model.bj.e4 !== '';
		return A2(
			$rtfeldman$elm_css$Html$Styled$header,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[$author$project$TW$Utilities$sticky, $author$project$TW$Utilities$top_0, $author$project$TW$Utilities$bg_white, $author$project$TW$Utilities$z_10, $author$project$TW$Utilities$flex, $author$project$TW$Utilities$items_center, $author$project$TW$Utilities$justify_center, $author$project$TW$Utilities$bg_blue_600, $author$project$TW$Utilities$rounded]))
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$UiComponents$Link$backLink,
					$author$project$Ui$Router$routeToPath(
						A3($author$project$Ui$Router$StationShow, operationId, stationId, iteration)),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$author$project$TW$Utilities$text_white]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$input,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$placeholder(
							$author$project$Translations$uiPagesStepsArticle_installation_folderSearchSearch(model.ck)),
							$rtfeldman$elm_css$Html$Styled$Attributes$id('search-box'),
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$author$project$TW$Utilities$px_3, $author$project$TW$Utilities$py_3, $author$project$TW$Utilities$bg_white, $author$project$TW$Utilities$flex_auto])),
							$rtfeldman$elm_css$Html$Styled$Attributes$value(model.bj.e4),
							$rtfeldman$elm_css$Html$Styled$Events$onInput(
							A2($elm$core$Basics$composeL, $author$project$Msg$WarehouseMsg_, $author$project$Msg$WarehouseUpdateArticleSearchTerm))
						]),
					_List_Nil),
					A2(
					$rtfeldman$elm_css$Html$Styled$button,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$author$project$TW$Utilities$p_3, $author$project$TW$Utilities$text_white])),
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Msg$WarehouseMsg_(
								$author$project$Msg$OperationResetWarehouseSearch(operationId)))
						]),
					_List_fromArray(
						[
							hasActiveSearch ? $author$project$Ui$UiComponents$Icons$icon($feathericons$elm_feather$FeatherIcons$x) : $author$project$Ui$UiComponents$Icons$icon($feathericons$elm_feather$FeatherIcons$search)
						]))
				]));
	});
var $author$project$Lib$articleContainsSearchTerm = F2(
	function (searchTerm, article) {
		var normalizedSearchTerm = $elm$core$String$toLower(searchTerm);
		return A2(
			$elm$core$String$contains,
			normalizedSearchTerm,
			$elm$core$String$toLower(article.ex)) || (A2(
			$elm$core$String$contains,
			normalizedSearchTerm,
			$elm$core$String$toLower(
				$elm$core$String$fromInt(article.bD))) || A2(
			$elm$core$String$contains,
			normalizedSearchTerm,
			$elm$core$String$toLower(article.fl)));
	});
var $author$project$Msg$StationChangeMaterial = F6(
	function (a, b, c, d, e, f) {
		return {$: 6, a: a, b: b, c: c, d: d, e: e, f: f};
	});
var $elm$core$Set$member = F2(
	function (key, _v0) {
		var dict = _v0;
		return A2($elm$core$Dict$member, key, dict);
	});
var $elm$core$Set$Set_elm_builtin = $elm$core$Basics$identity;
var $elm$core$Set$empty = $elm$core$Dict$empty;
var $elm$core$Set$insert = F2(
	function (key, _v0) {
		var dict = _v0;
		return A3($elm$core$Dict$insert, key, 0, dict);
	});
var $elm$core$Set$fromList = function (list) {
	return A3($elm$core$List$foldl, $elm$core$Set$insert, $elm$core$Set$empty, list);
};
var $author$project$Lib$noSn = $elm$core$Set$fromList(
	_List_fromArray(
		['none', '', '(keine)', 'keine']));
var $author$project$Lib$articleHasNoSn = function (article) {
	return A2(
		$elm$core$Set$member,
		$elm$core$String$trim(
			$elm$core$String$toLower(article.ex)),
		$author$project$Lib$noSn);
};
var $author$project$TW$Utilities$py_1 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$paddingTop(
			$rtfeldman$elm_css$Css$rem(0.25)),
			$rtfeldman$elm_css$Css$paddingBottom(
			$rtfeldman$elm_css$Css$rem(0.25))
		]));
var $author$project$Translations$uiPagesStepsArticle_installation_folderSearchApply = function (lang) {
	if (!lang) {
		return 'Verwenden';
	} else {
		return 'Apply';
	}
};
var $author$project$Ui$Pages$Steps$ArticleInstallation$Search$articleRenderer = F7(
	function (model, operationId, stationId, iteration, stepId, installationType, article) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$author$project$TW$Utilities$pr_4]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$elm$core$String$fromInt(article.bD))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$author$project$TW$Utilities$pr_4]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(article.ex)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$author$project$TW$Utilities$py_1]))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$UiComponents$Form$btnClear,
							false,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									$author$project$Msg$WarehouseMsg_(
										A6($author$project$Msg$StationChangeMaterial, operationId, article.bD, stationId, iteration, stepId, installationType)))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Translations$uiPagesStepsArticle_installation_folderSearchApply(model.ck))
								]))
						]))
				]));
	});
var $author$project$TW$Utilities$border_green_300 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--border-opacity', '1'),
			$rtfeldman$elm_css$Css$borderColor(
			$rtfeldman$elm_css$Css$hex('#9ae6b4')),
			A2($rtfeldman$elm_css$Css$property, 'border-color', 'rgba(154, 230, 180, var(--border-opacity))')
		]));
var $author$project$Ui$UiComponents$Form$btnGreen = F3(
	function (disabled, attributes, children) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$button,
			_Utils_ap(
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_Utils_ap(
							_List_fromArray(
								[$author$project$TW$Utilities$px_2, $author$project$TW$Utilities$py_2, $author$project$TW$Utilities$rounded, $author$project$TW$Utilities$border, $author$project$TW$Utilities$border_solid]),
							disabled ? _List_fromArray(
								[$author$project$TW$Utilities$opacity_50, $author$project$TW$Utilities$bg_gray_200, $author$project$TW$Utilities$text_gray_800, $author$project$TW$Utilities$border_gray_300]) : _List_fromArray(
								[$author$project$TW$Utilities$bg_green_200, $author$project$TW$Utilities$text_green_800, $author$project$TW$Utilities$border_green_300]))),
						$rtfeldman$elm_css$Html$Styled$Attributes$disabled(disabled)
					]),
				attributes),
			children);
	});
var $rtfeldman$elm_css$Css$flexShrink = $rtfeldman$elm_css$Css$prop1('flex-shrink');
var $author$project$TW$Utilities$flex_shrink_0 = $rtfeldman$elm_css$Css$flexShrink(
	$rtfeldman$elm_css$Css$int(0));
var $rtfeldman$elm_css$Html$Styled$h5 = $rtfeldman$elm_css$Html$Styled$node('h5');
var $rtfeldman$elm_css$Css$flexStart = $rtfeldman$elm_css$Css$prop1('flex-start');
var $author$project$TW$Utilities$items_start = $rtfeldman$elm_css$Css$alignItems($rtfeldman$elm_css$Css$flexStart);
var $author$project$TW$Utilities$mr_5 = $rtfeldman$elm_css$Css$marginRight(
	$rtfeldman$elm_css$Css$rem(1.25));
var $author$project$Translations$uiPagesStepsArticle_installation_folderSearchHits = function (lang) {
	if (!lang) {
		return ' Treffer';
	} else {
		return ' hits';
	}
};
var $author$project$Translations$uiPagesStepsArticle_installation_folderSearchItems = function (lang) {
	if (!lang) {
		return ' Artikel';
	} else {
		return ' item(s)';
	}
};
var $author$project$Translations$uiPagesStepsArticle_installation_folderSearchItems_found = function (lang) {
	if (!lang) {
		return 'Artikel gefunden';
	} else {
		return 'item(s) found';
	}
};
var $author$project$Translations$uiPagesStepsArticle_installation_folderSearchSearch_results_for = function (lang) {
	if (!lang) {
		return ' Suchergebnisse für ';
	} else {
		return ' search results for ';
	}
};
var $author$project$Translations$uiPagesStepsArticle_installation_folderSearchSelect_amount = function (lang) {
	if (!lang) {
		return 'Menge auswählen';
	} else {
		return 'Select amount';
	}
};
var $author$project$Translations$uiPagesStepsArticle_installation_folderSearchThere_is_no_anymore = F2(
	function (lang, str0) {
		if (!lang) {
			return 'Es gibt keine \' ' + (str0 + ' \' mehr');
		} else {
			return 'There is no \' ' + (str0 + ' \' anymore');
		}
	});
var $author$project$Ui$Pages$Steps$ArticleInstallation$Search$clusterRenderer = F9(
	function (model, usedArticleIds, operationId, searchTerm, stationId, iteration, stepId, installationType, _v0) {
		var description = _v0.a;
		var warehouse = _v0.b;
		var warehouseWithoutUsedArticles = A2(
			$elm$core$List$filter,
			function (a) {
				return !A2(
					$elm$core$List$member,
					$elm$core$String$fromInt(a.bD),
					usedArticleIds);
			},
			warehouse);
		var _v1 = $elm$core$List$head(warehouseWithoutUsedArticles);
		if (!_v1.$) {
			var article = _v1.a;
			var clusterSize = $elm$core$String$fromInt(
				$elm$core$List$length(warehouseWithoutUsedArticles));
			var infos = $author$project$Lib$articleHasNoSn(article) ? $rtfeldman$elm_css$Html$Styled$text('') : ((searchTerm === '') ? A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[$author$project$TW$Utilities$mr_5]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						_Utils_ap(
							clusterSize,
							$author$project$Translations$uiPagesStepsArticle_installation_folderSearchItems(model.ck)))
					])) : ((_Utils_eq(
				$elm$core$String$fromInt(article.bD),
				searchTerm) || _Utils_eq(article.ex, searchTerm)) ? A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[$author$project$TW$Utilities$mr_5]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						$author$project$Translations$uiPagesStepsArticle_installation_folderSearchItems_found(model.ck))
					])) : A2(
				$rtfeldman$elm_css$Html$Styled$p,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[$author$project$TW$Utilities$mr_5]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						_Utils_ap(
							clusterSize,
							$author$project$Translations$uiPagesStepsArticle_installation_folderSearchHits(model.ck)))
					]))));
			var partialMatchView = ($elm$core$String$length(searchTerm) >= 3) ? _List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$h5,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$author$project$TW$Utilities$text_center]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							_Utils_ap(
								clusterSize,
								_Utils_ap(
									$author$project$Translations$uiPagesStepsArticle_installation_folderSearchSearch_results_for(model.ck),
									description)))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$table,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$author$project$TW$Utilities$w_full, $author$project$TW$Utilities$text_center, $author$project$TW$Utilities$my_4]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$thead,
							_List_Nil,
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$tr,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[$author$project$TW$Utilities$text_sm, $author$project$TW$Utilities$opacity_50]))
										]),
									_List_fromArray(
										[
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_Nil,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$text('RMA')
												])),
											A2(
											$rtfeldman$elm_css$Html$Styled$th,
											_List_Nil,
											_List_fromArray(
												[
													$author$project$Lib$articleHasNoSn(article) ? $rtfeldman$elm_css$Html$Styled$text('') : $rtfeldman$elm_css$Html$Styled$text('SN')
												])),
											A2($rtfeldman$elm_css$Html$Styled$th, _List_Nil, _List_Nil)
										]))
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$tbody,
							_List_Nil,
							A2(
								$elm$core$List$map,
								A6($author$project$Ui$Pages$Steps$ArticleInstallation$Search$articleRenderer, model, operationId, stationId, iteration, stepId, installationType),
								warehouseWithoutUsedArticles))
						]))
				]) : _List_Nil;
			var buttons = $author$project$Lib$articleHasNoSn(article) ? _List_fromArray(
				[
					A4(
					$author$project$Ui$UiComponents$Form$btnLinkClear,
					$author$project$Ui$Router$routeToPath(
						A5($author$project$Ui$Router$StationSelectArticleMulti, operationId, stationId, iteration, stepId, article.fl)),
					false,
					_List_Nil,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Translations$uiPagesStepsArticle_installation_folderSearchSelect_amount(model.ck))
						]))
				]) : ((searchTerm === '') ? _List_fromArray(
				[
					A3(
					$author$project$Ui$UiComponents$Form$btnClear,
					false,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Msg$FocusSearch('search-box'))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Translations$uiPagesStepsArticle_installation_folderSearchSearch(model.ck))
						]))
				]) : ((_Utils_eq(
				$elm$core$String$fromInt(article.bD),
				searchTerm) || _Utils_eq(article.ex, searchTerm)) ? _List_fromArray(
				[
					A3(
					$author$project$Ui$UiComponents$Form$btnGreen,
					false,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Msg$WarehouseMsg_(
								A6($author$project$Msg$StationChangeMaterial, operationId, article.bD, stationId, iteration, stepId, installationType)))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Translations$uiPagesStepsArticle_installation_folderSearchApply(model.ck))
						]))
				]) : _List_fromArray(
				[
					A3(
					$author$project$Ui$UiComponents$Form$btnClear,
					false,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Events$onClick(
							$author$project$Msg$FocusSearch('search-box'))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(
							$author$project$Translations$uiPagesStepsArticle_installation_folderSearchSearch(model.ck))
						]))
				])));
			return A2(
				$rtfeldman$elm_css$Html$Styled$li,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[$author$project$TW$Utilities$border_b, $author$project$TW$Utilities$border_t_0, $author$project$TW$Utilities$border_l_0, $author$project$TW$Utilities$border_r_0, $author$project$TW$Utilities$border_gray_200, $author$project$TW$Utilities$border_solid, $author$project$TW$Utilities$mb_4, $author$project$TW$Utilities$pb_4, $author$project$TW$Utilities$px_4]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[$author$project$TW$Utilities$flex]))
							]),
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[$author$project$TW$Utilities$flex_auto]))
									]),
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$h4,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil)
											]),
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(description)
											])),
										infos
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$div,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[$author$project$TW$Utilities$flex, $author$project$TW$Utilities$flex_shrink_0, $author$project$TW$Utilities$items_start]))
									]),
								buttons)
							])),
						A2($rtfeldman$elm_css$Html$Styled$div, _List_Nil, partialMatchView)
					]));
		} else {
			return A2(
				$rtfeldman$elm_css$Html$Styled$li,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[$author$project$TW$Utilities$m_4]))
					]),
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$text(
						A2($author$project$Translations$uiPagesStepsArticle_installation_folderSearchThere_is_no_anymore, model.ck, description))
					]));
		}
	});
var $author$project$TemporaryWarehouse$findUsedArticles = function (stations) {
	return $elm$core$List$concat(
		A2(
			$elm$core$List$map,
			function (station) {
				var data = $elm$core$List$concat(
					A2(
						$elm$core$List$filterMap,
						function (articleInstallationModel) {
							if ((!articleInstallationModel.$) && (!articleInstallationModel.a.$)) {
								var usedArticleIds = articleInstallationModel.a.a;
								return $elm$core$Maybe$Just(usedArticleIds);
							} else {
								return $elm$core$Maybe$Nothing;
							}
						},
						A2(
							$elm$core$List$map,
							$elm$core$Tuple$second,
							$elm$core$Dict$toList(station.A.ag))));
				return data;
			},
			stations));
};
var $author$project$TW$Utilities$my_10 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			$rtfeldman$elm_css$Css$marginTop(
			$rtfeldman$elm_css$Css$rem(2.5)),
			$rtfeldman$elm_css$Css$marginBottom(
			$rtfeldman$elm_css$Css$rem(2.5))
		]));
var $author$project$Ui$Pages$Steps$ArticleInstallation$Search$noSnView = F7(
	function (model, operationId, stationId, iteration, stepId, searchTerm, noSn) {
		var articleList = $elm$core$Dict$toList(noSn);
		return A2(
			$elm$core$List$map,
			function (_v1) {
				var collector = _v1.b;
				return A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$author$project$TW$Utilities$border_b, $author$project$TW$Utilities$border_t_0, $author$project$TW$Utilities$border_l_0, $author$project$TW$Utilities$border_r_0, $author$project$TW$Utilities$border_gray_200, $author$project$TW$Utilities$border_solid, $author$project$TW$Utilities$mb_4, $author$project$TW$Utilities$pb_4, $author$project$TW$Utilities$px_4]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[$author$project$TW$Utilities$flex_auto]))
								]),
							_List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$h4,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil)
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(collector.fl)
										]))
								])),
							A4(
							$author$project$Ui$UiComponents$Form$btnLinkClear,
							$author$project$Ui$Router$routeToPath(
								A9($author$project$Ui$Router$StationSelectArticleMultiTemp, operationId, stationId, iteration, stepId, collector.gU, collector.fV, collector.gX, collector.bq, collector.fl)),
							false,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Translations$uiPagesStepsArticle_installation_folderSearchSelect_amount(model.ck))
								]))
						]));
			},
			A2(
				$elm$core$List$filter,
				function (_v0) {
					var collector = _v0.b;
					return A2(
						$author$project$Lib$articleContainsSearchTerm,
						searchTerm,
						{fl: collector.fl, bD: -1, ex: ''});
				},
				articleList));
	});
var $author$project$Ui$Pages$Steps$ArticleInstallation$Search$putArticleUnderDescription = F2(
	function (article, cluster) {
		return A3(
			$elm$core$Dict$update,
			article.fl,
			function (articles) {
				if (!articles.$) {
					var articles_ = articles.a;
					return $elm$core$Maybe$Just(
						A2($elm$core$List$cons, article, articles_));
				} else {
					return $elm$core$Maybe$Just(
						_List_fromArray(
							[article]));
				}
			},
			cluster);
	});
var $author$project$Msg$UseTempArticle = function (a) {
	return {$: 1, a: a};
};
var $author$project$Ui$Pages$Steps$ArticleInstallation$Search$tempArticleRendererSn = F7(
	function (model, operationId, stationId, iteration, stepId, installationType, rma) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$tr,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil)
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$author$project$TW$Utilities$pr_4]))
						]),
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$text(rma.eu.ex)
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$td,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$author$project$TW$Utilities$py_1]))
						]),
					_List_fromArray(
						[
							A3(
							$author$project$Ui$UiComponents$Form$btnClear,
							false,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Events$onClick(
									A3(
										$author$project$Msg$StationMsg_,
										operationId,
										stationId,
										A3(
											$author$project$Msg$StationUpdateStepState,
											stepId,
											iteration,
											A2(
												$author$project$Msg$StepArticleInstallationMsg,
												installationType,
												$author$project$Msg$UseTempArticle(
													$author$project$Types$Steps$ArticleInstallation$Sn(rma))))))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									$author$project$Translations$uiPagesStepsArticle_installation_folderSearchApply(model.ck))
								]))
						]))
				]));
	});
var $author$project$Ui$Pages$Steps$ArticleInstallation$Search$snView = F9(
	function (model, usedArticles, operationId, stationId, iteration, stepId, searchTerm, installationType, sn) {
		var articleList = $elm$core$Dict$toList(sn);
		return A2(
			$elm$core$List$map,
			function (_v1) {
				var rmaList = _v1.b;
				var rmaList_ = A2(
					$elm$core$List$filter,
					function (rma) {
						return !A2(
							$elm$core$List$member,
							$author$project$Types$Steps$ArticleInstallation$Sn(rma),
							usedArticles);
					},
					rmaList);
				var description = function (m) {
					if (!m.$) {
						var head = m.a;
						return head.fl;
					} else {
						return '';
					}
				}(
					$elm$core$List$head(rmaList));
				return A2(
					$rtfeldman$elm_css$Html$Styled$li,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$author$project$TW$Utilities$border_b, $author$project$TW$Utilities$border_t_0, $author$project$TW$Utilities$border_l_0, $author$project$TW$Utilities$border_r_0, $author$project$TW$Utilities$border_gray_200, $author$project$TW$Utilities$border_solid, $author$project$TW$Utilities$mb_4, $author$project$TW$Utilities$pb_4, $author$project$TW$Utilities$px_4]))
						]),
					_List_fromArray(
						[
							A2(
							$rtfeldman$elm_css$Html$Styled$h3,
							_List_Nil,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(description)
								])),
							A2(
							$rtfeldman$elm_css$Html$Styled$ul,
							_List_Nil,
							A2(
								$elm$core$List$map,
								A6($author$project$Ui$Pages$Steps$ArticleInstallation$Search$tempArticleRendererSn, model, operationId, stationId, iteration, stepId, installationType),
								rmaList_))
						]));
			},
			A2(
				$elm$core$List$filter,
				function (_v0) {
					var rmaList = _v0.b;
					return A3(
						$elm$core$List$foldl,
						F2(
							function (rma, contained) {
								return contained || A2(
									$author$project$Lib$articleContainsSearchTerm,
									searchTerm,
									{fl: rma.fl, bD: -1, ex: rma.eu.ex});
							}),
						false,
						rmaList);
				},
				articleList));
	});
var $author$project$Translations$uiPagesStepsArticle_installation_folderSearchItmes_recorded_in_store = function (lang) {
	if (!lang) {
		return 'In der Filiale erfasste Artikel';
	} else {
		return 'Items recorded in store';
	}
};
var $author$project$Ui$Pages$Steps$ArticleInstallation$Search$warehouseSearchResults = F7(
	function (model, operation, warehouse, stationId, iteration, stepId, installationType) {
		var searchTerm = model.bj.e4;
		var operationId = $elm$core$String$fromInt(operation.bD);
		var usedArticleIds = function () {
			var _v5 = A2($elm$core$Dict$get, operationId, model.aA);
			if (!_v5.$) {
				var stationWrapper = _v5.a;
				return $author$project$TemporaryWarehouse$findUsedArticles(stationWrapper.aA);
			} else {
				return _List_Nil;
			}
		}();
		var usedTempArticles = function () {
			var _v4 = A2($elm$core$Dict$get, operationId, model.aA);
			if (!_v4.$) {
				var stationWrapper = _v4.a;
				return $author$project$TemporaryWarehouse$findUsedTempArticles(stationWrapper.aA);
			} else {
				return _List_Nil;
			}
		}();
		var filteredWarehouse = A2(
			$elm$core$List$filter,
			function (article) {
				if (!installationType) {
					return article.cX;
				} else {
					return (_Utils_eq(article.gZ, $author$project$Lib$Sync$Server) || article.cX) && _Utils_eq(article.fZ, $elm$core$Maybe$Nothing);
				}
			},
			A2(
				$elm$core$List$filter,
				$author$project$Lib$articleContainsSearchTerm(searchTerm),
				warehouse));
		var clusteredArticles = A3($elm$core$List$foldl, $author$project$Ui$Pages$Steps$ArticleInstallation$Search$putArticleUnderDescription, $elm$core$Dict$empty, filteredWarehouse);
		var _v0 = function () {
			var _v1 = A2($elm$core$Dict$get, operationId, model.aA);
			if (!_v1.$) {
				var stationWrapper = _v1.a;
				return $author$project$TemporaryWarehouse$clusterArticlesByType(stationWrapper.aA);
			} else {
				return _Utils_Tuple2($elm$core$Dict$empty, $elm$core$Dict$empty);
			}
		}();
		var tempArticlesSn = _v0.a;
		var tempArticlesNoSn = _v0.b;
		return A2(
			$rtfeldman$elm_css$Html$Styled$ul,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[$author$project$TW$Utilities$list_none, $author$project$TW$Utilities$m_0, $author$project$TW$Utilities$p_0, $author$project$TW$Utilities$pt_4]))
				]),
			function (resList) {
				return $elm$core$List$concat(
					_List_fromArray(
						[
							resList,
							function () {
							if (!installationType) {
								return _List_Nil;
							} else {
								return $elm$core$List$concat(
									_List_fromArray(
										[
											_List_fromArray(
											[
												A2(
												$rtfeldman$elm_css$Html$Styled$li,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css(
														_List_fromArray(
															[$author$project$TW$Utilities$my_10, $author$project$TW$Utilities$text_center]))
													]),
												_List_fromArray(
													[
														A2(
														$rtfeldman$elm_css$Html$Styled$h3,
														_List_Nil,
														_List_fromArray(
															[
																$rtfeldman$elm_css$Html$Styled$text(
																$author$project$Translations$uiPagesStepsArticle_installation_folderSearchItmes_recorded_in_store(model.ck))
															]))
													]))
											]),
											A7($author$project$Ui$Pages$Steps$ArticleInstallation$Search$noSnView, model, operationId, stationId, iteration, stepId, searchTerm, tempArticlesNoSn),
											A9($author$project$Ui$Pages$Steps$ArticleInstallation$Search$snView, model, usedTempArticles, operationId, stationId, iteration, stepId, searchTerm, installationType, tempArticlesSn)
										]));
							}
						}()
						]));
			}(
				A2(
					$elm$core$List$map,
					A8($author$project$Ui$Pages$Steps$ArticleInstallation$Search$clusterRenderer, model, usedArticleIds, operationId, searchTerm, stationId, iteration, stepId, installationType),
					$elm$core$Dict$toList(clusteredArticles))));
	});
var $author$project$Ui$Pages$Steps$ArticleInstallation$Search$page = F6(
	function (model, operationId, stationId, iteration, stepId, installationType) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[$author$project$TW$Utilities$font_sans]))
				]),
			_List_fromArray(
				[
					function () {
					var _v0 = A2($elm$core$Dict$get, operationId, model.ba);
					if (_v0.$ === 1) {
						return $rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Translations$uiPagesStepsArticle_installation_folderSearchCant_find_operation, model.ck, operationId));
					} else {
						var operation = _v0.a;
						var _v1 = model.eV;
						switch (_v1.$) {
							case 3:
								var warehouse = _v1.a;
								return A2(
									$rtfeldman$elm_css$Html$Styled$div,
									_List_Nil,
									_List_fromArray(
										[
											A5($author$project$Ui$Pages$Steps$ArticleInstallation$Search$warehouseSearchBox, model, operationId, stationId, iteration, warehouse),
											A7($author$project$Ui$Pages$Steps$ArticleInstallation$Search$warehouseSearchResults, model, operation, warehouse, stationId, iteration, stepId, installationType)
										]));
							case 2:
								return $rtfeldman$elm_css$Html$Styled$text(
									$author$project$Translations$uiPagesStepsArticle_installation_folderSearchCant_load_warehouse(model.ck));
							default:
								return $rtfeldman$elm_css$Html$Styled$text(
									$author$project$Translations$uiPagesStepsArticle_installation_folderSearchLoading(model.ck));
						}
					}
				}()
				]));
	});
var $author$project$Msg$StationChangeMultipleMaterials = F7(
	function (a, b, c, d, e, f, g) {
		return {$: 7, a: a, b: b, c: c, d: d, e: e, f: f, g: g};
	});
var $author$project$Msg$WarehouseUpdateTakeArticlesFromWarehouseCount = function (a) {
	return {$: 1, a: a};
};
var $rtfeldman$elm_css$Html$Styled$label = $rtfeldman$elm_css$Html$Styled$node('label');
var $author$project$Ui$UiComponents$Form$label = F2(
	function (attributes, children) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$label,
			A2($elm$core$List$cons, $author$project$Ui$UiComponents$Form$labelStyle, attributes),
			children);
	});
var $author$project$TW$Utilities$mb_0 = $rtfeldman$elm_css$Css$marginBottom(
	$rtfeldman$elm_css$Css$px(0));
var $author$project$TW$Utilities$mb_16 = $rtfeldman$elm_css$Css$marginBottom(
	$rtfeldman$elm_css$Css$rem(4));
var $author$project$TW$Utilities$mr_3 = $rtfeldman$elm_css$Css$marginRight(
	$rtfeldman$elm_css$Css$rem(0.75));
var $author$project$TW$Utilities$mt_5 = $rtfeldman$elm_css$Css$marginTop(
	$rtfeldman$elm_css$Css$rem(1.25));
var $rtfeldman$elm_css$Html$Styled$strong = $rtfeldman$elm_css$Html$Styled$node('strong');
var $author$project$Translations$uiPagesStepsArticle_installation_folderSelect_multipleItems_still_in_stock = F2(
	function (lang, str0) {
		if (!lang) {
			return 'Noch ' + (str0 + ' Artikel auf Lager.');
		} else {
			return '' + (str0 + ' item(s) still in stock.');
		}
	});
var $author$project$Translations$uiPagesStepsArticle_installation_folderSelect_multipleUse = function (lang) {
	if (!lang) {
		return ' verwenden';
	} else {
		return ' use';
	}
};
var $author$project$Translations$uiPagesStepsArticle_installation_folderSelect_multipleUse_amount = function (lang) {
	if (!lang) {
		return 'Anzahl verwenden:';
	} else {
		return 'Use amount:';
	}
};
var $author$project$Translations$uiPagesStepsArticle_installation_folderSelect_multipleYou_selected_more_items_than_you_have_in_stock = function (lang) {
	if (!lang) {
		return 'Sie haben mehr Artikel ausgewählt, als Sie noch im Lager haben.';
	} else {
		return 'You selected more items than you have in stock.';
	}
};
var $author$project$Ui$Pages$Steps$ArticleInstallation$SelectMultiple$multiArticleView = F9(
	function (model, count, articles, operationId, stationId, stepId, iteration, description, installationType) {
		var selectableArticles = $elm$core$List$length(
			A4($author$project$Actions$Warehouse$getUnusedArticleIds, description, model.aA, $elm$core$Maybe$Nothing, articles));
		var maybeCount = $elm$core$String$toInt(count);
		var takeThisManyArticles = A2($elm$core$Maybe$withDefault, 0, maybeCount);
		var isDisabled = _Utils_eq(maybeCount, $elm$core$Maybe$Nothing) || ((_Utils_cmp(selectableArticles, takeThisManyArticles) < 0) || (!takeThisManyArticles));
		return A2(
			$rtfeldman$elm_css$Html$Styled$main_,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil)
				]),
			_List_fromArray(
				[
					A2(
					$author$project$Ui$Bentomax$toolbar,
					_List_Nil,
					_List_fromArray(
						[
							A2(
							$author$project$Ui$UiComponents$Link$backLink,
							$author$project$Ui$Router$routeToPath(
								A4($author$project$Ui$Router$StationSelectArticle, operationId, stationId, iteration, stepId)),
							_List_Nil),
							A2(
							$rtfeldman$elm_css$Html$Styled$strong,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[$author$project$TW$Utilities$mb_0, $author$project$TW$Utilities$w_full, $author$project$TW$Utilities$text_right, $author$project$TW$Utilities$mr_3, $author$project$TW$Utilities$block]))
								]),
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text(
									_Utils_ap(
										description,
										$author$project$Translations$uiPagesStepsArticle_installation_folderSelect_multipleUse(model.ck)))
								]))
						])),
					A2(
					$rtfeldman$elm_css$Html$Styled$section,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$author$project$TW$Utilities$mt_5, $author$project$TW$Utilities$mb_16, $author$project$TW$Utilities$p_4]))
						]),
					_Utils_ap(
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$label,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$Attributes$css(
										_List_fromArray(
											[$author$project$TW$Utilities$flex, $author$project$TW$Utilities$flex_col]))
									]),
								_List_fromArray(
									[
										A2(
										$author$project$Ui$UiComponents$Form$label,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$Translations$uiPagesStepsArticle_installation_folderSelect_multipleUse_amount(model.ck))
											])),
										A2(
										$author$project$Ui$UiComponents$Form$input,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$Attributes$placeholder('0'),
												$rtfeldman$elm_css$Html$Styled$Attributes$type_('number'),
												$rtfeldman$elm_css$Html$Styled$Attributes$value(count),
												$rtfeldman$elm_css$Html$Styled$Events$onInput(
												A2($elm$core$Basics$composeL, $author$project$Msg$WarehouseMsg_, $author$project$Msg$WarehouseUpdateTakeArticlesFromWarehouseCount))
											]),
										_List_Nil),
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$Translations$uiPagesStepsArticle_installation_folderSelect_multipleItems_still_in_stock,
											model.ck,
											$elm$core$String$fromInt(selectableArticles)))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text('')
									]))
							]),
						_Utils_ap(
							(_Utils_cmp(selectableArticles, takeThisManyArticles) < 0) ? _List_fromArray(
								[
									A2(
									$rtfeldman$elm_css$Html$Styled$p,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[$author$project$TW$Utilities$text_red_500]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Translations$uiPagesStepsArticle_installation_folderSelect_multipleYou_selected_more_items_than_you_have_in_stock(model.ck))
										]))
								]) : _List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$text('')
								]),
							_List_fromArray(
								[
									A3(
									$author$project$Ui$UiComponents$Form$btn,
									isDisabled,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Events$onClick(
											$author$project$Msg$WarehouseMsg_(
												A7($author$project$Msg$StationChangeMultipleMaterials, operationId, stationId, iteration, stepId, description, takeThisManyArticles, installationType))),
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[$author$project$TW$Utilities$w_full]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text('Los')
										]))
								]))))
				]));
	});
var $author$project$Translations$uiPagesStepsArticle_installation_folderSelect_multipleArticle_description_not_found = function (lang) {
	if (!lang) {
		return 'Artikelbeschreibung nicht gefunden...';
	} else {
		return 'Article description nit found';
	}
};
var $author$project$Translations$uiPagesStepsArticle_installation_folderSelect_multipleCant_find_operation = F2(
	function (lang, str0) {
		if (!lang) {
			return 'Konnte die Operation ' + (str0 + ' nicht finden.');
		} else {
			return 'Can\'t find operation ' + (str0 + '.');
		}
	});
var $author$project$Translations$uiPagesStepsArticle_installation_folderSelect_multipleCant_load_warehouse = function (lang) {
	if (!lang) {
		return 'Konnte das Warenlager nicht laden...';
	} else {
		return 'Can\'t load the warehouse...';
	}
};
var $author$project$Translations$uiPagesStepsArticle_installation_folderSelect_multipleLoading = function (lang) {
	if (!lang) {
		return '... laden ...';
	} else {
		return '... loading ...';
	}
};
var $author$project$Ui$Pages$Steps$ArticleInstallation$SelectMultiple$page = F7(
	function (model, operationId, stationId, iteration, stepId, maybeDescription, installationType) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[$author$project$TW$Utilities$font_sans]))
				]),
			_List_fromArray(
				[
					function () {
					var _v0 = A2($elm$core$Dict$get, operationId, model.ba);
					if (_v0.$ === 1) {
						return $rtfeldman$elm_css$Html$Styled$text(
							A2($author$project$Translations$uiPagesStepsArticle_installation_folderSelect_multipleCant_find_operation, model.ck, operationId));
					} else {
						var _v1 = model.eV;
						switch (_v1.$) {
							case 3:
								var articles = _v1.a;
								if (!maybeDescription.$) {
									var description = maybeDescription.a;
									return A9($author$project$Ui$Pages$Steps$ArticleInstallation$SelectMultiple$multiArticleView, model, model.bj.g0, articles, operationId, stationId, stepId, iteration, description, installationType);
								} else {
									return $rtfeldman$elm_css$Html$Styled$text(
										$author$project$Translations$uiPagesStepsArticle_installation_folderSelect_multipleArticle_description_not_found(model.ck));
								}
							case 2:
								return $rtfeldman$elm_css$Html$Styled$text(
									$author$project$Translations$uiPagesStepsArticle_installation_folderSelect_multipleCant_load_warehouse(model.ck));
							default:
								return $rtfeldman$elm_css$Html$Styled$text(
									$author$project$Translations$uiPagesStepsArticle_installation_folderSelect_multipleLoading(model.ck));
						}
					}
				}()
				]));
	});
var $author$project$Translations$uiPagesStepsArticle_installation_folderSelect_multiple_tempGo = function (lang) {
	if (!lang) {
		return 'Los';
	} else {
		return 'Go';
	}
};
var $author$project$Translations$uiPagesStepsArticle_installation_folderSelect_multiple_tempItmes_still_in_stock = F2(
	function (lang, str0) {
		if (!lang) {
			return 'Noch ' + (str0 + ' Artikel auf Lager.');
		} else {
			return '' + (str0 + ' items still in stock.');
		}
	});
var $author$project$Translations$uiPagesStepsArticle_installation_folderSelect_multiple_tempUse = function (lang) {
	if (!lang) {
		return ' verwenden';
	} else {
		return ' use';
	}
};
var $author$project$Translations$uiPagesStepsArticle_installation_folderSelect_multiple_tempUse_amount = function (lang) {
	if (!lang) {
		return 'Anzahl verwenden:';
	} else {
		return 'Use amount:';
	}
};
var $author$project$Translations$uiPagesStepsArticle_installation_folderSelect_multiple_tempYou_selected_more_items_than_you_have_in_stock = function (lang) {
	if (!lang) {
		return 'Sie haben mehr Artikel ausgewählt, als Sie noch im Lager haben.';
	} else {
		return 'You selected more items than you have in stock.';
	}
};
var $author$project$Ui$Pages$Steps$ArticleInstallation$SelectMultipleTemp$multiArticleView = function (model) {
	return function (count) {
		return function (operationId) {
			return function (stationId) {
				return function (iteration) {
					return function (stepId) {
						return function (rma) {
							return function (usedArticleCount) {
								return function (storedArticleCount) {
									return function (installationType) {
										var selectableArticles = storedArticleCount - usedArticleCount;
										var maybeCount = $elm$core$String$toInt(count);
										var takeThisManyArticles = A2($elm$core$Maybe$withDefault, 0, maybeCount);
										var isDisabled = _Utils_eq(maybeCount, $elm$core$Maybe$Nothing) || ((_Utils_cmp(selectableArticles, takeThisManyArticles) < 0) || (!takeThisManyArticles));
										return A2(
											$rtfeldman$elm_css$Html$Styled$main_,
											_List_fromArray(
												[
													$rtfeldman$elm_css$Html$Styled$Attributes$css(_List_Nil)
												]),
											_List_fromArray(
												[
													A2(
													$author$project$Ui$Bentomax$toolbar,
													_List_Nil,
													_List_fromArray(
														[
															A2(
															$author$project$Ui$UiComponents$Link$backLink,
															$author$project$Ui$Router$routeToPath(
																A4($author$project$Ui$Router$StationSelectArticle, operationId, rma.gU, rma.fV, rma.gX)),
															_List_Nil),
															A2(
															$rtfeldman$elm_css$Html$Styled$strong,
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$Attributes$css(
																	_List_fromArray(
																		[$author$project$TW$Utilities$mb_0, $author$project$TW$Utilities$w_full, $author$project$TW$Utilities$text_right, $author$project$TW$Utilities$mr_3, $author$project$TW$Utilities$block]))
																]),
															_List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text(
																	_Utils_ap(
																		rma.fl,
																		$author$project$Translations$uiPagesStepsArticle_installation_folderSelect_multiple_tempUse(model.ck)))
																]))
														])),
													A2(
													$rtfeldman$elm_css$Html$Styled$section,
													_List_fromArray(
														[
															$rtfeldman$elm_css$Html$Styled$Attributes$css(
															_List_fromArray(
																[$author$project$TW$Utilities$mt_5, $author$project$TW$Utilities$mb_16, $author$project$TW$Utilities$p_4]))
														]),
													_Utils_ap(
														_List_fromArray(
															[
																A2(
																$rtfeldman$elm_css$Html$Styled$label,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$Attributes$css(
																		_List_fromArray(
																			[$author$project$TW$Utilities$flex, $author$project$TW$Utilities$flex_col]))
																	]),
																_List_fromArray(
																	[
																		A2(
																		$author$project$Ui$UiComponents$Form$label,
																		_List_Nil,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$text(
																				$author$project$Translations$uiPagesStepsArticle_installation_folderSelect_multiple_tempUse_amount(model.ck))
																			])),
																		A2(
																		$author$project$Ui$UiComponents$Form$input,
																		_List_fromArray(
																			[
																				$rtfeldman$elm_css$Html$Styled$Attributes$placeholder('0'),
																				$rtfeldman$elm_css$Html$Styled$Attributes$type_('number'),
																				$rtfeldman$elm_css$Html$Styled$Attributes$value(count),
																				$rtfeldman$elm_css$Html$Styled$Events$onInput(
																				A2($elm$core$Basics$composeL, $author$project$Msg$WarehouseMsg_, $author$project$Msg$WarehouseUpdateTakeArticlesFromWarehouseCount))
																			]),
																		_List_Nil),
																		$rtfeldman$elm_css$Html$Styled$text(
																		A2(
																			$author$project$Translations$uiPagesStepsArticle_installation_folderSelect_multiple_tempItmes_still_in_stock,
																			model.ck,
																			$elm$core$String$fromInt(selectableArticles)))
																	])),
																A2(
																$rtfeldman$elm_css$Html$Styled$p,
																_List_Nil,
																_List_fromArray(
																	[
																		$rtfeldman$elm_css$Html$Styled$text('')
																	]))
															]),
														_Utils_ap(
															(_Utils_cmp(selectableArticles, takeThisManyArticles) < 0) ? _List_fromArray(
																[
																	A2(
																	$rtfeldman$elm_css$Html$Styled$p,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$css(
																			_List_fromArray(
																				[$author$project$TW$Utilities$text_red_500]))
																		]),
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$text(
																			$author$project$Translations$uiPagesStepsArticle_installation_folderSelect_multiple_tempYou_selected_more_items_than_you_have_in_stock(model.ck))
																		]))
																]) : _List_fromArray(
																[
																	$rtfeldman$elm_css$Html$Styled$text('')
																]),
															_List_fromArray(
																[
																	A3(
																	$author$project$Ui$UiComponents$Form$btn,
																	isDisabled,
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$Attributes$css(
																			_List_fromArray(
																				[$author$project$TW$Utilities$w_full])),
																			$rtfeldman$elm_css$Html$Styled$Events$onClick(
																			A3(
																				$author$project$Msg$StationMsg_,
																				operationId,
																				stationId,
																				A3(
																					$author$project$Msg$StationUpdateStepState,
																					stepId,
																					iteration,
																					A2(
																						$author$project$Msg$StepArticleInstallationMsg,
																						installationType,
																						$author$project$Msg$UseTempArticle(
																							$author$project$Types$Steps$ArticleInstallation$NoSn(
																								_Utils_update(
																									rma,
																									{Q: rma.Q + takeThisManyArticles})))))))
																		]),
																	_List_fromArray(
																		[
																			$rtfeldman$elm_css$Html$Styled$text(
																			$author$project$Translations$uiPagesStepsArticle_installation_folderSelect_multiple_tempGo(model.ck))
																		]))
																]))))
												]));
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Translations$uiPagesStepsArticle_installation_folderSelect_multiple_tempCant_find_operation = F2(
	function (lang, str0) {
		if (!lang) {
			return 'Konnte die Operation ' + (str0 + ' nicht finden.');
		} else {
			return 'Can\'t find operation ' + (str0 + '.');
		}
	});
var $author$project$Translations$uiPagesStepsArticle_installation_folderSelect_multiple_tempCant_find_station = function (lang) {
	if (!lang) {
		return 'Konnte die gewünschte Station nicht finden.';
	} else {
		return 'Can\'t find station';
	}
};
var $author$project$Translations$uiPagesStepsArticle_installation_folderSelect_multiple_tempCant_find_station_for_operation_id = function (lang) {
	if (!lang) {
		return 'Konnte die gewünschte Station nicht finden. (Keine Stationen für Operations-ID)';
	} else {
		return 'Can\'t find station. (no station for operations-id)';
	}
};
var $author$project$Ui$Pages$Steps$ArticleInstallation$SelectMultipleTemp$page = function (model) {
	return function (operationId) {
		return function (stationId) {
			return function (iteration) {
				return function (stepId) {
					return function (targetStationId) {
						return function (targetIteration) {
							return function (targetStepId) {
								return function (templateId) {
									return function (maybeDescription) {
										return function (installationType) {
											return A2(
												$rtfeldman$elm_css$Html$Styled$div,
												_List_fromArray(
													[
														$rtfeldman$elm_css$Html$Styled$Attributes$css(
														_List_fromArray(
															[$author$project$TW$Utilities$font_sans]))
													]),
												_List_fromArray(
													[
														function () {
														var _v0 = A2($elm$core$Dict$get, operationId, model.ba);
														if (_v0.$ === 1) {
															return $rtfeldman$elm_css$Html$Styled$text(
																A2($author$project$Translations$uiPagesStepsArticle_installation_folderSelect_multiple_tempCant_find_operation, model.ck, operationId));
														} else {
															var operation = _v0.a;
															var _v1 = A2($elm$core$Dict$get, operationId, model.aA);
															if (!_v1.$) {
																var stationWrapper = _v1.a;
																var usedArticleCount = function (article) {
																	if (!article.$) {
																		var article_ = article.a;
																		return article_.Q;
																	} else {
																		return 0;
																	}
																}(
																	$elm$core$List$head(
																		A2(
																			$elm$core$List$filter,
																			A2(
																				$elm$core$Basics$composeR,
																				function ($) {
																					return $.bq;
																				},
																				$elm$core$Basics$eq(templateId)),
																			A2(
																				$elm$core$List$filterMap,
																				function (articleId) {
																					switch (articleId.$) {
																						case 0:
																							var a = articleId.a;
																							return $elm$core$Maybe$Just(a);
																						case 3:
																							var a = articleId.a;
																							return $elm$core$Maybe$Just(a);
																						default:
																							return $elm$core$Maybe$Nothing;
																					}
																				},
																				$author$project$TemporaryWarehouse$findUsedTempArticles(stationWrapper.aA)))));
																var storedArticleCount = function (article) {
																	if (!article.$) {
																		var article_ = article.a;
																		return article_.Q;
																	} else {
																		return 0;
																	}
																}(
																	$elm$core$List$head(
																		A2(
																			$elm$core$List$filter,
																			A2(
																				$elm$core$Basics$composeR,
																				function ($) {
																					return $.bq;
																				},
																				$elm$core$Basics$eq(templateId)),
																			A2(
																				$elm$core$List$map,
																				$elm$core$Tuple$second,
																				$elm$core$Dict$toList(
																					$author$project$TemporaryWarehouse$clusterArticlesByType(stationWrapper.aA).b)))));
																var maybeStation = $elm$core$List$head(
																	A2(
																		$elm$core$List$filter,
																		function (station) {
																			return _Utils_eq(station.bD, stationId);
																		},
																		stationWrapper.aA));
																if (!maybeStation.$) {
																	var station = maybeStation.a;
																	var maybeStep = A2(
																		$elm$core$Dict$get,
																		_Utils_ap(
																			stepId,
																			$elm$core$String$fromInt(iteration)),
																		station.A.ag);
																	var rma = function () {
																		if ((((!maybeStep.$) && (!maybeStep.a.$)) && (maybeStep.a.a.$ === 1)) && (!maybeStep.a.a.a.$)) {
																			var data = maybeStep.a.a.a.a;
																			return data;
																		} else {
																			return {
																				Q: 0,
																				bq: templateId,
																				fl: A2($elm$core$Maybe$withDefault, '', maybeDescription),
																				fV: targetIteration,
																				gU: targetStationId,
																				gX: targetStepId
																			};
																		}
																	}();
																	return $author$project$Ui$Pages$Steps$ArticleInstallation$SelectMultipleTemp$multiArticleView(model)(model.bj.g0)(operationId)(stationId)(iteration)(stepId)(rma)(usedArticleCount)(storedArticleCount)(installationType);
																} else {
																	return $rtfeldman$elm_css$Html$Styled$text(
																		$author$project$Translations$uiPagesStepsArticle_installation_folderSelect_multiple_tempCant_find_station(model.ck));
																}
															} else {
																return $rtfeldman$elm_css$Html$Styled$text(
																	$author$project$Translations$uiPagesStepsArticle_installation_folderSelect_multiple_tempCant_find_station_for_operation_id(model.ck));
															}
														}
													}()
													]));
										};
									};
								};
							};
						};
					};
				};
			};
		};
	};
};
var $author$project$Translations$uiPagesStepsSignatureCant_find_operation = F2(
	function (lang, str0) {
		if (!lang) {
			return 'Konnte die Operation ' + (str0 + ' nicht finden. Deswegen können keine Stationen angezeigt werden.');
		} else {
			return 'Can\'t find operation ' + (str0 + '. Therefore no stations can be displayed.');
		}
	});
var $author$project$Translations$uiPagesStepsSignatureCant_find_station = function (lang) {
	if (!lang) {
		return 'Konnte die Station nicht finden...';
	} else {
		return 'Can\'t find station...';
	}
};
var $author$project$Translations$uiPagesStepsSignatureReady = function (lang) {
	if (!lang) {
		return 'Fertig';
	} else {
		return 'ready';
	}
};
var $author$project$Translations$uiPagesStepsSignatureSign = function (lang) {
	if (!lang) {
		return 'Unterschrift machen';
	} else {
		return 'Sign';
	}
};
var $author$project$TW$Utilities$border_gray_800 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--border-opacity', '1'),
			$rtfeldman$elm_css$Css$borderColor(
			$rtfeldman$elm_css$Css$hex('#2d3748')),
			A2($rtfeldman$elm_css$Css$property, 'border-color', 'rgba(45, 55, 72, var(--border-opacity))')
		]));
var $author$project$TW$Utilities$h_full = $rtfeldman$elm_css$Css$height(
	$rtfeldman$elm_css$Css$pct(100));
var $author$project$Msg$SignatureChanged = $elm$core$Basics$identity;
var $author$project$Msg$StepSignatureMsg = function (a) {
	return {$: 8, a: a};
};
var $author$project$Ui$UiComponents$SignaturePad$customMsg = F4(
	function (operationId, stationId, stepId, iteration) {
		return A2(
			$elm$core$Basics$composeR,
			$elm$core$Basics$identity,
			A2(
				$elm$core$Basics$composeR,
				$author$project$Msg$StepSignatureMsg,
				A2(
					$elm$core$Basics$composeR,
					A2($author$project$Msg$StationUpdateStepState, stepId, iteration),
					A2($author$project$Msg$StationMsg_, operationId, stationId))));
	});
var $author$project$Ui$UiComponents$SignaturePad$signatureChangeDecoder = A2(
	$elm$json$Json$Decode$at,
	_List_fromArray(
		['detail', 'signature']),
	$elm$json$Json$Decode$string);
var $author$project$Ui$UiComponents$SignaturePad$onSignatureChange = function (msg) {
	return A2(
		$rtfeldman$elm_css$Html$Styled$Events$on,
		'signature-change',
		A2($elm$json$Json$Decode$map, msg, $author$project$Ui$UiComponents$SignaturePad$signatureChangeDecoder));
};
var $author$project$Ui$UiComponents$SignaturePad$signaturePad = F4(
	function (operationId, stationId, stepId, iteration) {
		return A3(
			$rtfeldman$elm_css$Html$Styled$node,
			'signature-pad',
			_List_fromArray(
				[
					$author$project$Ui$UiComponents$SignaturePad$onSignatureChange(
					A4($author$project$Ui$UiComponents$SignaturePad$customMsg, operationId, stationId, stepId, iteration))
				]),
			_List_Nil);
	});
var $author$project$Ui$UiComponents$SignaturePad$view = F4(
	function (operationId, stationId, stepId, iteration) {
		return A2(
			$rtfeldman$elm_css$Html$Styled$div,
			_List_fromArray(
				[
					$rtfeldman$elm_css$Html$Styled$Attributes$css(
					_List_fromArray(
						[$author$project$TW$Utilities$px_2])),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'width', '100%'),
					A2($rtfeldman$elm_css$Html$Styled$Attributes$style, 'height', '200px')
				]),
			_List_fromArray(
				[
					A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$author$project$TW$Utilities$h_full, $author$project$TW$Utilities$w_full, $author$project$TW$Utilities$border, $author$project$TW$Utilities$bg_white, $author$project$TW$Utilities$border_solid, $author$project$TW$Utilities$border_gray_800]))
						]),
					_List_fromArray(
						[
							A4($author$project$Ui$UiComponents$SignaturePad$signaturePad, operationId, stationId, stepId, iteration)
						]))
				]));
	});
var $author$project$Ui$Pages$Steps$Signature$page = F5(
	function (model, operationId, stationId, iteration, stepId) {
		var _v0 = A2($elm$core$Dict$get, operationId, model.ba);
		if (_v0.$ === 1) {
			return $rtfeldman$elm_css$Html$Styled$text(
				A2($author$project$Translations$uiPagesStepsSignatureCant_find_operation, model.ck, operationId));
		} else {
			var operation = _v0.a;
			var stationWrapper = A2(
				$elm$core$Maybe$withDefault,
				$author$project$Types$Station$init,
				A2($elm$core$Dict$get, operationId, model.aA));
			var _v1 = $elm$core$List$head(
				A2(
					$elm$core$List$filter,
					A2(
						$elm$core$Basics$composeR,
						function ($) {
							return $.bD;
						},
						$elm$core$Basics$eq(stationId)),
					stationWrapper.aA));
			if (!_v1.$) {
				return A2(
					$rtfeldman$elm_css$Html$Styled$div,
					_List_fromArray(
						[
							$rtfeldman$elm_css$Html$Styled$Attributes$css(
							_List_fromArray(
								[$author$project$TW$Utilities$font_sans, $author$project$TW$Utilities$pt_16]))
						]),
					_List_fromArray(
						[
							A2(
							$author$project$Ui$Bentomax$toolbar,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[$author$project$TW$Utilities$fixed, $author$project$TW$Utilities$top_0, $author$project$TW$Utilities$left_0]))
								]),
							_List_fromArray(
								[
									A2(
									$author$project$Ui$UiComponents$Link$backLink,
									$author$project$Ui$Router$routeToPath(
										A3($author$project$Ui$Router$StationShow, operationId, stationId, iteration)),
									_List_Nil),
									A2(
									$rtfeldman$elm_css$Html$Styled$h1,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[$author$project$TW$Utilities$text_lg]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Translations$uiPagesStepsSignatureSign(model.ck))
										]))
								])),
							A4($author$project$Ui$UiComponents$SignaturePad$view, operationId, stationId, stepId, iteration),
							A2(
							$rtfeldman$elm_css$Html$Styled$div,
							_List_fromArray(
								[
									$rtfeldman$elm_css$Html$Styled$Attributes$css(
									_List_fromArray(
										[$author$project$TW$Utilities$p_2]))
								]),
							_List_fromArray(
								[
									A4(
									$author$project$Ui$UiComponents$Form$btnLink,
									$author$project$Ui$Router$routeToPath(
										A3($author$project$Ui$Router$StationShow, operationId, stationId, iteration)),
									false,
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$Attributes$css(
											_List_fromArray(
												[$author$project$TW$Utilities$w_full, $author$project$TW$Utilities$mb_2]))
										]),
									_List_fromArray(
										[
											$rtfeldman$elm_css$Html$Styled$text(
											$author$project$Translations$uiPagesStepsSignatureReady(model.ck))
										]))
								]))
						]));
			} else {
				return $rtfeldman$elm_css$Html$Styled$text(
					$author$project$Translations$uiPagesStepsSignatureCant_find_station(model.ck));
			}
		}
	});
var $author$project$TW$Utilities$rounded_lg = $rtfeldman$elm_css$Css$borderRadius(
	$rtfeldman$elm_css$Css$rem(0.5));
var $author$project$TW$Utilities$text_red_900 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--text-opacity', '1'),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('#742a2a')),
			A2($rtfeldman$elm_css$Css$property, 'color', 'rgba(116, 42, 42, var(--text-opacity))')
		]));
var $author$project$TW$Utilities$text_yellow_900 = $rtfeldman$elm_css$Css$batch(
	_List_fromArray(
		[
			A2($rtfeldman$elm_css$Css$property, '--text-opacity', '1'),
			$rtfeldman$elm_css$Css$color(
			$rtfeldman$elm_css$Css$hex('#744210')),
			A2($rtfeldman$elm_css$Css$property, 'color', 'rgba(116, 66, 16, var(--text-opacity))')
		]));
var $author$project$Translations$uiViewData_is_transmitted = function (lang) {
	if (!lang) {
		return 'Die Daten werden übermittelt';
	} else {
		return 'Data is transmitted';
	}
};
var $author$project$Translations$uiViewData_was_transmitted = function (lang) {
	if (!lang) {
		return 'Die Daten wurden übermittelt. Wenn sie noch mal geschickt werden sollen, bitte neu laden...';
	} else {
		return 'Data was transmitted. If you want to transmit them again please reload...';
	}
};
var $author$project$Translations$uiViewError = function (lang) {
	if (!lang) {
		return 'Fehler!';
	} else {
		return 'Error!';
	}
};
var $author$project$Translations$uiViewNo_id = function (lang) {
	if (!lang) {
		return 'KEINE ID';
	} else {
		return 'NO ID';
	}
};
var $author$project$Translations$uiViewNo_stations_found = function (lang) {
	if (!lang) {
		return 'Keine Stationen gefunden...';
	} else {
		return 'No Stations found...';
	}
};
var $author$project$Translations$uiViewSend_current_state = function (lang) {
	if (!lang) {
		return 'Aktuellen Zustand schicken (bitte nur nach Aufforderung)';
	} else {
		return 'Send current state (please only upon request)';
	}
};
var $author$project$Translations$uiViewStations_still_loading = function (lang) {
	if (!lang) {
		return 'Stationen Laden noch...';
	} else {
		return 'Stations still loading...';
	}
};
var $author$project$Translations$uiViewTry_again_later = function (lang) {
	if (!lang) {
		return 'Bitte später erneut versuchen (ggf. einmal die Seite neu Laden).';
	} else {
		return 'Please try again later (maybe reload the page).';
	}
};
var $author$project$Ui$View$view = function (model) {
	var _v0 = model.bj.c7;
	switch (_v0.$) {
		case 1:
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[$author$project$TW$Utilities$w_full, $author$project$TW$Utilities$flex, $author$project$TW$Utilities$items_center, $author$project$TW$Utilities$justify_center, $author$project$TW$Utilities$my_4]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[$author$project$TW$Utilities$inline_block, $author$project$TW$Utilities$p_4, $author$project$TW$Utilities$bg_red_200, $author$project$TW$Utilities$text_red_900, $author$project$TW$Utilities$font_bold, $author$project$TW$Utilities$rounded_lg]))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$Translations$uiViewNo_stations_found(model.ck))
							]))
					]));
		case 0:
			return A2(
				$rtfeldman$elm_css$Html$Styled$div,
				_List_fromArray(
					[
						$rtfeldman$elm_css$Html$Styled$Attributes$css(
						_List_fromArray(
							[$author$project$TW$Utilities$w_full, $author$project$TW$Utilities$flex, $author$project$TW$Utilities$items_center, $author$project$TW$Utilities$justify_center, $author$project$TW$Utilities$my_4]))
					]),
				_List_fromArray(
					[
						A2(
						$rtfeldman$elm_css$Html$Styled$span,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Attributes$css(
								_List_fromArray(
									[$author$project$TW$Utilities$inline_block, $author$project$TW$Utilities$p_4, $author$project$TW$Utilities$bg_yellow_200, $author$project$TW$Utilities$text_yellow_900, $author$project$TW$Utilities$font_bold, $author$project$TW$Utilities$rounded_lg]))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$Translations$uiViewStations_still_loading(model.ck))
							]))
					]));
		case 11:
			var _v1 = model.bj.fg;
			switch (_v1.$) {
				case 1:
					return A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$Translations$uiViewData_is_transmitted(model.ck))
							]));
				case 3:
					return A2(
						$rtfeldman$elm_css$Html$Styled$p,
						_List_Nil,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$Translations$uiViewData_was_transmitted(model.ck))
							]));
				case 0:
					return A3(
						$author$project$Ui$UiComponents$Form$btn,
						false,
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$Events$onClick(
								$author$project$Msg$ApiMsg_($author$project$Msg$ApiSendErrorReport))
							]),
						_List_fromArray(
							[
								$rtfeldman$elm_css$Html$Styled$text(
								$author$project$Translations$uiViewSend_current_state(model.ck))
							]));
				default:
					var err = _v1.a;
					return A2(
						$rtfeldman$elm_css$Html$Styled$div,
						_List_Nil,
						_List_fromArray(
							[
								A2(
								$rtfeldman$elm_css$Html$Styled$h4,
								_List_Nil,
								_List_fromArray(
									[
										A2(
										$rtfeldman$elm_css$Html$Styled$strong,
										_List_Nil,
										_List_fromArray(
											[
												$rtfeldman$elm_css$Html$Styled$text(
												$author$project$Translations$uiViewError(model.ck))
											]))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										$author$project$Translations$uiViewTry_again_later(model.ck))
									])),
								A2(
								$rtfeldman$elm_css$Html$Styled$p,
								_List_Nil,
								_List_fromArray(
									[
										$rtfeldman$elm_css$Html$Styled$text(
										A2(
											$author$project$Lib$Http$Extra$errorMessage,
											err,
											$author$project$Translations$uiViewNo_id(model.ck)))
									]))
							]));
			}
		case 2:
			var id = _v0.a;
			return A2($author$project$Ui$Pages$OperationDetail$page, id, model);
		case 3:
			var operationId = _v0.a;
			return $author$project$Ui$View$elevator(
				A2($author$project$Ui$Pages$Station$Create$page, operationId, model));
		case 4:
			var operationId = _v0.a;
			var stationId = _v0.b;
			var iteration = _v0.c;
			return $author$project$Ui$View$elevator(
				A4($author$project$Ui$Pages$Station$Show$page, operationId, stationId, iteration, model));
		case 5:
			var operationId = _v0.a;
			var stationId = _v0.b;
			var iteration = _v0.c;
			var stepId = _v0.d;
			return $author$project$Ui$View$elevator(
				A5($author$project$Ui$Pages$Steps$Signature$page, model, operationId, stationId, iteration, stepId));
		case 6:
			var operationId = _v0.a;
			var stationId = _v0.b;
			var iteration = _v0.c;
			var stepId = _v0.d;
			return $author$project$Ui$View$elevator(
				A6($author$project$Ui$Pages$Steps$ArticleInstallation$Search$page, model, operationId, stationId, iteration, stepId, 0));
		case 7:
			var operationId = _v0.a;
			var stationId = _v0.b;
			var iteration = _v0.c;
			var stepId = _v0.d;
			var description = _v0.e;
			return $author$project$Ui$View$elevator(
				A7(
					$author$project$Ui$Pages$Steps$ArticleInstallation$SelectMultiple$page,
					model,
					operationId,
					stationId,
					iteration,
					stepId,
					$elm$url$Url$percentDecode(description),
					0));
		case 8:
			var operationId = _v0.a;
			var stationId = _v0.b;
			var iteration = _v0.c;
			var stepId = _v0.d;
			return $author$project$Ui$View$elevator(
				A6($author$project$Ui$Pages$Steps$ArticleInstallation$Search$page, model, operationId, stationId, iteration, stepId, 1));
		case 9:
			var operationId = _v0.a;
			var stationId = _v0.b;
			var iteration = _v0.c;
			var stepId = _v0.d;
			var description = _v0.e;
			return $author$project$Ui$View$elevator(
				A7(
					$author$project$Ui$Pages$Steps$ArticleInstallation$SelectMultiple$page,
					model,
					operationId,
					stationId,
					iteration,
					stepId,
					$elm$url$Url$percentDecode(description),
					1));
		default:
			var operationId = _v0.a;
			var stationId = _v0.b;
			var iteration = _v0.c;
			var stepId = _v0.d;
			var targetStationId = _v0.e;
			var targetIteration = _v0.f;
			var targetStepId = _v0.g;
			var articleIndex = _v0.h;
			var description = _v0.i;
			return $author$project$Ui$View$elevator(
				$author$project$Ui$Pages$Steps$ArticleInstallation$SelectMultipleTemp$page(model)(operationId)(stationId)(iteration)(stepId)(targetStationId)(targetIteration)(targetStepId)(articleIndex)(
					$elm$url$Url$percentDecode(description))(1));
	}
};
var $author$project$App$main = $elm$browser$Browser$element(
	{
		fG: $author$project$Init$init,
		gY: $author$project$App$subscriptions,
		ha: $author$project$Update$update,
		hd: A2($elm$core$Basics$composeR, $author$project$Ui$View$view, $rtfeldman$elm_css$Html$Styled$toUnstyled)
	});
_Platform_export({'App':{'init':$author$project$App$main($elm$json$Json$Decode$value)(0)}});

//////////////////// HMR BEGIN ////////////////////

/*
  MIT License http://www.opensource.org/licenses/mit-license.php
  Original Author: Flux Xu @fluxxu
*/

/*
    A note about the environment that this code runs in...

    assumed globals:
        - `module` (from Node.js module system and webpack)

    assumed in scope after injection into the Elm IIFE:
        - `scope` (has an 'Elm' property which contains the public Elm API)
        - various functions defined by Elm which we have to hook such as `_Platform_initialize` and `_Scheduler_binding`
 */

if (module.hot) {
    (function () {
        "use strict";

        //polyfill for IE: https://github.com/fluxxu/elm-hot-loader/issues/16
        if (typeof Object.assign != 'function') {
            Object.assign = function (target) {
                'use strict';
                if (target == null) {
                    throw new TypeError('Cannot convert undefined or null to object');
                }

                target = Object(target);
                for (var index = 1; index < arguments.length; index++) {
                    var source = arguments[index];
                    if (source != null) {
                        for (var key in source) {
                            if (Object.prototype.hasOwnProperty.call(source, key)) {
                                target[key] = source[key];
                            }
                        }
                    }
                }
                return target;
            };
        }

        // Elm 0.19.1 introduced a '$' prefix at the beginning of the symbols it emits,
        // and we check for `Maybe.Just` because we expect it to be present in all Elm programs.
        var elmVersion;
        if (typeof elm$core$Maybe$Just !== 'undefined')
            elmVersion = '0.19.0';
        else if (typeof $elm$core$Maybe$Just !== 'undefined')
            elmVersion = '0.19.1';
        else
            throw new Error("Could not determine Elm version");

        function elmSymbol(symbol) {
            try {
                switch (elmVersion) {
                    case '0.19.0':
                        return eval(symbol);
                    case '0.19.1':
                        return eval('$' + symbol);
                    default:
                        throw new Error('Cannot resolve ' + symbol + '. Elm version unknown!')
                }
            } catch (e) {
                if (e instanceof ReferenceError) {
                    return undefined;
                } else {
                    throw e;
                }
            }
        }

        var instances = module.hot.data
            ? module.hot.data.instances || {}
            : {};
        var uid = module.hot.data
            ? module.hot.data.uid || 0
            : 0;

        if (Object.keys(instances).length === 0) {
            log("[elm-hot] Enabled");
        }

        var cancellers = [];

        // These 2 variables act as dynamically-scoped variables which are set only when the
        // Elm module's hooked init function is called.
        var initializingInstance = null;
        var swappingInstance = null;

        module.hot.accept();
        module.hot.dispose(function (data) {
            data.instances = instances;
            data.uid = uid;

            // Cleanup pending async tasks

            // First, make sure that no new tasks can be started until we finish replacing the code
            _Scheduler_binding = function () {
                return _Scheduler_fail(new Error('[elm-hot] Inactive Elm instance.'))
            };

            // Second, kill pending tasks belonging to the old instance
            if (cancellers.length) {
                log('[elm-hot] Killing ' + cancellers.length + ' running processes...');
                try {
                    cancellers.forEach(function (cancel) {
                        cancel();
                    });
                } catch (e) {
                    console.warn('[elm-hot] Kill process error: ' + e.message);
                }
            }
        });

        function log(message) {
            if (module.hot.verbose) {
                console.log(message)
            }
        }

        function getId() {
            return ++uid;
        }

        function findPublicModules(parent, path) {
            var modules = [];
            for (var key in parent) {
                var child = parent[key];
                var currentPath = path ? path + '.' + key : key;
                if ('init' in child) {
                    modules.push({
                        path: currentPath,
                        module: child
                    });
                } else {
                    modules = modules.concat(findPublicModules(child, currentPath));
                }
            }
            return modules;
        }

        function registerInstance(domNode, flags, path, portSubscribes, portSends) {
            var id = getId();

            var instance = {
                id: id,
                path: path,
                domNode: domNode,
                flags: flags,
                portSubscribes: portSubscribes,
                portSends: portSends,
                lastState: null // last Elm app state (root model)
            };

            return instances[id] = instance
        }

        function isFullscreenApp() {
            // Returns true if the Elm app will take over the entire DOM body.
            return typeof elmSymbol("elm$browser$Browser$application") !== 'undefined'
                || typeof elmSymbol("elm$browser$Browser$document") !== 'undefined';
        }

        function wrapDomNode(node) {
            // When embedding an Elm app into a specific DOM node, Elm will replace the provided
            // DOM node with the Elm app's content. When the Elm app is compiled normally, the
            // original DOM node is reused (its attributes and content changes, but the object
            // in memory remains the same). But when compiled using `--debug`, Elm will completely
            // destroy the original DOM node and instead replace it with 2 brand new nodes: one
            // for your Elm app's content and the other for the Elm debugger UI. In this case,
            // if you held a reference to the DOM node provided for embedding, it would be orphaned
            // after Elm module initialization.
            //
            // So in order to make both cases consistent and isolate us from changes in how Elm
            // does this, we will insert a dummy node to wrap the node for embedding and hold
            // a reference to the dummy node.
            //
            // We will also put a tag on the dummy node so that the Elm developer knows who went
            // behind their back and rudely put stuff in their DOM.
            var dummyNode = document.createElement("div");
            dummyNode.setAttribute("data-elm-hot", "true");
            dummyNode.style.height = "inherit";
            var parentNode = node.parentNode;
            parentNode.replaceChild(dummyNode, node);
            dummyNode.appendChild(node);
            return dummyNode;
        }

        function wrapPublicModule(path, module) {
            var originalInit = module.init;
            if (originalInit) {
                module.init = function (args) {
                    var elm;
                    var portSubscribes = {};
                    var portSends = {};
                    var domNode = null;
                    var flags = null;
                    if (typeof args !== 'undefined') {
                        // normal case
                        domNode = args['node'] && !isFullscreenApp()
                            ? wrapDomNode(args['node'])
                            : document.body;
                        flags = args['flags'];
                    } else {
                        // rare case: Elm allows init to be called without any arguments at all
                        domNode = document.body;
                        flags = undefined
                    }
                    initializingInstance = registerInstance(domNode, flags, path, portSubscribes, portSends);
                    elm = originalInit(args);
                    wrapPorts(elm, portSubscribes, portSends);
                    initializingInstance = null;
                    return elm;
                };
            } else {
                console.error("Could not find a public module to wrap at path " + path)
            }
        }

        function swap(Elm, instance) {
            log('[elm-hot] Hot-swapping module: ' + instance.path);

            swappingInstance = instance;

            // remove from the DOM everything that had been created by the old Elm app
            var containerNode = instance.domNode;
            while (containerNode.lastChild) {
                containerNode.removeChild(containerNode.lastChild);
            }

            var m = getAt(instance.path.split('.'), Elm);
            var elm;
            if (m) {
                // prepare to initialize the new Elm module
                var args = {flags: instance.flags};
                if (containerNode === document.body) {
                    // fullscreen case: no additional args needed
                } else {
                    // embed case: provide a new node for Elm to use
                    var nodeForEmbed = document.createElement("div");
                    containerNode.appendChild(nodeForEmbed);
                    args['node'] = nodeForEmbed;
                }

                elm = m.init(args);

                Object.keys(instance.portSubscribes).forEach(function (portName) {
                    if (portName in elm.ports && 'subscribe' in elm.ports[portName]) {
                        var handlers = instance.portSubscribes[portName];
                        if (!handlers.length) {
                            return;
                        }
                        log('[elm-hot] Reconnect ' + handlers.length + ' handler(s) to port \''
                            + portName + '\' (' + instance.path + ').');
                        handlers.forEach(function (handler) {
                            elm.ports[portName].subscribe(handler);
                        });
                    } else {
                        delete instance.portSubscribes[portName];
                        log('[elm-hot] Port was removed: ' + portName);
                    }
                });

                Object.keys(instance.portSends).forEach(function (portName) {
                    if (portName in elm.ports && 'send' in elm.ports[portName]) {
                        log('[elm-hot] Replace old port send with the new send');
                        instance.portSends[portName] = elm.ports[portName].send;
                    } else {
                        delete instance.portSends[portName];
                        log('[elm-hot] Port was removed: ' + portName);
                    }
                });
            } else {
                log('[elm-hot] Module was removed: ' + instance.path);
            }

            swappingInstance = null;
        }

        function wrapPorts(elm, portSubscribes, portSends) {
            var portNames = Object.keys(elm.ports || {});
            //hook ports
            if (portNames.length) {
                // hook outgoing ports
                portNames
                    .filter(function (name) {
                        return 'subscribe' in elm.ports[name];
                    })
                    .forEach(function (portName) {
                        var port = elm.ports[portName];
                        var subscribe = port.subscribe;
                        var unsubscribe = port.unsubscribe;
                        elm.ports[portName] = Object.assign(port, {
                            subscribe: function (handler) {
                                log('[elm-hot] ports.' + portName + '.subscribe called.');
                                if (!portSubscribes[portName]) {
                                    portSubscribes[portName] = [handler];
                                } else {
                                    //TODO handle subscribing to single handler more than once?
                                    portSubscribes[portName].push(handler);
                                }
                                return subscribe.call(port, handler);
                            },
                            unsubscribe: function (handler) {
                                log('[elm-hot] ports.' + portName + '.unsubscribe called.');
                                var list = portSubscribes[portName];
                                if (list && list.indexOf(handler) !== -1) {
                                    list.splice(list.lastIndexOf(handler), 1);
                                } else {
                                    console.warn('[elm-hot] ports.' + portName + '.unsubscribe: handler not subscribed');
                                }
                                return unsubscribe.call(port, handler);
                            }
                        });
                    });

                // hook incoming ports
                portNames
                    .filter(function (name) {
                        return 'send' in elm.ports[name];
                    })
                    .forEach(function (portName) {
                        var port = elm.ports[portName];
                        portSends[portName] = port.send;
                        elm.ports[portName] = Object.assign(port, {
                            send: function (val) {
                                return portSends[portName].call(port, val);
                            }
                        });
                    });
            }
            return portSubscribes;
        }

        /*
        Breadth-first search for a `Browser.Navigation.Key` in the user's app model.
        Returns the key and keypath or null if not found.
        */
        function findNavKey(rootModel) {
            var queue = [];
            if (isDebuggerModel(rootModel)) {
                /*
                 Extract the user's app model from the Elm Debugger's model. The Elm debugger
                 can hold multiple references to the user's model (e.g. in its "history"). So
                 we must be careful to only search within the "state" part of the Debugger.
                */
                queue.push({value: rootModel['state'], keypath: ['state']});
            } else {
                queue.push({value: rootModel, keypath: []});
            }

            while (queue.length !== 0) {
                var item = queue.shift();

                if (typeof item.value === "undefined" || item.value === null) {
                    continue;
                }

                // The nav key is identified by a runtime tag added by the elm-hot injector.
                if (item.value.hasOwnProperty("elm-hot-nav-key")) {
                    // found it!
                    return item;
                }

                if (typeof item.value !== "object") {
                    continue;
                }

                for (var propName in item.value) {
                    if (!item.value.hasOwnProperty(propName)) continue;
                    var newKeypath = item.keypath.slice();
                    newKeypath.push(propName);
                    queue.push({value: item.value[propName], keypath: newKeypath})
                }
            }

            return null;
        }


        function isDebuggerModel(model) {
            // Up until elm/browser 1.0.2, the Elm debugger could be identified by a
            // property named "expando". But in version 1.0.2 that was renamed to "expandoModel"
            return model
                && (model.hasOwnProperty("expando") || model.hasOwnProperty("expandoModel"))
                && model.hasOwnProperty("state");
        }

        function getAt(keyPath, obj) {
            return keyPath.reduce(function (xs, x) {
                return (xs && xs[x]) ? xs[x] : null
            }, obj)
        }

        function removeNavKeyListeners(navKey) {
            window.removeEventListener('popstate', navKey.value);
            window.navigator.userAgent.indexOf('Trident') < 0 || window.removeEventListener('hashchange', navKey.value);
        }

        // hook program creation
        var initialize = _Platform_initialize;
        _Platform_initialize = function (flagDecoder, args, init, update, subscriptions, stepperBuilder) {
            var instance = initializingInstance || swappingInstance;
            var tryFirstRender = !!swappingInstance;

            var hookedInit = function (args) {
                var initialStateTuple = init(args);
                if (swappingInstance) {
                    var oldModel = swappingInstance.lastState;
                    var newModel = initialStateTuple.a;

                    if (typeof elmSymbol("elm$browser$Browser$application") !== 'undefined') {
                        var oldKeyLoc = findNavKey(oldModel);

                        // attempt to find the Browser.Navigation.Key in the newly-constructed model
                        // and bring it along with the rest of the old data.
                        var newKeyLoc = findNavKey(newModel);
                        var error = null;
                        if (newKeyLoc === null) {
                            error = "could not find Browser.Navigation.Key in the new app model";
                        } else if (oldKeyLoc === null) {
                            error = "could not find Browser.Navigation.Key in the old app model.";
                        } else if (newKeyLoc.keypath.toString() !== oldKeyLoc.keypath.toString()) {
                            error = "the location of the Browser.Navigation.Key in the model has changed.";
                        } else {
                            // remove event listeners attached to the old nav key
                            removeNavKeyListeners(oldKeyLoc.value);

                            // insert the new nav key into the old model in the exact same location
                            var parentKeyPath = oldKeyLoc.keypath.slice(0, -1);
                            var lastSegment = oldKeyLoc.keypath.slice(-1)[0];
                            var oldParent = getAt(parentKeyPath, oldModel);
                            oldParent[lastSegment] = newKeyLoc.value;
                        }

                        if (error !== null) {
                            console.error("[elm-hot] Hot-swapping " + instance.path + " not possible: " + error);
                            oldModel = newModel;
                        }
                    }

                    // the heart of the app state hot-swap
                    initialStateTuple.a = oldModel;

                    // ignore any Cmds returned by the init during hot-swap
                    initialStateTuple.b = elmSymbol("elm$core$Platform$Cmd$none");
                } else {
                    // capture the initial state for later
                    initializingInstance.lastState = initialStateTuple.a;
                }

                return initialStateTuple
            };

            var hookedStepperBuilder = function (sendToApp, model) {
                var result;
                // first render may fail if shape of model changed too much
                if (tryFirstRender) {
                    tryFirstRender = false;
                    try {
                        result = stepperBuilder(sendToApp, model)
                    } catch (e) {
                        throw new Error('[elm-hot] Hot-swapping ' + instance.path +
                            ' is not possible, please reload page. Error: ' + e.message)
                    }
                } else {
                    result = stepperBuilder(sendToApp, model)
                }

                return function (nextModel, isSync) {
                    if (instance) {
                        // capture the state after every step so that later we can restore from it during a hot-swap
                        instance.lastState = nextModel
                    }
                    return result(nextModel, isSync)
                }
            };

            return initialize(flagDecoder, args, hookedInit, update, subscriptions, hookedStepperBuilder)
        };

        // hook process creation
        var originalBinding = _Scheduler_binding;
        _Scheduler_binding = function (originalCallback) {
            return originalBinding(function () {
                // start the scheduled process, which may return a cancellation function.
                var cancel = originalCallback.apply(this, arguments);
                if (cancel) {
                    cancellers.push(cancel);
                    return function () {
                        cancellers.splice(cancellers.indexOf(cancel), 1);
                        return cancel();
                    };
                }
                return cancel;
            });
        };

        scope['_elm_hot_loader_init'] = function (Elm) {
            // swap instances
            var removedInstances = [];
            for (var id in instances) {
                var instance = instances[id];
                if (instance.domNode.parentNode) {
                    swap(Elm, instance);
                } else {
                    removedInstances.push(id);
                }
            }

            removedInstances.forEach(function (id) {
                delete instance[id];
            });

            // wrap all public modules
            var publicModules = findPublicModules(Elm);
            publicModules.forEach(function (m) {
                wrapPublicModule(m.path, m.module);
            });
        }
    })();

    scope['_elm_hot_loader_init'](scope['Elm']);
}
//////////////////// HMR END ////////////////////


}(this));